(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["spect8-chat-ui"] = factory(require("vue"));
	else
		root["spect8-chat-ui"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var Error = global.Error;
var un$Test = uncurryThis(/./.test);

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (str) {
    var exec = this.exec;
    if (!isCallable(exec)) return un$Test(this, str);
    var result = call(exec, this, str);
    if (result !== null && !isObject(result)) {
      throw new Error('RegExp exec method returned something other than an Object or null');
    }
    return !!result;
  }
});


/***/ }),

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "010e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
            '_'
        ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ "01a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollResults_vue_vue_type_style_index_0_id_18d88725_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("be48");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollResults_vue_vue_type_style_index_0_id_18d88725_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollResults_vue_vue_type_style_index_0_id_18d88725_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "01b4":
/***/ (function(module, exports) {

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "01ce":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "02fb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
            '_'
        ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "03ec":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
            '_'
        ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ "040e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoyaltyPoints_vue_vue_type_style_index_0_id_5abbabc6_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f527");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoyaltyPoints_vue_vue_type_style_index_0_id_5abbabc6_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoyaltyPoints_vue_vue_type_style_index_0_id_5abbabc6_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var flattenIntoArray = __webpack_require__("a2bf");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIntegerOrInfinity = __webpack_require__("5926");
var arraySpeciesCreate = __webpack_require__("65f0");

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});


/***/ }),

/***/ "04d1":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ "0538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var arraySlice = __webpack_require__("f36a");

var Function = global.Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ "0558":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("c6b6");
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;
var arraySlice = __webpack_require__("4dae");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "0721":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ "0727":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "079e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ "07ac":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $values = __webpack_require__("6f53").values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0a06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var buildURL = __webpack_require__("30b5");
var InterceptorManager = __webpack_require__("f6b49");
var dispatchRequest = __webpack_require__("5270");
var mergeConfig = __webpack_require__("4a7b");
var validator = __webpack_require__("848b");

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "0a3c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ "0a84":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ "0b42":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "0bc6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0caa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                '_'
            ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d51":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "0df6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "0e49":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ "0e6b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ "0e81":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ "0f14":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ "0f38":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ "0ff2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
            '_'
        ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ "107c":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "10e8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ "1148":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var RangeError = global.RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ "1189":
/***/ (function(module) {

module.exports = JSON.parse("{\"emojiPicker\":{\"search\":\"Suche\",\"skintone\":\"Hautton\",\"notfound\":\"Kein Emoji gefunden\",\"categories\":{\"search\":\"Suchresultate\",\"recent\":\"Oft benutzt\",\"smileys\":\"Smileys & Gefühle\",\"people\":\"Menschen & Körper\",\"nature\":\"Tiere & Natur\",\"foods\":\"Essen & Trinken\",\"activity\":\"Aktivitäten\",\"places\":\"Reisen & Orte\",\"objects\":\"Objekte\",\"symbols\":\"Symbole\",\"flags\":\"Flaggen\",\"custom\":\"Benutzerdefiniert\"}},\"s8c\":{\"Active\":\"Aktiv\",\"Admin\":\"Admin\",\"Agree\":\"Zustimmen\",\"All\":\"Alle\",\"Assign roles to certain Chatters e\":{},\"Assign roles to certain Chatters e.g for enabling them to moderate a chatroom\":\"Zuweisen von Rollen an bestimmte Benutzer, z. B. um ihnen die Moderation eines Chatraums zu ermöglichen\",\"Avatar\":\"Avatar\",\"Bad\":\"Schlecht\",\"Badge\":\"Abzeichen\",\"Ban ends on\":\"Sperrung endet am/um\",\"Cancel\":\"Abbrechen\",\"Chat rooms\":\"Chaträume\",\"Close\":\"Schließen\",\"Come back in 30 days.\":\"Komm in 30 Tagen wieder\",\"Confirm\":\"Bestätigen\",\"Disagree\":\"Ablehnen\",\"Dismiss pinned message\":\"Angepinnte Nachricht ausblenden\",\"Edit side panel profile\":\"Profil bearbeiten\",\"Email or password incorrect. Please try again.\":\"E-Mail oder Passwort falsch. Bitte versuche es erneut.\",\"Enter your own text to require first-time viewers to agree to your rules before chatting. One rule per line.\":\"Gib deine eigenen Regeln ein, denen erstmalige Zuschauer vor dem Chatten zustimmen müssen. Eine Regel pro Zeile.\",\"Food\":\"Essen\",\"Gaming\":\"Gaming\",\"Incorrect input. Please check id or username of user\":\"Eingabefehler. Bitte überprüfe die ID oder den Benutzernamen.\",\"Loyalty\":\"Loyalty\",\"Manage basic chat functionality like Slow Mode, Chat Rules, etc.\":\"Allgemeine Einstellungen wie Slow Mode, Chat Regeln etc.\",\"Manage basic chat functionality like Slow Mode, Pinned messages, etc.\":\"Allgemeine Chat-Einstellungen wie Slow-Mode, angeheftete Nachrichten etc.\",\"Moderator\":\"Moderator\",\"Monsters\":\"Monster\",\"Music\":\"Musik\",\"Muted\":\"Ignoriert\",\"NEW\":\"NEU\",\"Nature\":\"Natur\",\"Origami\":\"Origami\",\"Password is missing or incorrect. Please try again!\":\"Passwort fehlt oder ist falsch. Bitte versuche es erneut.\",\"Replies\":\"Antworten\",\"Report\":\"Melden\",\"Resume\":\"Fortsetzen\",\"Retro\":\"Retro\",\"Robots\":\"Roboter\",\"Settings menu\":\"Einstellungsmenü\",\"Side Panel Profile\":\"Side-Panel Profil\",\"Sports\":\"Sport\",\"Start chatting\":\"Start\",\"Submit\":\"Einreichen\",\"Tell us how you want to present yourself in the side panel.\":\"Wie willst du dich im Chat präsentieren?\",\"Unmute\":\"Stummschaltung aufheben\",\"Username\":\"Benutzername\",\"We received your report and will not process it What a terrible day\":\"Wir haben Ihre Meldung erhalten und werden sie nicht bearbeiten. Was für ein schrecklicher Tag..\",\"Your report is already being processed, don't worry.\":\"Ihr Bericht wird bereits bearbeitet, keine Sorge.\",\"apply\":\"Änderungen speichern\",\"badWord\":\"Deine Nachricht enthält einen geblockten Begriff.\",\"banUser\":\"Benutzer sperren\",\"banWarning\":\"Du wurdest von einem Moderator gesperrt\",\"banned\":\"gesperrt\",\"bannedMessageText\":\"{type} wurde {action}\",\"blockedMessageNotification\":\"Ihre letzte Nachricht enthielt einen blockierten Begriff oder Ausdruck und wurde für den Chat gesperrt.\",\"changeLanguage\":\"Sprache ändern\",\"charLimit\":\"Deine Nachricht überschreitet das Zeichenlimit ({0}).\",\"customize\":\"Profil anpassen\",\"delete\":\"Nachricht löschen\",\"deleted\":\"gelöscht\",\"enabled\":\"aktiviert\",\"errors\":{},\"features\":\"Merkmale\",\"hyperlink\":\"Nachrichten dürfen keine Links enthalten.\",\"ignore\":\"Benutzer ignorieren\",\"inputLabel\":\"Sende eine Nachricht!\",\"loyaltyHighlightMessageDesc\":\"Dieser Kauf berechtigt dich dazu eine Nachricht hervorzuheben.\",\"loyaltyPinMessageDesc\":\"Dieser Kauf berechtigt dich dazu eine Nachricht anzuheften. Du kannst eine existierende Nachricht anheften oder eine neue Nachricht formulieren.\",\"loyaltyStartPollDesc\":\"Dieser Kauf berechtigt dich dazu eine Umfrage zu starten. Starte die Umfrage sofort oder später.\",\"loyaltyUnlockNameColorDesc\":\"Dieser Kauf berechtigt dich dazu eine neue Namensfarbe freizuschalten. Besuche dein Profil um die Namensfarbe zu wechseln.\",\"andMore\":\"und {num} mehr.\",\"moreActions\":\"Weitere Aktionen\",\"mute\":{\"warning\":\"Du bist stummgeschaltet\"},\"muteUser\":\"Benutzer stummschalten\",\"once\":\"Einmal reicht\",\"oops\":\"Etwas ist schief gelaufen\",\"pin\":{\"already\":\"Diese Nachricht ist bereits angepinnt\",\"message\":\"Nachricht anheften\"},\"pinnedMessage\":\"Angepinnte Nachricht\",\"profile\":{\"create\":\"Profil erstellen\",\"heading\":\"Wie soll dein Profil aussehen?\"},\"rateLimit\":\"Du sendest zu viele Nachrichten in kurzer Zeit.\",\"reaction\":{\"add\":\"Reaktion hinzufügen\"},\"reply\":\"Antwort | Antworten\",\"replyTooltip\":\"Antworten\",\"report\":{\"avatarHarmful\":\"Dieses Profilbild ist missbräuchlich oder Hass schürend\",\"header\":\"Nachricht oder Nutzer melden\",\"messageHarmful\":\"Diese Nachricht ist missbräuchlich oder Hass schürend\",\"messageSpam\":\"Diese Nachricht ist verdächtig oder Spam\",\"received\":\"Danke für deine Meldung. Wir werden sie schnellstmöglich bearbeiten.\",\"subheader\":\"Was ist das Problem mit dieser Nachricht oder diesem Nutzer?\",\"success\":\"Nachricht oder Nutzer erfolgreich gemeldet\",\"usernameHarmful\":\"Dieser Benutzername ist missbräuchlich oder Hass schürend\"},\"response\":{\"genericError\":\"Es ging etwas schief.\",\"BAD_WORD\":\"Deine Nachricht enthielt einen geblockten Begriff.\",\"CHAR_LIMIT\":\"Deine Nachricht hat das Zeichenlimit überschritten ({0}).\",\"HYPERLINK\":\"Nachrichten dürfen keine Links enthalten.\",\"RATE_LIMIT\":\"Du sendest zu viele Nachrichten in kurzer Zeit.\",\"SAME_MESSAGE_COUNT\":\"Du hast zu viele identische Nachrichten in Folge geschrieben ({0}).\",\"USER_BANNED\":\"Du wurdest von einem Admin oder Moderator gesperrt. Komm später wieder.\",\"USER_MUTED\":\"Du wurdest von einem Admin oder Moderator stummgeschaltet. Komm später wieder.\"},\"role\":{\"assign\":\"Weise bestimmten Benutzern Rollen zu, z.B. um ihnen die Moderation eines Chatraums zu ermöglichen\"},\"thisMessage\":\"Diese Nachricht\",\"thisUser\":\"Dieser Benutzer\",\"unbanUser\":\"{0} entsperren?\",\"scrollingPaused\":\"Chat wird während des Scrollens angehalten\",\"muted\":\"stummgeschaltet\",\"time\":{\"hours\":\"{value} Stunde | {value} Stunden\",\"minutes\":\"{value} Minute | {value} Minuten\",\"days\":\"{value} Tag | {value} Tage\",\"weeks\":\"{value} Woche | {value} Wochen\",\"indefinite\":\"Unbegrenzt\"}},\"polls\":{\"active\":\"Aktive Umfragen\",\"adminPublish\":\"Ein Admin oder Moderator wird die Ergebnisse in Kürze veröffentlichen.\",\"addAnswer\":\"WEITERE ANTWORT HINZUFÜGEN\",\"answer\":\"Antwort {num}\",\"answered\":\"BEANTWORTET\",\"answerLimit\":\"Antworten sind auf {chars} Zeichen beschränkt\",\"answerReceived\":\"Ihre Antwort ist eingegangen!\",\"createdBy\":\"Erstellt von\",\"createNew\":\"Neue Umfrage erstellen\",\"duration\":\"Umfragedauer\",\"ended\":\"Umfrage beendet\",\"hideResults\":\"Ergebnisse ausblenden\",\"left\":\"übrig\",\"minutes\":\"{num} Minuten\",\"missed\":\"VERPASST\",\"none\":\"Es gibt keine aktiven Umfragen\",\"open\":\"OFFEN\",\"past\":\"Vergangene Umfragen\",\"publish\":\"Die Ergebnisse werden in Kürze veröffentlicht.\",\"publishConfirm\":\"Bist du sicher? Diese Aktion kann nicht rückgängig gemacht werden.\",\"publishNo\":\"Nein\",\"publishYes\":\"Ja\",\"publishResults\":\"Ergebnisse veröffentlichen\",\"question\":\"Frage\",\"setDuration\":\"Umfragedauer einstellen\",\"showOverlayResults\":\"Ergebnisse im Overlay anzeigen\",\"showResults\":\"Ergebnisse anzeigen\",\"showWordcloud\":\"Wortwolke anzeigen\",\"submitted\":\"Vom Benutzer gesendete Antwort\",\"submittedBy\":\"Vom Benutzer gesendete Antwort von {displayName}\",\"typeAnswer\":\"Gib deine eigene Antwort ein\",\"voted\":\"Abgestimmt\",\"singleWordValidationMessage\":\"Antworten sind auf ein Wort begrenzt\",\"votesRemaining\":\"{votes} verbleibende Stimme | {votes} verbleibende Stimmen\"}}");

/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var getMethod = __webpack_require__("dc4a");
var arraySlice = __webpack_require__("4dae");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var stickyHelpers = __webpack_require__("9f7f");
var fails = __webpack_require__("d039");

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ "129f":
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "13b3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "13e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

var TypeError = global.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ "1565":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "1626":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "166a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "167b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                '_'
            ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ "1681":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "18a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ "18b2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "19aa":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isPrototypeOf = __webpack_require__("3a9b");

var TypeError = global.TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw TypeError('Incorrect invocation');
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1b2c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1b45":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
            '_'
        ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1bfb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1cfd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ "1d2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1fc1":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                '_'
            ),
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
            '_'
        ),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                '_'
            ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ "201b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                '_'
            ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
                    $0,
                    $1,
                    $2
                ) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ "20f6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var isArrayIteratorMethod = __webpack_require__("e95a");
var lengthOfArrayLike = __webpack_require__("07fa");
var isPrototypeOf = __webpack_require__("3a9b");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var TypeError = global.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "22f8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2421":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ "2444":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("c532");
var normalizeHeaderName = __webpack_require__("c8af");
var enhanceError = __webpack_require__("387f");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("b50d");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("b50d");
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var correctIsRegExpLogic = __webpack_require__("ab13");

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ "2554":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ "25a8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var isPrototypeOf = __webpack_require__("3a9b");
var $toString = __webpack_require__("577e");
var fails = __webpack_require__("d039");
var regExpFlags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];
var getFlags = uncurryThis(regExpFlags);

var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype) ? getFlags(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "269a":
/***/ (function(module, exports) {

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function installDirectives (component, directives) {
  var options = typeof component.exports === 'function'
    ? component.exports.extendOptions
    : component.options

  if (typeof component.exports === 'function') {
    options.directives = component.exports.options.directives
  }

  options.directives = options.directives || {}

  for (var i in directives) {
    options.directives[i] = options.directives[i] || directives[i]
  }
}


/***/ }),

/***/ "26f9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                '_'
            ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                '_'
            ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ "2921":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ "293c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ "29d7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UsersOnline_vue_vue_type_style_index_0_id_4fabab9c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0727");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UsersOnline_vue_vue_type_style_index_0_id_4fabab9c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UsersOnline_vue_vue_type_style_index_0_id_4fabab9c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var getMethod = __webpack_require__("dc4a");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "2af1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var sign = __webpack_require__("f748");

// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),

/***/ "2b19":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var is = __webpack_require__("129f");

// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$({ target: 'Object', stat: true }, {
  is: is
});


/***/ }),

/***/ "2ba4":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2bfb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ "2c3e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var MISSED_STICKY = __webpack_require__("9f7f").MISSED_STICKY;
var classof = __webpack_require__("c6b6");
var defineProperty = __webpack_require__("9bf2").f;
var getInternalState = __webpack_require__("69f3").get;

var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && MISSED_STICKY) {
  defineProperty(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).sticky;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ "2c64":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2ca0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var un$StartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return un$StartsWith
      ? un$StartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0366");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var fails = __webpack_require__("d039");
var html = __webpack_require__("1be4");
var arraySlice = __webpack_require__("f36a");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(isCallable(fn) ? fn : Function(fn), undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "2d83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("387f");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "2d8a":
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():undefined}(this,(function(){"use strict";function t(t){return"function"==typeof t}function n(){}var i=function(t){this.previousValue=t,this.interrupted=!1,this.interruptHandlers=new Set};i.prototype.throwIfInterrupted=function(){if(this.interrupted)throw new Error},i.prototype.interrupt=function(){this.interrupted||(this.interrupted=!0,this.interruptHandlers.forEach((function(t){try{t()}catch(t){}})))},i.prototype.onInterrupt=function(t){if(this.interrupted&&!this.interruptHandlers.has(t))try{t()}catch(t){}this.interruptHandlers.add(t)};function r(t){return function(){return t}}function e(){return[]}var o={animationDuration:{type:Number,default:1e3},animationEasing:{type:String,default:"ease"},animationOverlap:{type:Number,default:1},color:{type:[String,Function],default:"Black"},createCanvas:{type:Function,default:function(){return document.createElement("canvas")}},createWorker:{type:Function,default:function(t){return new Worker(URL.createObjectURL(new Blob([t])))}},enterAnimation:{type:[Object,String],default:r({opacity:0})},fontFamily:{type:[String,Function],default:"serif"},fontSizeRatio:{type:Number,default:0},fontStyle:{type:[String,Function],default:"normal"},fontVariant:{type:[String,Function],default:"normal"},fontWeight:{type:[String,Function],default:"normal"},leaveAnimation:{type:[Object,String],default:r({opacity:0})},loadFont:{type:Function,default:function(t,n,i,r){return document.fonts.load([n,i,"1px",t].join(" "),r)}},rotation:{type:[Number,Function],default:0},rotationUnit:{type:[String,Function],default:"turn"},spacing:{type:Number,default:0},text:{type:[String,Function],default:""},weight:{type:[Number,Function],default:1},words:{type:Array,default:e}};var u=r(null);function a(t){if(t){var n=typeof t;return"object"===n||"function"===n}return!1}function f(t){return"string"==typeof t}var s={animationOptions:function(){var t,n,i,r=this.animationDuration,e=this.enterAnimation,o=this.leaveAnimation;if(a(e)&&a(o)){var s=(t=Object.assign({},e,o),n=u,i={},Object.entries(t).forEach((function(r){var e=r[0],o=r[1];i[e]=n(o,e,t)})),i),c=function(t){Object.assign(t.style,e)},h=function(t,n){setTimeout((function(){Object.assign(t.style,s),setTimeout(n,r)}),1)};return{props:{css:!1},on:{beforeAppear:c,appear:h,beforeEnter:c,enter:h,leave:function(t,n){Object.assign(t.style,o),setTimeout(n,r)}}}}return f(e)&&f(o)?{props:{duration:r,appear:!0,appearActiveClass:e,enterActiveClass:e,leaveActiveClass:o}}:{}},normalizedAnimationOverlap:function(){var t=this.animationOverlap;return(t=Math.abs(t))<1&&(t=1/t),t},separateAnimationDelay:function(){var t=this.cloudWords;if(t.length>1){return(this.animationDuration-this.separateAnimationDuration)/(t.length-1)}return 0},separateAnimationDuration:function(){var t=this.cloudWords;if(t.length>0){var n=this.animationDuration,i=this.normalizedAnimationOverlap;return n/Math.min(i,t.length)}return 0}},c=Array.isArray;function h(n){return t(n)?n:r(n)}var l=2*Math.PI,v=l/360;function d(t){return void 0===t}function m(t,n){return t.postMessage(n),function(t){return new Promise((function(n,i){var r,e=function(t){var i=t.data;r(),n(i)},o=function(t){var n=t.error;r(),i(n)};r=function(){t.removeEventListener("message",e),t.removeEventListener("error",o)},t.addEventListener("message",e),t.addEventListener("error",o)}))}(t)}function p(t,n,i){return Math.ceil(t*Math.abs(Math.sin(i))+n*Math.abs(Math.cos(i)))}function g(t,n,i){return Math.ceil(t*Math.abs(Math.cos(i))+n*Math.abs(Math.sin(i)))}function b(t,n,i,r,e){return[t,n,i,r+"px",e].join(" ")}function y(t,n){return Math.ceil(t/n)*n}function M(t,n,i){var r=i().getContext("2d");return r.font=n,r.measureText(t).width}var w=function(t,n,i,r,e,o,u){this.t=t,this.i=n,this.o=i,this.u=r,this.s=e,this.h=o,this.l=u,this.v=1,this.m=0,this.p=0,this.g=0},x={M:{configurable:!0},S:{configurable:!0},j:{configurable:!0},F:{configurable:!0},O:{configurable:!0},W:{configurable:!0},A:{configurable:!0},B:{configurable:!0},C:{configurable:!0},L:{configurable:!0},_:{configurable:!0},P:{configurable:!0},T:{configurable:!0},k:{configurable:!0},N:{configurable:!0},D:{configurable:!0},H:{configurable:!0},R:{configurable:!0},U:{configurable:!0}};x.M.get=function(){return this.v},x.M.set=function(t){this.v!==t&&(this.v=t,this.V=void 0)},x.S.get=function(){return b(this.h,this.s,this.u,this.M,this.o)},x.j.get=function(){return void 0===this.q&&(this.q=M(this.t,b(this.h,this.s,this.u,1,this.o),this.l)),this.q},x.F.get=function(){return this.j*this.M},x.O.get=function(){return this.p*this.M},x.O.set=function(t){this.p=t/this.M},x.W.get=function(){return this.g*this.M},x.W.set=function(t){this.g=t/this.M},x.A.get=function(){return g(this.F,this.M,this.i)},x.B.get=function(){return p(this.F,this.M,this.i)},x.C.get=function(){return this.O-this.A/2},x.L.get=function(){return this.W-this.B/2},x._.get=function(){return this.m},x._.set=function(t){this.m!==t&&(this.m=t,this.V=void 0)},x.P.get=function(){return void 0===this.V&&(this.V=function(t,n,i,r,e,o,u,a,f){var s=b(n,i,r,e*=4,o),c=u*e*2,h=c+M(t,s,f),l=c+e,v=f(),d=v.getContext("2d"),m=y(g(h,l,a),4),w=y(p(h,l,a),4);v.width=m,v.height=w,d.translate(m/2,w/2),d.rotate(a),d.font=s,d.textAlign="center",d.textBaseline="middle",d.fillText(t,0,0),c>0&&(d.miterLimit=1,d.lineWidth=c,d.strokeText(t,0,0));for(var x=d.getImageData(0,0,m,w).data,S=[],j=1/0,F=0,O=1/0,E=0,W=m/4,A=w/4,B=0;B<W;++B)for(var C=0;C<A;++C)t:for(var L=0;L<4;++L)for(var _=0;_<4;++_){if(x[4*(m*(4*C+_)+(4*B+L))+3]){S.push([B,C]),j=Math.min(B,j),F=Math.max(B+1,F),O=Math.min(C,O),E=Math.max(C+1,E);break t}}return S.length>0?[S.map((function(t){var n=t[0],i=t[1];return[n-j,i-O]})),F-j,E-O,Math.ceil(W/2)-j,Math.ceil(A/2)-O]:[S,0,0,0,0]}(this.t,this.h,this.s,this.u,this.M,this.o,this._,this.i,this.l)),this.V},x.T.get=function(){return this.P[0]},x.k.get=function(){return this.P[1]},x.N.get=function(){return this.P[2]},x.D.get=function(){return this.P[3]},x.H.get=function(){return this.P[4]},x.R.get=function(){return Math.ceil(this.O)-this.D},x.R.set=function(t){this.O=t+this.D},x.U.get=function(){return Math.ceil(this.W)-this.H},x.U.set=function(t){this.W=t+this.H},Object.defineProperties(w.prototype,x);var S={cloudWords:function(t){this.$emit("update:cloudWords",t)},progress:{handler:function(t){this.$emit("update:progress",t)},deep:!0,immediate:!0}};var j={updateElementSize:function(){var t=this.$el;t&&(this.elementWidth=t.offsetWidth,this.elementHeight=t.offsetHeight)}};var F={name:"VueWordCloud",mixins:[function(r){return{data:function(){var t={};return Object.keys(r).forEach((function(n){t["asyncComputed_trigger_"+n]={}})),t},computed:{},beforeCreate:function(){var e=this,o=new Set;Object.entries(r).forEach((function(r){var u=r[0],a=r[1],f=a.get,s=a.default,c=a.errorHandler;void 0===c&&(c=n);var h,l=!0;e.$options.computed[u]=function(){return this["asyncComputed_trigger_"+u],this["asyncComputed_promise_"+u],s},e.$options.computed["asyncComputed_promise_"+u]=function(){var n=this;h&&(h.interrupt(),o.delete(h)),l&&(l=!1,t(s)&&(s=s.call(this)));var r=new i(s);h=r,o.add(h),new Promise((function(t){t(f.call(n,r))})).then((function(t){r.throwIfInterrupted(),s=t,n["asyncComputed_trigger_"+u]={}})).catch(c)}}))}}}({cloudWords:{get:function(t){var i,r=this,e=this,o=e.elementWidth,u=e.elementHeight,s=e.words,p=e.text,g=e.weight,b=e.rotation,y=e.rotationUnit,M=e.fontFamily,x=e.fontWeight,S=e.fontVariant,j=e.fontStyle,F=e.color,O=e.spacing,E=e.fontSizeRatio,W=e.createCanvas,A=e.loadFont,B=e.createWorker;i=E,E=(i=Math.abs(i))>1?1/i:i;var C=function(t){var n=t[0],i=t[1];return n>i?[1,i/n]:i>n?[n/i,1]:[1,1]}([o,u]);if(o>0&&u>0){var L=h(p),_=h(g),P=h(b),T=h(y),k=h(M),N=h(x),z=h(S),D=h(j),H=h(F);return s=s.map((function(t,n){var i,r,e,o,u,h,m,p,g,b,y;t&&(f(t)?e=t:c(t)?(e=(i=t)[0],o=i[1]):a(t)&&(e=(r=t).text,o=r.weight,u=r.rotation,h=r.rotationUnit,m=r.fontFamily,p=r.fontWeight,g=r.fontVariant,b=r.fontStyle,y=r.color)),d(e)&&(e=L(t,n,s)),d(o)&&(o=_(t,n,s)),d(u)&&(u=P(t,n,s)),d(h)&&(h=T(t,n,s)),d(m)&&(m=k(t,n,s)),d(p)&&(p=N(t,n,s)),d(g)&&(g=z(t,n,s)),d(b)&&(b=D(t,n,s)),d(y)&&(y=H(t,n,s));var M=new w(e,function(){switch(h){case"turn":return u*l;case"deg":return function(t){return t*v}(u)}return u}(),m,p,g,b,W);return Object.assign(M,{J:t,Y:o,G:y}),M})),Promise.resolve().then((function(){return Promise.all(s.map((function(t){var n=t.o,i=t.h,r=t.u,e=t.t;return A(n,i,r,e)})))})).catch(n).then((function(){if((s=s.filter((function(t){return t.F>0})).sort((function(t,n){return n.Y-t.Y}))).length>0){var n=s[0],i=function(t){return t[(n=t,n.length-1)];var n}(s),e=n.Y,a=i.Y;if(a<e){var f=E>0?1/E:a>0?e/a:e<0?a/e:1+e-a;s.forEach((function(t){var n,i,r;t.M=(n=t.Y,(r=1)+(n-(i=a))*(f-r)/(e-i))}))}s.reduceRight((function(t,n){return n.M<2*t?n.M/=t:(t=n.M,n.M=1),n.I=t}),1),s.forEach((function(t){t.M*=4}));var c=B('!function(){"use strict";var r=function(t){self.removeEventListener("message",r);var n,e,a,f,i,u=t.data,o=function(){n={},e=0,a=0,f=0,i=0};o();var s=function(){return Math.ceil((e+a)/2)},v=function(){return Math.ceil((f+i)/2)},c=function(){return{left:s(),top:v(),width:a-e,height:i-f}},l=function(r,t,u){r.forEach((function(r){var o=r[0],s=r[1],v=t+o,c=u+s;n[v+"|"+c]=!0,e=Math.min(v,e),a=Math.max(v+1,a),f=Math.min(c,f),i=Math.max(c+1,i)}))},h=function(r,t,e){return function(r,t,n){var e,a,f=r[0],i=r[1],u=t[0],o=t[1];f>i?(e=1,a=i/f):i>f?(a=1,e=f/i):e=a=1;var s=[u,o];if(n(s))return s;for(var v=u,c=o,l=u,h=o,M=v,d=c;;){u-=e,o-=a,v+=e,c+=a;var m=Math.floor(u),g=Math.floor(o),p=Math.ceil(v),E=Math.ceil(c);if(p>M)for(var L=g;L<E;++L){var x=[p,L];if(n(x))return x}if(E>d)for(var y=p;y>m;--y){var w=[y,E];if(n(w))return w}if(m<l)for(var B=E;B>g;--B){var F=[m,B];if(n(F))return F}if(g<h)for(var b=m;b<p;++b){var j=[b,g];if(n(j))return j}l=m,h=g,M=p,d=E}}(u,[t+s(),e+v()],(function(t){var e=t[0],a=t[1];return function(r,t,e){return r.every((function(r){var a=r[0],f=r[1];return!n[t+a+"|"+(e+f)]}))}(r,e,a)}))};self.postMessage({}),self.addEventListener("message",(function(r){self.postMessage({getBounds:c,put:l,findFit:h,clear:o}[r.data.name].apply(null,r.data.args))}))};self.addEventListener("message",r)}();\n'),h={completedWords:0,totalWords:s.length};return Promise.resolve().then((function(){return t.throwIfInterrupted(),r.progress=h,m(c,C)})).then((function(){t.throwIfInterrupted(),h.completedWords++;var n=Promise.resolve();return s.reduce((function(i,r,e){return n=n.then((function(){return r.I<i.I?Promise.resolve().then((function(){return m(c,{name:"clear"})})).then((function(){var t=Promise.resolve(),n=i.I/r.I;return s.slice(0,e).forEach((function(i){t=t.then((function(){return i.M*=n,m(c,{name:"put",args:[i.T,i.R,i.U]})}))})),t})):m(c,{name:"put",args:[i.T,i.R,i.U]})})).then((function(){return r._=O,m(c,{name:"findFit",args:[r.T,r.R,r.U]})})).then((function(n){var i=n[0],e=n[1];t.throwIfInterrupted(),h.completedWords++,r.R=i,r.U=e,r._=0})),r})),n})).then((function(){return m(c,{name:"put",args:[i.T,i.R,i.U]})})).then((function(){return m(c,{name:"getBounds"})})).then((function(t){var n=t.left,i=t.top,r=t.width,e=t.height;if(r>0&&e>0){var a=Math.min(o/r,u/e);s.forEach((function(t){t.O-=n,t.W-=i,t.M*=a}))}var f=new Set;return s.map((function(t){for(var n=t.J,i=t.t,r=t.Y,e=t.i,o=t.o,u=t.u,a=t.s,s=t.h,c=t.S,h=t.O,l=t.W,v=t.G,d=JSON.stringify([i,o,u,a,s]);f.has(d);)d+="!";return f.add(d),{key:d,word:n,text:i,weight:r,rotation:e,font:c,color:v,left:h,top:l}}))})).finally((function(){c.terminate()})).finally((function(){t.throwIfInterrupted(),r.progress=null}))}return[]}))}return[]},default:e}})],props:o,data:function(){return{elementWidth:0,elementHeight:0,progress:null}},computed:s,watch:S,mounted:function(){var t,n,i=this;t=function(){if(i._isDestroyed)return!1;i.updateElementSize()},n=1e3,function(t){var n=function(){for(var i=[],r=arguments.length;r--;)i[r]=arguments[r];return t.call.apply(t,[this,n].concat(i))};return n}((function(i){requestAnimationFrame((function(){!1!==t()&&setTimeout(i,n)}))}))()},methods:j,render:function(t){var n=this.$scopedSlots,i=this.animationEasing,r=this.animationOptions,e=this.cloudWords,o=this.separateAnimationDelay,u=this.separateAnimationDuration;return n=Object.assign({},{default:function(t){return t.text}},n),t("div",{style:{height:"100%",position:"relative",width:"100%"}},[t("div",{style:{bottom:"50%",position:"absolute",right:"50%",transform:"translate(50%,50%)"}},e.map((function(e,a){var f=e.color,s=e.font,c=e.left,h=e.rotation,l=e.text,v=e.top,d=e.weight,m=e.word;return t("transition",Object.assign({},r),[t("div",{key:a,style:Object.assign({},{left:c+"px",position:"absolute",top:v+"px"},u>0?{animation:[u+"ms",i,o*a+"ms"].join(" "),transition:["all",u+"ms",i,o*a+"ms"].join(" ")}:{})},[t("div",{style:Object.assign({},{bottom:0,position:"absolute",right:0,transform:["translate(50%,50%)","rotate("+h+"rad)"].join(" ")},u>0?{transition:["all",u+"ms",i,o*a+"ms"].join(" ")}:{})},[t("span",{style:{color:f,display:"inline-block",font:s,lineHeight:1,transform:"translateY(-0.1em)",whiteSpace:"nowrap"}},[n.default({color:f,font:s,left:c,text:l,top:v,weight:d,word:m})])])])])})))])}},O=globalThis.window;if(O){var E=O.Vue;E&&E.component(F.name,F)}return F}));


/***/ }),

/***/ "2e67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "2e8c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ "2f62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapState; });
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {}

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {}
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((false)) {}

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {}
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {}

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {}
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {}
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {}
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {}
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {}
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {}
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {}
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {}
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {}
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {}
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {}
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {}
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {}
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {}

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {}
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {}
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {}
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {}
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {}
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {}
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {}
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* unused harmony default export */ var _unused_webpack_default_export = (index);


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "30b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "3150":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_style_index_0_id_8edea27c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ff22");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_style_index_0_id_8edea27c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_style_index_0_id_8edea27c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "31ce":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3408":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var getMethod = __webpack_require__("dc4a");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "368e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "36a7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "37fb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3852":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "387f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "3886":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ "38cf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var repeat = __webpack_require__("1148");

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});


/***/ }),

/***/ "3934":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "3950":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChannelSelect_vue_vue_type_style_index_1_id_7b39d818_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18b2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChannelSelect_vue_vue_type_style_index_1_id_7b39d818_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChannelSelect_vue_vue_type_style_index_1_id_7b39d818_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "39a6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ "39bd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ "3a39":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ "3a6c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3ad0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3b1b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                '_'
            ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ "3c0d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
            '_'
        ),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ "3c93":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var toString = __webpack_require__("577e");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3d86":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3de5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
            '_'
        ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ "3e92":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ "3ea3":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var sign = __webpack_require__("f748");

var abs = Math.abs;
var pow = Math.pow;

// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$({ target: 'Math', stat: true }, {
  cbrt: function cbrt(x) {
    return sign(x = +x) * pow(abs(x), 1 / 3);
  }
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4069":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("44d2");

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');


/***/ }),

/***/ "408a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ "41fb":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():undefined}("undefined"!=typeof self?self:this,(function(){return function(){var e={661:function(){"undefined"!=typeof window&&function(){for(var e=0,t=["ms","moz","webkit","o"],i=0;i<t.length&&!window.requestAnimationFrame;++i)window.requestAnimationFrame=window[t[i]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[t[i]+"CancelAnimationFrame"]||window[t[i]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(t,i){var n=(new Date).getTime(),r=Math.max(0,16-(n-e)),o=window.setTimeout((function(){t(n+r)}),r);return e=n+r,o}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(e){clearTimeout(e)})}()}},t={};function i(n){var r=t[n];if(void 0!==r)return r.exports;var o=t[n]={exports:{}};return e[n](o,o.exports,i),o.exports}i.d=function(e,t){for(var n in t)i.o(t,n)&&!i.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};return function(){"use strict";i.r(n),i.d(n,{Anchors:function(){return k},Category:function(){return J},Emoji:function(){return W},EmojiData:function(){return $},EmojiIndex:function(){return q},EmojiView:function(){return R},Picker:function(){return oe},Preview:function(){return Z},Search:function(){return K},Skins:function(){return X},frequently:function(){return w},sanitize:function(){return N},store:function(){return c},uncompress:function(){return v}});var e,t,r="emoji-mart",o=JSON,s="undefined"!=typeof window&&"localStorage"in window;function a(e,i){if(t)t(e,i);else{if(!s)return;try{window.localStorage["".concat(r,".").concat(e)]=o.stringify(i)}catch(e){}}}var c={update:function(e){for(var t in e)a(t,e[t])},set:a,get:function(t){if(e)return e(t);if(s){try{var i=window.localStorage["".concat(r,".").concat(t)]}catch(e){return}return i?JSON.parse(i):void 0}},setNamespace:function(e){r=e},setHandlers:function(i){i||(i={}),e=i.getter,t=i.setter}};function u(e){return u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u(e)}function l(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}var h={name:"a",unified:"b",non_qualified:"c",has_img_apple:"d",has_img_google:"e",has_img_twitter:"f",has_img_facebook:"h",keywords:"j",sheet:"k",emoticons:"l",text:"m",short_names:"n",added_in:"o"},m=function(e){var t=[],i=function(e,i){e&&(Array.isArray(e)?e:[e]).forEach((function(e){(i?e.split(/[-|_|\s]+/):[e]).forEach((function(e){e=e.toLowerCase(),-1==t.indexOf(e)&&t.push(e)}))}))};return i(e.short_names,!0),i(e.name,!0),i(e.keywords,!1),i(e.emoticons,!1),t.join(",")};function d(e){var t,i=function(e,t){var i="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!i){if(Array.isArray(e)||(i=function(e,t){if(e){if("string"==typeof e)return l(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(e):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?l(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){i&&(e=i);var n=0,r=function(){};return{s:r,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,s=!0,a=!1;return{s:function(){i=i.call(e)},n:function(){var e=i.next();return s=e.done,e},e:function(e){a=!0,o=e},f:function(){try{s||null==i.return||i.return()}finally{if(a)throw o}}}}(Object.getOwnPropertyNames(e));try{for(i.s();!(t=i.n()).done;){var n=t.value,r=e[n];e[n]=r&&"object"===u(r)?d(r):r}}catch(e){i.e(e)}finally{i.f()}return Object.freeze(e)}var f,p,v=function(e){if(!e.compressed)return e;for(var t in e.compressed=!1,e.emojis){var i=e.emojis[t];for(var n in h)i[n]=i[h[n]],delete i[h[n]];i.short_names||(i.short_names=[]),i.short_names.unshift(t),i.sheet_x=i.sheet[0],i.sheet_y=i.sheet[1],delete i.sheet,i.text||(i.text=""),i.added_in||(i.added_in=6),i.added_in=i.added_in.toFixed(1),i.search=m(i)}return d(e)},j=["+1","grinning","kissing_heart","heart_eyes","laughing","stuck_out_tongue_winking_eye","sweat_smile","joy","scream","disappointed","unamused","weary","sob","sunglasses","heart","hankey"],y={};function g(){p=!0,f=c.get("frequently")}var w={add:function(e){p||g();var t=e.id;f||(f=y),f[t]||(f[t]=0),f[t]+=1,c.set("last",t),c.set("frequently",f)},get:function(e){if(p||g(),!f){y={};for(var t=[],i=Math.min(e,j.length),n=0;n<i;n++)y[j[n]]=parseInt((i-n)/4,10)+1,t.push(j[n]);return t}var r=e,o=[];for(var s in f)f.hasOwnProperty(s)&&o.push(s);var a=o.sort((function(e,t){return f[e]-f[t]})).reverse().slice(0,r),u=c.get("last");return u&&-1==a.indexOf(u)&&(a.pop(),a.push(u)),a}},_={activity:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"/></svg>',custom:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g transform="translate(2.000000, 1.000000)"><rect id="Rectangle" x="8" y="0" width="3" height="21" rx="1.5"></rect><rect id="Rectangle" transform="translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) " x="8.343" y="0.049" width="3" height="21" rx="1.5"></rect><rect id="Rectangle" transform="translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) " x="8.343" y="0.049" width="3" height="21" rx="1.5"></rect></g></svg>',flags:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"/></svg>',foods:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"/></svg>',nature:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"/><path d="M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"/></svg>',objects:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"/><path d="M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"/></svg>',smileys:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"/><path d="M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"/></svg>',people:'<svg xmlns:svg="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"> <path id="path3814" d="m 3.3591089,21.17726 c 0.172036,0.09385 4.265994,2.29837 8.8144451,2.29837 4.927767,0 8.670894,-2.211883 8.82782,-2.306019 0.113079,-0.06785 0.182268,-0.190051 0.182267,-0.321923 0,-3.03119 -0.929494,-5.804936 -2.617196,-7.810712 -1.180603,-1.403134 -2.661918,-2.359516 -4.295699,-2.799791 4.699118,-2.236258 3.102306,-9.28617162 -2.097191,-9.28617162 -5.1994978,0 -6.7963103,7.04991362 -2.097192,9.28617162 -1.6337821,0.440275 -3.1150971,1.396798 -4.2956991,2.799791 -1.687703,2.005776 -2.617196,4.779522 -2.617196,7.810712 1.2e-6,0.137378 0.075039,0.263785 0.195641,0.329572 z M 8.0439319,5.8308783 C 8.0439309,2.151521 12.492107,0.30955811 15.093491,2.9109411 17.694874,5.5123241 15.852911,9.9605006 12.173554,9.9605 9.8938991,9.9579135 8.0465186,8.1105332 8.0439319,5.8308783 Z m -1.688782,7.6894977 c 1.524535,-1.811449 3.5906601,-2.809035 5.8184041,-2.809035 2.227744,0 4.293869,0.997586 5.818404,2.809035 1.533639,1.822571 2.395932,4.339858 2.439152,7.108301 -0.803352,0.434877 -4.141636,2.096112 -8.257556,2.096112 -3.8062921,0 -7.3910861,-1.671043 -8.2573681,-2.104981 0.04505,-2.765017 0.906968,-5.278785 2.438964,-7.099432 z" /> <path id="path3816" d="M 12.173828 0.38867188 C 9.3198513 0.38867187 7.3770988 2.3672285 6.8652344 4.6308594 C 6.4218608 6.5916015 7.1153562 8.7676117 8.9648438 10.126953 C 7.6141249 10.677376 6.3550511 11.480944 5.3496094 12.675781 C 3.5629317 14.799185 2.6015625 17.701475 2.6015625 20.847656 C 2.6015654 21.189861 2.7894276 21.508002 3.0898438 21.671875 C 3.3044068 21.788925 7.4436239 24.039062 12.173828 24.039062 C 17.269918 24.039062 21.083568 21.776786 21.291016 21.652344 C 21.57281 21.483266 21.746097 21.176282 21.746094 20.847656 C 21.746094 17.701475 20.78277 14.799185 18.996094 12.675781 C 17.990455 11.480591 16.733818 10.675362 15.382812 10.125 C 17.231132 8.7655552 17.925675 6.5910701 17.482422 4.6308594 C 16.970557 2.3672285 15.027805 0.38867188 12.173828 0.38867188 z M 12.792969 2.3007812 C 13.466253 2.4161792 14.125113 2.7383941 14.695312 3.3085938 C 15.835712 4.4489931 15.985604 5.9473549 15.46875 7.1953125 C 14.951896 8.4432701 13.786828 9.3984378 12.173828 9.3984375 C 10.197719 9.3961954 8.607711 7.806187 8.6054688 5.8300781 C 8.6054683 4.2170785 9.5606362 3.0520102 10.808594 2.5351562 C 11.432573 2.2767293 12.119685 2.1853833 12.792969 2.3007812 z M 12.173828 11.273438 C 14.233647 11.273438 16.133674 12.185084 17.5625 13.882812 C 18.93069 15.508765 19.698347 17.776969 19.808594 20.283203 C 18.807395 20.800235 15.886157 22.162109 12.173828 22.162109 C 8.7614632 22.162109 5.6245754 20.787069 4.5390625 20.265625 C 4.6525896 17.766717 5.4203315 15.504791 6.7851562 13.882812 C 8.2139827 12.185084 10.11401 11.273438 12.173828 11.273438 z " /> </svg>',places:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"/><path d="M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"/></svg>',recent:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"/><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"/></svg>',symbols:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"/></svg>'};function C(e,t,i,n,r,o,s,a){var c,u="function"==typeof e?e.options:e;if(t&&(u.render=t,u.staticRenderFns=i,u._compiled=!0),n&&(u.functional=!0),o&&(u._scopeId="data-v-"+o),s?(c=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(s)},u._ssrRegister=c):r&&(c=a?function(){r.call(this,(u.functional?this.parent:this).$root.$options.shadowRoot)}:r),c)if(u.functional){u._injectStyles=c;var l=u.render;u.render=function(e,t){return c.call(t),l(e,t)}}else{var h=u.beforeCreate;u.beforeCreate=h?[].concat(h,c):[c]}return{exports:e,options:u}}var b=C({props:{i18n:{type:Object,required:!0},color:{type:String},categories:{type:Array,required:!0},activeCategory:{type:Object,default:function(){return{}}}},created:function(){this.svgs=_}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{staticClass:"emoji-mart-anchors",attrs:{role:"tablist"}},e._l(e.categories,(function(t){return i("button",{key:t.id,class:{"emoji-mart-anchor":!0,"emoji-mart-anchor-selected":t.id==e.activeCategory.id},style:{color:t.id==e.activeCategory.id?e.color:""},attrs:{role:"tab",type:"button","aria-label":t.name,"aria-selected":t.id==e.activeCategory.id,"data-title":e.i18n.categories[t.id]},on:{click:function(i){return e.$emit("click",t)}}},[i("div",{attrs:{"aria-hidden":"true"},domProps:{innerHTML:e._s(e.svgs[t.id])}}),e._v(" "),i("span",{staticClass:"emoji-mart-anchor-bar",style:{backgroundColor:e.color},attrs:{"aria-hidden":"true"}})])})),0)}),[],!1,null,null,null),k=b.exports;function E(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function S(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function x(e,t,i){return t&&S(e.prototype,t),i&&S(e,i),e}var O=String.fromCodePoint||function(){var e,t,i=16384,n=[],r=-1,o=arguments.length;if(!o)return"";for(var s="";++r<o;){var a=Number(arguments[r]);if(!isFinite(a)||a<0||a>1114111||Math.floor(a)!=a)throw RangeError("Invalid code point: "+a);a<=65535?n.push(a):(e=55296+((a-=65536)>>10),t=a%1024+56320,n.push(e,t)),(r+1===o||n.length>i)&&(s+=String.fromCharCode.apply(null,n),n.length=0)}return s};function P(e){var t=e.split("-").map((function(e){return"0x".concat(e)}));return O.apply(null,t)}function A(e){return e.reduce((function(e,t){return-1===e.indexOf(t)&&e.push(t),e}),[])}function M(e,t){var i=A(e),n=A(t);return i.filter((function(e){return n.indexOf(e)>=0}))}function I(e,t){var i={};for(var n in e){var r=e[n],o=r;t.hasOwnProperty(n)&&(o=t[n]),"object"===u(o)&&(o=I(r,o)),i[n]=o}return i}function F(e,t){var i="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!i){if(Array.isArray(e)||(i=function(e,t){if(e){if("string"==typeof e)return z(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(e):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?z(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){i&&(e=i);var n=0,r=function(){};return{s:r,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,s=!0,a=!1;return{s:function(){i=i.call(e)},n:function(){var e=i.next();return s=e.done,e},e:function(e){a=!0,o=e},f:function(){try{s||null==i.return||i.return()}finally{if(a)throw o}}}}function z(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}var L=/^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/,T=["1F3FA","1F3FB","1F3FC","1F3FD","1F3FE","1F3FF"],q=function(){function e(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=i.emojisToShowFilter,r=i.include,o=i.exclude,s=i.custom,a=i.recent,c=i.recentLength,u=void 0===c?20:c;E(this,e),this._data=v(t),this._emojisFilter=n||null,this._include=r||null,this._exclude=o||null,this._custom=s||[],this._recent=a||w.get(u),this._emojis={},this._nativeEmojis={},this._emoticons={},this._categories=[],this._recentCategory={id:"recent",name:"Recent",emojis:[]},this._customCategory={id:"custom",name:"Custom",emojis:[]},this._searchIndex={},this.buildIndex(),Object.freeze(this)}return x(e,[{key:"buildIndex",value:function(){var e=this,t=this._data.categories;if(this._include&&(t=(t=t.filter((function(t){return e._include.includes(t.id)}))).sort((function(t,i){var n=e._include.indexOf(t.id),r=e._include.indexOf(i.id);return n<r?-1:n>r?1:0}))),t.forEach((function(t){if(e.isCategoryNeeded(t.id)){var i={id:t.id,name:t.name,emojis:[]};t.emojis.forEach((function(t){var n=e.addEmoji(t);n&&i.emojis.push(n)})),i.emojis.length&&e._categories.push(i)}})),this.isCategoryNeeded("custom")){if(this._custom.length>0){var i,n=F(this._custom);try{for(n.s();!(i=n.n()).done;){var r=i.value;this.addCustomEmoji(r)}}catch(e){n.e(e)}finally{n.f()}}this._customCategory.emojis.length&&this._categories.push(this._customCategory)}this.isCategoryNeeded("recent")&&(this._recent.length&&this._recent.map((function(t){var i,n=F(e._customCategory.emojis);try{for(n.s();!(i=n.n()).done;){var r=i.value;if(r.id===t)return void e._recentCategory.emojis.push(r)}}catch(e){n.e(e)}finally{n.f()}e.hasEmoji(t)&&e._recentCategory.emojis.push(e.emoji(t))})),this._recentCategory.emojis.length&&this._categories.unshift(this._recentCategory))}},{key:"findEmoji",value:function(e,t){var i=e.match(L);if(i&&(e=i[1],i[2]&&(t=parseInt(i[2],10))),this._data.aliases.hasOwnProperty(e)&&(e=this._data.aliases[e]),this._emojis.hasOwnProperty(e)){var n=this._emojis[e];return t?n.getSkin(t):n}return this._nativeEmojis.hasOwnProperty(e)?this._nativeEmojis[e]:null}},{key:"categories",value:function(){return this._categories}},{key:"emoji",value:function(e){this._data.aliases.hasOwnProperty(e)&&(e=this._data.aliases[e]);var t=this._emojis[e];if(!t)throw new Error("Can not find emoji by id: "+e);return t}},{key:"firstEmoji",value:function(){var e=this._emojis[Object.keys(this._emojis)[0]];if(!e)throw new Error("Can not get first emoji");return e}},{key:"hasEmoji",value:function(e){return this._data.aliases.hasOwnProperty(e)&&(e=this._data.aliases[e]),!!this._emojis[e]}},{key:"nativeEmoji",value:function(e){return this._nativeEmojis.hasOwnProperty(e)?this._nativeEmojis[e]:null}},{key:"search",value:function(e,t){var i=this;if(t||(t=75),!e.length)return null;if("-"==e||"-1"==e)return[this.emoji("-1")];var n,r=e.toLowerCase().split(/[\s|,|\-|_]+/);r.length>2&&(r=[r[0],r[1]]),n=r.map((function(e){for(var t=i._emojis,n=i._searchIndex,r=0,o=0;o<e.length;o++){var s=e[o];r++,n[s]||(n[s]={}),(n=n[s]).results||function(){var i={};for(var o in n.results=[],n.emojis={},t){var s=t[o],a=s._data.search,c=e.substr(0,r),u=a.indexOf(c);if(-1!=u){var l=u+1;c==o&&(l=0),n.results.push(s),n.emojis[o]=s,i[o]=l}}n.results.sort((function(e,t){return i[e.id]-i[t.id]}))}(),t=n.emojis}return n.results})).filter((function(e){return e}));var o=null;return(o=n.length>1?M.apply(null,n):n.length?n[0]:[])&&o.length>t&&(o=o.slice(0,t)),o}},{key:"addCustomEmoji",value:function(e){var t=Object.assign({},e,{id:e.short_names[0],custom:!0});t.search||(t.search=m(t));var i=new $(t);return this._emojis[i.id]=i,this._customCategory.emojis.push(i),i}},{key:"addEmoji",value:function(e){var t=this,i=this._data.emojis[e];if(!this.isEmojiNeeded(i))return!1;var n=new $(i);if(this._emojis[e]=n,n.native&&(this._nativeEmojis[n.native]=n),n._skins)for(var r in n._skins){var o=n._skins[r];o.native&&(this._nativeEmojis[o.native]=o)}return n.emoticons&&n.emoticons.forEach((function(i){t._emoticons[i]||(t._emoticons[i]=e)})),n}},{key:"isCategoryNeeded",value:function(e){var t=!this._include||!this._include.length||this._include.indexOf(e)>-1,i=!(!this._exclude||!this._exclude.length)&&this._exclude.indexOf(e)>-1;return!(!t||i)}},{key:"isEmojiNeeded",value:function(e){return!this._emojisFilter||this._emojisFilter(e)}}]),e}(),$=function(){function e(t){if(E(this,e),this._data=Object.assign({},t),this._skins=null,this._data.skin_variations)for(var i in this._skins=[],T){var n=T[i],r=this._data.skin_variations[n],o=Object.assign({},t);for(var s in r)o[s]=r[s];delete o.skin_variations,o.skin_tone=parseInt(i)+1,this._skins.push(new e(o))}for(var a in this._sanitized=N(this._data),this._sanitized)this[a]=this._sanitized[a];this.short_names=this._data.short_names,this.short_name=this._data.short_names[0],Object.freeze(this)}return x(e,[{key:"getSkin",value:function(e){return e&&"native"!=e&&this._skins?this._skins[e-1]:this}},{key:"getPosition",value:function(){var e=100/57,t=Math.round(e*this._data.sheet_x*100)/100,i=Math.round(e*this._data.sheet_y*100)/100;return"".concat(t,"% ").concat(i,"%")}},{key:"ariaLabel",value:function(){return[this.native].concat(this.short_names).filter(Boolean).join(", ")}}]),e}(),R=function(){function e(t,i,n,r,o,s,a){E(this,e),this._emoji=t,this._native=r,this._skin=i,this._set=n,this._fallback=o,this.canRender=this._canRender(),this.cssClass=this._cssClass(),this.cssStyle=this._cssStyle(a),this.content=this._content(),this.title=!0===s?t.short_name:null,this.ariaLabel=t.ariaLabel(),Object.freeze(this)}return x(e,[{key:"getEmoji",value:function(){return this._emoji.getSkin(this._skin)}},{key:"_canRender",value:function(){return this._isCustom()||this._isNative()||this._hasEmoji()||this._fallback}},{key:"_cssClass",value:function(){return["emoji-set-"+this._set,"emoji-type-"+this._emojiType()]}},{key:"_cssStyle",value:function(e){var t={};return this._isCustom()?t={backgroundImage:"url("+this.getEmoji()._data.imageUrl+")",backgroundSize:"100%",width:e+"px",height:e+"px"}:this._hasEmoji()&&!this._isNative()&&(t={backgroundPosition:this.getEmoji().getPosition()}),e&&(t=this._isNative()?Object.assign(t,{fontSize:Math.round(.95*e*10)/10+"px"}):Object.assign(t,{width:e+"px",height:e+"px"})),t}},{key:"_content",value:function(){return this._isCustom()?"":this._isNative()?this.getEmoji().native:this._hasEmoji()?"":this._fallback?this._fallback(this.getEmoji()):null}},{key:"_isNative",value:function(){return this._native}},{key:"_isCustom",value:function(){return this.getEmoji().custom}},{key:"_hasEmoji",value:function(){if(!this.getEmoji()._data)return!1;var e=this.getEmoji()._data["has_img_"+this._set];return void 0===e||e}},{key:"_emojiType",value:function(){return this._isCustom()?"custom":this._isNative()?"native":this._hasEmoji()?"image":"fallback"}}]),e}();function N(e){var t=e.name,i=e.short_names,n=e.skin_tone,r=e.skin_variations,o=e.emoticons,s=e.unified,a=e.custom,c=e.imageUrl,u=e.id||i[0],l=":".concat(u,":");return a?{id:u,name:t,colons:l,emoticons:o,custom:a,imageUrl:c}:(n&&(l+=":skin-tone-".concat(n,":")),{id:u,name:t,colons:l,emoticons:o,unified:s.toLowerCase(),skin:n||(r?1:null),native:P(s)})}function D(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}var B={native:{type:Boolean,default:!1},tooltip:{type:Boolean,default:!1},fallback:{type:Function},skin:{type:Number,default:1},set:{type:String,default:"apple"},emoji:{type:[String,Object],required:!0},size:{type:Number,default:null},tag:{type:String,default:"span"}},H={perLine:{type:Number,default:9},maxSearchResults:{type:Number,default:75},emojiSize:{type:Number,default:24},title:{type:String,default:"Emoji Mart™"},emoji:{type:String,default:"department_store"},color:{type:String,default:"#ae65c5"},set:{type:String,default:"apple"},skin:{type:Number,default:null},defaultSkin:{type:Number,default:1},native:{type:Boolean,default:!1},emojiTooltip:{type:Boolean,default:!1},autoFocus:{type:Boolean,default:!1},i18n:{type:Object,default:function(){return{}}},showPreview:{type:Boolean,default:!0},showSearch:{type:Boolean,default:!0},showCategories:{type:Boolean,default:!0},showSkinTones:{type:Boolean,default:!0},infiniteScroll:{type:Boolean,default:!0},pickerStyles:{type:Object,default:function(){return{}}}};function U(e,t){var i=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),i.push.apply(i,n)}return i}function V(e){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?U(Object(i),!0).forEach((function(t){D(e,t,i[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(i)):U(Object(i)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(i,t))}))}return e}var W=C({props:V(V({},B),{},{data:{type:Object,required:!0}}),computed:{view:function(){return new R(this.emojiObject,this.skin,this.set,this.native,this.fallback,this.tooltip,this.size)},sanitizedData:function(){return this.emojiObject._sanitized},title:function(){return this.tooltip?this.emojiObject.short_name:null},emojiObject:function(){return"string"==typeof this.emoji?this.data.findEmoji(this.emoji):this.emoji}},created:function(){},methods:{onClick:function(){this.$emit("click",this.emojiObject)},onMouseEnter:function(){this.$emit("mouseenter",this.emojiObject)},onMouseLeave:function(){this.$emit("mouseleave",this.emojiObject)}}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return e.view.canRender?i(e.tag,{tag:"component",staticClass:"emoji-mart-emoji",attrs:{title:e.view.title,"aria-label":e.view.ariaLabel,"data-title":e.title},on:{mouseenter:e.onMouseEnter,mouseleave:e.onMouseLeave,click:e.onClick}},[i("span",{class:e.view.cssClass,style:e.view.cssStyle},[e._v(e._s(e.view.content))])]):e._e()}),[],!1,null,null,null).exports,J=C({props:{data:{type:Object,required:!0},i18n:{type:Object,required:!0},id:{type:String,required:!0},name:{type:String,required:!0},emojis:{type:Array},emojiProps:{type:Object,required:!0}},methods:{activeClass:function(e){return this.emojiProps.selectedEmoji&&this.emojiProps.selectedEmojiCategory&&this.emojiProps.selectedEmoji.id==e.id&&this.emojiProps.selectedEmojiCategory.id==this.id?"emoji-mart-emoji-selected":""}},computed:{isVisible:function(){return!!this.emojis},isSearch:function(){return"Search"==this.name},hasResults:function(){return this.emojis.length>0},emojiObjects:function(){var e=this;return this.emojis.map((function(t){return{emojiObject:t,emojiView:new R(t,e.emojiProps.skin,e.emojiProps.set,e.emojiProps.native,e.emojiProps.fallback,e.emojiProps.emojiTooltip,e.emojiProps.emojiSize)}}))}},components:{Emoji:W}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return e.isVisible&&(e.isSearch||e.hasResults)?i("section",{class:{"emoji-mart-category":!0,"emoji-mart-no-results":!e.hasResults},attrs:{"aria-label":e.i18n.categories[e.id]}},[i("div",{staticClass:"emoji-mart-category-label"},[i("h3",{staticClass:"emoji-mart-category-label"},[e._v(e._s(e.i18n.categories[e.id]))])]),e._v(" "),e._l(e.emojiObjects,(function(t){var n=t.emojiObject,r=t.emojiView;return[r.canRender?i("button",{key:n.id,staticClass:"emoji-mart-emoji",class:e.activeClass(n),attrs:{"aria-label":r.ariaLabel,role:"option","aria-selected":"false","aria-posinset":"1","aria-setsize":"1812",type:"button","data-title":n.short_name,title:r.title},on:{mouseenter:function(t){e.emojiProps.onEnter(r.getEmoji())},mouseleave:function(t){e.emojiProps.onLeave(r.getEmoji())},click:function(t){e.emojiProps.onClick(r.getEmoji())}}},[i("span",{class:r.cssClass,style:r.cssStyle},[e._v(e._s(r.content))])]):e._e()]})),e._v(" "),e.hasResults?e._e():i("div",[i("emoji",{attrs:{data:e.data,emoji:"sleuth_or_spy",native:e.emojiProps.native,skin:e.emojiProps.skin,set:e.emojiProps.set}}),e._v(" "),i("div",{staticClass:"emoji-mart-no-results-label"},[e._v(e._s(e.i18n.notfound))])],1)],2):e._e()}),[],!1,null,null,null).exports,X=C({props:{skin:{type:Number,required:!0}},data:function(){return{opened:!1}},methods:{onClick:function(e){this.opened&&e!=this.skin&&this.$emit("change",e),this.opened=!this.opened}}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{class:{"emoji-mart-skin-swatches":!0,"emoji-mart-skin-swatches-opened":e.opened}},e._l(6,(function(t){return i("span",{key:t,class:{"emoji-mart-skin-swatch":!0,"emoji-mart-skin-swatch-selected":e.skin==t}},[i("span",{class:"emoji-mart-skin emoji-mart-skin-tone-"+t,on:{click:function(i){return e.onClick(t)}}})])})),0)}),[],!1,null,null,null).exports,Z=C({props:{data:{type:Object,required:!0},title:{type:String,required:!0},emoji:{type:[String,Object]},idleEmoji:{type:[String,Object],required:!0},showSkinTones:{type:Boolean,default:!0},emojiProps:{type:Object,required:!0},skinProps:{type:Object,required:!0},onSkinChange:{type:Function,required:!0}},computed:{emojiData:function(){return this.emoji?this.emoji:{}},emojiShortNames:function(){return this.emojiData.short_names},emojiEmoticons:function(){return this.emojiData.emoticons}},components:{Emoji:W,Skins:X}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{staticClass:"emoji-mart-preview"},[e.emoji?[i("div",{staticClass:"emoji-mart-preview-emoji"},[i("emoji",{attrs:{data:e.data,emoji:e.emoji,native:e.emojiProps.native,skin:e.emojiProps.skin,set:e.emojiProps.set}})],1),e._v(" "),i("div",{staticClass:"emoji-mart-preview-data"},[i("div",{staticClass:"emoji-mart-preview-name"},[e._v(e._s(e.emoji.name))]),e._v(" "),i("div",{staticClass:"emoji-mart-preview-shortnames"},e._l(e.emojiShortNames,(function(t){return i("span",{key:t,staticClass:"emoji-mart-preview-shortname"},[e._v(":"+e._s(t)+":")])})),0),e._v(" "),i("div",{staticClass:"emoji-mart-preview-emoticons"},e._l(e.emojiEmoticons,(function(t){return i("span",{key:t,staticClass:"emoji-mart-preview-emoticon"},[e._v(e._s(t))])})),0)])]:[i("div",{staticClass:"emoji-mart-preview-emoji"},[i("emoji",{attrs:{data:e.data,emoji:e.idleEmoji,native:e.emojiProps.native,skin:e.emojiProps.skin,set:e.emojiProps.set}})],1),e._v(" "),i("div",{staticClass:"emoji-mart-preview-data"},[i("span",{staticClass:"emoji-mart-title-label"},[e._v(e._s(e.title))])]),e._v(" "),e.showSkinTones?i("div",{staticClass:"emoji-mart-preview-skins"},[i("skins",{attrs:{skin:e.skinProps.skin},on:{change:function(t){return e.onSkinChange(t)}}})],1):e._e()]],2)}),[],!1,null,null,null).exports,G=C({props:{data:{type:Object,required:!0},i18n:{type:Object,required:!0},autoFocus:{type:Boolean,default:!1},onSearch:{type:Function,required:!0},onArrowLeft:{type:Function,required:!1},onArrowRight:{type:Function,required:!1},onArrowDown:{type:Function,required:!1},onArrowUp:{type:Function,required:!1},onEnter:{type:Function,required:!1}},data:function(){return{value:""}},computed:{emojiIndex:function(){return this.data}},watch:{value:function(){this.$emit("search",this.value)}},methods:{clear:function(){this.value=""}},mounted:function(){var e=this.$el.querySelector("input");this.autoFocus&&e.focus()}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{staticClass:"emoji-mart-search"},[i("input",{directives:[{name:"model",rawName:"v-model",value:e.value,expression:"value"}],attrs:{type:"text",placeholder:e.i18n.search,role:"textbox","aria-autocomplete":"list","aria-owns":"emoji-mart-list","aria-label":"Search for an emoji","aria-describedby":"emoji-mart-search-description"},domProps:{value:e.value},on:{keydown:[function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"left",37,t.key,["Left","ArrowLeft"])||"button"in t&&0!==t.button?null:function(t){return e.$emit("arrowLeft",t)}.apply(null,arguments)},function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"right",39,t.key,["Right","ArrowRight"])||"button"in t&&2!==t.button?null:function(){return e.$emit("arrowRight")}.apply(null,arguments)},function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"down",40,t.key,["Down","ArrowDown"])?null:function(){return e.$emit("arrowDown")}.apply(null,arguments)},function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"up",38,t.key,["Up","ArrowUp"])?null:function(t){return e.$emit("arrowUp",t)}.apply(null,arguments)},function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"enter",13,t.key,"Enter")?null:function(){return e.$emit("enter")}.apply(null,arguments)}],input:function(t){t.target.composing||(e.value=t.target.value)}}}),e._v(" "),i("span",{staticClass:"hidden",attrs:{id:"emoji-picker-search-description"}},[e._v("Use the left, right, up and down arrow keys to navigate the emoji search\n    results.")])])}),[],!1,null,null,null),K=G.exports;function Q(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}i(661);var Y=function(){function e(t){var i,n;E(this,e),this._vm=t,this._data=t.data,this._perLine=t.perLine,this._categories=[],(i=this._categories).push.apply(i,function(e){if(Array.isArray(e))return Q(e)}(n=this._data.categories())||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(n)||function(e,t){if(e){if("string"==typeof e)return Q(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(e):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?Q(e,t):void 0}}(n)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()),this._categories=this._categories.filter((function(e){return e.emojis.length>0})),this._categories[0].first=!0,Object.freeze(this._categories),this.activeCategory=this._categories[0],this.searchEmojis=null,this.previewEmoji=null,this.previewEmojiCategoryIdx=0,this.previewEmojiIdx=-1}return x(e,[{key:"onScroll",value:function(){for(var e=this._vm.$refs.scroll.scrollTop,t=this.filteredCategories[0],i=0,n=this.filteredCategories.length;i<n;i++){var r=this.filteredCategories[i],o=this._vm.getCategoryComponent(i);if(o&&o.$el.offsetTop-50>e)break;t=r}this.activeCategory=t}},{key:"allCategories",get:function(){return this._categories}},{key:"filteredCategories",get:function(){return this.searchEmojis?[{id:"search",name:"Search",emojis:this.searchEmojis}]:this._categories.filter((function(e){return e.emojis.length>0}))}},{key:"previewEmojiCategory",get:function(){return this.previewEmojiCategoryIdx>=0?this.filteredCategories[this.previewEmojiCategoryIdx]:null}},{key:"onAnchorClick",value:function(e){var t=this;if(!this.searchEmojis){var i=this.filteredCategories.indexOf(e),n=this._vm.getCategoryComponent(i);this._vm.infiniteScroll?function(){if(n){var i=n.$el.offsetTop;e.first&&(i=0),t._vm.$refs.scroll.scrollTop=i}}():this.activeCategory=this.filteredCategories[i]}}},{key:"onSearch",value:function(e){var t=this._data.search(e,this.maxSearchResults);this.searchEmojis=t,this.previewEmojiCategoryIdx=0,this.previewEmojiIdx=0,this.updatePreviewEmoji()}},{key:"onEmojiEnter",value:function(e){this.previewEmoji=e,this.previewEmojiIdx=-1,this.previewEmojiCategoryIdx=-1}},{key:"onEmojiLeave",value:function(e){this.previewEmoji=null}},{key:"onArrowLeft",value:function(){this.previewEmojiIdx>0?this.previewEmojiIdx-=1:(this.previewEmojiCategoryIdx-=1,this.previewEmojiCategoryIdx<0?this.previewEmojiCategoryIdx=0:this.previewEmojiIdx=this.filteredCategories[this.previewEmojiCategoryIdx].emojis.length-1),this.updatePreviewEmoji()}},{key:"onArrowRight",value:function(){this.previewEmojiIdx<this.emojisLength(this.previewEmojiCategoryIdx)-1?this.previewEmojiIdx+=1:(this.previewEmojiCategoryIdx+=1,this.previewEmojiCategoryIdx>=this.filteredCategories.length?this.previewEmojiCategoryIdx=this.filteredCategories.length-1:this.previewEmojiIdx=0),this.updatePreviewEmoji()}},{key:"onArrowDown",value:function(){if(-1==this.previewEmojiIdx)return this.onArrowRight();var e=this.filteredCategories[this.previewEmojiCategoryIdx].emojis.length,t=this._perLine;this.previewEmojiIdx+t>e&&(t=e%this._perLine);for(var i=0;i<t;i++)this.onArrowRight();this.updatePreviewEmoji()}},{key:"onArrowUp",value:function(){var e=this._perLine;this.previewEmojiIdx-e<0&&(e=this.previewEmojiCategoryIdx>0?this.filteredCategories[this.previewEmojiCategoryIdx-1].emojis.length%this._perLine:0);for(var t=0;t<e;t++)this.onArrowLeft();this.updatePreviewEmoji()}},{key:"updatePreviewEmoji",value:function(){var e=this;this.previewEmoji=this.filteredCategories[this.previewEmojiCategoryIdx].emojis[this.previewEmojiIdx],this._vm.$nextTick((function(){var t=e._vm.$refs.scroll,i=t.querySelector(".emoji-mart-emoji-selected"),n=t.offsetTop-t.offsetHeight;i&&i.offsetTop+i.offsetHeight>n+t.scrollTop&&(t.scrollTop+=i.offsetHeight),i&&i.offsetTop<t.scrollTop&&(t.scrollTop-=i.offsetHeight)}))}},{key:"emojisLength",value:function(e){return-1==e?0:this.filteredCategories[e].emojis.length}}]),e}();function ee(e,t){var i=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),i.push.apply(i,n)}return i}function te(e){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?ee(Object(i),!0).forEach((function(t){D(e,t,i[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(i)):ee(Object(i)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(i,t))}))}return e}var ie={search:"Search",notfound:"No Emoji Found",categories:{search:"Search Results",recent:"Frequently Used",smileys:"Smileys & Emotion",people:"People & Body",nature:"Animals & Nature",foods:"Food & Drink",activity:"Activity",places:"Travel & Places",objects:"Objects",symbols:"Symbols",flags:"Flags",custom:"Custom"}},ne={props:te(te({},H),{},{data:{type:Object,required:!0}}),data:function(){return{activeSkin:this.skin||c.get("skin")||this.defaultSkin,view:new Y(this)}},computed:{customStyles:function(){return te({width:this.calculateWidth+"px"},this.pickerStyles)},emojiProps:function(){return{native:this.native,skin:this.activeSkin,set:this.set,emojiTooltip:this.emojiTooltip,emojiSize:this.emojiSize,selectedEmoji:this.view.previewEmoji,selectedEmojiCategory:this.view.previewEmojiCategory,onEnter:this.onEmojiEnter.bind(this),onLeave:this.onEmojiLeave.bind(this),onClick:this.onEmojiClick.bind(this)}},skinProps:function(){return{skin:this.activeSkin}},calculateWidth:function(){return this.perLine*(this.emojiSize+12)+12+2+function(){if("undefined"==typeof document)return 0;var e=document.createElement("div");e.style.width="100px",e.style.height="100px",e.style.overflow="scroll",e.style.position="absolute",e.style.top="-9999px",document.body.appendChild(e);var t=e.offsetWidth-e.clientWidth;return document.body.removeChild(e),t}()},filteredCategories:function(){return this.view.filteredCategories},mergedI18n:function(){return Object.freeze(I(ie,this.i18n))},idleEmoji:function(){try{return this.data.emoji(this.emoji)}catch(e){return console.error("Default preview emoji `"+this.emoji+"` is not available, check the Picker `emoji` property"),console.error(e),this.data.firstEmoji()}}},methods:{onScroll:function(){this.infiniteScroll&&!this.waitingForPaint&&(this.waitingForPaint=!0,window.requestAnimationFrame(this.onScrollPaint.bind(this)))},onScrollPaint:function(){this.waitingForPaint=!1,this.view.onScroll()},onAnchorClick:function(e){this.view.onAnchorClick(e)},onSearch:function(e){this.view.onSearch(e)},onEmojiEnter:function(e){this.view.onEmojiEnter(e)},onEmojiLeave:function(e){this.view.onEmojiLeave(e)},onArrowLeft:function(e){var t=this.view.previewEmojiIdx;this.view.onArrowLeft(),e&&this.view.previewEmojiIdx!==t&&e.preventDefault()},onArrowRight:function(){this.view.onArrowRight()},onArrowDown:function(){this.view.onArrowDown()},onArrowUp:function(e){this.view.onArrowUp(),e.preventDefault()},onEnter:function(e){this.$emit("select",this.view.previewEmoji),w.add(this.view.previewEmoji)},onEmojiClick:function(e){this.$emit("select",e),w.add(e)},onSkinChange:function(e){this.activeSkin=e,c.update({skin:e}),this.$emit("skin-change",e)},getCategoryComponent:function(e){var t=this.$refs["categories_"+e];return t&&"0"in t?t[0]:t}},components:{Anchors:k,Category:J,Preview:Z,Search:K}},re=C(ne,(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("section",{staticClass:"emoji-mart emoji-mart-static",style:e.customStyles},[e.showCategories?i("div",{staticClass:"emoji-mart-bar emoji-mart-bar-anchors"},[i("anchors",{attrs:{data:e.data,i18n:e.mergedI18n,color:e.color,categories:e.view.allCategories,"active-category":e.view.activeCategory},on:{click:e.onAnchorClick}})],1):e._e(),e._v(" "),e._t("searchTemplate",(function(){return[e.showSearch?i("search",{ref:"search",attrs:{data:e.data,i18n:e.mergedI18n,"auto-focus":e.autoFocus,"on-search":e.onSearch},on:{search:e.onSearch,arrowLeft:e.onArrowLeft,arrowRight:e.onArrowRight,arrowDown:e.onArrowDown,arrowUp:e.onArrowUp,enter:e.onEnter}}):e._e()]}),{data:e.data,i18n:e.i18n,autoFocus:e.autoFocus,onSearch:e.onSearch}),e._v(" "),i("div",{ref:"scroll",staticClass:"emoji-mart-scroll",attrs:{role:"tabpanel"},on:{scroll:e.onScroll}},[i("div",{ref:"scrollContent",attrs:{id:"emoji-mart-list",role:"listbox","aria-expanded":"true"}},e._l(e.view.filteredCategories,(function(t,n){return i("category",{directives:[{name:"show",rawName:"v-show",value:e.infiniteScroll||t==e.view.activeCategory,expression:"infiniteScroll || category == view.activeCategory"}],key:t.id,ref:"categories_"+n,refInFor:!0,attrs:{data:e.data,i18n:e.mergedI18n,id:t.id,name:t.name,emojis:t.emojis,"emoji-props":e.emojiProps}})})),1)]),e._v(" "),e._t("previewTemplate",(function(){return[e.showPreview?i("div",{staticClass:"emoji-mart-bar emoji-mart-bar-preview"},[i("preview",{attrs:{data:e.data,title:e.title,emoji:e.view.previewEmoji,"idle-emoji":e.idleEmoji,"show-skin-tones":e.showSkinTones,"emoji-props":e.emojiProps,"skin-props":e.skinProps,"on-skin-change":e.onSkinChange}})],1):e._e()]}),{data:e.data,title:e.title,emoji:e.view.previewEmoji,idleEmoji:e.idleEmoji,showSkinTones:e.showSkinTones,emojiProps:e.emojiProps,skinProps:e.skinProps,onSkinChange:e.onSkinChange})],2)}),[],!1,null,null,null),oe=re.exports}(),n}()}));

/***/ }),

/***/ "423e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "4362":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("df7c");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "440c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
            '_'
        ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var getMethod = __webpack_require__("dc4a");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4678":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "2bfb",
	"./af.js": "2bfb",
	"./ar": "8e73",
	"./ar-dz": "a356",
	"./ar-dz.js": "a356",
	"./ar-kw": "423e",
	"./ar-kw.js": "423e",
	"./ar-ly": "1cfd",
	"./ar-ly.js": "1cfd",
	"./ar-ma": "0a84",
	"./ar-ma.js": "0a84",
	"./ar-sa": "8230",
	"./ar-sa.js": "8230",
	"./ar-tn": "6d83",
	"./ar-tn.js": "6d83",
	"./ar.js": "8e73",
	"./az": "485c",
	"./az.js": "485c",
	"./be": "1fc1",
	"./be.js": "1fc1",
	"./bg": "84aa",
	"./bg.js": "84aa",
	"./bm": "a7fa",
	"./bm.js": "a7fa",
	"./bn": "9043",
	"./bn-bd": "9686",
	"./bn-bd.js": "9686",
	"./bn.js": "9043",
	"./bo": "d26a",
	"./bo.js": "d26a",
	"./br": "6887",
	"./br.js": "6887",
	"./bs": "2554",
	"./bs.js": "2554",
	"./ca": "d716",
	"./ca.js": "d716",
	"./cs": "3c0d",
	"./cs.js": "3c0d",
	"./cv": "03ec",
	"./cv.js": "03ec",
	"./cy": "9797",
	"./cy.js": "9797",
	"./da": "0f14",
	"./da.js": "0f14",
	"./de": "b469",
	"./de-at": "b3eb",
	"./de-at.js": "b3eb",
	"./de-ch": "bb71",
	"./de-ch.js": "bb71",
	"./de.js": "b469",
	"./dv": "598a",
	"./dv.js": "598a",
	"./el": "8d47",
	"./el.js": "8d47",
	"./en-au": "0e6b",
	"./en-au.js": "0e6b",
	"./en-ca": "3886",
	"./en-ca.js": "3886",
	"./en-gb": "39a6",
	"./en-gb.js": "39a6",
	"./en-ie": "e1d3",
	"./en-ie.js": "e1d3",
	"./en-il": "7333",
	"./en-il.js": "7333",
	"./en-in": "ec2e",
	"./en-in.js": "ec2e",
	"./en-nz": "6f50",
	"./en-nz.js": "6f50",
	"./en-sg": "b7e9",
	"./en-sg.js": "b7e9",
	"./eo": "65db",
	"./eo.js": "65db",
	"./es": "898b",
	"./es-do": "0a3c",
	"./es-do.js": "0a3c",
	"./es-mx": "b5b7",
	"./es-mx.js": "b5b7",
	"./es-us": "55c9",
	"./es-us.js": "55c9",
	"./es.js": "898b",
	"./et": "ec18",
	"./et.js": "ec18",
	"./eu": "0ff2",
	"./eu.js": "0ff2",
	"./fa": "8df4",
	"./fa.js": "8df4",
	"./fi": "81e9",
	"./fi.js": "81e9",
	"./fil": "d69a",
	"./fil.js": "d69a",
	"./fo": "0721",
	"./fo.js": "0721",
	"./fr": "9f26",
	"./fr-ca": "d9f8",
	"./fr-ca.js": "d9f8",
	"./fr-ch": "0e49",
	"./fr-ch.js": "0e49",
	"./fr.js": "9f26",
	"./fy": "7118",
	"./fy.js": "7118",
	"./ga": "5120",
	"./ga.js": "5120",
	"./gd": "f6b4",
	"./gd.js": "f6b4",
	"./gl": "8840",
	"./gl.js": "8840",
	"./gom-deva": "aaf2",
	"./gom-deva.js": "aaf2",
	"./gom-latn": "0caa",
	"./gom-latn.js": "0caa",
	"./gu": "e0c5",
	"./gu.js": "e0c5",
	"./he": "c7aa",
	"./he.js": "c7aa",
	"./hi": "dc4d",
	"./hi.js": "dc4d",
	"./hr": "4ba9",
	"./hr.js": "4ba9",
	"./hu": "5b14",
	"./hu.js": "5b14",
	"./hy-am": "d6b6",
	"./hy-am.js": "d6b6",
	"./id": "5038",
	"./id.js": "5038",
	"./is": "0558",
	"./is.js": "0558",
	"./it": "6e98",
	"./it-ch": "6f12",
	"./it-ch.js": "6f12",
	"./it.js": "6e98",
	"./ja": "079e",
	"./ja.js": "079e",
	"./jv": "b540",
	"./jv.js": "b540",
	"./ka": "201b",
	"./ka.js": "201b",
	"./kk": "6d79",
	"./kk.js": "6d79",
	"./km": "e81d",
	"./km.js": "e81d",
	"./kn": "3e92",
	"./kn.js": "3e92",
	"./ko": "22f8",
	"./ko.js": "22f8",
	"./ku": "2421",
	"./ku.js": "2421",
	"./ky": "9609",
	"./ky.js": "9609",
	"./lb": "440c",
	"./lb.js": "440c",
	"./lo": "b29d",
	"./lo.js": "b29d",
	"./lt": "26f9",
	"./lt.js": "26f9",
	"./lv": "b97c",
	"./lv.js": "b97c",
	"./me": "293c",
	"./me.js": "293c",
	"./mi": "688b",
	"./mi.js": "688b",
	"./mk": "6909",
	"./mk.js": "6909",
	"./ml": "02fb",
	"./ml.js": "02fb",
	"./mn": "958b",
	"./mn.js": "958b",
	"./mr": "39bd",
	"./mr.js": "39bd",
	"./ms": "ebe4",
	"./ms-my": "6403",
	"./ms-my.js": "6403",
	"./ms.js": "ebe4",
	"./mt": "1b45",
	"./mt.js": "1b45",
	"./my": "8689",
	"./my.js": "8689",
	"./nb": "6ce3",
	"./nb.js": "6ce3",
	"./ne": "3a39",
	"./ne.js": "3a39",
	"./nl": "facd",
	"./nl-be": "db29",
	"./nl-be.js": "db29",
	"./nl.js": "facd",
	"./nn": "b84c",
	"./nn.js": "b84c",
	"./oc-lnc": "167b",
	"./oc-lnc.js": "167b",
	"./pa-in": "f3ff",
	"./pa-in.js": "f3ff",
	"./pl": "8d57",
	"./pl.js": "8d57",
	"./pt": "f260",
	"./pt-br": "d2d4",
	"./pt-br.js": "d2d4",
	"./pt.js": "f260",
	"./ro": "972c",
	"./ro.js": "972c",
	"./ru": "957c",
	"./ru.js": "957c",
	"./sd": "6784",
	"./sd.js": "6784",
	"./se": "ffff",
	"./se.js": "ffff",
	"./si": "eda5",
	"./si.js": "eda5",
	"./sk": "7be6",
	"./sk.js": "7be6",
	"./sl": "8155",
	"./sl.js": "8155",
	"./sq": "c8f3",
	"./sq.js": "c8f3",
	"./sr": "cf1e",
	"./sr-cyrl": "13e9",
	"./sr-cyrl.js": "13e9",
	"./sr.js": "cf1e",
	"./ss": "52bd",
	"./ss.js": "52bd",
	"./sv": "5fbd",
	"./sv.js": "5fbd",
	"./sw": "74dc",
	"./sw.js": "74dc",
	"./ta": "3de5",
	"./ta.js": "3de5",
	"./te": "5cbb",
	"./te.js": "5cbb",
	"./tet": "576c",
	"./tet.js": "576c",
	"./tg": "3b1b",
	"./tg.js": "3b1b",
	"./th": "10e8",
	"./th.js": "10e8",
	"./tk": "5aff",
	"./tk.js": "5aff",
	"./tl-ph": "0f38",
	"./tl-ph.js": "0f38",
	"./tlh": "cf75",
	"./tlh.js": "cf75",
	"./tr": "0e81",
	"./tr.js": "0e81",
	"./tzl": "cf51",
	"./tzl.js": "cf51",
	"./tzm": "c109",
	"./tzm-latn": "b53d",
	"./tzm-latn.js": "b53d",
	"./tzm.js": "c109",
	"./ug-cn": "6117",
	"./ug-cn.js": "6117",
	"./uk": "ada2",
	"./uk.js": "ada2",
	"./ur": "5294",
	"./ur.js": "5294",
	"./uz": "2e8c",
	"./uz-latn": "010e",
	"./uz-latn.js": "010e",
	"./uz.js": "2e8c",
	"./vi": "2921",
	"./vi.js": "2921",
	"./x-pseudo": "fd7e",
	"./x-pseudo.js": "fd7e",
	"./yo": "7f33",
	"./yo.js": "7f33",
	"./zh-cn": "5c3a",
	"./zh-cn.js": "5c3a",
	"./zh-hk": "49ab",
	"./zh-hk.js": "49ab",
	"./zh-mo": "3a6c",
	"./zh-mo.js": "3a6c",
	"./zh-tw": "90ea",
	"./zh-tw.js": "90ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4678";

/***/ }),

/***/ "467f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("2d83");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "4804":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aConstructor = __webpack_require__("5087");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "485c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
            '_'
        ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "49ab":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ "4a0c":
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

/***/ }),

/***/ "4a7b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ "4ae1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0538");
var aConstructor = __webpack_require__("5087");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var fails = __webpack_require__("d039");

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "4b85":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4ba9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                '_'
            ),
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ "4c53":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var createNonEnumerableProperty = __webpack_require__("9112");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isPrototypeOf = __webpack_require__("3a9b");
var isRegExp = __webpack_require__("44e7");
var toString = __webpack_require__("577e");
var regExpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var enforceInternalState = __webpack_require__("69f3").enforce;
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var getFlags = uncurryThis(regExpFlags);
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4dae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");

var Array = global.Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var isConstructor = __webpack_require__("68ee");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");

var Array = global.Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4e3d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/highlightMessage.4a36e3ad.png";

/***/ }),

/***/ "4e82":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var toString = __webpack_require__("577e");
var fails = __webpack_require__("d039");
var internalSort = __webpack_require__("addb");
var arrayMethodIsStrict = __webpack_require__("a640");
var FF = __webpack_require__("04d1");
var IE_OR_EDGE = __webpack_require__("d998");
var V8 = __webpack_require__("2d00");
var WEBKIT = __webpack_require__("512c");

var test = [];
var un$Sort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});


/***/ }),

/***/ "4ec9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("6d61");
var collectionStrong = __webpack_require__("6566");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $entries = __webpack_require__("6f53").entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "4fadd":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__("d86b");

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ "4ff9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5038":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ "5087":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isConstructor = __webpack_require__("68ee");
var tryToString = __webpack_require__("0d51");

var TypeError = global.TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5104":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollQuestion_vue_vue_type_style_index_0_id_92a5fd40_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a545");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollQuestion_vue_vue_type_style_index_0_id_92a5fd40_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollQuestion_vue_vue_type_style_index_0_id_92a5fd40_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5120":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ "512c":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ "519f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5270":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var transformData = __webpack_require__("c401");
var isCancel = __webpack_require__("2e67");
var defaults = __webpack_require__("2444");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "5294":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ "52bd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
            '_'
        ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var fails = __webpack_require__("d039");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var toIntegerOrInfinity = __webpack_require__("5926");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getMethod = __webpack_require__("dc4a");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");
var wellKnownSymbol = __webpack_require__("b622");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "53ff":
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){var t={};function n(i){if(t[i])return t[i].exports;var o=t[i]={i:i,l:!1,exports:{}};return e[i].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.i=function(e){return e},n.d=function(e,t,i){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:i})},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=11)}([function(e,t){e.exports=function(e,t,n,i){var o,r=e=e||{},a=typeof e.default;"object"!==a&&"function"!==a||(o=e,r=e.default);var s="function"==typeof r?r.options:r;if(t&&(s.render=t.render,s.staticRenderFns=t.staticRenderFns),n&&(s._scopeId=n),i){var l=s.computed||(s.computed={});Object.keys(i).forEach(function(e){var t=i[e];l[e]=function(){return t}})}return{esModule:o,exports:r,options:s}}},function(e,t,n){"use strict";function i(){var e=window.getSelection();if(e&&e.rangeCount>0)return e.getRangeAt(0)}t.f=function(e,t){if(e.scrollIntoViewIfNeeded)e.scrollIntoViewIfNeeded(!1);else{var n=e.offsetTop-t.scrollTop;(n<0||n>t.offsetHeight-e.offsetHeight)&&((t=t||e.parentElement).scrollTop=e.offsetTop)}},t.e=function(e){var t=window.getSelection();t&&(t.removeAllRanges(),t.addRange(e))},t.d=i,t.a=function(e,t){return t.map(function(t){return{at:t,index:e.lastIndexOf(t)}}).reduce(function(e,t){return e.index>t.index?e:t})},t.b=function(e,t){t=t||window;var n={top:e.offsetTop,left:e.offsetLeft},i=e.offsetParent;for(;null!=i&&i!=t;)n.left+=i.offsetLeft,n.top+=i.offsetTop,i=i.offsetParent;return n},t.g=function(e,t){do{if(t(e))return e}while(e=e&&e.parentNode)},t.c=function(){var e=i();if(e){var t=e.cloneRange();return t.collapse(!0),t.setStart(t.endContainer,0),t}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(1),o=n(6),r=n.n(o),a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i])}return e};t.default={name:"At",mixins:[r.a],props:{value:{type:String,default:null},at:{type:String,default:null},ats:{type:Array,default:function(){return["@"]}},suffix:{type:String,default:" "},loop:{type:Boolean,default:!0},allowSpaces:{type:Boolean,default:!0},tabSelect:{type:Boolean,default:!1},avoidEmail:{type:Boolean,default:!0},showUnique:{type:Boolean,default:!0},hoverSelect:{type:Boolean,default:!0},members:{type:Array,default:function(){return[]}},nameKey:{type:String,default:""},filterMatch:{type:Function,default:function(e,t,n){return e.toLowerCase().indexOf(t.toLowerCase())>-1}},deleteMatch:{type:Function,default:function(e,t,n){return t===e+n}},scrollRef:{type:String,default:""}},data:function(){return{bindsValue:null!=this.value,customsEmbedded:!1,hasComposition:!1,atwho:null}},computed:{atItems:function(){return this.at?[this.at]:this.ats},currentItem:function(){return this.atwho?this.atwho.list[this.atwho.cur]:""},style:function(){if(this.atwho){var e=this.atwho,t=(e.list,e.cur,e.x),o=e.y,r=this.$refs.wrap;if(r){var a=n.i(i.b)(r),s=this.scrollRef?document.querySelector(this.scrollRef).scrollLeft:0,l=this.scrollRef?document.querySelector(this.scrollRef).scrollTop:0;return{left:t+s+window.pageXOffset-a.left+"px",top:o+l+window.pageYOffset-a.top+"px"}}}return null}},watch:{"atwho.cur":function(e){var t=this;null!=e&&this.$nextTick(function(){t.scrollToCur()})},members:function(){this.handleInput(!0)},value:function(e,t){this.bindsValue&&this.handleValueUpdate(e)}},mounted:function(){this.$scopedSlots.embeddedItem&&(this.customsEmbedded=!0),this.bindsValue&&this.handleValueUpdate(this.value)},methods:{itemName:function(e){var t=this.nameKey;return t?e[t]:e},isCur:function(e){return e===this.atwho.cur},handleValueUpdate:function(e){var t=this.$el.querySelector("[contenteditable]");e!==t.innerHTML&&(t.innerHTML=e,this.dispatchInput())},dispatchInput:function(){var e=this.$el.querySelector("[contenteditable]"),t=new Event("input",{bubbles:!0});e.dispatchEvent(t)},handleItemHover:function(e){this.hoverSelect&&this.selectByMouse(e)},handleItemClick:function(e){this.selectByMouse(e),this.insertItem()},handleDelete:function(e){var t=n.i(i.c)();if(t){if(this.customsEmbedded&&t.endOffset>=1){var o=t.endContainer.childNodes[t.endOffset]||t.endContainer.childNodes[t.endOffset-1];if(!o||o.nodeType===Node.TEXT_NODE&&!/^\s?$/.test(o.data))return;o.nodeType===Node.TEXT_NODE?o.previousSibling&&(o=o.previousSibling):o.previousElementSibling&&(o=o.previousElementSibling);var r=[].slice.call(o.childNodes);(r=[].reverse.call(r)).unshift(o);var a=void 0;if([].some.call(r,function(e){if(e.getAttribute&&null!=e.getAttribute("data-at-embedded"))return a=e,!0}),a){e.preventDefault(),e.stopPropagation();var s=n.i(i.d)();s&&(s.setStartBefore(a),s.deleteContents(),n.i(i.e)(s),this.handleInput())}return}var l=this.atItems,u=this.members,c=this.suffix,d=this.deleteMatch,f=this.itemName,h=t.toString(),p=n.i(i.a)(h,l),v=p.at,m=p.index;if(m>-1){var w=h.slice(m+v.length);if(u.some(function(e){var t=f(e);return d(t,w,c)})){e.preventDefault(),e.stopPropagation();var x=n.i(i.d)();x&&(x.setStart(x.endContainer,m),x.deleteContents(),n.i(i.e)(x),this.handleInput())}}}},handleKeyDown:function(e){var t=this;if(this.atwho){if(38===e.keyCode||40===e.keyCode)return void(e.metaKey||e.ctrlKey||(e.preventDefault(),e.stopPropagation(),this.selectByKeyboard(e)));if(13===e.keyCode||this.tabSelect&&9===e.keyCode)return this.insertItem(),e.preventDefault(),void e.stopPropagation();if(27===e.keyCode)return void this.closePanel()}(e.keyCode>=48&&e.keyCode<=90||8===e.keyCode)&&setTimeout(function(){t.handleInput()},50),8===e.keyCode&&this.handleDelete(e)},handleCompositionStart:function(){this.hasComposition=!0},handleCompositionEnd:function(){this.hasComposition=!1,this.handleInput()},handleInput:function(e){if(!this.hasComposition){var t=this.$el.querySelector("[contenteditable]");this.$emit("input",t.innerHTML);var o=n.i(i.c)();if(o){var r=this.atItems,a=this.avoidEmail,s=this.allowSpaces,l=this.showUnique,u=!0,c=o.toString(),d=n.i(i.a)(c,r),f=d.at,h=d.index;h<0&&(u=!1);var p=c[h-1],v=c.slice(h+f.length,c.length);if(a&&/^[a-z0-9]$/i.test(p)&&(u=!1),!s&&/\s/.test(v)&&(u=!1),/^\s/.test(v)&&(u=!1),u){var m=this.members,w=this.filterMatch,x=this.itemName;!e&&v&&this.$emit("at",v);var b=m.filter(function(e){var t=x(e);return w(t,v,f)});if(u=!1,b.length&&(u=!0,!l)){var g=b[0];v===x(g)&&(u=!1)}u?this.openPanel(b,o,h,f):this.closePanel()}else this.closePanel()}}},closePanel:function(){this.atwho&&(this.atwho=null)},openPanel:function(e,t,n,i){var o=this,r=function(){var r=t.cloneRange();r.setStart(r.endContainer,n+i.length);var a=r.getClientRects()[0];o.atwho={range:t,offset:n,list:e,x:a.left,y:a.top-4,cur:0}};this.atwho?r():setTimeout(r,10)},scrollToCur:function(){var e=this.$refs.cur[0],t=e.parentElement.parentElement;n.i(i.f)(e,t)},selectByMouse:function(e){var t=+n.i(i.g)(e.target,function(e){return e.getAttribute("data-index")}).getAttribute("data-index");this.atwho=a({},this.atwho,{cur:t})},selectByKeyboard:function(e){var t=38===e.keyCode?-1:1,n=this.atwho,i=n.cur,o=n.list,r=this.loop?(i+t+o.length)%o.length:Math.max(0,Math.min(i+t,o.length-1));this.atwho=a({},this.atwho,{cur:r})},insertText:function(e,t){t.deleteContents();var o=t.endContainer;if(o.nodeType===Node.TEXT_NODE){var r=t.endOffset;o.data=o.data.slice(0,r)+e+o.data.slice(r),t.setEnd(o,r+e.length)}else{var a=document.createTextNode(e);t.insertNode(a),t.setEndAfter(a)}t.collapse(!1),n.i(i.e)(t),this.dispatchInput()},insertHtml:function(e,t){t.deleteContents();var o=t.endContainer,r=document.createElement("span");if(r.appendChild(document.createTextNode(" ")),r.appendChild(this.htmlToElement(e)),r.appendChild(document.createTextNode(" ")),r.setAttribute("data-at-embedded",""),r.setAttribute("contenteditable",!1),o.nodeType===Node.TEXT_NODE){var a=t.endOffset,s=o.splitText(a);o.parentNode.insertBefore(r,s),t.setEndBefore(s)}else{var l=document.createTextNode(suffix);t.insertNode(r),t.setEndAfter(r),t.insertNode(l),t.setEndAfter(l)}t.collapse(!1),n.i(i.e)(t)},insertItem:function(){var e=this.atwho,t=e.range,o=(e.offset,e.list),r=e.cur,a=this.suffix,s=this.atItems,l=this.itemName,u=this.customsEmbedded,c=t.cloneRange(),d=t.toString(),f=n.i(i.a)(d,s),h=f.at,p=f.index,v=u?p:p+h.length;c.setStart(c.endContainer,v),n.i(i.e)(c),n.i(i.e)(c);var m=o[r];if(u){var w=this.$refs.embeddedItem.firstChild.innerHTML;this.insertHtml(w,c)}else{var x=l(m)+a;this.insertText(x,c)}this.$emit("insert",m),this.handleInput()},htmlToElement:function(e){var t=document.createElement("template");return e=e.trim(),t.innerHTML=e,t.content.firstChild}}}},function(e,t,n){(e.exports=n(4)()).push([e.i,".atwho-view{color:#000;border-radius:3px;box-shadow:0 0 5px rgba(0,0,0,.1);min-width:120px;z-index:11110!important}.atwho-ul{list-style:none}.atwho-li{display:block}.atwho-view{border-radius:6px;box-shadow:0 0 10px 0 hsla(211,9%,44%,.5)}.atwho-ul{max-height:135px;padding:0;margin:0}.atwho-li{box-sizing:border-box;height:27px;padding:0 12px;white-space:nowrap;display:flex;align-items:center}.atwho-li span{overflow:hidden;text-overflow:ellipsis}.atwho-cur{background:#5bb8ff;color:#fff}.atwho-wrap{position:relative}.atwho-panel{position:absolute}.atwho-inner{position:relative}.atwho-view{position:absolute;bottom:0;left:-.8em;cursor:default;background-color:hsla(0,0%,100%,.94);min-width:140px;max-width:180px;max-height:200px;overflow-y:auto}.atwho-view::-webkit-scrollbar{width:11px;height:11px}.atwho-view::-webkit-scrollbar-track{background-color:#f5f5f5}.atwho-view::-webkit-scrollbar-thumb{min-height:36px;border:2px solid transparent;border-top:3px solid transparent;border-bottom:3px solid transparent;background-clip:padding-box;border-radius:7px;background-color:#c4c4c4}",""])},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var n=this[t];n[2]?e.push("@media "+n[2]+"{"+n[1]+"}"):e.push(n[1])}return e.join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var i={},o=0;o<this.length;o++){var r=this[o][0];"number"==typeof r&&(i[r]=!0)}for(o=0;o<t.length;o++){var a=t[o];"number"==typeof a[0]&&i[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(e,t,n){var i=n(0)(n(2),null,null,null);e.exports=i.exports},function(e,t,n){n(9);var i=n(0)(null,n(7),null,null);e.exports=i.exports},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{ref:"wrap",staticClass:"atwho-wrap",on:{compositionstart:e.handleCompositionStart,compositionend:e.handleCompositionEnd,input:function(t){e.handleInput()},"!keydown":function(t){return e.handleKeyDown(t)}}},[e.atwho?n("div",{staticClass:"atwho-panel",style:e.style},[n("div",{staticClass:"atwho-inner"},[n("div",{staticClass:"atwho-view"},[n("ul",{staticClass:"atwho-ul"},e._l(e.atwho.list,function(t,i){return n("li",{key:i,ref:e.isCur(i)&&"cur",refInFor:!0,staticClass:"atwho-li",class:e.isCur(i)&&"atwho-cur",attrs:{"data-index":i},on:{mouseenter:e.handleItemHover,click:e.handleItemClick}},[e._t("item",[n("span",{domProps:{textContent:e._s(e.itemName(t))}})],{item:t})],2)}))])])]):e._e(),e._v(" "),n("span",{directives:[{name:"show",rawName:"v-show",value:!1,expression:"false"}],ref:"embeddedItem"},[e._t("embeddedItem",null,{current:e.currentItem})],2),e._v(" "),e._t("default")],2)},staticRenderFns:[]}},function(e,t){var n={},i=function(e){var t;return function(){return void 0===t&&(t=e.apply(this,arguments)),t}},o=i(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),r=i(function(){return document.head||document.getElementsByTagName("head")[0]}),a=null,s=0,l=[];function u(e,t){for(var i=0;i<e.length;i++){var o=e[i],r=n[o.id];if(r){r.refs++;for(var a=0;a<r.parts.length;a++)r.parts[a](o.parts[a]);for(;a<o.parts.length;a++)r.parts.push(f(o.parts[a],t))}else{var s=[];for(a=0;a<o.parts.length;a++)s.push(f(o.parts[a],t));n[o.id]={id:o.id,refs:1,parts:s}}}}function c(e){for(var t=[],n={},i=0;i<e.length;i++){var o=e[i],r=o[0],a={css:o[1],media:o[2],sourceMap:o[3]};n[r]?n[r].parts.push(a):t.push(n[r]={id:r,parts:[a]})}return t}function d(e){var t=document.createElement("style");return t.type="text/css",function(e,t){var n=r(),i=l[l.length-1];if("top"===e.insertAt)i?i.nextSibling?n.insertBefore(t,i.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),l.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}(e,t),t}function f(e,t){var n,i,o;if(t.singleton){var r=s++;n=a||(a=d(t)),i=v.bind(null,n,r,!1),o=v.bind(null,n,r,!0)}else n=d(t),i=function(e,t){var n=t.css,i=t.media,o=t.sourceMap;i&&e.setAttribute("media",i);o&&(n+="\n/*# sourceURL="+o.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */");if(e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}.bind(null,n),o=function(){!function(e){e.parentNode.removeChild(e);var t=l.indexOf(e);t>=0&&l.splice(t,1)}(n)};return i(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;i(e=t)}else o()}}e.exports=function(e,t){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");void 0===(t=t||{}).singleton&&(t.singleton=o()),void 0===t.insertAt&&(t.insertAt="bottom");var i=c(e);return u(i,t),function(e){for(var o=[],r=0;r<i.length;r++){var a=i[r];(s=n[a.id]).refs--,o.push(s)}e&&u(c(e),t);for(r=0;r<o.length;r++){var s;if(0===(s=o[r]).refs){for(var l=0;l<s.parts.length;l++)s.parts[l]();delete n[s.id]}}}};var h,p=(h=[],function(e,t){return h[e]=t,h.filter(Boolean).join("\n")});function v(e,t,n,i){var o=n?"":i.css;if(e.styleSheet)e.styleSheet.cssText=p(t,o);else{var r=document.createTextNode(o),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(r,a[t]):e.appendChild(r)}}},function(e,t,n){var i=n(3);"string"==typeof i&&(i=[[e.i,i,""]]);n(8)(i,{});i.locals&&(e.exports=i.locals)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),o=n.n(i),r=n(12),a=n.n(r),s=n(1);t.default={extends:o.a,name:"AtTextarea",computed:{style:function(){if(this.atwho){var e=this.atwho,t=(e.list,e.cur,e.x),n=e.y,i=this.$refs.wrap,o=this.$el.querySelector("textarea");if(i)return{left:t+o.offsetLeft-o.scrollLeft+"px",top:n+o.offsetTop-o.scrollTop+"px"}}return null}},methods:{handleValueUpdate:function(e){var t=this.$el.querySelector("textarea");e!==t.value&&(t.value=e,this.dispatchInput())},dispatchInput:function(){var e=this.$el.querySelector("textarea"),t=new Event("input",{bubbles:!0});e.dispatchEvent(t)},handleDelete:function(e){var t=this.$el.querySelector("textarea"),i=t.value.slice(0,t.selectionEnd);if(i){var o=this.atItems,r=this.members,a=this.suffix,l=this.deleteMatch,u=this.itemName,c=n.i(s.a)(i,o),d=c.at,f=c.index;if(f>-1){var h=i.slice(f+d.length);r.some(function(e){var t=u(e);return l(t,h,a)})&&(t.value=t.value.slice(0,f)+t.value.slice(t.selectionEnd-1),t.selectionStart=f+1,t.selectionEnd=f+1,this.handleInput())}}},handleInput:function(e){if(!this.hasComposition){var t=this.$el.querySelector("textarea");this.$emit("input",t.value);var i=t.value.slice(0,t.selectionEnd);if(i){var o=this.atItems,r=this.avoidEmail,a=this.allowSpaces,l=!0,u=n.i(s.a)(i,o),c=u.at,d=u.index;d<0&&(l=!1);var f=i[d-1],h=i.slice(d+c.length,i.length);if(r&&/^[a-z0-9]$/i.test(f)&&(l=!1),!a&&/\s/.test(h)&&(l=!1),/^\s/.test(h)&&(l=!1),l){var p=this.members,v=this.filterMatch,m=this.itemName;e||this.$emit("at",h);var w=p.filter(function(e){var t=m(e);return v(t,h,c)});w.length?this.openPanel(w,h,d,c,e):this.closePanel()}else this.closePanel()}else this.closePanel()}},openPanel:function(e,t,n,i){var o=this,r=function(){var r=o.$el.querySelector("textarea"),s=n+i.length,l=a()(r,s);o.atwho={chunk:t,offset:n,list:e,atEnd:s,x:l.left,y:l.top-4,cur:0}};this.atwho?r():setTimeout(r,10)},insertText:function(e,t){var n=t.selectionStart,i=t.selectionEnd;t.value=t.value.slice(0,n)+e+t.value.slice(i);var o=n+e.length;t.selectionStart=o,t.selectionEnd=o,this.dispatchInput()},insertItem:function(){var e=this.atwho,t=(e.chunk,e.offset,e.list),i=e.cur,o=e.atEnd,r=this.suffix,a=this.atItems,l=this.itemName,u=this.$el.querySelector("textarea"),c=u.value.slice(0,o),d=n.i(s.a)(c,a),f=d.at,h=d.index+f.length;u.selectionStart=h,u.focus();var p=t[i],v=l(p)+r;this.insertText(v,u),this.$emit("insert",p),this.handleInput()}}}},function(e,t,n){var i=n(0)(n(10),null,null,null);e.exports=i.exports},function(e,t){e.exports=__webpack_require__("a0ec")}]);
//# sourceMappingURL=vue-at-textarea.js.map

/***/ }),

/***/ "541d":
/***/ (function(module) {

module.exports = JSON.parse("{\"locale\":\"en\",\"long\":{\"year\":{\"previous\":\"last year\",\"current\":\"this year\",\"next\":\"next year\",\"past\":{\"one\":\"{0} year ago\",\"other\":\"{0} years ago\"},\"future\":{\"one\":\"in {0} year\",\"other\":\"in {0} years\"}},\"quarter\":{\"previous\":\"last quarter\",\"current\":\"this quarter\",\"next\":\"next quarter\",\"past\":{\"one\":\"{0} quarter ago\",\"other\":\"{0} quarters ago\"},\"future\":{\"one\":\"in {0} quarter\",\"other\":\"in {0} quarters\"}},\"month\":{\"previous\":\"last month\",\"current\":\"this month\",\"next\":\"next month\",\"past\":{\"one\":\"{0} month ago\",\"other\":\"{0} months ago\"},\"future\":{\"one\":\"in {0} month\",\"other\":\"in {0} months\"}},\"week\":{\"previous\":\"last week\",\"current\":\"this week\",\"next\":\"next week\",\"past\":{\"one\":\"{0} week ago\",\"other\":\"{0} weeks ago\"},\"future\":{\"one\":\"in {0} week\",\"other\":\"in {0} weeks\"}},\"day\":{\"previous\":\"yesterday\",\"current\":\"today\",\"next\":\"tomorrow\",\"past\":{\"one\":\"{0} day ago\",\"other\":\"{0} days ago\"},\"future\":{\"one\":\"in {0} day\",\"other\":\"in {0} days\"}},\"hour\":{\"current\":\"this hour\",\"past\":{\"one\":\"{0} hour ago\",\"other\":\"{0} hours ago\"},\"future\":{\"one\":\"in {0} hour\",\"other\":\"in {0} hours\"}},\"minute\":{\"current\":\"this minute\",\"past\":{\"one\":\"{0} minute ago\",\"other\":\"{0} minutes ago\"},\"future\":{\"one\":\"in {0} minute\",\"other\":\"in {0} minutes\"}},\"second\":{\"current\":\"now\",\"past\":{\"one\":\"{0} second ago\",\"other\":\"{0} seconds ago\"},\"future\":{\"one\":\"in {0} second\",\"other\":\"in {0} seconds\"}}},\"short\":{\"year\":{\"previous\":\"last yr.\",\"current\":\"this yr.\",\"next\":\"next yr.\",\"past\":\"{0} yr. ago\",\"future\":\"in {0} yr.\"},\"quarter\":{\"previous\":\"last qtr.\",\"current\":\"this qtr.\",\"next\":\"next qtr.\",\"past\":{\"one\":\"{0} qtr. ago\",\"other\":\"{0} qtrs. ago\"},\"future\":{\"one\":\"in {0} qtr.\",\"other\":\"in {0} qtrs.\"}},\"month\":{\"previous\":\"last mo.\",\"current\":\"this mo.\",\"next\":\"next mo.\",\"past\":\"{0} mo. ago\",\"future\":\"in {0} mo.\"},\"week\":{\"previous\":\"last wk.\",\"current\":\"this wk.\",\"next\":\"next wk.\",\"past\":\"{0} wk. ago\",\"future\":\"in {0} wk.\"},\"day\":{\"previous\":\"yesterday\",\"current\":\"today\",\"next\":\"tomorrow\",\"past\":{\"one\":\"{0} day ago\",\"other\":\"{0} days ago\"},\"future\":{\"one\":\"in {0} day\",\"other\":\"in {0} days\"}},\"hour\":{\"current\":\"this hour\",\"past\":\"{0} hr. ago\",\"future\":\"in {0} hr.\"},\"minute\":{\"current\":\"this minute\",\"past\":\"{0} min. ago\",\"future\":\"in {0} min.\"},\"second\":{\"current\":\"now\",\"past\":\"{0} sec. ago\",\"future\":\"in {0} sec.\"}},\"narrow\":{\"year\":{\"previous\":\"last yr.\",\"current\":\"this yr.\",\"next\":\"next yr.\",\"past\":\"{0} yr. ago\",\"future\":\"in {0} yr.\"},\"quarter\":{\"previous\":\"last qtr.\",\"current\":\"this qtr.\",\"next\":\"next qtr.\",\"past\":{\"one\":\"{0} qtr. ago\",\"other\":\"{0} qtrs. ago\"},\"future\":{\"one\":\"in {0} qtr.\",\"other\":\"in {0} qtrs.\"}},\"month\":{\"previous\":\"last mo.\",\"current\":\"this mo.\",\"next\":\"next mo.\",\"past\":\"{0} mo. ago\",\"future\":\"in {0} mo.\"},\"week\":{\"previous\":\"last wk.\",\"current\":\"this wk.\",\"next\":\"next wk.\",\"past\":\"{0} wk. ago\",\"future\":\"in {0} wk.\"},\"day\":{\"previous\":\"yesterday\",\"current\":\"today\",\"next\":\"tomorrow\",\"past\":{\"one\":\"{0} day ago\",\"other\":\"{0} days ago\"},\"future\":{\"one\":\"in {0} day\",\"other\":\"in {0} days\"}},\"hour\":{\"current\":\"this hour\",\"past\":\"{0} hr. ago\",\"future\":\"in {0} hr.\"},\"minute\":{\"current\":\"this minute\",\"past\":\"{0} min. ago\",\"future\":\"in {0} min.\"},\"second\":{\"current\":\"now\",\"past\":\"{0} sec. ago\",\"future\":\"in {0} sec.\"}},\"short-time\":{\"year\":\"{0} yr.\",\"month\":\"{0} mo.\",\"week\":\"{0} wk.\",\"day\":{\"one\":\"{0} day\",\"other\":\"{0} days\"},\"hour\":\"{0} hr.\",\"minute\":\"{0} min.\",\"second\":\"{0} sec.\"},\"long-time\":{\"year\":{\"one\":\"{0} year\",\"other\":\"{0} years\"},\"month\":{\"one\":\"{0} month\",\"other\":\"{0} months\"},\"week\":{\"one\":\"{0} week\",\"other\":\"{0} weeks\"},\"day\":{\"one\":\"{0} day\",\"other\":\"{0} days\"},\"hour\":{\"one\":\"{0} hour\",\"other\":\"{0} hours\"},\"minute\":{\"one\":\"{0} minute\",\"other\":\"{0} minutes\"},\"second\":{\"one\":\"{0} second\",\"other\":\"{0} seconds\"}},\"now\":{\"now\":{\"current\":\"now\",\"future\":\"in a moment\",\"past\":\"just now\"}},\"tiny\":{\"year\":\"{0}yr\",\"month\":\"{0}mo\",\"week\":\"{0}wk\",\"day\":\"{0}d\",\"hour\":\"{0}h\",\"minute\":\"{0}m\",\"second\":\"{0}s\",\"now\":\"now\"},\"mini\":{\"year\":\"{0}yr\",\"month\":\"{0}mo\",\"week\":\"{0}wk\",\"day\":\"{0}d\",\"hour\":\"{0}h\",\"minute\":\"{0}m\",\"second\":\"{0}s\",\"now\":\"now\"}}");

/***/ }),

/***/ "55c9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.20.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2022 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "576c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var classof = __webpack_require__("f5df");

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var whitespaces = __webpack_require__("5899");

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5926":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),

/***/ "598a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isRegExp = __webpack_require__("44e7");

var TypeError = global.TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5aff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ "5b14":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
        ' '
    );
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ "5b81":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var isCallable = __webpack_require__("1626");
var isRegExp = __webpack_require__("44e7");
var toString = __webpack_require__("577e");
var getMethod = __webpack_require__("dc4a");
var regExpFlags = __webpack_require__("ad6d");
var getSubstitution = __webpack_require__("0cb2");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var REPLACE = wellKnownSymbol('replace');
var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;
var getFlags = uncurryThis(regExpFlags);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf(string, searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (searchValue != null) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = toString(requireObjectCoercible('flags' in RegExpPrototype
          ? searchValue.flags
          : getFlags(searchValue)
        ));
        if (!~indexOf(flags, 'g')) throw TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod(searchValue, REPLACE);
      if (replacer) {
        return call(replacer, searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return replace(toString(O), searchValue, replaceValue);
      }
    }
    string = toString(O);
    searchString = toString(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      replacement = functionalReplace
        ? toString(replaceValue(searchString, position, string))
        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += stringSlice(string, endOfLastMatch);
    }
    return result;
  }
});


/***/ }),

/***/ "5c3a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ "5c42":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5cbb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
            '_'
        ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ "5db7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var flattenIntoArray = __webpack_require__("a2bf");
var aCallable = __webpack_require__("59ed");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ "5e23":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "5f02":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ "5fbd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6061":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollImageAnswers_vue_vue_type_style_index_0_id_1462e326_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("91f7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollImageAnswers_vue_vue_type_style_index_0_id_1462e326_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollImageAnswers_vue_vue_type_style_index_0_id_1462e326_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6062":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("6d61");
var collectionStrong = __webpack_require__("6566");

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "6069":
/***/ (function(module, exports) {

module.exports = typeof window == 'object';


/***/ }),

/***/ "608c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var uncurryThis = __webpack_require__("e330");
var call = __webpack_require__("c65b");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "6117":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ "615b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "61d2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "6403":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ "6544":
/***/ (function(module, exports) {

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function installComponents (component, components) {
  var options = typeof component.exports === 'function'
    ? component.exports.extendOptions
    : component.options

  if (typeof component.exports === 'function') {
    options.components = component.exports.options.components
  }

  options.components = options.components || {}

  for (var i in components) {
    options.components[i] = options.components[i] || components[i]
  }
}


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "6566":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("9bf2").f;
var create = __webpack_require__("7c73");
var redefineAll = __webpack_require__("e2cc");
var bind = __webpack_require__("0366");
var anInstance = __webpack_require__("19aa");
var iterate = __webpack_require__("2266");
var defineIterator = __webpack_require__("7dd0");
var setSpecies = __webpack_require__("2626");
var DESCRIPTORS = __webpack_require__("83ab");
var fastKey = __webpack_require__("f183").fastKey;
var InternalStateModule = __webpack_require__("69f3");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(Prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "65db":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("0b42");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6784":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ "6887":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ "688b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
            '_'
        ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ "68ee":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("f5df");
var getBuiltIn = __webpack_require__("d066");
var inspectSource = __webpack_require__("8925");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "6909":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6ac9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserList_vue_vue_type_style_index_0_id_3d12ab11_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5c42");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserList_vue_vue_type_style_index_0_id_3d12ab11_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserList_vue_vue_type_style_index_0_id_3d12ab11_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6ce3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ "6d61":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var InternalMetadataModule = __webpack_require__("f183");
var iterate = __webpack_require__("2266");
var anInstance = __webpack_require__("19aa");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var fails = __webpack_require__("d039");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var setToStringTag = __webpack_require__("d44e");
var inheritIfRequired = __webpack_require__("7156");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "6d79":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ "6d83":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ "6e98":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ "6ece":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f12":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ "6f50":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var uncurryThis = __webpack_require__("e330");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var $propertyIsEnumerable = __webpack_require__("d1e7").f;

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "7118":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
            '_'
        );

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ "73d9":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("44d2");

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7435":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var hasOwn = __webpack_require__("1a2d");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "74d4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsMenu_vue_vue_type_style_index_0_id_c838e56a_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1565");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsMenu_vue_vue_type_style_index_0_id_c838e56a_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsMenu_vue_vue_type_style_index_0_id_c838e56a_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "74dc":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
            '_'
        ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "785a":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("cc12");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "7863":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7a77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "7aac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var requireObjectCoercible = __webpack_require__("1d80");

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7be6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
            '_'
        ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("825a");
var definePropertiesModule = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "7c96":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var IS_PURE = __webpack_require__("c430");
var FunctionName = __webpack_require__("5e77");
var isCallable = __webpack_require__("1626");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "7f33":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "8155":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__("7b0b");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "81e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
            ' '
        ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
            '_'
        ),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
            '_'
        ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ "820e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var iterate = __webpack_require__("2266");

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "8230":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "83b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("d925");
var combineURLs = __webpack_require__("e683");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("a04b");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "848b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__("4a0c");

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ "84aa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8689":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8840":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "898b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ "899c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8a79":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var un$EndsWith = uncurryThis(''.endsWith);
var slice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return un$EndsWith
      ? un$EndsWith(that, search, end)
      : slice(that, end - search.length, end) === search;
  }
});


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8afd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PinnedMessage_vue_vue_type_style_index_0_id_04c4f152_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9c9a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PinnedMessage_vue_vue_type_style_index_0_id_04c4f152_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PinnedMessage_vue_vue_type_style_index_0_id_04c4f152_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8ce9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8d47":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
            '_'
        ),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
            '_'
        ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ "8d4f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8d57":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
            '_'
        ),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
            '_'
        ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
            '_'
        ),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ "8df4b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("7a77");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "8e73":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ "8efc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8f14":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// HumanizeDuration.js - https://git.io/j0HgmQ

/* global define, module */

(function () {
  // This has to be defined separately because of a bug: we want to alias
  // `gr` and `el` for backwards-compatiblity. In a breaking change, we can
  // remove `gr` entirely.
  // See https://github.com/EvanHahn/HumanizeDuration.js/issues/143 for more.
  var greek = {
    y: function (c) {
      return c === 1 ? "χρόνος" : "χρόνια";
    },
    mo: function (c) {
      return c === 1 ? "μήνας" : "μήνες";
    },
    w: function (c) {
      return c === 1 ? "εβδομάδα" : "εβδομάδες";
    },
    d: function (c) {
      return c === 1 ? "μέρα" : "μέρες";
    },
    h: function (c) {
      return c === 1 ? "ώρα" : "ώρες";
    },
    m: function (c) {
      return c === 1 ? "λεπτό" : "λεπτά";
    },
    s: function (c) {
      return c === 1 ? "δευτερόλεπτο" : "δευτερόλεπτα";
    },
    ms: function (c) {
      return c === 1
        ? "χιλιοστό του δευτερολέπτου"
        : "χιλιοστά του δευτερολέπτου";
    },
    decimal: ","
  };

  var ARABIC_DIGITS = ["۰", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

  var LANGUAGES = {
    af: {
      y: "jaar",
      mo: function (c) {
        return "maand" + (c === 1 ? "" : "e");
      },
      w: function (c) {
        return c === 1 ? "week" : "weke";
      },
      d: function (c) {
        return c === 1 ? "dag" : "dae";
      },
      h: function (c) {
        return c === 1 ? "uur" : "ure";
      },
      m: function (c) {
        return c === 1 ? "minuut" : "minute";
      },
      s: function (c) {
        return "sekonde" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "millisekonde" + (c === 1 ? "" : "s");
      },
      decimal: ","
    },
    ar: {
      y: function (c) {
        return ["سنة", "سنتان", "سنوات"][getArabicForm(c)];
      },
      mo: function (c) {
        return ["شهر", "شهران", "أشهر"][getArabicForm(c)];
      },
      w: function (c) {
        return ["أسبوع", "أسبوعين", "أسابيع"][getArabicForm(c)];
      },
      d: function (c) {
        return ["يوم", "يومين", "أيام"][getArabicForm(c)];
      },
      h: function (c) {
        return ["ساعة", "ساعتين", "ساعات"][getArabicForm(c)];
      },
      m: function (c) {
        return ["دقيقة", "دقيقتان", "دقائق"][getArabicForm(c)];
      },
      s: function (c) {
        return ["ثانية", "ثانيتان", "ثواني"][getArabicForm(c)];
      },
      ms: function (c) {
        return ["جزء من الثانية", "جزآن من الثانية", "أجزاء من الثانية"][
          getArabicForm(c)
        ];
      },
      decimal: ",",
      delimiter: " و ",
      _formatCount: function (count, decimal) {
        var replacements = assign(ARABIC_DIGITS, { ".": decimal });
        var characters = count.toString().split("");
        for (var i = 0; i < characters.length; i++) {
          var character = characters[i];
          if (has(replacements, character)) {
            characters[i] = replacements[character];
          }
        }
        return characters.join("");
      }
    },
    bg: {
      y: function (c) {
        return ["години", "година", "години"][getSlavicForm(c)];
      },
      mo: function (c) {
        return ["месеца", "месец", "месеца"][getSlavicForm(c)];
      },
      w: function (c) {
        return ["седмици", "седмица", "седмици"][getSlavicForm(c)];
      },
      d: function (c) {
        return ["дни", "ден", "дни"][getSlavicForm(c)];
      },
      h: function (c) {
        return ["часа", "час", "часа"][getSlavicForm(c)];
      },
      m: function (c) {
        return ["минути", "минута", "минути"][getSlavicForm(c)];
      },
      s: function (c) {
        return ["секунди", "секунда", "секунди"][getSlavicForm(c)];
      },
      ms: function (c) {
        return ["милисекунди", "милисекунда", "милисекунди"][getSlavicForm(c)];
      },
      decimal: ","
    },
    bn: {
      y: "বছর",
      mo: "মাস",
      w: "সপ্তাহ",
      d: "দিন",
      h: "ঘন্টা",
      m: "মিনিট",
      s: "সেকেন্ড",
      ms: "মিলিসেকেন্ড"
    },
    ca: {
      y: function (c) {
        return "any" + (c === 1 ? "" : "s");
      },
      mo: function (c) {
        return "mes" + (c === 1 ? "" : "os");
      },
      w: function (c) {
        return "setman" + (c === 1 ? "a" : "es");
      },
      d: function (c) {
        return "di" + (c === 1 ? "a" : "es");
      },
      h: function (c) {
        return "hor" + (c === 1 ? "a" : "es");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "" : "s");
      },
      s: function (c) {
        return "segon" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "milisegon" + (c === 1 ? "" : "s");
      },
      decimal: ","
    },
    cs: {
      y: function (c) {
        return ["rok", "roku", "roky", "let"][getCzechOrSlovakForm(c)];
      },
      mo: function (c) {
        return ["měsíc", "měsíce", "měsíce", "měsíců"][getCzechOrSlovakForm(c)];
      },
      w: function (c) {
        return ["týden", "týdne", "týdny", "týdnů"][getCzechOrSlovakForm(c)];
      },
      d: function (c) {
        return ["den", "dne", "dny", "dní"][getCzechOrSlovakForm(c)];
      },
      h: function (c) {
        return ["hodina", "hodiny", "hodiny", "hodin"][getCzechOrSlovakForm(c)];
      },
      m: function (c) {
        return ["minuta", "minuty", "minuty", "minut"][getCzechOrSlovakForm(c)];
      },
      s: function (c) {
        return ["sekunda", "sekundy", "sekundy", "sekund"][
          getCzechOrSlovakForm(c)
        ];
      },
      ms: function (c) {
        return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][
          getCzechOrSlovakForm(c)
        ];
      },
      decimal: ","
    },
    cy: {
      y: "flwyddyn",
      mo: "mis",
      w: "wythnos",
      d: "diwrnod",
      h: "awr",
      m: "munud",
      s: "eiliad",
      ms: "milieiliad"
    },
    da: {
      y: "år",
      mo: function (c) {
        return "måned" + (c === 1 ? "" : "er");
      },
      w: function (c) {
        return "uge" + (c === 1 ? "" : "r");
      },
      d: function (c) {
        return "dag" + (c === 1 ? "" : "e");
      },
      h: function (c) {
        return "time" + (c === 1 ? "" : "r");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "" : "ter");
      },
      s: function (c) {
        return "sekund" + (c === 1 ? "" : "er");
      },
      ms: function (c) {
        return "millisekund" + (c === 1 ? "" : "er");
      },
      decimal: ","
    },
    de: {
      y: function (c) {
        return "Jahr" + (c === 1 ? "" : "e");
      },
      mo: function (c) {
        return "Monat" + (c === 1 ? "" : "e");
      },
      w: function (c) {
        return "Woche" + (c === 1 ? "" : "n");
      },
      d: function (c) {
        return "Tag" + (c === 1 ? "" : "e");
      },
      h: function (c) {
        return "Stunde" + (c === 1 ? "" : "n");
      },
      m: function (c) {
        return "Minute" + (c === 1 ? "" : "n");
      },
      s: function (c) {
        return "Sekunde" + (c === 1 ? "" : "n");
      },
      ms: function (c) {
        return "Millisekunde" + (c === 1 ? "" : "n");
      },
      decimal: ","
    },
    el: greek,
    en: {
      y: function (c) {
        return "year" + (c === 1 ? "" : "s");
      },
      mo: function (c) {
        return "month" + (c === 1 ? "" : "s");
      },
      w: function (c) {
        return "week" + (c === 1 ? "" : "s");
      },
      d: function (c) {
        return "day" + (c === 1 ? "" : "s");
      },
      h: function (c) {
        return "hour" + (c === 1 ? "" : "s");
      },
      m: function (c) {
        return "minute" + (c === 1 ? "" : "s");
      },
      s: function (c) {
        return "second" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "millisecond" + (c === 1 ? "" : "s");
      },
      decimal: "."
    },
    eo: {
      y: function (c) {
        return "jaro" + (c === 1 ? "" : "j");
      },
      mo: function (c) {
        return "monato" + (c === 1 ? "" : "j");
      },
      w: function (c) {
        return "semajno" + (c === 1 ? "" : "j");
      },
      d: function (c) {
        return "tago" + (c === 1 ? "" : "j");
      },
      h: function (c) {
        return "horo" + (c === 1 ? "" : "j");
      },
      m: function (c) {
        return "minuto" + (c === 1 ? "" : "j");
      },
      s: function (c) {
        return "sekundo" + (c === 1 ? "" : "j");
      },
      ms: function (c) {
        return "milisekundo" + (c === 1 ? "" : "j");
      },
      decimal: ","
    },
    es: {
      y: function (c) {
        return "año" + (c === 1 ? "" : "s");
      },
      mo: function (c) {
        return "mes" + (c === 1 ? "" : "es");
      },
      w: function (c) {
        return "semana" + (c === 1 ? "" : "s");
      },
      d: function (c) {
        return "día" + (c === 1 ? "" : "s");
      },
      h: function (c) {
        return "hora" + (c === 1 ? "" : "s");
      },
      m: function (c) {
        return "minuto" + (c === 1 ? "" : "s");
      },
      s: function (c) {
        return "segundo" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "milisegundo" + (c === 1 ? "" : "s");
      },
      decimal: ","
    },
    et: {
      y: function (c) {
        return "aasta" + (c === 1 ? "" : "t");
      },
      mo: function (c) {
        return "kuu" + (c === 1 ? "" : "d");
      },
      w: function (c) {
        return "nädal" + (c === 1 ? "" : "at");
      },
      d: function (c) {
        return "päev" + (c === 1 ? "" : "a");
      },
      h: function (c) {
        return "tund" + (c === 1 ? "" : "i");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "" : "it");
      },
      s: function (c) {
        return "sekund" + (c === 1 ? "" : "it");
      },
      ms: function (c) {
        return "millisekund" + (c === 1 ? "" : "it");
      },
      decimal: ","
    },
    eu: {
      y: "urte",
      mo: "hilabete",
      w: "aste",
      d: "egun",
      h: "ordu",
      m: "minutu",
      s: "segundo",
      ms: "milisegundo",
      decimal: ","
    },
    fa: {
      y: "سال",
      mo: "ماه",
      w: "هفته",
      d: "روز",
      h: "ساعت",
      m: "دقیقه",
      s: "ثانیه",
      ms: "میلی ثانیه",
      decimal: "."
    },
    fi: {
      y: function (c) {
        return c === 1 ? "vuosi" : "vuotta";
      },
      mo: function (c) {
        return c === 1 ? "kuukausi" : "kuukautta";
      },
      w: function (c) {
        return "viikko" + (c === 1 ? "" : "a");
      },
      d: function (c) {
        return "päivä" + (c === 1 ? "" : "ä");
      },
      h: function (c) {
        return "tunti" + (c === 1 ? "" : "a");
      },
      m: function (c) {
        return "minuutti" + (c === 1 ? "" : "a");
      },
      s: function (c) {
        return "sekunti" + (c === 1 ? "" : "a");
      },
      ms: function (c) {
        return "millisekunti" + (c === 1 ? "" : "a");
      },
      decimal: ","
    },
    fo: {
      y: "ár",
      mo: function (c) {
        return c === 1 ? "mánaður" : "mánaðir";
      },
      w: function (c) {
        return c === 1 ? "vika" : "vikur";
      },
      d: function (c) {
        return c === 1 ? "dagur" : "dagar";
      },
      h: function (c) {
        return c === 1 ? "tími" : "tímar";
      },
      m: function (c) {
        return c === 1 ? "minuttur" : "minuttir";
      },
      s: "sekund",
      ms: "millisekund",
      decimal: ","
    },
    fr: {
      y: function (c) {
        return "an" + (c >= 2 ? "s" : "");
      },
      mo: "mois",
      w: function (c) {
        return "semaine" + (c >= 2 ? "s" : "");
      },
      d: function (c) {
        return "jour" + (c >= 2 ? "s" : "");
      },
      h: function (c) {
        return "heure" + (c >= 2 ? "s" : "");
      },
      m: function (c) {
        return "minute" + (c >= 2 ? "s" : "");
      },
      s: function (c) {
        return "seconde" + (c >= 2 ? "s" : "");
      },
      ms: function (c) {
        return "milliseconde" + (c >= 2 ? "s" : "");
      },
      decimal: ","
    },
    gr: greek,
    he: {
      y: function (c) {
        return c === 1 ? "שנה" : "שנים";
      },
      mo: function (c) {
        return c === 1 ? "חודש" : "חודשים";
      },
      w: function (c) {
        return c === 1 ? "שבוע" : "שבועות";
      },
      d: function (c) {
        return c === 1 ? "יום" : "ימים";
      },
      h: function (c) {
        return c === 1 ? "שעה" : "שעות";
      },
      m: function (c) {
        return c === 1 ? "דקה" : "דקות";
      },
      s: function (c) {
        return c === 1 ? "שניה" : "שניות";
      },
      ms: function (c) {
        return c === 1 ? "מילישנייה" : "מילישניות";
      },
      decimal: "."
    },
    hr: {
      y: function (c) {
        if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return "godine";
        }
        return "godina";
      },
      mo: function (c) {
        if (c === 1) {
          return "mjesec";
        } else if (c === 2 || c === 3 || c === 4) {
          return "mjeseca";
        }
        return "mjeseci";
      },
      w: function (c) {
        if (c % 10 === 1 && c !== 11) {
          return "tjedan";
        }
        return "tjedna";
      },
      d: function (c) {
        return c === 1 ? "dan" : "dana";
      },
      h: function (c) {
        if (c === 1) {
          return "sat";
        } else if (c === 2 || c === 3 || c === 4) {
          return "sata";
        }
        return "sati";
      },
      m: function (c) {
        var mod10 = c % 10;
        if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) {
          return "minute";
        }
        return "minuta";
      },
      s: function (c) {
        var mod10 = c % 10;
        if (mod10 === 5 || (Math.floor(c) === c && c >= 10 && c <= 19)) {
          return "sekundi";
        } else if (mod10 === 1) {
          return "sekunda";
        } else if (mod10 === 2 || mod10 === 3 || mod10 === 4) {
          return "sekunde";
        }
        return "sekundi";
      },
      ms: function (c) {
        if (c === 1) {
          return "milisekunda";
        } else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return "milisekunde";
        }
        return "milisekundi";
      },
      decimal: ","
    },
    hi: {
      y: "साल",
      mo: function (c) {
        return c === 1 ? "महीना" : "महीने";
      },
      w: function (c) {
        return c === 1 ? "हफ़्ता" : "हफ्ते";
      },
      d: "दिन",
      h: function (c) {
        return c === 1 ? "घंटा" : "घंटे";
      },
      m: "मिनट",
      s: "सेकंड",
      ms: "मिलीसेकंड",
      decimal: "."
    },
    hu: {
      y: "év",
      mo: "hónap",
      w: "hét",
      d: "nap",
      h: "óra",
      m: "perc",
      s: "másodperc",
      ms: "ezredmásodperc",
      decimal: ","
    },
    id: {
      y: "tahun",
      mo: "bulan",
      w: "minggu",
      d: "hari",
      h: "jam",
      m: "menit",
      s: "detik",
      ms: "milidetik",
      decimal: "."
    },
    is: {
      y: "ár",
      mo: function (c) {
        return "mánuð" + (c === 1 ? "ur" : "ir");
      },
      w: function (c) {
        return "vik" + (c === 1 ? "a" : "ur");
      },
      d: function (c) {
        return "dag" + (c === 1 ? "ur" : "ar");
      },
      h: function (c) {
        return "klukkutím" + (c === 1 ? "i" : "ar");
      },
      m: function (c) {
        return "mínút" + (c === 1 ? "a" : "ur");
      },
      s: function (c) {
        return "sekúnd" + (c === 1 ? "a" : "ur");
      },
      ms: function (c) {
        return "millisekúnd" + (c === 1 ? "a" : "ur");
      },
      decimal: "."
    },
    it: {
      y: function (c) {
        return "ann" + (c === 1 ? "o" : "i");
      },
      mo: function (c) {
        return "mes" + (c === 1 ? "e" : "i");
      },
      w: function (c) {
        return "settiman" + (c === 1 ? "a" : "e");
      },
      d: function (c) {
        return "giorn" + (c === 1 ? "o" : "i");
      },
      h: function (c) {
        return "or" + (c === 1 ? "a" : "e");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "o" : "i");
      },
      s: function (c) {
        return "second" + (c === 1 ? "o" : "i");
      },
      ms: function (c) {
        return "millisecond" + (c === 1 ? "o" : "i");
      },
      decimal: ","
    },
    ja: {
      y: "年",
      mo: "ヶ月",
      w: "週",
      d: "日",
      h: "時間",
      m: "分",
      s: "秒",
      ms: "ミリ秒",
      decimal: "."
    },
    km: {
      y: "ឆ្នាំ",
      mo: "ខែ",
      w: "សប្តាហ៍",
      d: "ថ្ងៃ",
      h: "ម៉ោង",
      m: "នាទី",
      s: "វិនាទី",
      ms: "មិល្លីវិនាទី"
    },
    kn: {
      y: function (c) {
        return c === 1 ? "ವರ್ಷ" : "ವರ್ಷಗಳು";
      },
      mo: function (c) {
        return c === 1 ? "ತಿಂಗಳು" : "ತಿಂಗಳುಗಳು";
      },
      w: function (c) {
        return c === 1 ? "ವಾರ" : "ವಾರಗಳು";
      },
      d: function (c) {
        return c === 1 ? "ದಿನ" : "ದಿನಗಳು";
      },
      h: function (c) {
        return c === 1 ? "ಗಂಟೆ" : "ಗಂಟೆಗಳು";
      },
      m: function (c) {
        return c === 1 ? "ನಿಮಿಷ" : "ನಿಮಿಷಗಳು";
      },
      s: function (c) {
        return c === 1 ? "ಸೆಕೆಂಡ್" : "ಸೆಕೆಂಡುಗಳು";
      },
      ms: function (c) {
        return c === 1 ? "ಮಿಲಿಸೆಕೆಂಡ್" : "ಮಿಲಿಸೆಕೆಂಡುಗಳು";
      }
    },
    ko: {
      y: "년",
      mo: "개월",
      w: "주일",
      d: "일",
      h: "시간",
      m: "분",
      s: "초",
      ms: "밀리 초",
      decimal: "."
    },
    ku: {
      y: "sal",
      mo: "meh",
      w: "hefte",
      d: "roj",
      h: "seet",
      m: "deqe",
      s: "saniye",
      ms: "mîlîçirk",
      decimal: ","
    },
    lo: {
      y: "ປີ",
      mo: "ເດືອນ",
      w: "ອາທິດ",
      d: "ມື້",
      h: "ຊົ່ວໂມງ",
      m: "ນາທີ",
      s: "ວິນາທີ",
      ms: "ມິນລິວິນາທີ",
      decimal: ","
    },
    lt: {
      y: function (c) {
        return c % 10 === 0 || (c % 100 >= 10 && c % 100 <= 20)
          ? "metų"
          : "metai";
      },
      mo: function (c) {
        return ["mėnuo", "mėnesiai", "mėnesių"][getLithuanianForm(c)];
      },
      w: function (c) {
        return ["savaitė", "savaitės", "savaičių"][getLithuanianForm(c)];
      },
      d: function (c) {
        return ["diena", "dienos", "dienų"][getLithuanianForm(c)];
      },
      h: function (c) {
        return ["valanda", "valandos", "valandų"][getLithuanianForm(c)];
      },
      m: function (c) {
        return ["minutė", "minutės", "minučių"][getLithuanianForm(c)];
      },
      s: function (c) {
        return ["sekundė", "sekundės", "sekundžių"][getLithuanianForm(c)];
      },
      ms: function (c) {
        return ["milisekundė", "milisekundės", "milisekundžių"][
          getLithuanianForm(c)
        ];
      },
      decimal: ","
    },
    lv: {
      y: function (c) {
        return getLatvianForm(c) ? "gads" : "gadi";
      },
      mo: function (c) {
        return getLatvianForm(c) ? "mēnesis" : "mēneši";
      },
      w: function (c) {
        return getLatvianForm(c) ? "nedēļa" : "nedēļas";
      },
      d: function (c) {
        return getLatvianForm(c) ? "diena" : "dienas";
      },
      h: function (c) {
        return getLatvianForm(c) ? "stunda" : "stundas";
      },
      m: function (c) {
        return getLatvianForm(c) ? "minūte" : "minūtes";
      },
      s: function (c) {
        return getLatvianForm(c) ? "sekunde" : "sekundes";
      },
      ms: function (c) {
        return getLatvianForm(c) ? "milisekunde" : "milisekundes";
      },
      decimal: ","
    },
    mk: {
      y: function (c) {
        return c === 1 ? "година" : "години";
      },
      mo: function (c) {
        return c === 1 ? "месец" : "месеци";
      },
      w: function (c) {
        return c === 1 ? "недела" : "недели";
      },
      d: function (c) {
        return c === 1 ? "ден" : "дена";
      },
      h: function (c) {
        return c === 1 ? "час" : "часа";
      },
      m: function (c) {
        return c === 1 ? "минута" : "минути";
      },
      s: function (c) {
        return c === 1 ? "секунда" : "секунди";
      },
      ms: function (c) {
        return c === 1 ? "милисекунда" : "милисекунди";
      },
      decimal: ","
    },
    mr: {
      y: function (c) {
        return c === 1 ? "वर्ष" : "वर्षे";
      },
      mo: function (c) {
        return c === 1 ? "महिना" : "महिने";
      },
      w: function (c) {
        return c === 1 ? "आठवडा" : "आठवडे";
      },
      d: "दिवस",
      h: "तास",
      m: function (c) {
        return c === 1 ? "मिनिट" : "मिनिटे";
      },
      s: "सेकंद",
      ms: "मिलिसेकंद"
    },
    ms: {
      y: "tahun",
      mo: "bulan",
      w: "minggu",
      d: "hari",
      h: "jam",
      m: "minit",
      s: "saat",
      ms: "milisaat",
      decimal: "."
    },
    nl: {
      y: "jaar",
      mo: function (c) {
        return c === 1 ? "maand" : "maanden";
      },
      w: function (c) {
        return c === 1 ? "week" : "weken";
      },
      d: function (c) {
        return c === 1 ? "dag" : "dagen";
      },
      h: "uur",
      m: function (c) {
        return c === 1 ? "minuut" : "minuten";
      },
      s: function (c) {
        return c === 1 ? "seconde" : "seconden";
      },
      ms: function (c) {
        return c === 1 ? "milliseconde" : "milliseconden";
      },
      decimal: ","
    },
    no: {
      y: "år",
      mo: function (c) {
        return "måned" + (c === 1 ? "" : "er");
      },
      w: function (c) {
        return "uke" + (c === 1 ? "" : "r");
      },
      d: function (c) {
        return "dag" + (c === 1 ? "" : "er");
      },
      h: function (c) {
        return "time" + (c === 1 ? "" : "r");
      },
      m: function (c) {
        return "minutt" + (c === 1 ? "" : "er");
      },
      s: function (c) {
        return "sekund" + (c === 1 ? "" : "er");
      },
      ms: function (c) {
        return "millisekund" + (c === 1 ? "" : "er");
      },
      decimal: ","
    },
    pl: {
      y: function (c) {
        return ["rok", "roku", "lata", "lat"][getPolishForm(c)];
      },
      mo: function (c) {
        return ["miesiąc", "miesiąca", "miesiące", "miesięcy"][
          getPolishForm(c)
        ];
      },
      w: function (c) {
        return ["tydzień", "tygodnia", "tygodnie", "tygodni"][getPolishForm(c)];
      },
      d: function (c) {
        return ["dzień", "dnia", "dni", "dni"][getPolishForm(c)];
      },
      h: function (c) {
        return ["godzina", "godziny", "godziny", "godzin"][getPolishForm(c)];
      },
      m: function (c) {
        return ["minuta", "minuty", "minuty", "minut"][getPolishForm(c)];
      },
      s: function (c) {
        return ["sekunda", "sekundy", "sekundy", "sekund"][getPolishForm(c)];
      },
      ms: function (c) {
        return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][
          getPolishForm(c)
        ];
      },
      decimal: ","
    },
    pt: {
      y: function (c) {
        return "ano" + (c === 1 ? "" : "s");
      },
      mo: function (c) {
        return c === 1 ? "mês" : "meses";
      },
      w: function (c) {
        return "semana" + (c === 1 ? "" : "s");
      },
      d: function (c) {
        return "dia" + (c === 1 ? "" : "s");
      },
      h: function (c) {
        return "hora" + (c === 1 ? "" : "s");
      },
      m: function (c) {
        return "minuto" + (c === 1 ? "" : "s");
      },
      s: function (c) {
        return "segundo" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "milissegundo" + (c === 1 ? "" : "s");
      },
      decimal: ","
    },
    ro: {
      y: function (c) {
        return c === 1 ? "an" : "ani";
      },
      mo: function (c) {
        return c === 1 ? "lună" : "luni";
      },
      w: function (c) {
        return c === 1 ? "săptămână" : "săptămâni";
      },
      d: function (c) {
        return c === 1 ? "zi" : "zile";
      },
      h: function (c) {
        return c === 1 ? "oră" : "ore";
      },
      m: function (c) {
        return c === 1 ? "minut" : "minute";
      },
      s: function (c) {
        return c === 1 ? "secundă" : "secunde";
      },
      ms: function (c) {
        return c === 1 ? "milisecundă" : "milisecunde";
      },
      decimal: ","
    },
    ru: {
      y: function (c) {
        return ["лет", "год", "года"][getSlavicForm(c)];
      },
      mo: function (c) {
        return ["месяцев", "месяц", "месяца"][getSlavicForm(c)];
      },
      w: function (c) {
        return ["недель", "неделя", "недели"][getSlavicForm(c)];
      },
      d: function (c) {
        return ["дней", "день", "дня"][getSlavicForm(c)];
      },
      h: function (c) {
        return ["часов", "час", "часа"][getSlavicForm(c)];
      },
      m: function (c) {
        return ["минут", "минута", "минуты"][getSlavicForm(c)];
      },
      s: function (c) {
        return ["секунд", "секунда", "секунды"][getSlavicForm(c)];
      },
      ms: function (c) {
        return ["миллисекунд", "миллисекунда", "миллисекунды"][
          getSlavicForm(c)
        ];
      },
      decimal: ","
    },
    sq: {
      y: function (c) {
        return c === 1 ? "vit" : "vjet";
      },
      mo: "muaj",
      w: "javë",
      d: "ditë",
      h: "orë",
      m: function (c) {
        return "minut" + (c === 1 ? "ë" : "a");
      },
      s: function (c) {
        return "sekond" + (c === 1 ? "ë" : "a");
      },
      ms: function (c) {
        return "milisekond" + (c === 1 ? "ë" : "a");
      },
      decimal: ","
    },
    sr: {
      y: function (c) {
        return ["години", "година", "године"][getSlavicForm(c)];
      },
      mo: function (c) {
        return ["месеци", "месец", "месеца"][getSlavicForm(c)];
      },
      w: function (c) {
        return ["недељи", "недеља", "недеље"][getSlavicForm(c)];
      },
      d: function (c) {
        return ["дани", "дан", "дана"][getSlavicForm(c)];
      },
      h: function (c) {
        return ["сати", "сат", "сата"][getSlavicForm(c)];
      },
      m: function (c) {
        return ["минута", "минут", "минута"][getSlavicForm(c)];
      },
      s: function (c) {
        return ["секунди", "секунда", "секунде"][getSlavicForm(c)];
      },
      ms: function (c) {
        return ["милисекунди", "милисекунда", "милисекунде"][getSlavicForm(c)];
      },
      decimal: ","
    },
    ta: {
      y: function (c) {
        return c === 1 ? "வருடம்" : "ஆண்டுகள்";
      },
      mo: function (c) {
        return c === 1 ? "மாதம்" : "மாதங்கள்";
      },
      w: function (c) {
        return c === 1 ? "வாரம்" : "வாரங்கள்";
      },
      d: function (c) {
        return c === 1 ? "நாள்" : "நாட்கள்";
      },
      h: function (c) {
        return c === 1 ? "மணி" : "மணிநேரம்";
      },
      m: function (c) {
        return "நிமிட" + (c === 1 ? "ம்" : "ங்கள்");
      },
      s: function (c) {
        return "வினாடி" + (c === 1 ? "" : "கள்");
      },
      ms: function (c) {
        return "மில்லி விநாடி" + (c === 1 ? "" : "கள்");
      }
    },
    te: {
      y: function (c) {
        return "సంవత్స" + (c === 1 ? "రం" : "రాల");
      },
      mo: function (c) {
        return "నెల" + (c === 1 ? "" : "ల");
      },
      w: function (c) {
        return c === 1 ? "వారం" : "వారాలు";
      },
      d: function (c) {
        return "రోజు" + (c === 1 ? "" : "లు");
      },
      h: function (c) {
        return "గంట" + (c === 1 ? "" : "లు");
      },
      m: function (c) {
        return c === 1 ? "నిమిషం" : "నిమిషాలు";
      },
      s: function (c) {
        return c === 1 ? "సెకను" : "సెకన్లు";
      },
      ms: function (c) {
        return c === 1 ? "మిల్లీసెకన్" : "మిల్లీసెకన్లు";
      }
    },
    uk: {
      y: function (c) {
        return ["років", "рік", "роки"][getSlavicForm(c)];
      },
      mo: function (c) {
        return ["місяців", "місяць", "місяці"][getSlavicForm(c)];
      },
      w: function (c) {
        return ["тижнів", "тиждень", "тижні"][getSlavicForm(c)];
      },
      d: function (c) {
        return ["днів", "день", "дні"][getSlavicForm(c)];
      },
      h: function (c) {
        return ["годин", "година", "години"][getSlavicForm(c)];
      },
      m: function (c) {
        return ["хвилин", "хвилина", "хвилини"][getSlavicForm(c)];
      },
      s: function (c) {
        return ["секунд", "секунда", "секунди"][getSlavicForm(c)];
      },
      ms: function (c) {
        return ["мілісекунд", "мілісекунда", "мілісекунди"][getSlavicForm(c)];
      },
      decimal: ","
    },
    ur: {
      y: "سال",
      mo: function (c) {
        return c === 1 ? "مہینہ" : "مہینے";
      },
      w: function (c) {
        return c === 1 ? "ہفتہ" : "ہفتے";
      },
      d: "دن",
      h: function (c) {
        return c === 1 ? "گھنٹہ" : "گھنٹے";
      },
      m: "منٹ",
      s: "سیکنڈ",
      ms: "ملی سیکنڈ",
      decimal: "."
    },
    sk: {
      y: function (c) {
        return ["rok", "roky", "roky", "rokov"][getCzechOrSlovakForm(c)];
      },
      mo: function (c) {
        return ["mesiac", "mesiace", "mesiace", "mesiacov"][
          getCzechOrSlovakForm(c)
        ];
      },
      w: function (c) {
        return ["týždeň", "týždne", "týždne", "týždňov"][
          getCzechOrSlovakForm(c)
        ];
      },
      d: function (c) {
        return ["deň", "dni", "dni", "dní"][getCzechOrSlovakForm(c)];
      },
      h: function (c) {
        return ["hodina", "hodiny", "hodiny", "hodín"][getCzechOrSlovakForm(c)];
      },
      m: function (c) {
        return ["minúta", "minúty", "minúty", "minút"][getCzechOrSlovakForm(c)];
      },
      s: function (c) {
        return ["sekunda", "sekundy", "sekundy", "sekúnd"][
          getCzechOrSlovakForm(c)
        ];
      },
      ms: function (c) {
        return ["milisekunda", "milisekundy", "milisekundy", "milisekúnd"][
          getCzechOrSlovakForm(c)
        ];
      },
      decimal: ","
    },
    sl: {
      y: function (c) {
        if (c % 10 === 1) {
          return "leto";
        } else if (c % 100 === 2) {
          return "leti";
        } else if (
          c % 100 === 3 ||
          c % 100 === 4 ||
          (Math.floor(c) !== c && c % 100 <= 5)
        ) {
          return "leta";
        } else {
          return "let";
        }
      },
      mo: function (c) {
        if (c % 10 === 1) {
          return "mesec";
        } else if (c % 100 === 2 || (Math.floor(c) !== c && c % 100 <= 5)) {
          return "meseca";
        } else if (c % 10 === 3 || c % 10 === 4) {
          return "mesece";
        } else {
          return "mesecev";
        }
      },
      w: function (c) {
        if (c % 10 === 1) {
          return "teden";
        } else if (c % 10 === 2 || (Math.floor(c) !== c && c % 100 <= 4)) {
          return "tedna";
        } else if (c % 10 === 3 || c % 10 === 4) {
          return "tedne";
        } else {
          return "tednov";
        }
      },
      d: function (c) {
        return c % 100 === 1 ? "dan" : "dni";
      },
      h: function (c) {
        if (c % 10 === 1) {
          return "ura";
        } else if (c % 100 === 2) {
          return "uri";
        } else if (c % 10 === 3 || c % 10 === 4 || Math.floor(c) !== c) {
          return "ure";
        } else {
          return "ur";
        }
      },
      m: function (c) {
        if (c % 10 === 1) {
          return "minuta";
        } else if (c % 10 === 2) {
          return "minuti";
        } else if (
          c % 10 === 3 ||
          c % 10 === 4 ||
          (Math.floor(c) !== c && c % 100 <= 4)
        ) {
          return "minute";
        } else {
          return "minut";
        }
      },
      s: function (c) {
        if (c % 10 === 1) {
          return "sekunda";
        } else if (c % 100 === 2) {
          return "sekundi";
        } else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) {
          return "sekunde";
        } else {
          return "sekund";
        }
      },
      ms: function (c) {
        if (c % 10 === 1) {
          return "milisekunda";
        } else if (c % 100 === 2) {
          return "milisekundi";
        } else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) {
          return "milisekunde";
        } else {
          return "milisekund";
        }
      },
      decimal: ","
    },
    sv: {
      y: "år",
      mo: function (c) {
        return "månad" + (c === 1 ? "" : "er");
      },
      w: function (c) {
        return "veck" + (c === 1 ? "a" : "or");
      },
      d: function (c) {
        return "dag" + (c === 1 ? "" : "ar");
      },
      h: function (c) {
        return "timm" + (c === 1 ? "e" : "ar");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "" : "er");
      },
      s: function (c) {
        return "sekund" + (c === 1 ? "" : "er");
      },
      ms: function (c) {
        return "millisekund" + (c === 1 ? "" : "er");
      },
      decimal: ","
    },
    sw: {
      y: function (c) {
        return c === 1 ? "mwaka" : "miaka";
      },
      mo: function (c) {
        return c === 1 ? "mwezi" : "miezi";
      },
      w: "wiki",
      d: function (c) {
        return c === 1 ? "siku" : "masiku";
      },
      h: function (c) {
        return c === 1 ? "saa" : "masaa";
      },
      m: "dakika",
      s: "sekunde",
      ms: "milisekunde",
      decimal: "."
    },
    tr: {
      y: "yıl",
      mo: "ay",
      w: "hafta",
      d: "gün",
      h: "saat",
      m: "dakika",
      s: "saniye",
      ms: "milisaniye",
      decimal: ","
    },
    th: {
      y: "ปี",
      mo: "เดือน",
      w: "สัปดาห์",
      d: "วัน",
      h: "ชั่วโมง",
      m: "นาที",
      s: "วินาที",
      ms: "มิลลิวินาที",
      decimal: "."
    },
    vi: {
      y: "năm",
      mo: "tháng",
      w: "tuần",
      d: "ngày",
      h: "giờ",
      m: "phút",
      s: "giây",
      ms: "mili giây",
      decimal: ","
    },
    zh_CN: {
      y: "年",
      mo: "个月",
      w: "周",
      d: "天",
      h: "小时",
      m: "分钟",
      s: "秒",
      ms: "毫秒",
      decimal: "."
    },
    zh_TW: {
      y: "年",
      mo: "個月",
      w: "周",
      d: "天",
      h: "小時",
      m: "分鐘",
      s: "秒",
      ms: "毫秒",
      decimal: "."
    }
  };

  // You can create a humanizer, which returns a function with default
  // parameters.
  function humanizer(passedOptions) {
    var result = function humanizer(ms, humanizerOptions) {
      var options = assign({}, result, humanizerOptions || {});
      return doHumanization(ms, options);
    };

    return assign(
      result,
      {
        language: "en",
        spacer: " ",
        conjunction: "",
        serialComma: true,
        units: ["y", "mo", "w", "d", "h", "m", "s"],
        languages: {},
        round: false,
        unitMeasures: {
          y: 31557600000,
          mo: 2629800000,
          w: 604800000,
          d: 86400000,
          h: 3600000,
          m: 60000,
          s: 1000,
          ms: 1
        }
      },
      passedOptions
    );
  }

  // The main function is just a wrapper around a default humanizer.
  var humanizeDuration = humanizer({});

  // Build dictionary from options
  function getDictionary(options) {
    var languagesFromOptions = [options.language];

    if (has(options, "fallbacks")) {
      if (isArray(options.fallbacks) && options.fallbacks.length) {
        languagesFromOptions = languagesFromOptions.concat(options.fallbacks);
      } else {
        throw new Error("fallbacks must be an array with at least one element");
      }
    }

    for (var i = 0; i < languagesFromOptions.length; i++) {
      var languageToTry = languagesFromOptions[i];
      if (has(options.languages, languageToTry)) {
        return options.languages[languageToTry];
      } else if (has(LANGUAGES, languageToTry)) {
        return LANGUAGES[languageToTry];
      }
    }

    throw new Error("No language found.");
  }

  // doHumanization does the bulk of the work.
  function doHumanization(ms, options) {
    var i, len, piece;

    // Make sure we have a positive number.
    // Has the nice sideffect of turning Number objects into primitives.
    ms = Math.abs(ms);

    var dictionary = getDictionary(options);
    var pieces = [];

    // Start at the top and keep removing units, bit by bit.
    var unitName, unitMS, unitCount;
    for (i = 0, len = options.units.length; i < len; i++) {
      unitName = options.units[i];
      unitMS = options.unitMeasures[unitName];

      // What's the number of full units we can fit?
      if (i + 1 === len) {
        if (has(options, "maxDecimalPoints")) {
          // We need to use this expValue to avoid rounding functionality of toFixed call
          var expValue = Math.pow(10, options.maxDecimalPoints);
          var unitCountFloat = ms / unitMS;
          unitCount = parseFloat(
            (Math.floor(expValue * unitCountFloat) / expValue).toFixed(
              options.maxDecimalPoints
            )
          );
        } else {
          unitCount = ms / unitMS;
        }
      } else {
        unitCount = Math.floor(ms / unitMS);
      }

      // Add the string.
      pieces.push({
        unitCount: unitCount,
        unitName: unitName
      });

      // Remove what we just figured out.
      ms -= unitCount * unitMS;
    }

    var firstOccupiedUnitIndex = 0;
    for (i = 0; i < pieces.length; i++) {
      if (pieces[i].unitCount) {
        firstOccupiedUnitIndex = i;
        break;
      }
    }

    if (options.round) {
      var ratioToLargerUnit, previousPiece;
      for (i = pieces.length - 1; i >= 0; i--) {
        piece = pieces[i];
        piece.unitCount = Math.round(piece.unitCount);

        if (i === 0) {
          break;
        }

        previousPiece = pieces[i - 1];

        ratioToLargerUnit =
          options.unitMeasures[previousPiece.unitName] /
          options.unitMeasures[piece.unitName];
        if (
          piece.unitCount % ratioToLargerUnit === 0 ||
          (options.largest && options.largest - 1 < i - firstOccupiedUnitIndex)
        ) {
          previousPiece.unitCount += piece.unitCount / ratioToLargerUnit;
          piece.unitCount = 0;
        }
      }
    }

    var result = [];
    for (i = 0, pieces.length; i < len; i++) {
      piece = pieces[i];
      if (piece.unitCount) {
        result.push(
          render(piece.unitCount, piece.unitName, dictionary, options)
        );
      }

      if (result.length === options.largest) {
        break;
      }
    }

    if (result.length) {
      var delimiter;
      if (has(options, "delimiter")) {
        delimiter = options.delimiter;
      } else if (has(dictionary, "delimiter")) {
        delimiter = dictionary.delimiter;
      } else {
        delimiter = ", ";
      }

      if (!options.conjunction || result.length === 1) {
        return result.join(delimiter);
      } else if (result.length === 2) {
        return result.join(options.conjunction);
      } else if (result.length > 2) {
        return (
          result.slice(0, -1).join(delimiter) +
          (options.serialComma ? "," : "") +
          options.conjunction +
          result.slice(-1)
        );
      }
    } else {
      return render(
        0,
        options.units[options.units.length - 1],
        dictionary,
        options
      );
    }
  }

  function render(count, type, dictionary, options) {
    var decimal;
    if (has(options, "decimal")) {
      decimal = options.decimal;
    } else if (has(dictionary, "decimal")) {
      decimal = dictionary.decimal;
    } else {
      decimal = ".";
    }

    var countStr;
    if (typeof dictionary._formatCount === "function") {
      countStr = dictionary._formatCount(count, decimal);
    } else {
      countStr = count.toString().replace(".", decimal);
    }

    var dictionaryValue = dictionary[type];
    var word;
    if (typeof dictionaryValue === "function") {
      word = dictionaryValue(count);
    } else {
      word = dictionaryValue;
    }

    return countStr + options.spacer + word;
  }

  function assign(destination) {
    var source;
    for (var i = 1; i < arguments.length; i++) {
      source = arguments[i];
      for (var prop in source) {
        if (has(source, prop)) {
          destination[prop] = source[prop];
        }
      }
    }
    return destination;
  }

  function getArabicForm(c) {
    if (c === 1) {
      return 0;
    }
    if (c === 2) {
      return 1;
    }
    if (c > 2 && c < 11) {
      return 2;
    }
    return 0;
  }

  function getPolishForm(c) {
    if (c === 1) {
      return 0;
    } else if (Math.floor(c) !== c) {
      return 1;
    } else if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) {
      return 2;
    } else {
      return 3;
    }
  }

  function getSlavicForm(c) {
    if (Math.floor(c) !== c) {
      return 2;
    } else if (
      (c % 100 >= 5 && c % 100 <= 20) ||
      (c % 10 >= 5 && c % 10 <= 9) ||
      c % 10 === 0
    ) {
      return 0;
    } else if (c % 10 === 1) {
      return 1;
    } else if (c > 1) {
      return 2;
    } else {
      return 0;
    }
  }

  function getCzechOrSlovakForm(c) {
    if (c === 1) {
      return 0;
    } else if (Math.floor(c) !== c) {
      return 1;
    } else if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) {
      return 2;
    } else {
      return 3;
    }
  }

  function getLithuanianForm(c) {
    if (c === 1 || (c % 10 === 1 && c % 100 > 20)) {
      return 0;
    } else if (
      Math.floor(c) !== c ||
      (c % 10 >= 2 && c % 100 > 20) ||
      (c % 10 >= 2 && c % 100 < 10)
    ) {
      return 1;
    } else {
      return 2;
    }
  }

  function getLatvianForm(c) {
    return c % 10 === 1 && c % 100 !== 11;
  }

  // We need to make sure we support browsers that don't have
  // `Array.isArray`, so we define a fallback here.
  var isArray =
    Array.isArray ||
    function (arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    };

  function has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  humanizeDuration.getSupportedLanguages = function getSupportedLanguages() {
    var result = [];
    for (var language in LANGUAGES) {
      if (has(LANGUAGES, language) && language !== "gr") {
        result.push(language);
      }
    }
    return result;
  };

  humanizeDuration.humanizer = humanizer;

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return humanizeDuration;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})();


/***/ }),

/***/ "8ff2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9043":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "90ea":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "91c8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "91f7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var toString = __webpack_require__("577e");
var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");
var create = __webpack_require__("7c73");
var getInternalState = __webpack_require__("69f3").get;
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "929b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollResult_vue_vue_type_style_index_0_id_27d0349d_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7c96");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollResult_vue_vue_type_style_index_0_id_27d0349d_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollResult_vue_vue_type_style_index_0_id_27d0349d_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9439":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * NchanSubscriber
 * usage: var sub = new NchanSubscriber(url, opt);
 * 
 * opt = {
 *   subscriber: 'longpoll', 'eventsource', or 'websocket',
 *     //or an array of the above indicating subscriber type preference
 *   reconnect: undefined or 'session' or 'persist'
 *     //if the HTML5 sessionStore or localStore should be used to resume
 *     //connections interrupted by a page load
 *   shared: true or undefined
 *     //share connection to same subscriber url between browser 
 *     //windows and tabs using localStorage. In shared mode, 
 *     //only 1 running subscriber is allowed per url per window/tab.
 * }
 * 
 * sub.on("transportSetup", function(opt, subscriberName) {
 *   // opt is a hash/object - not all transports support all options equally. Only longpoll supports arbitrary headers
 *   // subscriberName is a string
 * });
 * 
 * sub.on("transportNativeCreated", function(nativeTransportObject, subscriberName) {
 *   // nativeTransportObject is the native transport object and depends on the subscriber type
 *   // subscriberName is a string
 * });
 *
 * sub.on("transportNativeBeforeDestroy", function(nativeTransportObject, subscriberName) {
 *   // nativeTransportObject is the native transport object and depends on the subscriber type
 *   // subscriberName is a string
 * });
 *
 * sub.on("message", function(message, message_metadata) {
 *   // message is a string
 *   // message_metadata may contain 'id' and 'content-type'
 * });
 * 
 * sub.on('connect', function(evt) {
 *   //fired when first connected. 
 * });
 * 
 * sub.on('disconnect', function(evt) {
 *   // when disconnected.
 * });
 * 
 * sub.on('error', function(code, message) {
 *   //error callback. not sure about the parameters yet
 * });
 * 
 * sub.reconnect; // should subscriber try to reconnect? true by default.
 * sub.reconnectTimeout; //how long to wait to reconnect? does not apply to EventSource, which reconnects on its own.
 * sub.lastMessageId; //last message id. useful for resuming a connection without loss or repetition.
 * 
 * sub.start(); // begin (or resume) subscribing
 * sub.stop(); // stop subscriber. do not reconnect.
 */

//Thanks Darren Whitlen ( @prawnsalad ) for your feedback


;(function (global, moduleName, factory) { // eslint-disable-line
  "use strict";
  /* eslint-disable no-undef */
  var newModule = factory(global);
  if ( true && module != null && module.exports) {
    module.exports = newModule;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return newModule; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
  /* eslint-enable no-undef */
})(typeof window !== "undefined" ? window : this, "NchanSubscriber", function factory(global, undefined) { // eslint-disable-line

  // https://github.com/yanatan16/nanoajax
  var nanoajax={};
  (function(){var e=["responseType","withCredentials","timeout","onprogress"];nanoajax.ajax=function(r,o){var a=r.headers||{},u=r.body,s=r.method||(u?"POST":"GET"),i=false;var f=t(r.cors);function l(e,t){return function(){if(!i){o(f.status===undefined?e:f.status,f.status===0?"Error":f.response||f.responseText||t,f);i=true}}}f.open(s,r.url,true);var d=f.onload=l(200);f.onreadystatechange=function(){if(f.readyState===4)d()};f.onerror=l(null,"Error");f.ontimeout=l(null,"Timeout");f.onabort=l(null,"Abort");if(u){n(a,"X-Requested-With","XMLHttpRequest");if(!global.FormData||!(u instanceof global.FormData)){n(a,"Content-Type","application/x-www-form-urlencoded")}}for(var p=0,c=e.length,g;p<c;p++){g=e[p];if(r[g]!==undefined)f[g]=r[g]}for(var g in a)f.setRequestHeader(g,a[g]);f.send(u);return f};function t(e){if(e&&global.XDomainRequest&&!/MSIE 1/.test(navigator.userAgent))return new XDomainRequest;if(global.XMLHttpRequest)return new XMLHttpRequest}function n(e,t,n){e[t]=e[t]||n}})(); // eslint-disable-line


  // https://github.com/component/emitter
  function Emitter(t){return t?mixin(t):void 0}function mixin(t){for(var e in Emitter.prototype)t[e]=Emitter.prototype[e];return t}Emitter.prototype.on=Emitter.prototype.addEventListener=function(t,e){return this._callbacks=this._callbacks||{},(this._callbacks["$"+t]=this._callbacks["$"+t]||[]).push(e),this},Emitter.prototype.once=function(t,e){function i(){this.off(t,i),e.apply(this,arguments)}return i.fn=e,this.on(t,i),this},Emitter.prototype.off=Emitter.prototype.removeListener=Emitter.prototype.removeAllListeners=Emitter.prototype.removeEventListener=function(t,e){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var i=this._callbacks["$"+t];if(!i)return this;if(1==arguments.length)return delete this._callbacks["$"+t],this;for(var r,s=0;s<i.length;s++)if(r=i[s],r===e||r.fn===e){i.splice(s,1);break}return this},Emitter.prototype.emit=function(t){this._callbacks=this._callbacks||{};var e=[].slice.call(arguments,1),i=this._callbacks["$"+t];if(i){i=i.slice(0);for(var r=0,s=i.length;s>r;++r)i[r].apply(this,e)}return this},Emitter.prototype.listeners=function(t){return this._callbacks=this._callbacks||{},this._callbacks["$"+t]||[]},Emitter.prototype.hasListeners=function(t){return!!this.listeners(t).length};// eslint-disable-line

  var ughbind = (Function.prototype.bind
    ? function ughbind(fn, thisObj) {
      return fn.bind(thisObj);
    }
    : function ughbind(fn, thisObj) {
      return function() {
        fn.apply(thisObj, arguments);
      };
    }
  );

  var sharedSubscriberTable={};

  "use strict"; 
  function NchanSubscriber(url, opt) {
    if(typeof window !== "undefined" && this === window) {
      throw "use 'new NchanSubscriber(...)' to initialize";
    }
    
    this.url = url;
    opt = opt || {};
    
    //which transport should i use?
    if(typeof opt === "string") {
      opt = {subscriber: opt}; 
    }
    if(opt.transport && !opt.subscriber) {
      opt.subscriber = opt.transport;
    }
    if(typeof opt.subscriber === "string") {
      opt.subscriber = [ opt.subscriber ];
    }
    this.desiredTransport = opt.subscriber;
    
    if(opt.shared) {
      if (!("localStorage" in global)) {
        throw "localStorage unavailable for use in shared NchanSubscriber";
      }
      
      var pre = "NchanSubscriber:" + this.url + ":shared:";
      var sharedKey = function(key) { return pre + key; };
      var localStorage = global.localStorage;
      this.shared = {
        id: "" + Math.random() + Math.random(),
        key: sharedKey,
        get: function(key) {
          return localStorage.getItem(sharedKey(key));
        },
        set: function(key, val) {
          return localStorage.setItem(sharedKey(key), val);
        },
        setWithId: ughbind(function(key, val) {
          return this.shared.set(key, "##" + this.shared.id + ":" + val);
        }, this),
        getWithId: ughbind(function(key) {
          return this.shared.stripIdFromVal(this.shared.get(key));
        }, this),
        stripIdFromVal: function(val) {
          if(!val) {
            return val;
          }
          var sep = val.indexOf(":");
          if(val[0]!=val[1] || val[0]!="#" || !sep) {
            //throw "not an event value with id";
            return val; //for backwards-compatibility
          }
          return val.substring(sep+1, val.length);
        },
        remove: function(key) {
          return localStorage.removeItem(sharedKey(key));
        },
        matchEventKey: ughbind(function(ev, key) {
          if(ev.storageArea && ev.storageArea != localStorage){
            return false;
          }
          return ev.key == sharedKey(key);
        }, this),
        matchEventKeyWithId: ughbind(function(ev, key) {
          if(this.shared.matchEventKey(ev, key)) {
            var val = ev.newValue;
            var sep = val.indexOf(":");
            if(val[0]!=val[1] || val[0]!="#" || !sep) {
              //throw "not an event value with id";
              return true; //for backwards-compatibility
            }
            var id = val.substring(2, sep);
            return (id != this.shared.id); //ignore own events (accomodations for IE. Fuckin' IE, even after all these years...)
          }
          else {
            return false;
          }
        }, this),
        setRole: ughbind(function(role) {
          //console.log(this.url, "set shared role to ", role);
          if(role == "master" && this.shared.role != "master") {
            var now = new Date().getTime()/1000;
            this.shared.setWithId("master:created", now);
            this.shared.setWithId("master:lastSeen", now);
          }
          if(role == "slave" && !this.lastMessageId) {
            this.lastMessageId = this.shared.get("msg:id");
          }
          this.shared.role = role;
          return this;
        }, this),
        
        demoteToSlave: ughbind(function() {
          //console.log("demote to slave");
          if(this.shared.role != "master") {
            throw "can't demote non-master to slave";
          }
          if(this.running) {
            this.stop();
            this.shared.setRole("slave");
            this.initializeTransport();
            this.start();
          }
          else {
            this.initializeTransport();
          }
        }, this),
        
        maybePromoteToMaster: ughbind(function() {
          if(!(this.running || this.starting)) {
            //console.log(this.url, "stopped Subscriber won't be promoted to master");
            return this;
          }
          if(this.shared.maybePromotingToMaster) {
            //console.log(this.url, " already maybePromotingToMaster");
            return;
          }
          this.shared.maybePromotingToMaster = true;
          
          //console.log(this.url, "maybe promote to master");
          var processRoll;
          
          var lotteryRoundDuration = 2000;
          var currentContenders = 0;
          
          //roll the dice
          var roll = Math.random();
          var bestRoll = roll;
          
          var checkRollInterval;
          var checkRoll = ughbind(function(dontProcess) {
            var latestSharedRollTime = parseFloat(this.shared.getWithId("lotteryTime"));
            var latestSharedRoll = parseFloat(this.shared.getWithId("lottery"));
            var notStale = !latestSharedRollTime || (latestSharedRollTime > (new Date().getTime() - lotteryRoundDuration * 2));
            if(notStale && latestSharedRoll && (!bestRoll || latestSharedRoll > bestRoll)) {
              bestRoll = latestSharedRoll;
            }
            if(!dontProcess) {
              processRoll();
            }
          }, this);
          
          checkRoll(true);
          this.shared.setWithId("lottery", roll);
          this.shared.setWithId("lotteryTime", new Date().getTime() / 1000);
          
          var rollCallback = ughbind(function(ev) {
            if(this.shared.matchEventKeyWithId(ev, "lottery") && ev.newValue) {
              currentContenders += 1;
              var newVal = parseFloat(this.shared.stripIdFromVal(ev.newValue));
              var oldVal = parseFloat(this.shared.stripIdFromVal(ev.oldValue));
              if(oldVal > newVal) {
                this.shared.setWithId("lottery", oldVal);
              }
              
              if(!bestRoll || newVal >= bestRoll) {
                //console.log("new bestRoll", newVal);
                bestRoll = newVal;
              }
            }
          }, this);
          global.addEventListener("storage", rollCallback);
          
          var finish = ughbind(function() {
            //console.log("finish");
            this.shared.maybePromotingToMaster = false;
            //console.log(this.url, this.shared.role);
            global.removeEventListener("storage", rollCallback);
            if(checkRollInterval) {
              clearInterval(checkRollInterval);
            }
            if(this.shared && this.shared.role == "master") {
              this.shared.remove("lottery");
              this.shared.remove("lotteryTime");
            }
            if(this.running) {
              this.stop();
              this.initializeTransport();
              this.start();
            }
            else {
              this.initializeTransport();
              if(this.starting) {
                this.start();
              }
            }
          }, this);
          
          processRoll = ughbind(function() {
            //console.log("roll, bestroll", roll, bestRoll);
            if(roll < bestRoll) {
              //console.log(this.url, "loser");
              this.shared.setRole("slave");
              finish();
            }
            else if(roll >= bestRoll) {
              //var now = new Date().getTime() / 1000;
              //var lotteryTime = parseFloat(this.shared.getWithId("lotteryTime"));
              //console.log(lotteryTime, now - lotteryRoundDuration/1000);
              if(currentContenders == 0) {
                //console.log("winner, no more contenders!");
                this.shared.setRole("master");
                finish();
              }
              else {
                //console.log("winning, but have contenders", currentContenders);
                currentContenders = 0;
              }
            }
          }, this);
          
          checkRollInterval = global.setInterval(checkRoll, lotteryRoundDuration);
        }, this),
        masterCheckInterval: 10000
      };
    }
    
    this.lastMessageId = opt.id || opt.msgId;
    this.reconnect = typeof opt.reconnect == "undefined" ? true : opt.reconnect;
    this.reconnectTimeout = opt.reconnectTimeout || 1000;
    
    
    var saveConnectionState;
    if(!opt.reconnect) {
      saveConnectionState = function() {};
    }
    else {
      var index = "NchanSubscriber:" + url + ":lastMessageId";
      var storage;
      if(opt.reconnect == "persist") {
        storage = ("localStorage" in global) && global.localStorage;
        if(!storage)
          throw "can't use reconnect: 'persist' option: localStorage not available";
      }
      else if(opt.reconnect == "session") {
        storage = ("sessionStorage" in global) && global.sessionStorage;
        if(!storage)
          throw "can't use reconnect: 'session' option: sessionStorage not available";
      }
      else {
        throw "invalid 'reconnect' option value " + opt.reconnect;
      }
      saveConnectionState = ughbind(function(msgid) {
        if(this.shared && this.shared.role == "slave") return;
        storage.setItem(index, msgid);
      }, this);
      this.lastMessageId = storage.getItem(index);
    }
    
    var onUnloadEvent = ughbind(function() {
      if(this.running) {
        this.stop();
      }
      if(this.shared && this.shared.role == "master") {
        this.shared.setWithId("status", "disconnected");
      }
    }, this);
    global.addEventListener("beforeunload", onUnloadEvent, false);
    // swap `beforeunload` to `unload` after DOM is loaded
    global.addEventListener("DOMContentLoaded", function() {
      global.removeEventListener("beforeunload", onUnloadEvent, false);
      global.addEventListener("unload", onUnloadEvent, false);
    }, false);
    
    
    var notifySharedSubscribers;
    if(this.shared) {
      notifySharedSubscribers = ughbind(function(name, data) {
        if(this.shared.role != "master") {
          return;
        }
        
        if(name == "message") {
          this.shared.set("msg:id", data[1] && data[1].id || "");
          this.shared.set("msg:content-type", data[1] && data[1]["content-type"] || "");
          this.shared.set("msg", data[0]);
        }
        else if(name == "error") {
          //TODO 
        }
        else if(name == "connecting") {
          this.shared.setWithId("status", "connecting");
        }
        else if(name == "connect") {
          this.shared.setWithId("status", "connected");
        }
        else if(name == "reconnect") {
          this.shared.setWithId("status", "reconnecting");
        }
        else if(name == "disconnect") {
          this.shared.setWithId("status", "disconnected");
        }
      }, this);
    }
    else {
      notifySharedSubscribers = function(){};
    }
    
    var restartTimeoutIndex;
    var stopHandler = ughbind(function() {
      if(!restartTimeoutIndex && this.running && this.reconnect && !this.transport.reconnecting && !this.transport.doNotReconnect) {
        //console.log("stopHAndler reconnect plz", this.running, this.reconnect);
        notifySharedSubscribers("reconnect");
        restartTimeoutIndex = global.setTimeout(ughbind(function() {
          restartTimeoutIndex = null;
          this.stop();
          this.start();
        }, this), this.reconnectTimeout);
      }
      else {
        notifySharedSubscribers("disconnect");
      }
    }, this);
    
    this.on("message", function msg(msg, meta) {
      this.lastMessageId=meta.id;
      if(meta.id) {
        saveConnectionState(meta.id);
      }
      notifySharedSubscribers("message", [msg, meta]);
      //console.log(msg, meta);
    });
    this.on("error", function fail(code, text) {
      stopHandler(code, text);
      notifySharedSubscribers("error", [code, text]);
      //console.log("failure", code, text);
    });
    this.on("connect", function() {
      this.connected = true;
      notifySharedSubscribers("connect");
    });
    this.on("__disconnect", function fail(code, text) {
      this.connected = false;
      this.emit("disconnect", code, text);
      stopHandler(code, text);
      //console.log("__disconnect", code, text);
    });
  }

  Emitter(NchanSubscriber.prototype);

  NchanSubscriber.prototype.initializeTransport = function(possibleTransports) {
    if(possibleTransports) {
      this.desiredTransport = possibleTransports;
    }
    if(this.shared && this.shared.role == "slave") {
      this.transport = new this.SubscriberClass["__slave"](ughbind(this.emit, this)); //try it
    }
    else {
      var tryInitializeTransport = ughbind(function(name) {
        if(!this.SubscriberClass[name]) {
          throw "unknown subscriber type " + name;
        }
        try {
          this.transport = new this.SubscriberClass[name](ughbind(this.emit, this)); //try it
          return this.transport;
        } catch(err) { /*meh...*/ }
      }, this);
      
      var i;
      if(this.desiredTransport) {
        for(i=0; i<this.desiredTransport.length; i++) {
          if(tryInitializeTransport(this.desiredTransport[i])) {
            break;
          }
        }
      }
      else {
        for(i in this.SubscriberClass) {
          if (this.SubscriberClass.hasOwnProperty(i) && i[0] != "_" && tryInitializeTransport(i)) {
            break;
          }
        }
      }
    }
    if(! this.transport) {
      throw "can't use any transport type";
    }
  };

  var storageEventListener;

  NchanSubscriber.prototype.start = function() {
    if(this.running)
      throw "Can't start NchanSubscriber, it's already started.";
    
    this.starting = true;
    
    if(this.shared) {
      if(sharedSubscriberTable[this.url] && sharedSubscriberTable[this.url] != this) {
        throw "Only 1 shared subscriber allowed per url per window/tab.";
      }
      sharedSubscriberTable[this.url] = this;
      
      if(!this.shared.role) {
        var status = this.shared.getWithId("status");
        storageEventListener = ughbind(function(ev) {
          if(this.shared.matchEventKeyWithId(ev, "status")) {
            var newValue = this.shared.stripIdFromVal(ev.newValue);
            if(newValue == "disconnected") {
              if(this.shared.role == "slave") {
                //play the promotion lottery
                //console.log(this.url, "status changed to disconnected, maybepromotetomaster", ev.newValue, ev.oldValue);
                this.shared.maybePromoteToMaster();
              }
              else if(this.shared.role == "master") {
                //do nothing
                //console.log(this.url, "current role is master, do nothing?...");
              }
            }
          }
          else if(this.shared.role == "master" && this.shared.matchEventKeyWithId(ev, "master:created") && ev.newValue) {
            //a new master has arrived. demote to slave.
            this.shared.demoteToSlave();
          }
        }, this);
        global.addEventListener("storage", storageEventListener);
        if(status == "disconnected") {
          //console.log(this.url, "status == disconnected, maybepromotetomaster");
          this.shared.maybePromoteToMaster();
        }
        else {
          this.shared.setRole(status ? "slave" : "master");
          this.initializeTransport();
        }
      }
      
      if(this.shared.role == "master") {
        this.shared.setWithId("status", "connecting");
        this.transport.listen(this.url, this.lastMessageId);
        this.running = true;
        delete this.starting;
        
        //master checkin interval
        this.shared.masterIntervalCheckID = global.setInterval(ughbind(function() {
          this.shared.setWithId("master:lastSeen", new Date().getTime() / 1000);
        }, this), this.shared.masterCheckInterval * 0.8);
      }
      else if(this.shared.role == "slave") {
        this.transport.listen(this.url, this.shared);
        this.running = true;
        delete this.starting;
        
        //slave check if master is around
        this.shared.masterIntervalCheckID = global.setInterval(ughbind(function() {
          var lastCheckin = parseFloat(this.shared.getWithId("master:lastSeen"));
          if(!lastCheckin || lastCheckin < (new Date().getTime() / 1000) - this.shared.masterCheckInterval / 1000) {
            //master hasn't checked in for too long. assume it's gone.
            this.shared.maybePromoteToMaster();
          }
        }, this), this.shared.masterCheckInterval);
      }
    }
    else {
      if(!this.transport) {
        this.initializeTransport();
      }
      this.transport.listen(this.url, this.lastMessageId);
      this.running = true;
      delete this.starting;
    }
    return this;
  };

  NchanSubscriber.prototype.stop = function() {
    if(!this.running)
      throw "Can't stop NchanSubscriber, it's not running.";
    
    this.running = false;
    if(storageEventListener) {
      global.removeEventListener("storage", storageEventListener);
    }
    this.transport.cancel();
    if(this.shared) {
      delete sharedSubscriberTable[this.url];
      if(this.shared.masterIntervalCheckID) {
        clearInterval(this.shared.masterIntervalCheckID);
        delete this.shared.masterIntervalCheckID;
      }
    }
    return this;
  };

  function addLastMsgIdToQueryString(url, msgid) {
    if(msgid) {
      var m = url.match(/(\?.*)$/);
      url += (m ? "&" : "?") + "last_event_id=" + encodeURIComponent(msgid);
    }
    return url;
  }

  NchanSubscriber.prototype.SubscriberClass = {
    "websocket": (function() {
      function WSWrapper(emit) {
        WebSocket;
        this.emit = emit;
        this.name = "websocket";
        this.opt = {
          url: null,
          msgid: null,
          headers : {
            'Sec-WebSocket-Protocol' : "ws+meta.nchan"
          }
        }
      }

      WSWrapper.prototype.setup = function() {
        this.emit("transportSetup", this.opt, this.name);
        var count = 0;
        var property;
        for ( property in this.opt.headers ) count++;
        if (count != 1 && "Sec-WebSocket-Protocol" in this.opt.headers) {
          throw "WebSocket only supports one header; Sec-WebSocket-Protocol";
        }
      };

      WSWrapper.prototype.websocketizeURL = function(url) {
        var m = url.match(/^((\w+:)?\/\/([^/]+))?(\/)?(.*)/);
        var protocol = m[2];
        var host = m[3];
        var absolute = m[4];
        var path = m[5];
        
        var loc;
        if(typeof window == "object") {
          loc = window.location;
        }
        else if(typeof document == "object") {
          loc = document.location;
        }
        
        if(!protocol && loc) {
          protocol = loc.protocol;
        }
        if(protocol == "https:") {
          protocol = "wss:";
        }
        else if(protocol == "http:") {
          protocol = "ws:";
        }
        else if(protocol != "ws:") {
          protocol = "wss:"; //default setting: secure, unless "ws:" explicitly specified
        }
        
        if(!host && loc) {
          host = loc.host;
        }
        
        if(!absolute) {
          path = loc ? loc.pathname.match(/(.*\/)[^/]*/)[1] + path : "/" + path;
        }
        else {
          path = "/" + path;
        }
        
        return protocol + "//" + host + path;
      };
      
      WSWrapper.prototype.listen = function(url, msgid) {
        if(this.listener) {
          throw "websocket already listening";
        }
        this.opt.url = url;
        this.opt.msgid = msgid;
        this.setup();
        url = this.websocketizeURL(this.opt.url);
        url = addLastMsgIdToQueryString(url, this.opt.msgid);
        //console.log(url);
        this.listener = new WebSocket(url, this.opt.headers["Sec-WebSocket-Protocol"]);
        var l = this.listener;
        this.emit("transportNativeCreated", l, this.name);
        l.onmessage = ughbind(function(evt) {
          if (evt.data instanceof Blob) {
            //extract header, preserve rest of blob.
            //let's assume the header ends in the first 255 chars
            var headerSlice = evt.data.slice(0, 255);
            var reader = new FileReader();
            reader.addEventListener("loadend", ughbind(function() {
              var m = reader.result.match(/^id: (.*)\n(content-type: (.*)\n)?\n/m);
              this.emit("message", evt.data.slice(m[0].length), {"id": m[1], "content-type": m[3]});
            }, this));
            reader.readAsText(headerSlice)
          } else {
            var m = evt.data.match(/^id: (.*)\n(content-type: (.*)\n)?\n/m);
            this.emit("message", evt.data.substr(m[0].length), {"id": m[1], "content-type": m[3]});
          }
        }, this);
        
        l.onopen = ughbind(function(evt) {
          this.emit("connect", evt);
          //console.log("connect", evt);
        }, this);
        
        l.onerror = ughbind(function(evt) {
          //console.log("error", evt);
          this.emit("error", evt, l);
          delete this.listener;
        }, this);
        
        l.onclose = ughbind(function(evt) {
          this.emit("__disconnect", evt);
          delete this.listener;
        }, this);
      };
      
      WSWrapper.prototype.cancel = function() {
        if(this.listener) {
          this.emit("transportNativeBeforeDestroy", this.listener, this.name);
          this.listener.close();
          delete this.listener;
        }
      };
      
      return WSWrapper;
    })(),
  
    "eventsource": (function() {
      function ESWrapper(emit) {
        EventSource;
        this.emit = emit;
        this.name = "eventsource";
        this.opt = {
            url: null,
            msgid: null,
            headers : {
          }
        }
      }

      ESWrapper.prototype.setup = function() {
        this.emit("transportSetup", this.opt, this.name);
        var count = 0;
        var property;
        for ( property in this.opt.headers ) count++;
        if (count != 0) {
          throw "EventSource does not support headers";
        }
      };

      ESWrapper.prototype.listen= function(url, msgid) {
        if(this.listener) {
          throw "there's a ES listener running already";
        }
        this.opt.url = url;
        this.opt.msgid = msgid;
        this.setup();
        url = addLastMsgIdToQueryString(this.opt.url, this.opt.msgid);
        this.listener = new EventSource(url);
        var l = this.listener;
        this.emit("transportNativeCreated", l, this.name);
        l.onmessage = ughbind(function(evt){
          //console.log("message", evt);
          this.emit("message", evt.data, {id: evt.lastEventId});
        }, this);
        
        l.onopen = ughbind(function(evt) {
          this.reconnecting = false;
          //console.log("connect", evt);
          this.emit("connect", evt);
        }, this);
        
        l.onerror = ughbind(function(evt) {
          //EventSource will try to reconnect by itself
          //console.log("onerror", this.listener.readyState, evt);
          if(this.listener.readyState == EventSource.CONNECTING && !this.reconnecting) {
            if(!this.reconnecting) {
              this.reconnecting = true;
              this.emit("__disconnect", evt);
            }
          }
          else {
            this.emit("__disconnect", evt);
            //console.log('other __disconnect', evt);
          }
        }, this);
      };
      
      ESWrapper.prototype.cancel= function() {
        if(this.listener) {
          this.emit("transportNativeBeforeDestroy", this.listener, this.name);
          this.listener.close();
          delete this.listener;
        }
      };
      
      return ESWrapper;
    })(),
    
    "longpoll": (function () {
      function Longpoll(emit) {
        this.pollingRequest = null;
        this.longPollStartTime = null;
        this.maxLongPollTime = 5*60*1000; //5 minutes
        this.emit = emit;
        this.name = "longpoll";
        this.opt = {
          url: null,
          msgid: null,
          headers : {
          }
        }
      }

      Longpoll.prototype.setup = function() {
        this.emit("transportSetup", this.opt, this.name);
        var count = 0;
        var property;
        for ( property in this.opt.headers ) count++;
      };

      Longpoll.prototype.listen = function(url, msgid) {
        if(this.req) {
          throw "already listening";
        }
        this.opt.url = url;
        this.opt.msgid = msgid;
        if(msgid) {
          this.opt.headers["Etag"] = msgid;
        }
        this.setup();

        var setHeader = ughbind(function(incoming, name) {
          if(incoming) { this.opt.headers[name]= incoming; }
        }, this);

        this.pollingRequest = ughbind(function() {
          if (this.req) {
            this.emit("transportNativeBeforeDestroy", this.req, this.name);
          }
          this.reqStartTime = new Date().getTime();
          this.req = nanoajax.ajax({url: this.opt.url, headers: this.opt.headers}, requestCallback);
          this.emit("transportNativeCreated", this.req, this.name);
        }, this);
        var  requestCallback;
        requestCallback = ughbind(function (code, response_text, req) {
          setHeader(req.getResponseHeader("Last-Modified"), "If-Modified-Since");
          setHeader(req.getResponseHeader("Etag"), "If-None-Match");
          
          if(code >= 200 && code <= 210) {
            //legit reply
            var content_type = req.getResponseHeader("Content-Type");
            if (!this.parseMultipartMixedMessage(content_type, response_text, req)) {
              this.emit("message", response_text || "", {"content-type": content_type, "id": this.msgIdFromResponseHeaders(req)});
            }
            if (this.req) { //this check is needed because stop() may have been called in the message callback
              this.pollingRequest();
            }
          }
          else if((code == 0 && response_text == "Error" && req.readyState == 4) || (code === null && response_text != "Abort")) {
            //console.log("abort!!!");
            this.emit("__disconnect", code || 0, response_text);
            delete this.req;
          }
          else if(code !== null) {
            //HTTP error
            this.emit("error", code, response_text);
            delete this.req;
          }
          else {
            //don't care about abortions 
            delete this.req;
            this.emit("__disconnect");
            //console.log("abort!");
          }
        }, this);
        
        this.pollingRequest();
        this.emit("connect");
        
        return this;
      };
      
      Longpoll.prototype.parseMultipartMixedMessage = function(content_type, text, req) {
        var m = content_type && content_type.match(/^multipart\/mixed;\s+boundary=(.*)$/);
        if(!m) { 
          return false;
        }
        var boundary = m[1];
        
        var msgs = text.split("--" + boundary);
        if(msgs[0] != "" || !msgs[msgs.length-1].match(/--\r?\n/)) { throw "weird multipart/mixed split"; }
        
        msgs = msgs.slice(1, -1);
        for(var i in msgs) {
          m = msgs[i].match(/^(.*)\r?\n\r?\n([\s\S]*)\r?\n$/m);
          var hdrs = m[1].split("\n");
          
          var meta = {};
          for(var j in hdrs) {
            var hdr = hdrs[j].match(/^([^:]+):\s+(.*)/);
            if(hdr && hdr[1] == "Content-Type") {
              meta["content-type"] = hdr[2];
            }
          }
          
          if(i == msgs.length - 1) {
            meta["id"] = this.msgIdFromResponseHeaders(req);
          }
          this.emit("message", m[2], meta);
        }
        return true;
      };
      
      Longpoll.prototype.msgIdFromResponseHeaders = function(req) {
        var lastModified, etag;
        lastModified = req.getResponseHeader("Last-Modified");
        etag = req.getResponseHeader("Etag");
        if(lastModified) {
          return "" + Date.parse(lastModified)/1000 + ":" + (etag || "0");
        }
        else if(etag) {
          return etag;
        }
        else {
          return null;
        }
      };
      
      Longpoll.prototype.cancel = function() {
        if(this.req) {
          this.emit("transportNativeBeforeDestroy", this.req, this.name);
          this.req.abort();
          delete this.req;
        }
        return this; 
      };
      
      return Longpoll;
    })(),
    
    "__slave": (function() {
      function LocalStoreSlaveTransport(emit) {
        this.emit = emit;
        this.doNotReconnect = true;
        this.shared = null;
        this.name = "__slave";
        this.opt = {
          url: null,
          msgid: null,
          headers : {
          }
        }
      }

      LocalStoreSlaveTransport.prototype.setup = function() {
        this.emit("transportSetup", this.opt, this.name);
        var count = 0;
        var property;
        for ( property in this.opt.headers ) count++;
        if (count != 0) {
          throw "__slave does not support headers";
        }
      };

      LocalStoreSlaveTransport.prototype.listen = function(url, shared) {
        this.shared = shared;
        this.opt.url = url;  
        this.setup();
        this.statusChangeChecker = ughbind(function(ev) {
          if(this.shared.matchEventKey(ev, "msg")) {
            var msgId = this.shared.get("msg:id");
            var contentType = this.shared.get("msg:content-type");
            var msg = this.shared.get("msg");
            this.emit("message", msg, {"id": msgId == "" ? undefined : msgId, "content-type": contentType == "" ? undefined : contentType});
          }
        }, this);
        global.addEventListener("storage", this.statusChangeChecker);
        //this.emit("transportNativeCreated", this, this.name);
      };
        
      LocalStoreSlaveTransport.prototype.cancel = function() {
        global.removeEventListener("storage", this.statusChangeChecker);
      };
      
      return LocalStoreSlaveTransport;
    })()

  };

  return NchanSubscriber;
});


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "957c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                '_'
            ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                '_'
            ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ "958b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ "95ed":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9609":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ "9686":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "972c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ "9734":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9797":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
            '_'
        ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ "9911":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError = global.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var getIteratorMethod = __webpack_require__("35a1");

var TypeError = global.TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var iteratorClose = __webpack_require__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9c9a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9cb8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9e29":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollItem_vue_vue_type_style_index_0_id_60526126_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3852");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollItem_vue_vue_type_style_index_0_id_60526126_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollItem_vue_vue_type_style_index_0_id_60526126_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9f26":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ "9f7f1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a0ec":
/***/ (function(module, exports, __webpack_require__) {

/* jshint browser: true */

(function () {

// We'll copy the properties below into the mirror div.
// Note that some browsers, such as Firefox, do not concatenate properties
// into their shorthand (e.g. padding-top, padding-bottom etc. -> padding),
// so we have to list every single property explicitly.
var properties = [
  'direction',  // RTL support
  'boxSizing',
  'width',  // on Chrome and IE, exclude the scrollbar, so the mirror div wraps exactly as the textarea does
  'height',
  'overflowX',
  'overflowY',  // copy the scrollbar for IE

  'borderTopWidth',
  'borderRightWidth',
  'borderBottomWidth',
  'borderLeftWidth',
  'borderStyle',

  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',

  // https://developer.mozilla.org/en-US/docs/Web/CSS/font
  'fontStyle',
  'fontVariant',
  'fontWeight',
  'fontStretch',
  'fontSize',
  'fontSizeAdjust',
  'lineHeight',
  'fontFamily',

  'textAlign',
  'textTransform',
  'textIndent',
  'textDecoration',  // might not make a difference, but better be safe

  'letterSpacing',
  'wordSpacing',

  'tabSize',
  'MozTabSize'

];

var isBrowser = (typeof window !== 'undefined');
var isFirefox = (isBrowser && window.mozInnerScreenX != null);

function getCaretCoordinates(element, position, options) {
  if (!isBrowser) {
    throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
  }

  var debug = options && options.debug || false;
  if (debug) {
    var el = document.querySelector('#input-textarea-caret-position-mirror-div');
    if (el) el.parentNode.removeChild(el);
  }

  // The mirror div will replicate the textarea's style
  var div = document.createElement('div');
  div.id = 'input-textarea-caret-position-mirror-div';
  document.body.appendChild(div);

  var style = div.style;
  var computed = window.getComputedStyle ? window.getComputedStyle(element) : element.currentStyle;  // currentStyle for IE < 9
  var isInput = element.nodeName === 'INPUT';

  // Default textarea styles
  style.whiteSpace = 'pre-wrap';
  if (!isInput)
    style.wordWrap = 'break-word';  // only for textarea-s

  // Position off-screen
  style.position = 'absolute';  // required to return coordinates properly
  if (!debug)
    style.visibility = 'hidden';  // not 'display: none' because we want rendering

  // Transfer the element's properties to the div
  properties.forEach(function (prop) {
    if (isInput && prop === 'lineHeight') {
      // Special case for <input>s because text is rendered centered and line height may be != height
      style.lineHeight = computed.height;
    } else {
      style[prop] = computed[prop];
    }
  });

  if (isFirefox) {
    // Firefox lies about the overflow property for textareas: https://bugzilla.mozilla.org/show_bug.cgi?id=984275
    if (element.scrollHeight > parseInt(computed.height))
      style.overflowY = 'scroll';
  } else {
    style.overflow = 'hidden';  // for Chrome to not render a scrollbar; IE keeps overflowY = 'scroll'
  }

  div.textContent = element.value.substring(0, position);
  // The second special handling for input type="text" vs textarea:
  // spaces need to be replaced with non-breaking spaces - http://stackoverflow.com/a/13402035/1269037
  if (isInput)
    div.textContent = div.textContent.replace(/\s/g, '\u00a0');

  var span = document.createElement('span');
  // Wrapping must be replicated *exactly*, including when a long word gets
  // onto the next line, with whitespace at the end of the line before (#7).
  // The  *only* reliable way to do that is to copy the *entire* rest of the
  // textarea's content into the <span> created at the caret position.
  // For inputs, just '.' would be enough, but no need to bother.
  span.textContent = element.value.substring(position) || '.';  // || because a completely empty faux span doesn't render at all
  div.appendChild(span);

  var coordinates = {
    top: span.offsetTop + parseInt(computed['borderTopWidth']),
    left: span.offsetLeft + parseInt(computed['borderLeftWidth']),
    height: parseInt(computed['lineHeight'])
  };

  if (debug) {
    span.style.backgroundColor = '#aaa';
  } else {
    document.body.removeChild(div);
  }

  return coordinates;
}

if ( true && typeof module.exports != 'undefined') {
  module.exports = getCaretCoordinates;
} else if(isBrowser) {
  window.getCaretCoordinates = getCaretCoordinates;
}

}());


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var un$Join = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a2bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var lengthOfArrayLike = __webpack_require__("07fa");
var bind = __webpack_require__("0366");

var TypeError = global.TypeError;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ "a356":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var toAbsoluteIndex = __webpack_require__("23cb");
var toIntegerOrInfinity = __webpack_require__("5926");
var lengthOfArrayLike = __webpack_require__("07fa");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var TypeError = global.TypeError;
var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var isArray = __webpack_require__("e8b5");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var isPrototypeOf = __webpack_require__("3a9b");
var isSymbol = __webpack_require__("d9b5");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var $toString = __webpack_require__("577e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var definePropertiesModule = __webpack_require__("37e8");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var arraySlice = __webpack_require__("f36a");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  redefine(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = call($replacer, this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return apply($stringify, null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!SymbolPrototype[TO_PRIMITIVE]) {
  var valueOf = SymbolPrototype.valueOf;
  // eslint-disable-next-line no-unused-vars -- required for .length
  redefine(SymbolPrototype, TO_PRIMITIVE, function (hint) {
    // TODO: improve hint logic
    return call(valueOf, this);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a545":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a7fa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var hasOwn = __webpack_require__("1a2d");
var inheritIfRequired = __webpack_require__("7156");
var isPrototypeOf = __webpack_require__("3a9b");
var isSymbol = __webpack_require__("d9b5");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var thisNumberValue = __webpack_require__("408a");
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var arraySlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = arraySlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    // check on 1..constructor(foo) case
    return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); })
      ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "aaf2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                '_'
            ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ab36":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "aba9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/newColor.e79ac488.png";

/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ada2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                    '_'
                ),
                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                    '_'
                ),
                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                    '_'
                ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                '_'
            ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ "addb":
/***/ (function(module, exports, __webpack_require__) {

var arraySlice = __webpack_require__("4dae");

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var create = __webpack_require__("7c73");
var getPrototypeOf = __webpack_require__("e163");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var FUNCTION_NAME_EXISTS = __webpack_require__("5e77").EXISTS;
var uncurryThis = __webpack_require__("e330");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b29d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ "b3eb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ "b469":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ "b50d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var settle = __webpack_require__("467f");
var cookies = __webpack_require__("7aac");
var buildURL = __webpack_require__("30b5");
var buildFullPath = __webpack_require__("83b9");
var parseHeaders = __webpack_require__("c345");
var isURLSameOrigin = __webpack_require__("3934");
var createError = __webpack_require__("2d83");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "b53d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ "b540":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");
var IS_IOS_PEBBLE = __webpack_require__("d4c3");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b5b6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b5b7":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b680":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var thisNumberValue = __webpack_require__("408a");
var $repeat = __webpack_require__("1148");
var fails = __webpack_require__("d039");

var RangeError = global.RangeError;
var String = global.String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var un$ToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return un$ToFixed(0.00008, 3) !== '0.000' ||
    un$ToFixed(0.9, 0) !== '1' ||
    un$ToFixed(1.255, 2) !== '1.25' ||
    un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  un$ToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "b7e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ "b84c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ "b855":
/***/ (function(module, exports) {

module.exports = () => {
	// https://mths.be/emoji
	return /(?:[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDD-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF6](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC2\uDED0-\uDED9\uDEE0-\uDEE7]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?))/g;
};


/***/ }),

/***/ "b97c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
            '_'
        ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ "b980":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "ba63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollImageResults_vue_vue_type_style_index_0_id_2a884998_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c6de");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollImageResults_vue_vue_type_style_index_0_id_2a884998_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollImageResults_vue_vue_type_style_index_0_id_2a884998_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bb18":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bb2f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "bb71":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ "bc3a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cee4");

/***/ }),

/***/ "bd2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatEmojiPicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("519f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatEmojiPicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatEmojiPicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "be48":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c109":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ "c1df":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    undefined
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__("4678")("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "c30f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatTextMessage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("37fb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatTextMessage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatTextMessage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c345":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "c401":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var defaults = __webpack_require__("2444");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("1d2b");

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ "c607":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var classof = __webpack_require__("c6b6");
var defineProperty = __webpack_require__("9bf2").f;
var getInternalState = __webpack_require__("69f3").get;

var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineProperty(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ "c65b":
/***/ (function(module, exports) {

var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6de":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c770":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string') {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "c7aa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
            '_'
        ),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ "c7cd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
  fixed: function fixed() {
    return createHTML(this, 'tt', '', '');
  }
});


/***/ }),

/***/ "c8af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ "c8f3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ "c96a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "ca71":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb29":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fill = __webpack_require__("81d5");
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "cee4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var bind = __webpack_require__("1d2b");
var Axios = __webpack_require__("0a06");
var mergeConfig = __webpack_require__("4a7b");
var defaults = __webpack_require__("2444");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("7a77");
axios.CancelToken = __webpack_require__("8df4b");
axios.isCancel = __webpack_require__("2e67");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("0df6");

// Expose isAxiosError
axios.isAxiosError = __webpack_require__("5f02");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "cf1e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ "cf51":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ "cf75":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d191":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d26a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
            '_'
        ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
            '_'
        ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("e330");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d2d4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var hasOwn = __webpack_require__("1a2d");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d4c3":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");
var global = __webpack_require__("da84");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


/***/ }),

/***/ "d59f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d675":
/***/ (function(module) {

module.exports = JSON.parse("{\"locale\":\"de\",\"long\":{\"year\":{\"previous\":\"letztes Jahr\",\"current\":\"dieses Jahr\",\"next\":\"nächstes Jahr\",\"past\":{\"one\":\"vor {0} Jahr\",\"other\":\"vor {0} Jahren\"},\"future\":{\"one\":\"in {0} Jahr\",\"other\":\"in {0} Jahren\"}},\"quarter\":{\"previous\":\"letztes Quartal\",\"current\":\"dieses Quartal\",\"next\":\"nächstes Quartal\",\"past\":{\"one\":\"vor {0} Quartal\",\"other\":\"vor {0} Quartalen\"},\"future\":{\"one\":\"in {0} Quartal\",\"other\":\"in {0} Quartalen\"}},\"month\":{\"previous\":\"letzten Monat\",\"current\":\"diesen Monat\",\"next\":\"nächsten Monat\",\"past\":{\"one\":\"vor {0} Monat\",\"other\":\"vor {0} Monaten\"},\"future\":{\"one\":\"in {0} Monat\",\"other\":\"in {0} Monaten\"}},\"week\":{\"previous\":\"letzte Woche\",\"current\":\"diese Woche\",\"next\":\"nächste Woche\",\"past\":{\"one\":\"vor {0} Woche\",\"other\":\"vor {0} Wochen\"},\"future\":{\"one\":\"in {0} Woche\",\"other\":\"in {0} Wochen\"}},\"day\":{\"previous\":\"gestern\",\"previous-2\":\"vorgestern\",\"current\":\"heute\",\"next\":\"morgen\",\"next-2\":\"übermorgen\",\"past\":{\"one\":\"vor {0} Tag\",\"other\":\"vor {0} Tagen\"},\"future\":{\"one\":\"in {0} Tag\",\"other\":\"in {0} Tagen\"}},\"hour\":{\"current\":\"in dieser Stunde\",\"past\":{\"one\":\"vor {0} Stunde\",\"other\":\"vor {0} Stunden\"},\"future\":{\"one\":\"in {0} Stunde\",\"other\":\"in {0} Stunden\"}},\"minute\":{\"current\":\"in dieser Minute\",\"past\":{\"one\":\"vor {0} Minute\",\"other\":\"vor {0} Minuten\"},\"future\":{\"one\":\"in {0} Minute\",\"other\":\"in {0} Minuten\"}},\"second\":{\"current\":\"jetzt\",\"past\":{\"one\":\"vor {0} Sekunde\",\"other\":\"vor {0} Sekunden\"},\"future\":{\"one\":\"in {0} Sekunde\",\"other\":\"in {0} Sekunden\"}}},\"short\":{\"year\":{\"previous\":\"letztes Jahr\",\"current\":\"dieses Jahr\",\"next\":\"nächstes Jahr\",\"past\":{\"one\":\"vor {0} Jahr\",\"other\":\"vor {0} Jahren\"},\"future\":{\"one\":\"in {0} Jahr\",\"other\":\"in {0} Jahren\"}},\"quarter\":{\"previous\":\"letztes Quartal\",\"current\":\"dieses Quartal\",\"next\":\"nächstes Quartal\",\"past\":\"vor {0} Quart.\",\"future\":\"in {0} Quart.\"},\"month\":{\"previous\":\"letzten Monat\",\"current\":\"diesen Monat\",\"next\":\"nächsten Monat\",\"past\":{\"one\":\"vor {0} Monat\",\"other\":\"vor {0} Monaten\"},\"future\":{\"one\":\"in {0} Monat\",\"other\":\"in {0} Monaten\"}},\"week\":{\"previous\":\"letzte Woche\",\"current\":\"diese Woche\",\"next\":\"nächste Woche\",\"past\":{\"one\":\"vor {0} Woche\",\"other\":\"vor {0} Wochen\"},\"future\":{\"one\":\"in {0} Woche\",\"other\":\"in {0} Wochen\"}},\"day\":{\"previous\":\"gestern\",\"previous-2\":\"vorgestern\",\"current\":\"heute\",\"next\":\"morgen\",\"next-2\":\"übermorgen\",\"past\":{\"one\":\"vor {0} Tag\",\"other\":\"vor {0} Tagen\"},\"future\":{\"one\":\"in {0} Tag\",\"other\":\"in {0} Tagen\"}},\"hour\":{\"current\":\"in dieser Stunde\",\"past\":\"vor {0} Std.\",\"future\":\"in {0} Std.\"},\"minute\":{\"current\":\"in dieser Minute\",\"past\":\"vor {0} Min.\",\"future\":\"in {0} Min.\"},\"second\":{\"current\":\"jetzt\",\"past\":\"vor {0} Sek.\",\"future\":\"in {0} Sek.\"}},\"narrow\":{\"year\":{\"previous\":\"letztes Jahr\",\"current\":\"dieses Jahr\",\"next\":\"nächstes Jahr\",\"past\":{\"one\":\"vor {0} Jahr\",\"other\":\"vor {0} Jahren\"},\"future\":{\"one\":\"in {0} Jahr\",\"other\":\"in {0} Jahren\"}},\"quarter\":{\"previous\":\"letztes Quartal\",\"current\":\"dieses Quartal\",\"next\":\"nächstes Quartal\",\"past\":\"vor {0} Q\",\"future\":\"in {0} Q\"},\"month\":{\"previous\":\"letzten Monat\",\"current\":\"diesen Monat\",\"next\":\"nächsten Monat\",\"past\":{\"one\":\"vor {0} Monat\",\"other\":\"vor {0} Monaten\"},\"future\":{\"one\":\"in {0} Monat\",\"other\":\"in {0} Monaten\"}},\"week\":{\"previous\":\"letzte Woche\",\"current\":\"diese Woche\",\"next\":\"nächste Woche\",\"past\":\"vor {0} Wo.\",\"future\":\"in {0} Wo.\"},\"day\":{\"previous\":\"gestern\",\"previous-2\":\"vorgestern\",\"current\":\"heute\",\"next\":\"morgen\",\"next-2\":\"übermorgen\",\"past\":{\"one\":\"vor {0} Tag\",\"other\":\"vor {0} Tagen\"},\"future\":{\"one\":\"in {0} Tag\",\"other\":\"in {0} Tagen\"}},\"hour\":{\"current\":\"in dieser Stunde\",\"past\":\"vor {0} Std.\",\"future\":\"in {0} Std.\"},\"minute\":{\"current\":\"in dieser Minute\",\"past\":\"vor {0} m\",\"future\":\"in {0} m\"},\"second\":{\"current\":\"jetzt\",\"past\":\"vor {0} s\",\"future\":\"in {0} s\"}},\"now\":{\"now\":{\"current\":\"jetzt\",\"future\":\"in einem Moment\",\"past\":\"gerade jetzt\"}},\"mini\":{\"year\":\"{0} J.\",\"month\":\"{0} Mt.\",\"week\":\"{0} Wo.\",\"day\":\"{0} T.\",\"hour\":\"{0} Std.\",\"minute\":\"{0} Min.\",\"second\":\"{0} s\",\"now\":\"jetzt\"},\"long-time\":{\"year\":{\"one\":\"{0} Jahr\",\"other\":\"{0} Jahre\"},\"month\":{\"one\":\"{0} Monat\",\"other\":\"{0} Monate\"},\"week\":{\"one\":\"{0} Woche\",\"other\":\"{0} Wochen\"},\"day\":{\"one\":\"{0} Tag\",\"other\":\"{0} Tage\"},\"hour\":{\"one\":\"{0} Stunde\",\"other\":\"{0} Stunden\"},\"minute\":{\"one\":\"{0} Minute\",\"other\":\"{0} Minuten\"},\"second\":{\"one\":\"{0} Sekunde\",\"other\":\"{0} Sekunden\"}}}");

/***/ }),

/***/ "d69a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ "d6b6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                '_'
            ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
            '_'
        ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ "d716":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                '_'
            ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var uncurryThis = __webpack_require__("e330");
var redefine = __webpack_require__("6eeb");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d86b":
/***/ (function(module, exports, __webpack_require__) {

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__("d039");

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ "d925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "d998":
/***/ (function(module, exports, __webpack_require__) {

var UA = __webpack_require__("342f");

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),

/***/ "d9e2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var wrapErrorConstructorWithCause = __webpack_require__("e5cb");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "d9f8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "db29":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ "db42":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dbd3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "dc4d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                '_'
            ),
        },
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
            '_'
        ),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ "dca8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var FREEZING = __webpack_require__("bb2f");
var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var onFreeze = __webpack_require__("f183").onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "de38":
/***/ (function(module) {

module.exports = JSON.parse("{\"compressed\":true,\"categories\":[{\"id\":\"smileys\",\"name\":\"Smileys & Emotion\",\"emojis\":[\"grinning\",\"smiley\",\"smile\",\"grin\",\"laughing\",\"sweat_smile\",\"rolling_on_the_floor_laughing\",\"joy\",\"slightly_smiling_face\",\"upside_down_face\",\"wink\",\"blush\",\"innocent\",\"smiling_face_with_3_hearts\",\"heart_eyes\",\"star-struck\",\"kissing_heart\",\"kissing\",\"relaxed\",\"kissing_closed_eyes\",\"kissing_smiling_eyes\",\"smiling_face_with_tear\",\"yum\",\"stuck_out_tongue\",\"stuck_out_tongue_winking_eye\",\"zany_face\",\"stuck_out_tongue_closed_eyes\",\"money_mouth_face\",\"hugging_face\",\"face_with_hand_over_mouth\",\"shushing_face\",\"thinking_face\",\"zipper_mouth_face\",\"face_with_raised_eyebrow\",\"neutral_face\",\"expressionless\",\"no_mouth\",\"smirk\",\"unamused\",\"face_with_rolling_eyes\",\"grimacing\",\"lying_face\",\"relieved\",\"pensive\",\"sleepy\",\"drooling_face\",\"sleeping\",\"mask\",\"face_with_thermometer\",\"face_with_head_bandage\",\"nauseated_face\",\"face_vomiting\",\"sneezing_face\",\"hot_face\",\"cold_face\",\"woozy_face\",\"dizzy_face\",\"exploding_head\",\"face_with_cowboy_hat\",\"partying_face\",\"disguised_face\",\"sunglasses\",\"nerd_face\",\"face_with_monocle\",\"confused\",\"worried\",\"slightly_frowning_face\",\"white_frowning_face\",\"open_mouth\",\"hushed\",\"astonished\",\"flushed\",\"pleading_face\",\"frowning\",\"anguished\",\"fearful\",\"cold_sweat\",\"disappointed_relieved\",\"cry\",\"sob\",\"scream\",\"confounded\",\"persevere\",\"disappointed\",\"sweat\",\"weary\",\"tired_face\",\"yawning_face\",\"triumph\",\"rage\",\"angry\",\"face_with_symbols_on_mouth\",\"smiling_imp\",\"imp\",\"skull\",\"skull_and_crossbones\",\"hankey\",\"clown_face\",\"japanese_ogre\",\"japanese_goblin\",\"ghost\",\"alien\",\"space_invader\",\"robot_face\",\"smiley_cat\",\"smile_cat\",\"joy_cat\",\"heart_eyes_cat\",\"smirk_cat\",\"kissing_cat\",\"scream_cat\",\"crying_cat_face\",\"pouting_cat\",\"see_no_evil\",\"hear_no_evil\",\"speak_no_evil\",\"kiss\",\"love_letter\",\"cupid\",\"gift_heart\",\"sparkling_heart\",\"heartpulse\",\"heartbeat\",\"revolving_hearts\",\"two_hearts\",\"heart_decoration\",\"heavy_heart_exclamation_mark_ornament\",\"broken_heart\",\"heart\",\"orange_heart\",\"yellow_heart\",\"green_heart\",\"blue_heart\",\"purple_heart\",\"brown_heart\",\"black_heart\",\"white_heart\",\"100\",\"anger\",\"boom\",\"dizzy\",\"sweat_drops\",\"dash\",\"hole\",\"bomb\",\"speech_balloon\",\"left_speech_bubble\",\"right_anger_bubble\",\"thought_balloon\",\"zzz\"]},{\"id\":\"people\",\"name\":\"People & Body\",\"emojis\":[\"wave\",\"raised_back_of_hand\",\"raised_hand_with_fingers_splayed\",\"hand\",\"spock-hand\",\"ok_hand\",\"pinched_fingers\",\"pinching_hand\",\"v\",\"crossed_fingers\",\"i_love_you_hand_sign\",\"the_horns\",\"call_me_hand\",\"point_left\",\"point_right\",\"point_up_2\",\"middle_finger\",\"point_down\",\"point_up\",\"+1\",\"-1\",\"fist\",\"facepunch\",\"left-facing_fist\",\"right-facing_fist\",\"clap\",\"raised_hands\",\"open_hands\",\"palms_up_together\",\"handshake\",\"pray\",\"writing_hand\",\"nail_care\",\"selfie\",\"muscle\",\"mechanical_arm\",\"mechanical_leg\",\"leg\",\"foot\",\"ear\",\"ear_with_hearing_aid\",\"nose\",\"brain\",\"anatomical_heart\",\"lungs\",\"tooth\",\"bone\",\"eyes\",\"eye\",\"tongue\",\"lips\",\"baby\",\"child\",\"boy\",\"girl\",\"adult\",\"person_with_blond_hair\",\"man\",\"bearded_person\",\"red_haired_man\",\"curly_haired_man\",\"white_haired_man\",\"bald_man\",\"woman\",\"red_haired_woman\",\"red_haired_person\",\"curly_haired_woman\",\"curly_haired_person\",\"white_haired_woman\",\"white_haired_person\",\"bald_woman\",\"bald_person\",\"blond-haired-woman\",\"blond-haired-man\",\"older_adult\",\"older_man\",\"older_woman\",\"person_frowning\",\"man-frowning\",\"woman-frowning\",\"person_with_pouting_face\",\"man-pouting\",\"woman-pouting\",\"no_good\",\"man-gesturing-no\",\"woman-gesturing-no\",\"ok_woman\",\"man-gesturing-ok\",\"woman-gesturing-ok\",\"information_desk_person\",\"man-tipping-hand\",\"woman-tipping-hand\",\"raising_hand\",\"man-raising-hand\",\"woman-raising-hand\",\"deaf_person\",\"deaf_man\",\"deaf_woman\",\"bow\",\"man-bowing\",\"woman-bowing\",\"face_palm\",\"man-facepalming\",\"woman-facepalming\",\"shrug\",\"man-shrugging\",\"woman-shrugging\",\"health_worker\",\"male-doctor\",\"female-doctor\",\"student\",\"male-student\",\"female-student\",\"teacher\",\"male-teacher\",\"female-teacher\",\"judge\",\"male-judge\",\"female-judge\",\"farmer\",\"male-farmer\",\"female-farmer\",\"cook\",\"male-cook\",\"female-cook\",\"mechanic\",\"male-mechanic\",\"female-mechanic\",\"factory_worker\",\"male-factory-worker\",\"female-factory-worker\",\"office_worker\",\"male-office-worker\",\"female-office-worker\",\"scientist\",\"male-scientist\",\"female-scientist\",\"technologist\",\"male-technologist\",\"female-technologist\",\"singer\",\"male-singer\",\"female-singer\",\"artist\",\"male-artist\",\"female-artist\",\"pilot\",\"male-pilot\",\"female-pilot\",\"astronaut\",\"male-astronaut\",\"female-astronaut\",\"firefighter\",\"male-firefighter\",\"female-firefighter\",\"cop\",\"male-police-officer\",\"female-police-officer\",\"sleuth_or_spy\",\"male-detective\",\"female-detective\",\"guardsman\",\"male-guard\",\"female-guard\",\"ninja\",\"construction_worker\",\"male-construction-worker\",\"female-construction-worker\",\"prince\",\"princess\",\"man_with_turban\",\"man-wearing-turban\",\"woman-wearing-turban\",\"man_with_gua_pi_mao\",\"person_with_headscarf\",\"person_in_tuxedo\",\"man_in_tuxedo\",\"woman_in_tuxedo\",\"bride_with_veil\",\"man_with_veil\",\"woman_with_veil\",\"pregnant_woman\",\"breast-feeding\",\"woman_feeding_baby\",\"man_feeding_baby\",\"person_feeding_baby\",\"angel\",\"santa\",\"mrs_claus\",\"mx_claus\",\"superhero\",\"male_superhero\",\"female_superhero\",\"supervillain\",\"male_supervillain\",\"female_supervillain\",\"mage\",\"male_mage\",\"female_mage\",\"fairy\",\"male_fairy\",\"female_fairy\",\"vampire\",\"male_vampire\",\"female_vampire\",\"merperson\",\"merman\",\"mermaid\",\"elf\",\"male_elf\",\"female_elf\",\"genie\",\"male_genie\",\"female_genie\",\"zombie\",\"male_zombie\",\"female_zombie\",\"massage\",\"man-getting-massage\",\"woman-getting-massage\",\"haircut\",\"man-getting-haircut\",\"woman-getting-haircut\",\"walking\",\"man-walking\",\"woman-walking\",\"standing_person\",\"man_standing\",\"woman_standing\",\"kneeling_person\",\"man_kneeling\",\"woman_kneeling\",\"person_with_probing_cane\",\"man_with_probing_cane\",\"woman_with_probing_cane\",\"person_in_motorized_wheelchair\",\"man_in_motorized_wheelchair\",\"woman_in_motorized_wheelchair\",\"person_in_manual_wheelchair\",\"man_in_manual_wheelchair\",\"woman_in_manual_wheelchair\",\"runner\",\"man-running\",\"woman-running\",\"dancer\",\"man_dancing\",\"man_in_business_suit_levitating\",\"dancers\",\"man-with-bunny-ears-partying\",\"woman-with-bunny-ears-partying\",\"person_in_steamy_room\",\"man_in_steamy_room\",\"woman_in_steamy_room\",\"person_climbing\",\"man_climbing\",\"woman_climbing\",\"fencer\",\"horse_racing\",\"skier\",\"snowboarder\",\"golfer\",\"man-golfing\",\"woman-golfing\",\"surfer\",\"man-surfing\",\"woman-surfing\",\"rowboat\",\"man-rowing-boat\",\"woman-rowing-boat\",\"swimmer\",\"man-swimming\",\"woman-swimming\",\"person_with_ball\",\"man-bouncing-ball\",\"woman-bouncing-ball\",\"weight_lifter\",\"man-lifting-weights\",\"woman-lifting-weights\",\"bicyclist\",\"man-biking\",\"woman-biking\",\"mountain_bicyclist\",\"man-mountain-biking\",\"woman-mountain-biking\",\"person_doing_cartwheel\",\"man-cartwheeling\",\"woman-cartwheeling\",\"wrestlers\",\"man-wrestling\",\"woman-wrestling\",\"water_polo\",\"man-playing-water-polo\",\"woman-playing-water-polo\",\"handball\",\"man-playing-handball\",\"woman-playing-handball\",\"juggling\",\"man-juggling\",\"woman-juggling\",\"person_in_lotus_position\",\"man_in_lotus_position\",\"woman_in_lotus_position\",\"bath\",\"sleeping_accommodation\",\"people_holding_hands\",\"two_women_holding_hands\",\"man_and_woman_holding_hands\",\"two_men_holding_hands\",\"couplekiss\",\"woman-kiss-man\",\"man-kiss-man\",\"woman-kiss-woman\",\"couple_with_heart\",\"woman-heart-man\",\"man-heart-man\",\"woman-heart-woman\",\"family\",\"man-woman-boy\",\"man-woman-girl\",\"man-woman-girl-boy\",\"man-woman-boy-boy\",\"man-woman-girl-girl\",\"man-man-boy\",\"man-man-girl\",\"man-man-girl-boy\",\"man-man-boy-boy\",\"man-man-girl-girl\",\"woman-woman-boy\",\"woman-woman-girl\",\"woman-woman-girl-boy\",\"woman-woman-boy-boy\",\"woman-woman-girl-girl\",\"man-boy\",\"man-boy-boy\",\"man-girl\",\"man-girl-boy\",\"man-girl-girl\",\"woman-boy\",\"woman-boy-boy\",\"woman-girl\",\"woman-girl-boy\",\"woman-girl-girl\",\"speaking_head_in_silhouette\",\"bust_in_silhouette\",\"busts_in_silhouette\",\"people_hugging\",\"footprints\"]},{\"id\":\"nature\",\"name\":\"Animals & Nature\",\"emojis\":[\"monkey_face\",\"monkey\",\"gorilla\",\"orangutan\",\"dog\",\"dog2\",\"guide_dog\",\"service_dog\",\"poodle\",\"wolf\",\"fox_face\",\"raccoon\",\"cat\",\"cat2\",\"black_cat\",\"lion_face\",\"tiger\",\"tiger2\",\"leopard\",\"horse\",\"racehorse\",\"unicorn_face\",\"zebra_face\",\"deer\",\"bison\",\"cow\",\"ox\",\"water_buffalo\",\"cow2\",\"pig\",\"pig2\",\"boar\",\"pig_nose\",\"ram\",\"sheep\",\"goat\",\"dromedary_camel\",\"camel\",\"llama\",\"giraffe_face\",\"elephant\",\"mammoth\",\"rhinoceros\",\"hippopotamus\",\"mouse\",\"mouse2\",\"rat\",\"hamster\",\"rabbit\",\"rabbit2\",\"chipmunk\",\"beaver\",\"hedgehog\",\"bat\",\"bear\",\"polar_bear\",\"koala\",\"panda_face\",\"sloth\",\"otter\",\"skunk\",\"kangaroo\",\"badger\",\"feet\",\"turkey\",\"chicken\",\"rooster\",\"hatching_chick\",\"baby_chick\",\"hatched_chick\",\"bird\",\"penguin\",\"dove_of_peace\",\"eagle\",\"duck\",\"swan\",\"owl\",\"dodo\",\"feather\",\"flamingo\",\"peacock\",\"parrot\",\"frog\",\"crocodile\",\"turtle\",\"lizard\",\"snake\",\"dragon_face\",\"dragon\",\"sauropod\",\"t-rex\",\"whale\",\"whale2\",\"dolphin\",\"seal\",\"fish\",\"tropical_fish\",\"blowfish\",\"shark\",\"octopus\",\"shell\",\"snail\",\"butterfly\",\"bug\",\"ant\",\"bee\",\"beetle\",\"ladybug\",\"cricket\",\"cockroach\",\"spider\",\"spider_web\",\"scorpion\",\"mosquito\",\"fly\",\"worm\",\"microbe\",\"bouquet\",\"cherry_blossom\",\"white_flower\",\"rosette\",\"rose\",\"wilted_flower\",\"hibiscus\",\"sunflower\",\"blossom\",\"tulip\",\"seedling\",\"potted_plant\",\"evergreen_tree\",\"deciduous_tree\",\"palm_tree\",\"cactus\",\"ear_of_rice\",\"herb\",\"shamrock\",\"four_leaf_clover\",\"maple_leaf\",\"fallen_leaf\",\"leaves\"]},{\"id\":\"foods\",\"name\":\"Food & Drink\",\"emojis\":[\"grapes\",\"melon\",\"watermelon\",\"tangerine\",\"lemon\",\"banana\",\"pineapple\",\"mango\",\"apple\",\"green_apple\",\"pear\",\"peach\",\"cherries\",\"strawberry\",\"blueberries\",\"kiwifruit\",\"tomato\",\"olive\",\"coconut\",\"avocado\",\"eggplant\",\"potato\",\"carrot\",\"corn\",\"hot_pepper\",\"bell_pepper\",\"cucumber\",\"leafy_green\",\"broccoli\",\"garlic\",\"onion\",\"mushroom\",\"peanuts\",\"chestnut\",\"bread\",\"croissant\",\"baguette_bread\",\"flatbread\",\"pretzel\",\"bagel\",\"pancakes\",\"waffle\",\"cheese_wedge\",\"meat_on_bone\",\"poultry_leg\",\"cut_of_meat\",\"bacon\",\"hamburger\",\"fries\",\"pizza\",\"hotdog\",\"sandwich\",\"taco\",\"burrito\",\"tamale\",\"stuffed_flatbread\",\"falafel\",\"egg\",\"fried_egg\",\"shallow_pan_of_food\",\"stew\",\"fondue\",\"bowl_with_spoon\",\"green_salad\",\"popcorn\",\"butter\",\"salt\",\"canned_food\",\"bento\",\"rice_cracker\",\"rice_ball\",\"rice\",\"curry\",\"ramen\",\"spaghetti\",\"sweet_potato\",\"oden\",\"sushi\",\"fried_shrimp\",\"fish_cake\",\"moon_cake\",\"dango\",\"dumpling\",\"fortune_cookie\",\"takeout_box\",\"crab\",\"lobster\",\"shrimp\",\"squid\",\"oyster\",\"icecream\",\"shaved_ice\",\"ice_cream\",\"doughnut\",\"cookie\",\"birthday\",\"cake\",\"cupcake\",\"pie\",\"chocolate_bar\",\"candy\",\"lollipop\",\"custard\",\"honey_pot\",\"baby_bottle\",\"glass_of_milk\",\"coffee\",\"teapot\",\"tea\",\"sake\",\"champagne\",\"wine_glass\",\"cocktail\",\"tropical_drink\",\"beer\",\"beers\",\"clinking_glasses\",\"tumbler_glass\",\"cup_with_straw\",\"bubble_tea\",\"beverage_box\",\"mate_drink\",\"ice_cube\",\"chopsticks\",\"knife_fork_plate\",\"fork_and_knife\",\"spoon\",\"hocho\",\"amphora\"]},{\"id\":\"activity\",\"name\":\"Activities\",\"emojis\":[\"jack_o_lantern\",\"christmas_tree\",\"fireworks\",\"sparkler\",\"firecracker\",\"sparkles\",\"balloon\",\"tada\",\"confetti_ball\",\"tanabata_tree\",\"bamboo\",\"dolls\",\"flags\",\"wind_chime\",\"rice_scene\",\"red_envelope\",\"ribbon\",\"gift\",\"reminder_ribbon\",\"admission_tickets\",\"ticket\",\"medal\",\"trophy\",\"sports_medal\",\"first_place_medal\",\"second_place_medal\",\"third_place_medal\",\"soccer\",\"baseball\",\"softball\",\"basketball\",\"volleyball\",\"football\",\"rugby_football\",\"tennis\",\"flying_disc\",\"bowling\",\"cricket_bat_and_ball\",\"field_hockey_stick_and_ball\",\"ice_hockey_stick_and_puck\",\"lacrosse\",\"table_tennis_paddle_and_ball\",\"badminton_racquet_and_shuttlecock\",\"boxing_glove\",\"martial_arts_uniform\",\"goal_net\",\"golf\",\"ice_skate\",\"fishing_pole_and_fish\",\"diving_mask\",\"running_shirt_with_sash\",\"ski\",\"sled\",\"curling_stone\",\"dart\",\"yo-yo\",\"kite\",\"8ball\",\"crystal_ball\",\"magic_wand\",\"nazar_amulet\",\"video_game\",\"joystick\",\"slot_machine\",\"game_die\",\"jigsaw\",\"teddy_bear\",\"pinata\",\"nesting_dolls\",\"spades\",\"hearts\",\"diamonds\",\"clubs\",\"chess_pawn\",\"black_joker\",\"mahjong\",\"flower_playing_cards\",\"performing_arts\",\"frame_with_picture\",\"art\",\"thread\",\"sewing_needle\",\"yarn\",\"knot\"]},{\"id\":\"places\",\"name\":\"Travel & Places\",\"emojis\":[\"earth_africa\",\"earth_americas\",\"earth_asia\",\"globe_with_meridians\",\"world_map\",\"japan\",\"compass\",\"snow_capped_mountain\",\"mountain\",\"volcano\",\"mount_fuji\",\"camping\",\"beach_with_umbrella\",\"desert\",\"desert_island\",\"national_park\",\"stadium\",\"classical_building\",\"building_construction\",\"bricks\",\"rock\",\"wood\",\"hut\",\"house_buildings\",\"derelict_house_building\",\"house\",\"house_with_garden\",\"office\",\"post_office\",\"european_post_office\",\"hospital\",\"bank\",\"hotel\",\"love_hotel\",\"convenience_store\",\"school\",\"department_store\",\"factory\",\"japanese_castle\",\"european_castle\",\"wedding\",\"tokyo_tower\",\"statue_of_liberty\",\"church\",\"mosque\",\"hindu_temple\",\"synagogue\",\"shinto_shrine\",\"kaaba\",\"fountain\",\"tent\",\"foggy\",\"night_with_stars\",\"cityscape\",\"sunrise_over_mountains\",\"sunrise\",\"city_sunset\",\"city_sunrise\",\"bridge_at_night\",\"hotsprings\",\"carousel_horse\",\"ferris_wheel\",\"roller_coaster\",\"barber\",\"circus_tent\",\"steam_locomotive\",\"railway_car\",\"bullettrain_side\",\"bullettrain_front\",\"train2\",\"metro\",\"light_rail\",\"station\",\"tram\",\"monorail\",\"mountain_railway\",\"train\",\"bus\",\"oncoming_bus\",\"trolleybus\",\"minibus\",\"ambulance\",\"fire_engine\",\"police_car\",\"oncoming_police_car\",\"taxi\",\"oncoming_taxi\",\"car\",\"oncoming_automobile\",\"blue_car\",\"pickup_truck\",\"truck\",\"articulated_lorry\",\"tractor\",\"racing_car\",\"racing_motorcycle\",\"motor_scooter\",\"manual_wheelchair\",\"motorized_wheelchair\",\"auto_rickshaw\",\"bike\",\"scooter\",\"skateboard\",\"roller_skate\",\"busstop\",\"motorway\",\"railway_track\",\"oil_drum\",\"fuelpump\",\"rotating_light\",\"traffic_light\",\"vertical_traffic_light\",\"octagonal_sign\",\"construction\",\"anchor\",\"boat\",\"canoe\",\"speedboat\",\"passenger_ship\",\"ferry\",\"motor_boat\",\"ship\",\"airplane\",\"small_airplane\",\"airplane_departure\",\"airplane_arriving\",\"parachute\",\"seat\",\"helicopter\",\"suspension_railway\",\"mountain_cableway\",\"aerial_tramway\",\"satellite\",\"rocket\",\"flying_saucer\",\"bellhop_bell\",\"luggage\",\"hourglass\",\"hourglass_flowing_sand\",\"watch\",\"alarm_clock\",\"stopwatch\",\"timer_clock\",\"mantelpiece_clock\",\"clock12\",\"clock1230\",\"clock1\",\"clock130\",\"clock2\",\"clock230\",\"clock3\",\"clock330\",\"clock4\",\"clock430\",\"clock5\",\"clock530\",\"clock6\",\"clock630\",\"clock7\",\"clock730\",\"clock8\",\"clock830\",\"clock9\",\"clock930\",\"clock10\",\"clock1030\",\"clock11\",\"clock1130\",\"new_moon\",\"waxing_crescent_moon\",\"first_quarter_moon\",\"moon\",\"full_moon\",\"waning_gibbous_moon\",\"last_quarter_moon\",\"waning_crescent_moon\",\"crescent_moon\",\"new_moon_with_face\",\"first_quarter_moon_with_face\",\"last_quarter_moon_with_face\",\"thermometer\",\"sunny\",\"full_moon_with_face\",\"sun_with_face\",\"ringed_planet\",\"star\",\"star2\",\"stars\",\"milky_way\",\"cloud\",\"partly_sunny\",\"thunder_cloud_and_rain\",\"mostly_sunny\",\"barely_sunny\",\"partly_sunny_rain\",\"rain_cloud\",\"snow_cloud\",\"lightning\",\"tornado\",\"fog\",\"wind_blowing_face\",\"cyclone\",\"rainbow\",\"closed_umbrella\",\"umbrella\",\"umbrella_with_rain_drops\",\"umbrella_on_ground\",\"zap\",\"snowflake\",\"snowman\",\"snowman_without_snow\",\"comet\",\"fire\",\"droplet\",\"ocean\"]},{\"id\":\"objects\",\"name\":\"Objects\",\"emojis\":[\"eyeglasses\",\"dark_sunglasses\",\"goggles\",\"lab_coat\",\"safety_vest\",\"necktie\",\"shirt\",\"jeans\",\"scarf\",\"gloves\",\"coat\",\"socks\",\"dress\",\"kimono\",\"sari\",\"one-piece_swimsuit\",\"briefs\",\"shorts\",\"bikini\",\"womans_clothes\",\"purse\",\"handbag\",\"pouch\",\"shopping_bags\",\"school_satchel\",\"thong_sandal\",\"mans_shoe\",\"athletic_shoe\",\"hiking_boot\",\"womans_flat_shoe\",\"high_heel\",\"sandal\",\"ballet_shoes\",\"boot\",\"crown\",\"womans_hat\",\"tophat\",\"mortar_board\",\"billed_cap\",\"military_helmet\",\"helmet_with_white_cross\",\"prayer_beads\",\"lipstick\",\"ring\",\"gem\",\"mute\",\"speaker\",\"sound\",\"loud_sound\",\"loudspeaker\",\"mega\",\"postal_horn\",\"bell\",\"no_bell\",\"musical_score\",\"musical_note\",\"notes\",\"studio_microphone\",\"level_slider\",\"control_knobs\",\"microphone\",\"headphones\",\"radio\",\"saxophone\",\"accordion\",\"guitar\",\"musical_keyboard\",\"trumpet\",\"violin\",\"banjo\",\"drum_with_drumsticks\",\"long_drum\",\"iphone\",\"calling\",\"phone\",\"telephone_receiver\",\"pager\",\"fax\",\"battery\",\"electric_plug\",\"computer\",\"desktop_computer\",\"printer\",\"keyboard\",\"three_button_mouse\",\"trackball\",\"minidisc\",\"floppy_disk\",\"cd\",\"dvd\",\"abacus\",\"movie_camera\",\"film_frames\",\"film_projector\",\"clapper\",\"tv\",\"camera\",\"camera_with_flash\",\"video_camera\",\"vhs\",\"mag\",\"mag_right\",\"candle\",\"bulb\",\"flashlight\",\"izakaya_lantern\",\"diya_lamp\",\"notebook_with_decorative_cover\",\"closed_book\",\"book\",\"green_book\",\"blue_book\",\"orange_book\",\"books\",\"notebook\",\"ledger\",\"page_with_curl\",\"scroll\",\"page_facing_up\",\"newspaper\",\"rolled_up_newspaper\",\"bookmark_tabs\",\"bookmark\",\"label\",\"moneybag\",\"coin\",\"yen\",\"dollar\",\"euro\",\"pound\",\"money_with_wings\",\"credit_card\",\"receipt\",\"chart\",\"email\",\"e-mail\",\"incoming_envelope\",\"envelope_with_arrow\",\"outbox_tray\",\"inbox_tray\",\"package\",\"mailbox\",\"mailbox_closed\",\"mailbox_with_mail\",\"mailbox_with_no_mail\",\"postbox\",\"ballot_box_with_ballot\",\"pencil2\",\"black_nib\",\"lower_left_fountain_pen\",\"lower_left_ballpoint_pen\",\"lower_left_paintbrush\",\"lower_left_crayon\",\"memo\",\"briefcase\",\"file_folder\",\"open_file_folder\",\"card_index_dividers\",\"date\",\"calendar\",\"spiral_note_pad\",\"spiral_calendar_pad\",\"card_index\",\"chart_with_upwards_trend\",\"chart_with_downwards_trend\",\"bar_chart\",\"clipboard\",\"pushpin\",\"round_pushpin\",\"paperclip\",\"linked_paperclips\",\"straight_ruler\",\"triangular_ruler\",\"scissors\",\"card_file_box\",\"file_cabinet\",\"wastebasket\",\"lock\",\"unlock\",\"lock_with_ink_pen\",\"closed_lock_with_key\",\"key\",\"old_key\",\"hammer\",\"axe\",\"pick\",\"hammer_and_pick\",\"hammer_and_wrench\",\"dagger_knife\",\"crossed_swords\",\"gun\",\"boomerang\",\"bow_and_arrow\",\"shield\",\"carpentry_saw\",\"wrench\",\"screwdriver\",\"nut_and_bolt\",\"gear\",\"compression\",\"scales\",\"probing_cane\",\"link\",\"chains\",\"hook\",\"toolbox\",\"magnet\",\"ladder\",\"alembic\",\"test_tube\",\"petri_dish\",\"dna\",\"microscope\",\"telescope\",\"satellite_antenna\",\"syringe\",\"drop_of_blood\",\"pill\",\"adhesive_bandage\",\"stethoscope\",\"door\",\"elevator\",\"mirror\",\"window\",\"bed\",\"couch_and_lamp\",\"chair\",\"toilet\",\"plunger\",\"shower\",\"bathtub\",\"mouse_trap\",\"razor\",\"lotion_bottle\",\"safety_pin\",\"broom\",\"basket\",\"roll_of_paper\",\"bucket\",\"soap\",\"toothbrush\",\"sponge\",\"fire_extinguisher\",\"shopping_trolley\",\"smoking\",\"coffin\",\"headstone\",\"funeral_urn\",\"moyai\",\"placard\"]},{\"id\":\"symbols\",\"name\":\"Symbols\",\"emojis\":[\"atm\",\"put_litter_in_its_place\",\"potable_water\",\"wheelchair\",\"mens\",\"womens\",\"restroom\",\"baby_symbol\",\"wc\",\"passport_control\",\"customs\",\"baggage_claim\",\"left_luggage\",\"warning\",\"children_crossing\",\"no_entry\",\"no_entry_sign\",\"no_bicycles\",\"no_smoking\",\"do_not_litter\",\"non-potable_water\",\"no_pedestrians\",\"no_mobile_phones\",\"underage\",\"radioactive_sign\",\"biohazard_sign\",\"arrow_up\",\"arrow_upper_right\",\"arrow_right\",\"arrow_lower_right\",\"arrow_down\",\"arrow_lower_left\",\"arrow_left\",\"arrow_upper_left\",\"arrow_up_down\",\"left_right_arrow\",\"leftwards_arrow_with_hook\",\"arrow_right_hook\",\"arrow_heading_up\",\"arrow_heading_down\",\"arrows_clockwise\",\"arrows_counterclockwise\",\"back\",\"end\",\"on\",\"soon\",\"top\",\"place_of_worship\",\"atom_symbol\",\"om_symbol\",\"star_of_david\",\"wheel_of_dharma\",\"yin_yang\",\"latin_cross\",\"orthodox_cross\",\"star_and_crescent\",\"peace_symbol\",\"menorah_with_nine_branches\",\"six_pointed_star\",\"aries\",\"taurus\",\"gemini\",\"cancer\",\"leo\",\"virgo\",\"libra\",\"scorpius\",\"sagittarius\",\"capricorn\",\"aquarius\",\"pisces\",\"ophiuchus\",\"twisted_rightwards_arrows\",\"repeat\",\"repeat_one\",\"arrow_forward\",\"fast_forward\",\"black_right_pointing_double_triangle_with_vertical_bar\",\"black_right_pointing_triangle_with_double_vertical_bar\",\"arrow_backward\",\"rewind\",\"black_left_pointing_double_triangle_with_vertical_bar\",\"arrow_up_small\",\"arrow_double_up\",\"arrow_down_small\",\"arrow_double_down\",\"double_vertical_bar\",\"black_square_for_stop\",\"black_circle_for_record\",\"eject\",\"cinema\",\"low_brightness\",\"high_brightness\",\"signal_strength\",\"vibration_mode\",\"mobile_phone_off\",\"female_sign\",\"male_sign\",\"transgender_symbol\",\"heavy_multiplication_x\",\"heavy_plus_sign\",\"heavy_minus_sign\",\"heavy_division_sign\",\"infinity\",\"bangbang\",\"interrobang\",\"question\",\"grey_question\",\"grey_exclamation\",\"exclamation\",\"wavy_dash\",\"currency_exchange\",\"heavy_dollar_sign\",\"medical_symbol\",\"recycle\",\"fleur_de_lis\",\"trident\",\"name_badge\",\"beginner\",\"o\",\"white_check_mark\",\"ballot_box_with_check\",\"heavy_check_mark\",\"x\",\"negative_squared_cross_mark\",\"curly_loop\",\"loop\",\"part_alternation_mark\",\"eight_spoked_asterisk\",\"eight_pointed_black_star\",\"sparkle\",\"copyright\",\"registered\",\"tm\",\"hash\",\"keycap_star\",\"zero\",\"one\",\"two\",\"three\",\"four\",\"five\",\"six\",\"seven\",\"eight\",\"nine\",\"keycap_ten\",\"capital_abcd\",\"abcd\",\"1234\",\"symbols\",\"abc\",\"a\",\"ab\",\"b\",\"cl\",\"cool\",\"free\",\"information_source\",\"id\",\"m\",\"new\",\"ng\",\"o2\",\"ok\",\"parking\",\"sos\",\"up\",\"vs\",\"koko\",\"sa\",\"u6708\",\"u6709\",\"u6307\",\"ideograph_advantage\",\"u5272\",\"u7121\",\"u7981\",\"accept\",\"u7533\",\"u5408\",\"u7a7a\",\"congratulations\",\"secret\",\"u55b6\",\"u6e80\",\"red_circle\",\"large_orange_circle\",\"large_yellow_circle\",\"large_green_circle\",\"large_blue_circle\",\"large_purple_circle\",\"large_brown_circle\",\"black_circle\",\"white_circle\",\"large_red_square\",\"large_orange_square\",\"large_yellow_square\",\"large_green_square\",\"large_blue_square\",\"large_purple_square\",\"large_brown_square\",\"black_large_square\",\"white_large_square\",\"black_medium_square\",\"white_medium_square\",\"black_medium_small_square\",\"white_medium_small_square\",\"black_small_square\",\"white_small_square\",\"large_orange_diamond\",\"large_blue_diamond\",\"small_orange_diamond\",\"small_blue_diamond\",\"small_red_triangle\",\"small_red_triangle_down\",\"diamond_shape_with_a_dot_inside\",\"radio_button\",\"white_square_button\",\"black_square_button\"]},{\"id\":\"flags\",\"name\":\"Flags\",\"emojis\":[\"checkered_flag\",\"cn\",\"crossed_flags\",\"de\",\"es\",\"flag-ac\",\"flag-ad\",\"flag-ae\",\"flag-af\",\"flag-ag\",\"flag-ai\",\"flag-al\",\"flag-am\",\"flag-ao\",\"flag-aq\",\"flag-ar\",\"flag-as\",\"flag-at\",\"flag-au\",\"flag-aw\",\"flag-ax\",\"flag-az\",\"flag-ba\",\"flag-bb\",\"flag-bd\",\"flag-be\",\"flag-bf\",\"flag-bg\",\"flag-bh\",\"flag-bi\",\"flag-bj\",\"flag-bl\",\"flag-bm\",\"flag-bn\",\"flag-bo\",\"flag-bq\",\"flag-br\",\"flag-bs\",\"flag-bt\",\"flag-bv\",\"flag-bw\",\"flag-by\",\"flag-bz\",\"flag-ca\",\"flag-cc\",\"flag-cd\",\"flag-cf\",\"flag-cg\",\"flag-ch\",\"flag-ci\",\"flag-ck\",\"flag-cl\",\"flag-cm\",\"flag-co\",\"flag-cp\",\"flag-cr\",\"flag-cu\",\"flag-cv\",\"flag-cw\",\"flag-cx\",\"flag-cy\",\"flag-cz\",\"flag-dg\",\"flag-dj\",\"flag-dk\",\"flag-dm\",\"flag-do\",\"flag-dz\",\"flag-ea\",\"flag-ec\",\"flag-ee\",\"flag-eg\",\"flag-eh\",\"flag-england\",\"flag-er\",\"flag-et\",\"flag-eu\",\"flag-fi\",\"flag-fj\",\"flag-fk\",\"flag-fm\",\"flag-fo\",\"flag-ga\",\"flag-gd\",\"flag-ge\",\"flag-gf\",\"flag-gg\",\"flag-gh\",\"flag-gi\",\"flag-gl\",\"flag-gm\",\"flag-gn\",\"flag-gp\",\"flag-gq\",\"flag-gr\",\"flag-gs\",\"flag-gt\",\"flag-gu\",\"flag-gw\",\"flag-gy\",\"flag-hk\",\"flag-hm\",\"flag-hn\",\"flag-hr\",\"flag-ht\",\"flag-hu\",\"flag-ic\",\"flag-id\",\"flag-ie\",\"flag-il\",\"flag-im\",\"flag-in\",\"flag-io\",\"flag-iq\",\"flag-ir\",\"flag-is\",\"flag-je\",\"flag-jm\",\"flag-jo\",\"flag-ke\",\"flag-kg\",\"flag-kh\",\"flag-ki\",\"flag-km\",\"flag-kn\",\"flag-kp\",\"flag-kw\",\"flag-ky\",\"flag-kz\",\"flag-la\",\"flag-lb\",\"flag-lc\",\"flag-li\",\"flag-lk\",\"flag-lr\",\"flag-ls\",\"flag-lt\",\"flag-lu\",\"flag-lv\",\"flag-ly\",\"flag-ma\",\"flag-mc\",\"flag-md\",\"flag-me\",\"flag-mf\",\"flag-mg\",\"flag-mh\",\"flag-mk\",\"flag-ml\",\"flag-mm\",\"flag-mn\",\"flag-mo\",\"flag-mp\",\"flag-mq\",\"flag-mr\",\"flag-ms\",\"flag-mt\",\"flag-mu\",\"flag-mv\",\"flag-mw\",\"flag-mx\",\"flag-my\",\"flag-mz\",\"flag-na\",\"flag-nc\",\"flag-ne\",\"flag-nf\",\"flag-ng\",\"flag-ni\",\"flag-nl\",\"flag-no\",\"flag-np\",\"flag-nr\",\"flag-nu\",\"flag-nz\",\"flag-om\",\"flag-pa\",\"flag-pe\",\"flag-pf\",\"flag-pg\",\"flag-ph\",\"flag-pk\",\"flag-pl\",\"flag-pm\",\"flag-pn\",\"flag-pr\",\"flag-ps\",\"flag-pt\",\"flag-pw\",\"flag-py\",\"flag-qa\",\"flag-re\",\"flag-ro\",\"flag-rs\",\"flag-rw\",\"flag-sa\",\"flag-sb\",\"flag-sc\",\"flag-scotland\",\"flag-sd\",\"flag-se\",\"flag-sg\",\"flag-sh\",\"flag-si\",\"flag-sj\",\"flag-sk\",\"flag-sl\",\"flag-sm\",\"flag-sn\",\"flag-so\",\"flag-sr\",\"flag-ss\",\"flag-st\",\"flag-sv\",\"flag-sx\",\"flag-sy\",\"flag-sz\",\"flag-ta\",\"flag-tc\",\"flag-td\",\"flag-tf\",\"flag-tg\",\"flag-th\",\"flag-tj\",\"flag-tk\",\"flag-tl\",\"flag-tm\",\"flag-tn\",\"flag-to\",\"flag-tr\",\"flag-tt\",\"flag-tv\",\"flag-tw\",\"flag-tz\",\"flag-ua\",\"flag-ug\",\"flag-um\",\"flag-uy\",\"flag-uz\",\"flag-va\",\"flag-vc\",\"flag-ve\",\"flag-vg\",\"flag-vi\",\"flag-vn\",\"flag-vu\",\"flag-wales\",\"flag-wf\",\"flag-ws\",\"flag-xk\",\"flag-ye\",\"flag-yt\",\"flag-za\",\"flag-zm\",\"flag-zw\",\"fr\",\"gb\",\"it\",\"jp\",\"kr\",\"pirate_flag\",\"rainbow-flag\",\"ru\",\"transgender_flag\",\"triangular_flag_on_post\",\"us\",\"waving_black_flag\",\"waving_white_flag\"]}],\"emojis\":{\"100\":{\"a\":\"Hundred Points Symbol\",\"b\":\"1F4AF\",\"j\":[\"hundred_points\",\"score\",\"perfect\",\"numbers\",\"century\",\"exam\",\"quiz\",\"test\",\"pass\",\"hundred\"],\"k\":[26,6],\"o\":0},\"1234\":{\"a\":\"Input Symbol for Numbers\",\"b\":\"1F522\",\"j\":[\"input_numbers\",\"numbers\",\"blue-square\"],\"k\":[28,4],\"o\":0},\"earth_africa\":{\"a\":\"Earth Globe Europe-Africa\",\"b\":\"1F30D\",\"j\":[\"globe_showing_europe_africa\",\"globe\",\"world\",\"international\"],\"k\":[5,27],\"o\":0},\"grapes\":{\"a\":\"Grapes\",\"b\":\"1F347\",\"j\":[\"grapes\",\"fruit\",\"food\",\"wine\"],\"k\":[6,25],\"o\":0},\"jack_o_lantern\":{\"a\":\"Jack-O-Lantern\",\"b\":\"1F383\",\"j\":[\"jack_o_lantern\",\"halloween\",\"light\",\"pumpkin\",\"creepy\",\"fall\"],\"k\":[7,27],\"o\":0},\"checkered_flag\":{\"a\":\"Chequered Flag\",\"b\":\"1F3C1\",\"j\":[\"chequered_flag\",\"contest\",\"finishline\",\"race\",\"gokart\"],\"k\":[8,31],\"o\":0},\"atm\":{\"a\":\"Automated Teller Machine\",\"b\":\"1F3E7\",\"j\":[\"atm_sign\",\"money\",\"sales\",\"cash\",\"blue-square\",\"payment\",\"bank\"],\"k\":[10,48],\"o\":0},\"monkey_face\":{\"a\":\"Monkey Face\",\"b\":\"1F435\",\"j\":[\"monkey_face\",\"animal\",\"nature\",\"circus\"],\"k\":[12,15],\"l\":[\":o)\"],\"o\":0},\"wave\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F44B-1F3FB\",\"non_qualified\":null,\"image\":\"1f44b-1f3fb.png\",\"sheet_x\":13,\"sheet_y\":17,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F44B-1F3FC\",\"non_qualified\":null,\"image\":\"1f44b-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":18,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F44B-1F3FD\",\"non_qualified\":null,\"image\":\"1f44b-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":19,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F44B-1F3FE\",\"non_qualified\":null,\"image\":\"1f44b-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":20,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F44B-1F3FF\",\"non_qualified\":null,\"image\":\"1f44b-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":21,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Waving Hand Sign\",\"b\":\"1F44B\",\"j\":[\"waving_hand\",\"hands\",\"gesture\",\"goodbye\",\"solong\",\"farewell\",\"hello\",\"hi\",\"palm\"],\"k\":[13,16],\"o\":0},\"eyeglasses\":{\"a\":\"Eyeglasses\",\"b\":\"1F453\",\"j\":[\"glasses\",\"fashion\",\"accessories\",\"eyesight\",\"nerdy\",\"dork\",\"geek\"],\"k\":[13,54],\"o\":0},\"grinning\":{\"a\":\"Grinning Face\",\"b\":\"1F600\",\"j\":[\"grinning_face\",\"face\",\"smile\",\"happy\",\"joy\",\":D\",\"grin\"],\"k\":[30,32],\"m\":\":D\",\"o\":1},\"earth_americas\":{\"a\":\"Earth Globe Americas\",\"b\":\"1F30E\",\"j\":[\"globe_showing_americas\",\"globe\",\"world\",\"USA\",\"international\"],\"k\":[5,28],\"o\":0},\"melon\":{\"a\":\"Melon\",\"b\":\"1F348\",\"j\":[\"melon\",\"fruit\",\"nature\",\"food\"],\"k\":[6,26],\"o\":0},\"christmas_tree\":{\"a\":\"Christmas Tree\",\"b\":\"1F384\",\"j\":[\"christmas_tree\",\"festival\",\"vacation\",\"december\",\"xmas\",\"celebration\"],\"k\":[7,28],\"o\":0},\"monkey\":{\"a\":\"Monkey\",\"b\":\"1F412\",\"j\":[\"monkey\",\"animal\",\"nature\",\"banana\",\"circus\"],\"k\":[11,37],\"o\":0},\"dark_sunglasses\":{\"a\":\"Sunglasses\",\"b\":\"1F576-FE0F\",\"c\":\"1F576\",\"j\":[\"sunglasses\",\"face\",\"cool\",\"accessories\"],\"k\":[29,31],\"o\":0},\"smiley\":{\"a\":\"Smiling Face with Open Mouth\",\"b\":\"1F603\",\"j\":[\"grinning_face_with_big_eyes\",\"face\",\"happy\",\"joy\",\"haha\",\":D\",\":)\",\"smile\",\"funny\"],\"k\":[30,35],\"l\":[\"=)\",\"=-)\"],\"m\":\":)\",\"o\":0},\"triangular_flag_on_post\":{\"a\":\"Triangular Flag on Post\",\"b\":\"1F6A9\",\"j\":[\"triangular_flag\",\"mark\",\"milestone\",\"place\"],\"k\":[34,50],\"o\":0},\"put_litter_in_its_place\":{\"a\":\"Put Litter in Its Place Symbol\",\"b\":\"1F6AE\",\"j\":[\"litter_in_bin_sign\",\"blue-square\",\"sign\",\"human\",\"info\"],\"k\":[34,55],\"o\":1},\"raised_back_of_hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F91A-1F3FB\",\"non_qualified\":null,\"image\":\"1f91a-1f3fb.png\",\"sheet_x\":37,\"sheet_y\":44,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F91A-1F3FC\",\"non_qualified\":null,\"image\":\"1f91a-1f3fc.png\",\"sheet_x\":37,\"sheet_y\":45,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F91A-1F3FD\",\"non_qualified\":null,\"image\":\"1f91a-1f3fd.png\",\"sheet_x\":37,\"sheet_y\":46,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F91A-1F3FE\",\"non_qualified\":null,\"image\":\"1f91a-1f3fe.png\",\"sheet_x\":37,\"sheet_y\":47,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F91A-1F3FF\",\"non_qualified\":null,\"image\":\"1f91a-1f3ff.png\",\"sheet_x\":37,\"sheet_y\":48,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Raised Back of Hand\",\"b\":\"1F91A\",\"j\":[\"raised_back_of_hand\",\"fingers\",\"raised\",\"backhand\"],\"k\":[37,43],\"o\":3},\"earth_asia\":{\"a\":\"Earth Globe Asia-Australia\",\"b\":\"1F30F\",\"j\":[\"globe_showing_asia_australia\",\"globe\",\"world\",\"east\",\"international\"],\"k\":[5,29],\"o\":0},\"watermelon\":{\"a\":\"Watermelon\",\"b\":\"1F349\",\"j\":[\"watermelon\",\"fruit\",\"food\",\"picnic\",\"summer\"],\"k\":[6,27],\"o\":0},\"fireworks\":{\"a\":\"Fireworks\",\"b\":\"1F386\",\"j\":[\"fireworks\",\"photo\",\"festival\",\"carnival\",\"congratulations\"],\"k\":[7,35],\"o\":0},\"crossed_flags\":{\"a\":\"Crossed Flags\",\"b\":\"1F38C\",\"j\":[\"crossed_flags\",\"japanese\",\"nation\",\"country\",\"border\"],\"k\":[7,41],\"o\":0},\"raised_hand_with_fingers_splayed\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F590-1F3FB\",\"non_qualified\":null,\"image\":\"1f590-1f3fb.png\",\"sheet_x\":29,\"sheet_y\":47,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F590-1F3FC\",\"non_qualified\":null,\"image\":\"1f590-1f3fc.png\",\"sheet_x\":29,\"sheet_y\":48,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F590-1F3FD\",\"non_qualified\":null,\"image\":\"1f590-1f3fd.png\",\"sheet_x\":29,\"sheet_y\":49,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F590-1F3FE\",\"non_qualified\":null,\"image\":\"1f590-1f3fe.png\",\"sheet_x\":29,\"sheet_y\":50,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F590-1F3FF\",\"non_qualified\":null,\"image\":\"1f590-1f3ff.png\",\"sheet_x\":29,\"sheet_y\":51,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Hand with Fingers Splayed\",\"b\":\"1F590-FE0F\",\"c\":\"1F590\",\"j\":[\"hand_with_fingers_splayed\",\"hand\",\"fingers\",\"palm\"],\"k\":[29,46],\"o\":0},\"smile\":{\"a\":\"Smiling Face with Open Mouth and Smiling Eyes\",\"b\":\"1F604\",\"j\":[\"grinning_face_with_smiling_eyes\",\"face\",\"happy\",\"joy\",\"funny\",\"haha\",\"laugh\",\"like\",\":D\",\":)\"],\"k\":[30,36],\"l\":[\"C:\",\"c:\",\":D\",\":-D\"],\"m\":\":)\",\"o\":0},\"potable_water\":{\"a\":\"Potable Water Symbol\",\"b\":\"1F6B0\",\"j\":[\"potable_water\",\"blue-square\",\"liquid\",\"restroom\",\"cleaning\",\"faucet\"],\"k\":[34,57],\"o\":1},\"goggles\":{\"a\":\"Goggles\",\"b\":\"1F97D\",\"j\":[\"goggles\",\"eyes\",\"protection\",\"safety\"],\"k\":[42,30],\"o\":11},\"gorilla\":{\"a\":\"Gorilla\",\"b\":\"1F98D\",\"j\":[\"gorilla\",\"animal\",\"nature\",\"circus\"],\"k\":[42,46],\"o\":3},\"globe_with_meridians\":{\"a\":\"Globe with Meridians\",\"b\":\"1F310\",\"j\":[\"globe_with_meridians\",\"earth\",\"international\",\"world\",\"internet\",\"interweb\",\"i18n\"],\"k\":[5,30],\"o\":1},\"tangerine\":{\"a\":\"Tangerine\",\"b\":\"1F34A\",\"j\":[\"tangerine\",\"food\",\"fruit\",\"nature\",\"orange\"],\"k\":[6,28],\"o\":0},\"sparkler\":{\"a\":\"Firework Sparkler\",\"b\":\"1F387\",\"j\":[\"sparkler\",\"stars\",\"night\",\"shine\"],\"k\":[7,36],\"o\":0},\"waving_black_flag\":{\"a\":\"Waving Black Flag\",\"b\":\"1F3F4\",\"j\":[\"black_flag\",\"pirate\"],\"k\":[11,7],\"o\":1},\"grin\":{\"a\":\"Grinning Face with Smiling Eyes\",\"b\":\"1F601\",\"j\":[\"beaming_face_with_smiling_eyes\",\"face\",\"happy\",\"smile\",\"joy\",\"kawaii\"],\"k\":[30,33],\"o\":0},\"lab_coat\":{\"a\":\"Lab Coat\",\"b\":\"1F97C\",\"j\":[\"lab_coat\",\"doctor\",\"experiment\",\"scientist\",\"chemist\"],\"k\":[42,29],\"o\":11},\"orangutan\":{\"a\":\"Orangutan\",\"b\":\"1F9A7\",\"j\":[\"orangutan\",\"animal\"],\"k\":[43,14],\"o\":12},\"wheelchair\":{\"a\":\"Wheelchair Symbol\",\"b\":\"267F\",\"j\":[\"wheelchair_symbol\",\"blue-square\",\"disabled\",\"accessibility\"],\"k\":[54,45],\"o\":0},\"hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"270B-1F3FB\",\"non_qualified\":null,\"image\":\"270b-1f3fb.png\",\"sheet_x\":55,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"270B-1F3FC\",\"non_qualified\":null,\"image\":\"270b-1f3fc.png\",\"sheet_x\":55,\"sheet_y\":56,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"270B-1F3FD\",\"non_qualified\":null,\"image\":\"270b-1f3fd.png\",\"sheet_x\":55,\"sheet_y\":57,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"270B-1F3FE\",\"non_qualified\":null,\"image\":\"270b-1f3fe.png\",\"sheet_x\":56,\"sheet_y\":0,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"270B-1F3FF\",\"non_qualified\":null,\"image\":\"270b-1f3ff.png\",\"sheet_x\":56,\"sheet_y\":1,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Raised Hand\",\"b\":\"270B\",\"j\":[\"raised_hand\",\"fingers\",\"stop\",\"highfive\",\"palm\",\"ban\"],\"k\":[55,54],\"n\":[\"raised_hand\"],\"o\":0},\"lemon\":{\"a\":\"Lemon\",\"b\":\"1F34B\",\"j\":[\"lemon\",\"fruit\",\"nature\"],\"k\":[6,29],\"o\":1},\"waving_white_flag\":{\"a\":\"White Flag\",\"b\":\"1F3F3-FE0F\",\"c\":\"1F3F3\",\"j\":[\"white_flag\",\"losing\",\"loser\",\"lost\",\"surrender\",\"give up\",\"fail\"],\"k\":[11,2],\"o\":0},\"dog\":{\"a\":\"Dog Face\",\"b\":\"1F436\",\"j\":[\"dog_face\",\"animal\",\"friend\",\"nature\",\"woof\",\"puppy\",\"pet\",\"faithful\"],\"k\":[12,16],\"o\":0},\"spock-hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F596-1F3FB\",\"non_qualified\":null,\"image\":\"1f596-1f3fb.png\",\"sheet_x\":30,\"sheet_y\":1,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F596-1F3FC\",\"non_qualified\":null,\"image\":\"1f596-1f3fc.png\",\"sheet_x\":30,\"sheet_y\":2,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F596-1F3FD\",\"non_qualified\":null,\"image\":\"1f596-1f3fd.png\",\"sheet_x\":30,\"sheet_y\":3,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F596-1F3FE\",\"non_qualified\":null,\"image\":\"1f596-1f3fe.png\",\"sheet_x\":30,\"sheet_y\":4,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F596-1F3FF\",\"non_qualified\":null,\"image\":\"1f596-1f3ff.png\",\"sheet_x\":30,\"sheet_y\":5,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Raised Hand with Part Between Middle and Ring Fingers\",\"b\":\"1F596\",\"j\":[\"vulcan_salute\",\"hand\",\"fingers\",\"spock\",\"star trek\"],\"k\":[30,0],\"o\":1},\"world_map\":{\"a\":\"World Map\",\"b\":\"1F5FA-FE0F\",\"c\":\"1F5FA\",\"j\":[\"world_map\",\"location\",\"direction\"],\"k\":[30,26],\"o\":0},\"laughing\":{\"a\":\"Smiling Face with Open Mouth and Tightly-Closed Eyes\",\"b\":\"1F606\",\"j\":[\"grinning_squinting_face\",\"happy\",\"joy\",\"lol\",\"satisfied\",\"haha\",\"face\",\"glad\",\"XD\",\"laugh\"],\"k\":[30,38],\"l\":[\":>\",\":->\"],\"n\":[\"satisfied\"],\"o\":0},\"mens\":{\"a\":\"Mens Symbol\",\"b\":\"1F6B9\",\"j\":[\"men_s_room\",\"toilet\",\"restroom\",\"wc\",\"blue-square\",\"gender\",\"male\"],\"k\":[36,1],\"o\":0},\"safety_vest\":{\"a\":\"Safety Vest\",\"b\":\"1F9BA\",\"j\":[\"safety_vest\",\"protection\"],\"k\":[44,15],\"o\":12},\"firecracker\":{\"a\":\"Firecracker\",\"b\":\"1F9E8\",\"j\":[\"firecracker\",\"dynamite\",\"boom\",\"explode\",\"explosion\",\"explosive\"],\"k\":[51,51],\"o\":11},\"banana\":{\"a\":\"Banana\",\"b\":\"1F34C\",\"j\":[\"banana\",\"fruit\",\"food\",\"monkey\"],\"k\":[6,30],\"o\":0},\"rainbow-flag\":{\"a\":\"Rainbow Flag\",\"b\":\"1F3F3-FE0F-200D-1F308\",\"c\":\"1F3F3-200D-1F308\",\"j\":[\"rainbow_flag\",\"flag\",\"rainbow\",\"pride\",\"gay\",\"lgbt\",\"glbt\",\"queer\",\"homosexual\",\"lesbian\",\"bisexual\",\"transgender\"],\"k\":[11,0],\"o\":4},\"dog2\":{\"a\":\"Dog\",\"b\":\"1F415\",\"j\":[\"dog\",\"animal\",\"nature\",\"friend\",\"doge\",\"pet\",\"faithful\"],\"k\":[11,41],\"o\":0},\"ok_hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F44C-1F3FB\",\"non_qualified\":null,\"image\":\"1f44c-1f3fb.png\",\"sheet_x\":13,\"sheet_y\":23,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F44C-1F3FC\",\"non_qualified\":null,\"image\":\"1f44c-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":24,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F44C-1F3FD\",\"non_qualified\":null,\"image\":\"1f44c-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":25,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F44C-1F3FE\",\"non_qualified\":null,\"image\":\"1f44c-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":26,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F44C-1F3FF\",\"non_qualified\":null,\"image\":\"1f44c-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":27,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Ok Hand Sign\",\"b\":\"1F44C\",\"j\":[\"ok_hand\",\"fingers\",\"limbs\",\"perfect\",\"ok\",\"okay\"],\"k\":[13,22],\"o\":0},\"necktie\":{\"a\":\"Necktie\",\"b\":\"1F454\",\"j\":[\"necktie\",\"shirt\",\"suitup\",\"formal\",\"fashion\",\"cloth\",\"business\"],\"k\":[13,55],\"o\":0},\"japan\":{\"a\":\"Silhouette of Japan\",\"b\":\"1F5FE\",\"j\":[\"map_of_japan\",\"nation\",\"country\",\"japanese\",\"asia\"],\"k\":[30,30],\"o\":0},\"sweat_smile\":{\"a\":\"Smiling Face with Open Mouth and Cold Sweat\",\"b\":\"1F605\",\"j\":[\"grinning_face_with_sweat\",\"face\",\"hot\",\"happy\",\"laugh\",\"sweat\",\"smile\",\"relief\"],\"k\":[30,37],\"o\":0},\"womens\":{\"a\":\"Womens Symbol\",\"b\":\"1F6BA\",\"j\":[\"women_s_room\",\"purple-square\",\"woman\",\"female\",\"toilet\",\"loo\",\"restroom\",\"gender\"],\"k\":[36,2],\"o\":0},\"sparkles\":{\"a\":\"Sparkles\",\"b\":\"2728\",\"j\":[\"sparkles\",\"stars\",\"shine\",\"shiny\",\"cool\",\"awesome\",\"good\",\"magic\"],\"k\":[56,20],\"o\":0},\"pineapple\":{\"a\":\"Pineapple\",\"b\":\"1F34D\",\"j\":[\"pineapple\",\"fruit\",\"nature\",\"food\"],\"k\":[6,31],\"o\":0},\"balloon\":{\"a\":\"Balloon\",\"b\":\"1F388\",\"j\":[\"balloon\",\"party\",\"celebration\",\"birthday\",\"circus\"],\"k\":[7,37],\"o\":0},\"transgender_flag\":{\"a\":\"Transgender Flag\",\"b\":\"1F3F3-FE0F-200D-26A7-FE0F\",\"j\":[\"transgender flag\",\"lgbtq\"],\"k\":[11,1],\"o\":13},\"shirt\":{\"a\":\"T-Shirt\",\"b\":\"1F455\",\"j\":[\"t_shirt\",\"fashion\",\"cloth\",\"casual\",\"shirt\",\"tee\"],\"k\":[13,56],\"n\":[\"tshirt\"],\"o\":0},\"restroom\":{\"a\":\"Restroom\",\"b\":\"1F6BB\",\"j\":[\"restroom\",\"blue-square\",\"toilet\",\"refresh\",\"wc\",\"gender\"],\"k\":[36,3],\"o\":0},\"pinched_fingers\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F90C-1F3FB\",\"non_qualified\":null,\"image\":\"1f90c-1f3fb.png\",\"sheet_x\":37,\"sheet_y\":10,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F90C-1F3FC\",\"non_qualified\":null,\"image\":\"1f90c-1f3fc.png\",\"sheet_x\":37,\"sheet_y\":11,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F90C-1F3FD\",\"non_qualified\":null,\"image\":\"1f90c-1f3fd.png\",\"sheet_x\":37,\"sheet_y\":12,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F90C-1F3FE\",\"non_qualified\":null,\"image\":\"1f90c-1f3fe.png\",\"sheet_x\":37,\"sheet_y\":13,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F90C-1F3FF\",\"non_qualified\":null,\"image\":\"1f90c-1f3ff.png\",\"sheet_x\":37,\"sheet_y\":14,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Pinched Fingers\",\"b\":\"1F90C\",\"j\":[\"pinched fingers\",\"size\",\"tiny\",\"small\"],\"k\":[37,9],\"o\":13},\"rolling_on_the_floor_laughing\":{\"a\":\"Rolling on the Floor Laughing\",\"b\":\"1F923\",\"j\":[\"rolling_on_the_floor_laughing\",\"face\",\"rolling\",\"floor\",\"laughing\",\"lol\",\"haha\"],\"k\":[38,19],\"o\":3},\"guide_dog\":{\"a\":\"Guide Dog\",\"b\":\"1F9AE\",\"j\":[\"guide_dog\",\"animal\",\"blind\"],\"k\":[43,21],\"o\":12},\"compass\":{\"a\":\"Compass\",\"b\":\"1F9ED\",\"j\":[\"compass\",\"magnetic\",\"navigation\",\"orienteering\"],\"k\":[51,56],\"o\":11},\"tada\":{\"a\":\"Party Popper\",\"b\":\"1F389\",\"j\":[\"party_popper\",\"party\",\"congratulations\",\"birthday\",\"magic\",\"circus\",\"celebration\"],\"k\":[7,38],\"o\":0},\"snow_capped_mountain\":{\"a\":\"Snow-Capped Mountain\",\"b\":\"1F3D4-FE0F\",\"c\":\"1F3D4\",\"j\":[\"snow_capped_mountain\",\"photo\",\"nature\",\"environment\",\"winter\",\"cold\"],\"k\":[10,29],\"o\":0},\"pirate_flag\":{\"a\":\"Pirate Flag\",\"b\":\"1F3F4-200D-2620-FE0F\",\"c\":\"1F3F4-200D-2620\",\"j\":[\"pirate_flag\",\"skull\",\"crossbones\",\"flag\",\"banner\"],\"k\":[11,3],\"o\":11},\"service_dog\":{\"a\":\"Service Dog\",\"b\":\"1F415-200D-1F9BA\",\"j\":[\"service_dog\",\"blind\",\"animal\"],\"k\":[11,40],\"o\":12},\"jeans\":{\"a\":\"Jeans\",\"b\":\"1F456\",\"j\":[\"jeans\",\"fashion\",\"shopping\"],\"k\":[13,57],\"o\":0},\"joy\":{\"a\":\"Face with Tears of Joy\",\"b\":\"1F602\",\"j\":[\"face_with_tears_of_joy\",\"face\",\"cry\",\"tears\",\"weep\",\"happy\",\"happytears\",\"haha\"],\"k\":[30,34],\"o\":0},\"baby_symbol\":{\"a\":\"Baby Symbol\",\"b\":\"1F6BC\",\"j\":[\"baby_symbol\",\"orange-square\",\"child\"],\"k\":[36,4],\"o\":0},\"pinching_hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F90F-1F3FB\",\"non_qualified\":null,\"image\":\"1f90f-1f3fb.png\",\"sheet_x\":37,\"sheet_y\":18,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F90F-1F3FC\",\"non_qualified\":null,\"image\":\"1f90f-1f3fc.png\",\"sheet_x\":37,\"sheet_y\":19,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F90F-1F3FD\",\"non_qualified\":null,\"image\":\"1f90f-1f3fd.png\",\"sheet_x\":37,\"sheet_y\":20,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F90F-1F3FE\",\"non_qualified\":null,\"image\":\"1f90f-1f3fe.png\",\"sheet_x\":37,\"sheet_y\":21,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F90F-1F3FF\",\"non_qualified\":null,\"image\":\"1f90f-1f3ff.png\",\"sheet_x\":37,\"sheet_y\":22,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Pinching Hand\",\"b\":\"1F90F\",\"j\":[\"pinching_hand\",\"tiny\",\"small\",\"size\"],\"k\":[37,17],\"o\":12},\"mango\":{\"a\":\"Mango\",\"b\":\"1F96D\",\"j\":[\"mango\",\"fruit\",\"food\",\"tropical\"],\"k\":[42,10],\"o\":11},\"flag-ac\":{\"a\":\"Ascension Island Flag\",\"b\":\"1F1E6-1F1E8\",\"j\":[\"flag_ascension_island\"],\"k\":[0,31],\"o\":2},\"apple\":{\"a\":\"Red Apple\",\"b\":\"1F34E\",\"j\":[\"red_apple\",\"fruit\",\"mac\",\"school\"],\"k\":[6,32],\"o\":0},\"confetti_ball\":{\"a\":\"Confetti Ball\",\"b\":\"1F38A\",\"j\":[\"confetti_ball\",\"festival\",\"party\",\"birthday\",\"circus\"],\"k\":[7,39],\"o\":0},\"poodle\":{\"a\":\"Poodle\",\"b\":\"1F429\",\"j\":[\"poodle\",\"dog\",\"animal\",\"101\",\"nature\",\"pet\"],\"k\":[12,3],\"o\":0},\"slightly_smiling_face\":{\"a\":\"Slightly Smiling Face\",\"b\":\"1F642\",\"j\":[\"slightly_smiling_face\",\"face\",\"smile\"],\"k\":[31,40],\"l\":[\":)\",\"(:\",\":-)\"],\"o\":1},\"wc\":{\"a\":\"Water Closet\",\"b\":\"1F6BE\",\"j\":[\"water_closet\",\"toilet\",\"restroom\",\"blue-square\"],\"k\":[36,6],\"o\":0},\"scarf\":{\"a\":\"Scarf\",\"b\":\"1F9E3\",\"j\":[\"scarf\",\"neck\",\"winter\",\"clothes\"],\"k\":[51,46],\"o\":5},\"mountain\":{\"a\":\"Mountain\",\"b\":\"26F0-FE0F\",\"c\":\"26F0\",\"j\":[\"mountain\",\"photo\",\"nature\",\"environment\"],\"k\":[55,16],\"o\":0},\"v\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"270C-1F3FB\",\"non_qualified\":null,\"image\":\"270c-1f3fb.png\",\"sheet_x\":56,\"sheet_y\":3,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"270C-1F3FC\",\"non_qualified\":null,\"image\":\"270c-1f3fc.png\",\"sheet_x\":56,\"sheet_y\":4,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"270C-1F3FD\",\"non_qualified\":null,\"image\":\"270c-1f3fd.png\",\"sheet_x\":56,\"sheet_y\":5,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"270C-1F3FE\",\"non_qualified\":null,\"image\":\"270c-1f3fe.png\",\"sheet_x\":56,\"sheet_y\":6,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"270C-1F3FF\",\"non_qualified\":null,\"image\":\"270c-1f3ff.png\",\"sheet_x\":56,\"sheet_y\":7,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Victory Hand\",\"b\":\"270C-FE0F\",\"c\":\"270C\",\"j\":[\"victory_hand\",\"fingers\",\"ohyeah\",\"hand\",\"peace\",\"victory\",\"two\"],\"k\":[56,2],\"o\":0},\"flag-ad\":{\"a\":\"Andorra Flag\",\"b\":\"1F1E6-1F1E9\",\"j\":[\"flag_andorra\",\"ad\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,32],\"o\":2},\"volcano\":{\"a\":\"Volcano\",\"b\":\"1F30B\",\"j\":[\"volcano\",\"photo\",\"nature\",\"disaster\"],\"k\":[5,25],\"o\":0},\"green_apple\":{\"a\":\"Green Apple\",\"b\":\"1F34F\",\"j\":[\"green_apple\",\"fruit\",\"nature\"],\"k\":[6,33],\"o\":0},\"tanabata_tree\":{\"a\":\"Tanabata Tree\",\"b\":\"1F38B\",\"j\":[\"tanabata_tree\",\"plant\",\"nature\",\"branch\",\"summer\"],\"k\":[7,40],\"o\":0},\"wolf\":{\"a\":\"Wolf Face\",\"b\":\"1F43A\",\"j\":[\"wolf\",\"animal\",\"nature\",\"wild\"],\"k\":[12,20],\"o\":0},\"upside_down_face\":{\"a\":\"Upside-Down Face\",\"b\":\"1F643\",\"j\":[\"upside_down_face\",\"face\",\"flipped\",\"silly\",\"smile\"],\"k\":[31,41],\"o\":1},\"passport_control\":{\"a\":\"Passport Control\",\"b\":\"1F6C2\",\"j\":[\"passport_control\",\"custom\",\"blue-square\"],\"k\":[36,15],\"o\":1},\"crossed_fingers\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F91E-1F3FB\",\"non_qualified\":null,\"image\":\"1f91e-1f3fb.png\",\"sheet_x\":38,\"sheet_y\":5,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F91E-1F3FC\",\"non_qualified\":null,\"image\":\"1f91e-1f3fc.png\",\"sheet_x\":38,\"sheet_y\":6,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F91E-1F3FD\",\"non_qualified\":null,\"image\":\"1f91e-1f3fd.png\",\"sheet_x\":38,\"sheet_y\":7,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F91E-1F3FE\",\"non_qualified\":null,\"image\":\"1f91e-1f3fe.png\",\"sheet_x\":38,\"sheet_y\":8,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F91E-1F3FF\",\"non_qualified\":null,\"image\":\"1f91e-1f3ff.png\",\"sheet_x\":38,\"sheet_y\":9,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Hand with Index and Middle Fingers Crossed\",\"b\":\"1F91E\",\"j\":[\"crossed_fingers\",\"good\",\"lucky\"],\"k\":[38,4],\"n\":[\"hand_with_index_and_middle_fingers_crossed\"],\"o\":3},\"gloves\":{\"a\":\"Gloves\",\"b\":\"1F9E4\",\"j\":[\"gloves\",\"hands\",\"winter\",\"clothes\"],\"k\":[51,47],\"o\":5},\"flag-ae\":{\"a\":\"United Arab Emirates Flag\",\"b\":\"1F1E6-1F1EA\",\"j\":[\"flag_united_arab_emirates\",\"united\",\"arab\",\"emirates\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,33],\"o\":2},\"pear\":{\"a\":\"Pear\",\"b\":\"1F350\",\"j\":[\"pear\",\"fruit\",\"nature\",\"food\"],\"k\":[6,34],\"o\":1},\"bamboo\":{\"a\":\"Pine Decoration\",\"b\":\"1F38D\",\"j\":[\"pine_decoration\",\"plant\",\"nature\",\"vegetable\",\"panda\",\"pine_decoration\"],\"k\":[7,42],\"o\":0},\"mount_fuji\":{\"a\":\"Mount Fuji\",\"b\":\"1F5FB\",\"j\":[\"mount_fuji\",\"photo\",\"mountain\",\"nature\",\"japanese\"],\"k\":[30,27],\"o\":0},\"wink\":{\"a\":\"Winking Face\",\"b\":\"1F609\",\"j\":[\"winking_face\",\"face\",\"happy\",\"mischievous\",\"secret\",\";)\",\"smile\",\"eye\"],\"k\":[30,41],\"l\":[\";)\",\";-)\"],\"m\":\";)\",\"o\":0},\"customs\":{\"a\":\"Customs\",\"b\":\"1F6C3\",\"j\":[\"customs\",\"passport\",\"border\",\"blue-square\"],\"k\":[36,16],\"o\":1},\"i_love_you_hand_sign\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F91F-1F3FB\",\"non_qualified\":null,\"image\":\"1f91f-1f3fb.png\",\"sheet_x\":38,\"sheet_y\":11,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F91F-1F3FC\",\"non_qualified\":null,\"image\":\"1f91f-1f3fc.png\",\"sheet_x\":38,\"sheet_y\":12,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F91F-1F3FD\",\"non_qualified\":null,\"image\":\"1f91f-1f3fd.png\",\"sheet_x\":38,\"sheet_y\":13,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F91F-1F3FE\",\"non_qualified\":null,\"image\":\"1f91f-1f3fe.png\",\"sheet_x\":38,\"sheet_y\":14,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F91F-1F3FF\",\"non_qualified\":null,\"image\":\"1f91f-1f3ff.png\",\"sheet_x\":38,\"sheet_y\":15,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"I Love You Hand Sign\",\"b\":\"1F91F\",\"j\":[\"love_you_gesture\",\"hand\",\"fingers\",\"gesture\"],\"k\":[38,10],\"o\":5},\"fox_face\":{\"a\":\"Fox Face\",\"b\":\"1F98A\",\"j\":[\"fox\",\"animal\",\"nature\",\"face\"],\"k\":[42,43],\"o\":3},\"coat\":{\"a\":\"Coat\",\"b\":\"1F9E5\",\"j\":[\"coat\",\"jacket\"],\"k\":[51,48],\"o\":5},\"flag-af\":{\"a\":\"Afghanistan Flag\",\"b\":\"1F1E6-1F1EB\",\"j\":[\"flag_afghanistan\",\"af\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,34],\"o\":2},\"peach\":{\"a\":\"Peach\",\"b\":\"1F351\",\"j\":[\"peach\",\"fruit\",\"nature\",\"food\"],\"k\":[6,35],\"o\":0},\"dolls\":{\"a\":\"Japanese Dolls\",\"b\":\"1F38E\",\"j\":[\"japanese_dolls\",\"japanese\",\"toy\",\"kimono\"],\"k\":[7,43],\"o\":0},\"camping\":{\"a\":\"Camping\",\"b\":\"1F3D5-FE0F\",\"c\":\"1F3D5\",\"j\":[\"camping\",\"photo\",\"outdoors\",\"tent\"],\"k\":[10,30],\"o\":0},\"blush\":{\"a\":\"Smiling Face with Smiling Eyes\",\"b\":\"1F60A\",\"j\":[\"smiling_face_with_smiling_eyes\",\"face\",\"smile\",\"happy\",\"flushed\",\"crush\",\"embarrassed\",\"shy\",\"joy\"],\"k\":[30,42],\"m\":\":)\",\"o\":0},\"baggage_claim\":{\"a\":\"Baggage Claim\",\"b\":\"1F6C4\",\"j\":[\"baggage_claim\",\"blue-square\",\"airport\",\"transport\"],\"k\":[36,17],\"o\":1},\"the_horns\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F918-1F3FB\",\"non_qualified\":null,\"image\":\"1f918-1f3fb.png\",\"sheet_x\":37,\"sheet_y\":32,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F918-1F3FC\",\"non_qualified\":null,\"image\":\"1f918-1f3fc.png\",\"sheet_x\":37,\"sheet_y\":33,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F918-1F3FD\",\"non_qualified\":null,\"image\":\"1f918-1f3fd.png\",\"sheet_x\":37,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F918-1F3FE\",\"non_qualified\":null,\"image\":\"1f918-1f3fe.png\",\"sheet_x\":37,\"sheet_y\":35,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F918-1F3FF\",\"non_qualified\":null,\"image\":\"1f918-1f3ff.png\",\"sheet_x\":37,\"sheet_y\":36,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Sign of the Horns\",\"b\":\"1F918\",\"j\":[\"sign_of_the_horns\",\"hand\",\"fingers\",\"evil_eye\",\"sign_of_horns\",\"rock_on\"],\"k\":[37,31],\"n\":[\"sign_of_the_horns\"],\"o\":1},\"raccoon\":{\"a\":\"Raccoon\",\"b\":\"1F99D\",\"j\":[\"raccoon\",\"animal\",\"nature\"],\"k\":[43,4],\"o\":11},\"socks\":{\"a\":\"Socks\",\"b\":\"1F9E6\",\"j\":[\"socks\",\"stockings\",\"clothes\"],\"k\":[51,49],\"o\":5},\"flag-ag\":{\"a\":\"Antigua & Barbuda Flag\",\"b\":\"1F1E6-1F1EC\",\"j\":[\"flag_antigua_barbuda\",\"antigua\",\"barbuda\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,35],\"o\":2},\"cherries\":{\"a\":\"Cherries\",\"b\":\"1F352\",\"j\":[\"cherries\",\"food\",\"fruit\"],\"k\":[6,36],\"o\":0},\"flags\":{\"a\":\"Carp Streamer\",\"b\":\"1F38F\",\"j\":[\"carp_streamer\",\"fish\",\"japanese\",\"koinobori\",\"carp\",\"banner\"],\"k\":[7,44],\"o\":0},\"beach_with_umbrella\":{\"a\":\"Beach with Umbrella\",\"b\":\"1F3D6-FE0F\",\"c\":\"1F3D6\",\"j\":[\"beach_with_umbrella\",\"weather\",\"summer\",\"sunny\",\"sand\",\"mojito\"],\"k\":[10,31],\"o\":0},\"cat\":{\"a\":\"Cat Face\",\"b\":\"1F431\",\"j\":[\"cat_face\",\"animal\",\"meow\",\"nature\",\"pet\",\"kitten\"],\"k\":[12,11],\"o\":0},\"dress\":{\"a\":\"Dress\",\"b\":\"1F457\",\"j\":[\"dress\",\"clothes\",\"fashion\",\"shopping\"],\"k\":[14,0],\"o\":0},\"innocent\":{\"a\":\"Smiling Face with Halo\",\"b\":\"1F607\",\"j\":[\"smiling_face_with_halo\",\"face\",\"angel\",\"heaven\",\"halo\"],\"k\":[30,39],\"o\":1},\"left_luggage\":{\"a\":\"Left Luggage\",\"b\":\"1F6C5\",\"j\":[\"left_luggage\",\"blue-square\",\"travel\"],\"k\":[36,18],\"o\":1},\"call_me_hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F919-1F3FB\",\"non_qualified\":null,\"image\":\"1f919-1f3fb.png\",\"sheet_x\":37,\"sheet_y\":38,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F919-1F3FC\",\"non_qualified\":null,\"image\":\"1f919-1f3fc.png\",\"sheet_x\":37,\"sheet_y\":39,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F919-1F3FD\",\"non_qualified\":null,\"image\":\"1f919-1f3fd.png\",\"sheet_x\":37,\"sheet_y\":40,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F919-1F3FE\",\"non_qualified\":null,\"image\":\"1f919-1f3fe.png\",\"sheet_x\":37,\"sheet_y\":41,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F919-1F3FF\",\"non_qualified\":null,\"image\":\"1f919-1f3ff.png\",\"sheet_x\":37,\"sheet_y\":42,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Call Me Hand\",\"b\":\"1F919\",\"j\":[\"call_me_hand\",\"hands\",\"gesture\"],\"k\":[37,37],\"o\":3},\"flag-ai\":{\"a\":\"Anguilla Flag\",\"b\":\"1F1E6-1F1EE\",\"j\":[\"flag_anguilla\",\"ai\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,36],\"o\":2},\"strawberry\":{\"a\":\"Strawberry\",\"b\":\"1F353\",\"j\":[\"strawberry\",\"fruit\",\"food\",\"nature\"],\"k\":[6,37],\"o\":0},\"wind_chime\":{\"a\":\"Wind Chime\",\"b\":\"1F390\",\"j\":[\"wind_chime\",\"nature\",\"ding\",\"spring\",\"bell\"],\"k\":[7,45],\"o\":0},\"desert\":{\"a\":\"Desert\",\"b\":\"1F3DC-FE0F\",\"c\":\"1F3DC\",\"j\":[\"desert\",\"photo\",\"warm\",\"saharah\"],\"k\":[10,37],\"o\":0},\"cat2\":{\"a\":\"Cat\",\"b\":\"1F408\",\"j\":[\"cat\",\"animal\",\"meow\",\"pet\",\"cats\"],\"k\":[11,27],\"o\":0},\"point_left\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F448-1F3FB\",\"non_qualified\":null,\"image\":\"1f448-1f3fb.png\",\"sheet_x\":12,\"sheet_y\":57,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F448-1F3FC\",\"non_qualified\":null,\"image\":\"1f448-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":0,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F448-1F3FD\",\"non_qualified\":null,\"image\":\"1f448-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":1,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F448-1F3FE\",\"non_qualified\":null,\"image\":\"1f448-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":2,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F448-1F3FF\",\"non_qualified\":null,\"image\":\"1f448-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":3,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"White Left Pointing Backhand Index\",\"b\":\"1F448\",\"j\":[\"backhand_index_pointing_left\",\"direction\",\"fingers\",\"hand\",\"left\"],\"k\":[12,56],\"o\":0},\"kimono\":{\"a\":\"Kimono\",\"b\":\"1F458\",\"j\":[\"kimono\",\"dress\",\"fashion\",\"women\",\"female\",\"japanese\"],\"k\":[14,1],\"o\":0},\"smiling_face_with_3_hearts\":{\"a\":\"Smiling Face with Smiling Eyes and Three Hearts\",\"b\":\"1F970\",\"j\":[\"smiling_face_with_hearts\",\"face\",\"love\",\"like\",\"affection\",\"valentines\",\"infatuation\",\"crush\",\"hearts\",\"adore\"],\"k\":[42,13],\"o\":11},\"warning\":{\"a\":\"Warning Sign\",\"b\":\"26A0-FE0F\",\"c\":\"26A0\",\"j\":[\"warning\",\"exclamation\",\"wip\",\"alert\",\"error\",\"problem\",\"issue\"],\"k\":[54,55],\"o\":0},\"flag-al\":{\"a\":\"Albania Flag\",\"b\":\"1F1E6-1F1F1\",\"j\":[\"flag_albania\",\"al\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,37],\"o\":2},\"rice_scene\":{\"a\":\"Moon Viewing Ceremony\",\"b\":\"1F391\",\"j\":[\"moon_viewing_ceremony\",\"photo\",\"japan\",\"asia\",\"tsukimi\"],\"k\":[7,46],\"o\":0},\"desert_island\":{\"a\":\"Desert Island\",\"b\":\"1F3DD-FE0F\",\"c\":\"1F3DD\",\"j\":[\"desert_island\",\"photo\",\"tropical\",\"mojito\"],\"k\":[10,38],\"o\":0},\"black_cat\":{\"a\":\"Black Cat\",\"b\":\"1F408-200D-2B1B\",\"j\":[\"black cat\",\"superstition\",\"luck\"],\"k\":[11,26],\"o\":13},\"point_right\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F449-1F3FB\",\"non_qualified\":null,\"image\":\"1f449-1f3fb.png\",\"sheet_x\":13,\"sheet_y\":5,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F449-1F3FC\",\"non_qualified\":null,\"image\":\"1f449-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":6,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F449-1F3FD\",\"non_qualified\":null,\"image\":\"1f449-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":7,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F449-1F3FE\",\"non_qualified\":null,\"image\":\"1f449-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":8,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F449-1F3FF\",\"non_qualified\":null,\"image\":\"1f449-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":9,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"White Right Pointing Backhand Index\",\"b\":\"1F449\",\"j\":[\"backhand_index_pointing_right\",\"fingers\",\"hand\",\"direction\",\"right\"],\"k\":[13,4],\"o\":0},\"heart_eyes\":{\"a\":\"Smiling Face with Heart-Shaped Eyes\",\"b\":\"1F60D\",\"j\":[\"smiling_face_with_heart_eyes\",\"face\",\"love\",\"like\",\"affection\",\"valentines\",\"infatuation\",\"crush\",\"heart\"],\"k\":[30,45],\"o\":0},\"children_crossing\":{\"a\":\"Children Crossing\",\"b\":\"1F6B8\",\"j\":[\"children_crossing\",\"school\",\"warning\",\"danger\",\"sign\",\"driving\",\"yellow-diamond\"],\"k\":[36,0],\"o\":1},\"sari\":{\"a\":\"Sari\",\"b\":\"1F97B\",\"j\":[\"sari\",\"dress\"],\"k\":[42,28],\"o\":12},\"blueberries\":{\"a\":\"Blueberries\",\"b\":\"1FAD0\",\"j\":[\"blueberries\",\"fruit\"],\"k\":[53,9],\"o\":13},\"flag-am\":{\"a\":\"Armenia Flag\",\"b\":\"1F1E6-1F1F2\",\"j\":[\"flag_armenia\",\"am\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,38],\"o\":2},\"national_park\":{\"a\":\"National Park\",\"b\":\"1F3DE-FE0F\",\"c\":\"1F3DE\",\"j\":[\"national_park\",\"photo\",\"environment\",\"nature\"],\"k\":[10,39],\"o\":0},\"point_up_2\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F446-1F3FB\",\"non_qualified\":null,\"image\":\"1f446-1f3fb.png\",\"sheet_x\":12,\"sheet_y\":45,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F446-1F3FC\",\"non_qualified\":null,\"image\":\"1f446-1f3fc.png\",\"sheet_x\":12,\"sheet_y\":46,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F446-1F3FD\",\"non_qualified\":null,\"image\":\"1f446-1f3fd.png\",\"sheet_x\":12,\"sheet_y\":47,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F446-1F3FE\",\"non_qualified\":null,\"image\":\"1f446-1f3fe.png\",\"sheet_x\":12,\"sheet_y\":48,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F446-1F3FF\",\"non_qualified\":null,\"image\":\"1f446-1f3ff.png\",\"sheet_x\":12,\"sheet_y\":49,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"White Up Pointing Backhand Index\",\"b\":\"1F446\",\"j\":[\"backhand_index_pointing_up\",\"fingers\",\"hand\",\"direction\",\"up\"],\"k\":[12,44],\"o\":0},\"star-struck\":{\"a\":\"Grinning Face with Star Eyes\",\"b\":\"1F929\",\"j\":[\"star_struck\",\"face\",\"smile\",\"starry\",\"eyes\",\"grinning\"],\"k\":[38,42],\"n\":[\"grinning_face_with_star_eyes\"],\"o\":5},\"kiwifruit\":{\"a\":\"Kiwifruit\",\"b\":\"1F95D\",\"j\":[\"kiwi_fruit\",\"fruit\",\"food\"],\"k\":[41,52],\"o\":3},\"lion_face\":{\"a\":\"Lion Face\",\"b\":\"1F981\",\"j\":[\"lion\",\"animal\",\"nature\"],\"k\":[42,34],\"o\":1},\"red_envelope\":{\"a\":\"Red Gift Envelope\",\"b\":\"1F9E7\",\"j\":[\"red_envelope\",\"gift\"],\"k\":[51,50],\"o\":11},\"one-piece_swimsuit\":{\"a\":\"One-Piece Swimsuit\",\"b\":\"1FA71\",\"j\":[\"one_piece_swimsuit\",\"fashion\"],\"k\":[52,18],\"o\":12},\"no_entry\":{\"a\":\"No Entry\",\"b\":\"26D4\",\"j\":[\"no_entry\",\"limit\",\"security\",\"privacy\",\"bad\",\"denied\",\"stop\",\"circle\"],\"k\":[55,13],\"o\":0},\"flag-ao\":{\"a\":\"Angola Flag\",\"b\":\"1F1E6-1F1F4\",\"j\":[\"flag_angola\",\"ao\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,39],\"o\":2},\"tomato\":{\"a\":\"Tomato\",\"b\":\"1F345\",\"j\":[\"tomato\",\"fruit\",\"vegetable\",\"nature\",\"food\"],\"k\":[6,23],\"o\":0},\"ribbon\":{\"a\":\"Ribbon\",\"b\":\"1F380\",\"j\":[\"ribbon\",\"decoration\",\"pink\",\"girl\",\"bowtie\"],\"k\":[7,24],\"o\":0},\"stadium\":{\"a\":\"Stadium\",\"b\":\"1F3DF-FE0F\",\"c\":\"1F3DF\",\"j\":[\"stadium\",\"photo\",\"place\",\"sports\",\"concert\",\"venue\"],\"k\":[10,40],\"o\":0},\"tiger\":{\"a\":\"Tiger Face\",\"b\":\"1F42F\",\"j\":[\"tiger_face\",\"animal\",\"cat\",\"danger\",\"wild\",\"nature\",\"roar\"],\"k\":[12,9],\"o\":0},\"middle_finger\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F595-1F3FB\",\"non_qualified\":null,\"image\":\"1f595-1f3fb.png\",\"sheet_x\":29,\"sheet_y\":53,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F595-1F3FC\",\"non_qualified\":null,\"image\":\"1f595-1f3fc.png\",\"sheet_x\":29,\"sheet_y\":54,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F595-1F3FD\",\"non_qualified\":null,\"image\":\"1f595-1f3fd.png\",\"sheet_x\":29,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F595-1F3FE\",\"non_qualified\":null,\"image\":\"1f595-1f3fe.png\",\"sheet_x\":29,\"sheet_y\":56,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F595-1F3FF\",\"non_qualified\":null,\"image\":\"1f595-1f3ff.png\",\"sheet_x\":29,\"sheet_y\":57,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Reversed Hand with Middle Finger Extended\",\"b\":\"1F595\",\"j\":[\"middle_finger\",\"hand\",\"fingers\",\"rude\",\"middle\",\"flipping\"],\"k\":[29,52],\"n\":[\"reversed_hand_with_middle_finger_extended\"],\"o\":1},\"kissing_heart\":{\"a\":\"Face Throwing a Kiss\",\"b\":\"1F618\",\"j\":[\"face_blowing_a_kiss\",\"face\",\"love\",\"like\",\"affection\",\"valentines\",\"infatuation\",\"kiss\"],\"k\":[30,56],\"l\":[\":*\",\":-*\"],\"o\":0},\"no_entry_sign\":{\"a\":\"No Entry Sign\",\"b\":\"1F6AB\",\"j\":[\"prohibited\",\"forbid\",\"stop\",\"limit\",\"denied\",\"disallow\",\"circle\"],\"k\":[34,52],\"o\":0},\"briefs\":{\"a\":\"Briefs\",\"b\":\"1FA72\",\"j\":[\"briefs\",\"clothing\"],\"k\":[52,19],\"o\":12},\"flag-aq\":{\"a\":\"Antarctica Flag\",\"b\":\"1F1E6-1F1F6\",\"j\":[\"flag_antarctica\",\"aq\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,40],\"o\":2},\"gift\":{\"a\":\"Wrapped Present\",\"b\":\"1F381\",\"j\":[\"wrapped_gift\",\"present\",\"birthday\",\"christmas\",\"xmas\"],\"k\":[7,25],\"o\":0},\"classical_building\":{\"a\":\"Classical Building\",\"b\":\"1F3DB-FE0F\",\"c\":\"1F3DB\",\"j\":[\"classical_building\",\"art\",\"culture\",\"history\"],\"k\":[10,36],\"o\":0},\"tiger2\":{\"a\":\"Tiger\",\"b\":\"1F405\",\"j\":[\"tiger\",\"animal\",\"nature\",\"roar\"],\"k\":[11,23],\"o\":1},\"point_down\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F447-1F3FB\",\"non_qualified\":null,\"image\":\"1f447-1f3fb.png\",\"sheet_x\":12,\"sheet_y\":51,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F447-1F3FC\",\"non_qualified\":null,\"image\":\"1f447-1f3fc.png\",\"sheet_x\":12,\"sheet_y\":52,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F447-1F3FD\",\"non_qualified\":null,\"image\":\"1f447-1f3fd.png\",\"sheet_x\":12,\"sheet_y\":53,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F447-1F3FE\",\"non_qualified\":null,\"image\":\"1f447-1f3fe.png\",\"sheet_x\":12,\"sheet_y\":54,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F447-1F3FF\",\"non_qualified\":null,\"image\":\"1f447-1f3ff.png\",\"sheet_x\":12,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"White Down Pointing Backhand Index\",\"b\":\"1F447\",\"j\":[\"backhand_index_pointing_down\",\"fingers\",\"hand\",\"direction\",\"down\"],\"k\":[12,50],\"o\":0},\"kissing\":{\"a\":\"Kissing Face\",\"b\":\"1F617\",\"j\":[\"kissing_face\",\"love\",\"like\",\"face\",\"3\",\"valentines\",\"infatuation\",\"kiss\"],\"k\":[30,55],\"o\":1},\"no_bicycles\":{\"a\":\"No Bicycles\",\"b\":\"1F6B3\",\"j\":[\"no_bicycles\",\"cyclist\",\"prohibited\",\"circle\"],\"k\":[35,2],\"o\":1},\"shorts\":{\"a\":\"Shorts\",\"b\":\"1FA73\",\"j\":[\"shorts\",\"clothing\"],\"k\":[52,20],\"o\":12},\"olive\":{\"a\":\"Olive\",\"b\":\"1FAD2\",\"j\":[\"olive\",\"fruit\"],\"k\":[53,11],\"o\":13},\"flag-ar\":{\"a\":\"Argentina Flag\",\"b\":\"1F1E6-1F1F7\",\"j\":[\"flag_argentina\",\"ar\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,41],\"o\":2},\"reminder_ribbon\":{\"a\":\"Reminder Ribbon\",\"b\":\"1F397-FE0F\",\"c\":\"1F397\",\"j\":[\"reminder_ribbon\",\"sports\",\"cause\",\"support\",\"awareness\"],\"k\":[7,50],\"o\":0},\"building_construction\":{\"a\":\"Building Construction\",\"b\":\"1F3D7-FE0F\",\"c\":\"1F3D7\",\"j\":[\"building_construction\",\"wip\",\"working\",\"progress\"],\"k\":[10,32],\"o\":0},\"leopard\":{\"a\":\"Leopard\",\"b\":\"1F406\",\"j\":[\"leopard\",\"animal\",\"nature\"],\"k\":[11,24],\"o\":1},\"bikini\":{\"a\":\"Bikini\",\"b\":\"1F459\",\"j\":[\"bikini\",\"swimming\",\"female\",\"woman\",\"girl\",\"fashion\",\"beach\",\"summer\"],\"k\":[14,2],\"o\":0},\"no_smoking\":{\"a\":\"No Smoking Symbol\",\"b\":\"1F6AD\",\"j\":[\"no_smoking\",\"cigarette\",\"blue-square\",\"smell\",\"smoke\"],\"k\":[34,54],\"o\":0},\"coconut\":{\"a\":\"Coconut\",\"b\":\"1F965\",\"j\":[\"coconut\",\"fruit\",\"nature\",\"food\",\"palm\"],\"k\":[42,2],\"o\":5},\"point_up\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"261D-1F3FB\",\"non_qualified\":null,\"image\":\"261d-1f3fb.png\",\"sheet_x\":54,\"sheet_y\":8,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"261D-1F3FC\",\"non_qualified\":null,\"image\":\"261d-1f3fc.png\",\"sheet_x\":54,\"sheet_y\":9,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"261D-1F3FD\",\"non_qualified\":null,\"image\":\"261d-1f3fd.png\",\"sheet_x\":54,\"sheet_y\":10,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"261D-1F3FE\",\"non_qualified\":null,\"image\":\"261d-1f3fe.png\",\"sheet_x\":54,\"sheet_y\":11,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"261D-1F3FF\",\"non_qualified\":null,\"image\":\"261d-1f3ff.png\",\"sheet_x\":54,\"sheet_y\":12,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"White Up Pointing Index\",\"b\":\"261D-FE0F\",\"c\":\"261D\",\"j\":[\"index_pointing_up\",\"hand\",\"fingers\",\"direction\",\"up\"],\"k\":[54,7],\"o\":0},\"relaxed\":{\"a\":\"White Smiling Face\",\"b\":\"263A-FE0F\",\"c\":\"263A\",\"j\":[\"smiling_face\",\"face\",\"blush\",\"massage\",\"happiness\"],\"k\":[54,22],\"o\":0},\"flag-as\":{\"a\":\"American Samoa Flag\",\"b\":\"1F1E6-1F1F8\",\"j\":[\"flag_american_samoa\",\"american\",\"ws\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,42],\"o\":2},\"admission_tickets\":{\"a\":\"Admission Tickets\",\"b\":\"1F39F-FE0F\",\"c\":\"1F39F\",\"j\":[\"admission_tickets\",\"sports\",\"concert\",\"entrance\"],\"k\":[7,55],\"o\":0},\"horse\":{\"a\":\"Horse Face\",\"b\":\"1F434\",\"j\":[\"horse_face\",\"animal\",\"brown\",\"nature\"],\"k\":[12,14],\"o\":0},\"+1\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F44D-1F3FB\",\"non_qualified\":null,\"image\":\"1f44d-1f3fb.png\",\"sheet_x\":13,\"sheet_y\":29,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F44D-1F3FC\",\"non_qualified\":null,\"image\":\"1f44d-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":30,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F44D-1F3FD\",\"non_qualified\":null,\"image\":\"1f44d-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":31,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F44D-1F3FE\",\"non_qualified\":null,\"image\":\"1f44d-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":32,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F44D-1F3FF\",\"non_qualified\":null,\"image\":\"1f44d-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":33,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Thumbs Up Sign\",\"b\":\"1F44D\",\"j\":[\"thumbs_up\",\"thumbsup\",\"yes\",\"awesome\",\"good\",\"agree\",\"accept\",\"cool\",\"hand\",\"like\"],\"k\":[13,28],\"n\":[\"thumbsup\"],\"o\":0},\"womans_clothes\":{\"a\":\"Womans Clothes\",\"b\":\"1F45A\",\"j\":[\"woman_s_clothes\",\"fashion\",\"shopping_bags\",\"female\"],\"k\":[14,3],\"o\":0},\"kissing_closed_eyes\":{\"a\":\"Kissing Face with Closed Eyes\",\"b\":\"1F61A\",\"j\":[\"kissing_face_with_closed_eyes\",\"face\",\"love\",\"like\",\"affection\",\"valentines\",\"infatuation\",\"kiss\"],\"k\":[31,0],\"o\":0},\"do_not_litter\":{\"a\":\"Do Not Litter Symbol\",\"b\":\"1F6AF\",\"j\":[\"no_littering\",\"trash\",\"bin\",\"garbage\",\"circle\"],\"k\":[34,56],\"o\":1},\"avocado\":{\"a\":\"Avocado\",\"b\":\"1F951\",\"j\":[\"avocado\",\"fruit\",\"food\"],\"k\":[41,40],\"o\":3},\"bricks\":{\"a\":\"Brick\",\"b\":\"1F9F1\",\"j\":[\"brick\",\"bricks\"],\"k\":[52,2],\"o\":11},\"flag-at\":{\"a\":\"Austria Flag\",\"b\":\"1F1E6-1F1F9\",\"j\":[\"flag_austria\",\"at\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,43],\"o\":2},\"eggplant\":{\"a\":\"Aubergine\",\"b\":\"1F346\",\"j\":[\"eggplant\",\"vegetable\",\"nature\",\"food\",\"aubergine\"],\"k\":[6,24],\"o\":0},\"ticket\":{\"a\":\"Ticket\",\"b\":\"1F3AB\",\"j\":[\"ticket\",\"event\",\"concert\",\"pass\"],\"k\":[8,9],\"o\":0},\"racehorse\":{\"a\":\"Horse\",\"b\":\"1F40E\",\"j\":[\"horse\",\"animal\",\"gamble\",\"luck\"],\"k\":[11,33],\"o\":0},\"-1\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F44E-1F3FB\",\"non_qualified\":null,\"image\":\"1f44e-1f3fb.png\",\"sheet_x\":13,\"sheet_y\":35,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F44E-1F3FC\",\"non_qualified\":null,\"image\":\"1f44e-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":36,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F44E-1F3FD\",\"non_qualified\":null,\"image\":\"1f44e-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":37,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F44E-1F3FE\",\"non_qualified\":null,\"image\":\"1f44e-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":38,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F44E-1F3FF\",\"non_qualified\":null,\"image\":\"1f44e-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":39,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Thumbs Down Sign\",\"b\":\"1F44E\",\"j\":[\"thumbs_down\",\"thumbsdown\",\"no\",\"dislike\",\"hand\"],\"k\":[13,34],\"n\":[\"thumbsdown\"],\"o\":0},\"purse\":{\"a\":\"Purse\",\"b\":\"1F45B\",\"j\":[\"purse\",\"fashion\",\"accessories\",\"money\",\"sales\",\"shopping\"],\"k\":[14,4],\"o\":0},\"kissing_smiling_eyes\":{\"a\":\"Kissing Face with Smiling Eyes\",\"b\":\"1F619\",\"j\":[\"kissing_face_with_smiling_eyes\",\"face\",\"affection\",\"valentines\",\"infatuation\",\"kiss\"],\"k\":[30,57],\"o\":1},\"non-potable_water\":{\"a\":\"Non-Potable Water Symbol\",\"b\":\"1F6B1\",\"j\":[\"non_potable_water\",\"drink\",\"faucet\",\"tap\",\"circle\"],\"k\":[35,0],\"o\":1},\"rock\":{\"a\":\"Rock\",\"b\":\"1FAA8\",\"j\":[\"rock\",\"stone\"],\"k\":[52,56],\"o\":13},\"flag-au\":{\"a\":\"Australia Flag\",\"b\":\"1F1E6-1F1FA\",\"j\":[\"flag_australia\",\"au\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,44],\"o\":2},\"medal\":{\"a\":\"Military Medal\",\"b\":\"1F396-FE0F\",\"c\":\"1F396\",\"j\":[\"military_medal\",\"award\",\"winning\",\"army\"],\"k\":[7,49],\"o\":0},\"handbag\":{\"a\":\"Handbag\",\"b\":\"1F45C\",\"j\":[\"handbag\",\"fashion\",\"accessory\",\"accessories\",\"shopping\"],\"k\":[14,5],\"o\":0},\"no_pedestrians\":{\"a\":\"No Pedestrians\",\"b\":\"1F6B7\",\"j\":[\"no_pedestrians\",\"rules\",\"crossing\",\"walking\",\"circle\"],\"k\":[35,57],\"o\":1},\"potato\":{\"a\":\"Potato\",\"b\":\"1F954\",\"j\":[\"potato\",\"food\",\"tuber\",\"vegatable\",\"starch\"],\"k\":[41,43],\"o\":3},\"smiling_face_with_tear\":{\"a\":\"Smiling Face with Tear\",\"b\":\"1F972\",\"j\":[\"smiling face with tear\",\"sad\",\"cry\",\"pretend\"],\"k\":[42,15],\"o\":13},\"unicorn_face\":{\"a\":\"Unicorn Face\",\"b\":\"1F984\",\"j\":[\"unicorn\",\"animal\",\"nature\",\"mystical\"],\"k\":[42,37],\"o\":1},\"wood\":{\"a\":\"Wood\",\"b\":\"1FAB5\",\"j\":[\"wood\",\"nature\",\"timber\",\"trunk\"],\"k\":[53,4],\"o\":13},\"fist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"270A-1F3FB\",\"non_qualified\":null,\"image\":\"270a-1f3fb.png\",\"sheet_x\":55,\"sheet_y\":49,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"270A-1F3FC\",\"non_qualified\":null,\"image\":\"270a-1f3fc.png\",\"sheet_x\":55,\"sheet_y\":50,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"270A-1F3FD\",\"non_qualified\":null,\"image\":\"270a-1f3fd.png\",\"sheet_x\":55,\"sheet_y\":51,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"270A-1F3FE\",\"non_qualified\":null,\"image\":\"270a-1f3fe.png\",\"sheet_x\":55,\"sheet_y\":52,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"270A-1F3FF\",\"non_qualified\":null,\"image\":\"270a-1f3ff.png\",\"sheet_x\":55,\"sheet_y\":53,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Raised Fist\",\"b\":\"270A\",\"j\":[\"raised_fist\",\"fingers\",\"hand\",\"grasp\"],\"k\":[55,48],\"o\":0},\"flag-aw\":{\"a\":\"Aruba Flag\",\"b\":\"1F1E6-1F1FC\",\"j\":[\"flag_aruba\",\"aw\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,45],\"o\":2},\"trophy\":{\"a\":\"Trophy\",\"b\":\"1F3C6\",\"j\":[\"trophy\",\"win\",\"award\",\"contest\",\"place\",\"ftw\",\"ceremony\"],\"k\":[9,17],\"o\":0},\"facepunch\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F44A-1F3FB\",\"non_qualified\":null,\"image\":\"1f44a-1f3fb.png\",\"sheet_x\":13,\"sheet_y\":11,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F44A-1F3FC\",\"non_qualified\":null,\"image\":\"1f44a-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":12,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F44A-1F3FD\",\"non_qualified\":null,\"image\":\"1f44a-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":13,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F44A-1F3FE\",\"non_qualified\":null,\"image\":\"1f44a-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":14,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F44A-1F3FF\",\"non_qualified\":null,\"image\":\"1f44a-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":15,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Fisted Hand Sign\",\"b\":\"1F44A\",\"j\":[\"oncoming_fist\",\"angry\",\"violence\",\"fist\",\"hit\",\"attack\",\"hand\"],\"k\":[13,10],\"n\":[\"punch\"],\"o\":0},\"pouch\":{\"a\":\"Pouch\",\"b\":\"1F45D\",\"j\":[\"clutch_bag\",\"bag\",\"accessories\",\"shopping\"],\"k\":[14,6],\"o\":0},\"no_mobile_phones\":{\"a\":\"No Mobile Phones\",\"b\":\"1F4F5\",\"j\":[\"no_mobile_phones\",\"iphone\",\"mute\",\"circle\"],\"k\":[27,18],\"o\":1},\"yum\":{\"a\":\"Face Savouring Delicious Food\",\"b\":\"1F60B\",\"j\":[\"face_savoring_food\",\"happy\",\"joy\",\"tongue\",\"smile\",\"face\",\"silly\",\"yummy\",\"nom\",\"delicious\",\"savouring\"],\"k\":[30,43],\"o\":0},\"hut\":{\"a\":\"Hut\",\"b\":\"1F6D6\",\"j\":[\"hut\",\"house\",\"structure\"],\"k\":[36,33],\"o\":13},\"carrot\":{\"a\":\"Carrot\",\"b\":\"1F955\",\"j\":[\"carrot\",\"vegetable\",\"food\",\"orange\"],\"k\":[41,44],\"o\":3},\"zebra_face\":{\"a\":\"Zebra Face\",\"b\":\"1F993\",\"j\":[\"zebra\",\"animal\",\"nature\",\"stripes\",\"safari\"],\"k\":[42,52],\"o\":5},\"flag-ax\":{\"a\":\"Åland Islands Flag\",\"b\":\"1F1E6-1F1FD\",\"j\":[\"flag_aland_islands\",\"Åland\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,46],\"o\":2},\"corn\":{\"a\":\"Ear of Maize\",\"b\":\"1F33D\",\"j\":[\"ear_of_corn\",\"food\",\"vegetable\",\"plant\"],\"k\":[6,15],\"o\":0},\"sports_medal\":{\"a\":\"Sports Medal\",\"b\":\"1F3C5\",\"j\":[\"sports_medal\",\"award\",\"winning\"],\"k\":[9,16],\"o\":1},\"house_buildings\":{\"a\":\"Houses\",\"b\":\"1F3D8-FE0F\",\"c\":\"1F3D8\",\"j\":[\"houses\",\"buildings\",\"photo\"],\"k\":[10,33],\"o\":0},\"underage\":{\"a\":\"No One Under Eighteen Symbol\",\"b\":\"1F51E\",\"j\":[\"no_one_under_eighteen\",\"18\",\"drink\",\"pub\",\"night\",\"minor\",\"circle\"],\"k\":[28,0],\"o\":0},\"stuck_out_tongue\":{\"a\":\"Face with Stuck-out Tongue\",\"b\":\"1F61B\",\"j\":[\"face_with_tongue\",\"face\",\"prank\",\"childish\",\"playful\",\"mischievous\",\"smile\",\"tongue\"],\"k\":[31,1],\"l\":[\":p\",\":-p\",\":P\",\":-P\",\":b\",\":-b\"],\"m\":\":p\",\"o\":1},\"shopping_bags\":{\"a\":\"Shopping Bags\",\"b\":\"1F6CD-FE0F\",\"c\":\"1F6CD\",\"j\":[\"shopping_bags\",\"mall\",\"buy\",\"purchase\"],\"k\":[36,26],\"o\":0},\"left-facing_fist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F91B-1F3FB\",\"non_qualified\":null,\"image\":\"1f91b-1f3fb.png\",\"sheet_x\":37,\"sheet_y\":50,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F91B-1F3FC\",\"non_qualified\":null,\"image\":\"1f91b-1f3fc.png\",\"sheet_x\":37,\"sheet_y\":51,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F91B-1F3FD\",\"non_qualified\":null,\"image\":\"1f91b-1f3fd.png\",\"sheet_x\":37,\"sheet_y\":52,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F91B-1F3FE\",\"non_qualified\":null,\"image\":\"1f91b-1f3fe.png\",\"sheet_x\":37,\"sheet_y\":53,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F91B-1F3FF\",\"non_qualified\":null,\"image\":\"1f91b-1f3ff.png\",\"sheet_x\":37,\"sheet_y\":54,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Left-Facing Fist\",\"b\":\"1F91B\",\"j\":[\"left_facing_fist\",\"hand\",\"fistbump\"],\"k\":[37,49],\"o\":3},\"deer\":{\"a\":\"Deer\",\"b\":\"1F98C\",\"j\":[\"deer\",\"animal\",\"nature\",\"horns\",\"venison\"],\"k\":[42,45],\"o\":3},\"flag-az\":{\"a\":\"Azerbaijan Flag\",\"b\":\"1F1E6-1F1FF\",\"j\":[\"flag_azerbaijan\",\"az\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,47],\"o\":2},\"hot_pepper\":{\"a\":\"Hot Pepper\",\"b\":\"1F336-FE0F\",\"c\":\"1F336\",\"j\":[\"hot_pepper\",\"food\",\"spicy\",\"chilli\",\"chili\"],\"k\":[6,8],\"o\":0},\"school_satchel\":{\"a\":\"School Satchel\",\"b\":\"1F392\",\"j\":[\"backpack\",\"student\",\"education\",\"bag\",\"backpack\"],\"k\":[7,47],\"o\":0},\"derelict_house_building\":{\"a\":\"Derelict House\",\"b\":\"1F3DA-FE0F\",\"c\":\"1F3DA\",\"j\":[\"derelict_house\",\"abandon\",\"evict\",\"broken\",\"building\"],\"k\":[10,35],\"o\":0},\"stuck_out_tongue_winking_eye\":{\"a\":\"Face with Stuck-out Tongue and Winking Eye\",\"b\":\"1F61C\",\"j\":[\"winking_face_with_tongue\",\"face\",\"prank\",\"childish\",\"playful\",\"mischievous\",\"smile\",\"wink\",\"tongue\"],\"k\":[31,2],\"l\":[\";p\",\";-p\",\";b\",\";-b\",\";P\",\";-P\"],\"m\":\";p\",\"o\":0},\"right-facing_fist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F91C-1F3FB\",\"non_qualified\":null,\"image\":\"1f91c-1f3fb.png\",\"sheet_x\":37,\"sheet_y\":56,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F91C-1F3FC\",\"non_qualified\":null,\"image\":\"1f91c-1f3fc.png\",\"sheet_x\":37,\"sheet_y\":57,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F91C-1F3FD\",\"non_qualified\":null,\"image\":\"1f91c-1f3fd.png\",\"sheet_x\":38,\"sheet_y\":0,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F91C-1F3FE\",\"non_qualified\":null,\"image\":\"1f91c-1f3fe.png\",\"sheet_x\":38,\"sheet_y\":1,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F91C-1F3FF\",\"non_qualified\":null,\"image\":\"1f91c-1f3ff.png\",\"sheet_x\":38,\"sheet_y\":2,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Right-Facing Fist\",\"b\":\"1F91C\",\"j\":[\"right_facing_fist\",\"hand\",\"fistbump\"],\"k\":[37,55],\"o\":3},\"first_place_medal\":{\"a\":\"First Place Medal\",\"b\":\"1F947\",\"j\":[\"1st_place_medal\",\"award\",\"winning\",\"first\"],\"k\":[41,30],\"o\":3},\"bison\":{\"a\":\"Bison\",\"b\":\"1F9AC\",\"j\":[\"bison\",\"ox\"],\"k\":[43,19],\"o\":13},\"radioactive_sign\":{\"a\":\"Radioactive\",\"b\":\"2622-FE0F\",\"c\":\"2622\",\"j\":[\"radioactive\",\"nuclear\",\"danger\"],\"k\":[54,14],\"o\":1},\"flag-ba\":{\"a\":\"Bosnia & Herzegovina Flag\",\"b\":\"1F1E7-1F1E6\",\"j\":[\"flag_bosnia_herzegovina\",\"bosnia\",\"herzegovina\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,48],\"o\":2},\"house\":{\"a\":\"House Building\",\"b\":\"1F3E0\",\"j\":[\"house\",\"building\",\"home\"],\"k\":[10,41],\"o\":0},\"cow\":{\"a\":\"Cow Face\",\"b\":\"1F42E\",\"j\":[\"cow_face\",\"beef\",\"ox\",\"animal\",\"nature\",\"moo\",\"milk\"],\"k\":[12,8],\"o\":0},\"clap\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F44F-1F3FB\",\"non_qualified\":null,\"image\":\"1f44f-1f3fb.png\",\"sheet_x\":13,\"sheet_y\":41,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F44F-1F3FC\",\"non_qualified\":null,\"image\":\"1f44f-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":42,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F44F-1F3FD\",\"non_qualified\":null,\"image\":\"1f44f-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":43,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F44F-1F3FE\",\"non_qualified\":null,\"image\":\"1f44f-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":44,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F44F-1F3FF\",\"non_qualified\":null,\"image\":\"1f44f-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":45,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Clapping Hands Sign\",\"b\":\"1F44F\",\"j\":[\"clapping_hands\",\"hands\",\"praise\",\"applause\",\"congrats\",\"yay\"],\"k\":[13,40],\"o\":0},\"zany_face\":{\"a\":\"Grinning Face with One Large and One Small Eye\",\"b\":\"1F92A\",\"j\":[\"zany_face\",\"face\",\"goofy\",\"crazy\"],\"k\":[38,43],\"n\":[\"grinning_face_with_one_large_and_one_small_eye\"],\"o\":5},\"second_place_medal\":{\"a\":\"Second Place Medal\",\"b\":\"1F948\",\"j\":[\"2nd_place_medal\",\"award\",\"second\"],\"k\":[41,31],\"o\":3},\"thong_sandal\":{\"a\":\"Thong Sandal\",\"b\":\"1FA74\",\"j\":[\"thong sandal\",\"footwear\",\"summer\"],\"k\":[52,21],\"o\":13},\"bell_pepper\":{\"a\":\"Bell Pepper\",\"b\":\"1FAD1\",\"j\":[\"bell pepper\",\"fruit\",\"plant\"],\"k\":[53,10],\"o\":13},\"biohazard_sign\":{\"a\":\"Biohazard\",\"b\":\"2623-FE0F\",\"c\":\"2623\",\"j\":[\"biohazard\",\"danger\"],\"k\":[54,15],\"o\":1},\"flag-bb\":{\"a\":\"Barbados Flag\",\"b\":\"1F1E7-1F1E7\",\"j\":[\"flag_barbados\",\"bb\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,49],\"o\":2},\"house_with_garden\":{\"a\":\"House with Garden\",\"b\":\"1F3E1\",\"j\":[\"house_with_garden\",\"home\",\"plant\",\"nature\"],\"k\":[10,42],\"o\":0},\"ox\":{\"a\":\"Ox\",\"b\":\"1F402\",\"j\":[\"ox\",\"animal\",\"cow\",\"beef\"],\"k\":[11,20],\"o\":1},\"mans_shoe\":{\"a\":\"Mans Shoe\",\"b\":\"1F45E\",\"j\":[\"man_s_shoe\",\"fashion\",\"male\"],\"k\":[14,7],\"n\":[\"shoe\"],\"o\":0},\"stuck_out_tongue_closed_eyes\":{\"a\":\"Face with Stuck-out Tongue and Tightly-Closed Eyes\",\"b\":\"1F61D\",\"j\":[\"squinting_face_with_tongue\",\"face\",\"prank\",\"playful\",\"mischievous\",\"smile\",\"tongue\"],\"k\":[31,3],\"o\":0},\"raised_hands\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64C-1F3FB\",\"non_qualified\":null,\"image\":\"1f64c-1f3fb.png\",\"sheet_x\":33,\"sheet_y\":3,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64C-1F3FC\",\"non_qualified\":null,\"image\":\"1f64c-1f3fc.png\",\"sheet_x\":33,\"sheet_y\":4,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64C-1F3FD\",\"non_qualified\":null,\"image\":\"1f64c-1f3fd.png\",\"sheet_x\":33,\"sheet_y\":5,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64C-1F3FE\",\"non_qualified\":null,\"image\":\"1f64c-1f3fe.png\",\"sheet_x\":33,\"sheet_y\":6,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64C-1F3FF\",\"non_qualified\":null,\"image\":\"1f64c-1f3ff.png\",\"sheet_x\":33,\"sheet_y\":7,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person Raising Both Hands in Celebration\",\"b\":\"1F64C\",\"j\":[\"raising_hands\",\"gesture\",\"hooray\",\"yea\",\"celebration\",\"hands\"],\"k\":[33,2],\"o\":0},\"third_place_medal\":{\"a\":\"Third Place Medal\",\"b\":\"1F949\",\"j\":[\"3rd_place_medal\",\"award\",\"third\"],\"k\":[41,32],\"o\":3},\"cucumber\":{\"a\":\"Cucumber\",\"b\":\"1F952\",\"j\":[\"cucumber\",\"fruit\",\"food\",\"pickle\"],\"k\":[41,41],\"o\":3},\"arrow_up\":{\"a\":\"Upwards Black Arrow\",\"b\":\"2B06-FE0F\",\"c\":\"2B06\",\"j\":[\"up_arrow\",\"blue-square\",\"continue\",\"top\",\"direction\"],\"k\":[56,42],\"o\":0},\"flag-bd\":{\"a\":\"Bangladesh Flag\",\"b\":\"1F1E7-1F1E9\",\"j\":[\"flag_bangladesh\",\"bd\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,50],\"o\":2},\"office\":{\"a\":\"Office Building\",\"b\":\"1F3E2\",\"j\":[\"office_building\",\"building\",\"bureau\",\"work\"],\"k\":[10,43],\"o\":0},\"water_buffalo\":{\"a\":\"Water Buffalo\",\"b\":\"1F403\",\"j\":[\"water_buffalo\",\"animal\",\"nature\",\"ox\",\"cow\"],\"k\":[11,21],\"o\":1},\"open_hands\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F450-1F3FB\",\"non_qualified\":null,\"image\":\"1f450-1f3fb.png\",\"sheet_x\":13,\"sheet_y\":47,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F450-1F3FC\",\"non_qualified\":null,\"image\":\"1f450-1f3fc.png\",\"sheet_x\":13,\"sheet_y\":48,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F450-1F3FD\",\"non_qualified\":null,\"image\":\"1f450-1f3fd.png\",\"sheet_x\":13,\"sheet_y\":49,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F450-1F3FE\",\"non_qualified\":null,\"image\":\"1f450-1f3fe.png\",\"sheet_x\":13,\"sheet_y\":50,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F450-1F3FF\",\"non_qualified\":null,\"image\":\"1f450-1f3ff.png\",\"sheet_x\":13,\"sheet_y\":51,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Open Hands Sign\",\"b\":\"1F450\",\"j\":[\"open_hands\",\"fingers\",\"butterfly\",\"hands\",\"open\"],\"k\":[13,46],\"o\":0},\"athletic_shoe\":{\"a\":\"Athletic Shoe\",\"b\":\"1F45F\",\"j\":[\"running_shoe\",\"shoes\",\"sports\",\"sneakers\"],\"k\":[14,8],\"o\":0},\"money_mouth_face\":{\"a\":\"Money-Mouth Face\",\"b\":\"1F911\",\"j\":[\"money_mouth_face\",\"face\",\"rich\",\"dollar\",\"money\"],\"k\":[37,24],\"o\":1},\"leafy_green\":{\"a\":\"Leafy Green\",\"b\":\"1F96C\",\"j\":[\"leafy_green\",\"food\",\"vegetable\",\"plant\",\"bok choy\",\"cabbage\",\"kale\",\"lettuce\"],\"k\":[42,9],\"o\":11},\"arrow_upper_right\":{\"a\":\"North East Arrow\",\"b\":\"2197-FE0F\",\"c\":\"2197\",\"j\":[\"up_right_arrow\",\"blue-square\",\"point\",\"direction\",\"diagonal\",\"northeast\"],\"k\":[53,23],\"o\":0},\"soccer\":{\"a\":\"Soccer Ball\",\"b\":\"26BD\",\"j\":[\"soccer_ball\",\"sports\",\"football\"],\"k\":[55,4],\"o\":0},\"flag-be\":{\"a\":\"Belgium Flag\",\"b\":\"1F1E7-1F1EA\",\"j\":[\"flag_belgium\",\"be\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,51],\"o\":2},\"post_office\":{\"a\":\"Japanese Post Office\",\"b\":\"1F3E3\",\"j\":[\"japanese_post_office\",\"building\",\"envelope\",\"communication\"],\"k\":[10,44],\"o\":0},\"cow2\":{\"a\":\"Cow\",\"b\":\"1F404\",\"j\":[\"cow\",\"beef\",\"ox\",\"animal\",\"nature\",\"moo\",\"milk\"],\"k\":[11,22],\"o\":1},\"hugging_face\":{\"a\":\"Hugging Face\",\"b\":\"1F917\",\"j\":[\"hugging_face\",\"face\",\"smile\",\"hug\"],\"k\":[37,30],\"o\":1},\"palms_up_together\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F932-1F3FB\",\"non_qualified\":null,\"image\":\"1f932-1f3fb.png\",\"sheet_x\":39,\"sheet_y\":4,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F932-1F3FC\",\"non_qualified\":null,\"image\":\"1f932-1f3fc.png\",\"sheet_x\":39,\"sheet_y\":5,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F932-1F3FD\",\"non_qualified\":null,\"image\":\"1f932-1f3fd.png\",\"sheet_x\":39,\"sheet_y\":6,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F932-1F3FE\",\"non_qualified\":null,\"image\":\"1f932-1f3fe.png\",\"sheet_x\":39,\"sheet_y\":7,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F932-1F3FF\",\"non_qualified\":null,\"image\":\"1f932-1f3ff.png\",\"sheet_x\":39,\"sheet_y\":8,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Palms Up Together\",\"b\":\"1F932\",\"j\":[\"palms_up_together\",\"hands\",\"gesture\",\"cupped\",\"prayer\"],\"k\":[39,3],\"o\":5},\"broccoli\":{\"a\":\"Broccoli\",\"b\":\"1F966\",\"j\":[\"broccoli\",\"fruit\",\"food\",\"vegetable\"],\"k\":[42,3],\"o\":5},\"hiking_boot\":{\"a\":\"Hiking Boot\",\"b\":\"1F97E\",\"j\":[\"hiking_boot\",\"backpacking\",\"camping\",\"hiking\"],\"k\":[42,31],\"o\":11},\"baseball\":{\"a\":\"Baseball\",\"b\":\"26BE\",\"j\":[\"baseball\",\"sports\",\"balls\"],\"k\":[55,5],\"o\":0},\"arrow_right\":{\"a\":\"Black Rightwards Arrow\",\"b\":\"27A1-FE0F\",\"c\":\"27A1\",\"j\":[\"right_arrow\",\"blue-square\",\"next\"],\"k\":[56,36],\"o\":0},\"flag-bf\":{\"a\":\"Burkina Faso Flag\",\"b\":\"1F1E7-1F1EB\",\"j\":[\"flag_burkina_faso\",\"burkina\",\"faso\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,52],\"o\":2},\"european_post_office\":{\"a\":\"European Post Office\",\"b\":\"1F3E4\",\"j\":[\"post_office\",\"building\",\"email\"],\"k\":[10,45],\"o\":1},\"pig\":{\"a\":\"Pig Face\",\"b\":\"1F437\",\"j\":[\"pig_face\",\"animal\",\"oink\",\"nature\"],\"k\":[12,17],\"o\":0},\"handshake\":{\"a\":\"Handshake\",\"b\":\"1F91D\",\"j\":[\"handshake\",\"agreement\",\"shake\"],\"k\":[38,3],\"o\":3},\"face_with_hand_over_mouth\":{\"a\":\"Smiling Face with Smiling Eyes and Hand Covering Mouth\",\"b\":\"1F92D\",\"j\":[\"face_with_hand_over_mouth\",\"face\",\"whoops\",\"shock\",\"surprise\"],\"k\":[38,46],\"n\":[\"smiling_face_with_smiling_eyes_and_hand_covering_mouth\"],\"o\":5},\"softball\":{\"a\":\"Softball\",\"b\":\"1F94E\",\"j\":[\"softball\",\"sports\",\"balls\"],\"k\":[41,37],\"o\":11},\"womans_flat_shoe\":{\"a\":\"Flat Shoe\",\"b\":\"1F97F\",\"j\":[\"flat_shoe\",\"ballet\",\"slip-on\",\"slipper\"],\"k\":[42,32],\"o\":11},\"garlic\":{\"a\":\"Garlic\",\"b\":\"1F9C4\",\"j\":[\"garlic\",\"food\",\"spice\",\"cook\"],\"k\":[44,30],\"o\":12},\"arrow_lower_right\":{\"a\":\"South East Arrow\",\"b\":\"2198-FE0F\",\"c\":\"2198\",\"j\":[\"down_right_arrow\",\"blue-square\",\"direction\",\"diagonal\",\"southeast\"],\"k\":[53,24],\"o\":0},\"flag-bg\":{\"a\":\"Bulgaria Flag\",\"b\":\"1F1E7-1F1EC\",\"j\":[\"flag_bulgaria\",\"bg\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,53],\"o\":2},\"basketball\":{\"a\":\"Basketball and Hoop\",\"b\":\"1F3C0\",\"j\":[\"basketball\",\"sports\",\"balls\",\"NBA\"],\"k\":[8,30],\"o\":0},\"hospital\":{\"a\":\"Hospital\",\"b\":\"1F3E5\",\"j\":[\"hospital\",\"building\",\"health\",\"surgery\",\"doctor\"],\"k\":[10,46],\"o\":0},\"pig2\":{\"a\":\"Pig\",\"b\":\"1F416\",\"j\":[\"pig\",\"animal\",\"nature\"],\"k\":[11,42],\"o\":1},\"high_heel\":{\"a\":\"High-Heeled Shoe\",\"b\":\"1F460\",\"j\":[\"high_heeled_shoe\",\"fashion\",\"shoes\",\"female\",\"pumps\",\"stiletto\"],\"k\":[14,9],\"o\":0},\"pray\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64F-1F3FB\",\"non_qualified\":null,\"image\":\"1f64f-1f3fb.png\",\"sheet_x\":33,\"sheet_y\":45,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64F-1F3FC\",\"non_qualified\":null,\"image\":\"1f64f-1f3fc.png\",\"sheet_x\":33,\"sheet_y\":46,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64F-1F3FD\",\"non_qualified\":null,\"image\":\"1f64f-1f3fd.png\",\"sheet_x\":33,\"sheet_y\":47,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64F-1F3FE\",\"non_qualified\":null,\"image\":\"1f64f-1f3fe.png\",\"sheet_x\":33,\"sheet_y\":48,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64F-1F3FF\",\"non_qualified\":null,\"image\":\"1f64f-1f3ff.png\",\"sheet_x\":33,\"sheet_y\":49,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person with Folded Hands\",\"b\":\"1F64F\",\"j\":[\"folded_hands\",\"please\",\"hope\",\"wish\",\"namaste\",\"highfive\"],\"k\":[33,44],\"o\":0},\"shushing_face\":{\"a\":\"Face with Finger Covering Closed Lips\",\"b\":\"1F92B\",\"j\":[\"shushing_face\",\"face\",\"quiet\",\"shhh\"],\"k\":[38,44],\"n\":[\"face_with_finger_covering_closed_lips\"],\"o\":5},\"onion\":{\"a\":\"Onion\",\"b\":\"1F9C5\",\"j\":[\"onion\",\"cook\",\"food\",\"spice\"],\"k\":[44,31],\"o\":12},\"arrow_down\":{\"a\":\"Downwards Black Arrow\",\"b\":\"2B07-FE0F\",\"c\":\"2B07\",\"j\":[\"down_arrow\",\"blue-square\",\"direction\",\"bottom\"],\"k\":[56,43],\"o\":0},\"flag-bh\":{\"a\":\"Bahrain Flag\",\"b\":\"1F1E7-1F1ED\",\"j\":[\"flag_bahrain\",\"bh\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,54],\"o\":2},\"mushroom\":{\"a\":\"Mushroom\",\"b\":\"1F344\",\"j\":[\"mushroom\",\"plant\",\"vegetable\"],\"k\":[6,22],\"o\":0},\"volleyball\":{\"a\":\"Volleyball\",\"b\":\"1F3D0\",\"j\":[\"volleyball\",\"sports\",\"balls\"],\"k\":[10,25],\"o\":1},\"bank\":{\"a\":\"Bank\",\"b\":\"1F3E6\",\"j\":[\"bank\",\"building\",\"money\",\"sales\",\"cash\",\"business\",\"enterprise\"],\"k\":[10,47],\"o\":0},\"boar\":{\"a\":\"Boar\",\"b\":\"1F417\",\"j\":[\"boar\",\"animal\",\"nature\"],\"k\":[11,43],\"o\":0},\"sandal\":{\"a\":\"Womans Sandal\",\"b\":\"1F461\",\"j\":[\"woman_s_sandal\",\"shoes\",\"fashion\",\"flip flops\"],\"k\":[14,10],\"o\":0},\"thinking_face\":{\"a\":\"Thinking Face\",\"b\":\"1F914\",\"j\":[\"thinking_face\",\"face\",\"hmmm\",\"think\",\"consider\"],\"k\":[37,27],\"o\":1},\"arrow_lower_left\":{\"a\":\"South West Arrow\",\"b\":\"2199-FE0F\",\"c\":\"2199\",\"j\":[\"down_left_arrow\",\"blue-square\",\"direction\",\"diagonal\",\"southwest\"],\"k\":[53,25],\"o\":0},\"writing_hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"270D-1F3FB\",\"non_qualified\":null,\"image\":\"270d-1f3fb.png\",\"sheet_x\":56,\"sheet_y\":9,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"270D-1F3FC\",\"non_qualified\":null,\"image\":\"270d-1f3fc.png\",\"sheet_x\":56,\"sheet_y\":10,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"270D-1F3FD\",\"non_qualified\":null,\"image\":\"270d-1f3fd.png\",\"sheet_x\":56,\"sheet_y\":11,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"270D-1F3FE\",\"non_qualified\":null,\"image\":\"270d-1f3fe.png\",\"sheet_x\":56,\"sheet_y\":12,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"270D-1F3FF\",\"non_qualified\":null,\"image\":\"270d-1f3ff.png\",\"sheet_x\":56,\"sheet_y\":13,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Writing Hand\",\"b\":\"270D-FE0F\",\"c\":\"270D\",\"j\":[\"writing_hand\",\"lower_left_ballpoint_pen\",\"stationery\",\"write\",\"compose\"],\"k\":[56,8],\"o\":0},\"flag-bi\":{\"a\":\"Burundi Flag\",\"b\":\"1F1E7-1F1EE\",\"j\":[\"flag_burundi\",\"bi\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,55],\"o\":2},\"football\":{\"a\":\"American Football\",\"b\":\"1F3C8\",\"j\":[\"american_football\",\"sports\",\"balls\",\"NFL\"],\"k\":[9,24],\"o\":0},\"hotel\":{\"a\":\"Hotel\",\"b\":\"1F3E8\",\"j\":[\"hotel\",\"building\",\"accomodation\",\"checkin\"],\"k\":[10,49],\"o\":0},\"pig_nose\":{\"a\":\"Pig Nose\",\"b\":\"1F43D\",\"j\":[\"pig_nose\",\"animal\",\"oink\"],\"k\":[12,24],\"o\":0},\"nail_care\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F485-1F3FB\",\"non_qualified\":null,\"image\":\"1f485-1f3fb.png\",\"sheet_x\":24,\"sheet_y\":37,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F485-1F3FC\",\"non_qualified\":null,\"image\":\"1f485-1f3fc.png\",\"sheet_x\":24,\"sheet_y\":38,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F485-1F3FD\",\"non_qualified\":null,\"image\":\"1f485-1f3fd.png\",\"sheet_x\":24,\"sheet_y\":39,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F485-1F3FE\",\"non_qualified\":null,\"image\":\"1f485-1f3fe.png\",\"sheet_x\":24,\"sheet_y\":40,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F485-1F3FF\",\"non_qualified\":null,\"image\":\"1f485-1f3ff.png\",\"sheet_x\":24,\"sheet_y\":41,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Nail Polish\",\"b\":\"1F485\",\"j\":[\"nail_polish\",\"beauty\",\"manicure\",\"finger\",\"fashion\",\"nail\"],\"k\":[24,36],\"o\":0},\"zipper_mouth_face\":{\"a\":\"Zipper-Mouth Face\",\"b\":\"1F910\",\"j\":[\"zipper_mouth_face\",\"face\",\"sealed\",\"zipper\",\"secret\"],\"k\":[37,23],\"o\":1},\"peanuts\":{\"a\":\"Peanuts\",\"b\":\"1F95C\",\"j\":[\"peanuts\",\"food\",\"nut\"],\"k\":[41,51],\"o\":3},\"ballet_shoes\":{\"a\":\"Ballet Shoes\",\"b\":\"1FA70\",\"j\":[\"ballet_shoes\",\"dance\"],\"k\":[52,17],\"o\":12},\"arrow_left\":{\"a\":\"Leftwards Black Arrow\",\"b\":\"2B05-FE0F\",\"c\":\"2B05\",\"j\":[\"left_arrow\",\"blue-square\",\"previous\",\"back\"],\"k\":[56,41],\"o\":0},\"flag-bj\":{\"a\":\"Benin Flag\",\"b\":\"1F1E7-1F1EF\",\"j\":[\"flag_benin\",\"bj\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,56],\"o\":2},\"chestnut\":{\"a\":\"Chestnut\",\"b\":\"1F330\",\"j\":[\"chestnut\",\"food\",\"squirrel\"],\"k\":[6,2],\"o\":0},\"rugby_football\":{\"a\":\"Rugby Football\",\"b\":\"1F3C9\",\"j\":[\"rugby_football\",\"sports\",\"team\"],\"k\":[9,25],\"o\":1},\"love_hotel\":{\"a\":\"Love Hotel\",\"b\":\"1F3E9\",\"j\":[\"love_hotel\",\"like\",\"affection\",\"dating\"],\"k\":[10,50],\"o\":0},\"ram\":{\"a\":\"Ram\",\"b\":\"1F40F\",\"j\":[\"ram\",\"animal\",\"sheep\",\"nature\"],\"k\":[11,34],\"o\":1},\"boot\":{\"a\":\"Womans Boots\",\"b\":\"1F462\",\"j\":[\"woman_s_boot\",\"shoes\",\"fashion\"],\"k\":[14,11],\"o\":0},\"face_with_raised_eyebrow\":{\"a\":\"Face with One Eyebrow Raised\",\"b\":\"1F928\",\"j\":[\"face_with_raised_eyebrow\",\"face\",\"distrust\",\"scepticism\",\"disapproval\",\"disbelief\",\"surprise\"],\"k\":[38,41],\"n\":[\"face_with_one_eyebrow_raised\"],\"o\":5},\"selfie\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F933-1F3FB\",\"non_qualified\":null,\"image\":\"1f933-1f3fb.png\",\"sheet_x\":39,\"sheet_y\":10,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F933-1F3FC\",\"non_qualified\":null,\"image\":\"1f933-1f3fc.png\",\"sheet_x\":39,\"sheet_y\":11,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F933-1F3FD\",\"non_qualified\":null,\"image\":\"1f933-1f3fd.png\",\"sheet_x\":39,\"sheet_y\":12,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F933-1F3FE\",\"non_qualified\":null,\"image\":\"1f933-1f3fe.png\",\"sheet_x\":39,\"sheet_y\":13,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F933-1F3FF\",\"non_qualified\":null,\"image\":\"1f933-1f3ff.png\",\"sheet_x\":39,\"sheet_y\":14,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Selfie\",\"b\":\"1F933\",\"j\":[\"selfie\",\"camera\",\"phone\"],\"k\":[39,9],\"o\":3},\"arrow_upper_left\":{\"a\":\"North West Arrow\",\"b\":\"2196-FE0F\",\"c\":\"2196\",\"j\":[\"up_left_arrow\",\"blue-square\",\"point\",\"direction\",\"diagonal\",\"northwest\"],\"k\":[53,22],\"o\":0},\"flag-bl\":{\"a\":\"St. Barthélemy Flag\",\"b\":\"1F1E7-1F1F1\",\"j\":[\"flag_st_barthelemy\",\"saint\",\"barthélemy\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[0,57],\"o\":2},\"bread\":{\"a\":\"Bread\",\"b\":\"1F35E\",\"j\":[\"bread\",\"food\",\"wheat\",\"breakfast\",\"toast\"],\"k\":[6,48],\"o\":0},\"tennis\":{\"a\":\"Tennis Racquet and Ball\",\"b\":\"1F3BE\",\"j\":[\"tennis\",\"sports\",\"balls\",\"green\"],\"k\":[8,28],\"o\":0},\"convenience_store\":{\"a\":\"Convenience Store\",\"b\":\"1F3EA\",\"j\":[\"convenience_store\",\"building\",\"shopping\",\"groceries\"],\"k\":[10,51],\"o\":0},\"sheep\":{\"a\":\"Sheep\",\"b\":\"1F411\",\"j\":[\"ewe\",\"animal\",\"nature\",\"wool\",\"shipit\"],\"k\":[11,36],\"o\":0},\"crown\":{\"a\":\"Crown\",\"b\":\"1F451\",\"j\":[\"crown\",\"king\",\"kod\",\"leader\",\"royalty\",\"lord\"],\"k\":[13,52],\"o\":0},\"muscle\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F4AA-1F3FB\",\"non_qualified\":null,\"image\":\"1f4aa-1f3fb.png\",\"sheet_x\":25,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F4AA-1F3FC\",\"non_qualified\":null,\"image\":\"1f4aa-1f3fc.png\",\"sheet_x\":25,\"sheet_y\":56,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F4AA-1F3FD\",\"non_qualified\":null,\"image\":\"1f4aa-1f3fd.png\",\"sheet_x\":25,\"sheet_y\":57,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F4AA-1F3FE\",\"non_qualified\":null,\"image\":\"1f4aa-1f3fe.png\",\"sheet_x\":26,\"sheet_y\":0,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F4AA-1F3FF\",\"non_qualified\":null,\"image\":\"1f4aa-1f3ff.png\",\"sheet_x\":26,\"sheet_y\":1,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Flexed Biceps\",\"b\":\"1F4AA\",\"j\":[\"flexed_biceps\",\"arm\",\"flex\",\"hand\",\"summer\",\"strong\",\"biceps\"],\"k\":[25,54],\"o\":0},\"neutral_face\":{\"a\":\"Neutral Face\",\"b\":\"1F610\",\"j\":[\"neutral_face\",\"indifference\",\"meh\",\":|\",\"neutral\"],\"k\":[30,48],\"l\":[\":|\",\":-|\"],\"o\":0},\"arrow_up_down\":{\"a\":\"Up Down Arrow\",\"b\":\"2195-FE0F\",\"c\":\"2195\",\"j\":[\"up_down_arrow\",\"blue-square\",\"direction\",\"way\",\"vertical\"],\"k\":[53,21],\"o\":0},\"flag-bm\":{\"a\":\"Bermuda Flag\",\"b\":\"1F1E7-1F1F2\",\"j\":[\"flag_bermuda\",\"bm\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,0],\"o\":2},\"school\":{\"a\":\"School\",\"b\":\"1F3EB\",\"j\":[\"school\",\"building\",\"student\",\"education\",\"learn\",\"teach\"],\"k\":[10,52],\"o\":0},\"goat\":{\"a\":\"Goat\",\"b\":\"1F410\",\"j\":[\"goat\",\"animal\",\"nature\"],\"k\":[11,35],\"o\":1},\"womans_hat\":{\"a\":\"Womans Hat\",\"b\":\"1F452\",\"j\":[\"woman_s_hat\",\"fashion\",\"accessories\",\"female\",\"lady\",\"spring\"],\"k\":[13,53],\"o\":0},\"expressionless\":{\"a\":\"Expressionless Face\",\"b\":\"1F611\",\"j\":[\"expressionless_face\",\"face\",\"indifferent\",\"-_-\",\"meh\",\"deadpan\"],\"k\":[30,49],\"o\":1},\"flying_disc\":{\"a\":\"Flying Disc\",\"b\":\"1F94F\",\"j\":[\"flying_disc\",\"sports\",\"frisbee\",\"ultimate\"],\"k\":[41,38],\"o\":11},\"croissant\":{\"a\":\"Croissant\",\"b\":\"1F950\",\"j\":[\"croissant\",\"food\",\"bread\",\"french\"],\"k\":[41,39],\"o\":3},\"mechanical_arm\":{\"a\":\"Mechanical Arm\",\"b\":\"1F9BE\",\"j\":[\"mechanical_arm\",\"accessibility\"],\"k\":[44,24],\"o\":12},\"left_right_arrow\":{\"a\":\"Left Right Arrow\",\"b\":\"2194-FE0F\",\"c\":\"2194\",\"j\":[\"left_right_arrow\",\"shape\",\"direction\",\"horizontal\",\"sideways\"],\"k\":[53,20],\"o\":0},\"flag-bn\":{\"a\":\"Brunei Flag\",\"b\":\"1F1E7-1F1F3\",\"j\":[\"flag_brunei\",\"bn\",\"darussalam\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,1],\"o\":2},\"tophat\":{\"a\":\"Top Hat\",\"b\":\"1F3A9\",\"j\":[\"top_hat\",\"magic\",\"gentleman\",\"classy\",\"circus\"],\"k\":[8,7],\"o\":0},\"bowling\":{\"a\":\"Bowling\",\"b\":\"1F3B3\",\"j\":[\"bowling\",\"sports\",\"fun\",\"play\"],\"k\":[8,17],\"o\":0},\"department_store\":{\"a\":\"Department Store\",\"b\":\"1F3EC\",\"j\":[\"department_store\",\"building\",\"shopping\",\"mall\"],\"k\":[10,53],\"o\":0},\"dromedary_camel\":{\"a\":\"Dromedary Camel\",\"b\":\"1F42A\",\"j\":[\"camel\",\"animal\",\"hot\",\"desert\",\"hump\"],\"k\":[12,4],\"o\":1},\"no_mouth\":{\"a\":\"Face Without Mouth\",\"b\":\"1F636\",\"j\":[\"face_without_mouth\",\"face\",\"hellokitty\"],\"k\":[31,28],\"o\":1},\"baguette_bread\":{\"a\":\"Baguette Bread\",\"b\":\"1F956\",\"j\":[\"baguette_bread\",\"food\",\"bread\",\"french\"],\"k\":[41,45],\"o\":3},\"mechanical_leg\":{\"a\":\"Mechanical Leg\",\"b\":\"1F9BF\",\"j\":[\"mechanical_leg\",\"accessibility\"],\"k\":[44,25],\"o\":12},\"leftwards_arrow_with_hook\":{\"a\":\"Leftwards Arrow with Hook\",\"b\":\"21A9-FE0F\",\"c\":\"21A9\",\"j\":[\"right_arrow_curving_left\",\"back\",\"return\",\"blue-square\",\"undo\",\"enter\"],\"k\":[53,26],\"o\":0},\"flag-bo\":{\"a\":\"Bolivia Flag\",\"b\":\"1F1E7-1F1F4\",\"j\":[\"flag_bolivia\",\"bo\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,2],\"o\":2},\"mortar_board\":{\"a\":\"Graduation Cap\",\"b\":\"1F393\",\"j\":[\"graduation_cap\",\"school\",\"college\",\"degree\",\"university\",\"graduation\",\"cap\",\"hat\",\"legal\",\"learn\",\"education\"],\"k\":[7,48],\"o\":0},\"cricket_bat_and_ball\":{\"a\":\"Cricket Bat and Ball\",\"b\":\"1F3CF\",\"j\":[\"cricket_game\",\"sports\"],\"k\":[10,24],\"o\":1},\"factory\":{\"a\":\"Factory\",\"b\":\"1F3ED\",\"j\":[\"factory\",\"building\",\"industry\",\"pollution\",\"smoke\"],\"k\":[10,54],\"o\":0},\"camel\":{\"a\":\"Bactrian Camel\",\"b\":\"1F42B\",\"j\":[\"two_hump_camel\",\"animal\",\"nature\",\"hot\",\"desert\",\"hump\"],\"k\":[12,5],\"o\":0},\"smirk\":{\"a\":\"Smirking Face\",\"b\":\"1F60F\",\"j\":[\"smirking_face\",\"face\",\"smile\",\"mean\",\"prank\",\"smug\",\"sarcasm\"],\"k\":[30,47],\"o\":0},\"leg\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9B5-1F3FB\",\"non_qualified\":null,\"image\":\"1f9b5-1f3fb.png\",\"sheet_x\":43,\"sheet_y\":25,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9B5-1F3FC\",\"non_qualified\":null,\"image\":\"1f9b5-1f3fc.png\",\"sheet_x\":43,\"sheet_y\":26,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9B5-1F3FD\",\"non_qualified\":null,\"image\":\"1f9b5-1f3fd.png\",\"sheet_x\":43,\"sheet_y\":27,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9B5-1F3FE\",\"non_qualified\":null,\"image\":\"1f9b5-1f3fe.png\",\"sheet_x\":43,\"sheet_y\":28,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9B5-1F3FF\",\"non_qualified\":null,\"image\":\"1f9b5-1f3ff.png\",\"sheet_x\":43,\"sheet_y\":29,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Leg\",\"b\":\"1F9B5\",\"j\":[\"leg\",\"kick\",\"limb\"],\"k\":[43,24],\"o\":11},\"flatbread\":{\"a\":\"Flatbread\",\"b\":\"1FAD3\",\"j\":[\"flatbread\",\"flour\",\"food\"],\"k\":[53,12],\"o\":13},\"arrow_right_hook\":{\"a\":\"Rightwards Arrow with Hook\",\"b\":\"21AA-FE0F\",\"c\":\"21AA\",\"j\":[\"left_arrow_curving_right\",\"blue-square\",\"return\",\"rotate\",\"direction\"],\"k\":[53,27],\"o\":0},\"flag-bq\":{\"a\":\"Caribbean Netherlands Flag\",\"b\":\"1F1E7-1F1F6\",\"j\":[\"flag_caribbean_netherlands\",\"bonaire\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,3],\"o\":2},\"field_hockey_stick_and_ball\":{\"a\":\"Field Hockey Stick and Ball\",\"b\":\"1F3D1\",\"j\":[\"field_hockey\",\"sports\"],\"k\":[10,26],\"o\":1},\"japanese_castle\":{\"a\":\"Japanese Castle\",\"b\":\"1F3EF\",\"j\":[\"japanese_castle\",\"photo\",\"building\"],\"k\":[10,56],\"o\":0},\"unamused\":{\"a\":\"Unamused Face\",\"b\":\"1F612\",\"j\":[\"unamused_face\",\"indifference\",\"bored\",\"straight face\",\"serious\",\"sarcasm\",\"unimpressed\",\"skeptical\",\"dubious\",\"side_eye\"],\"k\":[30,50],\"m\":\":(\",\"o\":0},\"pretzel\":{\"a\":\"Pretzel\",\"b\":\"1F968\",\"j\":[\"pretzel\",\"food\",\"bread\",\"twisted\"],\"k\":[42,5],\"o\":5},\"llama\":{\"a\":\"Llama\",\"b\":\"1F999\",\"j\":[\"llama\",\"animal\",\"nature\",\"alpaca\"],\"k\":[43,0],\"o\":11},\"foot\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9B6-1F3FB\",\"non_qualified\":null,\"image\":\"1f9b6-1f3fb.png\",\"sheet_x\":43,\"sheet_y\":31,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9B6-1F3FC\",\"non_qualified\":null,\"image\":\"1f9b6-1f3fc.png\",\"sheet_x\":43,\"sheet_y\":32,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9B6-1F3FD\",\"non_qualified\":null,\"image\":\"1f9b6-1f3fd.png\",\"sheet_x\":43,\"sheet_y\":33,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9B6-1F3FE\",\"non_qualified\":null,\"image\":\"1f9b6-1f3fe.png\",\"sheet_x\":43,\"sheet_y\":34,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9B6-1F3FF\",\"non_qualified\":null,\"image\":\"1f9b6-1f3ff.png\",\"sheet_x\":43,\"sheet_y\":35,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Foot\",\"b\":\"1F9B6\",\"j\":[\"foot\",\"kick\",\"stomp\"],\"k\":[43,30],\"o\":11},\"billed_cap\":{\"a\":\"Billed Cap\",\"b\":\"1F9E2\",\"j\":[\"billed_cap\",\"cap\",\"baseball\"],\"k\":[51,45],\"o\":5},\"arrow_heading_up\":{\"a\":\"Arrow Pointing Rightwards Then Curving Upwards\",\"b\":\"2934-FE0F\",\"c\":\"2934\",\"j\":[\"right_arrow_curving_up\",\"blue-square\",\"direction\",\"top\"],\"k\":[56,39],\"o\":0},\"flag-br\":{\"a\":\"Brazil Flag\",\"b\":\"1F1E7-1F1F7\",\"j\":[\"flag_brazil\",\"br\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,4],\"o\":2},\"ice_hockey_stick_and_puck\":{\"a\":\"Ice Hockey Stick and Puck\",\"b\":\"1F3D2\",\"j\":[\"ice_hockey\",\"sports\"],\"k\":[10,27],\"o\":1},\"european_castle\":{\"a\":\"European Castle\",\"b\":\"1F3F0\",\"j\":[\"castle\",\"building\",\"royalty\",\"history\"],\"k\":[10,57],\"o\":0},\"ear\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F442-1F3FB\",\"non_qualified\":null,\"image\":\"1f442-1f3fb.png\",\"sheet_x\":12,\"sheet_y\":31,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F442-1F3FC\",\"non_qualified\":null,\"image\":\"1f442-1f3fc.png\",\"sheet_x\":12,\"sheet_y\":32,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F442-1F3FD\",\"non_qualified\":null,\"image\":\"1f442-1f3fd.png\",\"sheet_x\":12,\"sheet_y\":33,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F442-1F3FE\",\"non_qualified\":null,\"image\":\"1f442-1f3fe.png\",\"sheet_x\":12,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F442-1F3FF\",\"non_qualified\":null,\"image\":\"1f442-1f3ff.png\",\"sheet_x\":12,\"sheet_y\":35,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Ear\",\"b\":\"1F442\",\"j\":[\"ear\",\"face\",\"hear\",\"sound\",\"listen\"],\"k\":[12,30],\"o\":0},\"face_with_rolling_eyes\":{\"a\":\"Face with Rolling Eyes\",\"b\":\"1F644\",\"j\":[\"face_with_rolling_eyes\",\"face\",\"eyeroll\",\"frustrated\"],\"k\":[31,42],\"o\":1},\"bagel\":{\"a\":\"Bagel\",\"b\":\"1F96F\",\"j\":[\"bagel\",\"food\",\"bread\",\"bakery\",\"schmear\"],\"k\":[42,12],\"o\":11},\"giraffe_face\":{\"a\":\"Giraffe Face\",\"b\":\"1F992\",\"j\":[\"giraffe\",\"animal\",\"nature\",\"spots\",\"safari\"],\"k\":[42,51],\"o\":5},\"military_helmet\":{\"a\":\"Military Helmet\",\"b\":\"1FA96\",\"j\":[\"military helmet\",\"army\",\"protection\"],\"k\":[52,38],\"o\":13},\"arrow_heading_down\":{\"a\":\"Arrow Pointing Rightwards Then Curving Downwards\",\"b\":\"2935-FE0F\",\"c\":\"2935\",\"j\":[\"right_arrow_curving_down\",\"blue-square\",\"direction\",\"bottom\"],\"k\":[56,40],\"o\":0},\"flag-bs\":{\"a\":\"Bahamas Flag\",\"b\":\"1F1E7-1F1F8\",\"j\":[\"flag_bahamas\",\"bs\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,5],\"o\":2},\"elephant\":{\"a\":\"Elephant\",\"b\":\"1F418\",\"j\":[\"elephant\",\"animal\",\"nature\",\"nose\",\"th\",\"circus\"],\"k\":[11,44],\"o\":0},\"wedding\":{\"a\":\"Wedding\",\"b\":\"1F492\",\"j\":[\"wedding\",\"love\",\"like\",\"affection\",\"couple\",\"marriage\",\"bride\",\"groom\"],\"k\":[25,30],\"o\":0},\"arrows_clockwise\":{\"a\":\"Clockwise Downwards and Upwards Open Circle Arrows\",\"b\":\"1F503\",\"j\":[\"clockwise_vertical_arrows\",\"sync\",\"cycle\",\"round\",\"repeat\"],\"k\":[27,31],\"o\":0},\"grimacing\":{\"a\":\"Grimacing Face\",\"b\":\"1F62C\",\"j\":[\"grimacing_face\",\"face\",\"grimace\",\"teeth\"],\"k\":[31,18],\"o\":1},\"lacrosse\":{\"a\":\"Lacrosse Stick and Ball\",\"b\":\"1F94D\",\"j\":[\"lacrosse\",\"sports\",\"ball\",\"stick\"],\"k\":[41,36],\"o\":11},\"pancakes\":{\"a\":\"Pancakes\",\"b\":\"1F95E\",\"j\":[\"pancakes\",\"food\",\"breakfast\",\"flapjacks\",\"hotcakes\"],\"k\":[41,53],\"o\":3},\"ear_with_hearing_aid\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9BB-1F3FB\",\"non_qualified\":null,\"image\":\"1f9bb-1f3fb.png\",\"sheet_x\":44,\"sheet_y\":17,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9BB-1F3FC\",\"non_qualified\":null,\"image\":\"1f9bb-1f3fc.png\",\"sheet_x\":44,\"sheet_y\":18,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9BB-1F3FD\",\"non_qualified\":null,\"image\":\"1f9bb-1f3fd.png\",\"sheet_x\":44,\"sheet_y\":19,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9BB-1F3FE\",\"non_qualified\":null,\"image\":\"1f9bb-1f3fe.png\",\"sheet_x\":44,\"sheet_y\":20,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9BB-1F3FF\",\"non_qualified\":null,\"image\":\"1f9bb-1f3ff.png\",\"sheet_x\":44,\"sheet_y\":21,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Ear with Hearing Aid\",\"b\":\"1F9BB\",\"j\":[\"ear_with_hearing_aid\",\"accessibility\"],\"k\":[44,16],\"o\":12},\"helmet_with_white_cross\":{\"a\":\"Rescue Worker’s Helmet\",\"b\":\"26D1-FE0F\",\"c\":\"26D1\",\"j\":[\"rescue_worker_s_helmet\",\"construction\",\"build\"],\"k\":[55,11],\"o\":0},\"flag-bt\":{\"a\":\"Bhutan Flag\",\"b\":\"1F1E7-1F1F9\",\"j\":[\"flag_bhutan\",\"bt\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,6],\"o\":2},\"table_tennis_paddle_and_ball\":{\"a\":\"Table Tennis Paddle and Ball\",\"b\":\"1F3D3\",\"j\":[\"ping_pong\",\"sports\",\"pingpong\"],\"k\":[10,28],\"o\":1},\"nose\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F443-1F3FB\",\"non_qualified\":null,\"image\":\"1f443-1f3fb.png\",\"sheet_x\":12,\"sheet_y\":37,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F443-1F3FC\",\"non_qualified\":null,\"image\":\"1f443-1f3fc.png\",\"sheet_x\":12,\"sheet_y\":38,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F443-1F3FD\",\"non_qualified\":null,\"image\":\"1f443-1f3fd.png\",\"sheet_x\":12,\"sheet_y\":39,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F443-1F3FE\",\"non_qualified\":null,\"image\":\"1f443-1f3fe.png\",\"sheet_x\":12,\"sheet_y\":40,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F443-1F3FF\",\"non_qualified\":null,\"image\":\"1f443-1f3ff.png\",\"sheet_x\":12,\"sheet_y\":41,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Nose\",\"b\":\"1F443\",\"j\":[\"nose\",\"smell\",\"sniff\"],\"k\":[12,36],\"o\":0},\"prayer_beads\":{\"a\":\"Prayer Beads\",\"b\":\"1F4FF\",\"j\":[\"prayer_beads\",\"dhikr\",\"religious\"],\"k\":[27,27],\"o\":1},\"arrows_counterclockwise\":{\"a\":\"Anticlockwise Downwards and Upwards Open Circle Arrows\",\"b\":\"1F504\",\"j\":[\"counterclockwise_arrows_button\",\"blue-square\",\"sync\",\"cycle\"],\"k\":[27,32],\"o\":1},\"tokyo_tower\":{\"a\":\"Tokyo Tower\",\"b\":\"1F5FC\",\"j\":[\"tokyo_tower\",\"photo\",\"japanese\"],\"k\":[30,28],\"o\":0},\"lying_face\":{\"a\":\"Lying Face\",\"b\":\"1F925\",\"j\":[\"lying_face\",\"face\",\"lie\",\"pinocchio\"],\"k\":[38,21],\"o\":3},\"mammoth\":{\"a\":\"Mammoth\",\"b\":\"1F9A3\",\"j\":[\"mammoth\",\"elephant\",\"tusks\"],\"k\":[43,10],\"o\":13},\"waffle\":{\"a\":\"Waffle\",\"b\":\"1F9C7\",\"j\":[\"waffle\",\"food\",\"breakfast\"],\"k\":[44,33],\"o\":12},\"flag-bv\":{\"a\":\"Bouvet Island Flag\",\"b\":\"1F1E7-1F1FB\",\"j\":[\"flag_bouvet_island\",\"norway\"],\"k\":[1,7],\"o\":2},\"badminton_racquet_and_shuttlecock\":{\"a\":\"Badminton Racquet and Shuttlecock\",\"b\":\"1F3F8\",\"j\":[\"badminton\",\"sports\"],\"k\":[11,10],\"o\":1},\"lipstick\":{\"a\":\"Lipstick\",\"b\":\"1F484\",\"j\":[\"lipstick\",\"female\",\"girl\",\"fashion\",\"woman\"],\"k\":[24,35],\"o\":0},\"back\":{\"a\":\"Back with Leftwards Arrow Above\",\"b\":\"1F519\",\"j\":[\"back_arrow\",\"arrow\",\"words\",\"return\"],\"k\":[27,53],\"o\":0},\"statue_of_liberty\":{\"a\":\"Statue of Liberty\",\"b\":\"1F5FD\",\"j\":[\"statue_of_liberty\",\"american\",\"newyork\"],\"k\":[30,29],\"o\":0},\"relieved\":{\"a\":\"Relieved Face\",\"b\":\"1F60C\",\"j\":[\"relieved_face\",\"face\",\"relaxed\",\"phew\",\"massage\",\"happiness\"],\"k\":[30,44],\"o\":0},\"rhinoceros\":{\"a\":\"Rhinoceros\",\"b\":\"1F98F\",\"j\":[\"rhinoceros\",\"animal\",\"nature\",\"horn\"],\"k\":[42,48],\"o\":3},\"cheese_wedge\":{\"a\":\"Cheese Wedge\",\"b\":\"1F9C0\",\"j\":[\"cheese_wedge\",\"food\",\"chadder\"],\"k\":[44,26],\"o\":1},\"brain\":{\"a\":\"Brain\",\"b\":\"1F9E0\",\"j\":[\"brain\",\"smart\",\"intelligent\"],\"k\":[51,43],\"o\":5},\"flag-bw\":{\"a\":\"Botswana Flag\",\"b\":\"1F1E7-1F1FC\",\"j\":[\"flag_botswana\",\"bw\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,8],\"o\":2},\"meat_on_bone\":{\"a\":\"Meat on Bone\",\"b\":\"1F356\",\"j\":[\"meat_on_bone\",\"good\",\"food\",\"drumstick\"],\"k\":[6,40],\"o\":0},\"ring\":{\"a\":\"Ring\",\"b\":\"1F48D\",\"j\":[\"ring\",\"wedding\",\"propose\",\"marriage\",\"valentines\",\"diamond\",\"fashion\",\"jewelry\",\"gem\",\"engagement\"],\"k\":[25,25],\"o\":0},\"end\":{\"a\":\"End with Leftwards Arrow Above\",\"b\":\"1F51A\",\"j\":[\"end_arrow\",\"words\",\"arrow\"],\"k\":[27,54],\"o\":0},\"pensive\":{\"a\":\"Pensive Face\",\"b\":\"1F614\",\"j\":[\"pensive_face\",\"face\",\"sad\",\"depressed\",\"upset\"],\"k\":[30,52],\"o\":0},\"boxing_glove\":{\"a\":\"Boxing Glove\",\"b\":\"1F94A\",\"j\":[\"boxing_glove\",\"sports\",\"fighting\"],\"k\":[41,33],\"o\":3},\"hippopotamus\":{\"a\":\"Hippopotamus\",\"b\":\"1F99B\",\"j\":[\"hippopotamus\",\"animal\",\"nature\"],\"k\":[43,2],\"o\":11},\"anatomical_heart\":{\"a\":\"Anatomical Heart\",\"b\":\"1FAC0\",\"j\":[\"anatomical heart\",\"health\",\"heartbeat\"],\"k\":[53,6],\"o\":13},\"church\":{\"a\":\"Church\",\"b\":\"26EA\",\"j\":[\"church\",\"building\",\"religion\",\"christ\"],\"k\":[55,15],\"o\":0},\"flag-by\":{\"a\":\"Belarus Flag\",\"b\":\"1F1E7-1F1FE\",\"j\":[\"flag_belarus\",\"by\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,9],\"o\":2},\"poultry_leg\":{\"a\":\"Poultry Leg\",\"b\":\"1F357\",\"j\":[\"poultry_leg\",\"food\",\"meat\",\"drumstick\",\"bird\",\"chicken\",\"turkey\"],\"k\":[6,41],\"o\":0},\"mouse\":{\"a\":\"Mouse Face\",\"b\":\"1F42D\",\"j\":[\"mouse_face\",\"animal\",\"nature\",\"cheese_wedge\",\"rodent\"],\"k\":[12,7],\"o\":0},\"gem\":{\"a\":\"Gem Stone\",\"b\":\"1F48E\",\"j\":[\"gem_stone\",\"blue\",\"ruby\",\"diamond\",\"jewelry\"],\"k\":[25,26],\"o\":0},\"on\":{\"a\":\"On with Exclamation Mark with Left Right Arrow Above\",\"b\":\"1F51B\",\"j\":[\"on_arrow\",\"arrow\",\"words\"],\"k\":[27,55],\"o\":0},\"mosque\":{\"a\":\"Mosque\",\"b\":\"1F54C\",\"j\":[\"mosque\",\"islam\",\"worship\",\"minaret\"],\"k\":[28,35],\"o\":1},\"sleepy\":{\"a\":\"Sleepy Face\",\"b\":\"1F62A\",\"j\":[\"sleepy_face\",\"face\",\"tired\",\"rest\",\"nap\"],\"k\":[31,16],\"o\":0},\"martial_arts_uniform\":{\"a\":\"Martial Arts Uniform\",\"b\":\"1F94B\",\"j\":[\"martial_arts_uniform\",\"judo\",\"karate\",\"taekwondo\"],\"k\":[41,34],\"o\":3},\"lungs\":{\"a\":\"Lungs\",\"b\":\"1FAC1\",\"j\":[\"lungs\",\"breathe\"],\"k\":[53,7],\"o\":13},\"flag-bz\":{\"a\":\"Belize Flag\",\"b\":\"1F1E7-1F1FF\",\"j\":[\"flag_belize\",\"bz\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,10],\"o\":2},\"mouse2\":{\"a\":\"Mouse\",\"b\":\"1F401\",\"j\":[\"mouse\",\"animal\",\"nature\",\"rodent\"],\"k\":[11,19],\"o\":1},\"mute\":{\"a\":\"Speaker with Cancellation Stroke\",\"b\":\"1F507\",\"j\":[\"muted_speaker\",\"sound\",\"volume\",\"silence\",\"quiet\"],\"k\":[27,35],\"o\":1},\"soon\":{\"a\":\"Soon with Rightwards Arrow Above\",\"b\":\"1F51C\",\"j\":[\"soon_arrow\",\"arrow\",\"words\"],\"k\":[27,56],\"o\":0},\"hindu_temple\":{\"a\":\"Hindu Temple\",\"b\":\"1F6D5\",\"j\":[\"hindu_temple\",\"religion\"],\"k\":[36,32],\"o\":12},\"drooling_face\":{\"a\":\"Drooling Face\",\"b\":\"1F924\",\"j\":[\"drooling_face\",\"face\"],\"k\":[38,20],\"o\":3},\"goal_net\":{\"a\":\"Goal Net\",\"b\":\"1F945\",\"j\":[\"goal_net\",\"sports\"],\"k\":[41,29],\"o\":3},\"cut_of_meat\":{\"a\":\"Cut of Meat\",\"b\":\"1F969\",\"j\":[\"cut_of_meat\",\"food\",\"cow\",\"meat\",\"cut\",\"chop\",\"lambchop\",\"porkchop\"],\"k\":[42,6],\"o\":5},\"tooth\":{\"a\":\"Tooth\",\"b\":\"1F9B7\",\"j\":[\"tooth\",\"teeth\",\"dentist\"],\"k\":[43,36],\"o\":11},\"flag-ca\":{\"a\":\"Canada Flag\",\"b\":\"1F1E8-1F1E6\",\"j\":[\"flag_canada\",\"ca\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,11],\"o\":2},\"rat\":{\"a\":\"Rat\",\"b\":\"1F400\",\"j\":[\"rat\",\"animal\",\"mouse\",\"rodent\"],\"k\":[11,18],\"o\":1},\"speaker\":{\"a\":\"Speaker\",\"b\":\"1F508\",\"j\":[\"speaker_low_volume\",\"sound\",\"volume\",\"silence\",\"broadcast\"],\"k\":[27,36],\"o\":0},\"top\":{\"a\":\"Top with Upwards Arrow Above\",\"b\":\"1F51D\",\"j\":[\"top_arrow\",\"words\",\"blue-square\"],\"k\":[27,57],\"o\":0},\"synagogue\":{\"a\":\"Synagogue\",\"b\":\"1F54D\",\"j\":[\"synagogue\",\"judaism\",\"worship\",\"temple\",\"jewish\"],\"k\":[28,36],\"o\":1},\"sleeping\":{\"a\":\"Sleeping Face\",\"b\":\"1F634\",\"j\":[\"sleeping_face\",\"face\",\"tired\",\"sleepy\",\"night\",\"zzz\"],\"k\":[31,26],\"o\":1},\"bacon\":{\"a\":\"Bacon\",\"b\":\"1F953\",\"j\":[\"bacon\",\"food\",\"breakfast\",\"pork\",\"pig\",\"meat\"],\"k\":[41,42],\"o\":3},\"bone\":{\"a\":\"Bone\",\"b\":\"1F9B4\",\"j\":[\"bone\",\"skeleton\"],\"k\":[43,23],\"o\":11},\"golf\":{\"a\":\"Flag in Hole\",\"b\":\"26F3\",\"j\":[\"flag_in_hole\",\"sports\",\"business\",\"flag\",\"hole\",\"summer\"],\"k\":[55,19],\"o\":0},\"flag-cc\":{\"a\":\"Cocos (keeling) Islands Flag\",\"b\":\"1F1E8-1F1E8\",\"j\":[\"flag_cocos_islands\",\"cocos\",\"keeling\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,12],\"o\":2},\"hamburger\":{\"a\":\"Hamburger\",\"b\":\"1F354\",\"j\":[\"hamburger\",\"meat\",\"fast food\",\"beef\",\"cheeseburger\",\"mcdonalds\",\"burger king\"],\"k\":[6,38],\"o\":0},\"hamster\":{\"a\":\"Hamster Face\",\"b\":\"1F439\",\"j\":[\"hamster\",\"animal\",\"nature\"],\"k\":[12,19],\"o\":0},\"eyes\":{\"a\":\"Eyes\",\"b\":\"1F440\",\"j\":[\"eyes\",\"look\",\"watch\",\"stalk\",\"peek\",\"see\"],\"k\":[12,27],\"o\":0},\"sound\":{\"a\":\"Speaker with One Sound Wave\",\"b\":\"1F509\",\"j\":[\"speaker_medium_volume\",\"volume\",\"speaker\",\"broadcast\"],\"k\":[27,37],\"o\":1},\"mask\":{\"a\":\"Face with Medical Mask\",\"b\":\"1F637\",\"j\":[\"face_with_medical_mask\",\"face\",\"sick\",\"ill\",\"disease\"],\"k\":[31,29],\"o\":0},\"place_of_worship\":{\"a\":\"Place of Worship\",\"b\":\"1F6D0\",\"j\":[\"place_of_worship\",\"religion\",\"church\",\"temple\",\"prayer\"],\"k\":[36,29],\"o\":1},\"shinto_shrine\":{\"a\":\"Shinto Shrine\",\"b\":\"26E9-FE0F\",\"c\":\"26E9\",\"j\":[\"shinto_shrine\",\"temple\",\"japan\",\"kyoto\"],\"k\":[55,14],\"o\":0},\"ice_skate\":{\"a\":\"Ice Skate\",\"b\":\"26F8-FE0F\",\"c\":\"26F8\",\"j\":[\"ice_skate\",\"sports\"],\"k\":[55,23],\"o\":0},\"flag-cd\":{\"a\":\"Congo - Kinshasa Flag\",\"b\":\"1F1E8-1F1E9\",\"j\":[\"flag_congo_kinshasa\",\"congo\",\"democratic\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,13],\"o\":2},\"fries\":{\"a\":\"French Fries\",\"b\":\"1F35F\",\"j\":[\"french_fries\",\"chips\",\"snack\",\"fast food\"],\"k\":[6,49],\"o\":0},\"fishing_pole_and_fish\":{\"a\":\"Fishing Pole and Fish\",\"b\":\"1F3A3\",\"j\":[\"fishing_pole\",\"food\",\"hobby\",\"summer\"],\"k\":[8,1],\"o\":0},\"rabbit\":{\"a\":\"Rabbit Face\",\"b\":\"1F430\",\"j\":[\"rabbit_face\",\"animal\",\"nature\",\"pet\",\"spring\",\"magic\",\"bunny\"],\"k\":[12,10],\"o\":0},\"eye\":{\"a\":\"Eye\",\"b\":\"1F441-FE0F\",\"c\":\"1F441\",\"j\":[\"eye\",\"face\",\"look\",\"see\",\"watch\",\"stare\"],\"k\":[12,29],\"o\":0},\"loud_sound\":{\"a\":\"Speaker with Three Sound Waves\",\"b\":\"1F50A\",\"j\":[\"speaker_high_volume\",\"volume\",\"noise\",\"noisy\",\"speaker\",\"broadcast\"],\"k\":[27,38],\"o\":0},\"kaaba\":{\"a\":\"Kaaba\",\"b\":\"1F54B\",\"j\":[\"kaaba\",\"mecca\",\"mosque\",\"islam\"],\"k\":[28,34],\"o\":1},\"face_with_thermometer\":{\"a\":\"Face with Thermometer\",\"b\":\"1F912\",\"j\":[\"face_with_thermometer\",\"sick\",\"temperature\",\"thermometer\",\"cold\",\"fever\"],\"k\":[37,25],\"o\":1},\"atom_symbol\":{\"a\":\"Atom Symbol\",\"b\":\"269B-FE0F\",\"c\":\"269B\",\"j\":[\"atom_symbol\",\"science\",\"physics\",\"chemistry\"],\"k\":[54,53],\"o\":1},\"flag-cf\":{\"a\":\"Central African Republic Flag\",\"b\":\"1F1E8-1F1EB\",\"j\":[\"flag_central_african_republic\",\"central\",\"african\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,14],\"o\":2},\"pizza\":{\"a\":\"Slice of Pizza\",\"b\":\"1F355\",\"j\":[\"pizza\",\"food\",\"party\"],\"k\":[6,39],\"o\":0},\"rabbit2\":{\"a\":\"Rabbit\",\"b\":\"1F407\",\"j\":[\"rabbit\",\"animal\",\"nature\",\"pet\",\"magic\",\"spring\"],\"k\":[11,25],\"o\":1},\"tongue\":{\"a\":\"Tongue\",\"b\":\"1F445\",\"j\":[\"tongue\",\"mouth\",\"playful\"],\"k\":[12,43],\"o\":0},\"loudspeaker\":{\"a\":\"Public Address Loudspeaker\",\"b\":\"1F4E2\",\"j\":[\"loudspeaker\",\"volume\",\"sound\"],\"k\":[26,57],\"o\":0},\"om_symbol\":{\"a\":\"Om\",\"b\":\"1F549-FE0F\",\"c\":\"1F549\",\"j\":[\"om\",\"hinduism\",\"buddhism\",\"sikhism\",\"jainism\"],\"k\":[28,32],\"o\":0},\"face_with_head_bandage\":{\"a\":\"Face with Head-Bandage\",\"b\":\"1F915\",\"j\":[\"face_with_head_bandage\",\"injured\",\"clumsy\",\"bandage\",\"hurt\"],\"k\":[37,28],\"o\":1},\"diving_mask\":{\"a\":\"Diving Mask\",\"b\":\"1F93F\",\"j\":[\"diving_mask\",\"sport\",\"ocean\"],\"k\":[41,23],\"o\":12},\"fountain\":{\"a\":\"Fountain\",\"b\":\"26F2\",\"j\":[\"fountain\",\"photo\",\"summer\",\"water\",\"fresh\"],\"k\":[55,18],\"o\":0},\"flag-cg\":{\"a\":\"Congo - Brazzaville Flag\",\"b\":\"1F1E8-1F1EC\",\"j\":[\"flag_congo_brazzaville\",\"congo\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,15],\"o\":2},\"hotdog\":{\"a\":\"Hot Dog\",\"b\":\"1F32D\",\"j\":[\"hot_dog\",\"food\",\"frankfurter\"],\"k\":[5,57],\"o\":1},\"running_shirt_with_sash\":{\"a\":\"Running Shirt with Sash\",\"b\":\"1F3BD\",\"j\":[\"running_shirt\",\"play\",\"pageant\"],\"k\":[8,27],\"o\":0},\"chipmunk\":{\"a\":\"Chipmunk\",\"b\":\"1F43F-FE0F\",\"c\":\"1F43F\",\"j\":[\"chipmunk\",\"animal\",\"nature\",\"rodent\",\"squirrel\"],\"k\":[12,26],\"o\":0},\"lips\":{\"a\":\"Mouth\",\"b\":\"1F444\",\"j\":[\"mouth\",\"mouth\",\"kiss\"],\"k\":[12,42],\"o\":0},\"mega\":{\"a\":\"Cheering Megaphone\",\"b\":\"1F4E3\",\"j\":[\"megaphone\",\"sound\",\"speaker\",\"volume\"],\"k\":[27,0],\"o\":0},\"nauseated_face\":{\"a\":\"Nauseated Face\",\"b\":\"1F922\",\"j\":[\"nauseated_face\",\"face\",\"vomit\",\"gross\",\"green\",\"sick\",\"throw up\",\"ill\"],\"k\":[38,18],\"o\":3},\"tent\":{\"a\":\"Tent\",\"b\":\"26FA\",\"j\":[\"tent\",\"photo\",\"camping\",\"outdoors\"],\"k\":[55,42],\"o\":0},\"star_of_david\":{\"a\":\"Star of David\",\"b\":\"2721-FE0F\",\"c\":\"2721\",\"j\":[\"star_of_david\",\"judaism\"],\"k\":[56,19],\"o\":0},\"flag-ch\":{\"a\":\"Switzerland Flag\",\"b\":\"1F1E8-1F1ED\",\"j\":[\"flag_switzerland\",\"ch\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,16],\"o\":2},\"foggy\":{\"a\":\"Foggy\",\"b\":\"1F301\",\"j\":[\"foggy\",\"photo\",\"mountain\"],\"k\":[5,15],\"o\":0},\"ski\":{\"a\":\"Ski and Ski Boot\",\"b\":\"1F3BF\",\"j\":[\"skis\",\"sports\",\"winter\",\"cold\",\"snow\"],\"k\":[8,29],\"o\":0},\"baby\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F476-1F3FB\",\"non_qualified\":null,\"image\":\"1f476-1f3fb.png\",\"sheet_x\":23,\"sheet_y\":9,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F476-1F3FC\",\"non_qualified\":null,\"image\":\"1f476-1f3fc.png\",\"sheet_x\":23,\"sheet_y\":10,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F476-1F3FD\",\"non_qualified\":null,\"image\":\"1f476-1f3fd.png\",\"sheet_x\":23,\"sheet_y\":11,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F476-1F3FE\",\"non_qualified\":null,\"image\":\"1f476-1f3fe.png\",\"sheet_x\":23,\"sheet_y\":12,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F476-1F3FF\",\"non_qualified\":null,\"image\":\"1f476-1f3ff.png\",\"sheet_x\":23,\"sheet_y\":13,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Baby\",\"b\":\"1F476\",\"j\":[\"baby\",\"child\",\"boy\",\"girl\",\"toddler\"],\"k\":[23,8],\"o\":0},\"postal_horn\":{\"a\":\"Postal Horn\",\"b\":\"1F4EF\",\"j\":[\"postal_horn\",\"instrument\",\"music\"],\"k\":[27,12],\"o\":1},\"face_vomiting\":{\"a\":\"Face with Open Mouth Vomiting\",\"b\":\"1F92E\",\"j\":[\"face_vomiting\",\"face\",\"sick\"],\"k\":[38,47],\"n\":[\"face_with_open_mouth_vomiting\"],\"o\":5},\"sandwich\":{\"a\":\"Sandwich\",\"b\":\"1F96A\",\"j\":[\"sandwich\",\"food\",\"lunch\",\"bread\"],\"k\":[42,7],\"o\":5},\"beaver\":{\"a\":\"Beaver\",\"b\":\"1F9AB\",\"j\":[\"beaver\",\"animal\",\"rodent\"],\"k\":[43,18],\"o\":13},\"wheel_of_dharma\":{\"a\":\"Wheel of Dharma\",\"b\":\"2638-FE0F\",\"c\":\"2638\",\"j\":[\"wheel_of_dharma\",\"hinduism\",\"buddhism\",\"sikhism\",\"jainism\"],\"k\":[54,20],\"o\":0},\"flag-ci\":{\"a\":\"Côte D’ivoire Flag\",\"b\":\"1F1E8-1F1EE\",\"j\":[\"flag_cote_d_ivoire\",\"ivory\",\"coast\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,17],\"o\":2},\"night_with_stars\":{\"a\":\"Night with Stars\",\"b\":\"1F303\",\"j\":[\"night_with_stars\",\"evening\",\"city\",\"downtown\"],\"k\":[5,17],\"o\":0},\"taco\":{\"a\":\"Taco\",\"b\":\"1F32E\",\"j\":[\"taco\",\"food\",\"mexican\"],\"k\":[6,0],\"o\":1},\"bell\":{\"a\":\"Bell\",\"b\":\"1F514\",\"j\":[\"bell\",\"sound\",\"notification\",\"christmas\",\"xmas\",\"chime\"],\"k\":[27,48],\"o\":0},\"sled\":{\"a\":\"Sled\",\"b\":\"1F6F7\",\"j\":[\"sled\",\"sleigh\",\"luge\",\"toboggan\"],\"k\":[36,49],\"o\":5},\"sneezing_face\":{\"a\":\"Sneezing Face\",\"b\":\"1F927\",\"j\":[\"sneezing_face\",\"face\",\"gesundheit\",\"sneeze\",\"sick\",\"allergy\"],\"k\":[38,40],\"o\":3},\"hedgehog\":{\"a\":\"Hedgehog\",\"b\":\"1F994\",\"j\":[\"hedgehog\",\"animal\",\"nature\",\"spiny\"],\"k\":[42,53],\"o\":5},\"child\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D2-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d2-1f3fb.png\",\"sheet_x\":48,\"sheet_y\":44,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D2-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d2-1f3fc.png\",\"sheet_x\":48,\"sheet_y\":45,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D2-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d2-1f3fd.png\",\"sheet_x\":48,\"sheet_y\":46,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D2-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d2-1f3fe.png\",\"sheet_x\":48,\"sheet_y\":47,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D2-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d2-1f3ff.png\",\"sheet_x\":48,\"sheet_y\":48,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Child\",\"b\":\"1F9D2\",\"j\":[\"child\",\"gender-neutral\",\"young\"],\"k\":[48,43],\"o\":5},\"yin_yang\":{\"a\":\"Yin Yang\",\"b\":\"262F-FE0F\",\"c\":\"262F\",\"j\":[\"yin_yang\",\"balance\"],\"k\":[54,19],\"o\":0},\"flag-ck\":{\"a\":\"Cook Islands Flag\",\"b\":\"1F1E8-1F1F0\",\"j\":[\"flag_cook_islands\",\"cook\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,18],\"o\":2},\"burrito\":{\"a\":\"Burrito\",\"b\":\"1F32F\",\"j\":[\"burrito\",\"food\",\"mexican\"],\"k\":[6,1],\"o\":1},\"cityscape\":{\"a\":\"Cityscape\",\"b\":\"1F3D9-FE0F\",\"c\":\"1F3D9\",\"j\":[\"cityscape\",\"photo\",\"night life\",\"urban\"],\"k\":[10,34],\"o\":0},\"boy\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F466-1F3FB\",\"non_qualified\":null,\"image\":\"1f466-1f3fb.png\",\"sheet_x\":14,\"sheet_y\":16,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F466-1F3FC\",\"non_qualified\":null,\"image\":\"1f466-1f3fc.png\",\"sheet_x\":14,\"sheet_y\":17,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F466-1F3FD\",\"non_qualified\":null,\"image\":\"1f466-1f3fd.png\",\"sheet_x\":14,\"sheet_y\":18,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F466-1F3FE\",\"non_qualified\":null,\"image\":\"1f466-1f3fe.png\",\"sheet_x\":14,\"sheet_y\":19,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F466-1F3FF\",\"non_qualified\":null,\"image\":\"1f466-1f3ff.png\",\"sheet_x\":14,\"sheet_y\":20,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Boy\",\"b\":\"1F466\",\"j\":[\"boy\",\"man\",\"male\",\"guy\",\"teenager\"],\"k\":[14,15],\"o\":0},\"no_bell\":{\"a\":\"Bell with Cancellation Stroke\",\"b\":\"1F515\",\"j\":[\"bell_with_slash\",\"sound\",\"volume\",\"mute\",\"quiet\",\"silent\"],\"k\":[27,49],\"o\":1},\"curling_stone\":{\"a\":\"Curling Stone\",\"b\":\"1F94C\",\"j\":[\"curling_stone\",\"sports\"],\"k\":[41,35],\"o\":5},\"hot_face\":{\"a\":\"Overheated Face\",\"b\":\"1F975\",\"j\":[\"hot_face\",\"face\",\"feverish\",\"heat\",\"red\",\"sweating\"],\"k\":[42,18],\"o\":11},\"bat\":{\"a\":\"Bat\",\"b\":\"1F987\",\"j\":[\"bat\",\"animal\",\"nature\",\"blind\",\"vampire\"],\"k\":[42,40],\"o\":3},\"latin_cross\":{\"a\":\"Latin Cross\",\"b\":\"271D-FE0F\",\"c\":\"271D\",\"j\":[\"latin_cross\",\"christianity\"],\"k\":[56,18],\"o\":0},\"flag-cl\":{\"a\":\"Chile Flag\",\"b\":\"1F1E8-1F1F1\",\"j\":[\"flag_chile\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,19],\"o\":2},\"sunrise_over_mountains\":{\"a\":\"Sunrise over Mountains\",\"b\":\"1F304\",\"j\":[\"sunrise_over_mountains\",\"view\",\"vacation\",\"photo\"],\"k\":[5,18],\"o\":0},\"dart\":{\"a\":\"Direct Hit\",\"b\":\"1F3AF\",\"j\":[\"direct_hit\",\"game\",\"play\",\"bar\",\"target\",\"bullseye\"],\"k\":[8,13],\"o\":0},\"musical_score\":{\"a\":\"Musical Score\",\"b\":\"1F3BC\",\"j\":[\"musical_score\",\"treble\",\"clef\",\"compose\"],\"k\":[8,26],\"o\":0},\"bear\":{\"a\":\"Bear Face\",\"b\":\"1F43B\",\"j\":[\"bear\",\"animal\",\"nature\",\"wild\"],\"k\":[12,22],\"o\":0},\"girl\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F467-1F3FB\",\"non_qualified\":null,\"image\":\"1f467-1f3fb.png\",\"sheet_x\":14,\"sheet_y\":22,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F467-1F3FC\",\"non_qualified\":null,\"image\":\"1f467-1f3fc.png\",\"sheet_x\":14,\"sheet_y\":23,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F467-1F3FD\",\"non_qualified\":null,\"image\":\"1f467-1f3fd.png\",\"sheet_x\":14,\"sheet_y\":24,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F467-1F3FE\",\"non_qualified\":null,\"image\":\"1f467-1f3fe.png\",\"sheet_x\":14,\"sheet_y\":25,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F467-1F3FF\",\"non_qualified\":null,\"image\":\"1f467-1f3ff.png\",\"sheet_x\":14,\"sheet_y\":26,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Girl\",\"b\":\"1F467\",\"j\":[\"girl\",\"female\",\"woman\",\"teenager\"],\"k\":[14,21],\"o\":0},\"cold_face\":{\"a\":\"Freezing Face\",\"b\":\"1F976\",\"j\":[\"cold_face\",\"face\",\"blue\",\"freezing\",\"frozen\",\"frostbite\",\"icicles\"],\"k\":[42,19],\"o\":11},\"tamale\":{\"a\":\"Tamale\",\"b\":\"1FAD4\",\"j\":[\"tamale\",\"food\",\"masa\"],\"k\":[53,13],\"o\":13},\"orthodox_cross\":{\"a\":\"Orthodox Cross\",\"b\":\"2626-FE0F\",\"c\":\"2626\",\"j\":[\"orthodox_cross\",\"suppedaneum\",\"religion\"],\"k\":[54,16],\"o\":1},\"flag-cm\":{\"a\":\"Cameroon Flag\",\"b\":\"1F1E8-1F1F2\",\"j\":[\"flag_cameroon\",\"cm\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,20],\"o\":2},\"sunrise\":{\"a\":\"Sunrise\",\"b\":\"1F305\",\"j\":[\"sunrise\",\"morning\",\"view\",\"vacation\",\"photo\"],\"k\":[5,19],\"o\":0},\"musical_note\":{\"a\":\"Musical Note\",\"b\":\"1F3B5\",\"j\":[\"musical_note\",\"score\",\"tone\",\"sound\"],\"k\":[8,19],\"o\":0},\"polar_bear\":{\"a\":\"Polar Bear\",\"b\":\"1F43B-200D-2744-FE0F\",\"c\":\"1F43B-200D-2744\",\"j\":[\"polar bear\",\"animal\",\"arctic\"],\"k\":[12,21],\"o\":13},\"stuffed_flatbread\":{\"a\":\"Stuffed Flatbread\",\"b\":\"1F959\",\"j\":[\"stuffed_flatbread\",\"food\",\"flatbread\",\"stuffed\",\"gyro\"],\"k\":[41,48],\"o\":3},\"woozy_face\":{\"a\":\"Face with Uneven Eyes and Wavy Mouth\",\"b\":\"1F974\",\"j\":[\"woozy_face\",\"face\",\"dizzy\",\"intoxicated\",\"tipsy\",\"wavy\"],\"k\":[42,17],\"o\":11},\"adult\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb.png\",\"sheet_x\":48,\"sheet_y\":38,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc.png\",\"sheet_x\":48,\"sheet_y\":39,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd.png\",\"sheet_x\":48,\"sheet_y\":40,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe.png\",\"sheet_x\":48,\"sheet_y\":41,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff.png\",\"sheet_x\":48,\"sheet_y\":42,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Adult\",\"b\":\"1F9D1\",\"j\":[\"person\",\"gender-neutral\",\"person\"],\"k\":[48,37],\"o\":5},\"yo-yo\":{\"a\":\"Yo-Yo\",\"b\":\"1FA80\",\"j\":[\"yo_yo\",\"toy\"],\"k\":[52,25],\"o\":12},\"star_and_crescent\":{\"a\":\"Star and Crescent\",\"b\":\"262A-FE0F\",\"c\":\"262A\",\"j\":[\"star_and_crescent\",\"islam\"],\"k\":[54,17],\"o\":0},\"cn\":{\"a\":\"China Flag\",\"b\":\"1F1E8-1F1F3\",\"j\":[\"flag_china\",\"china\",\"chinese\",\"prc\",\"flag\",\"country\",\"nation\",\"banner\"],\"k\":[1,21],\"n\":[\"flag-cn\"],\"o\":0},\"city_sunset\":{\"a\":\"Cityscape at Dusk\",\"b\":\"1F306\",\"j\":[\"cityscape_at_dusk\",\"photo\",\"evening\",\"sky\",\"buildings\"],\"k\":[5,20],\"o\":0},\"notes\":{\"a\":\"Multiple Musical Notes\",\"b\":\"1F3B6\",\"j\":[\"musical_notes\",\"music\",\"score\"],\"k\":[8,20],\"o\":0},\"koala\":{\"a\":\"Koala\",\"b\":\"1F428\",\"j\":[\"koala\",\"animal\",\"nature\"],\"k\":[12,2],\"o\":0},\"person_with_blond_hair\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F471-1F3FB\",\"non_qualified\":null,\"image\":\"1f471-1f3fb.png\",\"sheet_x\":22,\"sheet_y\":25,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F471-1F3FC\",\"non_qualified\":null,\"image\":\"1f471-1f3fc.png\",\"sheet_x\":22,\"sheet_y\":26,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F471-1F3FD\",\"non_qualified\":null,\"image\":\"1f471-1f3fd.png\",\"sheet_x\":22,\"sheet_y\":27,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F471-1F3FE\",\"non_qualified\":null,\"image\":\"1f471-1f3fe.png\",\"sheet_x\":22,\"sheet_y\":28,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F471-1F3FF\",\"non_qualified\":null,\"image\":\"1f471-1f3ff.png\",\"sheet_x\":22,\"sheet_y\":29,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F471-200D-2642-FE0F\",\"a\":\"Person with Blond Hair\",\"b\":\"1F471\",\"j\":[\"person_blond_hair\",\"hairstyle\"],\"k\":[22,24],\"o\":0},\"dizzy_face\":{\"a\":\"Dizzy Face\",\"b\":\"1F635\",\"j\":[\"dizzy_face\",\"spent\",\"unconscious\",\"xox\",\"dizzy\"],\"k\":[31,27],\"o\":0},\"falafel\":{\"a\":\"Falafel\",\"b\":\"1F9C6\",\"j\":[\"falafel\",\"food\"],\"k\":[44,32],\"o\":12},\"kite\":{\"a\":\"Kite\",\"b\":\"1FA81\",\"j\":[\"kite\",\"wind\",\"fly\"],\"k\":[52,26],\"o\":12},\"peace_symbol\":{\"a\":\"Peace Symbol\",\"b\":\"262E-FE0F\",\"c\":\"262E\",\"j\":[\"peace_symbol\",\"hippie\"],\"k\":[54,18],\"o\":1},\"flag-co\":{\"a\":\"Colombia Flag\",\"b\":\"1F1E8-1F1F4\",\"j\":[\"flag_colombia\",\"co\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,22],\"o\":2},\"city_sunrise\":{\"a\":\"Sunset over Buildings\",\"b\":\"1F307\",\"j\":[\"sunset\",\"photo\",\"good morning\",\"dawn\"],\"k\":[5,21],\"o\":0},\"studio_microphone\":{\"a\":\"Studio Microphone\",\"b\":\"1F399-FE0F\",\"c\":\"1F399\",\"j\":[\"studio_microphone\",\"sing\",\"recording\",\"artist\",\"talkshow\"],\"k\":[7,51],\"o\":0},\"8ball\":{\"a\":\"Billiards\",\"b\":\"1F3B1\",\"j\":[\"pool_8_ball\",\"pool\",\"hobby\",\"game\",\"luck\",\"magic\"],\"k\":[8,15],\"o\":0},\"panda_face\":{\"a\":\"Panda Face\",\"b\":\"1F43C\",\"j\":[\"panda\",\"animal\",\"nature\",\"panda\"],\"k\":[12,23],\"o\":0},\"man\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f468-1f3fb.png\",\"sheet_x\":17,\"sheet_y\":15,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f468-1f3fc.png\",\"sheet_x\":17,\"sheet_y\":16,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f468-1f3fd.png\",\"sheet_x\":17,\"sheet_y\":17,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f468-1f3fe.png\",\"sheet_x\":17,\"sheet_y\":18,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f468-1f3ff.png\",\"sheet_x\":17,\"sheet_y\":19,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man\",\"b\":\"1F468\",\"j\":[\"man\",\"mustache\",\"father\",\"dad\",\"guy\",\"classy\",\"sir\",\"moustache\"],\"k\":[17,14],\"o\":0},\"menorah_with_nine_branches\":{\"a\":\"Menorah with Nine Branches\",\"b\":\"1F54E\",\"j\":[\"menorah\",\"hanukkah\",\"candles\",\"jewish\"],\"k\":[28,37],\"o\":1},\"exploding_head\":{\"a\":\"Shocked Face with Exploding Head\",\"b\":\"1F92F\",\"j\":[\"exploding_head\",\"face\",\"shocked\",\"mind\",\"blown\"],\"k\":[38,48],\"n\":[\"shocked_face_with_exploding_head\"],\"o\":5},\"egg\":{\"a\":\"Egg\",\"b\":\"1F95A\",\"j\":[\"egg\",\"food\",\"chicken\",\"breakfast\"],\"k\":[41,49],\"o\":3},\"flag-cp\":{\"a\":\"Clipperton Island Flag\",\"b\":\"1F1E8-1F1F5\",\"j\":[\"flag_clipperton_island\"],\"k\":[1,23],\"o\":2},\"bridge_at_night\":{\"a\":\"Bridge at Night\",\"b\":\"1F309\",\"j\":[\"bridge_at_night\",\"photo\",\"sanfrancisco\"],\"k\":[5,23],\"o\":0},\"fried_egg\":{\"a\":\"Cooking\",\"b\":\"1F373\",\"j\":[\"cooking\",\"food\",\"breakfast\",\"kitchen\",\"egg\"],\"k\":[7,11],\"n\":[\"cooking\"],\"o\":0},\"level_slider\":{\"a\":\"Level Slider\",\"b\":\"1F39A-FE0F\",\"c\":\"1F39A\",\"j\":[\"level_slider\",\"scale\"],\"k\":[7,52],\"o\":0},\"crystal_ball\":{\"a\":\"Crystal Ball\",\"b\":\"1F52E\",\"j\":[\"crystal_ball\",\"disco\",\"party\",\"magic\",\"circus\",\"fortune_teller\"],\"k\":[28,16],\"o\":0},\"six_pointed_star\":{\"a\":\"Six Pointed Star with Middle Dot\",\"b\":\"1F52F\",\"j\":[\"dotted_six_pointed_star\",\"purple-square\",\"religion\",\"jewish\",\"hexagram\"],\"k\":[28,17],\"o\":0},\"face_with_cowboy_hat\":{\"a\":\"Face with Cowboy Hat\",\"b\":\"1F920\",\"j\":[\"cowboy_hat_face\",\"face\",\"cowgirl\",\"hat\"],\"k\":[38,16],\"o\":3},\"sloth\":{\"a\":\"Sloth\",\"b\":\"1F9A5\",\"j\":[\"sloth\",\"animal\"],\"k\":[43,12],\"o\":12},\"bearded_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D4-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d4-1f3fb.png\",\"sheet_x\":48,\"sheet_y\":56,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D4-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d4-1f3fc.png\",\"sheet_x\":48,\"sheet_y\":57,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D4-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d4-1f3fd.png\",\"sheet_x\":49,\"sheet_y\":0,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D4-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d4-1f3fe.png\",\"sheet_x\":49,\"sheet_y\":1,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D4-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d4-1f3ff.png\",\"sheet_x\":49,\"sheet_y\":2,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Bearded Person\",\"b\":\"1F9D4\",\"j\":[\"man_beard\",\"person\",\"bewhiskered\"],\"k\":[48,55],\"o\":5},\"flag-cr\":{\"a\":\"Costa Rica Flag\",\"b\":\"1F1E8-1F1F7\",\"j\":[\"flag_costa_rica\",\"costa\",\"rica\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,24],\"o\":2},\"control_knobs\":{\"a\":\"Control Knobs\",\"b\":\"1F39B-FE0F\",\"c\":\"1F39B\",\"j\":[\"control_knobs\",\"dial\"],\"k\":[7,53],\"o\":0},\"red_haired_man\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f9b0.png\",\"sheet_x\":16,\"sheet_y\":17,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f9b0.png\",\"sheet_x\":16,\"sheet_y\":18,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f9b0.png\",\"sheet_x\":16,\"sheet_y\":19,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f9b0.png\",\"sheet_x\":16,\"sheet_y\":20,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f9b0.png\",\"sheet_x\":16,\"sheet_y\":21,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man: Red Hair\",\"b\":\"1F468-200D-1F9B0\",\"j\":[\"man_red_hair\",\"hairstyle\"],\"k\":[16,16],\"o\":11},\"shallow_pan_of_food\":{\"a\":\"Shallow Pan of Food\",\"b\":\"1F958\",\"j\":[\"shallow_pan_of_food\",\"food\",\"cooking\",\"casserole\",\"paella\"],\"k\":[41,47],\"o\":3},\"partying_face\":{\"a\":\"Face with Party Horn and Party Hat\",\"b\":\"1F973\",\"j\":[\"partying_face\",\"face\",\"celebration\",\"woohoo\"],\"k\":[42,16],\"o\":11},\"otter\":{\"a\":\"Otter\",\"b\":\"1F9A6\",\"j\":[\"otter\",\"animal\"],\"k\":[43,13],\"o\":12},\"magic_wand\":{\"a\":\"Magic Wand\",\"b\":\"1FA84\",\"j\":[\"magic wand\",\"supernature\",\"power\"],\"k\":[52,29],\"o\":13},\"aries\":{\"a\":\"Aries\",\"b\":\"2648\",\"j\":[\"aries\",\"sign\",\"purple-square\",\"zodiac\",\"astrology\"],\"k\":[54,25],\"o\":0},\"hotsprings\":{\"a\":\"Hot Springs\",\"b\":\"2668-FE0F\",\"c\":\"2668\",\"j\":[\"hot_springs\",\"bath\",\"warm\",\"relax\"],\"k\":[54,42],\"o\":0},\"flag-cu\":{\"a\":\"Cuba Flag\",\"b\":\"1F1E8-1F1FA\",\"j\":[\"flag_cuba\",\"cu\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,25],\"o\":2},\"stew\":{\"a\":\"Pot of Food\",\"b\":\"1F372\",\"j\":[\"pot_of_food\",\"food\",\"meat\",\"soup\"],\"k\":[7,10],\"o\":0},\"carousel_horse\":{\"a\":\"Carousel Horse\",\"b\":\"1F3A0\",\"j\":[\"carousel_horse\",\"photo\",\"carnival\"],\"k\":[7,56],\"o\":0},\"microphone\":{\"a\":\"Microphone\",\"b\":\"1F3A4\",\"j\":[\"microphone\",\"sound\",\"music\",\"PA\",\"sing\",\"talkshow\"],\"k\":[8,2],\"o\":0},\"curly_haired_man\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f9b1.png\",\"sheet_x\":16,\"sheet_y\":23,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f9b1.png\",\"sheet_x\":16,\"sheet_y\":24,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f9b1.png\",\"sheet_x\":16,\"sheet_y\":25,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f9b1.png\",\"sheet_x\":16,\"sheet_y\":26,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f9b1.png\",\"sheet_x\":16,\"sheet_y\":27,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man: Curly Hair\",\"b\":\"1F468-200D-1F9B1\",\"j\":[\"man_curly_hair\",\"hairstyle\"],\"k\":[16,22],\"o\":11},\"disguised_face\":{\"a\":\"Disguised Face\",\"b\":\"1F978\",\"j\":[\"disguised face\",\"pretent\",\"brows\",\"glasses\",\"moustache\"],\"k\":[42,26],\"o\":13},\"skunk\":{\"a\":\"Skunk\",\"b\":\"1F9A8\",\"j\":[\"skunk\",\"animal\"],\"k\":[43,15],\"o\":12},\"nazar_amulet\":{\"a\":\"Nazar Amulet\",\"b\":\"1F9FF\",\"j\":[\"nazar_amulet\",\"bead\",\"charm\"],\"k\":[52,16],\"o\":11},\"taurus\":{\"a\":\"Taurus\",\"b\":\"2649\",\"j\":[\"taurus\",\"purple-square\",\"sign\",\"zodiac\",\"astrology\"],\"k\":[54,26],\"o\":0},\"flag-cv\":{\"a\":\"Cape Verde Flag\",\"b\":\"1F1E8-1F1FB\",\"j\":[\"flag_cape_verde\",\"cabo\",\"verde\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,26],\"o\":2},\"ferris_wheel\":{\"a\":\"Ferris Wheel\",\"b\":\"1F3A1\",\"j\":[\"ferris_wheel\",\"photo\",\"carnival\",\"londoneye\"],\"k\":[7,57],\"o\":0},\"headphones\":{\"a\":\"Headphone\",\"b\":\"1F3A7\",\"j\":[\"headphone\",\"music\",\"score\",\"gadgets\"],\"k\":[8,5],\"o\":0},\"video_game\":{\"a\":\"Video Game\",\"b\":\"1F3AE\",\"j\":[\"video_game\",\"play\",\"console\",\"PS4\",\"controller\"],\"k\":[8,12],\"o\":0},\"white_haired_man\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f9b3.png\",\"sheet_x\":16,\"sheet_y\":35,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f9b3.png\",\"sheet_x\":16,\"sheet_y\":36,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f9b3.png\",\"sheet_x\":16,\"sheet_y\":37,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f9b3.png\",\"sheet_x\":16,\"sheet_y\":38,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f9b3.png\",\"sheet_x\":16,\"sheet_y\":39,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man: White Hair\",\"b\":\"1F468-200D-1F9B3\",\"j\":[\"man_white_hair\",\"old\",\"elder\"],\"k\":[16,34],\"o\":11},\"sunglasses\":{\"a\":\"Smiling Face with Sunglasses\",\"b\":\"1F60E\",\"j\":[\"smiling_face_with_sunglasses\",\"face\",\"cool\",\"smile\",\"summer\",\"beach\",\"sunglass\"],\"k\":[30,46],\"l\":[\"8)\"],\"o\":1},\"kangaroo\":{\"a\":\"Kangaroo\",\"b\":\"1F998\",\"j\":[\"kangaroo\",\"animal\",\"nature\",\"australia\",\"joey\",\"hop\",\"marsupial\"],\"k\":[42,57],\"o\":11},\"fondue\":{\"a\":\"Fondue\",\"b\":\"1FAD5\",\"j\":[\"fondue\",\"cheese\",\"pot\",\"food\"],\"k\":[53,14],\"o\":13},\"gemini\":{\"a\":\"Gemini\",\"b\":\"264A\",\"j\":[\"gemini\",\"sign\",\"zodiac\",\"purple-square\",\"astrology\"],\"k\":[54,27],\"o\":0},\"flag-cw\":{\"a\":\"Curaçao Flag\",\"b\":\"1F1E8-1F1FC\",\"j\":[\"flag_curacao\",\"curaçao\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,27],\"o\":2},\"roller_coaster\":{\"a\":\"Roller Coaster\",\"b\":\"1F3A2\",\"j\":[\"roller_coaster\",\"carnival\",\"playground\",\"photo\",\"fun\"],\"k\":[8,0],\"o\":0},\"bald_man\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f9b2.png\",\"sheet_x\":16,\"sheet_y\":29,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f9b2.png\",\"sheet_x\":16,\"sheet_y\":30,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f9b2.png\",\"sheet_x\":16,\"sheet_y\":31,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f9b2.png\",\"sheet_x\":16,\"sheet_y\":32,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f9b2.png\",\"sheet_x\":16,\"sheet_y\":33,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man: Bald\",\"b\":\"1F468-200D-1F9B2\",\"j\":[\"man_bald\",\"hairless\"],\"k\":[16,28],\"o\":11},\"radio\":{\"a\":\"Radio\",\"b\":\"1F4FB\",\"j\":[\"radio\",\"communication\",\"music\",\"podcast\",\"program\"],\"k\":[27,24],\"o\":0},\"joystick\":{\"a\":\"Joystick\",\"b\":\"1F579-FE0F\",\"c\":\"1F579\",\"j\":[\"joystick\",\"game\",\"play\"],\"k\":[29,34],\"o\":0},\"nerd_face\":{\"a\":\"Nerd Face\",\"b\":\"1F913\",\"j\":[\"nerd_face\",\"face\",\"nerdy\",\"geek\",\"dork\"],\"k\":[37,26],\"o\":1},\"bowl_with_spoon\":{\"a\":\"Bowl with Spoon\",\"b\":\"1F963\",\"j\":[\"bowl_with_spoon\",\"food\",\"breakfast\",\"cereal\",\"oatmeal\",\"porridge\"],\"k\":[42,0],\"o\":5},\"badger\":{\"a\":\"Badger\",\"b\":\"1F9A1\",\"j\":[\"badger\",\"animal\",\"nature\",\"honey\"],\"k\":[43,8],\"o\":11},\"cancer\":{\"a\":\"Cancer\",\"b\":\"264B\",\"j\":[\"cancer\",\"sign\",\"zodiac\",\"purple-square\",\"astrology\"],\"k\":[54,28],\"o\":0},\"flag-cx\":{\"a\":\"Christmas Island Flag\",\"b\":\"1F1E8-1F1FD\",\"j\":[\"flag_christmas_island\",\"christmas\",\"island\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,28],\"o\":2},\"slot_machine\":{\"a\":\"Slot Machine\",\"b\":\"1F3B0\",\"j\":[\"slot_machine\",\"bet\",\"gamble\",\"vegas\",\"fruit machine\",\"luck\",\"casino\"],\"k\":[8,14],\"o\":0},\"saxophone\":{\"a\":\"Saxophone\",\"b\":\"1F3B7\",\"j\":[\"saxophone\",\"music\",\"instrument\",\"jazz\",\"blues\"],\"k\":[8,21],\"o\":0},\"feet\":{\"a\":\"Paw Prints\",\"b\":\"1F43E\",\"j\":[\"paw_prints\",\"animal\",\"tracking\",\"footprints\",\"dog\",\"cat\",\"pet\",\"feet\"],\"k\":[12,25],\"n\":[\"paw_prints\"],\"o\":0},\"woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":5,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":6,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":7,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":8,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":9,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman\",\"b\":\"1F469\",\"j\":[\"woman\",\"female\",\"girls\",\"lady\"],\"k\":[20,4],\"o\":0},\"barber\":{\"a\":\"Barber Pole\",\"b\":\"1F488\",\"j\":[\"barber_pole\",\"hair\",\"salon\",\"style\"],\"k\":[25,20],\"o\":0},\"green_salad\":{\"a\":\"Green Salad\",\"b\":\"1F957\",\"j\":[\"green_salad\",\"food\",\"healthy\",\"lettuce\"],\"k\":[41,46],\"o\":3},\"face_with_monocle\":{\"a\":\"Face with Monocle\",\"b\":\"1F9D0\",\"j\":[\"face_with_monocle\",\"face\",\"stuffy\",\"wealthy\"],\"k\":[45,34],\"o\":5},\"leo\":{\"a\":\"Leo\",\"b\":\"264C\",\"j\":[\"leo\",\"sign\",\"purple-square\",\"zodiac\",\"astrology\"],\"k\":[54,29],\"o\":0},\"flag-cy\":{\"a\":\"Cyprus Flag\",\"b\":\"1F1E8-1F1FE\",\"j\":[\"flag_cyprus\",\"cy\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,29],\"o\":2},\"popcorn\":{\"a\":\"Popcorn\",\"b\":\"1F37F\",\"j\":[\"popcorn\",\"food\",\"movie theater\",\"films\",\"snack\"],\"k\":[7,23],\"o\":1},\"circus_tent\":{\"a\":\"Circus Tent\",\"b\":\"1F3AA\",\"j\":[\"circus_tent\",\"festival\",\"carnival\",\"party\"],\"k\":[8,8],\"o\":0},\"game_die\":{\"a\":\"Game Die\",\"b\":\"1F3B2\",\"j\":[\"game_die\",\"dice\",\"random\",\"tabletop\",\"play\",\"luck\"],\"k\":[8,16],\"o\":0},\"red_haired_woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f9b0.png\",\"sheet_x\":19,\"sheet_y\":5,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f9b0.png\",\"sheet_x\":19,\"sheet_y\":6,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f9b0.png\",\"sheet_x\":19,\"sheet_y\":7,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f9b0.png\",\"sheet_x\":19,\"sheet_y\":8,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f9b0.png\",\"sheet_x\":19,\"sheet_y\":9,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman: Red Hair\",\"b\":\"1F469-200D-1F9B0\",\"j\":[\"woman_red_hair\",\"hairstyle\"],\"k\":[19,4],\"o\":11},\"confused\":{\"a\":\"Confused Face\",\"b\":\"1F615\",\"j\":[\"confused_face\",\"face\",\"indifference\",\"huh\",\"weird\",\"hmmm\",\":/\"],\"k\":[30,53],\"l\":[\":\\\\\",\":-\\\\\",\":/\",\":-/\"],\"o\":1},\"turkey\":{\"a\":\"Turkey\",\"b\":\"1F983\",\"j\":[\"turkey\",\"animal\",\"bird\"],\"k\":[42,36],\"o\":1},\"accordion\":{\"a\":\"Accordion\",\"b\":\"1FA97\",\"j\":[\"accordion\",\"music\"],\"k\":[52,39],\"o\":13},\"virgo\":{\"a\":\"Virgo\",\"b\":\"264D\",\"j\":[\"virgo\",\"sign\",\"zodiac\",\"purple-square\",\"astrology\"],\"k\":[54,30],\"o\":0},\"flag-cz\":{\"a\":\"Czechia Flag\",\"b\":\"1F1E8-1F1FF\",\"j\":[\"flag_czechia\",\"cz\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,30],\"o\":2},\"guitar\":{\"a\":\"Guitar\",\"b\":\"1F3B8\",\"j\":[\"guitar\",\"music\",\"instrument\"],\"k\":[8,22],\"o\":0},\"chicken\":{\"a\":\"Chicken\",\"b\":\"1F414\",\"j\":[\"chicken\",\"animal\",\"cluck\",\"nature\",\"bird\"],\"k\":[11,39],\"o\":0},\"worried\":{\"a\":\"Worried Face\",\"b\":\"1F61F\",\"j\":[\"worried_face\",\"face\",\"concern\",\"nervous\",\":(\"],\"k\":[31,5],\"o\":1},\"steam_locomotive\":{\"a\":\"Steam Locomotive\",\"b\":\"1F682\",\"j\":[\"locomotive\",\"transportation\",\"vehicle\",\"train\"],\"k\":[33,52],\"o\":1},\"butter\":{\"a\":\"Butter\",\"b\":\"1F9C8\",\"j\":[\"butter\",\"food\",\"cook\"],\"k\":[44,34],\"o\":12},\"red_haired_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f9b0.png\",\"sheet_x\":47,\"sheet_y\":42,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f9b0.png\",\"sheet_x\":47,\"sheet_y\":43,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f9b0.png\",\"sheet_x\":47,\"sheet_y\":44,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f9b0.png\",\"sheet_x\":47,\"sheet_y\":45,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F9B0\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f9b0.png\",\"sheet_x\":47,\"sheet_y\":46,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person: Red Hair\",\"b\":\"1F9D1-200D-1F9B0\",\"j\":[\"person_red_hair\",\"hairstyle\"],\"k\":[47,41],\"o\":12},\"jigsaw\":{\"a\":\"Jigsaw Puzzle Piece\",\"b\":\"1F9E9\",\"j\":[\"puzzle_piece\",\"interlocking\",\"puzzle\",\"piece\"],\"k\":[51,52],\"o\":11},\"libra\":{\"a\":\"Libra\",\"b\":\"264E\",\"j\":[\"libra\",\"sign\",\"purple-square\",\"zodiac\",\"astrology\"],\"k\":[54,31],\"o\":0},\"de\":{\"a\":\"Germany Flag\",\"b\":\"1F1E9-1F1EA\",\"j\":[\"flag_germany\",\"german\",\"nation\",\"flag\",\"country\",\"banner\"],\"k\":[1,31],\"n\":[\"flag-de\"],\"o\":0},\"musical_keyboard\":{\"a\":\"Musical Keyboard\",\"b\":\"1F3B9\",\"j\":[\"musical_keyboard\",\"piano\",\"instrument\",\"compose\"],\"k\":[8,23],\"o\":0},\"rooster\":{\"a\":\"Rooster\",\"b\":\"1F413\",\"j\":[\"rooster\",\"animal\",\"nature\",\"chicken\"],\"k\":[11,38],\"o\":1},\"curly_haired_woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f9b1.png\",\"sheet_x\":19,\"sheet_y\":11,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f9b1.png\",\"sheet_x\":19,\"sheet_y\":12,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f9b1.png\",\"sheet_x\":19,\"sheet_y\":13,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f9b1.png\",\"sheet_x\":19,\"sheet_y\":14,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f9b1.png\",\"sheet_x\":19,\"sheet_y\":15,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman: Curly Hair\",\"b\":\"1F469-200D-1F9B1\",\"j\":[\"woman_curly_hair\",\"hairstyle\"],\"k\":[19,10],\"o\":11},\"slightly_frowning_face\":{\"a\":\"Slightly Frowning Face\",\"b\":\"1F641\",\"j\":[\"slightly_frowning_face\",\"face\",\"frowning\",\"disappointed\",\"sad\",\"upset\"],\"k\":[31,39],\"o\":1},\"railway_car\":{\"a\":\"Railway Car\",\"b\":\"1F683\",\"j\":[\"railway_car\",\"transportation\",\"vehicle\"],\"k\":[33,53],\"o\":0},\"salt\":{\"a\":\"Salt Shaker\",\"b\":\"1F9C2\",\"j\":[\"salt\",\"condiment\",\"shaker\"],\"k\":[44,28],\"o\":11},\"teddy_bear\":{\"a\":\"Teddy Bear\",\"b\":\"1F9F8\",\"j\":[\"teddy_bear\",\"plush\",\"stuffed\"],\"k\":[52,9],\"o\":11},\"scorpius\":{\"a\":\"Scorpius\",\"b\":\"264F\",\"j\":[\"scorpio\",\"sign\",\"zodiac\",\"purple-square\",\"astrology\",\"scorpio\"],\"k\":[54,32],\"o\":0},\"flag-dg\":{\"a\":\"Diego Garcia Flag\",\"b\":\"1F1E9-1F1EC\",\"j\":[\"flag_diego_garcia\"],\"k\":[1,32],\"o\":2},\"trumpet\":{\"a\":\"Trumpet\",\"b\":\"1F3BA\",\"j\":[\"trumpet\",\"music\",\"brass\"],\"k\":[8,24],\"o\":0},\"hatching_chick\":{\"a\":\"Hatching Chick\",\"b\":\"1F423\",\"j\":[\"hatching_chick\",\"animal\",\"chicken\",\"egg\",\"born\",\"baby\",\"bird\"],\"k\":[11,55],\"o\":0},\"bullettrain_side\":{\"a\":\"High-Speed Train\",\"b\":\"1F684\",\"j\":[\"high_speed_train\",\"transportation\",\"vehicle\"],\"k\":[33,54],\"o\":0},\"canned_food\":{\"a\":\"Canned Food\",\"b\":\"1F96B\",\"j\":[\"canned_food\",\"food\",\"soup\"],\"k\":[42,8],\"o\":5},\"curly_haired_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f9b1.png\",\"sheet_x\":47,\"sheet_y\":48,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f9b1.png\",\"sheet_x\":47,\"sheet_y\":49,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f9b1.png\",\"sheet_x\":47,\"sheet_y\":50,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f9b1.png\",\"sheet_x\":47,\"sheet_y\":51,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F9B1\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f9b1.png\",\"sheet_x\":47,\"sheet_y\":52,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person: Curly Hair\",\"b\":\"1F9D1-200D-1F9B1\",\"j\":[\"person_curly_hair\",\"hairstyle\"],\"k\":[47,47],\"o\":12},\"pinata\":{\"a\":\"Pinata\",\"b\":\"1FA85\",\"j\":[\"pinata\",\"mexico\",\"candy\",\"celebration\"],\"k\":[52,30],\"o\":13},\"white_frowning_face\":{\"a\":\"Frowning Face\",\"b\":\"2639-FE0F\",\"c\":\"2639\",\"j\":[\"frowning_face\",\"face\",\"sad\",\"upset\",\"frown\"],\"k\":[54,21],\"o\":0},\"sagittarius\":{\"a\":\"Sagittarius\",\"b\":\"2650\",\"j\":[\"sagittarius\",\"sign\",\"zodiac\",\"purple-square\",\"astrology\"],\"k\":[54,33],\"o\":0},\"flag-dj\":{\"a\":\"Djibouti Flag\",\"b\":\"1F1E9-1F1EF\",\"j\":[\"flag_djibouti\",\"dj\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,33],\"o\":2},\"bento\":{\"a\":\"Bento Box\",\"b\":\"1F371\",\"j\":[\"bento_box\",\"food\",\"japanese\",\"box\"],\"k\":[7,9],\"o\":0},\"violin\":{\"a\":\"Violin\",\"b\":\"1F3BB\",\"j\":[\"violin\",\"music\",\"instrument\",\"orchestra\",\"symphony\"],\"k\":[8,25],\"o\":0},\"baby_chick\":{\"a\":\"Baby Chick\",\"b\":\"1F424\",\"j\":[\"baby_chick\",\"animal\",\"chicken\",\"bird\"],\"k\":[11,56],\"o\":0},\"white_haired_woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f9b3.png\",\"sheet_x\":19,\"sheet_y\":23,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f9b3.png\",\"sheet_x\":19,\"sheet_y\":24,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f9b3.png\",\"sheet_x\":19,\"sheet_y\":25,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f9b3.png\",\"sheet_x\":19,\"sheet_y\":26,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f9b3.png\",\"sheet_x\":19,\"sheet_y\":27,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman: White Hair\",\"b\":\"1F469-200D-1F9B3\",\"j\":[\"woman_white_hair\",\"old\",\"elder\"],\"k\":[19,22],\"o\":11},\"open_mouth\":{\"a\":\"Face with Open Mouth\",\"b\":\"1F62E\",\"j\":[\"face_with_open_mouth\",\"face\",\"surprise\",\"impressed\",\"wow\",\"whoa\",\":O\"],\"k\":[31,20],\"l\":[\":o\",\":-o\",\":O\",\":-O\"],\"o\":1},\"bullettrain_front\":{\"a\":\"High-Speed Train with Bullet Nose\",\"b\":\"1F685\",\"j\":[\"bullet_train\",\"transportation\",\"vehicle\",\"speed\",\"fast\",\"public\",\"travel\"],\"k\":[33,55],\"o\":0},\"nesting_dolls\":{\"a\":\"Nesting Dolls\",\"b\":\"1FA86\",\"j\":[\"nesting dolls\",\"matryoshka\",\"toy\"],\"k\":[52,31],\"o\":13},\"capricorn\":{\"a\":\"Capricorn\",\"b\":\"2651\",\"j\":[\"capricorn\",\"sign\",\"zodiac\",\"purple-square\",\"astrology\"],\"k\":[54,34],\"o\":0},\"flag-dk\":{\"a\":\"Denmark Flag\",\"b\":\"1F1E9-1F1F0\",\"j\":[\"flag_denmark\",\"dk\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,34],\"o\":2},\"rice_cracker\":{\"a\":\"Rice Cracker\",\"b\":\"1F358\",\"j\":[\"rice_cracker\",\"food\",\"japanese\"],\"k\":[6,42],\"o\":0},\"hatched_chick\":{\"a\":\"Front-Facing Baby Chick\",\"b\":\"1F425\",\"j\":[\"front_facing_baby_chick\",\"animal\",\"chicken\",\"baby\",\"bird\"],\"k\":[11,57],\"o\":0},\"hushed\":{\"a\":\"Hushed Face\",\"b\":\"1F62F\",\"j\":[\"hushed_face\",\"face\",\"woo\",\"shh\"],\"k\":[31,21],\"o\":1},\"train2\":{\"a\":\"Train\",\"b\":\"1F686\",\"j\":[\"train\",\"transportation\",\"vehicle\"],\"k\":[33,56],\"o\":1},\"white_haired_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f9b3.png\",\"sheet_x\":48,\"sheet_y\":2,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f9b3.png\",\"sheet_x\":48,\"sheet_y\":3,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f9b3.png\",\"sheet_x\":48,\"sheet_y\":4,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f9b3.png\",\"sheet_x\":48,\"sheet_y\":5,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F9B3\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f9b3.png\",\"sheet_x\":48,\"sheet_y\":6,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false}},\"a\":\"Person: White Hair\",\"b\":\"1F9D1-200D-1F9B3\",\"j\":[\"person_white_hair\",\"elder\",\"old\"],\"k\":[48,1],\"o\":12},\"banjo\":{\"a\":\"Banjo\",\"b\":\"1FA95\",\"j\":[\"banjo\",\"music\",\"instructment\"],\"k\":[52,37],\"o\":12},\"aquarius\":{\"a\":\"Aquarius\",\"b\":\"2652\",\"j\":[\"aquarius\",\"sign\",\"purple-square\",\"zodiac\",\"astrology\"],\"k\":[54,35],\"o\":0},\"spades\":{\"a\":\"Black Spade Suit\",\"b\":\"2660-FE0F\",\"c\":\"2660\",\"j\":[\"spade_suit\",\"poker\",\"cards\",\"suits\",\"magic\"],\"k\":[54,38],\"o\":0},\"flag-dm\":{\"a\":\"Dominica Flag\",\"b\":\"1F1E9-1F1F2\",\"j\":[\"flag_dominica\",\"dm\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,35],\"o\":2},\"rice_ball\":{\"a\":\"Rice Ball\",\"b\":\"1F359\",\"j\":[\"rice_ball\",\"food\",\"japanese\"],\"k\":[6,43],\"o\":0},\"bird\":{\"a\":\"Bird\",\"b\":\"1F426\",\"j\":[\"bird\",\"animal\",\"nature\",\"fly\",\"tweet\",\"spring\"],\"k\":[12,0],\"o\":0},\"bald_woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f9b2.png\",\"sheet_x\":19,\"sheet_y\":17,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f9b2.png\",\"sheet_x\":19,\"sheet_y\":18,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f9b2.png\",\"sheet_x\":19,\"sheet_y\":19,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f9b2.png\",\"sheet_x\":19,\"sheet_y\":20,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f9b2.png\",\"sheet_x\":19,\"sheet_y\":21,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman: Bald\",\"b\":\"1F469-200D-1F9B2\",\"j\":[\"woman_bald\",\"hairless\"],\"k\":[19,16],\"o\":11},\"astonished\":{\"a\":\"Astonished Face\",\"b\":\"1F632\",\"j\":[\"astonished_face\",\"face\",\"xox\",\"surprised\",\"poisoned\"],\"k\":[31,24],\"o\":0},\"metro\":{\"a\":\"Metro\",\"b\":\"1F687\",\"j\":[\"metro\",\"transportation\",\"blue-square\",\"mrt\",\"underground\",\"tube\"],\"k\":[33,57],\"o\":0},\"drum_with_drumsticks\":{\"a\":\"Drum with Drumsticks\",\"b\":\"1F941\",\"j\":[\"drum\",\"music\",\"instrument\",\"drumsticks\",\"snare\"],\"k\":[41,25],\"o\":3},\"pisces\":{\"a\":\"Pisces\",\"b\":\"2653\",\"j\":[\"pisces\",\"purple-square\",\"sign\",\"zodiac\",\"astrology\"],\"k\":[54,36],\"o\":0},\"hearts\":{\"a\":\"Black Heart Suit\",\"b\":\"2665-FE0F\",\"c\":\"2665\",\"j\":[\"heart_suit\",\"poker\",\"cards\",\"magic\",\"suits\"],\"k\":[54,40],\"o\":0},\"flag-do\":{\"a\":\"Dominican Republic Flag\",\"b\":\"1F1E9-1F1F4\",\"j\":[\"flag_dominican_republic\",\"dominican\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,36],\"o\":2},\"rice\":{\"a\":\"Cooked Rice\",\"b\":\"1F35A\",\"j\":[\"cooked_rice\",\"food\",\"china\",\"asian\"],\"k\":[6,44],\"o\":0},\"penguin\":{\"a\":\"Penguin\",\"b\":\"1F427\",\"j\":[\"penguin\",\"animal\",\"nature\"],\"k\":[12,1],\"o\":0},\"flushed\":{\"a\":\"Flushed Face\",\"b\":\"1F633\",\"j\":[\"flushed_face\",\"face\",\"blush\",\"shy\",\"flattered\"],\"k\":[31,25],\"o\":0},\"light_rail\":{\"a\":\"Light Rail\",\"b\":\"1F688\",\"j\":[\"light_rail\",\"transportation\",\"vehicle\"],\"k\":[34,0],\"o\":1},\"bald_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f9b2.png\",\"sheet_x\":47,\"sheet_y\":54,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f9b2.png\",\"sheet_x\":47,\"sheet_y\":55,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f9b2.png\",\"sheet_x\":47,\"sheet_y\":56,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f9b2.png\",\"sheet_x\":47,\"sheet_y\":57,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F9B2\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f9b2.png\",\"sheet_x\":48,\"sheet_y\":0,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false}},\"a\":\"Person: Bald\",\"b\":\"1F9D1-200D-1F9B2\",\"j\":[\"person_bald\",\"hairless\"],\"k\":[47,53],\"o\":12},\"long_drum\":{\"a\":\"Long Drum\",\"b\":\"1FA98\",\"j\":[\"long drum\",\"music\"],\"k\":[52,40],\"o\":13},\"diamonds\":{\"a\":\"Black Diamond Suit\",\"b\":\"2666-FE0F\",\"c\":\"2666\",\"j\":[\"diamond_suit\",\"poker\",\"cards\",\"magic\",\"suits\"],\"k\":[54,41],\"o\":0},\"ophiuchus\":{\"a\":\"Ophiuchus\",\"b\":\"26CE\",\"j\":[\"ophiuchus\",\"sign\",\"purple-square\",\"constellation\",\"astrology\"],\"k\":[55,9],\"o\":0},\"flag-dz\":{\"a\":\"Algeria Flag\",\"b\":\"1F1E9-1F1FF\",\"j\":[\"flag_algeria\",\"dz\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,37],\"o\":2},\"curry\":{\"a\":\"Curry and Rice\",\"b\":\"1F35B\",\"j\":[\"curry_rice\",\"food\",\"spicy\",\"hot\",\"indian\"],\"k\":[6,45],\"o\":0},\"blond-haired-woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F471-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F471-1F3FB-200D-2640\",\"image\":\"1f471-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F471-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F471-1F3FC-200D-2640\",\"image\":\"1f471-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F471-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F471-1F3FD-200D-2640\",\"image\":\"1f471-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F471-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F471-1F3FE-200D-2640\",\"image\":\"1f471-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":16,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F471-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F471-1F3FF-200D-2640\",\"image\":\"1f471-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":17,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman: Blond Hair\",\"b\":\"1F471-200D-2640-FE0F\",\"c\":\"1F471-200D-2640\",\"j\":[\"woman_blond_hair\",\"woman\",\"female\",\"girl\",\"blonde\",\"person\"],\"k\":[22,12],\"o\":4},\"iphone\":{\"a\":\"Mobile Phone\",\"b\":\"1F4F1\",\"j\":[\"mobile_phone\",\"technology\",\"apple\",\"gadgets\",\"dial\"],\"k\":[27,14],\"o\":0},\"twisted_rightwards_arrows\":{\"a\":\"Twisted Rightwards Arrows\",\"b\":\"1F500\",\"j\":[\"shuffle_tracks_button\",\"blue-square\",\"shuffle\",\"music\",\"random\"],\"k\":[27,28],\"o\":1},\"dove_of_peace\":{\"a\":\"Dove\",\"b\":\"1F54A-FE0F\",\"c\":\"1F54A\",\"j\":[\"dove\",\"animal\",\"bird\"],\"k\":[28,33],\"o\":0},\"station\":{\"a\":\"Station\",\"b\":\"1F689\",\"j\":[\"station\",\"transportation\",\"vehicle\",\"public\"],\"k\":[34,1],\"o\":0},\"pleading_face\":{\"a\":\"Face with Pleading Eyes\",\"b\":\"1F97A\",\"j\":[\"pleading_face\",\"face\",\"begging\",\"mercy\"],\"k\":[42,27],\"o\":11},\"clubs\":{\"a\":\"Black Club Suit\",\"b\":\"2663-FE0F\",\"c\":\"2663\",\"j\":[\"club_suit\",\"poker\",\"cards\",\"magic\",\"suits\"],\"k\":[54,39],\"o\":0},\"flag-ea\":{\"a\":\"Ceuta & Melilla Flag\",\"b\":\"1F1EA-1F1E6\",\"j\":[\"flag_ceuta_melilla\"],\"k\":[1,38],\"o\":2},\"ramen\":{\"a\":\"Steaming Bowl\",\"b\":\"1F35C\",\"j\":[\"steaming_bowl\",\"food\",\"japanese\",\"noodle\",\"chopsticks\"],\"k\":[6,46],\"o\":0},\"blond-haired-man\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F471-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F471-1F3FB-200D-2642\",\"image\":\"1f471-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":19,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F471-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F471-1F3FC-200D-2642\",\"image\":\"1f471-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":20,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F471-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F471-1F3FD-200D-2642\",\"image\":\"1f471-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":21,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F471-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F471-1F3FE-200D-2642\",\"image\":\"1f471-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F471-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F471-1F3FF-200D-2642\",\"image\":\"1f471-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F471\",\"a\":\"Man: Blond Hair\",\"b\":\"1F471-200D-2642-FE0F\",\"c\":\"1F471-200D-2642\",\"j\":[\"man_blond_hair\",\"man\",\"male\",\"boy\",\"blonde\",\"guy\",\"person\"],\"k\":[22,18],\"o\":4},\"calling\":{\"a\":\"Mobile Phone with Rightwards Arrow at Left\",\"b\":\"1F4F2\",\"j\":[\"mobile_phone_with_arrow\",\"iphone\",\"incoming\"],\"k\":[27,15],\"o\":0},\"repeat\":{\"a\":\"Clockwise Rightwards and Leftwards Open Circle Arrows\",\"b\":\"1F501\",\"j\":[\"repeat_button\",\"loop\",\"record\"],\"k\":[27,29],\"o\":1},\"frowning\":{\"a\":\"Frowning Face with Open Mouth\",\"b\":\"1F626\",\"j\":[\"frowning_face_with_open_mouth\",\"face\",\"aw\",\"what\"],\"k\":[31,12],\"o\":1},\"tram\":{\"a\":\"Tram\",\"b\":\"1F68A\",\"j\":[\"tram\",\"transportation\",\"vehicle\"],\"k\":[34,2],\"o\":1},\"eagle\":{\"a\":\"Eagle\",\"b\":\"1F985\",\"j\":[\"eagle\",\"animal\",\"nature\",\"bird\"],\"k\":[42,38],\"o\":3},\"chess_pawn\":{\"a\":\"Chess Pawn\",\"b\":\"265F-FE0F\",\"c\":\"265F\",\"j\":[\"chess_pawn\",\"expendable\"],\"k\":[54,37],\"o\":11},\"black_joker\":{\"a\":\"Playing Card Black Joker\",\"b\":\"1F0CF\",\"j\":[\"joker\",\"poker\",\"cards\",\"game\",\"play\",\"magic\"],\"k\":[0,15],\"o\":0},\"flag-ec\":{\"a\":\"Ecuador Flag\",\"b\":\"1F1EA-1F1E8\",\"j\":[\"flag_ecuador\",\"ec\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,39],\"o\":2},\"spaghetti\":{\"a\":\"Spaghetti\",\"b\":\"1F35D\",\"j\":[\"spaghetti\",\"food\",\"italian\",\"noodle\"],\"k\":[6,47],\"o\":0},\"repeat_one\":{\"a\":\"Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay\",\"b\":\"1F502\",\"j\":[\"repeat_single_button\",\"blue-square\",\"loop\"],\"k\":[27,30],\"o\":1},\"anguished\":{\"a\":\"Anguished Face\",\"b\":\"1F627\",\"j\":[\"anguished_face\",\"face\",\"stunned\",\"nervous\"],\"k\":[31,13],\"l\":[\"D:\"],\"o\":1},\"monorail\":{\"a\":\"Monorail\",\"b\":\"1F69D\",\"j\":[\"monorail\",\"transportation\",\"vehicle\"],\"k\":[34,21],\"o\":1},\"duck\":{\"a\":\"Duck\",\"b\":\"1F986\",\"j\":[\"duck\",\"animal\",\"nature\",\"bird\",\"mallard\"],\"k\":[42,39],\"o\":3},\"older_adult\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D3-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d3-1f3fb.png\",\"sheet_x\":48,\"sheet_y\":50,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D3-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d3-1f3fc.png\",\"sheet_x\":48,\"sheet_y\":51,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D3-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d3-1f3fd.png\",\"sheet_x\":48,\"sheet_y\":52,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D3-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d3-1f3fe.png\",\"sheet_x\":48,\"sheet_y\":53,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D3-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d3-1f3ff.png\",\"sheet_x\":48,\"sheet_y\":54,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Older Adult\",\"b\":\"1F9D3\",\"j\":[\"older_person\",\"human\",\"elder\",\"senior\",\"gender-neutral\"],\"k\":[48,49],\"o\":5},\"phone\":{\"a\":\"Black Telephone\",\"b\":\"260E-FE0F\",\"c\":\"260E\",\"j\":[\"telephone\",\"technology\",\"communication\",\"dial\",\"telephone\"],\"k\":[54,2],\"n\":[\"telephone\"],\"o\":0},\"mahjong\":{\"a\":\"Mahjong Tile Red Dragon\",\"b\":\"1F004\",\"j\":[\"mahjong_red_dragon\",\"game\",\"play\",\"chinese\",\"kanji\"],\"k\":[0,14],\"o\":0},\"flag-ee\":{\"a\":\"Estonia Flag\",\"b\":\"1F1EA-1F1EA\",\"j\":[\"flag_estonia\",\"ee\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,40],\"o\":2},\"sweet_potato\":{\"a\":\"Roasted Sweet Potato\",\"b\":\"1F360\",\"j\":[\"roasted_sweet_potato\",\"food\",\"nature\"],\"k\":[6,50],\"o\":0},\"older_man\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F474-1F3FB\",\"non_qualified\":null,\"image\":\"1f474-1f3fb.png\",\"sheet_x\":22,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F474-1F3FC\",\"non_qualified\":null,\"image\":\"1f474-1f3fc.png\",\"sheet_x\":22,\"sheet_y\":56,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F474-1F3FD\",\"non_qualified\":null,\"image\":\"1f474-1f3fd.png\",\"sheet_x\":22,\"sheet_y\":57,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F474-1F3FE\",\"non_qualified\":null,\"image\":\"1f474-1f3fe.png\",\"sheet_x\":23,\"sheet_y\":0,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F474-1F3FF\",\"non_qualified\":null,\"image\":\"1f474-1f3ff.png\",\"sheet_x\":23,\"sheet_y\":1,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Older Man\",\"b\":\"1F474\",\"j\":[\"old_man\",\"human\",\"male\",\"men\",\"old\",\"elder\",\"senior\"],\"k\":[22,54],\"o\":0},\"telephone_receiver\":{\"a\":\"Telephone Receiver\",\"b\":\"1F4DE\",\"j\":[\"telephone_receiver\",\"technology\",\"communication\",\"dial\"],\"k\":[26,53],\"o\":0},\"fearful\":{\"a\":\"Fearful Face\",\"b\":\"1F628\",\"j\":[\"fearful_face\",\"face\",\"scared\",\"terrified\",\"nervous\",\"oops\",\"huh\"],\"k\":[31,14],\"o\":0},\"mountain_railway\":{\"a\":\"Mountain Railway\",\"b\":\"1F69E\",\"j\":[\"mountain_railway\",\"transportation\",\"vehicle\"],\"k\":[34,22],\"o\":1},\"swan\":{\"a\":\"Swan\",\"b\":\"1F9A2\",\"j\":[\"swan\",\"animal\",\"nature\",\"bird\"],\"k\":[43,9],\"o\":11},\"arrow_forward\":{\"a\":\"Black Right-Pointing Triangle\",\"b\":\"25B6-FE0F\",\"c\":\"25B6\",\"j\":[\"play_button\",\"blue-square\",\"right\",\"direction\",\"play\"],\"k\":[53,49],\"o\":0},\"flag-eg\":{\"a\":\"Egypt Flag\",\"b\":\"1F1EA-1F1EC\",\"j\":[\"flag_egypt\",\"eg\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,41],\"o\":2},\"oden\":{\"a\":\"Oden\",\"b\":\"1F362\",\"j\":[\"oden\",\"food\",\"japanese\"],\"k\":[6,52],\"o\":0},\"flower_playing_cards\":{\"a\":\"Flower Playing Cards\",\"b\":\"1F3B4\",\"j\":[\"flower_playing_cards\",\"game\",\"sunset\",\"red\"],\"k\":[8,18],\"o\":0},\"older_woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F475-1F3FB\",\"non_qualified\":null,\"image\":\"1f475-1f3fb.png\",\"sheet_x\":23,\"sheet_y\":3,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F475-1F3FC\",\"non_qualified\":null,\"image\":\"1f475-1f3fc.png\",\"sheet_x\":23,\"sheet_y\":4,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F475-1F3FD\",\"non_qualified\":null,\"image\":\"1f475-1f3fd.png\",\"sheet_x\":23,\"sheet_y\":5,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F475-1F3FE\",\"non_qualified\":null,\"image\":\"1f475-1f3fe.png\",\"sheet_x\":23,\"sheet_y\":6,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F475-1F3FF\",\"non_qualified\":null,\"image\":\"1f475-1f3ff.png\",\"sheet_x\":23,\"sheet_y\":7,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Older Woman\",\"b\":\"1F475\",\"j\":[\"old_woman\",\"human\",\"female\",\"women\",\"lady\",\"old\",\"elder\",\"senior\"],\"k\":[23,2],\"o\":0},\"pager\":{\"a\":\"Pager\",\"b\":\"1F4DF\",\"j\":[\"pager\",\"bbcall\",\"oldschool\",\"90s\"],\"k\":[26,54],\"o\":0},\"cold_sweat\":{\"a\":\"Face with Open Mouth and Cold Sweat\",\"b\":\"1F630\",\"j\":[\"anxious_face_with_sweat\",\"face\",\"nervous\",\"sweat\"],\"k\":[31,22],\"o\":0},\"train\":{\"a\":\"Tram Car\",\"b\":\"1F68B\",\"j\":[\"tram_car\",\"transportation\",\"vehicle\",\"carriage\",\"public\",\"travel\"],\"k\":[34,3],\"o\":1},\"owl\":{\"a\":\"Owl\",\"b\":\"1F989\",\"j\":[\"owl\",\"animal\",\"nature\",\"bird\",\"hoot\"],\"k\":[42,42],\"o\":3},\"fast_forward\":{\"a\":\"Black Right-Pointing Double Triangle\",\"b\":\"23E9\",\"j\":[\"fast_forward_button\",\"blue-square\",\"play\",\"speed\",\"continue\"],\"k\":[53,32],\"o\":0},\"flag-eh\":{\"a\":\"Western Sahara Flag\",\"b\":\"1F1EA-1F1ED\",\"j\":[\"flag_western_sahara\",\"western\",\"sahara\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,42],\"o\":2},\"sushi\":{\"a\":\"Sushi\",\"b\":\"1F363\",\"j\":[\"sushi\",\"food\",\"fish\",\"japanese\",\"rice\"],\"k\":[6,53],\"o\":0},\"performing_arts\":{\"a\":\"Performing Arts\",\"b\":\"1F3AD\",\"j\":[\"performing_arts\",\"acting\",\"theater\",\"drama\"],\"k\":[8,11],\"o\":0},\"fax\":{\"a\":\"Fax Machine\",\"b\":\"1F4E0\",\"j\":[\"fax_machine\",\"communication\",\"technology\"],\"k\":[26,55],\"o\":0},\"disappointed_relieved\":{\"a\":\"Disappointed but Relieved Face\",\"b\":\"1F625\",\"j\":[\"sad_but_relieved_face\",\"face\",\"phew\",\"sweat\",\"nervous\"],\"k\":[31,11],\"o\":0},\"person_frowning\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64D-1F3FB\",\"non_qualified\":null,\"image\":\"1f64d-1f3fb.png\",\"sheet_x\":33,\"sheet_y\":21,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64D-1F3FC\",\"non_qualified\":null,\"image\":\"1f64d-1f3fc.png\",\"sheet_x\":33,\"sheet_y\":22,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64D-1F3FD\",\"non_qualified\":null,\"image\":\"1f64d-1f3fd.png\",\"sheet_x\":33,\"sheet_y\":23,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64D-1F3FE\",\"non_qualified\":null,\"image\":\"1f64d-1f3fe.png\",\"sheet_x\":33,\"sheet_y\":24,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64D-1F3FF\",\"non_qualified\":null,\"image\":\"1f64d-1f3ff.png\",\"sheet_x\":33,\"sheet_y\":25,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F64D-200D-2640-FE0F\",\"a\":\"Person Frowning\",\"b\":\"1F64D\",\"j\":[\"person_frowning\",\"worried\"],\"k\":[33,20],\"o\":0},\"bus\":{\"a\":\"Bus\",\"b\":\"1F68C\",\"j\":[\"bus\",\"car\",\"vehicle\",\"transportation\"],\"k\":[34,4],\"o\":0},\"dodo\":{\"a\":\"Dodo\",\"b\":\"1F9A4\",\"j\":[\"dodo\",\"animal\",\"bird\"],\"k\":[43,11],\"o\":13},\"black_right_pointing_double_triangle_with_vertical_bar\":{\"a\":\"Next Track Button\",\"b\":\"23ED-FE0F\",\"c\":\"23ED\",\"j\":[\"next_track_button\",\"forward\",\"next\",\"blue-square\"],\"k\":[53,36],\"o\":0},\"flag-er\":{\"a\":\"Eritrea Flag\",\"b\":\"1F1EA-1F1F7\",\"j\":[\"flag_eritrea\",\"er\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,43],\"o\":2},\"fried_shrimp\":{\"a\":\"Fried Shrimp\",\"b\":\"1F364\",\"j\":[\"fried_shrimp\",\"food\",\"animal\",\"appetizer\",\"summer\"],\"k\":[6,54],\"o\":0},\"battery\":{\"a\":\"Battery\",\"b\":\"1F50B\",\"j\":[\"battery\",\"power\",\"energy\",\"sustain\"],\"k\":[27,39],\"o\":0},\"frame_with_picture\":{\"a\":\"Framed Picture\",\"b\":\"1F5BC-FE0F\",\"c\":\"1F5BC\",\"j\":[\"framed_picture\",\"photography\"],\"k\":[30,11],\"o\":0},\"cry\":{\"a\":\"Crying Face\",\"b\":\"1F622\",\"j\":[\"crying_face\",\"face\",\"tears\",\"sad\",\"depressed\",\"upset\",\":'(\"],\"k\":[31,8],\"l\":[\":'(\"],\"m\":\":'(\",\"o\":0},\"man-frowning\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64D-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F64D-1F3FB-200D-2642\",\"image\":\"1f64d-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64D-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F64D-1F3FC-200D-2642\",\"image\":\"1f64d-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":16,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64D-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F64D-1F3FD-200D-2642\",\"image\":\"1f64d-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":17,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64D-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F64D-1F3FE-200D-2642\",\"image\":\"1f64d-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":18,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64D-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F64D-1F3FF-200D-2642\",\"image\":\"1f64d-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":19,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Frowning\",\"b\":\"1F64D-200D-2642-FE0F\",\"c\":\"1F64D-200D-2642\",\"j\":[\"man_frowning\",\"male\",\"boy\",\"man\",\"sad\",\"depressed\",\"discouraged\",\"unhappy\"],\"k\":[33,14],\"o\":4},\"oncoming_bus\":{\"a\":\"Oncoming Bus\",\"b\":\"1F68D\",\"j\":[\"oncoming_bus\",\"vehicle\",\"transportation\"],\"k\":[34,5],\"o\":0},\"feather\":{\"a\":\"Feather\",\"b\":\"1FAB6\",\"j\":[\"feather\",\"bird\",\"fly\"],\"k\":[53,5],\"o\":13},\"black_right_pointing_triangle_with_double_vertical_bar\":{\"a\":\"Play or Pause Button\",\"b\":\"23EF-FE0F\",\"c\":\"23EF\",\"j\":[\"play_or_pause_button\",\"blue-square\",\"play\",\"pause\"],\"k\":[53,38],\"o\":1},\"es\":{\"a\":\"Spain Flag\",\"b\":\"1F1EA-1F1F8\",\"j\":[\"flag_spain\",\"spain\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,44],\"n\":[\"flag-es\"],\"o\":0},\"fish_cake\":{\"a\":\"Fish Cake with Swirl Design\",\"b\":\"1F365\",\"j\":[\"fish_cake_with_swirl\",\"food\",\"japan\",\"sea\",\"beach\",\"narutomaki\",\"pink\",\"swirl\",\"kamaboko\",\"surimi\",\"ramen\"],\"k\":[6,55],\"o\":0},\"art\":{\"a\":\"Artist Palette\",\"b\":\"1F3A8\",\"j\":[\"artist_palette\",\"design\",\"paint\",\"draw\",\"colors\"],\"k\":[8,6],\"o\":0},\"electric_plug\":{\"a\":\"Electric Plug\",\"b\":\"1F50C\",\"j\":[\"electric_plug\",\"charger\",\"power\"],\"k\":[27,40],\"o\":0},\"sob\":{\"a\":\"Loudly Crying Face\",\"b\":\"1F62D\",\"j\":[\"loudly_crying_face\",\"face\",\"cry\",\"tears\",\"sad\",\"upset\",\"depressed\"],\"k\":[31,19],\"m\":\":'(\",\"o\":0},\"woman-frowning\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64D-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F64D-1F3FB-200D-2640\",\"image\":\"1f64d-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64D-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F64D-1F3FC-200D-2640\",\"image\":\"1f64d-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64D-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F64D-1F3FD-200D-2640\",\"image\":\"1f64d-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":11,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64D-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F64D-1F3FE-200D-2640\",\"image\":\"1f64d-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64D-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F64D-1F3FF-200D-2640\",\"image\":\"1f64d-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F64D\",\"a\":\"Woman Frowning\",\"b\":\"1F64D-200D-2640-FE0F\",\"c\":\"1F64D-200D-2640\",\"j\":[\"woman_frowning\",\"female\",\"girl\",\"woman\",\"sad\",\"depressed\",\"discouraged\",\"unhappy\"],\"k\":[33,8],\"o\":4},\"trolleybus\":{\"a\":\"Trolleybus\",\"b\":\"1F68E\",\"j\":[\"trolleybus\",\"bart\",\"transportation\",\"vehicle\"],\"k\":[34,6],\"o\":1},\"flamingo\":{\"a\":\"Flamingo\",\"b\":\"1F9A9\",\"j\":[\"flamingo\",\"animal\"],\"k\":[43,16],\"o\":12},\"arrow_backward\":{\"a\":\"Black Left-Pointing Triangle\",\"b\":\"25C0-FE0F\",\"c\":\"25C0\",\"j\":[\"reverse_button\",\"blue-square\",\"left\",\"direction\"],\"k\":[53,50],\"o\":0},\"flag-et\":{\"a\":\"Ethiopia Flag\",\"b\":\"1F1EA-1F1F9\",\"j\":[\"flag_ethiopia\",\"et\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,45],\"o\":2},\"computer\":{\"a\":\"Personal Computer\",\"b\":\"1F4BB\",\"j\":[\"laptop\",\"technology\",\"laptop\",\"screen\",\"display\",\"monitor\"],\"k\":[26,18],\"o\":0},\"scream\":{\"a\":\"Face Screaming in Fear\",\"b\":\"1F631\",\"j\":[\"face_screaming_in_fear\",\"face\",\"munch\",\"scared\",\"omg\"],\"k\":[31,23],\"o\":0},\"person_with_pouting_face\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64E-1F3FB\",\"non_qualified\":null,\"image\":\"1f64e-1f3fb.png\",\"sheet_x\":33,\"sheet_y\":39,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64E-1F3FC\",\"non_qualified\":null,\"image\":\"1f64e-1f3fc.png\",\"sheet_x\":33,\"sheet_y\":40,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64E-1F3FD\",\"non_qualified\":null,\"image\":\"1f64e-1f3fd.png\",\"sheet_x\":33,\"sheet_y\":41,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64E-1F3FE\",\"non_qualified\":null,\"image\":\"1f64e-1f3fe.png\",\"sheet_x\":33,\"sheet_y\":42,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64E-1F3FF\",\"non_qualified\":null,\"image\":\"1f64e-1f3ff.png\",\"sheet_x\":33,\"sheet_y\":43,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F64E-200D-2640-FE0F\",\"a\":\"Person with Pouting Face\",\"b\":\"1F64E\",\"j\":[\"person_pouting\",\"upset\"],\"k\":[33,38],\"o\":0},\"minibus\":{\"a\":\"Minibus\",\"b\":\"1F690\",\"j\":[\"minibus\",\"vehicle\",\"car\",\"transportation\"],\"k\":[34,8],\"o\":1},\"moon_cake\":{\"a\":\"Moon Cake\",\"b\":\"1F96E\",\"j\":[\"moon_cake\",\"food\",\"autumn\"],\"k\":[42,11],\"o\":11},\"peacock\":{\"a\":\"Peacock\",\"b\":\"1F99A\",\"j\":[\"peacock\",\"animal\",\"nature\",\"peahen\",\"bird\"],\"k\":[43,1],\"o\":11},\"thread\":{\"a\":\"Spool of Thread\",\"b\":\"1F9F5\",\"j\":[\"thread\",\"needle\",\"sewing\",\"spool\",\"string\"],\"k\":[52,6],\"o\":11},\"rewind\":{\"a\":\"Black Left-Pointing Double Triangle\",\"b\":\"23EA\",\"j\":[\"fast_reverse_button\",\"play\",\"blue-square\"],\"k\":[53,33],\"o\":0},\"flag-eu\":{\"a\":\"European Union Flag\",\"b\":\"1F1EA-1F1FA\",\"j\":[\"flag_european_union\",\"european\",\"union\",\"flag\",\"banner\"],\"k\":[1,46],\"o\":2},\"dango\":{\"a\":\"Dango\",\"b\":\"1F361\",\"j\":[\"dango\",\"food\",\"dessert\",\"sweet\",\"japanese\",\"barbecue\",\"meat\"],\"k\":[6,51],\"o\":0},\"desktop_computer\":{\"a\":\"Desktop Computer\",\"b\":\"1F5A5-FE0F\",\"c\":\"1F5A5\",\"j\":[\"desktop_computer\",\"technology\",\"computing\",\"screen\"],\"k\":[30,7],\"o\":0},\"confounded\":{\"a\":\"Confounded Face\",\"b\":\"1F616\",\"j\":[\"confounded_face\",\"face\",\"confused\",\"sick\",\"unwell\",\"oops\",\":S\"],\"k\":[30,54],\"o\":0},\"man-pouting\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64E-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F64E-1F3FB-200D-2642\",\"image\":\"1f64e-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":33,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64E-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F64E-1F3FC-200D-2642\",\"image\":\"1f64e-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64E-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F64E-1F3FD-200D-2642\",\"image\":\"1f64e-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":35,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64E-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F64E-1F3FE-200D-2642\",\"image\":\"1f64e-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":36,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64E-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F64E-1F3FF-200D-2642\",\"image\":\"1f64e-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":33,\"sheet_y\":37,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Pouting\",\"b\":\"1F64E-200D-2642-FE0F\",\"c\":\"1F64E-200D-2642\",\"j\":[\"man_pouting\",\"male\",\"boy\",\"man\"],\"k\":[33,32],\"o\":4},\"ambulance\":{\"a\":\"Ambulance\",\"b\":\"1F691\",\"j\":[\"ambulance\",\"health\",\"911\",\"hospital\"],\"k\":[34,9],\"o\":0},\"parrot\":{\"a\":\"Parrot\",\"b\":\"1F99C\",\"j\":[\"parrot\",\"animal\",\"nature\",\"bird\",\"pirate\",\"talk\"],\"k\":[43,3],\"o\":11},\"sewing_needle\":{\"a\":\"Sewing Needle\",\"b\":\"1FAA1\",\"j\":[\"sewing needle\",\"stitches\"],\"k\":[52,49],\"o\":13},\"black_left_pointing_double_triangle_with_vertical_bar\":{\"a\":\"Last Track Button\",\"b\":\"23EE-FE0F\",\"c\":\"23EE\",\"j\":[\"last_track_button\",\"backward\"],\"k\":[53,37],\"o\":0},\"flag-fi\":{\"a\":\"Finland Flag\",\"b\":\"1F1EB-1F1EE\",\"j\":[\"flag_finland\",\"fi\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,47],\"o\":2},\"frog\":{\"a\":\"Frog Face\",\"b\":\"1F438\",\"j\":[\"frog\",\"animal\",\"nature\",\"croak\",\"toad\"],\"k\":[12,18],\"o\":0},\"arrow_up_small\":{\"a\":\"Up-Pointing Small Red Triangle\",\"b\":\"1F53C\",\"j\":[\"upwards_button\",\"blue-square\",\"triangle\",\"direction\",\"point\",\"forward\",\"top\"],\"k\":[28,30],\"o\":0},\"printer\":{\"a\":\"Printer\",\"b\":\"1F5A8-FE0F\",\"c\":\"1F5A8\",\"j\":[\"printer\",\"paper\",\"ink\"],\"k\":[30,8],\"o\":0},\"persevere\":{\"a\":\"Persevering Face\",\"b\":\"1F623\",\"j\":[\"persevering_face\",\"face\",\"sick\",\"no\",\"upset\",\"oops\"],\"k\":[31,9],\"o\":0},\"woman-pouting\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64E-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F64E-1F3FB-200D-2640\",\"image\":\"1f64e-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":27,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64E-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F64E-1F3FC-200D-2640\",\"image\":\"1f64e-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64E-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F64E-1F3FD-200D-2640\",\"image\":\"1f64e-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64E-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F64E-1F3FE-200D-2640\",\"image\":\"1f64e-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64E-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F64E-1F3FF-200D-2640\",\"image\":\"1f64e-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":33,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F64E\",\"a\":\"Woman Pouting\",\"b\":\"1F64E-200D-2640-FE0F\",\"c\":\"1F64E-200D-2640\",\"j\":[\"woman_pouting\",\"female\",\"girl\",\"woman\"],\"k\":[33,26],\"o\":4},\"fire_engine\":{\"a\":\"Fire Engine\",\"b\":\"1F692\",\"j\":[\"fire_engine\",\"transportation\",\"cars\",\"vehicle\"],\"k\":[34,10],\"o\":0},\"dumpling\":{\"a\":\"Dumpling\",\"b\":\"1F95F\",\"j\":[\"dumpling\",\"food\",\"empanada\",\"pierogi\",\"potsticker\"],\"k\":[41,54],\"o\":5},\"yarn\":{\"a\":\"Ball of Yarn\",\"b\":\"1F9F6\",\"j\":[\"yarn\",\"ball\",\"crochet\",\"knit\"],\"k\":[52,7],\"o\":11},\"flag-fj\":{\"a\":\"Fiji Flag\",\"b\":\"1F1EB-1F1EF\",\"j\":[\"flag_fiji\",\"fj\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,48],\"o\":2},\"crocodile\":{\"a\":\"Crocodile\",\"b\":\"1F40A\",\"j\":[\"crocodile\",\"animal\",\"nature\",\"reptile\",\"lizard\",\"alligator\"],\"k\":[11,29],\"o\":1},\"disappointed\":{\"a\":\"Disappointed Face\",\"b\":\"1F61E\",\"j\":[\"disappointed_face\",\"face\",\"sad\",\"upset\",\"depressed\",\":(\"],\"k\":[31,4],\"l\":[\"):\",\":(\",\":-(\"],\"m\":\":(\",\"o\":0},\"no_good\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F645-1F3FB\",\"non_qualified\":null,\"image\":\"1f645-1f3fb.png\",\"sheet_x\":31,\"sheet_y\":56,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F645-1F3FC\",\"non_qualified\":null,\"image\":\"1f645-1f3fc.png\",\"sheet_x\":31,\"sheet_y\":57,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F645-1F3FD\",\"non_qualified\":null,\"image\":\"1f645-1f3fd.png\",\"sheet_x\":32,\"sheet_y\":0,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F645-1F3FE\",\"non_qualified\":null,\"image\":\"1f645-1f3fe.png\",\"sheet_x\":32,\"sheet_y\":1,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F645-1F3FF\",\"non_qualified\":null,\"image\":\"1f645-1f3ff.png\",\"sheet_x\":32,\"sheet_y\":2,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F645-200D-2640-FE0F\",\"a\":\"Face with No Good Gesture\",\"b\":\"1F645\",\"j\":[\"person_gesturing_no\",\"decline\"],\"k\":[31,55],\"o\":0},\"police_car\":{\"a\":\"Police Car\",\"b\":\"1F693\",\"j\":[\"police_car\",\"vehicle\",\"cars\",\"transportation\",\"law\",\"legal\",\"enforcement\"],\"k\":[34,11],\"o\":0},\"fortune_cookie\":{\"a\":\"Fortune Cookie\",\"b\":\"1F960\",\"j\":[\"fortune_cookie\",\"food\",\"prophecy\"],\"k\":[41,55],\"o\":5},\"knot\":{\"a\":\"Knot\",\"b\":\"1FAA2\",\"j\":[\"knot\",\"rope\",\"scout\"],\"k\":[52,50],\"o\":13},\"keyboard\":{\"a\":\"Keyboard\",\"b\":\"2328-FE0F\",\"c\":\"2328\",\"j\":[\"keyboard\",\"technology\",\"computer\",\"type\",\"input\",\"text\"],\"k\":[53,30],\"o\":1},\"arrow_double_up\":{\"a\":\"Black Up-Pointing Double Triangle\",\"b\":\"23EB\",\"j\":[\"fast_up_button\",\"blue-square\",\"direction\",\"top\"],\"k\":[53,34],\"o\":0},\"flag-fk\":{\"a\":\"Falkland Islands Flag\",\"b\":\"1F1EB-1F1F0\",\"j\":[\"flag_falkland_islands\",\"falkland\",\"islands\",\"malvinas\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,49],\"o\":2},\"turtle\":{\"a\":\"Turtle\",\"b\":\"1F422\",\"j\":[\"turtle\",\"animal\",\"slow\",\"nature\",\"tortoise\"],\"k\":[11,54],\"o\":0},\"arrow_down_small\":{\"a\":\"Down-Pointing Small Red Triangle\",\"b\":\"1F53D\",\"j\":[\"downwards_button\",\"blue-square\",\"direction\",\"bottom\"],\"k\":[28,31],\"o\":0},\"three_button_mouse\":{\"a\":\"Computer Mouse\",\"b\":\"1F5B1-FE0F\",\"c\":\"1F5B1\",\"j\":[\"computer_mouse\",\"click\"],\"k\":[30,9],\"o\":0},\"sweat\":{\"a\":\"Face with Cold Sweat\",\"b\":\"1F613\",\"j\":[\"downcast_face_with_sweat\",\"face\",\"hot\",\"sad\",\"tired\",\"exercise\"],\"k\":[30,51],\"o\":0},\"man-gesturing-no\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F645-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F645-1F3FB-200D-2642\",\"image\":\"1f645-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":31,\"sheet_y\":50,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F645-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F645-1F3FC-200D-2642\",\"image\":\"1f645-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":31,\"sheet_y\":51,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F645-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F645-1F3FD-200D-2642\",\"image\":\"1f645-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":31,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F645-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F645-1F3FE-200D-2642\",\"image\":\"1f645-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":31,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F645-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F645-1F3FF-200D-2642\",\"image\":\"1f645-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":31,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Gesturing No\",\"b\":\"1F645-200D-2642-FE0F\",\"c\":\"1F645-200D-2642\",\"j\":[\"man_gesturing_no\",\"male\",\"boy\",\"man\",\"nope\"],\"k\":[31,49],\"o\":4},\"oncoming_police_car\":{\"a\":\"Oncoming Police Car\",\"b\":\"1F694\",\"j\":[\"oncoming_police_car\",\"vehicle\",\"law\",\"legal\",\"enforcement\",\"911\"],\"k\":[34,12],\"o\":0},\"takeout_box\":{\"a\":\"Takeout Box\",\"b\":\"1F961\",\"j\":[\"takeout_box\",\"food\",\"leftovers\"],\"k\":[41,56],\"o\":5},\"flag-fm\":{\"a\":\"Micronesia Flag\",\"b\":\"1F1EB-1F1F2\",\"j\":[\"flag_micronesia\",\"micronesia\",\"federated\",\"states\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,50],\"o\":2},\"trackball\":{\"a\":\"Trackball\",\"b\":\"1F5B2-FE0F\",\"c\":\"1F5B2\",\"j\":[\"trackball\",\"technology\",\"trackpad\"],\"k\":[30,10],\"o\":0},\"weary\":{\"a\":\"Weary Face\",\"b\":\"1F629\",\"j\":[\"weary_face\",\"face\",\"tired\",\"sleepy\",\"sad\",\"frustrated\",\"upset\"],\"k\":[31,15],\"o\":0},\"woman-gesturing-no\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F645-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F645-1F3FB-200D-2640\",\"image\":\"1f645-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":31,\"sheet_y\":44,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F645-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F645-1F3FC-200D-2640\",\"image\":\"1f645-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":31,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F645-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F645-1F3FD-200D-2640\",\"image\":\"1f645-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":31,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F645-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F645-1F3FE-200D-2640\",\"image\":\"1f645-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":31,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F645-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F645-1F3FF-200D-2640\",\"image\":\"1f645-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":31,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F645\",\"a\":\"Woman Gesturing No\",\"b\":\"1F645-200D-2640-FE0F\",\"c\":\"1F645-200D-2640\",\"j\":[\"woman_gesturing_no\",\"female\",\"girl\",\"woman\",\"nope\"],\"k\":[31,43],\"o\":4},\"taxi\":{\"a\":\"Taxi\",\"b\":\"1F695\",\"j\":[\"taxi\",\"uber\",\"vehicle\",\"cars\",\"transportation\"],\"k\":[34,13],\"o\":0},\"crab\":{\"a\":\"Crab\",\"b\":\"1F980\",\"j\":[\"crab\",\"animal\",\"crustacean\"],\"k\":[42,33],\"o\":1},\"lizard\":{\"a\":\"Lizard\",\"b\":\"1F98E\",\"j\":[\"lizard\",\"animal\",\"nature\",\"reptile\"],\"k\":[42,47],\"o\":3},\"arrow_double_down\":{\"a\":\"Black Down-Pointing Double Triangle\",\"b\":\"23EC\",\"j\":[\"fast_down_button\",\"blue-square\",\"direction\",\"bottom\"],\"k\":[53,35],\"o\":0},\"flag-fo\":{\"a\":\"Faroe Islands Flag\",\"b\":\"1F1EB-1F1F4\",\"j\":[\"flag_faroe_islands\",\"faroe\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,51],\"o\":2},\"snake\":{\"a\":\"Snake\",\"b\":\"1F40D\",\"j\":[\"snake\",\"animal\",\"evil\",\"nature\",\"hiss\",\"python\"],\"k\":[11,32],\"o\":0},\"minidisc\":{\"a\":\"Minidisc\",\"b\":\"1F4BD\",\"j\":[\"computer_disk\",\"technology\",\"record\",\"data\",\"disk\",\"90s\"],\"k\":[26,20],\"o\":0},\"tired_face\":{\"a\":\"Tired Face\",\"b\":\"1F62B\",\"j\":[\"tired_face\",\"sick\",\"whine\",\"upset\",\"frustrated\"],\"k\":[31,17],\"o\":0},\"ok_woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F646-1F3FB\",\"non_qualified\":null,\"image\":\"1f646-1f3fb.png\",\"sheet_x\":32,\"sheet_y\":16,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F646-1F3FC\",\"non_qualified\":null,\"image\":\"1f646-1f3fc.png\",\"sheet_x\":32,\"sheet_y\":17,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F646-1F3FD\",\"non_qualified\":null,\"image\":\"1f646-1f3fd.png\",\"sheet_x\":32,\"sheet_y\":18,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F646-1F3FE\",\"non_qualified\":null,\"image\":\"1f646-1f3fe.png\",\"sheet_x\":32,\"sheet_y\":19,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F646-1F3FF\",\"non_qualified\":null,\"image\":\"1f646-1f3ff.png\",\"sheet_x\":32,\"sheet_y\":20,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F646-200D-2640-FE0F\",\"a\":\"Face with Ok Gesture\",\"b\":\"1F646\",\"j\":[\"person_gesturing_ok\",\"agree\"],\"k\":[32,15],\"o\":0},\"oncoming_taxi\":{\"a\":\"Oncoming Taxi\",\"b\":\"1F696\",\"j\":[\"oncoming_taxi\",\"vehicle\",\"cars\",\"uber\"],\"k\":[34,14],\"o\":1},\"lobster\":{\"a\":\"Lobster\",\"b\":\"1F99E\",\"j\":[\"lobster\",\"animal\",\"nature\",\"bisque\",\"claws\",\"seafood\"],\"k\":[43,5],\"o\":11},\"double_vertical_bar\":{\"a\":\"Pause Button\",\"b\":\"23F8-FE0F\",\"c\":\"23F8\",\"j\":[\"pause_button\",\"pause\",\"blue-square\"],\"k\":[53,43],\"o\":0},\"fr\":{\"a\":\"France Flag\",\"b\":\"1F1EB-1F1F7\",\"j\":[\"flag_france\",\"banner\",\"flag\",\"nation\",\"france\",\"french\",\"country\"],\"k\":[1,52],\"n\":[\"flag-fr\"],\"o\":0},\"dragon_face\":{\"a\":\"Dragon Face\",\"b\":\"1F432\",\"j\":[\"dragon_face\",\"animal\",\"myth\",\"nature\",\"chinese\",\"green\"],\"k\":[12,12],\"o\":0},\"floppy_disk\":{\"a\":\"Floppy Disk\",\"b\":\"1F4BE\",\"j\":[\"floppy_disk\",\"oldschool\",\"technology\",\"save\",\"90s\",\"80s\"],\"k\":[26,21],\"o\":0},\"man-gesturing-ok\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F646-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F646-1F3FB-200D-2642\",\"image\":\"1f646-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F646-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F646-1F3FC-200D-2642\",\"image\":\"1f646-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":11,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F646-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F646-1F3FD-200D-2642\",\"image\":\"1f646-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F646-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F646-1F3FE-200D-2642\",\"image\":\"1f646-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F646-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F646-1F3FF-200D-2642\",\"image\":\"1f646-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Gesturing Ok\",\"b\":\"1F646-200D-2642-FE0F\",\"c\":\"1F646-200D-2642\",\"j\":[\"man_gesturing_ok\",\"men\",\"boy\",\"male\",\"blue\",\"human\",\"man\"],\"k\":[32,9],\"o\":4},\"car\":{\"a\":\"Automobile\",\"b\":\"1F697\",\"j\":[\"automobile\",\"red\",\"transportation\",\"vehicle\"],\"k\":[34,15],\"n\":[\"red_car\"],\"o\":0},\"yawning_face\":{\"a\":\"Yawning Face\",\"b\":\"1F971\",\"j\":[\"yawning_face\",\"tired\",\"sleepy\",\"\"],\"k\":[42,14],\"o\":12},\"shrimp\":{\"a\":\"Shrimp\",\"b\":\"1F990\",\"j\":[\"shrimp\",\"animal\",\"ocean\",\"nature\",\"seafood\"],\"k\":[42,49],\"o\":3},\"black_square_for_stop\":{\"a\":\"Stop Button\",\"b\":\"23F9-FE0F\",\"c\":\"23F9\",\"j\":[\"stop_button\",\"blue-square\"],\"k\":[53,44],\"o\":0},\"flag-ga\":{\"a\":\"Gabon Flag\",\"b\":\"1F1EC-1F1E6\",\"j\":[\"flag_gabon\",\"ga\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,53],\"o\":2},\"dragon\":{\"a\":\"Dragon\",\"b\":\"1F409\",\"j\":[\"dragon\",\"animal\",\"myth\",\"nature\",\"chinese\",\"green\"],\"k\":[11,28],\"o\":1},\"cd\":{\"a\":\"Optical Disc\",\"b\":\"1F4BF\",\"j\":[\"optical_disk\",\"technology\",\"dvd\",\"disk\",\"disc\",\"90s\"],\"k\":[26,22],\"o\":0},\"triumph\":{\"a\":\"Face with Look of Triumph\",\"b\":\"1F624\",\"j\":[\"face_with_steam_from_nose\",\"face\",\"gas\",\"phew\",\"proud\",\"pride\"],\"k\":[31,10],\"o\":0},\"woman-gesturing-ok\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F646-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F646-1F3FB-200D-2640\",\"image\":\"1f646-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":4,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F646-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F646-1F3FC-200D-2640\",\"image\":\"1f646-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":5,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F646-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F646-1F3FD-200D-2640\",\"image\":\"1f646-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F646-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F646-1F3FE-200D-2640\",\"image\":\"1f646-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F646-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F646-1F3FF-200D-2640\",\"image\":\"1f646-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F646\",\"a\":\"Woman Gesturing Ok\",\"b\":\"1F646-200D-2640-FE0F\",\"c\":\"1F646-200D-2640\",\"j\":[\"woman_gesturing_ok\",\"women\",\"girl\",\"female\",\"pink\",\"human\",\"woman\"],\"k\":[32,3],\"o\":4},\"oncoming_automobile\":{\"a\":\"Oncoming Automobile\",\"b\":\"1F698\",\"j\":[\"oncoming_automobile\",\"car\",\"vehicle\",\"transportation\"],\"k\":[34,16],\"o\":0},\"squid\":{\"a\":\"Squid\",\"b\":\"1F991\",\"j\":[\"squid\",\"animal\",\"nature\",\"ocean\",\"sea\"],\"k\":[42,50],\"o\":3},\"black_circle_for_record\":{\"a\":\"Record Button\",\"b\":\"23FA-FE0F\",\"c\":\"23FA\",\"j\":[\"record_button\",\"blue-square\"],\"k\":[53,45],\"o\":0},\"gb\":{\"a\":\"United Kingdom Flag\",\"b\":\"1F1EC-1F1E7\",\"j\":[\"flag_united_kingdom\",\"united\",\"kingdom\",\"great\",\"britain\",\"northern\",\"ireland\",\"flag\",\"nation\",\"country\",\"banner\",\"british\",\"UK\",\"english\",\"england\",\"union jack\"],\"k\":[1,54],\"n\":[\"uk\",\"flag-gb\"],\"o\":0},\"information_desk_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F481-1F3FB\",\"non_qualified\":null,\"image\":\"1f481-1f3fb.png\",\"sheet_x\":24,\"sheet_y\":6,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F481-1F3FC\",\"non_qualified\":null,\"image\":\"1f481-1f3fc.png\",\"sheet_x\":24,\"sheet_y\":7,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F481-1F3FD\",\"non_qualified\":null,\"image\":\"1f481-1f3fd.png\",\"sheet_x\":24,\"sheet_y\":8,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F481-1F3FE\",\"non_qualified\":null,\"image\":\"1f481-1f3fe.png\",\"sheet_x\":24,\"sheet_y\":9,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F481-1F3FF\",\"non_qualified\":null,\"image\":\"1f481-1f3ff.png\",\"sheet_x\":24,\"sheet_y\":10,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F481-200D-2640-FE0F\",\"a\":\"Information Desk Person\",\"b\":\"1F481\",\"j\":[\"person_tipping_hand\",\"information\"],\"k\":[24,5],\"o\":0},\"dvd\":{\"a\":\"Dvd\",\"b\":\"1F4C0\",\"j\":[\"dvd\",\"cd\",\"disk\",\"disc\"],\"k\":[26,23],\"o\":0},\"rage\":{\"a\":\"Pouting Face\",\"b\":\"1F621\",\"j\":[\"pouting_face\",\"angry\",\"mad\",\"hate\",\"despise\"],\"k\":[31,7],\"o\":0},\"blue_car\":{\"a\":\"Recreational Vehicle\",\"b\":\"1F699\",\"j\":[\"sport_utility_vehicle\",\"transportation\",\"vehicle\"],\"k\":[34,17],\"o\":0},\"sauropod\":{\"a\":\"Sauropod\",\"b\":\"1F995\",\"j\":[\"sauropod\",\"animal\",\"nature\",\"dinosaur\",\"brachiosaurus\",\"brontosaurus\",\"diplodocus\",\"extinct\"],\"k\":[42,54],\"o\":5},\"oyster\":{\"a\":\"Oyster\",\"b\":\"1F9AA\",\"j\":[\"oyster\",\"food\"],\"k\":[43,17],\"o\":12},\"eject\":{\"a\":\"Eject Button\",\"b\":\"23CF-FE0F\",\"c\":\"23CF\",\"j\":[\"eject_button\",\"blue-square\"],\"k\":[53,31],\"o\":1},\"flag-gd\":{\"a\":\"Grenada Flag\",\"b\":\"1F1EC-1F1E9\",\"j\":[\"flag_grenada\",\"gd\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,55],\"o\":2},\"icecream\":{\"a\":\"Soft Ice Cream\",\"b\":\"1F366\",\"j\":[\"soft_ice_cream\",\"food\",\"hot\",\"dessert\",\"summer\"],\"k\":[6,56],\"o\":0},\"cinema\":{\"a\":\"Cinema\",\"b\":\"1F3A6\",\"j\":[\"cinema\",\"blue-square\",\"record\",\"film\",\"movie\",\"curtain\",\"stage\",\"theater\"],\"k\":[8,4],\"o\":0},\"man-tipping-hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F481-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F481-1F3FB-200D-2642\",\"image\":\"1f481-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":0,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F481-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F481-1F3FC-200D-2642\",\"image\":\"1f481-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":1,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F481-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F481-1F3FD-200D-2642\",\"image\":\"1f481-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":2,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F481-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F481-1F3FE-200D-2642\",\"image\":\"1f481-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":3,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F481-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F481-1F3FF-200D-2642\",\"image\":\"1f481-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":4,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Tipping Hand\",\"b\":\"1F481-200D-2642-FE0F\",\"c\":\"1F481-200D-2642\",\"j\":[\"man_tipping_hand\",\"male\",\"boy\",\"man\",\"human\",\"information\"],\"k\":[23,57],\"o\":4},\"angry\":{\"a\":\"Angry Face\",\"b\":\"1F620\",\"j\":[\"angry_face\",\"mad\",\"face\",\"annoyed\",\"frustrated\"],\"k\":[31,6],\"l\":[\">:(\",\">:-(\"],\"o\":0},\"pickup_truck\":{\"a\":\"Pickup Truck\",\"b\":\"1F6FB\",\"j\":[\"pickup truck\",\"car\",\"transportation\"],\"k\":[36,53],\"o\":13},\"t-rex\":{\"a\":\"T-Rex\",\"b\":\"1F996\",\"j\":[\"t_rex\",\"animal\",\"nature\",\"dinosaur\",\"tyrannosaurus\",\"extinct\"],\"k\":[42,55],\"o\":5},\"abacus\":{\"a\":\"Abacus\",\"b\":\"1F9EE\",\"j\":[\"abacus\",\"calculation\"],\"k\":[51,57],\"o\":11},\"flag-ge\":{\"a\":\"Georgia Flag\",\"b\":\"1F1EC-1F1EA\",\"j\":[\"flag_georgia\",\"ge\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,56],\"o\":2},\"shaved_ice\":{\"a\":\"Shaved Ice\",\"b\":\"1F367\",\"j\":[\"shaved_ice\",\"hot\",\"dessert\",\"summer\"],\"k\":[6,57],\"o\":0},\"movie_camera\":{\"a\":\"Movie Camera\",\"b\":\"1F3A5\",\"j\":[\"movie_camera\",\"film\",\"record\"],\"k\":[8,3],\"o\":0},\"whale\":{\"a\":\"Spouting Whale\",\"b\":\"1F433\",\"j\":[\"spouting_whale\",\"animal\",\"nature\",\"sea\",\"ocean\"],\"k\":[12,13],\"o\":0},\"woman-tipping-hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F481-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F481-1F3FB-200D-2640\",\"image\":\"1f481-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F481-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F481-1F3FC-200D-2640\",\"image\":\"1f481-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F481-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F481-1F3FD-200D-2640\",\"image\":\"1f481-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F481-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F481-1F3FE-200D-2640\",\"image\":\"1f481-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F481-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F481-1F3FF-200D-2640\",\"image\":\"1f481-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":56,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F481\",\"a\":\"Woman Tipping Hand\",\"b\":\"1F481-200D-2640-FE0F\",\"c\":\"1F481-200D-2640\",\"j\":[\"woman_tipping_hand\",\"female\",\"girl\",\"woman\",\"human\",\"information\"],\"k\":[23,51],\"o\":4},\"low_brightness\":{\"a\":\"Low Brightness Symbol\",\"b\":\"1F505\",\"j\":[\"dim_button\",\"sun\",\"afternoon\",\"warm\",\"summer\"],\"k\":[27,33],\"o\":1},\"truck\":{\"a\":\"Delivery Truck\",\"b\":\"1F69A\",\"j\":[\"delivery_truck\",\"cars\",\"transportation\"],\"k\":[34,18],\"o\":0},\"face_with_symbols_on_mouth\":{\"a\":\"Serious Face with Symbols Covering Mouth\",\"b\":\"1F92C\",\"j\":[\"face_with_symbols_on_mouth\",\"face\",\"swearing\",\"cursing\",\"cussing\",\"profanity\",\"expletive\"],\"k\":[38,45],\"n\":[\"serious_face_with_symbols_covering_mouth\"],\"o\":5},\"flag-gf\":{\"a\":\"French Guiana Flag\",\"b\":\"1F1EC-1F1EB\",\"j\":[\"flag_french_guiana\",\"french\",\"guiana\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[1,57],\"o\":2},\"ice_cream\":{\"a\":\"Ice Cream\",\"b\":\"1F368\",\"j\":[\"ice_cream\",\"food\",\"hot\",\"dessert\"],\"k\":[7,0],\"o\":0},\"film_frames\":{\"a\":\"Film Frames\",\"b\":\"1F39E-FE0F\",\"c\":\"1F39E\",\"j\":[\"film_frames\",\"movie\"],\"k\":[7,54],\"o\":0},\"whale2\":{\"a\":\"Whale\",\"b\":\"1F40B\",\"j\":[\"whale\",\"animal\",\"nature\",\"sea\",\"ocean\"],\"k\":[11,30],\"o\":1},\"high_brightness\":{\"a\":\"High Brightness Symbol\",\"b\":\"1F506\",\"j\":[\"bright_button\",\"sun\",\"light\"],\"k\":[27,34],\"o\":1},\"smiling_imp\":{\"a\":\"Smiling Face with Horns\",\"b\":\"1F608\",\"j\":[\"smiling_face_with_horns\",\"devil\",\"horns\"],\"k\":[30,40],\"o\":1},\"raising_hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64B-1F3FB\",\"non_qualified\":null,\"image\":\"1f64b-1f3fb.png\",\"sheet_x\":32,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64B-1F3FC\",\"non_qualified\":null,\"image\":\"1f64b-1f3fc.png\",\"sheet_x\":32,\"sheet_y\":56,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64B-1F3FD\",\"non_qualified\":null,\"image\":\"1f64b-1f3fd.png\",\"sheet_x\":32,\"sheet_y\":57,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64B-1F3FE\",\"non_qualified\":null,\"image\":\"1f64b-1f3fe.png\",\"sheet_x\":33,\"sheet_y\":0,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64B-1F3FF\",\"non_qualified\":null,\"image\":\"1f64b-1f3ff.png\",\"sheet_x\":33,\"sheet_y\":1,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F64B-200D-2640-FE0F\",\"a\":\"Happy Person Raising One Hand\",\"b\":\"1F64B\",\"j\":[\"person_raising_hand\",\"question\"],\"k\":[32,54],\"o\":0},\"articulated_lorry\":{\"a\":\"Articulated Lorry\",\"b\":\"1F69B\",\"j\":[\"articulated_lorry\",\"vehicle\",\"cars\",\"transportation\",\"express\"],\"k\":[34,19],\"o\":1},\"flag-gg\":{\"a\":\"Guernsey Flag\",\"b\":\"1F1EC-1F1EC\",\"j\":[\"flag_guernsey\",\"gg\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,0],\"o\":2},\"doughnut\":{\"a\":\"Doughnut\",\"b\":\"1F369\",\"j\":[\"doughnut\",\"food\",\"dessert\",\"snack\",\"sweet\",\"donut\"],\"k\":[7,1],\"o\":0},\"dolphin\":{\"a\":\"Dolphin\",\"b\":\"1F42C\",\"j\":[\"dolphin\",\"animal\",\"nature\",\"fish\",\"sea\",\"ocean\",\"flipper\",\"fins\",\"beach\"],\"k\":[12,6],\"n\":[\"flipper\"],\"o\":0},\"imp\":{\"a\":\"Imp\",\"b\":\"1F47F\",\"j\":[\"angry_face_with_horns\",\"devil\",\"angry\",\"horns\"],\"k\":[23,49],\"o\":0},\"signal_strength\":{\"a\":\"Antenna with Bars\",\"b\":\"1F4F6\",\"j\":[\"antenna_bars\",\"blue-square\",\"reception\",\"phone\",\"internet\",\"connection\",\"wifi\",\"bluetooth\",\"bars\"],\"k\":[27,19],\"o\":0},\"film_projector\":{\"a\":\"Film Projector\",\"b\":\"1F4FD-FE0F\",\"c\":\"1F4FD\",\"j\":[\"film_projector\",\"video\",\"tape\",\"record\",\"movie\"],\"k\":[27,26],\"o\":0},\"man-raising-hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64B-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F64B-1F3FB-200D-2642\",\"image\":\"1f64b-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64B-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F64B-1F3FC-200D-2642\",\"image\":\"1f64b-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":50,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64B-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F64B-1F3FD-200D-2642\",\"image\":\"1f64b-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":51,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64B-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F64B-1F3FE-200D-2642\",\"image\":\"1f64b-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64B-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F64B-1F3FF-200D-2642\",\"image\":\"1f64b-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Raising Hand\",\"b\":\"1F64B-200D-2642-FE0F\",\"c\":\"1F64B-200D-2642\",\"j\":[\"man_raising_hand\",\"male\",\"boy\",\"man\"],\"k\":[32,48],\"o\":4},\"tractor\":{\"a\":\"Tractor\",\"b\":\"1F69C\",\"j\":[\"tractor\",\"vehicle\",\"car\",\"farming\",\"agriculture\"],\"k\":[34,20],\"o\":1},\"flag-gh\":{\"a\":\"Ghana Flag\",\"b\":\"1F1EC-1F1ED\",\"j\":[\"flag_ghana\",\"gh\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,1],\"o\":2},\"cookie\":{\"a\":\"Cookie\",\"b\":\"1F36A\",\"j\":[\"cookie\",\"food\",\"snack\",\"oreo\",\"chocolate\",\"sweet\",\"dessert\"],\"k\":[7,2],\"o\":0},\"clapper\":{\"a\":\"Clapper Board\",\"b\":\"1F3AC\",\"j\":[\"clapper_board\",\"movie\",\"film\",\"record\"],\"k\":[8,10],\"o\":0},\"racing_car\":{\"a\":\"Racing Car\",\"b\":\"1F3CE-FE0F\",\"c\":\"1F3CE\",\"j\":[\"racing_car\",\"sports\",\"race\",\"fast\",\"formula\",\"f1\"],\"k\":[10,23],\"o\":0},\"skull\":{\"a\":\"Skull\",\"b\":\"1F480\",\"j\":[\"skull\",\"dead\",\"skeleton\",\"creepy\",\"death\"],\"k\":[23,50],\"o\":0},\"vibration_mode\":{\"a\":\"Vibration Mode\",\"b\":\"1F4F3\",\"j\":[\"vibration_mode\",\"orange-square\",\"phone\"],\"k\":[27,16],\"o\":0},\"woman-raising-hand\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F64B-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F64B-1F3FB-200D-2640\",\"image\":\"1f64b-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F64B-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F64B-1F3FC-200D-2640\",\"image\":\"1f64b-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":44,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F64B-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F64B-1F3FD-200D-2640\",\"image\":\"1f64b-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F64B-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F64B-1F3FE-200D-2640\",\"image\":\"1f64b-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F64B-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F64B-1F3FF-200D-2640\",\"image\":\"1f64b-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F64B\",\"a\":\"Woman Raising Hand\",\"b\":\"1F64B-200D-2640-FE0F\",\"c\":\"1F64B-200D-2640\",\"j\":[\"woman_raising_hand\",\"female\",\"girl\",\"woman\"],\"k\":[32,42],\"o\":4},\"seal\":{\"a\":\"Seal\",\"b\":\"1F9AD\",\"j\":[\"seal\",\"animal\",\"creature\",\"sea\"],\"k\":[43,20],\"o\":13},\"flag-gi\":{\"a\":\"Gibraltar Flag\",\"b\":\"1F1EC-1F1EE\",\"j\":[\"flag_gibraltar\",\"gi\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,2],\"o\":2},\"birthday\":{\"a\":\"Birthday Cake\",\"b\":\"1F382\",\"j\":[\"birthday_cake\",\"food\",\"dessert\",\"cake\"],\"k\":[7,26],\"o\":0},\"racing_motorcycle\":{\"a\":\"Motorcycle\",\"b\":\"1F3CD-FE0F\",\"c\":\"1F3CD\",\"j\":[\"motorcycle\",\"race\",\"sports\",\"fast\"],\"k\":[10,22],\"o\":0},\"fish\":{\"a\":\"Fish\",\"b\":\"1F41F\",\"j\":[\"fish\",\"animal\",\"food\",\"nature\"],\"k\":[11,51],\"o\":0},\"mobile_phone_off\":{\"a\":\"Mobile Phone off\",\"b\":\"1F4F4\",\"j\":[\"mobile_phone_off\",\"mute\",\"orange-square\",\"silence\",\"quiet\"],\"k\":[27,17],\"o\":0},\"tv\":{\"a\":\"Television\",\"b\":\"1F4FA\",\"j\":[\"television\",\"technology\",\"program\",\"oldschool\",\"show\",\"television\"],\"k\":[27,23],\"o\":0},\"deaf_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CF-1F3FB\",\"non_qualified\":null,\"image\":\"1f9cf-1f3fb.png\",\"sheet_x\":45,\"sheet_y\":29,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CF-1F3FC\",\"non_qualified\":null,\"image\":\"1f9cf-1f3fc.png\",\"sheet_x\":45,\"sheet_y\":30,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CF-1F3FD\",\"non_qualified\":null,\"image\":\"1f9cf-1f3fd.png\",\"sheet_x\":45,\"sheet_y\":31,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CF-1F3FE\",\"non_qualified\":null,\"image\":\"1f9cf-1f3fe.png\",\"sheet_x\":45,\"sheet_y\":32,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CF-1F3FF\",\"non_qualified\":null,\"image\":\"1f9cf-1f3ff.png\",\"sheet_x\":45,\"sheet_y\":33,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Deaf Person\",\"b\":\"1F9CF\",\"j\":[\"deaf_person\",\"accessibility\"],\"k\":[45,28],\"o\":12},\"skull_and_crossbones\":{\"a\":\"Skull and Crossbones\",\"b\":\"2620-FE0F\",\"c\":\"2620\",\"j\":[\"skull_and_crossbones\",\"poison\",\"danger\",\"deadly\",\"scary\",\"death\",\"pirate\",\"evil\"],\"k\":[54,13],\"o\":1},\"flag-gl\":{\"a\":\"Greenland Flag\",\"b\":\"1F1EC-1F1F1\",\"j\":[\"flag_greenland\",\"gl\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,3],\"o\":2},\"cake\":{\"a\":\"Shortcake\",\"b\":\"1F370\",\"j\":[\"shortcake\",\"food\",\"dessert\"],\"k\":[7,8],\"o\":0},\"tropical_fish\":{\"a\":\"Tropical Fish\",\"b\":\"1F420\",\"j\":[\"tropical_fish\",\"animal\",\"swim\",\"ocean\",\"beach\",\"nemo\"],\"k\":[11,52],\"o\":0},\"hankey\":{\"a\":\"Pile of Poo\",\"b\":\"1F4A9\",\"j\":[\"pile_of_poo\",\"hankey\",\"shitface\",\"fail\",\"turd\",\"shit\"],\"k\":[25,53],\"n\":[\"poop\",\"shit\"],\"o\":0},\"camera\":{\"a\":\"Camera\",\"b\":\"1F4F7\",\"j\":[\"camera\",\"gadgets\",\"photography\"],\"k\":[27,20],\"o\":0},\"motor_scooter\":{\"a\":\"Motor Scooter\",\"b\":\"1F6F5\",\"j\":[\"motor_scooter\",\"vehicle\",\"vespa\",\"sasha\"],\"k\":[36,47],\"o\":3},\"deaf_man\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CF-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9CF-1F3FB-200D-2642\",\"image\":\"1f9cf-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":23,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CF-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9CF-1F3FC-200D-2642\",\"image\":\"1f9cf-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":24,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CF-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9CF-1F3FD-200D-2642\",\"image\":\"1f9cf-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":25,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CF-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9CF-1F3FE-200D-2642\",\"image\":\"1f9cf-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":26,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CF-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9CF-1F3FF-200D-2642\",\"image\":\"1f9cf-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":27,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Deaf Man\",\"b\":\"1F9CF-200D-2642-FE0F\",\"c\":\"1F9CF-200D-2642\",\"j\":[\"deaf_man\",\"accessibility\"],\"k\":[45,22],\"o\":12},\"female_sign\":{\"a\":\"Female Sign\",\"b\":\"2640-FE0F\",\"c\":\"2640\",\"j\":[\"female_sign\",\"woman\",\"women\",\"lady\",\"girl\"],\"k\":[54,23],\"o\":4},\"flag-gm\":{\"a\":\"Gambia Flag\",\"b\":\"1F1EC-1F1F2\",\"j\":[\"flag_gambia\",\"gm\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,4],\"o\":2},\"blowfish\":{\"a\":\"Blowfish\",\"b\":\"1F421\",\"j\":[\"blowfish\",\"animal\",\"nature\",\"food\",\"sea\",\"ocean\"],\"k\":[11,53],\"o\":0},\"camera_with_flash\":{\"a\":\"Camera with Flash\",\"b\":\"1F4F8\",\"j\":[\"camera_with_flash\",\"photography\",\"gadgets\"],\"k\":[27,21],\"o\":1},\"clown_face\":{\"a\":\"Clown Face\",\"b\":\"1F921\",\"j\":[\"clown_face\",\"face\"],\"k\":[38,17],\"o\":3},\"manual_wheelchair\":{\"a\":\"Manual Wheelchair\",\"b\":\"1F9BD\",\"j\":[\"manual_wheelchair\",\"accessibility\"],\"k\":[44,23],\"o\":12},\"cupcake\":{\"a\":\"Cupcake\",\"b\":\"1F9C1\",\"j\":[\"cupcake\",\"food\",\"dessert\",\"bakery\",\"sweet\"],\"k\":[44,27],\"o\":11},\"deaf_woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CF-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9CF-1F3FB-200D-2640\",\"image\":\"1f9cf-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":17,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CF-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9CF-1F3FC-200D-2640\",\"image\":\"1f9cf-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":18,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CF-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9CF-1F3FD-200D-2640\",\"image\":\"1f9cf-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":19,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CF-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9CF-1F3FE-200D-2640\",\"image\":\"1f9cf-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":20,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CF-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9CF-1F3FF-200D-2640\",\"image\":\"1f9cf-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":21,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Deaf Woman\",\"b\":\"1F9CF-200D-2640-FE0F\",\"c\":\"1F9CF-200D-2640\",\"j\":[\"deaf_woman\",\"accessibility\"],\"k\":[45,16],\"o\":12},\"male_sign\":{\"a\":\"Male Sign\",\"b\":\"2642-FE0F\",\"c\":\"2642\",\"j\":[\"male_sign\",\"man\",\"boy\",\"men\"],\"k\":[54,24],\"o\":4},\"flag-gn\":{\"a\":\"Guinea Flag\",\"b\":\"1F1EC-1F1F3\",\"j\":[\"flag_guinea\",\"gn\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,5],\"o\":2},\"japanese_ogre\":{\"a\":\"Japanese Ogre\",\"b\":\"1F479\",\"j\":[\"ogre\",\"monster\",\"red\",\"mask\",\"halloween\",\"scary\",\"creepy\",\"devil\",\"demon\",\"japanese\",\"ogre\"],\"k\":[23,38],\"o\":0},\"video_camera\":{\"a\":\"Video Camera\",\"b\":\"1F4F9\",\"j\":[\"video_camera\",\"film\",\"record\"],\"k\":[27,22],\"o\":0},\"bow\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F647-1F3FB\",\"non_qualified\":null,\"image\":\"1f647-1f3fb.png\",\"sheet_x\":32,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F647-1F3FC\",\"non_qualified\":null,\"image\":\"1f647-1f3fc.png\",\"sheet_x\":32,\"sheet_y\":35,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F647-1F3FD\",\"non_qualified\":null,\"image\":\"1f647-1f3fd.png\",\"sheet_x\":32,\"sheet_y\":36,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F647-1F3FE\",\"non_qualified\":null,\"image\":\"1f647-1f3fe.png\",\"sheet_x\":32,\"sheet_y\":37,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F647-1F3FF\",\"non_qualified\":null,\"image\":\"1f647-1f3ff.png\",\"sheet_x\":32,\"sheet_y\":38,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F647-200D-2642-FE0F\",\"a\":\"Person Bowing Deeply\",\"b\":\"1F647\",\"j\":[\"person_bowing\",\"respectiful\"],\"k\":[32,33],\"o\":0},\"pie\":{\"a\":\"Pie\",\"b\":\"1F967\",\"j\":[\"pie\",\"food\",\"dessert\",\"pastry\"],\"k\":[42,4],\"o\":5},\"shark\":{\"a\":\"Shark\",\"b\":\"1F988\",\"j\":[\"shark\",\"animal\",\"nature\",\"fish\",\"sea\",\"ocean\",\"jaws\",\"fins\",\"beach\"],\"k\":[42,41],\"o\":3},\"motorized_wheelchair\":{\"a\":\"Motorized Wheelchair\",\"b\":\"1F9BC\",\"j\":[\"motorized_wheelchair\",\"accessibility\"],\"k\":[44,22],\"o\":12},\"transgender_symbol\":{\"a\":\"Transgender Symbol\",\"b\":\"26A7-FE0F\",\"c\":\"26A7\",\"j\":[\"transgender symbol\",\"lgbtq\"],\"k\":[54,57],\"o\":13},\"flag-gp\":{\"a\":\"Guadeloupe Flag\",\"b\":\"1F1EC-1F1F5\",\"j\":[\"flag_guadeloupe\",\"gp\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,6],\"o\":2},\"chocolate_bar\":{\"a\":\"Chocolate Bar\",\"b\":\"1F36B\",\"j\":[\"chocolate_bar\",\"food\",\"snack\",\"dessert\",\"sweet\"],\"k\":[7,3],\"o\":0},\"octopus\":{\"a\":\"Octopus\",\"b\":\"1F419\",\"j\":[\"octopus\",\"animal\",\"creature\",\"ocean\",\"sea\",\"nature\",\"beach\"],\"k\":[11,45],\"o\":0},\"japanese_goblin\":{\"a\":\"Japanese Goblin\",\"b\":\"1F47A\",\"j\":[\"goblin\",\"red\",\"evil\",\"mask\",\"monster\",\"scary\",\"creepy\",\"japanese\",\"goblin\"],\"k\":[23,39],\"o\":0},\"vhs\":{\"a\":\"Videocassette\",\"b\":\"1F4FC\",\"j\":[\"videocassette\",\"record\",\"video\",\"oldschool\",\"90s\",\"80s\"],\"k\":[27,25],\"o\":0},\"man-bowing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F647-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F647-1F3FB-200D-2642\",\"image\":\"1f647-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F647-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F647-1F3FC-200D-2642\",\"image\":\"1f647-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F647-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F647-1F3FD-200D-2642\",\"image\":\"1f647-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F647-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F647-1F3FE-200D-2642\",\"image\":\"1f647-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F647-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F647-1F3FF-200D-2642\",\"image\":\"1f647-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":32,\"sheet_y\":32,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F647\",\"a\":\"Man Bowing\",\"b\":\"1F647-200D-2642-FE0F\",\"c\":\"1F647-200D-2642\",\"j\":[\"man_bowing\",\"man\",\"male\",\"boy\"],\"k\":[32,27],\"o\":4},\"auto_rickshaw\":{\"a\":\"Auto Rickshaw\",\"b\":\"1F6FA\",\"j\":[\"auto_rickshaw\",\"move\",\"transportation\"],\"k\":[36,52],\"o\":12},\"heavy_multiplication_x\":{\"a\":\"Heavy Multiplication X\",\"b\":\"2716-FE0F\",\"c\":\"2716\",\"j\":[\"multiplication_sign\",\"math\",\"calculation\"],\"k\":[56,17],\"o\":0},\"flag-gq\":{\"a\":\"Equatorial Guinea Flag\",\"b\":\"1F1EC-1F1F6\",\"j\":[\"flag_equatorial_guinea\",\"equatorial\",\"gn\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,7],\"o\":2},\"candy\":{\"a\":\"Candy\",\"b\":\"1F36C\",\"j\":[\"candy\",\"snack\",\"dessert\",\"sweet\",\"lolly\"],\"k\":[7,4],\"o\":0},\"shell\":{\"a\":\"Spiral Shell\",\"b\":\"1F41A\",\"j\":[\"spiral_shell\",\"nature\",\"sea\",\"beach\"],\"k\":[11,46],\"o\":0},\"ghost\":{\"a\":\"Ghost\",\"b\":\"1F47B\",\"j\":[\"ghost\",\"halloween\",\"spooky\",\"scary\"],\"k\":[23,40],\"o\":0},\"mag\":{\"a\":\"Left-Pointing Magnifying Glass\",\"b\":\"1F50D\",\"j\":[\"magnifying_glass_tilted_left\",\"search\",\"zoom\",\"find\",\"detective\"],\"k\":[27,41],\"o\":0},\"woman-bowing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F647-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F647-1F3FB-200D-2640\",\"image\":\"1f647-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F647-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F647-1F3FC-200D-2640\",\"image\":\"1f647-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F647-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F647-1F3FD-200D-2640\",\"image\":\"1f647-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F647-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F647-1F3FE-200D-2640\",\"image\":\"1f647-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F647-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F647-1F3FF-200D-2640\",\"image\":\"1f647-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":32,\"sheet_y\":26,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Bowing\",\"b\":\"1F647-200D-2640-FE0F\",\"c\":\"1F647-200D-2640\",\"j\":[\"woman_bowing\",\"woman\",\"female\",\"girl\"],\"k\":[32,21],\"o\":4},\"bike\":{\"a\":\"Bicycle\",\"b\":\"1F6B2\",\"j\":[\"bicycle\",\"sports\",\"bicycle\",\"exercise\",\"hipster\"],\"k\":[35,1],\"o\":0},\"heavy_plus_sign\":{\"a\":\"Heavy Plus Sign\",\"b\":\"2795\",\"j\":[\"plus_sign\",\"math\",\"calculation\",\"addition\",\"more\",\"increase\"],\"k\":[56,33],\"o\":0},\"flag-gr\":{\"a\":\"Greece Flag\",\"b\":\"1F1EC-1F1F7\",\"j\":[\"flag_greece\",\"gr\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,8],\"o\":2},\"lollipop\":{\"a\":\"Lollipop\",\"b\":\"1F36D\",\"j\":[\"lollipop\",\"food\",\"snack\",\"candy\",\"sweet\"],\"k\":[7,5],\"o\":0},\"snail\":{\"a\":\"Snail\",\"b\":\"1F40C\",\"j\":[\"snail\",\"slow\",\"animal\",\"shell\"],\"k\":[11,31],\"o\":0},\"alien\":{\"a\":\"Extraterrestrial Alien\",\"b\":\"1F47D\",\"j\":[\"alien\",\"UFO\",\"paul\",\"weird\",\"outer_space\"],\"k\":[23,47],\"o\":0},\"mag_right\":{\"a\":\"Right-Pointing Magnifying Glass\",\"b\":\"1F50E\",\"j\":[\"magnifying_glass_tilted_right\",\"search\",\"zoom\",\"find\",\"detective\"],\"k\":[27,42],\"o\":0},\"scooter\":{\"a\":\"Scooter\",\"b\":\"1F6F4\",\"j\":[\"kick_scooter\",\"vehicle\",\"kick\",\"razor\"],\"k\":[36,46],\"o\":3},\"face_palm\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F926-1F3FB\",\"non_qualified\":null,\"image\":\"1f926-1f3fb.png\",\"sheet_x\":38,\"sheet_y\":35,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F926-1F3FC\",\"non_qualified\":null,\"image\":\"1f926-1f3fc.png\",\"sheet_x\":38,\"sheet_y\":36,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F926-1F3FD\",\"non_qualified\":null,\"image\":\"1f926-1f3fd.png\",\"sheet_x\":38,\"sheet_y\":37,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F926-1F3FE\",\"non_qualified\":null,\"image\":\"1f926-1f3fe.png\",\"sheet_x\":38,\"sheet_y\":38,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F926-1F3FF\",\"non_qualified\":null,\"image\":\"1f926-1f3ff.png\",\"sheet_x\":38,\"sheet_y\":39,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Face Palm\",\"b\":\"1F926\",\"j\":[\"person_facepalming\",\"disappointed\"],\"k\":[38,34],\"o\":3},\"heavy_minus_sign\":{\"a\":\"Heavy Minus Sign\",\"b\":\"2796\",\"j\":[\"minus_sign\",\"math\",\"calculation\",\"subtract\",\"less\"],\"k\":[56,34],\"o\":0},\"flag-gs\":{\"a\":\"South Georgia & South Sandwich Islands Flag\",\"b\":\"1F1EC-1F1F8\",\"j\":[\"flag_south_georgia_south_sandwich_islands\",\"south\",\"georgia\",\"sandwich\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,9],\"o\":2},\"custard\":{\"a\":\"Custard\",\"b\":\"1F36E\",\"j\":[\"custard\",\"dessert\",\"food\"],\"k\":[7,6],\"o\":0},\"space_invader\":{\"a\":\"Alien Monster\",\"b\":\"1F47E\",\"j\":[\"alien_monster\",\"game\",\"arcade\",\"play\"],\"k\":[23,48],\"o\":0},\"candle\":{\"a\":\"Candle\",\"b\":\"1F56F-FE0F\",\"c\":\"1F56F\",\"j\":[\"candle\",\"fire\",\"wax\"],\"k\":[29,4],\"o\":0},\"skateboard\":{\"a\":\"Skateboard\",\"b\":\"1F6F9\",\"j\":[\"skateboard\",\"board\"],\"k\":[36,51],\"o\":11},\"man-facepalming\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F926-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F926-1F3FB-200D-2642\",\"image\":\"1f926-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":38,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F926-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F926-1F3FC-200D-2642\",\"image\":\"1f926-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":38,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F926-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F926-1F3FD-200D-2642\",\"image\":\"1f926-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":38,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F926-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F926-1F3FE-200D-2642\",\"image\":\"1f926-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":38,\"sheet_y\":32,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F926-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F926-1F3FF-200D-2642\",\"image\":\"1f926-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":38,\"sheet_y\":33,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Facepalming\",\"b\":\"1F926-200D-2642-FE0F\",\"c\":\"1F926-200D-2642\",\"j\":[\"man_facepalming\",\"man\",\"male\",\"boy\",\"disbelief\"],\"k\":[38,28],\"o\":4},\"butterfly\":{\"a\":\"Butterfly\",\"b\":\"1F98B\",\"j\":[\"butterfly\",\"animal\",\"insect\",\"nature\",\"caterpillar\"],\"k\":[42,44],\"o\":3},\"heavy_division_sign\":{\"a\":\"Heavy Division Sign\",\"b\":\"2797\",\"j\":[\"division_sign\",\"divide\",\"math\",\"calculation\"],\"k\":[56,35],\"o\":0},\"flag-gt\":{\"a\":\"Guatemala Flag\",\"b\":\"1F1EC-1F1F9\",\"j\":[\"flag_guatemala\",\"gt\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,10],\"o\":2},\"honey_pot\":{\"a\":\"Honey Pot\",\"b\":\"1F36F\",\"j\":[\"honey_pot\",\"bees\",\"sweet\",\"kitchen\"],\"k\":[7,7],\"o\":0},\"bug\":{\"a\":\"Bug\",\"b\":\"1F41B\",\"j\":[\"bug\",\"animal\",\"insect\",\"nature\",\"worm\"],\"k\":[11,47],\"o\":0},\"bulb\":{\"a\":\"Electric Light Bulb\",\"b\":\"1F4A1\",\"j\":[\"light_bulb\",\"light\",\"electricity\",\"idea\"],\"k\":[25,45],\"o\":0},\"roller_skate\":{\"a\":\"Roller Skate\",\"b\":\"1F6FC\",\"j\":[\"roller skate\",\"footwear\",\"sports\"],\"k\":[36,54],\"o\":13},\"robot_face\":{\"a\":\"Robot Face\",\"b\":\"1F916\",\"j\":[\"robot\",\"computer\",\"machine\",\"bot\"],\"k\":[37,29],\"o\":1},\"woman-facepalming\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F926-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F926-1F3FB-200D-2640\",\"image\":\"1f926-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":38,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F926-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F926-1F3FC-200D-2640\",\"image\":\"1f926-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":38,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F926-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F926-1F3FD-200D-2640\",\"image\":\"1f926-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":38,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F926-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F926-1F3FE-200D-2640\",\"image\":\"1f926-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":38,\"sheet_y\":26,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F926-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F926-1F3FF-200D-2640\",\"image\":\"1f926-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":38,\"sheet_y\":27,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Facepalming\",\"b\":\"1F926-200D-2640-FE0F\",\"c\":\"1F926-200D-2640\",\"j\":[\"woman_facepalming\",\"woman\",\"female\",\"girl\",\"disbelief\"],\"k\":[38,22],\"o\":4},\"infinity\":{\"a\":\"Infinity\",\"b\":\"267E-FE0F\",\"c\":\"267E\",\"j\":[\"infinity\",\"forever\"],\"k\":[54,44],\"o\":11},\"flag-gu\":{\"a\":\"Guam Flag\",\"b\":\"1F1EC-1F1FA\",\"j\":[\"flag_guam\",\"gu\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,11],\"o\":2},\"baby_bottle\":{\"a\":\"Baby Bottle\",\"b\":\"1F37C\",\"j\":[\"baby_bottle\",\"food\",\"container\",\"milk\"],\"k\":[7,20],\"o\":1},\"ant\":{\"a\":\"Ant\",\"b\":\"1F41C\",\"j\":[\"ant\",\"animal\",\"insect\",\"nature\",\"bug\"],\"k\":[11,48],\"o\":0},\"flashlight\":{\"a\":\"Electric Torch\",\"b\":\"1F526\",\"j\":[\"flashlight\",\"dark\",\"camping\",\"sight\",\"night\"],\"k\":[28,8],\"o\":0},\"smiley_cat\":{\"a\":\"Smiling Cat Face with Open Mouth\",\"b\":\"1F63A\",\"j\":[\"grinning_cat\",\"animal\",\"cats\",\"happy\",\"smile\"],\"k\":[31,32],\"o\":0},\"busstop\":{\"a\":\"Bus Stop\",\"b\":\"1F68F\",\"j\":[\"bus_stop\",\"transportation\",\"wait\"],\"k\":[34,7],\"o\":0},\"shrug\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F937-1F3FB\",\"non_qualified\":null,\"image\":\"1f937-1f3fb.png\",\"sheet_x\":40,\"sheet_y\":0,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F937-1F3FC\",\"non_qualified\":null,\"image\":\"1f937-1f3fc.png\",\"sheet_x\":40,\"sheet_y\":1,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F937-1F3FD\",\"non_qualified\":null,\"image\":\"1f937-1f3fd.png\",\"sheet_x\":40,\"sheet_y\":2,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F937-1F3FE\",\"non_qualified\":null,\"image\":\"1f937-1f3fe.png\",\"sheet_x\":40,\"sheet_y\":3,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F937-1F3FF\",\"non_qualified\":null,\"image\":\"1f937-1f3ff.png\",\"sheet_x\":40,\"sheet_y\":4,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Shrug\",\"b\":\"1F937\",\"j\":[\"person_shrugging\",\"regardless\"],\"k\":[39,57],\"o\":3},\"bangbang\":{\"a\":\"Double Exclamation Mark\",\"b\":\"203C-FE0F\",\"c\":\"203C\",\"j\":[\"double_exclamation_mark\",\"exclamation\",\"surprise\"],\"k\":[53,16],\"o\":0},\"flag-gw\":{\"a\":\"Guinea-Bissau Flag\",\"b\":\"1F1EC-1F1FC\",\"j\":[\"flag_guinea_bissau\",\"gw\",\"bissau\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,12],\"o\":2},\"izakaya_lantern\":{\"a\":\"Izakaya Lantern\",\"b\":\"1F3EE\",\"j\":[\"red_paper_lantern\",\"light\",\"paper\",\"halloween\",\"spooky\"],\"k\":[10,55],\"n\":[\"lantern\"],\"o\":0},\"bee\":{\"a\":\"Honeybee\",\"b\":\"1F41D\",\"j\":[\"honeybee\",\"animal\",\"insect\",\"nature\",\"bug\",\"spring\",\"honey\"],\"k\":[11,49],\"n\":[\"honeybee\"],\"o\":0},\"smile_cat\":{\"a\":\"Grinning Cat Face with Smiling Eyes\",\"b\":\"1F638\",\"j\":[\"grinning_cat_with_smiling_eyes\",\"animal\",\"cats\",\"smile\"],\"k\":[31,30],\"o\":0},\"motorway\":{\"a\":\"Motorway\",\"b\":\"1F6E3-FE0F\",\"c\":\"1F6E3\",\"j\":[\"motorway\",\"road\",\"cupertino\",\"interstate\",\"highway\"],\"k\":[36,38],\"o\":0},\"man-shrugging\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F937-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F937-1F3FB-200D-2642\",\"image\":\"1f937-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F937-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F937-1F3FC-200D-2642\",\"image\":\"1f937-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F937-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F937-1F3FD-200D-2642\",\"image\":\"1f937-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F937-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F937-1F3FE-200D-2642\",\"image\":\"1f937-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F937-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F937-1F3FF-200D-2642\",\"image\":\"1f937-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":56,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Shrugging\",\"b\":\"1F937-200D-2642-FE0F\",\"c\":\"1F937-200D-2642\",\"j\":[\"man_shrugging\",\"man\",\"male\",\"boy\",\"confused\",\"indifferent\",\"doubt\"],\"k\":[39,51],\"o\":4},\"glass_of_milk\":{\"a\":\"Glass of Milk\",\"b\":\"1F95B\",\"j\":[\"glass_of_milk\",\"beverage\",\"drink\",\"cow\"],\"k\":[41,50],\"o\":3},\"interrobang\":{\"a\":\"Exclamation Question Mark\",\"b\":\"2049-FE0F\",\"c\":\"2049\",\"j\":[\"exclamation_question_mark\",\"wat\",\"punctuation\",\"surprise\"],\"k\":[53,17],\"o\":0},\"flag-gy\":{\"a\":\"Guyana Flag\",\"b\":\"1F1EC-1F1FE\",\"j\":[\"flag_guyana\",\"gy\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,13],\"o\":2},\"joy_cat\":{\"a\":\"Cat Face with Tears of Joy\",\"b\":\"1F639\",\"j\":[\"cat_with_tears_of_joy\",\"animal\",\"cats\",\"haha\",\"happy\",\"tears\"],\"k\":[31,31],\"o\":0},\"railway_track\":{\"a\":\"Railway Track\",\"b\":\"1F6E4-FE0F\",\"c\":\"1F6E4\",\"j\":[\"railway_track\",\"train\",\"transportation\"],\"k\":[36,39],\"o\":0},\"woman-shrugging\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F937-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F937-1F3FB-200D-2640\",\"image\":\"1f937-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F937-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F937-1F3FC-200D-2640\",\"image\":\"1f937-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F937-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F937-1F3FD-200D-2640\",\"image\":\"1f937-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F937-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F937-1F3FE-200D-2640\",\"image\":\"1f937-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F937-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F937-1F3FF-200D-2640\",\"image\":\"1f937-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":50,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Shrugging\",\"b\":\"1F937-200D-2640-FE0F\",\"c\":\"1F937-200D-2640\",\"j\":[\"woman_shrugging\",\"woman\",\"female\",\"girl\",\"confused\",\"indifferent\",\"doubt\"],\"k\":[39,45],\"o\":4},\"diya_lamp\":{\"a\":\"Diya Lamp\",\"b\":\"1FA94\",\"j\":[\"diya_lamp\",\"lighting\"],\"k\":[52,36],\"o\":12},\"beetle\":{\"a\":\"Beetle\",\"b\":\"1FAB2\",\"j\":[\"beetle\",\"insect\"],\"k\":[53,1],\"o\":13},\"coffee\":{\"a\":\"Hot Beverage\",\"b\":\"2615\",\"j\":[\"hot_beverage\",\"beverage\",\"caffeine\",\"latte\",\"espresso\"],\"k\":[54,5],\"o\":0},\"question\":{\"a\":\"Black Question Mark Ornament\",\"b\":\"2753\",\"j\":[\"question_mark\",\"doubt\",\"confused\"],\"k\":[56,27],\"o\":0},\"flag-hk\":{\"a\":\"Hong Kong Sar China Flag\",\"b\":\"1F1ED-1F1F0\",\"j\":[\"flag_hong_kong_sar_china\",\"hong\",\"kong\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,14],\"o\":2},\"ladybug\":{\"a\":\"Lady Beetle\",\"b\":\"1F41E\",\"j\":[\"lady_beetle\",\"animal\",\"insect\",\"nature\",\"ladybug\"],\"k\":[11,50],\"n\":[\"lady_beetle\"],\"o\":0},\"notebook_with_decorative_cover\":{\"a\":\"Notebook with Decorative Cover\",\"b\":\"1F4D4\",\"j\":[\"notebook_with_decorative_cover\",\"classroom\",\"notes\",\"record\",\"paper\",\"study\"],\"k\":[26,43],\"o\":0},\"heart_eyes_cat\":{\"a\":\"Smiling Cat Face with Heart-Shaped Eyes\",\"b\":\"1F63B\",\"j\":[\"smiling_cat_with_heart_eyes\",\"animal\",\"love\",\"like\",\"affection\",\"cats\",\"valentines\",\"heart\"],\"k\":[31,33],\"o\":0},\"oil_drum\":{\"a\":\"Oil Drum\",\"b\":\"1F6E2-FE0F\",\"c\":\"1F6E2\",\"j\":[\"oil_drum\",\"barrell\"],\"k\":[36,37],\"o\":0},\"health_worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-2695-FE0F\",\"non_qualified\":\"1F9D1-1F3FB-200D-2695\",\"image\":\"1f9d1-1f3fb-200d-2695-fe0f.png\",\"sheet_x\":48,\"sheet_y\":20,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-2695-FE0F\",\"non_qualified\":\"1F9D1-1F3FC-200D-2695\",\"image\":\"1f9d1-1f3fc-200d-2695-fe0f.png\",\"sheet_x\":48,\"sheet_y\":21,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-2695-FE0F\",\"non_qualified\":\"1F9D1-1F3FD-200D-2695\",\"image\":\"1f9d1-1f3fd-200d-2695-fe0f.png\",\"sheet_x\":48,\"sheet_y\":22,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-2695-FE0F\",\"non_qualified\":\"1F9D1-1F3FE-200D-2695\",\"image\":\"1f9d1-1f3fe-200d-2695-fe0f.png\",\"sheet_x\":48,\"sheet_y\":23,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-2695-FE0F\",\"non_qualified\":\"1F9D1-1F3FF-200D-2695\",\"image\":\"1f9d1-1f3ff-200d-2695-fe0f.png\",\"sheet_x\":48,\"sheet_y\":24,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Health Worker\",\"b\":\"1F9D1-200D-2695-FE0F\",\"c\":\"1F9D1-200D-2695\",\"j\":[\"health_worker\",\"hospital\"],\"k\":[48,19],\"o\":12},\"teapot\":{\"a\":\"Teapot\",\"b\":\"1FAD6\",\"j\":[\"teapot\",\"drink\",\"hot\"],\"k\":[53,15],\"o\":13},\"grey_question\":{\"a\":\"White Question Mark Ornament\",\"b\":\"2754\",\"j\":[\"white_question_mark\",\"doubts\",\"gray\",\"huh\",\"confused\"],\"k\":[56,28],\"o\":0},\"flag-hm\":{\"a\":\"Heard & Mcdonald Islands Flag\",\"b\":\"1F1ED-1F1F2\",\"j\":[\"flag_heard_mcdonald_islands\"],\"k\":[2,15],\"o\":2},\"tea\":{\"a\":\"Teacup Without Handle\",\"b\":\"1F375\",\"j\":[\"teacup_without_handle\",\"drink\",\"bowl\",\"breakfast\",\"green\",\"british\"],\"k\":[7,13],\"o\":0},\"male-doctor\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-2695-FE0F\",\"non_qualified\":\"1F468-1F3FB-200D-2695\",\"image\":\"1f468-1f3fb-200d-2695-fe0f.png\",\"sheet_x\":16,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-2695-FE0F\",\"non_qualified\":\"1F468-1F3FC-200D-2695\",\"image\":\"1f468-1f3fc-200d-2695-fe0f.png\",\"sheet_x\":16,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-2695-FE0F\",\"non_qualified\":\"1F468-1F3FD-200D-2695\",\"image\":\"1f468-1f3fd-200d-2695-fe0f.png\",\"sheet_x\":16,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-2695-FE0F\",\"non_qualified\":\"1F468-1F3FE-200D-2695\",\"image\":\"1f468-1f3fe-200d-2695-fe0f.png\",\"sheet_x\":16,\"sheet_y\":56,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-2695-FE0F\",\"non_qualified\":\"1F468-1F3FF-200D-2695\",\"image\":\"1f468-1f3ff-200d-2695-fe0f.png\",\"sheet_x\":16,\"sheet_y\":57,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Health Worker\",\"b\":\"1F468-200D-2695-FE0F\",\"c\":\"1F468-200D-2695\",\"j\":[\"man_health_worker\",\"doctor\",\"nurse\",\"therapist\",\"healthcare\",\"man\",\"human\"],\"k\":[16,52],\"o\":4},\"closed_book\":{\"a\":\"Closed Book\",\"b\":\"1F4D5\",\"j\":[\"closed_book\",\"read\",\"library\",\"knowledge\",\"textbook\",\"learn\"],\"k\":[26,44],\"o\":0},\"smirk_cat\":{\"a\":\"Cat Face with Wry Smile\",\"b\":\"1F63C\",\"j\":[\"cat_with_wry_smile\",\"animal\",\"cats\",\"smirk\"],\"k\":[31,34],\"o\":0},\"cricket\":{\"a\":\"Cricket\",\"b\":\"1F997\",\"j\":[\"cricket\",\"animal\",\"cricket\",\"chirp\"],\"k\":[42,56],\"o\":5},\"fuelpump\":{\"a\":\"Fuel Pump\",\"b\":\"26FD\",\"j\":[\"fuel_pump\",\"gas station\",\"petroleum\"],\"k\":[55,43],\"o\":0},\"grey_exclamation\":{\"a\":\"White Exclamation Mark Ornament\",\"b\":\"2755\",\"j\":[\"white_exclamation_mark\",\"surprise\",\"punctuation\",\"gray\",\"wow\",\"warning\"],\"k\":[56,29],\"o\":0},\"flag-hn\":{\"a\":\"Honduras Flag\",\"b\":\"1F1ED-1F1F3\",\"j\":[\"flag_honduras\",\"hn\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,16],\"o\":2},\"sake\":{\"a\":\"Sake Bottle and Cup\",\"b\":\"1F376\",\"j\":[\"sake\",\"wine\",\"drink\",\"drunk\",\"beverage\",\"japanese\",\"alcohol\",\"booze\"],\"k\":[7,14],\"o\":0},\"female-doctor\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-2695-FE0F\",\"non_qualified\":\"1F469-1F3FB-200D-2695\",\"image\":\"1f469-1f3fb-200d-2695-fe0f.png\",\"sheet_x\":19,\"sheet_y\":41,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-2695-FE0F\",\"non_qualified\":\"1F469-1F3FC-200D-2695\",\"image\":\"1f469-1f3fc-200d-2695-fe0f.png\",\"sheet_x\":19,\"sheet_y\":42,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-2695-FE0F\",\"non_qualified\":\"1F469-1F3FD-200D-2695\",\"image\":\"1f469-1f3fd-200d-2695-fe0f.png\",\"sheet_x\":19,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-2695-FE0F\",\"non_qualified\":\"1F469-1F3FE-200D-2695\",\"image\":\"1f469-1f3fe-200d-2695-fe0f.png\",\"sheet_x\":19,\"sheet_y\":44,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-2695-FE0F\",\"non_qualified\":\"1F469-1F3FF-200D-2695\",\"image\":\"1f469-1f3ff-200d-2695-fe0f.png\",\"sheet_x\":19,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Health Worker\",\"b\":\"1F469-200D-2695-FE0F\",\"c\":\"1F469-200D-2695\",\"j\":[\"woman_health_worker\",\"doctor\",\"nurse\",\"therapist\",\"healthcare\",\"woman\",\"human\"],\"k\":[19,40],\"o\":4},\"book\":{\"a\":\"Open Book\",\"b\":\"1F4D6\",\"j\":[\"open_book\",\"book\",\"read\",\"library\",\"knowledge\",\"literature\",\"learn\",\"study\"],\"k\":[26,45],\"n\":[\"open_book\"],\"o\":0},\"kissing_cat\":{\"a\":\"Kissing Cat Face with Closed Eyes\",\"b\":\"1F63D\",\"j\":[\"kissing_cat\",\"animal\",\"cats\",\"kiss\"],\"k\":[31,35],\"o\":0},\"rotating_light\":{\"a\":\"Police Cars Revolving Light\",\"b\":\"1F6A8\",\"j\":[\"police_car_light\",\"police\",\"ambulance\",\"911\",\"emergency\",\"alert\",\"error\",\"pinged\",\"law\",\"legal\"],\"k\":[34,49],\"o\":0},\"cockroach\":{\"a\":\"Cockroach\",\"b\":\"1FAB3\",\"j\":[\"cockroach\",\"insect\",\"pests\"],\"k\":[53,2],\"o\":13},\"exclamation\":{\"a\":\"Heavy Exclamation Mark Symbol\",\"b\":\"2757\",\"j\":[\"exclamation_mark\",\"heavy_exclamation_mark\",\"danger\",\"surprise\",\"punctuation\",\"wow\",\"warning\"],\"k\":[56,30],\"n\":[\"heavy_exclamation_mark\"],\"o\":0},\"flag-hr\":{\"a\":\"Croatia Flag\",\"b\":\"1F1ED-1F1F7\",\"j\":[\"flag_croatia\",\"hr\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,17],\"o\":2},\"champagne\":{\"a\":\"Bottle with Popping Cork\",\"b\":\"1F37E\",\"j\":[\"bottle_with_popping_cork\",\"drink\",\"wine\",\"bottle\",\"celebration\"],\"k\":[7,22],\"o\":1},\"green_book\":{\"a\":\"Green Book\",\"b\":\"1F4D7\",\"j\":[\"green_book\",\"read\",\"library\",\"knowledge\",\"study\"],\"k\":[26,46],\"o\":0},\"spider\":{\"a\":\"Spider\",\"b\":\"1F577-FE0F\",\"c\":\"1F577\",\"j\":[\"spider\",\"animal\",\"arachnid\"],\"k\":[29,32],\"o\":0},\"scream_cat\":{\"a\":\"Weary Cat Face\",\"b\":\"1F640\",\"j\":[\"weary_cat\",\"animal\",\"cats\",\"munch\",\"scared\",\"scream\"],\"k\":[31,38],\"o\":0},\"traffic_light\":{\"a\":\"Horizontal Traffic Light\",\"b\":\"1F6A5\",\"j\":[\"horizontal_traffic_light\",\"transportation\",\"signal\"],\"k\":[34,46],\"o\":0},\"student\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F393\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f393.png\",\"sheet_x\":46,\"sheet_y\":2,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F393\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f393.png\",\"sheet_x\":46,\"sheet_y\":3,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F393\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f393.png\",\"sheet_x\":46,\"sheet_y\":4,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F393\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f393.png\",\"sheet_x\":46,\"sheet_y\":5,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F393\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f393.png\",\"sheet_x\":46,\"sheet_y\":6,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Student\",\"b\":\"1F9D1-200D-1F393\",\"j\":[\"student\",\"learn\"],\"k\":[46,1],\"o\":12},\"wavy_dash\":{\"a\":\"Wavy Dash\",\"b\":\"3030-FE0F\",\"c\":\"3030\",\"j\":[\"wavy_dash\",\"draw\",\"line\",\"moustache\",\"mustache\",\"squiggle\",\"scribble\"],\"k\":[56,48],\"o\":0},\"flag-ht\":{\"a\":\"Haiti Flag\",\"b\":\"1F1ED-1F1F9\",\"j\":[\"flag_haiti\",\"ht\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,18],\"o\":2},\"wine_glass\":{\"a\":\"Wine Glass\",\"b\":\"1F377\",\"j\":[\"wine_glass\",\"drink\",\"beverage\",\"drunk\",\"alcohol\",\"booze\"],\"k\":[7,15],\"o\":0},\"male-student\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F393\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f393.png\",\"sheet_x\":14,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F393\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f393.png\",\"sheet_x\":14,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F393\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f393.png\",\"sheet_x\":14,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F393\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f393.png\",\"sheet_x\":14,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F393\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f393.png\",\"sheet_x\":14,\"sheet_y\":50,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Student\",\"b\":\"1F468-200D-1F393\",\"j\":[\"man_student\",\"graduate\",\"man\",\"human\"],\"k\":[14,45],\"o\":4},\"currency_exchange\":{\"a\":\"Currency Exchange\",\"b\":\"1F4B1\",\"j\":[\"currency_exchange\",\"money\",\"sales\",\"dollar\",\"travel\"],\"k\":[26,8],\"o\":0},\"blue_book\":{\"a\":\"Blue Book\",\"b\":\"1F4D8\",\"j\":[\"blue_book\",\"read\",\"library\",\"knowledge\",\"learn\",\"study\"],\"k\":[26,47],\"o\":0},\"spider_web\":{\"a\":\"Spider Web\",\"b\":\"1F578-FE0F\",\"c\":\"1F578\",\"j\":[\"spider_web\",\"animal\",\"insect\",\"arachnid\",\"silk\"],\"k\":[29,33],\"o\":0},\"crying_cat_face\":{\"a\":\"Crying Cat Face\",\"b\":\"1F63F\",\"j\":[\"crying_cat\",\"animal\",\"tears\",\"weep\",\"sad\",\"cats\",\"upset\",\"cry\"],\"k\":[31,37],\"o\":0},\"vertical_traffic_light\":{\"a\":\"Vertical Traffic Light\",\"b\":\"1F6A6\",\"j\":[\"vertical_traffic_light\",\"transportation\",\"driving\"],\"k\":[34,47],\"o\":1},\"flag-hu\":{\"a\":\"Hungary Flag\",\"b\":\"1F1ED-1F1FA\",\"j\":[\"flag_hungary\",\"hu\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,19],\"o\":2},\"cocktail\":{\"a\":\"Cocktail Glass\",\"b\":\"1F378\",\"j\":[\"cocktail_glass\",\"drink\",\"drunk\",\"alcohol\",\"beverage\",\"booze\",\"mojito\"],\"k\":[7,16],\"o\":0},\"female-student\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F393\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f393.png\",\"sheet_x\":17,\"sheet_y\":39,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F393\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f393.png\",\"sheet_x\":17,\"sheet_y\":40,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F393\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f393.png\",\"sheet_x\":17,\"sheet_y\":41,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F393\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f393.png\",\"sheet_x\":17,\"sheet_y\":42,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F393\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f393.png\",\"sheet_x\":17,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Student\",\"b\":\"1F469-200D-1F393\",\"j\":[\"woman_student\",\"graduate\",\"woman\",\"human\"],\"k\":[17,38],\"o\":4},\"heavy_dollar_sign\":{\"a\":\"Heavy Dollar Sign\",\"b\":\"1F4B2\",\"j\":[\"heavy_dollar_sign\",\"money\",\"sales\",\"payment\",\"currency\",\"buck\"],\"k\":[26,9],\"o\":0},\"orange_book\":{\"a\":\"Orange Book\",\"b\":\"1F4D9\",\"j\":[\"orange_book\",\"read\",\"library\",\"knowledge\",\"textbook\",\"study\"],\"k\":[26,48],\"o\":0},\"pouting_cat\":{\"a\":\"Pouting Cat Face\",\"b\":\"1F63E\",\"j\":[\"pouting_cat\",\"animal\",\"cats\"],\"k\":[31,36],\"o\":0},\"octagonal_sign\":{\"a\":\"Octagonal Sign\",\"b\":\"1F6D1\",\"j\":[\"stop_sign\",\"stop\"],\"k\":[36,30],\"o\":3},\"scorpion\":{\"a\":\"Scorpion\",\"b\":\"1F982\",\"j\":[\"scorpion\",\"animal\",\"arachnid\"],\"k\":[42,35],\"o\":1},\"flag-ic\":{\"a\":\"Canary Islands Flag\",\"b\":\"1F1EE-1F1E8\",\"j\":[\"flag_canary_islands\",\"canary\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,20],\"o\":2},\"tropical_drink\":{\"a\":\"Tropical Drink\",\"b\":\"1F379\",\"j\":[\"tropical_drink\",\"beverage\",\"cocktail\",\"summer\",\"beach\",\"alcohol\",\"booze\",\"mojito\"],\"k\":[7,17],\"o\":0},\"books\":{\"a\":\"Books\",\"b\":\"1F4DA\",\"j\":[\"books\",\"literature\",\"library\",\"study\"],\"k\":[26,49],\"o\":0},\"see_no_evil\":{\"a\":\"See-No-Evil Monkey\",\"b\":\"1F648\",\"j\":[\"see_no_evil_monkey\",\"monkey\",\"animal\",\"nature\",\"haha\"],\"k\":[32,39],\"o\":0},\"construction\":{\"a\":\"Construction Sign\",\"b\":\"1F6A7\",\"j\":[\"construction\",\"wip\",\"progress\",\"caution\",\"warning\"],\"k\":[34,48],\"o\":0},\"mosquito\":{\"a\":\"Mosquito\",\"b\":\"1F99F\",\"j\":[\"mosquito\",\"animal\",\"nature\",\"insect\",\"malaria\"],\"k\":[43,6],\"o\":11},\"teacher\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f3eb.png\",\"sheet_x\":46,\"sheet_y\":20,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f3eb.png\",\"sheet_x\":46,\"sheet_y\":21,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f3eb.png\",\"sheet_x\":46,\"sheet_y\":22,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f3eb.png\",\"sheet_x\":46,\"sheet_y\":23,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f3eb.png\",\"sheet_x\":46,\"sheet_y\":24,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Teacher\",\"b\":\"1F9D1-200D-1F3EB\",\"j\":[\"teacher\",\"professor\"],\"k\":[46,19],\"o\":12},\"medical_symbol\":{\"a\":\"Medical Symbol\",\"b\":\"2695-FE0F\",\"c\":\"2695\",\"j\":[\"medical_symbol\",\"health\",\"hospital\"],\"k\":[54,49],\"n\":[\"staff_of_aesculapius\"],\"o\":4},\"flag-id\":{\"a\":\"Indonesia Flag\",\"b\":\"1F1EE-1F1E9\",\"j\":[\"flag_indonesia\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,21],\"o\":2},\"beer\":{\"a\":\"Beer Mug\",\"b\":\"1F37A\",\"j\":[\"beer_mug\",\"relax\",\"beverage\",\"drink\",\"drunk\",\"party\",\"pub\",\"summer\",\"alcohol\",\"booze\"],\"k\":[7,18],\"o\":0},\"male-teacher\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f3eb.png\",\"sheet_x\":15,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f3eb.png\",\"sheet_x\":15,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f3eb.png\",\"sheet_x\":15,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f3eb.png\",\"sheet_x\":15,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f3eb.png\",\"sheet_x\":15,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Teacher\",\"b\":\"1F468-200D-1F3EB\",\"j\":[\"man_teacher\",\"instructor\",\"professor\",\"man\",\"human\"],\"k\":[15,5],\"o\":4},\"notebook\":{\"a\":\"Notebook\",\"b\":\"1F4D3\",\"j\":[\"notebook\",\"stationery\",\"record\",\"notes\",\"paper\",\"study\"],\"k\":[26,42],\"o\":0},\"hear_no_evil\":{\"a\":\"Hear-No-Evil Monkey\",\"b\":\"1F649\",\"j\":[\"hear_no_evil_monkey\",\"animal\",\"monkey\",\"nature\"],\"k\":[32,40],\"o\":0},\"fly\":{\"a\":\"Fly\",\"b\":\"1FAB0\",\"j\":[\"fly\",\"insect\"],\"k\":[52,57],\"o\":13},\"recycle\":{\"a\":\"Black Universal Recycling Symbol\",\"b\":\"267B-FE0F\",\"c\":\"267B\",\"j\":[\"recycling_symbol\",\"arrow\",\"environment\",\"garbage\",\"trash\"],\"k\":[54,43],\"o\":0},\"anchor\":{\"a\":\"Anchor\",\"b\":\"2693\",\"j\":[\"anchor\",\"ship\",\"ferry\",\"sea\",\"boat\"],\"k\":[54,47],\"o\":0},\"flag-ie\":{\"a\":\"Ireland Flag\",\"b\":\"1F1EE-1F1EA\",\"j\":[\"flag_ireland\",\"ie\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,22],\"o\":2},\"beers\":{\"a\":\"Clinking Beer Mugs\",\"b\":\"1F37B\",\"j\":[\"clinking_beer_mugs\",\"relax\",\"beverage\",\"drink\",\"drunk\",\"party\",\"pub\",\"summer\",\"alcohol\",\"booze\"],\"k\":[7,19],\"o\":0},\"female-teacher\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f3eb.png\",\"sheet_x\":17,\"sheet_y\":57,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f3eb.png\",\"sheet_x\":18,\"sheet_y\":0,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f3eb.png\",\"sheet_x\":18,\"sheet_y\":1,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f3eb.png\",\"sheet_x\":18,\"sheet_y\":2,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F3EB\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f3eb.png\",\"sheet_x\":18,\"sheet_y\":3,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Teacher\",\"b\":\"1F469-200D-1F3EB\",\"j\":[\"woman_teacher\",\"instructor\",\"professor\",\"woman\",\"human\"],\"k\":[17,56],\"o\":4},\"ledger\":{\"a\":\"Ledger\",\"b\":\"1F4D2\",\"j\":[\"ledger\",\"notes\",\"paper\"],\"k\":[26,41],\"o\":0},\"speak_no_evil\":{\"a\":\"Speak-No-Evil Monkey\",\"b\":\"1F64A\",\"j\":[\"speak_no_evil_monkey\",\"monkey\",\"animal\",\"nature\",\"omg\"],\"k\":[32,41],\"o\":0},\"worm\":{\"a\":\"Worm\",\"b\":\"1FAB1\",\"j\":[\"worm\",\"animal\"],\"k\":[53,0],\"o\":13},\"fleur_de_lis\":{\"a\":\"Fleur-De-Lis\",\"b\":\"269C-FE0F\",\"c\":\"269C\",\"j\":[\"fleur_de_lis\",\"decorative\",\"scout\"],\"k\":[54,54],\"o\":1},\"boat\":{\"a\":\"Sailboat\",\"b\":\"26F5\",\"j\":[\"sailboat\",\"ship\",\"summer\",\"transportation\",\"water\",\"sailing\"],\"k\":[55,21],\"n\":[\"sailboat\"],\"o\":0},\"flag-il\":{\"a\":\"Israel Flag\",\"b\":\"1F1EE-1F1F1\",\"j\":[\"flag_israel\",\"il\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,23],\"o\":2},\"kiss\":{\"a\":\"Kiss Mark\",\"b\":\"1F48B\",\"j\":[\"kiss_mark\",\"face\",\"lips\",\"love\",\"like\",\"affection\",\"valentines\"],\"k\":[25,23],\"o\":0},\"page_with_curl\":{\"a\":\"Page with Curl\",\"b\":\"1F4C3\",\"j\":[\"page_with_curl\",\"documents\",\"office\",\"paper\"],\"k\":[26,26],\"o\":0},\"trident\":{\"a\":\"Trident Emblem\",\"b\":\"1F531\",\"j\":[\"trident_emblem\",\"weapon\",\"spear\"],\"k\":[28,19],\"o\":0},\"canoe\":{\"a\":\"Canoe\",\"b\":\"1F6F6\",\"j\":[\"canoe\",\"boat\",\"paddle\",\"water\",\"ship\"],\"k\":[36,48],\"o\":3},\"clinking_glasses\":{\"a\":\"Clinking Glasses\",\"b\":\"1F942\",\"j\":[\"clinking_glasses\",\"beverage\",\"drink\",\"party\",\"alcohol\",\"celebrate\",\"cheers\",\"wine\",\"champagne\",\"toast\"],\"k\":[41,26],\"o\":3},\"microbe\":{\"a\":\"Microbe\",\"b\":\"1F9A0\",\"j\":[\"microbe\",\"amoeba\",\"bacteria\",\"germs\"],\"k\":[43,7],\"o\":11},\"judge\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-2696-FE0F\",\"non_qualified\":\"1F9D1-1F3FB-200D-2696\",\"image\":\"1f9d1-1f3fb-200d-2696-fe0f.png\",\"sheet_x\":48,\"sheet_y\":26,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-2696-FE0F\",\"non_qualified\":\"1F9D1-1F3FC-200D-2696\",\"image\":\"1f9d1-1f3fc-200d-2696-fe0f.png\",\"sheet_x\":48,\"sheet_y\":27,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-2696-FE0F\",\"non_qualified\":\"1F9D1-1F3FD-200D-2696\",\"image\":\"1f9d1-1f3fd-200d-2696-fe0f.png\",\"sheet_x\":48,\"sheet_y\":28,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-2696-FE0F\",\"non_qualified\":\"1F9D1-1F3FE-200D-2696\",\"image\":\"1f9d1-1f3fe-200d-2696-fe0f.png\",\"sheet_x\":48,\"sheet_y\":29,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-2696-FE0F\",\"non_qualified\":\"1F9D1-1F3FF-200D-2696\",\"image\":\"1f9d1-1f3ff-200d-2696-fe0f.png\",\"sheet_x\":48,\"sheet_y\":30,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Judge\",\"b\":\"1F9D1-200D-2696-FE0F\",\"c\":\"1F9D1-200D-2696\",\"j\":[\"judge\",\"law\"],\"k\":[48,25],\"o\":12},\"flag-im\":{\"a\":\"Isle of Man Flag\",\"b\":\"1F1EE-1F1F2\",\"j\":[\"flag_isle_of_man\",\"isle\",\"man\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,24],\"o\":2},\"male-judge\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-2696-FE0F\",\"non_qualified\":\"1F468-1F3FB-200D-2696\",\"image\":\"1f468-1f3fb-200d-2696-fe0f.png\",\"sheet_x\":17,\"sheet_y\":1,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-2696-FE0F\",\"non_qualified\":\"1F468-1F3FC-200D-2696\",\"image\":\"1f468-1f3fc-200d-2696-fe0f.png\",\"sheet_x\":17,\"sheet_y\":2,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-2696-FE0F\",\"non_qualified\":\"1F468-1F3FD-200D-2696\",\"image\":\"1f468-1f3fd-200d-2696-fe0f.png\",\"sheet_x\":17,\"sheet_y\":3,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-2696-FE0F\",\"non_qualified\":\"1F468-1F3FE-200D-2696\",\"image\":\"1f468-1f3fe-200d-2696-fe0f.png\",\"sheet_x\":17,\"sheet_y\":4,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-2696-FE0F\",\"non_qualified\":\"1F468-1F3FF-200D-2696\",\"image\":\"1f468-1f3ff-200d-2696-fe0f.png\",\"sheet_x\":17,\"sheet_y\":5,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Judge\",\"b\":\"1F468-200D-2696-FE0F\",\"c\":\"1F468-200D-2696\",\"j\":[\"man_judge\",\"justice\",\"court\",\"man\",\"human\"],\"k\":[17,0],\"o\":4},\"love_letter\":{\"a\":\"Love Letter\",\"b\":\"1F48C\",\"j\":[\"love_letter\",\"email\",\"like\",\"affection\",\"envelope\",\"valentines\"],\"k\":[25,24],\"o\":0},\"bouquet\":{\"a\":\"Bouquet\",\"b\":\"1F490\",\"j\":[\"bouquet\",\"flowers\",\"nature\",\"spring\"],\"k\":[25,28],\"o\":0},\"name_badge\":{\"a\":\"Name Badge\",\"b\":\"1F4DB\",\"j\":[\"name_badge\",\"fire\",\"forbid\"],\"k\":[26,50],\"o\":0},\"scroll\":{\"a\":\"Scroll\",\"b\":\"1F4DC\",\"j\":[\"scroll\",\"documents\",\"ancient\",\"history\",\"paper\"],\"k\":[26,51],\"o\":0},\"speedboat\":{\"a\":\"Speedboat\",\"b\":\"1F6A4\",\"j\":[\"speedboat\",\"ship\",\"transportation\",\"vehicle\",\"summer\"],\"k\":[34,45],\"o\":0},\"tumbler_glass\":{\"a\":\"Tumbler Glass\",\"b\":\"1F943\",\"j\":[\"tumbler_glass\",\"drink\",\"beverage\",\"drunk\",\"alcohol\",\"liquor\",\"booze\",\"bourbon\",\"scotch\",\"whisky\",\"glass\",\"shot\"],\"k\":[41,27],\"o\":3},\"flag-in\":{\"a\":\"India Flag\",\"b\":\"1F1EE-1F1F3\",\"j\":[\"flag_india\",\"in\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,25],\"o\":2},\"cherry_blossom\":{\"a\":\"Cherry Blossom\",\"b\":\"1F338\",\"j\":[\"cherry_blossom\",\"nature\",\"plant\",\"spring\",\"flower\"],\"k\":[6,10],\"o\":0},\"female-judge\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-2696-FE0F\",\"non_qualified\":\"1F469-1F3FB-200D-2696\",\"image\":\"1f469-1f3fb-200d-2696-fe0f.png\",\"sheet_x\":19,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-2696-FE0F\",\"non_qualified\":\"1F469-1F3FC-200D-2696\",\"image\":\"1f469-1f3fc-200d-2696-fe0f.png\",\"sheet_x\":19,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-2696-FE0F\",\"non_qualified\":\"1F469-1F3FD-200D-2696\",\"image\":\"1f469-1f3fd-200d-2696-fe0f.png\",\"sheet_x\":19,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-2696-FE0F\",\"non_qualified\":\"1F469-1F3FE-200D-2696\",\"image\":\"1f469-1f3fe-200d-2696-fe0f.png\",\"sheet_x\":19,\"sheet_y\":50,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-2696-FE0F\",\"non_qualified\":\"1F469-1F3FF-200D-2696\",\"image\":\"1f469-1f3ff-200d-2696-fe0f.png\",\"sheet_x\":19,\"sheet_y\":51,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Judge\",\"b\":\"1F469-200D-2696-FE0F\",\"c\":\"1F469-200D-2696\",\"j\":[\"woman_judge\",\"justice\",\"court\",\"woman\",\"human\"],\"k\":[19,46],\"o\":4},\"cupid\":{\"a\":\"Heart with Arrow\",\"b\":\"1F498\",\"j\":[\"heart_with_arrow\",\"love\",\"like\",\"heart\",\"affection\",\"valentines\"],\"k\":[25,36],\"o\":0},\"page_facing_up\":{\"a\":\"Page Facing Up\",\"b\":\"1F4C4\",\"j\":[\"page_facing_up\",\"documents\",\"office\",\"paper\",\"information\"],\"k\":[26,27],\"o\":0},\"beginner\":{\"a\":\"Japanese Symbol for Beginner\",\"b\":\"1F530\",\"j\":[\"japanese_symbol_for_beginner\",\"badge\",\"shield\"],\"k\":[28,18],\"o\":0},\"passenger_ship\":{\"a\":\"Passenger Ship\",\"b\":\"1F6F3-FE0F\",\"c\":\"1F6F3\",\"j\":[\"passenger_ship\",\"yacht\",\"cruise\",\"ferry\"],\"k\":[36,45],\"o\":0},\"cup_with_straw\":{\"a\":\"Cup with Straw\",\"b\":\"1F964\",\"j\":[\"cup_with_straw\",\"drink\",\"soda\"],\"k\":[42,1],\"o\":5},\"flag-io\":{\"a\":\"British Indian Ocean Territory Flag\",\"b\":\"1F1EE-1F1F4\",\"j\":[\"flag_british_indian_ocean_territory\",\"british\",\"indian\",\"ocean\",\"territory\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,26],\"o\":2},\"gift_heart\":{\"a\":\"Heart with Ribbon\",\"b\":\"1F49D\",\"j\":[\"heart_with_ribbon\",\"love\",\"valentines\"],\"k\":[25,41],\"o\":0},\"white_flower\":{\"a\":\"White Flower\",\"b\":\"1F4AE\",\"j\":[\"white_flower\",\"japanese\",\"spring\"],\"k\":[26,5],\"o\":0},\"newspaper\":{\"a\":\"Newspaper\",\"b\":\"1F4F0\",\"j\":[\"newspaper\",\"press\",\"headline\"],\"k\":[27,13],\"o\":0},\"bubble_tea\":{\"a\":\"Bubble Tea\",\"b\":\"1F9CB\",\"j\":[\"bubble tea\",\"taiwan\",\"boba\",\"milk tea\",\"straw\"],\"k\":[44,37],\"o\":13},\"farmer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f33e.png\",\"sheet_x\":45,\"sheet_y\":36,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f33e.png\",\"sheet_x\":45,\"sheet_y\":37,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f33e.png\",\"sheet_x\":45,\"sheet_y\":38,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f33e.png\",\"sheet_x\":45,\"sheet_y\":39,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f33e.png\",\"sheet_x\":45,\"sheet_y\":40,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Farmer\",\"b\":\"1F9D1-200D-1F33E\",\"j\":[\"farmer\",\"crops\"],\"k\":[45,35],\"o\":12},\"ferry\":{\"a\":\"Ferry\",\"b\":\"26F4-FE0F\",\"c\":\"26F4\",\"j\":[\"ferry\",\"boat\",\"ship\",\"yacht\"],\"k\":[55,20],\"o\":0},\"o\":{\"a\":\"Heavy Large Circle\",\"b\":\"2B55\",\"j\":[\"hollow_red_circle\",\"circle\",\"round\"],\"k\":[56,47],\"o\":0},\"flag-iq\":{\"a\":\"Iraq Flag\",\"b\":\"1F1EE-1F1F6\",\"j\":[\"flag_iraq\",\"iq\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,27],\"o\":2},\"rosette\":{\"a\":\"Rosette\",\"b\":\"1F3F5-FE0F\",\"c\":\"1F3F5\",\"j\":[\"rosette\",\"flower\",\"decoration\",\"military\"],\"k\":[11,8],\"o\":0},\"male-farmer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f33e.png\",\"sheet_x\":14,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f33e.png\",\"sheet_x\":14,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f33e.png\",\"sheet_x\":14,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f33e.png\",\"sheet_x\":14,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f33e.png\",\"sheet_x\":14,\"sheet_y\":32,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Farmer\",\"b\":\"1F468-200D-1F33E\",\"j\":[\"man_farmer\",\"rancher\",\"gardener\",\"man\",\"human\"],\"k\":[14,27],\"o\":4},\"sparkling_heart\":{\"a\":\"Sparkling Heart\",\"b\":\"1F496\",\"j\":[\"sparkling_heart\",\"love\",\"like\",\"affection\",\"valentines\"],\"k\":[25,34],\"o\":0},\"rolled_up_newspaper\":{\"a\":\"Rolled-Up Newspaper\",\"b\":\"1F5DE-FE0F\",\"c\":\"1F5DE\",\"j\":[\"rolled_up_newspaper\",\"press\",\"headline\"],\"k\":[30,20],\"o\":0},\"motor_boat\":{\"a\":\"Motor Boat\",\"b\":\"1F6E5-FE0F\",\"c\":\"1F6E5\",\"j\":[\"motor_boat\",\"ship\"],\"k\":[36,40],\"o\":0},\"beverage_box\":{\"a\":\"Beverage Box\",\"b\":\"1F9C3\",\"j\":[\"beverage_box\",\"drink\"],\"k\":[44,29],\"o\":12},\"white_check_mark\":{\"a\":\"White Heavy Check Mark\",\"b\":\"2705\",\"j\":[\"check_mark_button\",\"green-square\",\"ok\",\"agree\",\"vote\",\"election\",\"answer\",\"tick\"],\"k\":[55,45],\"o\":0},\"flag-ir\":{\"a\":\"Iran Flag\",\"b\":\"1F1EE-1F1F7\",\"j\":[\"flag_iran\",\"iran\",\"islamic\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,28],\"o\":2},\"rose\":{\"a\":\"Rose\",\"b\":\"1F339\",\"j\":[\"rose\",\"flowers\",\"valentines\",\"love\",\"spring\"],\"k\":[6,11],\"o\":0},\"female-farmer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f33e.png\",\"sheet_x\":17,\"sheet_y\":21,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f33e.png\",\"sheet_x\":17,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f33e.png\",\"sheet_x\":17,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f33e.png\",\"sheet_x\":17,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F33E\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f33e.png\",\"sheet_x\":17,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Farmer\",\"b\":\"1F469-200D-1F33E\",\"j\":[\"woman_farmer\",\"rancher\",\"gardener\",\"woman\",\"human\"],\"k\":[17,20],\"o\":4},\"heartpulse\":{\"a\":\"Growing Heart\",\"b\":\"1F497\",\"j\":[\"growing_heart\",\"like\",\"love\",\"affection\",\"valentines\",\"pink\"],\"k\":[25,35],\"o\":0},\"bookmark_tabs\":{\"a\":\"Bookmark Tabs\",\"b\":\"1F4D1\",\"j\":[\"bookmark_tabs\",\"favorite\",\"save\",\"order\",\"tidy\"],\"k\":[26,40],\"o\":0},\"ship\":{\"a\":\"Ship\",\"b\":\"1F6A2\",\"j\":[\"ship\",\"transportation\",\"titanic\",\"deploy\"],\"k\":[34,26],\"o\":0},\"mate_drink\":{\"a\":\"Mate Drink\",\"b\":\"1F9C9\",\"j\":[\"mate\",\"drink\",\"tea\",\"beverage\"],\"k\":[44,35],\"o\":12},\"ballot_box_with_check\":{\"a\":\"Ballot Box with Check\",\"b\":\"2611-FE0F\",\"c\":\"2611\",\"j\":[\"check_box_with_check\",\"ok\",\"agree\",\"confirm\",\"black-square\",\"vote\",\"election\",\"yes\",\"tick\"],\"k\":[54,3],\"o\":0},\"flag-is\":{\"a\":\"Iceland Flag\",\"b\":\"1F1EE-1F1F8\",\"j\":[\"flag_iceland\",\"is\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,29],\"o\":2},\"heartbeat\":{\"a\":\"Beating Heart\",\"b\":\"1F493\",\"j\":[\"beating_heart\",\"love\",\"like\",\"affection\",\"valentines\",\"pink\",\"heart\"],\"k\":[25,31],\"o\":0},\"bookmark\":{\"a\":\"Bookmark\",\"b\":\"1F516\",\"j\":[\"bookmark\",\"favorite\",\"label\",\"save\"],\"k\":[27,50],\"o\":0},\"wilted_flower\":{\"a\":\"Wilted Flower\",\"b\":\"1F940\",\"j\":[\"wilted_flower\",\"plant\",\"nature\",\"flower\"],\"k\":[41,24],\"o\":3},\"ice_cube\":{\"a\":\"Ice Cube\",\"b\":\"1F9CA\",\"j\":[\"ice\",\"water\",\"cold\"],\"k\":[44,36],\"o\":12},\"cook\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F373\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f373.png\",\"sheet_x\":45,\"sheet_y\":42,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F373\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f373.png\",\"sheet_x\":45,\"sheet_y\":43,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F373\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f373.png\",\"sheet_x\":45,\"sheet_y\":44,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F373\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f373.png\",\"sheet_x\":45,\"sheet_y\":45,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F373\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f373.png\",\"sheet_x\":45,\"sheet_y\":46,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Cook\",\"b\":\"1F9D1-200D-1F373\",\"j\":[\"cook\",\"food\",\"kitchen\",\"culinary\"],\"k\":[45,41],\"o\":12},\"airplane\":{\"a\":\"Airplane\",\"b\":\"2708-FE0F\",\"c\":\"2708\",\"j\":[\"airplane\",\"vehicle\",\"transportation\",\"flight\",\"fly\"],\"k\":[55,46],\"o\":0},\"heavy_check_mark\":{\"a\":\"Heavy Check Mark\",\"b\":\"2714-FE0F\",\"c\":\"2714\",\"j\":[\"check_mark\",\"ok\",\"nike\",\"answer\",\"yes\",\"tick\"],\"k\":[56,16],\"o\":0},\"it\":{\"a\":\"Italy Flag\",\"b\":\"1F1EE-1F1F9\",\"j\":[\"flag_italy\",\"italy\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,30],\"n\":[\"flag-it\"],\"o\":0},\"hibiscus\":{\"a\":\"Hibiscus\",\"b\":\"1F33A\",\"j\":[\"hibiscus\",\"plant\",\"vegetable\",\"flowers\",\"beach\"],\"k\":[6,12],\"o\":0},\"label\":{\"a\":\"Label\",\"b\":\"1F3F7-FE0F\",\"c\":\"1F3F7\",\"j\":[\"label\",\"sale\",\"tag\"],\"k\":[11,9],\"o\":0},\"male-cook\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F373\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f373.png\",\"sheet_x\":14,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F373\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f373.png\",\"sheet_x\":14,\"sheet_y\":35,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F373\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f373.png\",\"sheet_x\":14,\"sheet_y\":36,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F373\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f373.png\",\"sheet_x\":14,\"sheet_y\":37,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F373\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f373.png\",\"sheet_x\":14,\"sheet_y\":38,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Cook\",\"b\":\"1F468-200D-1F373\",\"j\":[\"man_cook\",\"chef\",\"man\",\"human\"],\"k\":[14,33],\"o\":4},\"revolving_hearts\":{\"a\":\"Revolving Hearts\",\"b\":\"1F49E\",\"j\":[\"revolving_hearts\",\"love\",\"like\",\"affection\",\"valentines\"],\"k\":[25,42],\"o\":0},\"small_airplane\":{\"a\":\"Small Airplane\",\"b\":\"1F6E9-FE0F\",\"c\":\"1F6E9\",\"j\":[\"small_airplane\",\"flight\",\"transportation\",\"fly\",\"vehicle\"],\"k\":[36,41],\"o\":0},\"chopsticks\":{\"a\":\"Chopsticks\",\"b\":\"1F962\",\"j\":[\"chopsticks\",\"food\"],\"k\":[41,57],\"o\":5},\"x\":{\"a\":\"Cross Mark\",\"b\":\"274C\",\"j\":[\"cross_mark\",\"no\",\"delete\",\"remove\",\"cancel\",\"red\"],\"k\":[56,25],\"o\":0},\"flag-je\":{\"a\":\"Jersey Flag\",\"b\":\"1F1EF-1F1EA\",\"j\":[\"flag_jersey\",\"je\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,31],\"o\":2},\"sunflower\":{\"a\":\"Sunflower\",\"b\":\"1F33B\",\"j\":[\"sunflower\",\"nature\",\"plant\",\"fall\"],\"k\":[6,13],\"o\":0},\"knife_fork_plate\":{\"a\":\"Fork and Knife with Plate\",\"b\":\"1F37D-FE0F\",\"c\":\"1F37D\",\"j\":[\"fork_and_knife_with_plate\",\"food\",\"eat\",\"meal\",\"lunch\",\"dinner\",\"restaurant\"],\"k\":[7,21],\"o\":0},\"female-cook\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F373\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f373.png\",\"sheet_x\":17,\"sheet_y\":27,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F373\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f373.png\",\"sheet_x\":17,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F373\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f373.png\",\"sheet_x\":17,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F373\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f373.png\",\"sheet_x\":17,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F373\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f373.png\",\"sheet_x\":17,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Cook\",\"b\":\"1F469-200D-1F373\",\"j\":[\"woman_cook\",\"chef\",\"woman\",\"human\"],\"k\":[17,26],\"o\":4},\"two_hearts\":{\"a\":\"Two Hearts\",\"b\":\"1F495\",\"j\":[\"two_hearts\",\"love\",\"like\",\"affection\",\"valentines\",\"heart\"],\"k\":[25,33],\"o\":0},\"moneybag\":{\"a\":\"Money Bag\",\"b\":\"1F4B0\",\"j\":[\"money_bag\",\"dollar\",\"payment\",\"coins\",\"sale\"],\"k\":[26,7],\"o\":0},\"airplane_departure\":{\"a\":\"Airplane Departure\",\"b\":\"1F6EB\",\"j\":[\"airplane_departure\",\"airport\",\"flight\",\"landing\"],\"k\":[36,42],\"o\":1},\"negative_squared_cross_mark\":{\"a\":\"Negative Squared Cross Mark\",\"b\":\"274E\",\"j\":[\"cross_mark_button\",\"x\",\"green-square\",\"no\",\"deny\"],\"k\":[56,26],\"o\":0},\"flag-jm\":{\"a\":\"Jamaica Flag\",\"b\":\"1F1EF-1F1F2\",\"j\":[\"flag_jamaica\",\"jm\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,32],\"o\":2},\"blossom\":{\"a\":\"Blossom\",\"b\":\"1F33C\",\"j\":[\"blossom\",\"nature\",\"flowers\",\"yellow\"],\"k\":[6,14],\"o\":0},\"fork_and_knife\":{\"a\":\"Fork and Knife\",\"b\":\"1F374\",\"j\":[\"fork_and_knife\",\"cutlery\",\"kitchen\"],\"k\":[7,12],\"o\":0},\"heart_decoration\":{\"a\":\"Heart Decoration\",\"b\":\"1F49F\",\"j\":[\"heart_decoration\",\"purple-square\",\"love\",\"like\"],\"k\":[25,43],\"o\":0},\"airplane_arriving\":{\"a\":\"Airplane Arriving\",\"b\":\"1F6EC\",\"j\":[\"airplane_arrival\",\"airport\",\"flight\",\"boarding\"],\"k\":[36,43],\"o\":1},\"mechanic\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F527\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f527.png\",\"sheet_x\":46,\"sheet_y\":44,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F527\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f527.png\",\"sheet_x\":46,\"sheet_y\":45,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F527\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f527.png\",\"sheet_x\":46,\"sheet_y\":46,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F527\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f527.png\",\"sheet_x\":46,\"sheet_y\":47,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F527\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f527.png\",\"sheet_x\":46,\"sheet_y\":48,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Mechanic\",\"b\":\"1F9D1-200D-1F527\",\"j\":[\"mechanic\",\"worker\",\"technician\"],\"k\":[46,43],\"o\":12},\"coin\":{\"a\":\"Coin\",\"b\":\"1FA99\",\"j\":[\"coin\",\"money\",\"currency\"],\"k\":[52,41],\"o\":13},\"curly_loop\":{\"a\":\"Curly Loop\",\"b\":\"27B0\",\"j\":[\"curly_loop\",\"scribble\",\"draw\",\"shape\",\"squiggle\"],\"k\":[56,37],\"o\":0},\"flag-jo\":{\"a\":\"Jordan Flag\",\"b\":\"1F1EF-1F1F4\",\"j\":[\"flag_jordan\",\"jo\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,33],\"o\":2},\"tulip\":{\"a\":\"Tulip\",\"b\":\"1F337\",\"j\":[\"tulip\",\"flowers\",\"plant\",\"nature\",\"summer\",\"spring\"],\"k\":[6,9],\"o\":0},\"male-mechanic\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F527\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f527.png\",\"sheet_x\":15,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F527\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f527.png\",\"sheet_x\":15,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F527\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f527.png\",\"sheet_x\":15,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F527\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f527.png\",\"sheet_x\":15,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F527\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f527.png\",\"sheet_x\":15,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Mechanic\",\"b\":\"1F468-200D-1F527\",\"j\":[\"man_mechanic\",\"plumber\",\"man\",\"human\",\"wrench\"],\"k\":[15,44],\"o\":4},\"yen\":{\"a\":\"Banknote with Yen Sign\",\"b\":\"1F4B4\",\"j\":[\"yen_banknote\",\"money\",\"sales\",\"japanese\",\"dollar\",\"currency\"],\"k\":[26,11],\"o\":0},\"spoon\":{\"a\":\"Spoon\",\"b\":\"1F944\",\"j\":[\"spoon\",\"cutlery\",\"kitchen\",\"tableware\"],\"k\":[41,28],\"o\":3},\"parachute\":{\"a\":\"Parachute\",\"b\":\"1FA82\",\"j\":[\"parachute\",\"fly\",\"glide\"],\"k\":[52,27],\"o\":12},\"heavy_heart_exclamation_mark_ornament\":{\"a\":\"Heart Exclamation\",\"b\":\"2763-FE0F\",\"c\":\"2763\",\"j\":[\"heart_exclamation\",\"decoration\",\"love\"],\"k\":[56,31],\"o\":1},\"loop\":{\"a\":\"Double Curly Loop\",\"b\":\"27BF\",\"j\":[\"double_curly_loop\",\"tape\",\"cassette\"],\"k\":[56,38],\"o\":1},\"jp\":{\"a\":\"Japan Flag\",\"b\":\"1F1EF-1F1F5\",\"j\":[\"flag_japan\",\"japanese\",\"nation\",\"flag\",\"country\",\"banner\"],\"k\":[2,34],\"n\":[\"flag-jp\"],\"o\":0},\"seedling\":{\"a\":\"Seedling\",\"b\":\"1F331\",\"j\":[\"seedling\",\"plant\",\"nature\",\"grass\",\"lawn\",\"spring\"],\"k\":[6,3],\"o\":0},\"female-mechanic\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F527\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f527.png\",\"sheet_x\":18,\"sheet_y\":33,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F527\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f527.png\",\"sheet_x\":18,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F527\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f527.png\",\"sheet_x\":18,\"sheet_y\":35,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F527\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f527.png\",\"sheet_x\":18,\"sheet_y\":36,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F527\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f527.png\",\"sheet_x\":18,\"sheet_y\":37,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Mechanic\",\"b\":\"1F469-200D-1F527\",\"j\":[\"woman_mechanic\",\"plumber\",\"woman\",\"human\",\"wrench\"],\"k\":[18,32],\"o\":4},\"broken_heart\":{\"a\":\"Broken Heart\",\"b\":\"1F494\",\"j\":[\"broken_heart\",\"sad\",\"sorry\",\"break\",\"heart\",\"heartbreak\"],\"k\":[25,32],\"l\":[\"</3\"],\"m\":\"</3\",\"o\":0},\"dollar\":{\"a\":\"Banknote with Dollar Sign\",\"b\":\"1F4B5\",\"j\":[\"dollar_banknote\",\"money\",\"sales\",\"bill\",\"currency\"],\"k\":[26,12],\"o\":0},\"seat\":{\"a\":\"Seat\",\"b\":\"1F4BA\",\"j\":[\"seat\",\"sit\",\"airplane\",\"transport\",\"bus\",\"flight\",\"fly\"],\"k\":[26,17],\"o\":0},\"hocho\":{\"a\":\"Hocho\",\"b\":\"1F52A\",\"j\":[\"kitchen_knife\",\"knife\",\"blade\",\"cutlery\",\"kitchen\",\"weapon\"],\"k\":[28,12],\"n\":[\"knife\"],\"o\":0},\"part_alternation_mark\":{\"a\":\"Part Alternation Mark\",\"b\":\"303D-FE0F\",\"c\":\"303D\",\"j\":[\"part_alternation_mark\",\"graph\",\"presentation\",\"stats\",\"business\",\"economics\",\"bad\"],\"k\":[56,49],\"o\":0},\"flag-ke\":{\"a\":\"Kenya Flag\",\"b\":\"1F1F0-1F1EA\",\"j\":[\"flag_kenya\",\"ke\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,35],\"o\":2},\"amphora\":{\"a\":\"Amphora\",\"b\":\"1F3FA\",\"j\":[\"amphora\",\"vase\",\"jar\"],\"k\":[11,12],\"o\":1},\"euro\":{\"a\":\"Banknote with Euro Sign\",\"b\":\"1F4B6\",\"j\":[\"euro_banknote\",\"money\",\"sales\",\"dollar\",\"currency\"],\"k\":[26,13],\"o\":1},\"helicopter\":{\"a\":\"Helicopter\",\"b\":\"1F681\",\"j\":[\"helicopter\",\"transportation\",\"vehicle\",\"fly\"],\"k\":[33,51],\"o\":1},\"factory_worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f3ed.png\",\"sheet_x\":46,\"sheet_y\":26,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f3ed.png\",\"sheet_x\":46,\"sheet_y\":27,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f3ed.png\",\"sheet_x\":46,\"sheet_y\":28,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f3ed.png\",\"sheet_x\":46,\"sheet_y\":29,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f3ed.png\",\"sheet_x\":46,\"sheet_y\":30,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Factory Worker\",\"b\":\"1F9D1-200D-1F3ED\",\"j\":[\"factory_worker\",\"labor\"],\"k\":[46,25],\"o\":12},\"potted_plant\":{\"a\":\"Potted Plant\",\"b\":\"1FAB4\",\"j\":[\"potted plant\",\"greenery\",\"house\"],\"k\":[53,3],\"o\":13},\"eight_spoked_asterisk\":{\"a\":\"Eight Spoked Asterisk\",\"b\":\"2733-FE0F\",\"c\":\"2733\",\"j\":[\"eight_spoked_asterisk\",\"star\",\"sparkle\",\"green-square\"],\"k\":[56,21],\"o\":0},\"heart\":{\"a\":\"Heavy Black Heart\",\"b\":\"2764-FE0F\",\"c\":\"2764\",\"j\":[\"red_heart\",\"love\",\"like\",\"valentines\"],\"k\":[56,32],\"l\":[\"<3\"],\"m\":\"<3\",\"o\":0},\"flag-kg\":{\"a\":\"Kyrgyzstan Flag\",\"b\":\"1F1F0-1F1EC\",\"j\":[\"flag_kyrgyzstan\",\"kg\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,36],\"o\":2},\"evergreen_tree\":{\"a\":\"Evergreen Tree\",\"b\":\"1F332\",\"j\":[\"evergreen_tree\",\"plant\",\"nature\"],\"k\":[6,4],\"o\":1},\"male-factory-worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f3ed.png\",\"sheet_x\":15,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f3ed.png\",\"sheet_x\":15,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f3ed.png\",\"sheet_x\":15,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f3ed.png\",\"sheet_x\":15,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f3ed.png\",\"sheet_x\":15,\"sheet_y\":16,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Factory Worker\",\"b\":\"1F468-200D-1F3ED\",\"j\":[\"man_factory_worker\",\"assembly\",\"industrial\",\"man\",\"human\"],\"k\":[15,11],\"o\":4},\"pound\":{\"a\":\"Banknote with Pound Sign\",\"b\":\"1F4B7\",\"j\":[\"pound_banknote\",\"british\",\"sterling\",\"money\",\"sales\",\"bills\",\"uk\",\"england\",\"currency\"],\"k\":[26,14],\"o\":1},\"suspension_railway\":{\"a\":\"Suspension Railway\",\"b\":\"1F69F\",\"j\":[\"suspension_railway\",\"vehicle\",\"transportation\"],\"k\":[34,23],\"o\":1},\"orange_heart\":{\"a\":\"Orange Heart\",\"b\":\"1F9E1\",\"j\":[\"orange_heart\",\"love\",\"like\",\"affection\",\"valentines\"],\"k\":[51,44],\"o\":5},\"eight_pointed_black_star\":{\"a\":\"Eight Pointed Black Star\",\"b\":\"2734-FE0F\",\"c\":\"2734\",\"j\":[\"eight_pointed_star\",\"orange-square\",\"shape\",\"polygon\"],\"k\":[56,22],\"o\":0},\"flag-kh\":{\"a\":\"Cambodia Flag\",\"b\":\"1F1F0-1F1ED\",\"j\":[\"flag_cambodia\",\"kh\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,37],\"o\":2},\"deciduous_tree\":{\"a\":\"Deciduous Tree\",\"b\":\"1F333\",\"j\":[\"deciduous_tree\",\"plant\",\"nature\"],\"k\":[6,5],\"o\":1},\"female-factory-worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f3ed.png\",\"sheet_x\":18,\"sheet_y\":5,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f3ed.png\",\"sheet_x\":18,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f3ed.png\",\"sheet_x\":18,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f3ed.png\",\"sheet_x\":18,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F3ED\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f3ed.png\",\"sheet_x\":18,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Factory Worker\",\"b\":\"1F469-200D-1F3ED\",\"j\":[\"woman_factory_worker\",\"assembly\",\"industrial\",\"woman\",\"human\"],\"k\":[18,4],\"o\":4},\"yellow_heart\":{\"a\":\"Yellow Heart\",\"b\":\"1F49B\",\"j\":[\"yellow_heart\",\"love\",\"like\",\"affection\",\"valentines\"],\"k\":[25,39],\"m\":\"<3\",\"o\":0},\"money_with_wings\":{\"a\":\"Money with Wings\",\"b\":\"1F4B8\",\"j\":[\"money_with_wings\",\"dollar\",\"bills\",\"payment\",\"sale\"],\"k\":[26,15],\"o\":0},\"mountain_cableway\":{\"a\":\"Mountain Cableway\",\"b\":\"1F6A0\",\"j\":[\"mountain_cableway\",\"transportation\",\"vehicle\",\"ski\"],\"k\":[34,24],\"o\":1},\"sparkle\":{\"a\":\"Sparkle\",\"b\":\"2747-FE0F\",\"c\":\"2747\",\"j\":[\"sparkle\",\"stars\",\"green-square\",\"awesome\",\"good\",\"fireworks\"],\"k\":[56,24],\"o\":0},\"copyright\":{\"a\":\"Copyright Sign\",\"b\":\"00A9-FE0F\",\"c\":\"00A9\",\"j\":[\"copyright\",\"ip\",\"license\",\"circle\",\"law\",\"legal\"],\"k\":[0,12],\"o\":0},\"flag-ki\":{\"a\":\"Kiribati Flag\",\"b\":\"1F1F0-1F1EE\",\"j\":[\"flag_kiribati\",\"ki\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,38],\"o\":2},\"palm_tree\":{\"a\":\"Palm Tree\",\"b\":\"1F334\",\"j\":[\"palm_tree\",\"plant\",\"vegetable\",\"nature\",\"summer\",\"beach\",\"mojito\",\"tropical\"],\"k\":[6,6],\"o\":0},\"green_heart\":{\"a\":\"Green Heart\",\"b\":\"1F49A\",\"j\":[\"green_heart\",\"love\",\"like\",\"affection\",\"valentines\"],\"k\":[25,38],\"m\":\"<3\",\"o\":0},\"credit_card\":{\"a\":\"Credit Card\",\"b\":\"1F4B3\",\"j\":[\"credit_card\",\"money\",\"sales\",\"dollar\",\"bill\",\"payment\",\"shopping\"],\"k\":[26,10],\"o\":0},\"aerial_tramway\":{\"a\":\"Aerial Tramway\",\"b\":\"1F6A1\",\"j\":[\"aerial_tramway\",\"transportation\",\"vehicle\",\"ski\"],\"k\":[34,25],\"o\":1},\"office_worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f4bc.png\",\"sheet_x\":46,\"sheet_y\":38,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f4bc.png\",\"sheet_x\":46,\"sheet_y\":39,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f4bc.png\",\"sheet_x\":46,\"sheet_y\":40,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f4bc.png\",\"sheet_x\":46,\"sheet_y\":41,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f4bc.png\",\"sheet_x\":46,\"sheet_y\":42,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Office Worker\",\"b\":\"1F9D1-200D-1F4BC\",\"j\":[\"office_worker\",\"business\"],\"k\":[46,37],\"o\":12},\"registered\":{\"a\":\"Registered Sign\",\"b\":\"00AE-FE0F\",\"c\":\"00AE\",\"j\":[\"registered\",\"alphabet\",\"circle\"],\"k\":[0,13],\"o\":0},\"flag-km\":{\"a\":\"Comoros Flag\",\"b\":\"1F1F0-1F1F2\",\"j\":[\"flag_comoros\",\"km\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,39],\"o\":2},\"cactus\":{\"a\":\"Cactus\",\"b\":\"1F335\",\"j\":[\"cactus\",\"vegetable\",\"plant\",\"nature\"],\"k\":[6,7],\"o\":0},\"male-office-worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f4bc.png\",\"sheet_x\":15,\"sheet_y\":39,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f4bc.png\",\"sheet_x\":15,\"sheet_y\":40,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f4bc.png\",\"sheet_x\":15,\"sheet_y\":41,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f4bc.png\",\"sheet_x\":15,\"sheet_y\":42,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f4bc.png\",\"sheet_x\":15,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Office Worker\",\"b\":\"1F468-200D-1F4BC\",\"j\":[\"man_office_worker\",\"business\",\"manager\",\"man\",\"human\"],\"k\":[15,38],\"o\":4},\"blue_heart\":{\"a\":\"Blue Heart\",\"b\":\"1F499\",\"j\":[\"blue_heart\",\"love\",\"like\",\"affection\",\"valentines\"],\"k\":[25,37],\"m\":\"<3\",\"o\":0},\"satellite\":{\"a\":\"Satellite\",\"b\":\"1F6F0-FE0F\",\"c\":\"1F6F0\",\"j\":[\"satellite\",\"communication\",\"gps\",\"orbit\",\"spaceflight\",\"NASA\",\"ISS\"],\"k\":[36,44],\"o\":0},\"receipt\":{\"a\":\"Receipt\",\"b\":\"1F9FE\",\"j\":[\"receipt\",\"accounting\",\"expenses\"],\"k\":[52,15],\"o\":11},\"flag-kn\":{\"a\":\"St. Kitts & Nevis Flag\",\"b\":\"1F1F0-1F1F3\",\"j\":[\"flag_st_kitts_nevis\",\"saint\",\"kitts\",\"nevis\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,40],\"o\":2},\"ear_of_rice\":{\"a\":\"Ear of Rice\",\"b\":\"1F33E\",\"j\":[\"sheaf_of_rice\",\"nature\",\"plant\"],\"k\":[6,16],\"o\":0},\"female-office-worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f4bc.png\",\"sheet_x\":18,\"sheet_y\":27,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f4bc.png\",\"sheet_x\":18,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f4bc.png\",\"sheet_x\":18,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f4bc.png\",\"sheet_x\":18,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F4BC\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f4bc.png\",\"sheet_x\":18,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Office Worker\",\"b\":\"1F469-200D-1F4BC\",\"j\":[\"woman_office_worker\",\"business\",\"manager\",\"woman\",\"human\"],\"k\":[18,26],\"o\":4},\"purple_heart\":{\"a\":\"Purple Heart\",\"b\":\"1F49C\",\"j\":[\"purple_heart\",\"love\",\"like\",\"affection\",\"valentines\"],\"k\":[25,40],\"m\":\"<3\",\"o\":0},\"chart\":{\"a\":\"Chart with Upwards Trend and Yen Sign\",\"b\":\"1F4B9\",\"j\":[\"chart_increasing_with_yen\",\"green-square\",\"graph\",\"presentation\",\"stats\"],\"k\":[26,16],\"o\":0},\"rocket\":{\"a\":\"Rocket\",\"b\":\"1F680\",\"j\":[\"rocket\",\"launch\",\"ship\",\"staffmode\",\"NASA\",\"outer space\",\"outer_space\",\"fly\"],\"k\":[33,50],\"o\":0},\"tm\":{\"a\":\"Trade Mark Sign\",\"b\":\"2122-FE0F\",\"c\":\"2122\",\"j\":[\"trade_mark\",\"trademark\",\"brand\",\"law\",\"legal\"],\"k\":[53,18],\"o\":0},\"hash\":{\"a\":\"Hash Key\",\"b\":\"0023-FE0F-20E3\",\"c\":\"0023-20E3\",\"j\":[\"keycap_\",\"symbol\",\"blue-square\",\"twitter\"],\"k\":[0,0],\"o\":0},\"flag-kp\":{\"a\":\"North Korea Flag\",\"b\":\"1F1F0-1F1F5\",\"j\":[\"flag_north_korea\",\"north\",\"korea\",\"nation\",\"flag\",\"country\",\"banner\"],\"k\":[2,41],\"o\":2},\"herb\":{\"a\":\"Herb\",\"b\":\"1F33F\",\"j\":[\"herb\",\"vegetable\",\"plant\",\"medicine\",\"weed\",\"grass\",\"lawn\"],\"k\":[6,17],\"o\":0},\"flying_saucer\":{\"a\":\"Flying Saucer\",\"b\":\"1F6F8\",\"j\":[\"flying_saucer\",\"transportation\",\"vehicle\",\"ufo\"],\"k\":[36,50],\"o\":5},\"brown_heart\":{\"a\":\"Brown Heart\",\"b\":\"1F90E\",\"j\":[\"brown_heart\",\"coffee\"],\"k\":[37,16],\"o\":12},\"scientist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f52c.png\",\"sheet_x\":46,\"sheet_y\":50,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f52c.png\",\"sheet_x\":46,\"sheet_y\":51,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f52c.png\",\"sheet_x\":46,\"sheet_y\":52,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f52c.png\",\"sheet_x\":46,\"sheet_y\":53,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f52c.png\",\"sheet_x\":46,\"sheet_y\":54,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Scientist\",\"b\":\"1F9D1-200D-1F52C\",\"j\":[\"scientist\",\"chemistry\"],\"k\":[46,49],\"o\":12},\"email\":{\"a\":\"Envelope\",\"b\":\"2709-FE0F\",\"c\":\"2709\",\"j\":[\"envelope\",\"letter\",\"postal\",\"inbox\",\"communication\"],\"k\":[55,47],\"n\":[\"envelope\"],\"o\":0},\"keycap_star\":{\"a\":\"Keycap: *\",\"b\":\"002A-FE0F-20E3\",\"c\":\"002A-20E3\",\"j\":[\"keycap_\",\"star\",\"keycap\"],\"k\":[0,1],\"o\":2},\"kr\":{\"a\":\"South Korea Flag\",\"b\":\"1F1F0-1F1F7\",\"j\":[\"flag_south_korea\",\"south\",\"korea\",\"nation\",\"flag\",\"country\",\"banner\"],\"k\":[2,42],\"n\":[\"flag-kr\"],\"o\":0},\"male-scientist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f52c.png\",\"sheet_x\":15,\"sheet_y\":51,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f52c.png\",\"sheet_x\":15,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f52c.png\",\"sheet_x\":15,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f52c.png\",\"sheet_x\":15,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f52c.png\",\"sheet_x\":15,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Scientist\",\"b\":\"1F468-200D-1F52C\",\"j\":[\"man_scientist\",\"biologist\",\"chemist\",\"engineer\",\"physicist\",\"man\",\"human\"],\"k\":[15,50],\"o\":4},\"e-mail\":{\"a\":\"E-Mail Symbol\",\"b\":\"1F4E7\",\"j\":[\"e_mail\",\"communication\",\"inbox\"],\"k\":[27,4],\"o\":0},\"black_heart\":{\"a\":\"Black Heart\",\"b\":\"1F5A4\",\"j\":[\"black_heart\",\"evil\"],\"k\":[30,6],\"o\":3},\"bellhop_bell\":{\"a\":\"Bellhop Bell\",\"b\":\"1F6CE-FE0F\",\"c\":\"1F6CE\",\"j\":[\"bellhop_bell\",\"service\"],\"k\":[36,27],\"o\":0},\"shamrock\":{\"a\":\"Shamrock\",\"b\":\"2618-FE0F\",\"c\":\"2618\",\"j\":[\"shamrock\",\"vegetable\",\"plant\",\"nature\",\"irish\",\"clover\"],\"k\":[54,6],\"o\":1},\"zero\":{\"a\":\"Keycap 0\",\"b\":\"0030-FE0F-20E3\",\"c\":\"0030-20E3\",\"j\":[\"keycap_0\",\"0\",\"numbers\",\"blue-square\",\"null\"],\"k\":[0,2],\"o\":0},\"flag-kw\":{\"a\":\"Kuwait Flag\",\"b\":\"1F1F0-1F1FC\",\"j\":[\"flag_kuwait\",\"kw\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,43],\"o\":2},\"four_leaf_clover\":{\"a\":\"Four Leaf Clover\",\"b\":\"1F340\",\"j\":[\"four_leaf_clover\",\"vegetable\",\"plant\",\"nature\",\"lucky\",\"irish\"],\"k\":[6,18],\"o\":0},\"female-scientist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f52c.png\",\"sheet_x\":18,\"sheet_y\":39,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f52c.png\",\"sheet_x\":18,\"sheet_y\":40,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f52c.png\",\"sheet_x\":18,\"sheet_y\":41,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f52c.png\",\"sheet_x\":18,\"sheet_y\":42,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F52C\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f52c.png\",\"sheet_x\":18,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Scientist\",\"b\":\"1F469-200D-1F52C\",\"j\":[\"woman_scientist\",\"biologist\",\"chemist\",\"engineer\",\"physicist\",\"woman\",\"human\"],\"k\":[18,38],\"o\":4},\"incoming_envelope\":{\"a\":\"Incoming Envelope\",\"b\":\"1F4E8\",\"j\":[\"incoming_envelope\",\"email\",\"inbox\"],\"k\":[27,5],\"o\":0},\"white_heart\":{\"a\":\"White Heart\",\"b\":\"1F90D\",\"j\":[\"white_heart\",\"pure\"],\"k\":[37,15],\"o\":12},\"luggage\":{\"a\":\"Luggage\",\"b\":\"1F9F3\",\"j\":[\"luggage\",\"packing\",\"travel\"],\"k\":[52,4],\"o\":11},\"one\":{\"a\":\"Keycap 1\",\"b\":\"0031-FE0F-20E3\",\"c\":\"0031-20E3\",\"j\":[\"keycap_1\",\"blue-square\",\"numbers\",\"1\"],\"k\":[0,3],\"o\":0},\"flag-ky\":{\"a\":\"Cayman Islands Flag\",\"b\":\"1F1F0-1F1FE\",\"j\":[\"flag_cayman_islands\",\"cayman\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,44],\"o\":2},\"maple_leaf\":{\"a\":\"Maple Leaf\",\"b\":\"1F341\",\"j\":[\"maple_leaf\",\"nature\",\"plant\",\"vegetable\",\"ca\",\"fall\"],\"k\":[6,19],\"o\":0},\"envelope_with_arrow\":{\"a\":\"Envelope with Downwards Arrow Above\",\"b\":\"1F4E9\",\"j\":[\"envelope_with_arrow\",\"email\",\"communication\"],\"k\":[27,6],\"o\":0},\"technologist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f4bb.png\",\"sheet_x\":46,\"sheet_y\":32,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f4bb.png\",\"sheet_x\":46,\"sheet_y\":33,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f4bb.png\",\"sheet_x\":46,\"sheet_y\":34,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f4bb.png\",\"sheet_x\":46,\"sheet_y\":35,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f4bb.png\",\"sheet_x\":46,\"sheet_y\":36,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Technologist\",\"b\":\"1F9D1-200D-1F4BB\",\"j\":[\"technologist\",\"computer\"],\"k\":[46,31],\"o\":12},\"hourglass\":{\"a\":\"Hourglass\",\"b\":\"231B\",\"j\":[\"hourglass_done\",\"time\",\"clock\",\"oldschool\",\"limit\",\"exam\",\"quiz\",\"test\"],\"k\":[53,29],\"o\":0},\"two\":{\"a\":\"Keycap 2\",\"b\":\"0032-FE0F-20E3\",\"c\":\"0032-20E3\",\"j\":[\"keycap_2\",\"numbers\",\"2\",\"prime\",\"blue-square\"],\"k\":[0,4],\"o\":0},\"flag-kz\":{\"a\":\"Kazakhstan Flag\",\"b\":\"1F1F0-1F1FF\",\"j\":[\"flag_kazakhstan\",\"kz\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,45],\"o\":2},\"fallen_leaf\":{\"a\":\"Fallen Leaf\",\"b\":\"1F342\",\"j\":[\"fallen_leaf\",\"nature\",\"plant\",\"vegetable\",\"leaves\"],\"k\":[6,20],\"o\":0},\"male-technologist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f4bb.png\",\"sheet_x\":15,\"sheet_y\":33,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f4bb.png\",\"sheet_x\":15,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f4bb.png\",\"sheet_x\":15,\"sheet_y\":35,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f4bb.png\",\"sheet_x\":15,\"sheet_y\":36,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f4bb.png\",\"sheet_x\":15,\"sheet_y\":37,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Technologist\",\"b\":\"1F468-200D-1F4BB\",\"j\":[\"man_technologist\",\"coder\",\"developer\",\"engineer\",\"programmer\",\"software\",\"man\",\"human\",\"laptop\",\"computer\"],\"k\":[15,32],\"o\":4},\"anger\":{\"a\":\"Anger Symbol\",\"b\":\"1F4A2\",\"j\":[\"anger_symbol\",\"angry\",\"mad\"],\"k\":[25,46],\"o\":0},\"outbox_tray\":{\"a\":\"Outbox Tray\",\"b\":\"1F4E4\",\"j\":[\"outbox_tray\",\"inbox\",\"email\"],\"k\":[27,1],\"o\":0},\"hourglass_flowing_sand\":{\"a\":\"Hourglass with Flowing Sand\",\"b\":\"23F3\",\"j\":[\"hourglass_not_done\",\"oldschool\",\"time\",\"countdown\"],\"k\":[53,42],\"o\":0},\"three\":{\"a\":\"Keycap 3\",\"b\":\"0033-FE0F-20E3\",\"c\":\"0033-20E3\",\"j\":[\"keycap_3\",\"3\",\"numbers\",\"prime\",\"blue-square\"],\"k\":[0,5],\"o\":0},\"flag-la\":{\"a\":\"Laos Flag\",\"b\":\"1F1F1-1F1E6\",\"j\":[\"flag_laos\",\"lao\",\"democratic\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,46],\"o\":2},\"leaves\":{\"a\":\"Leaf Fluttering in Wind\",\"b\":\"1F343\",\"j\":[\"leaf_fluttering_in_wind\",\"nature\",\"plant\",\"tree\",\"vegetable\",\"grass\",\"lawn\",\"spring\"],\"k\":[6,21],\"o\":0},\"female-technologist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f4bb.png\",\"sheet_x\":18,\"sheet_y\":21,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f4bb.png\",\"sheet_x\":18,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f4bb.png\",\"sheet_x\":18,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f4bb.png\",\"sheet_x\":18,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F4BB\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f4bb.png\",\"sheet_x\":18,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Technologist\",\"b\":\"1F469-200D-1F4BB\",\"j\":[\"woman_technologist\",\"coder\",\"developer\",\"engineer\",\"programmer\",\"software\",\"woman\",\"human\",\"laptop\",\"computer\"],\"k\":[18,20],\"o\":4},\"boom\":{\"a\":\"Collision Symbol\",\"b\":\"1F4A5\",\"j\":[\"collision\",\"bomb\",\"explode\",\"explosion\",\"collision\",\"blown\"],\"k\":[25,49],\"n\":[\"collision\"],\"o\":0},\"inbox_tray\":{\"a\":\"Inbox Tray\",\"b\":\"1F4E5\",\"j\":[\"inbox_tray\",\"email\",\"documents\"],\"k\":[27,2],\"o\":0},\"watch\":{\"a\":\"Watch\",\"b\":\"231A\",\"j\":[\"watch\",\"time\",\"accessories\"],\"k\":[53,28],\"o\":0},\"four\":{\"a\":\"Keycap 4\",\"b\":\"0034-FE0F-20E3\",\"c\":\"0034-20E3\",\"j\":[\"keycap_4\",\"4\",\"numbers\",\"blue-square\"],\"k\":[0,6],\"o\":0},\"flag-lb\":{\"a\":\"Lebanon Flag\",\"b\":\"1F1F1-1F1E7\",\"j\":[\"flag_lebanon\",\"lb\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,47],\"o\":2},\"dizzy\":{\"a\":\"Dizzy Symbol\",\"b\":\"1F4AB\",\"j\":[\"dizzy\",\"star\",\"sparkle\",\"shoot\",\"magic\"],\"k\":[26,2],\"o\":0},\"package\":{\"a\":\"Package\",\"b\":\"1F4E6\",\"j\":[\"package\",\"mail\",\"gift\",\"cardboard\",\"box\",\"moving\"],\"k\":[27,3],\"o\":0},\"singer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f3a4.png\",\"sheet_x\":46,\"sheet_y\":8,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f3a4.png\",\"sheet_x\":46,\"sheet_y\":9,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f3a4.png\",\"sheet_x\":46,\"sheet_y\":10,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f3a4.png\",\"sheet_x\":46,\"sheet_y\":11,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f3a4.png\",\"sheet_x\":46,\"sheet_y\":12,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Singer\",\"b\":\"1F9D1-200D-1F3A4\",\"j\":[\"singer\",\"song\",\"artist\",\"performer\"],\"k\":[46,7],\"o\":12},\"alarm_clock\":{\"a\":\"Alarm Clock\",\"b\":\"23F0\",\"j\":[\"alarm_clock\",\"time\",\"wake\"],\"k\":[53,39],\"o\":0},\"five\":{\"a\":\"Keycap 5\",\"b\":\"0035-FE0F-20E3\",\"c\":\"0035-20E3\",\"j\":[\"keycap_5\",\"5\",\"numbers\",\"blue-square\",\"prime\"],\"k\":[0,7],\"o\":0},\"flag-lc\":{\"a\":\"St. Lucia Flag\",\"b\":\"1F1F1-1F1E8\",\"j\":[\"flag_st_lucia\",\"saint\",\"lucia\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,48],\"o\":2},\"male-singer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f3a4.png\",\"sheet_x\":14,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f3a4.png\",\"sheet_x\":14,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f3a4.png\",\"sheet_x\":14,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f3a4.png\",\"sheet_x\":14,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f3a4.png\",\"sheet_x\":14,\"sheet_y\":56,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Singer\",\"b\":\"1F468-200D-1F3A4\",\"j\":[\"man_singer\",\"rockstar\",\"entertainer\",\"man\",\"human\"],\"k\":[14,51],\"o\":4},\"sweat_drops\":{\"a\":\"Splashing Sweat Symbol\",\"b\":\"1F4A6\",\"j\":[\"sweat_droplets\",\"water\",\"drip\",\"oops\"],\"k\":[25,50],\"o\":0},\"mailbox\":{\"a\":\"Closed Mailbox with Raised Flag\",\"b\":\"1F4EB\",\"j\":[\"closed_mailbox_with_raised_flag\",\"email\",\"inbox\",\"communication\"],\"k\":[27,8],\"o\":0},\"stopwatch\":{\"a\":\"Stopwatch\",\"b\":\"23F1-FE0F\",\"c\":\"23F1\",\"j\":[\"stopwatch\",\"time\",\"deadline\"],\"k\":[53,40],\"o\":1},\"six\":{\"a\":\"Keycap 6\",\"b\":\"0036-FE0F-20E3\",\"c\":\"0036-20E3\",\"j\":[\"keycap_6\",\"6\",\"numbers\",\"blue-square\"],\"k\":[0,8],\"o\":0},\"flag-li\":{\"a\":\"Liechtenstein Flag\",\"b\":\"1F1F1-1F1EE\",\"j\":[\"flag_liechtenstein\",\"li\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,49],\"o\":2},\"female-singer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f3a4.png\",\"sheet_x\":17,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f3a4.png\",\"sheet_x\":17,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f3a4.png\",\"sheet_x\":17,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f3a4.png\",\"sheet_x\":17,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F3A4\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f3a4.png\",\"sheet_x\":17,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Singer\",\"b\":\"1F469-200D-1F3A4\",\"j\":[\"woman_singer\",\"rockstar\",\"entertainer\",\"woman\",\"human\"],\"k\":[17,44],\"o\":4},\"dash\":{\"a\":\"Dash Symbol\",\"b\":\"1F4A8\",\"j\":[\"dashing_away\",\"wind\",\"air\",\"fast\",\"shoo\",\"fart\",\"smoke\",\"puff\"],\"k\":[25,52],\"o\":0},\"mailbox_closed\":{\"a\":\"Closed Mailbox with Lowered Flag\",\"b\":\"1F4EA\",\"j\":[\"closed_mailbox_with_lowered_flag\",\"email\",\"communication\",\"inbox\"],\"k\":[27,7],\"o\":0},\"timer_clock\":{\"a\":\"Timer Clock\",\"b\":\"23F2-FE0F\",\"c\":\"23F2\",\"j\":[\"timer_clock\",\"alarm\"],\"k\":[53,41],\"o\":1},\"seven\":{\"a\":\"Keycap 7\",\"b\":\"0037-FE0F-20E3\",\"c\":\"0037-20E3\",\"j\":[\"keycap_7\",\"7\",\"numbers\",\"blue-square\",\"prime\"],\"k\":[0,9],\"o\":0},\"flag-lk\":{\"a\":\"Sri Lanka Flag\",\"b\":\"1F1F1-1F1F0\",\"j\":[\"flag_sri_lanka\",\"sri\",\"lanka\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,50],\"o\":2},\"mailbox_with_mail\":{\"a\":\"Open Mailbox with Raised Flag\",\"b\":\"1F4EC\",\"j\":[\"open_mailbox_with_raised_flag\",\"email\",\"inbox\",\"communication\"],\"k\":[27,9],\"o\":0},\"mantelpiece_clock\":{\"a\":\"Mantelpiece Clock\",\"b\":\"1F570-FE0F\",\"c\":\"1F570\",\"j\":[\"mantelpiece_clock\",\"time\"],\"k\":[29,5],\"o\":0},\"hole\":{\"a\":\"Hole\",\"b\":\"1F573-FE0F\",\"c\":\"1F573\",\"j\":[\"hole\",\"embarrassing\"],\"k\":[29,6],\"o\":0},\"artist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f3a8.png\",\"sheet_x\":46,\"sheet_y\":14,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f3a8.png\",\"sheet_x\":46,\"sheet_y\":15,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f3a8.png\",\"sheet_x\":46,\"sheet_y\":16,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f3a8.png\",\"sheet_x\":46,\"sheet_y\":17,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f3a8.png\",\"sheet_x\":46,\"sheet_y\":18,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Artist\",\"b\":\"1F9D1-200D-1F3A8\",\"j\":[\"artist\",\"painting\",\"draw\",\"creativity\"],\"k\":[46,13],\"o\":12},\"eight\":{\"a\":\"Keycap 8\",\"b\":\"0038-FE0F-20E3\",\"c\":\"0038-20E3\",\"j\":[\"keycap_8\",\"8\",\"blue-square\",\"numbers\"],\"k\":[0,10],\"o\":0},\"flag-lr\":{\"a\":\"Liberia Flag\",\"b\":\"1F1F1-1F1F7\",\"j\":[\"flag_liberia\",\"lr\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,51],\"o\":2},\"male-artist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f3a8.png\",\"sheet_x\":15,\"sheet_y\":0,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f3a8.png\",\"sheet_x\":15,\"sheet_y\":1,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f3a8.png\",\"sheet_x\":15,\"sheet_y\":2,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f3a8.png\",\"sheet_x\":15,\"sheet_y\":3,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f3a8.png\",\"sheet_x\":15,\"sheet_y\":4,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Artist\",\"b\":\"1F468-200D-1F3A8\",\"j\":[\"man_artist\",\"painter\",\"man\",\"human\"],\"k\":[14,57],\"o\":4},\"bomb\":{\"a\":\"Bomb\",\"b\":\"1F4A3\",\"j\":[\"bomb\",\"boom\",\"explode\",\"explosion\",\"terrorism\"],\"k\":[25,47],\"o\":0},\"mailbox_with_no_mail\":{\"a\":\"Open Mailbox with Lowered Flag\",\"b\":\"1F4ED\",\"j\":[\"open_mailbox_with_lowered_flag\",\"email\",\"inbox\"],\"k\":[27,10],\"o\":0},\"clock12\":{\"a\":\"Clock Face Twelve Oclock\",\"b\":\"1F55B\",\"j\":[\"twelve_o_clock\",\"time\",\"noon\",\"midnight\",\"midday\",\"late\",\"early\",\"schedule\"],\"k\":[28,49],\"o\":0},\"nine\":{\"a\":\"Keycap 9\",\"b\":\"0039-FE0F-20E3\",\"c\":\"0039-20E3\",\"j\":[\"keycap_9\",\"blue-square\",\"numbers\",\"9\"],\"k\":[0,11],\"o\":0},\"flag-ls\":{\"a\":\"Lesotho Flag\",\"b\":\"1F1F1-1F1F8\",\"j\":[\"flag_lesotho\",\"ls\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,52],\"o\":2},\"female-artist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f3a8.png\",\"sheet_x\":17,\"sheet_y\":51,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f3a8.png\",\"sheet_x\":17,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f3a8.png\",\"sheet_x\":17,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f3a8.png\",\"sheet_x\":17,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F3A8\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f3a8.png\",\"sheet_x\":17,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Artist\",\"b\":\"1F469-200D-1F3A8\",\"j\":[\"woman_artist\",\"painter\",\"woman\",\"human\"],\"k\":[17,50],\"o\":4},\"speech_balloon\":{\"a\":\"Speech Balloon\",\"b\":\"1F4AC\",\"j\":[\"speech_balloon\",\"bubble\",\"words\",\"message\",\"talk\",\"chatting\"],\"k\":[26,3],\"o\":0},\"postbox\":{\"a\":\"Postbox\",\"b\":\"1F4EE\",\"j\":[\"postbox\",\"email\",\"letter\",\"envelope\"],\"k\":[27,11],\"o\":0},\"clock1230\":{\"a\":\"Clock Face Twelve-Thirty\",\"b\":\"1F567\",\"j\":[\"twelve_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[29,3],\"o\":0},\"flag-lt\":{\"a\":\"Lithuania Flag\",\"b\":\"1F1F1-1F1F9\",\"j\":[\"flag_lithuania\",\"lt\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,53],\"o\":2},\"keycap_ten\":{\"a\":\"Keycap Ten\",\"b\":\"1F51F\",\"j\":[\"keycap_10\",\"numbers\",\"10\",\"blue-square\"],\"k\":[28,1],\"o\":0},\"clock1\":{\"a\":\"Clock Face One Oclock\",\"b\":\"1F550\",\"j\":[\"one_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,38],\"o\":0},\"ballot_box_with_ballot\":{\"a\":\"Ballot Box with Ballot\",\"b\":\"1F5F3-FE0F\",\"c\":\"1F5F3\",\"j\":[\"ballot_box_with_ballot\",\"election\",\"vote\"],\"k\":[30,25],\"o\":0},\"pilot\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-2708-FE0F\",\"non_qualified\":\"1F9D1-1F3FB-200D-2708\",\"image\":\"1f9d1-1f3fb-200d-2708-fe0f.png\",\"sheet_x\":48,\"sheet_y\":32,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-2708-FE0F\",\"non_qualified\":\"1F9D1-1F3FC-200D-2708\",\"image\":\"1f9d1-1f3fc-200d-2708-fe0f.png\",\"sheet_x\":48,\"sheet_y\":33,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-2708-FE0F\",\"non_qualified\":\"1F9D1-1F3FD-200D-2708\",\"image\":\"1f9d1-1f3fd-200d-2708-fe0f.png\",\"sheet_x\":48,\"sheet_y\":34,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-2708-FE0F\",\"non_qualified\":\"1F9D1-1F3FE-200D-2708\",\"image\":\"1f9d1-1f3fe-200d-2708-fe0f.png\",\"sheet_x\":48,\"sheet_y\":35,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-2708-FE0F\",\"non_qualified\":\"1F9D1-1F3FF-200D-2708\",\"image\":\"1f9d1-1f3ff-200d-2708-fe0f.png\",\"sheet_x\":48,\"sheet_y\":36,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Pilot\",\"b\":\"1F9D1-200D-2708-FE0F\",\"c\":\"1F9D1-200D-2708\",\"j\":[\"pilot\",\"fly\",\"plane\",\"airplane\"],\"k\":[48,31],\"o\":12},\"flag-lu\":{\"a\":\"Luxembourg Flag\",\"b\":\"1F1F1-1F1FA\",\"j\":[\"flag_luxembourg\",\"lu\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,54],\"o\":2},\"male-pilot\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-2708-FE0F\",\"non_qualified\":\"1F468-1F3FB-200D-2708\",\"image\":\"1f468-1f3fb-200d-2708-fe0f.png\",\"sheet_x\":17,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-2708-FE0F\",\"non_qualified\":\"1F468-1F3FC-200D-2708\",\"image\":\"1f468-1f3fc-200d-2708-fe0f.png\",\"sheet_x\":17,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-2708-FE0F\",\"non_qualified\":\"1F468-1F3FD-200D-2708\",\"image\":\"1f468-1f3fd-200d-2708-fe0f.png\",\"sheet_x\":17,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-2708-FE0F\",\"non_qualified\":\"1F468-1F3FE-200D-2708\",\"image\":\"1f468-1f3fe-200d-2708-fe0f.png\",\"sheet_x\":17,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-2708-FE0F\",\"non_qualified\":\"1F468-1F3FF-200D-2708\",\"image\":\"1f468-1f3ff-200d-2708-fe0f.png\",\"sheet_x\":17,\"sheet_y\":11,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Pilot\",\"b\":\"1F468-200D-2708-FE0F\",\"c\":\"1F468-200D-2708\",\"j\":[\"man_pilot\",\"aviator\",\"plane\",\"man\",\"human\"],\"k\":[17,6],\"o\":4},\"capital_abcd\":{\"a\":\"Input Symbol for Latin Capital Letters\",\"b\":\"1F520\",\"j\":[\"input_latin_uppercase\",\"alphabet\",\"words\",\"blue-square\"],\"k\":[28,2],\"o\":0},\"clock130\":{\"a\":\"Clock Face One-Thirty\",\"b\":\"1F55C\",\"j\":[\"one_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,50],\"o\":0},\"left_speech_bubble\":{\"a\":\"Left Speech Bubble\",\"b\":\"1F5E8-FE0F\",\"c\":\"1F5E8\",\"j\":[\"left_speech_bubble\",\"words\",\"message\",\"talk\",\"chatting\"],\"k\":[30,23],\"o\":2},\"pencil2\":{\"a\":\"Pencil\",\"b\":\"270F-FE0F\",\"c\":\"270F\",\"j\":[\"pencil\",\"stationery\",\"write\",\"paper\",\"writing\",\"school\",\"study\"],\"k\":[56,14],\"o\":0},\"flag-lv\":{\"a\":\"Latvia Flag\",\"b\":\"1F1F1-1F1FB\",\"j\":[\"flag_latvia\",\"lv\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,55],\"o\":2},\"female-pilot\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-2708-FE0F\",\"non_qualified\":\"1F469-1F3FB-200D-2708\",\"image\":\"1f469-1f3fb-200d-2708-fe0f.png\",\"sheet_x\":19,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-2708-FE0F\",\"non_qualified\":\"1F469-1F3FC-200D-2708\",\"image\":\"1f469-1f3fc-200d-2708-fe0f.png\",\"sheet_x\":19,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-2708-FE0F\",\"non_qualified\":\"1F469-1F3FD-200D-2708\",\"image\":\"1f469-1f3fd-200d-2708-fe0f.png\",\"sheet_x\":19,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-2708-FE0F\",\"non_qualified\":\"1F469-1F3FE-200D-2708\",\"image\":\"1f469-1f3fe-200d-2708-fe0f.png\",\"sheet_x\":19,\"sheet_y\":56,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-2708-FE0F\",\"non_qualified\":\"1F469-1F3FF-200D-2708\",\"image\":\"1f469-1f3ff-200d-2708-fe0f.png\",\"sheet_x\":19,\"sheet_y\":57,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Pilot\",\"b\":\"1F469-200D-2708-FE0F\",\"c\":\"1F469-200D-2708\",\"j\":[\"woman_pilot\",\"aviator\",\"plane\",\"woman\",\"human\"],\"k\":[19,52],\"o\":4},\"abcd\":{\"a\":\"Input Symbol for Latin Small Letters\",\"b\":\"1F521\",\"j\":[\"input_latin_lowercase\",\"blue-square\",\"alphabet\"],\"k\":[28,3],\"o\":0},\"clock2\":{\"a\":\"Clock Face Two Oclock\",\"b\":\"1F551\",\"j\":[\"two_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,39],\"o\":0},\"right_anger_bubble\":{\"a\":\"Right Anger Bubble\",\"b\":\"1F5EF-FE0F\",\"c\":\"1F5EF\",\"j\":[\"right_anger_bubble\",\"caption\",\"speech\",\"thinking\",\"mad\"],\"k\":[30,24],\"o\":0},\"black_nib\":{\"a\":\"Black Nib\",\"b\":\"2712-FE0F\",\"c\":\"2712\",\"j\":[\"black_nib\",\"pen\",\"stationery\",\"writing\",\"write\"],\"k\":[56,15],\"o\":0},\"flag-ly\":{\"a\":\"Libya Flag\",\"b\":\"1F1F1-1F1FE\",\"j\":[\"flag_libya\",\"ly\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,56],\"o\":2},\"thought_balloon\":{\"a\":\"Thought Balloon\",\"b\":\"1F4AD\",\"j\":[\"thought_balloon\",\"bubble\",\"cloud\",\"speech\",\"thinking\",\"dream\"],\"k\":[26,4],\"o\":1},\"clock230\":{\"a\":\"Clock Face Two-Thirty\",\"b\":\"1F55D\",\"j\":[\"two_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,51],\"o\":0},\"lower_left_fountain_pen\":{\"a\":\"Fountain Pen\",\"b\":\"1F58B-FE0F\",\"c\":\"1F58B\",\"j\":[\"fountain_pen\",\"stationery\",\"writing\",\"write\"],\"k\":[29,43],\"o\":0},\"astronaut\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F680\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f680.png\",\"sheet_x\":46,\"sheet_y\":56,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F680\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f680.png\",\"sheet_x\":46,\"sheet_y\":57,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F680\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f680.png\",\"sheet_x\":47,\"sheet_y\":0,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F680\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f680.png\",\"sheet_x\":47,\"sheet_y\":1,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F680\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f680.png\",\"sheet_x\":47,\"sheet_y\":2,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Astronaut\",\"b\":\"1F9D1-200D-1F680\",\"j\":[\"astronaut\",\"outerspace\"],\"k\":[46,55],\"o\":12},\"flag-ma\":{\"a\":\"Morocco Flag\",\"b\":\"1F1F2-1F1E6\",\"j\":[\"flag_morocco\",\"ma\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[2,57],\"o\":2},\"male-astronaut\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F680\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f680.png\",\"sheet_x\":15,\"sheet_y\":57,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F680\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f680.png\",\"sheet_x\":16,\"sheet_y\":0,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F680\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f680.png\",\"sheet_x\":16,\"sheet_y\":1,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F680\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f680.png\",\"sheet_x\":16,\"sheet_y\":2,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F680\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f680.png\",\"sheet_x\":16,\"sheet_y\":3,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Astronaut\",\"b\":\"1F468-200D-1F680\",\"j\":[\"man_astronaut\",\"space\",\"rocket\",\"man\",\"human\"],\"k\":[15,56],\"o\":4},\"zzz\":{\"a\":\"Sleeping Symbol\",\"b\":\"1F4A4\",\"j\":[\"zzz\",\"sleepy\",\"tired\",\"dream\"],\"k\":[25,48],\"o\":0},\"symbols\":{\"a\":\"Input Symbol for Symbols\",\"b\":\"1F523\",\"j\":[\"input_symbols\",\"blue-square\",\"music\",\"note\",\"ampersand\",\"percent\",\"glyphs\",\"characters\"],\"k\":[28,5],\"o\":0},\"clock3\":{\"a\":\"Clock Face Three Oclock\",\"b\":\"1F552\",\"j\":[\"three_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,40],\"o\":0},\"lower_left_ballpoint_pen\":{\"a\":\"Pen\",\"b\":\"1F58A-FE0F\",\"c\":\"1F58A\",\"j\":[\"pen\",\"stationery\",\"writing\",\"write\"],\"k\":[29,42],\"o\":0},\"flag-mc\":{\"a\":\"Monaco Flag\",\"b\":\"1F1F2-1F1E8\",\"j\":[\"flag_monaco\",\"mc\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,0],\"o\":2},\"female-astronaut\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F680\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f680.png\",\"sheet_x\":18,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F680\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f680.png\",\"sheet_x\":18,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F680\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f680.png\",\"sheet_x\":18,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F680\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f680.png\",\"sheet_x\":18,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F680\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f680.png\",\"sheet_x\":18,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Astronaut\",\"b\":\"1F469-200D-1F680\",\"j\":[\"woman_astronaut\",\"space\",\"rocket\",\"woman\",\"human\"],\"k\":[18,44],\"o\":4},\"abc\":{\"a\":\"Input Symbol for Latin Letters\",\"b\":\"1F524\",\"j\":[\"input_latin_letters\",\"blue-square\",\"alphabet\"],\"k\":[28,6],\"o\":0},\"clock330\":{\"a\":\"Clock Face Three-Thirty\",\"b\":\"1F55E\",\"j\":[\"three_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,52],\"o\":0},\"lower_left_paintbrush\":{\"a\":\"Paintbrush\",\"b\":\"1F58C-FE0F\",\"c\":\"1F58C\",\"j\":[\"paintbrush\",\"drawing\",\"creativity\",\"art\"],\"k\":[29,44],\"o\":0},\"a\":{\"a\":\"Negative Squared Latin Capital Letter a\",\"b\":\"1F170-FE0F\",\"c\":\"1F170\",\"j\":[\"a_button\",\"red-square\",\"alphabet\",\"letter\"],\"k\":[0,16],\"o\":0},\"flag-md\":{\"a\":\"Moldova Flag\",\"b\":\"1F1F2-1F1E9\",\"j\":[\"flag_moldova\",\"moldova\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,1],\"o\":2},\"clock4\":{\"a\":\"Clock Face Four Oclock\",\"b\":\"1F553\",\"j\":[\"four_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,41],\"o\":0},\"lower_left_crayon\":{\"a\":\"Crayon\",\"b\":\"1F58D-FE0F\",\"c\":\"1F58D\",\"j\":[\"crayon\",\"drawing\",\"creativity\"],\"k\":[29,45],\"o\":0},\"firefighter\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F692\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f692.png\",\"sheet_x\":47,\"sheet_y\":4,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F692\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f692.png\",\"sheet_x\":47,\"sheet_y\":5,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F692\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f692.png\",\"sheet_x\":47,\"sheet_y\":6,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F692\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f692.png\",\"sheet_x\":47,\"sheet_y\":7,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F692\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f692.png\",\"sheet_x\":47,\"sheet_y\":8,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Firefighter\",\"b\":\"1F9D1-200D-1F692\",\"j\":[\"firefighter\",\"fire\"],\"k\":[47,3],\"o\":12},\"ab\":{\"a\":\"Negative Squared Ab\",\"b\":\"1F18E\",\"j\":[\"ab_button\",\"red-square\",\"alphabet\"],\"k\":[0,20],\"o\":0},\"flag-me\":{\"a\":\"Montenegro Flag\",\"b\":\"1F1F2-1F1EA\",\"j\":[\"flag_montenegro\",\"me\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,2],\"o\":2},\"male-firefighter\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F692\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f692.png\",\"sheet_x\":16,\"sheet_y\":5,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F692\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f692.png\",\"sheet_x\":16,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F692\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f692.png\",\"sheet_x\":16,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F692\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f692.png\",\"sheet_x\":16,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F692\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f692.png\",\"sheet_x\":16,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Firefighter\",\"b\":\"1F468-200D-1F692\",\"j\":[\"man_firefighter\",\"fireman\",\"man\",\"human\"],\"k\":[16,4],\"o\":4},\"memo\":{\"a\":\"Memo\",\"b\":\"1F4DD\",\"j\":[\"memo\",\"write\",\"documents\",\"stationery\",\"pencil\",\"paper\",\"writing\",\"legal\",\"exam\",\"quiz\",\"test\",\"study\",\"compose\"],\"k\":[26,52],\"n\":[\"pencil\"],\"o\":0},\"clock430\":{\"a\":\"Clock Face Four-Thirty\",\"b\":\"1F55F\",\"j\":[\"four_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,53],\"o\":0},\"b\":{\"a\":\"Negative Squared Latin Capital Letter B\",\"b\":\"1F171-FE0F\",\"c\":\"1F171\",\"j\":[\"b_button\",\"red-square\",\"alphabet\",\"letter\"],\"k\":[0,17],\"o\":0},\"flag-mf\":{\"a\":\"St. Martin Flag\",\"b\":\"1F1F2-1F1EB\",\"j\":[\"flag_st_martin\"],\"k\":[3,3],\"o\":2},\"female-firefighter\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F692\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f692.png\",\"sheet_x\":18,\"sheet_y\":51,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F692\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f692.png\",\"sheet_x\":18,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F692\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f692.png\",\"sheet_x\":18,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F692\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f692.png\",\"sheet_x\":18,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F692\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f692.png\",\"sheet_x\":18,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Firefighter\",\"b\":\"1F469-200D-1F692\",\"j\":[\"woman_firefighter\",\"fireman\",\"woman\",\"human\"],\"k\":[18,50],\"o\":4},\"briefcase\":{\"a\":\"Briefcase\",\"b\":\"1F4BC\",\"j\":[\"briefcase\",\"business\",\"documents\",\"work\",\"law\",\"legal\",\"job\",\"career\"],\"k\":[26,19],\"o\":0},\"clock5\":{\"a\":\"Clock Face Five Oclock\",\"b\":\"1F554\",\"j\":[\"five_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,42],\"o\":0},\"cl\":{\"a\":\"Squared Cl\",\"b\":\"1F191\",\"j\":[\"cl_button\",\"alphabet\",\"words\",\"red-square\"],\"k\":[0,21],\"o\":0},\"flag-mg\":{\"a\":\"Madagascar Flag\",\"b\":\"1F1F2-1F1EC\",\"j\":[\"flag_madagascar\",\"mg\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,4],\"o\":2},\"cop\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F46E-1F3FB\",\"non_qualified\":null,\"image\":\"1f46e-1f3fb.png\",\"sheet_x\":21,\"sheet_y\":44,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F46E-1F3FC\",\"non_qualified\":null,\"image\":\"1f46e-1f3fc.png\",\"sheet_x\":21,\"sheet_y\":45,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F46E-1F3FD\",\"non_qualified\":null,\"image\":\"1f46e-1f3fd.png\",\"sheet_x\":21,\"sheet_y\":46,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F46E-1F3FE\",\"non_qualified\":null,\"image\":\"1f46e-1f3fe.png\",\"sheet_x\":21,\"sheet_y\":47,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F46E-1F3FF\",\"non_qualified\":null,\"image\":\"1f46e-1f3ff.png\",\"sheet_x\":21,\"sheet_y\":48,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F46E-200D-2642-FE0F\",\"a\":\"Police Officer\",\"b\":\"1F46E\",\"j\":[\"police_officer\",\"cop\"],\"k\":[21,43],\"o\":0},\"file_folder\":{\"a\":\"File Folder\",\"b\":\"1F4C1\",\"j\":[\"file_folder\",\"documents\",\"business\",\"office\"],\"k\":[26,24],\"o\":0},\"clock530\":{\"a\":\"Clock Face Five-Thirty\",\"b\":\"1F560\",\"j\":[\"five_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,54],\"o\":0},\"cool\":{\"a\":\"Squared Cool\",\"b\":\"1F192\",\"j\":[\"cool_button\",\"words\",\"blue-square\"],\"k\":[0,22],\"o\":0},\"flag-mh\":{\"a\":\"Marshall Islands Flag\",\"b\":\"1F1F2-1F1ED\",\"j\":[\"flag_marshall_islands\",\"marshall\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,5],\"o\":2},\"male-police-officer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F46E-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F46E-1F3FB-200D-2642\",\"image\":\"1f46e-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":21,\"sheet_y\":38,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F46E-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F46E-1F3FC-200D-2642\",\"image\":\"1f46e-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":21,\"sheet_y\":39,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F46E-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F46E-1F3FD-200D-2642\",\"image\":\"1f46e-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":21,\"sheet_y\":40,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F46E-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F46E-1F3FE-200D-2642\",\"image\":\"1f46e-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":21,\"sheet_y\":41,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F46E-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F46E-1F3FF-200D-2642\",\"image\":\"1f46e-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":21,\"sheet_y\":42,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F46E\",\"a\":\"Man Police Officer\",\"b\":\"1F46E-200D-2642-FE0F\",\"c\":\"1F46E-200D-2642\",\"j\":[\"man_police_officer\",\"man\",\"police\",\"law\",\"legal\",\"enforcement\",\"arrest\",\"911\"],\"k\":[21,37],\"o\":4},\"open_file_folder\":{\"a\":\"Open File Folder\",\"b\":\"1F4C2\",\"j\":[\"open_file_folder\",\"documents\",\"load\"],\"k\":[26,25],\"o\":0},\"clock6\":{\"a\":\"Clock Face Six Oclock\",\"b\":\"1F555\",\"j\":[\"six_o_clock\",\"time\",\"late\",\"early\",\"schedule\",\"dawn\",\"dusk\"],\"k\":[28,43],\"o\":0},\"free\":{\"a\":\"Squared Free\",\"b\":\"1F193\",\"j\":[\"free_button\",\"blue-square\",\"words\"],\"k\":[0,23],\"o\":0},\"flag-mk\":{\"a\":\"North Macedonia Flag\",\"b\":\"1F1F2-1F1F0\",\"j\":[\"flag_north_macedonia\",\"macedonia\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,6],\"o\":2},\"female-police-officer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F46E-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F46E-1F3FB-200D-2640\",\"image\":\"1f46e-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":32,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F46E-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F46E-1F3FC-200D-2640\",\"image\":\"1f46e-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":33,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F46E-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F46E-1F3FD-200D-2640\",\"image\":\"1f46e-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F46E-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F46E-1F3FE-200D-2640\",\"image\":\"1f46e-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":35,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F46E-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F46E-1F3FF-200D-2640\",\"image\":\"1f46e-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":36,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Police Officer\",\"b\":\"1F46E-200D-2640-FE0F\",\"c\":\"1F46E-200D-2640\",\"j\":[\"woman_police_officer\",\"woman\",\"police\",\"law\",\"legal\",\"enforcement\",\"arrest\",\"911\",\"female\"],\"k\":[21,31],\"o\":4},\"clock630\":{\"a\":\"Clock Face Six-Thirty\",\"b\":\"1F561\",\"j\":[\"six_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,55],\"o\":0},\"card_index_dividers\":{\"a\":\"Card Index Dividers\",\"b\":\"1F5C2-FE0F\",\"c\":\"1F5C2\",\"j\":[\"card_index_dividers\",\"organizing\",\"business\",\"stationery\"],\"k\":[30,12],\"o\":0},\"flag-ml\":{\"a\":\"Mali Flag\",\"b\":\"1F1F2-1F1F1\",\"j\":[\"flag_mali\",\"ml\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,7],\"o\":2},\"date\":{\"a\":\"Calendar\",\"b\":\"1F4C5\",\"j\":[\"calendar\",\"calendar\",\"schedule\"],\"k\":[26,28],\"o\":0},\"clock7\":{\"a\":\"Clock Face Seven Oclock\",\"b\":\"1F556\",\"j\":[\"seven_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,44],\"o\":0},\"sleuth_or_spy\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F575-1F3FB\",\"non_qualified\":null,\"image\":\"1f575-1f3fb.png\",\"sheet_x\":29,\"sheet_y\":26,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F575-1F3FC\",\"non_qualified\":null,\"image\":\"1f575-1f3fc.png\",\"sheet_x\":29,\"sheet_y\":27,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F575-1F3FD\",\"non_qualified\":null,\"image\":\"1f575-1f3fd.png\",\"sheet_x\":29,\"sheet_y\":28,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F575-1F3FE\",\"non_qualified\":null,\"image\":\"1f575-1f3fe.png\",\"sheet_x\":29,\"sheet_y\":29,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F575-1F3FF\",\"non_qualified\":null,\"image\":\"1f575-1f3ff.png\",\"sheet_x\":29,\"sheet_y\":30,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F575-FE0F-200D-2642-FE0F\",\"a\":\"Detective\",\"b\":\"1F575-FE0F\",\"c\":\"1F575\",\"j\":[\"detective\",\"human\",\"spy\",\"detective\"],\"k\":[29,25],\"o\":0},\"information_source\":{\"a\":\"Information Source\",\"b\":\"2139-FE0F\",\"c\":\"2139\",\"j\":[\"information\",\"blue-square\",\"alphabet\",\"letter\"],\"k\":[53,19],\"o\":0},\"id\":{\"a\":\"Squared Id\",\"b\":\"1F194\",\"j\":[\"id_button\",\"purple-square\",\"words\"],\"k\":[0,24],\"o\":0},\"flag-mm\":{\"a\":\"Myanmar (burma) Flag\",\"b\":\"1F1F2-1F1F2\",\"j\":[\"flag_myanmar\",\"mm\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,8],\"o\":2},\"calendar\":{\"a\":\"Tear-off Calendar\",\"b\":\"1F4C6\",\"j\":[\"tear_off_calendar\",\"schedule\",\"date\",\"planning\"],\"k\":[26,29],\"o\":0},\"clock730\":{\"a\":\"Clock Face Seven-Thirty\",\"b\":\"1F562\",\"j\":[\"seven_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,56],\"o\":0},\"male-detective\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F575-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F575-1F3FB-200D-2642\",\"image\":\"1f575-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":29,\"sheet_y\":20,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F575-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F575-1F3FC-200D-2642\",\"image\":\"1f575-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":29,\"sheet_y\":21,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F575-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F575-1F3FD-200D-2642\",\"image\":\"1f575-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":29,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F575-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F575-1F3FE-200D-2642\",\"image\":\"1f575-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":29,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F575-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F575-1F3FF-200D-2642\",\"image\":\"1f575-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":29,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F575-FE0F\",\"a\":\"Man Detective\",\"b\":\"1F575-FE0F-200D-2642-FE0F\",\"j\":[\"man_detective\",\"crime\"],\"k\":[29,19],\"o\":4},\"flag-mn\":{\"a\":\"Mongolia Flag\",\"b\":\"1F1F2-1F1F3\",\"j\":[\"flag_mongolia\",\"mn\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,9],\"o\":2},\"clock8\":{\"a\":\"Clock Face Eight Oclock\",\"b\":\"1F557\",\"j\":[\"eight_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,45],\"o\":0},\"female-detective\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F575-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F575-1F3FB-200D-2640\",\"image\":\"1f575-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":29,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F575-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F575-1F3FC-200D-2640\",\"image\":\"1f575-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":29,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F575-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F575-1F3FD-200D-2640\",\"image\":\"1f575-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":29,\"sheet_y\":16,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F575-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F575-1F3FE-200D-2640\",\"image\":\"1f575-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":29,\"sheet_y\":17,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F575-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F575-1F3FF-200D-2640\",\"image\":\"1f575-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":29,\"sheet_y\":18,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Detective\",\"b\":\"1F575-FE0F-200D-2640-FE0F\",\"j\":[\"woman_detective\",\"human\",\"spy\",\"detective\",\"female\",\"woman\"],\"k\":[29,13],\"o\":4},\"spiral_note_pad\":{\"a\":\"Spiral Notepad\",\"b\":\"1F5D2-FE0F\",\"c\":\"1F5D2\",\"j\":[\"spiral_notepad\",\"memo\",\"stationery\"],\"k\":[30,16],\"o\":0},\"m\":{\"a\":\"Circled Latin Capital Letter M\",\"b\":\"24C2-FE0F\",\"c\":\"24C2\",\"j\":[\"circled_m\",\"alphabet\",\"blue-circle\",\"letter\"],\"k\":[53,46],\"o\":0},\"new\":{\"a\":\"Squared New\",\"b\":\"1F195\",\"j\":[\"new_button\",\"blue-square\",\"words\",\"start\"],\"k\":[0,25],\"o\":0},\"flag-mo\":{\"a\":\"Macao Sar China Flag\",\"b\":\"1F1F2-1F1F4\",\"j\":[\"flag_macao_sar_china\",\"macao\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,10],\"o\":2},\"guardsman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F482-1F3FB\",\"non_qualified\":null,\"image\":\"1f482-1f3fb.png\",\"sheet_x\":24,\"sheet_y\":24,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F482-1F3FC\",\"non_qualified\":null,\"image\":\"1f482-1f3fc.png\",\"sheet_x\":24,\"sheet_y\":25,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F482-1F3FD\",\"non_qualified\":null,\"image\":\"1f482-1f3fd.png\",\"sheet_x\":24,\"sheet_y\":26,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F482-1F3FE\",\"non_qualified\":null,\"image\":\"1f482-1f3fe.png\",\"sheet_x\":24,\"sheet_y\":27,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F482-1F3FF\",\"non_qualified\":null,\"image\":\"1f482-1f3ff.png\",\"sheet_x\":24,\"sheet_y\":28,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F482-200D-2642-FE0F\",\"a\":\"Guardsman\",\"b\":\"1F482\",\"j\":[\"guard\",\"protect\"],\"k\":[24,23],\"o\":0},\"clock830\":{\"a\":\"Clock Face Eight-Thirty\",\"b\":\"1F563\",\"j\":[\"eight_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,57],\"o\":0},\"spiral_calendar_pad\":{\"a\":\"Spiral Calendar\",\"b\":\"1F5D3-FE0F\",\"c\":\"1F5D3\",\"j\":[\"spiral_calendar\",\"date\",\"schedule\",\"planning\"],\"k\":[30,17],\"o\":0},\"ng\":{\"a\":\"Squared Ng\",\"b\":\"1F196\",\"j\":[\"ng_button\",\"blue-square\",\"words\",\"shape\",\"icon\"],\"k\":[0,26],\"o\":0},\"flag-mp\":{\"a\":\"Northern Mariana Islands Flag\",\"b\":\"1F1F2-1F1F5\",\"j\":[\"flag_northern_mariana_islands\",\"northern\",\"mariana\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,11],\"o\":2},\"male-guard\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F482-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F482-1F3FB-200D-2642\",\"image\":\"1f482-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":18,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F482-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F482-1F3FC-200D-2642\",\"image\":\"1f482-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":19,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F482-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F482-1F3FD-200D-2642\",\"image\":\"1f482-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":20,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F482-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F482-1F3FE-200D-2642\",\"image\":\"1f482-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":21,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F482-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F482-1F3FF-200D-2642\",\"image\":\"1f482-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F482\",\"a\":\"Man Guard\",\"b\":\"1F482-200D-2642-FE0F\",\"c\":\"1F482-200D-2642\",\"j\":[\"man_guard\",\"uk\",\"gb\",\"british\",\"male\",\"guy\",\"royal\"],\"k\":[24,17],\"o\":4},\"card_index\":{\"a\":\"Card Index\",\"b\":\"1F4C7\",\"j\":[\"card_index\",\"business\",\"stationery\"],\"k\":[26,30],\"o\":0},\"clock9\":{\"a\":\"Clock Face Nine Oclock\",\"b\":\"1F558\",\"j\":[\"nine_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,46],\"o\":0},\"o2\":{\"a\":\"Negative Squared Latin Capital Letter O\",\"b\":\"1F17E-FE0F\",\"c\":\"1F17E\",\"j\":[\"o_button\",\"alphabet\",\"red-square\",\"letter\"],\"k\":[0,18],\"o\":0},\"flag-mq\":{\"a\":\"Martinique Flag\",\"b\":\"1F1F2-1F1F6\",\"j\":[\"flag_martinique\",\"mq\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,12],\"o\":2},\"female-guard\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F482-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F482-1F3FB-200D-2640\",\"image\":\"1f482-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F482-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F482-1F3FC-200D-2640\",\"image\":\"1f482-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F482-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F482-1F3FD-200D-2640\",\"image\":\"1f482-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F482-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F482-1F3FE-200D-2640\",\"image\":\"1f482-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F482-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F482-1F3FF-200D-2640\",\"image\":\"1f482-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":16,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Guard\",\"b\":\"1F482-200D-2640-FE0F\",\"c\":\"1F482-200D-2640\",\"j\":[\"woman_guard\",\"uk\",\"gb\",\"british\",\"female\",\"royal\",\"woman\"],\"k\":[24,11],\"o\":4},\"chart_with_upwards_trend\":{\"a\":\"Chart with Upwards Trend\",\"b\":\"1F4C8\",\"j\":[\"chart_increasing\",\"graph\",\"presentation\",\"stats\",\"recovery\",\"business\",\"economics\",\"money\",\"sales\",\"good\",\"success\"],\"k\":[26,31],\"o\":0},\"clock930\":{\"a\":\"Clock Face Nine-Thirty\",\"b\":\"1F564\",\"j\":[\"nine_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[29,0],\"o\":0},\"ok\":{\"a\":\"Squared Ok\",\"b\":\"1F197\",\"j\":[\"ok_button\",\"good\",\"agree\",\"yes\",\"blue-square\"],\"k\":[0,27],\"o\":0},\"flag-mr\":{\"a\":\"Mauritania Flag\",\"b\":\"1F1F2-1F1F7\",\"j\":[\"flag_mauritania\",\"mr\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,13],\"o\":2},\"chart_with_downwards_trend\":{\"a\":\"Chart with Downwards Trend\",\"b\":\"1F4C9\",\"j\":[\"chart_decreasing\",\"graph\",\"presentation\",\"stats\",\"recession\",\"business\",\"economics\",\"money\",\"sales\",\"bad\",\"failure\"],\"k\":[26,32],\"o\":0},\"clock10\":{\"a\":\"Clock Face Ten Oclock\",\"b\":\"1F559\",\"j\":[\"ten_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,47],\"o\":0},\"ninja\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F977-1F3FB\",\"non_qualified\":null,\"image\":\"1f977-1f3fb.png\",\"sheet_x\":42,\"sheet_y\":21,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F977-1F3FC\",\"non_qualified\":null,\"image\":\"1f977-1f3fc.png\",\"sheet_x\":42,\"sheet_y\":22,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F977-1F3FD\",\"non_qualified\":null,\"image\":\"1f977-1f3fd.png\",\"sheet_x\":42,\"sheet_y\":23,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F977-1F3FE\",\"non_qualified\":null,\"image\":\"1f977-1f3fe.png\",\"sheet_x\":42,\"sheet_y\":24,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F977-1F3FF\",\"non_qualified\":null,\"image\":\"1f977-1f3ff.png\",\"sheet_x\":42,\"sheet_y\":25,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Ninja\",\"b\":\"1F977\",\"j\":[\"ninja\",\"ninjutsu\",\"skills\",\"japanese\"],\"k\":[42,20],\"o\":13},\"parking\":{\"a\":\"Negative Squared Latin Capital Letter P\",\"b\":\"1F17F-FE0F\",\"c\":\"1F17F\",\"j\":[\"p_button\",\"cars\",\"blue-square\",\"alphabet\",\"letter\"],\"k\":[0,19],\"o\":0},\"flag-ms\":{\"a\":\"Montserrat Flag\",\"b\":\"1F1F2-1F1F8\",\"j\":[\"flag_montserrat\",\"ms\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,14],\"o\":2},\"construction_worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F477-1F3FB\",\"non_qualified\":null,\"image\":\"1f477-1f3fb.png\",\"sheet_x\":23,\"sheet_y\":27,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F477-1F3FC\",\"non_qualified\":null,\"image\":\"1f477-1f3fc.png\",\"sheet_x\":23,\"sheet_y\":28,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F477-1F3FD\",\"non_qualified\":null,\"image\":\"1f477-1f3fd.png\",\"sheet_x\":23,\"sheet_y\":29,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F477-1F3FE\",\"non_qualified\":null,\"image\":\"1f477-1f3fe.png\",\"sheet_x\":23,\"sheet_y\":30,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F477-1F3FF\",\"non_qualified\":null,\"image\":\"1f477-1f3ff.png\",\"sheet_x\":23,\"sheet_y\":31,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F477-200D-2642-FE0F\",\"a\":\"Construction Worker\",\"b\":\"1F477\",\"j\":[\"construction_worker\",\"labor\",\"build\"],\"k\":[23,26],\"o\":0},\"bar_chart\":{\"a\":\"Bar Chart\",\"b\":\"1F4CA\",\"j\":[\"bar_chart\",\"graph\",\"presentation\",\"stats\"],\"k\":[26,33],\"o\":0},\"clock1030\":{\"a\":\"Clock Face Ten-Thirty\",\"b\":\"1F565\",\"j\":[\"ten_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[29,1],\"o\":0},\"sos\":{\"a\":\"Squared Sos\",\"b\":\"1F198\",\"j\":[\"sos_button\",\"help\",\"red-square\",\"words\",\"emergency\",\"911\"],\"k\":[0,28],\"o\":0},\"flag-mt\":{\"a\":\"Malta Flag\",\"b\":\"1F1F2-1F1F9\",\"j\":[\"flag_malta\",\"mt\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,15],\"o\":2},\"male-construction-worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F477-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F477-1F3FB-200D-2642\",\"image\":\"1f477-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":23,\"sheet_y\":21,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F477-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F477-1F3FC-200D-2642\",\"image\":\"1f477-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":23,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F477-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F477-1F3FD-200D-2642\",\"image\":\"1f477-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":23,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F477-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F477-1F3FE-200D-2642\",\"image\":\"1f477-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":23,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F477-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F477-1F3FF-200D-2642\",\"image\":\"1f477-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":23,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F477\",\"a\":\"Man Construction Worker\",\"b\":\"1F477-200D-2642-FE0F\",\"c\":\"1F477-200D-2642\",\"j\":[\"man_construction_worker\",\"male\",\"human\",\"wip\",\"guy\",\"build\",\"construction\",\"worker\",\"labor\"],\"k\":[23,20],\"o\":4},\"clipboard\":{\"a\":\"Clipboard\",\"b\":\"1F4CB\",\"j\":[\"clipboard\",\"stationery\",\"documents\"],\"k\":[26,34],\"o\":0},\"clock11\":{\"a\":\"Clock Face Eleven Oclock\",\"b\":\"1F55A\",\"j\":[\"eleven_o_clock\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[28,48],\"o\":0},\"up\":{\"a\":\"Squared Up with Exclamation Mark\",\"b\":\"1F199\",\"j\":[\"up_button\",\"blue-square\",\"above\",\"high\"],\"k\":[0,29],\"o\":0},\"flag-mu\":{\"a\":\"Mauritius Flag\",\"b\":\"1F1F2-1F1FA\",\"j\":[\"flag_mauritius\",\"mu\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,16],\"o\":2},\"female-construction-worker\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F477-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F477-1F3FB-200D-2640\",\"image\":\"1f477-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F477-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F477-1F3FC-200D-2640\",\"image\":\"1f477-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":16,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F477-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F477-1F3FD-200D-2640\",\"image\":\"1f477-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":17,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F477-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F477-1F3FE-200D-2640\",\"image\":\"1f477-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":18,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F477-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F477-1F3FF-200D-2640\",\"image\":\"1f477-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":23,\"sheet_y\":19,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Construction Worker\",\"b\":\"1F477-200D-2640-FE0F\",\"c\":\"1F477-200D-2640\",\"j\":[\"woman_construction_worker\",\"female\",\"human\",\"wip\",\"build\",\"construction\",\"worker\",\"labor\",\"woman\"],\"k\":[23,14],\"o\":4},\"pushpin\":{\"a\":\"Pushpin\",\"b\":\"1F4CC\",\"j\":[\"pushpin\",\"stationery\",\"mark\",\"here\"],\"k\":[26,35],\"o\":0},\"clock1130\":{\"a\":\"Clock Face Eleven-Thirty\",\"b\":\"1F566\",\"j\":[\"eleven_thirty\",\"time\",\"late\",\"early\",\"schedule\"],\"k\":[29,2],\"o\":0},\"vs\":{\"a\":\"Squared Vs\",\"b\":\"1F19A\",\"j\":[\"vs_button\",\"words\",\"orange-square\"],\"k\":[0,30],\"o\":0},\"flag-mv\":{\"a\":\"Maldives Flag\",\"b\":\"1F1F2-1F1FB\",\"j\":[\"flag_maldives\",\"mv\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,17],\"o\":2},\"new_moon\":{\"a\":\"New Moon Symbol\",\"b\":\"1F311\",\"j\":[\"new_moon\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,31],\"o\":0},\"round_pushpin\":{\"a\":\"Round Pushpin\",\"b\":\"1F4CD\",\"j\":[\"round_pushpin\",\"stationery\",\"location\",\"map\",\"here\"],\"k\":[26,36],\"o\":0},\"prince\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F934-1F3FB\",\"non_qualified\":null,\"image\":\"1f934-1f3fb.png\",\"sheet_x\":39,\"sheet_y\":16,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F934-1F3FC\",\"non_qualified\":null,\"image\":\"1f934-1f3fc.png\",\"sheet_x\":39,\"sheet_y\":17,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F934-1F3FD\",\"non_qualified\":null,\"image\":\"1f934-1f3fd.png\",\"sheet_x\":39,\"sheet_y\":18,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F934-1F3FE\",\"non_qualified\":null,\"image\":\"1f934-1f3fe.png\",\"sheet_x\":39,\"sheet_y\":19,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F934-1F3FF\",\"non_qualified\":null,\"image\":\"1f934-1f3ff.png\",\"sheet_x\":39,\"sheet_y\":20,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Prince\",\"b\":\"1F934\",\"j\":[\"prince\",\"boy\",\"man\",\"male\",\"crown\",\"royal\",\"king\"],\"k\":[39,15],\"o\":3},\"flag-mw\":{\"a\":\"Malawi Flag\",\"b\":\"1F1F2-1F1FC\",\"j\":[\"flag_malawi\",\"mw\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,18],\"o\":2},\"koko\":{\"a\":\"Squared Katakana Koko\",\"b\":\"1F201\",\"j\":[\"japanese_here_button\",\"blue-square\",\"here\",\"katakana\",\"japanese\",\"destination\"],\"k\":[4,57],\"o\":0},\"waxing_crescent_moon\":{\"a\":\"Waxing Crescent Moon Symbol\",\"b\":\"1F312\",\"j\":[\"waxing_crescent_moon\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,32],\"o\":1},\"princess\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F478-1F3FB\",\"non_qualified\":null,\"image\":\"1f478-1f3fb.png\",\"sheet_x\":23,\"sheet_y\":33,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F478-1F3FC\",\"non_qualified\":null,\"image\":\"1f478-1f3fc.png\",\"sheet_x\":23,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F478-1F3FD\",\"non_qualified\":null,\"image\":\"1f478-1f3fd.png\",\"sheet_x\":23,\"sheet_y\":35,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F478-1F3FE\",\"non_qualified\":null,\"image\":\"1f478-1f3fe.png\",\"sheet_x\":23,\"sheet_y\":36,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F478-1F3FF\",\"non_qualified\":null,\"image\":\"1f478-1f3ff.png\",\"sheet_x\":23,\"sheet_y\":37,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Princess\",\"b\":\"1F478\",\"j\":[\"princess\",\"girl\",\"woman\",\"female\",\"blond\",\"crown\",\"royal\",\"queen\"],\"k\":[23,32],\"o\":0},\"paperclip\":{\"a\":\"Paperclip\",\"b\":\"1F4CE\",\"j\":[\"paperclip\",\"documents\",\"stationery\"],\"k\":[26,37],\"o\":0},\"flag-mx\":{\"a\":\"Mexico Flag\",\"b\":\"1F1F2-1F1FD\",\"j\":[\"flag_mexico\",\"mx\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,19],\"o\":2},\"sa\":{\"a\":\"Squared Katakana Sa\",\"b\":\"1F202-FE0F\",\"c\":\"1F202\",\"j\":[\"japanese_service_charge_button\",\"japanese\",\"blue-square\",\"katakana\"],\"k\":[5,0],\"o\":0},\"first_quarter_moon\":{\"a\":\"First Quarter Moon Symbol\",\"b\":\"1F313\",\"j\":[\"first_quarter_moon\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,33],\"o\":0},\"man_with_turban\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F473-1F3FB\",\"non_qualified\":null,\"image\":\"1f473-1f3fb.png\",\"sheet_x\":22,\"sheet_y\":49,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F473-1F3FC\",\"non_qualified\":null,\"image\":\"1f473-1f3fc.png\",\"sheet_x\":22,\"sheet_y\":50,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F473-1F3FD\",\"non_qualified\":null,\"image\":\"1f473-1f3fd.png\",\"sheet_x\":22,\"sheet_y\":51,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F473-1F3FE\",\"non_qualified\":null,\"image\":\"1f473-1f3fe.png\",\"sheet_x\":22,\"sheet_y\":52,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F473-1F3FF\",\"non_qualified\":null,\"image\":\"1f473-1f3ff.png\",\"sheet_x\":22,\"sheet_y\":53,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F473-200D-2642-FE0F\",\"a\":\"Man with Turban\",\"b\":\"1F473\",\"j\":[\"person_wearing_turban\",\"headdress\"],\"k\":[22,48],\"o\":0},\"linked_paperclips\":{\"a\":\"Linked Paperclips\",\"b\":\"1F587-FE0F\",\"c\":\"1F587\",\"j\":[\"linked_paperclips\",\"documents\",\"stationery\"],\"k\":[29,41],\"o\":0},\"flag-my\":{\"a\":\"Malaysia Flag\",\"b\":\"1F1F2-1F1FE\",\"j\":[\"flag_malaysia\",\"my\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,20],\"o\":2},\"u6708\":{\"a\":\"Squared Cjk Unified Ideograph-6708\",\"b\":\"1F237-FE0F\",\"c\":\"1F237\",\"j\":[\"japanese_monthly_amount_button\",\"chinese\",\"month\",\"moon\",\"japanese\",\"orange-square\",\"kanji\"],\"k\":[5,8],\"o\":0},\"moon\":{\"a\":\"Waxing Gibbous Moon Symbol\",\"b\":\"1F314\",\"j\":[\"waxing_gibbous_moon\",\"nature\",\"night\",\"sky\",\"gray\",\"twilight\",\"planet\",\"space\",\"evening\",\"sleep\"],\"k\":[5,34],\"n\":[\"waxing_gibbous_moon\"],\"o\":0},\"man-wearing-turban\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F473-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F473-1F3FB-200D-2642\",\"image\":\"1f473-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F473-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F473-1F3FC-200D-2642\",\"image\":\"1f473-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":44,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F473-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F473-1F3FD-200D-2642\",\"image\":\"1f473-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F473-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F473-1F3FE-200D-2642\",\"image\":\"1f473-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F473-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F473-1F3FF-200D-2642\",\"image\":\"1f473-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F473\",\"a\":\"Man Wearing Turban\",\"b\":\"1F473-200D-2642-FE0F\",\"c\":\"1F473-200D-2642\",\"j\":[\"man_wearing_turban\",\"male\",\"indian\",\"hinduism\",\"arabs\"],\"k\":[22,42],\"o\":4},\"straight_ruler\":{\"a\":\"Straight Ruler\",\"b\":\"1F4CF\",\"j\":[\"straight_ruler\",\"stationery\",\"calculate\",\"length\",\"math\",\"school\",\"drawing\",\"architect\",\"sketch\"],\"k\":[26,38],\"o\":0},\"flag-mz\":{\"a\":\"Mozambique Flag\",\"b\":\"1F1F2-1F1FF\",\"j\":[\"flag_mozambique\",\"mz\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,21],\"o\":2},\"u6709\":{\"a\":\"Squared Cjk Unified Ideograph-6709\",\"b\":\"1F236\",\"j\":[\"japanese_not_free_of_charge_button\",\"orange-square\",\"chinese\",\"have\",\"kanji\"],\"k\":[5,7],\"o\":0},\"full_moon\":{\"a\":\"Full Moon Symbol\",\"b\":\"1F315\",\"j\":[\"full_moon\",\"nature\",\"yellow\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,35],\"o\":0},\"woman-wearing-turban\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F473-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F473-1F3FB-200D-2640\",\"image\":\"1f473-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":37,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F473-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F473-1F3FC-200D-2640\",\"image\":\"1f473-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":38,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F473-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F473-1F3FD-200D-2640\",\"image\":\"1f473-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":39,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F473-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F473-1F3FE-200D-2640\",\"image\":\"1f473-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":40,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F473-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F473-1F3FF-200D-2640\",\"image\":\"1f473-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":22,\"sheet_y\":41,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Wearing Turban\",\"b\":\"1F473-200D-2640-FE0F\",\"c\":\"1F473-200D-2640\",\"j\":[\"woman_wearing_turban\",\"female\",\"indian\",\"hinduism\",\"arabs\",\"woman\"],\"k\":[22,36],\"o\":4},\"triangular_ruler\":{\"a\":\"Triangular Ruler\",\"b\":\"1F4D0\",\"j\":[\"triangular_ruler\",\"stationery\",\"math\",\"architect\",\"sketch\"],\"k\":[26,39],\"o\":0},\"flag-na\":{\"a\":\"Namibia Flag\",\"b\":\"1F1F3-1F1E6\",\"j\":[\"flag_namibia\",\"na\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,22],\"o\":2},\"u6307\":{\"a\":\"Squared Cjk Unified Ideograph-6307\",\"b\":\"1F22F\",\"j\":[\"japanese_reserved_button\",\"chinese\",\"point\",\"green-square\",\"kanji\"],\"k\":[5,2],\"o\":0},\"waning_gibbous_moon\":{\"a\":\"Waning Gibbous Moon Symbol\",\"b\":\"1F316\",\"j\":[\"waning_gibbous_moon\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\",\"waxing_gibbous_moon\"],\"k\":[5,36],\"o\":1},\"man_with_gua_pi_mao\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F472-1F3FB\",\"non_qualified\":null,\"image\":\"1f472-1f3fb.png\",\"sheet_x\":22,\"sheet_y\":31,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F472-1F3FC\",\"non_qualified\":null,\"image\":\"1f472-1f3fc.png\",\"sheet_x\":22,\"sheet_y\":32,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F472-1F3FD\",\"non_qualified\":null,\"image\":\"1f472-1f3fd.png\",\"sheet_x\":22,\"sheet_y\":33,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F472-1F3FE\",\"non_qualified\":null,\"image\":\"1f472-1f3fe.png\",\"sheet_x\":22,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F472-1F3FF\",\"non_qualified\":null,\"image\":\"1f472-1f3ff.png\",\"sheet_x\":22,\"sheet_y\":35,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man with Gua Pi Mao\",\"b\":\"1F472\",\"j\":[\"man_with_skullcap\",\"male\",\"boy\",\"chinese\"],\"k\":[22,30],\"o\":0},\"scissors\":{\"a\":\"Black Scissors\",\"b\":\"2702-FE0F\",\"c\":\"2702\",\"j\":[\"scissors\",\"stationery\",\"cut\"],\"k\":[55,44],\"o\":0},\"flag-nc\":{\"a\":\"New Caledonia Flag\",\"b\":\"1F1F3-1F1E8\",\"j\":[\"flag_new_caledonia\",\"new\",\"caledonia\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,23],\"o\":2},\"ideograph_advantage\":{\"a\":\"Circled Ideograph Advantage\",\"b\":\"1F250\",\"j\":[\"japanese_bargain_button\",\"chinese\",\"kanji\",\"obtain\",\"get\",\"circle\"],\"k\":[5,12],\"o\":0},\"last_quarter_moon\":{\"a\":\"Last Quarter Moon Symbol\",\"b\":\"1F317\",\"j\":[\"last_quarter_moon\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,37],\"o\":1},\"card_file_box\":{\"a\":\"Card File Box\",\"b\":\"1F5C3-FE0F\",\"c\":\"1F5C3\",\"j\":[\"card_file_box\",\"business\",\"stationery\"],\"k\":[30,13],\"o\":0},\"person_with_headscarf\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D5-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d5-1f3fb.png\",\"sheet_x\":49,\"sheet_y\":4,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D5-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d5-1f3fc.png\",\"sheet_x\":49,\"sheet_y\":5,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D5-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d5-1f3fd.png\",\"sheet_x\":49,\"sheet_y\":6,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D5-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d5-1f3fe.png\",\"sheet_x\":49,\"sheet_y\":7,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D5-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d5-1f3ff.png\",\"sheet_x\":49,\"sheet_y\":8,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person with Headscarf\",\"b\":\"1F9D5\",\"j\":[\"woman_with_headscarf\",\"female\",\"hijab\",\"mantilla\",\"tichel\"],\"k\":[49,3],\"o\":5},\"flag-ne\":{\"a\":\"Niger Flag\",\"b\":\"1F1F3-1F1EA\",\"j\":[\"flag_niger\",\"ne\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,24],\"o\":2},\"u5272\":{\"a\":\"Squared Cjk Unified Ideograph-5272\",\"b\":\"1F239\",\"j\":[\"japanese_discount_button\",\"cut\",\"divide\",\"chinese\",\"kanji\",\"pink-square\"],\"k\":[5,10],\"o\":0},\"waning_crescent_moon\":{\"a\":\"Waning Crescent Moon Symbol\",\"b\":\"1F318\",\"j\":[\"waning_crescent_moon\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,38],\"o\":1},\"file_cabinet\":{\"a\":\"File Cabinet\",\"b\":\"1F5C4-FE0F\",\"c\":\"1F5C4\",\"j\":[\"file_cabinet\",\"filing\",\"organizing\"],\"k\":[30,14],\"o\":0},\"person_in_tuxedo\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F935-1F3FB\",\"non_qualified\":null,\"image\":\"1f935-1f3fb.png\",\"sheet_x\":39,\"sheet_y\":34,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F935-1F3FC\",\"non_qualified\":null,\"image\":\"1f935-1f3fc.png\",\"sheet_x\":39,\"sheet_y\":35,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F935-1F3FD\",\"non_qualified\":null,\"image\":\"1f935-1f3fd.png\",\"sheet_x\":39,\"sheet_y\":36,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F935-1F3FE\",\"non_qualified\":null,\"image\":\"1f935-1f3fe.png\",\"sheet_x\":39,\"sheet_y\":37,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F935-1F3FF\",\"non_qualified\":null,\"image\":\"1f935-1f3ff.png\",\"sheet_x\":39,\"sheet_y\":38,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man in Tuxedo\",\"b\":\"1F935\",\"j\":[\"man_in_tuxedo\",\"couple\",\"marriage\",\"wedding\",\"groom\"],\"k\":[39,33],\"o\":3},\"flag-nf\":{\"a\":\"Norfolk Island Flag\",\"b\":\"1F1F3-1F1EB\",\"j\":[\"flag_norfolk_island\",\"norfolk\",\"island\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,25],\"o\":2},\"u7121\":{\"a\":\"Squared Cjk Unified Ideograph-7121\",\"b\":\"1F21A\",\"j\":[\"japanese_free_of_charge_button\",\"nothing\",\"chinese\",\"kanji\",\"japanese\",\"orange-square\"],\"k\":[5,1],\"o\":0},\"crescent_moon\":{\"a\":\"Crescent Moon\",\"b\":\"1F319\",\"j\":[\"crescent_moon\",\"night\",\"sleep\",\"sky\",\"evening\",\"magic\"],\"k\":[5,39],\"o\":0},\"wastebasket\":{\"a\":\"Wastebasket\",\"b\":\"1F5D1-FE0F\",\"c\":\"1F5D1\",\"j\":[\"wastebasket\",\"bin\",\"trash\",\"rubbish\",\"garbage\",\"toss\"],\"k\":[30,15],\"o\":0},\"man_in_tuxedo\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F935-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F935-1F3FB-200D-2642\",\"image\":\"1f935-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":28,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F935-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F935-1F3FC-200D-2642\",\"image\":\"1f935-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":29,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F935-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F935-1F3FD-200D-2642\",\"image\":\"1f935-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":30,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F935-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F935-1F3FE-200D-2642\",\"image\":\"1f935-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":31,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F935-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F935-1F3FF-200D-2642\",\"image\":\"1f935-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":39,\"sheet_y\":32,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man in Tuxedo\",\"b\":\"1F935-200D-2642-FE0F\",\"c\":\"1F935-200D-2642\",\"j\":[\"man in tuxedo\",\"formal\",\"fashion\"],\"k\":[39,27],\"o\":13},\"flag-ng\":{\"a\":\"Nigeria Flag\",\"b\":\"1F1F3-1F1EC\",\"j\":[\"flag_nigeria\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,26],\"o\":2},\"u7981\":{\"a\":\"Squared Cjk Unified Ideograph-7981\",\"b\":\"1F232\",\"j\":[\"japanese_prohibited_button\",\"kanji\",\"japanese\",\"chinese\",\"forbidden\",\"limit\",\"restricted\",\"red-square\"],\"k\":[5,3],\"o\":0},\"new_moon_with_face\":{\"a\":\"New Moon with Face\",\"b\":\"1F31A\",\"j\":[\"new_moon_face\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,40],\"o\":1},\"lock\":{\"a\":\"Lock\",\"b\":\"1F512\",\"j\":[\"locked\",\"security\",\"password\",\"padlock\"],\"k\":[27,46],\"o\":0},\"woman_in_tuxedo\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F935-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F935-1F3FB-200D-2640\",\"image\":\"1f935-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":22,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F935-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F935-1F3FC-200D-2640\",\"image\":\"1f935-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":23,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F935-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F935-1F3FD-200D-2640\",\"image\":\"1f935-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":24,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F935-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F935-1F3FE-200D-2640\",\"image\":\"1f935-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":25,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F935-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F935-1F3FF-200D-2640\",\"image\":\"1f935-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":39,\"sheet_y\":26,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman in Tuxedo\",\"b\":\"1F935-200D-2640-FE0F\",\"c\":\"1F935-200D-2640\",\"j\":[\"woman in tuxedo\",\"formal\",\"fashion\"],\"k\":[39,21],\"o\":13},\"flag-ni\":{\"a\":\"Nicaragua Flag\",\"b\":\"1F1F3-1F1EE\",\"j\":[\"flag_nicaragua\",\"ni\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,27],\"o\":2},\"accept\":{\"a\":\"Circled Ideograph Accept\",\"b\":\"1F251\",\"j\":[\"japanese_acceptable_button\",\"ok\",\"good\",\"chinese\",\"kanji\",\"agree\",\"yes\",\"orange-circle\"],\"k\":[5,13],\"o\":0},\"first_quarter_moon_with_face\":{\"a\":\"First Quarter Moon with Face\",\"b\":\"1F31B\",\"j\":[\"first_quarter_moon_face\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,41],\"o\":0},\"bride_with_veil\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F470-1F3FB\",\"non_qualified\":null,\"image\":\"1f470-1f3fb.png\",\"sheet_x\":22,\"sheet_y\":7,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F470-1F3FC\",\"non_qualified\":null,\"image\":\"1f470-1f3fc.png\",\"sheet_x\":22,\"sheet_y\":8,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F470-1F3FD\",\"non_qualified\":null,\"image\":\"1f470-1f3fd.png\",\"sheet_x\":22,\"sheet_y\":9,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F470-1F3FE\",\"non_qualified\":null,\"image\":\"1f470-1f3fe.png\",\"sheet_x\":22,\"sheet_y\":10,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F470-1F3FF\",\"non_qualified\":null,\"image\":\"1f470-1f3ff.png\",\"sheet_x\":22,\"sheet_y\":11,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Bride with Veil\",\"b\":\"1F470\",\"j\":[\"bride_with_veil\",\"couple\",\"marriage\",\"wedding\",\"woman\",\"bride\"],\"k\":[22,6],\"o\":0},\"unlock\":{\"a\":\"Open Lock\",\"b\":\"1F513\",\"j\":[\"unlocked\",\"privacy\",\"security\"],\"k\":[27,47],\"o\":0},\"flag-nl\":{\"a\":\"Netherlands Flag\",\"b\":\"1F1F3-1F1F1\",\"j\":[\"flag_netherlands\",\"nl\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,28],\"o\":2},\"u7533\":{\"a\":\"Squared Cjk Unified Ideograph-7533\",\"b\":\"1F238\",\"j\":[\"japanese_application_button\",\"chinese\",\"japanese\",\"kanji\",\"orange-square\"],\"k\":[5,9],\"o\":0},\"last_quarter_moon_with_face\":{\"a\":\"Last Quarter Moon with Face\",\"b\":\"1F31C\",\"j\":[\"last_quarter_moon_face\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,42],\"o\":0},\"man_with_veil\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F470-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F470-1F3FB-200D-2642\",\"image\":\"1f470-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":1,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F470-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F470-1F3FC-200D-2642\",\"image\":\"1f470-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":2,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F470-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F470-1F3FD-200D-2642\",\"image\":\"1f470-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":3,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F470-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F470-1F3FE-200D-2642\",\"image\":\"1f470-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":4,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F470-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F470-1F3FF-200D-2642\",\"image\":\"1f470-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":22,\"sheet_y\":5,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man with Veil\",\"b\":\"1F470-200D-2642-FE0F\",\"c\":\"1F470-200D-2642\",\"j\":[\"man with veil\",\"wedding\",\"marriage\"],\"k\":[22,0],\"o\":13},\"lock_with_ink_pen\":{\"a\":\"Lock with Ink Pen\",\"b\":\"1F50F\",\"j\":[\"locked_with_pen\",\"security\",\"secret\"],\"k\":[27,43],\"o\":0},\"flag-no\":{\"a\":\"Norway Flag\",\"b\":\"1F1F3-1F1F4\",\"j\":[\"flag_norway\",\"no\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,29],\"o\":2},\"u5408\":{\"a\":\"Squared Cjk Unified Ideograph-5408\",\"b\":\"1F234\",\"j\":[\"japanese_passing_grade_button\",\"japanese\",\"chinese\",\"join\",\"kanji\",\"red-square\"],\"k\":[5,5],\"o\":0},\"thermometer\":{\"a\":\"Thermometer\",\"b\":\"1F321-FE0F\",\"c\":\"1F321\",\"j\":[\"thermometer\",\"weather\",\"temperature\",\"hot\",\"cold\"],\"k\":[5,47],\"o\":0},\"woman_with_veil\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F470-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F470-1F3FB-200D-2640\",\"image\":\"1f470-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":53,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F470-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F470-1F3FC-200D-2640\",\"image\":\"1f470-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":54,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F470-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F470-1F3FD-200D-2640\",\"image\":\"1f470-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":55,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F470-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F470-1F3FE-200D-2640\",\"image\":\"1f470-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":56,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F470-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F470-1F3FF-200D-2640\",\"image\":\"1f470-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":21,\"sheet_y\":57,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman with Veil\",\"b\":\"1F470-200D-2640-FE0F\",\"c\":\"1F470-200D-2640\",\"j\":[\"woman with veil\",\"wedding\",\"marriage\"],\"k\":[21,52],\"o\":13},\"closed_lock_with_key\":{\"a\":\"Closed Lock with Key\",\"b\":\"1F510\",\"j\":[\"locked_with_key\",\"security\",\"privacy\"],\"k\":[27,44],\"o\":0},\"flag-np\":{\"a\":\"Nepal Flag\",\"b\":\"1F1F3-1F1F5\",\"j\":[\"flag_nepal\",\"np\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,30],\"o\":2},\"u7a7a\":{\"a\":\"Squared Cjk Unified Ideograph-7a7a\",\"b\":\"1F233\",\"j\":[\"japanese_vacancy_button\",\"kanji\",\"japanese\",\"chinese\",\"empty\",\"sky\",\"blue-square\"],\"k\":[5,4],\"o\":0},\"key\":{\"a\":\"Key\",\"b\":\"1F511\",\"j\":[\"key\",\"lock\",\"door\",\"password\"],\"k\":[27,45],\"o\":0},\"pregnant_woman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F930-1F3FB\",\"non_qualified\":null,\"image\":\"1f930-1f3fb.png\",\"sheet_x\":38,\"sheet_y\":50,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F930-1F3FC\",\"non_qualified\":null,\"image\":\"1f930-1f3fc.png\",\"sheet_x\":38,\"sheet_y\":51,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F930-1F3FD\",\"non_qualified\":null,\"image\":\"1f930-1f3fd.png\",\"sheet_x\":38,\"sheet_y\":52,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F930-1F3FE\",\"non_qualified\":null,\"image\":\"1f930-1f3fe.png\",\"sheet_x\":38,\"sheet_y\":53,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F930-1F3FF\",\"non_qualified\":null,\"image\":\"1f930-1f3ff.png\",\"sheet_x\":38,\"sheet_y\":54,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Pregnant Woman\",\"b\":\"1F930\",\"j\":[\"pregnant_woman\",\"baby\"],\"k\":[38,49],\"o\":3},\"sunny\":{\"a\":\"Black Sun with Rays\",\"b\":\"2600-FE0F\",\"c\":\"2600\",\"j\":[\"sun\",\"weather\",\"nature\",\"brightness\",\"summer\",\"beach\",\"spring\"],\"k\":[53,55],\"o\":0},\"flag-nr\":{\"a\":\"Nauru Flag\",\"b\":\"1F1F3-1F1F7\",\"j\":[\"flag_nauru\",\"nr\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,31],\"o\":2},\"full_moon_with_face\":{\"a\":\"Full Moon with Face\",\"b\":\"1F31D\",\"j\":[\"full_moon_face\",\"nature\",\"twilight\",\"planet\",\"space\",\"night\",\"evening\",\"sleep\"],\"k\":[5,43],\"o\":1},\"old_key\":{\"a\":\"Old Key\",\"b\":\"1F5DD-FE0F\",\"c\":\"1F5DD\",\"j\":[\"old_key\",\"lock\",\"door\",\"password\"],\"k\":[30,19],\"o\":0},\"breast-feeding\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F931-1F3FB\",\"non_qualified\":null,\"image\":\"1f931-1f3fb.png\",\"sheet_x\":38,\"sheet_y\":56,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F931-1F3FC\",\"non_qualified\":null,\"image\":\"1f931-1f3fc.png\",\"sheet_x\":38,\"sheet_y\":57,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F931-1F3FD\",\"non_qualified\":null,\"image\":\"1f931-1f3fd.png\",\"sheet_x\":39,\"sheet_y\":0,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F931-1F3FE\",\"non_qualified\":null,\"image\":\"1f931-1f3fe.png\",\"sheet_x\":39,\"sheet_y\":1,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F931-1F3FF\",\"non_qualified\":null,\"image\":\"1f931-1f3ff.png\",\"sheet_x\":39,\"sheet_y\":2,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Breast-Feeding\",\"b\":\"1F931\",\"j\":[\"breast_feeding\",\"nursing\",\"baby\"],\"k\":[38,55],\"o\":5},\"congratulations\":{\"a\":\"Circled Ideograph Congratulation\",\"b\":\"3297-FE0F\",\"c\":\"3297\",\"j\":[\"japanese_congratulations_button\",\"chinese\",\"kanji\",\"japanese\",\"red-circle\"],\"k\":[56,50],\"o\":0},\"flag-nu\":{\"a\":\"Niue Flag\",\"b\":\"1F1F3-1F1FA\",\"j\":[\"flag_niue\",\"nu\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,32],\"o\":2},\"sun_with_face\":{\"a\":\"Sun with Face\",\"b\":\"1F31E\",\"j\":[\"sun_with_face\",\"nature\",\"morning\",\"sky\"],\"k\":[5,44],\"o\":1},\"woman_feeding_baby\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f37c.png\",\"sheet_x\":17,\"sheet_y\":33,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f37c.png\",\"sheet_x\":17,\"sheet_y\":34,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f37c.png\",\"sheet_x\":17,\"sheet_y\":35,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f37c.png\",\"sheet_x\":17,\"sheet_y\":36,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f37c.png\",\"sheet_x\":17,\"sheet_y\":37,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Feeding Baby\",\"b\":\"1F469-200D-1F37C\",\"j\":[\"woman feeding baby\",\"birth\",\"food\"],\"k\":[17,32],\"o\":13},\"hammer\":{\"a\":\"Hammer\",\"b\":\"1F528\",\"j\":[\"hammer\",\"tools\",\"build\",\"create\"],\"k\":[28,10],\"o\":0},\"secret\":{\"a\":\"Circled Ideograph Secret\",\"b\":\"3299-FE0F\",\"c\":\"3299\",\"j\":[\"japanese_secret_button\",\"privacy\",\"chinese\",\"sshh\",\"kanji\",\"red-circle\"],\"k\":[56,51],\"o\":0},\"flag-nz\":{\"a\":\"New Zealand Flag\",\"b\":\"1F1F3-1F1FF\",\"j\":[\"flag_new_zealand\",\"new\",\"zealand\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,33],\"o\":2},\"u55b6\":{\"a\":\"Squared Cjk Unified Ideograph-55b6\",\"b\":\"1F23A\",\"j\":[\"japanese_open_for_business_button\",\"japanese\",\"opening hours\",\"orange-square\"],\"k\":[5,11],\"o\":0},\"man_feeding_baby\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f37c.png\",\"sheet_x\":14,\"sheet_y\":40,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f37c.png\",\"sheet_x\":14,\"sheet_y\":41,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f37c.png\",\"sheet_x\":14,\"sheet_y\":42,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f37c.png\",\"sheet_x\":14,\"sheet_y\":43,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f37c.png\",\"sheet_x\":14,\"sheet_y\":44,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Feeding Baby\",\"b\":\"1F468-200D-1F37C\",\"j\":[\"man feeding baby\",\"birth\",\"food\"],\"k\":[14,39],\"o\":13},\"ringed_planet\":{\"a\":\"Ringed Planet\",\"b\":\"1FA90\",\"j\":[\"ringed_planet\",\"outerspace\"],\"k\":[52,32],\"o\":12},\"axe\":{\"a\":\"Axe\",\"b\":\"1FA93\",\"j\":[\"axe\",\"tool\",\"chop\",\"cut\"],\"k\":[52,35],\"o\":12},\"flag-om\":{\"a\":\"Oman Flag\",\"b\":\"1F1F4-1F1F2\",\"j\":[\"flag_oman\",\"om_symbol\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,34],\"o\":2},\"u6e80\":{\"a\":\"Squared Cjk Unified Ideograph-6e80\",\"b\":\"1F235\",\"j\":[\"japanese_no_vacancy_button\",\"full\",\"chinese\",\"japanese\",\"red-square\",\"kanji\"],\"k\":[5,6],\"o\":0},\"person_feeding_baby\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f37c.png\",\"sheet_x\":45,\"sheet_y\":48,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f37c.png\",\"sheet_x\":45,\"sheet_y\":49,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f37c.png\",\"sheet_x\":45,\"sheet_y\":50,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f37c.png\",\"sheet_x\":45,\"sheet_y\":51,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F37C\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f37c.png\",\"sheet_x\":45,\"sheet_y\":52,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person Feeding Baby\",\"b\":\"1F9D1-200D-1F37C\",\"j\":[\"person feeding baby\",\"birth\",\"food\"],\"k\":[45,47],\"o\":13},\"pick\":{\"a\":\"Pick\",\"b\":\"26CF-FE0F\",\"c\":\"26CF\",\"j\":[\"pick\",\"tools\",\"dig\"],\"k\":[55,10],\"o\":0},\"star\":{\"a\":\"White Medium Star\",\"b\":\"2B50\",\"j\":[\"star\",\"night\",\"yellow\"],\"k\":[56,46],\"o\":0},\"flag-pa\":{\"a\":\"Panama Flag\",\"b\":\"1F1F5-1F1E6\",\"j\":[\"flag_panama\",\"pa\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,35],\"o\":2},\"star2\":{\"a\":\"Glowing Star\",\"b\":\"1F31F\",\"j\":[\"glowing_star\",\"night\",\"sparkle\",\"awesome\",\"good\",\"magic\"],\"k\":[5,45],\"o\":0},\"angel\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F47C-1F3FB\",\"non_qualified\":null,\"image\":\"1f47c-1f3fb.png\",\"sheet_x\":23,\"sheet_y\":42,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F47C-1F3FC\",\"non_qualified\":null,\"image\":\"1f47c-1f3fc.png\",\"sheet_x\":23,\"sheet_y\":43,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F47C-1F3FD\",\"non_qualified\":null,\"image\":\"1f47c-1f3fd.png\",\"sheet_x\":23,\"sheet_y\":44,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F47C-1F3FE\",\"non_qualified\":null,\"image\":\"1f47c-1f3fe.png\",\"sheet_x\":23,\"sheet_y\":45,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F47C-1F3FF\",\"non_qualified\":null,\"image\":\"1f47c-1f3ff.png\",\"sheet_x\":23,\"sheet_y\":46,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Baby Angel\",\"b\":\"1F47C\",\"j\":[\"baby_angel\",\"heaven\",\"wings\",\"halo\"],\"k\":[23,41],\"o\":0},\"red_circle\":{\"a\":\"Large Red Circle\",\"b\":\"1F534\",\"j\":[\"red_circle\",\"shape\",\"error\",\"danger\"],\"k\":[28,22],\"o\":0},\"hammer_and_pick\":{\"a\":\"Hammer and Pick\",\"b\":\"2692-FE0F\",\"c\":\"2692\",\"j\":[\"hammer_and_pick\",\"tools\",\"build\",\"create\"],\"k\":[54,46],\"o\":1},\"flag-pe\":{\"a\":\"Peru Flag\",\"b\":\"1F1F5-1F1EA\",\"j\":[\"flag_peru\",\"pe\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,36],\"o\":2},\"stars\":{\"a\":\"Shooting Star\",\"b\":\"1F320\",\"j\":[\"shooting_star\",\"night\",\"photo\"],\"k\":[5,46],\"o\":0},\"santa\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F385-1F3FB\",\"non_qualified\":null,\"image\":\"1f385-1f3fb.png\",\"sheet_x\":7,\"sheet_y\":30,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F385-1F3FC\",\"non_qualified\":null,\"image\":\"1f385-1f3fc.png\",\"sheet_x\":7,\"sheet_y\":31,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F385-1F3FD\",\"non_qualified\":null,\"image\":\"1f385-1f3fd.png\",\"sheet_x\":7,\"sheet_y\":32,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F385-1F3FE\",\"non_qualified\":null,\"image\":\"1f385-1f3fe.png\",\"sheet_x\":7,\"sheet_y\":33,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F385-1F3FF\",\"non_qualified\":null,\"image\":\"1f385-1f3ff.png\",\"sheet_x\":7,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Father Christmas\",\"b\":\"1F385\",\"j\":[\"santa_claus\",\"festival\",\"man\",\"male\",\"xmas\",\"father christmas\"],\"k\":[7,29],\"o\":0},\"hammer_and_wrench\":{\"a\":\"Hammer and Wrench\",\"b\":\"1F6E0-FE0F\",\"c\":\"1F6E0\",\"j\":[\"hammer_and_wrench\",\"tools\",\"build\",\"create\"],\"k\":[36,35],\"o\":0},\"large_orange_circle\":{\"a\":\"Large Orange Circle\",\"b\":\"1F7E0\",\"j\":[\"orange_circle\",\"round\"],\"k\":[36,55],\"o\":12},\"flag-pf\":{\"a\":\"French Polynesia Flag\",\"b\":\"1F1F5-1F1EB\",\"j\":[\"flag_french_polynesia\",\"french\",\"polynesia\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,37],\"o\":2},\"milky_way\":{\"a\":\"Milky Way\",\"b\":\"1F30C\",\"j\":[\"milky_way\",\"photo\",\"space\",\"stars\"],\"k\":[5,26],\"o\":0},\"dagger_knife\":{\"a\":\"Dagger\",\"b\":\"1F5E1-FE0F\",\"c\":\"1F5E1\",\"j\":[\"dagger\",\"weapon\"],\"k\":[30,21],\"o\":0},\"large_yellow_circle\":{\"a\":\"Large Yellow Circle\",\"b\":\"1F7E1\",\"j\":[\"yellow_circle\",\"round\"],\"k\":[36,56],\"o\":12},\"mrs_claus\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F936-1F3FB\",\"non_qualified\":null,\"image\":\"1f936-1f3fb.png\",\"sheet_x\":39,\"sheet_y\":40,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F936-1F3FC\",\"non_qualified\":null,\"image\":\"1f936-1f3fc.png\",\"sheet_x\":39,\"sheet_y\":41,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F936-1F3FD\",\"non_qualified\":null,\"image\":\"1f936-1f3fd.png\",\"sheet_x\":39,\"sheet_y\":42,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F936-1F3FE\",\"non_qualified\":null,\"image\":\"1f936-1f3fe.png\",\"sheet_x\":39,\"sheet_y\":43,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F936-1F3FF\",\"non_qualified\":null,\"image\":\"1f936-1f3ff.png\",\"sheet_x\":39,\"sheet_y\":44,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Mother Christmas\",\"b\":\"1F936\",\"j\":[\"mrs_claus\",\"woman\",\"female\",\"xmas\",\"mother christmas\"],\"k\":[39,39],\"n\":[\"mother_christmas\"],\"o\":3},\"flag-pg\":{\"a\":\"Papua New Guinea Flag\",\"b\":\"1F1F5-1F1EC\",\"j\":[\"flag_papua_new_guinea\",\"papua\",\"new\",\"guinea\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,38],\"o\":2},\"large_green_circle\":{\"a\":\"Large Green Circle\",\"b\":\"1F7E2\",\"j\":[\"green_circle\",\"round\"],\"k\":[36,57],\"o\":12},\"mx_claus\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F384\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f384.png\",\"sheet_x\":45,\"sheet_y\":54,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F384\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f384.png\",\"sheet_x\":45,\"sheet_y\":55,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F384\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f384.png\",\"sheet_x\":45,\"sheet_y\":56,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F384\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f384.png\",\"sheet_x\":45,\"sheet_y\":57,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F384\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f384.png\",\"sheet_x\":46,\"sheet_y\":0,\"added_in\":\"13.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Mx Claus\",\"b\":\"1F9D1-200D-1F384\",\"j\":[\"mx claus\",\"christmas\"],\"k\":[45,53],\"o\":13},\"cloud\":{\"a\":\"Cloud\",\"b\":\"2601-FE0F\",\"c\":\"2601\",\"j\":[\"cloud\",\"weather\",\"sky\"],\"k\":[53,56],\"o\":0},\"crossed_swords\":{\"a\":\"Crossed Swords\",\"b\":\"2694-FE0F\",\"c\":\"2694\",\"j\":[\"crossed_swords\",\"weapon\"],\"k\":[54,48],\"o\":1},\"flag-ph\":{\"a\":\"Philippines Flag\",\"b\":\"1F1F5-1F1ED\",\"j\":[\"flag_philippines\",\"ph\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,39],\"o\":2},\"gun\":{\"a\":\"Pistol\",\"b\":\"1F52B\",\"j\":[\"pistol\",\"violence\",\"weapon\",\"pistol\",\"revolver\"],\"k\":[28,13],\"o\":0},\"large_blue_circle\":{\"a\":\"Large Blue Circle\",\"b\":\"1F535\",\"j\":[\"blue_circle\",\"shape\",\"icon\",\"button\"],\"k\":[28,23],\"o\":0},\"superhero\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9B8-1F3FB\",\"non_qualified\":null,\"image\":\"1f9b8-1f3fb.png\",\"sheet_x\":43,\"sheet_y\":50,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9B8-1F3FC\",\"non_qualified\":null,\"image\":\"1f9b8-1f3fc.png\",\"sheet_x\":43,\"sheet_y\":51,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9B8-1F3FD\",\"non_qualified\":null,\"image\":\"1f9b8-1f3fd.png\",\"sheet_x\":43,\"sheet_y\":52,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9B8-1F3FE\",\"non_qualified\":null,\"image\":\"1f9b8-1f3fe.png\",\"sheet_x\":43,\"sheet_y\":53,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9B8-1F3FF\",\"non_qualified\":null,\"image\":\"1f9b8-1f3ff.png\",\"sheet_x\":43,\"sheet_y\":54,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Superhero\",\"b\":\"1F9B8\",\"j\":[\"superhero\",\"marvel\"],\"k\":[43,49],\"o\":11},\"partly_sunny\":{\"a\":\"Sun Behind Cloud\",\"b\":\"26C5\",\"j\":[\"sun_behind_cloud\",\"weather\",\"nature\",\"cloudy\",\"morning\",\"fall\",\"spring\"],\"k\":[55,7],\"o\":0},\"flag-pk\":{\"a\":\"Pakistan Flag\",\"b\":\"1F1F5-1F1F0\",\"j\":[\"flag_pakistan\",\"pk\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,40],\"o\":2},\"large_purple_circle\":{\"a\":\"Large Purple Circle\",\"b\":\"1F7E3\",\"j\":[\"purple_circle\",\"round\"],\"k\":[37,0],\"o\":12},\"male_superhero\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9B8-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9B8-1F3FB-200D-2642\",\"image\":\"1f9b8-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":43,\"sheet_y\":44,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9B8-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9B8-1F3FC-200D-2642\",\"image\":\"1f9b8-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":43,\"sheet_y\":45,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9B8-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9B8-1F3FD-200D-2642\",\"image\":\"1f9b8-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":43,\"sheet_y\":46,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9B8-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9B8-1F3FE-200D-2642\",\"image\":\"1f9b8-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":43,\"sheet_y\":47,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9B8-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9B8-1F3FF-200D-2642\",\"image\":\"1f9b8-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":43,\"sheet_y\":48,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Superhero\",\"b\":\"1F9B8-200D-2642-FE0F\",\"c\":\"1F9B8-200D-2642\",\"j\":[\"man_superhero\",\"man\",\"male\",\"good\",\"hero\",\"superpowers\"],\"k\":[43,43],\"o\":11},\"boomerang\":{\"a\":\"Boomerang\",\"b\":\"1FA83\",\"j\":[\"boomerang\",\"weapon\"],\"k\":[52,28],\"o\":13},\"thunder_cloud_and_rain\":{\"a\":\"Cloud with Lightning and Rain\",\"b\":\"26C8-FE0F\",\"c\":\"26C8\",\"j\":[\"cloud_with_lightning_and_rain\",\"weather\",\"lightning\"],\"k\":[55,8],\"o\":0},\"flag-pl\":{\"a\":\"Poland Flag\",\"b\":\"1F1F5-1F1F1\",\"j\":[\"flag_poland\",\"pl\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,41],\"o\":2},\"mostly_sunny\":{\"a\":\"Sun Behind Small Cloud\",\"b\":\"1F324-FE0F\",\"c\":\"1F324\",\"j\":[\"sun_behind_small_cloud\",\"weather\"],\"k\":[5,48],\"n\":[\"sun_small_cloud\"],\"o\":0},\"bow_and_arrow\":{\"a\":\"Bow and Arrow\",\"b\":\"1F3F9\",\"j\":[\"bow_and_arrow\",\"sports\"],\"k\":[11,11],\"o\":1},\"large_brown_circle\":{\"a\":\"Large Brown Circle\",\"b\":\"1F7E4\",\"j\":[\"brown_circle\",\"round\"],\"k\":[37,1],\"o\":12},\"female_superhero\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9B8-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9B8-1F3FB-200D-2640\",\"image\":\"1f9b8-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":43,\"sheet_y\":38,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9B8-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9B8-1F3FC-200D-2640\",\"image\":\"1f9b8-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":43,\"sheet_y\":39,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9B8-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9B8-1F3FD-200D-2640\",\"image\":\"1f9b8-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":43,\"sheet_y\":40,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9B8-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9B8-1F3FE-200D-2640\",\"image\":\"1f9b8-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":43,\"sheet_y\":41,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9B8-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9B8-1F3FF-200D-2640\",\"image\":\"1f9b8-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":43,\"sheet_y\":42,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Superhero\",\"b\":\"1F9B8-200D-2640-FE0F\",\"c\":\"1F9B8-200D-2640\",\"j\":[\"woman_superhero\",\"woman\",\"female\",\"good\",\"heroine\",\"superpowers\"],\"k\":[43,37],\"o\":11},\"flag-pm\":{\"a\":\"St. Pierre & Miquelon Flag\",\"b\":\"1F1F5-1F1F2\",\"j\":[\"flag_st_pierre_miquelon\",\"saint\",\"pierre\",\"miquelon\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,42],\"o\":2},\"barely_sunny\":{\"a\":\"Sun Behind Large Cloud\",\"b\":\"1F325-FE0F\",\"c\":\"1F325\",\"j\":[\"sun_behind_large_cloud\",\"weather\"],\"k\":[5,49],\"n\":[\"sun_behind_cloud\"],\"o\":0},\"shield\":{\"a\":\"Shield\",\"b\":\"1F6E1-FE0F\",\"c\":\"1F6E1\",\"j\":[\"shield\",\"protection\",\"security\"],\"k\":[36,36],\"o\":0},\"supervillain\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9B9-1F3FB\",\"non_qualified\":null,\"image\":\"1f9b9-1f3fb.png\",\"sheet_x\":44,\"sheet_y\":10,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9B9-1F3FC\",\"non_qualified\":null,\"image\":\"1f9b9-1f3fc.png\",\"sheet_x\":44,\"sheet_y\":11,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9B9-1F3FD\",\"non_qualified\":null,\"image\":\"1f9b9-1f3fd.png\",\"sheet_x\":44,\"sheet_y\":12,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9B9-1F3FE\",\"non_qualified\":null,\"image\":\"1f9b9-1f3fe.png\",\"sheet_x\":44,\"sheet_y\":13,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9B9-1F3FF\",\"non_qualified\":null,\"image\":\"1f9b9-1f3ff.png\",\"sheet_x\":44,\"sheet_y\":14,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Supervillain\",\"b\":\"1F9B9\",\"j\":[\"supervillain\",\"marvel\"],\"k\":[44,9],\"o\":11},\"black_circle\":{\"a\":\"Medium Black Circle\",\"b\":\"26AB\",\"j\":[\"black_circle\",\"shape\",\"button\",\"round\"],\"k\":[55,1],\"o\":0},\"flag-pn\":{\"a\":\"Pitcairn Islands Flag\",\"b\":\"1F1F5-1F1F3\",\"j\":[\"flag_pitcairn_islands\",\"pitcairn\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,43],\"o\":2},\"partly_sunny_rain\":{\"a\":\"Sun Behind Rain Cloud\",\"b\":\"1F326-FE0F\",\"c\":\"1F326\",\"j\":[\"sun_behind_rain_cloud\",\"weather\"],\"k\":[5,50],\"n\":[\"sun_behind_rain_cloud\"],\"o\":0},\"male_supervillain\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9B9-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9B9-1F3FB-200D-2642\",\"image\":\"1f9b9-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":4,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9B9-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9B9-1F3FC-200D-2642\",\"image\":\"1f9b9-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":5,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9B9-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9B9-1F3FD-200D-2642\",\"image\":\"1f9b9-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":6,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9B9-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9B9-1F3FE-200D-2642\",\"image\":\"1f9b9-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":7,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9B9-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9B9-1F3FF-200D-2642\",\"image\":\"1f9b9-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":8,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Supervillain\",\"b\":\"1F9B9-200D-2642-FE0F\",\"c\":\"1F9B9-200D-2642\",\"j\":[\"man_supervillain\",\"man\",\"male\",\"evil\",\"bad\",\"criminal\",\"hero\",\"superpowers\"],\"k\":[44,3],\"o\":11},\"carpentry_saw\":{\"a\":\"Carpentry Saw\",\"b\":\"1FA9A\",\"j\":[\"carpentry saw\",\"cut\",\"chop\"],\"k\":[52,42],\"o\":13},\"white_circle\":{\"a\":\"Medium White Circle\",\"b\":\"26AA\",\"j\":[\"white_circle\",\"shape\",\"round\"],\"k\":[55,0],\"o\":0},\"flag-pr\":{\"a\":\"Puerto Rico Flag\",\"b\":\"1F1F5-1F1F7\",\"j\":[\"flag_puerto_rico\",\"puerto\",\"rico\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,44],\"o\":2},\"rain_cloud\":{\"a\":\"Cloud with Rain\",\"b\":\"1F327-FE0F\",\"c\":\"1F327\",\"j\":[\"cloud_with_rain\",\"weather\"],\"k\":[5,51],\"o\":0},\"wrench\":{\"a\":\"Wrench\",\"b\":\"1F527\",\"j\":[\"wrench\",\"tools\",\"diy\",\"ikea\",\"fix\",\"maintainer\"],\"k\":[28,9],\"o\":0},\"large_red_square\":{\"a\":\"Large Red Square\",\"b\":\"1F7E5\",\"j\":[\"red_square\"],\"k\":[37,2],\"o\":12},\"female_supervillain\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9B9-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9B9-1F3FB-200D-2640\",\"image\":\"1f9b9-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":43,\"sheet_y\":56,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9B9-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9B9-1F3FC-200D-2640\",\"image\":\"1f9b9-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":43,\"sheet_y\":57,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9B9-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9B9-1F3FD-200D-2640\",\"image\":\"1f9b9-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":0,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9B9-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9B9-1F3FE-200D-2640\",\"image\":\"1f9b9-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":1,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9B9-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9B9-1F3FF-200D-2640\",\"image\":\"1f9b9-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":2,\"added_in\":\"11.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Supervillain\",\"b\":\"1F9B9-200D-2640-FE0F\",\"c\":\"1F9B9-200D-2640\",\"j\":[\"woman_supervillain\",\"woman\",\"female\",\"evil\",\"bad\",\"criminal\",\"heroine\",\"superpowers\"],\"k\":[43,55],\"o\":11},\"flag-ps\":{\"a\":\"Palestinian Territories Flag\",\"b\":\"1F1F5-1F1F8\",\"j\":[\"flag_palestinian_territories\",\"palestine\",\"palestinian\",\"territories\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,45],\"o\":2},\"snow_cloud\":{\"a\":\"Cloud with Snow\",\"b\":\"1F328-FE0F\",\"c\":\"1F328\",\"j\":[\"cloud_with_snow\",\"weather\"],\"k\":[5,52],\"o\":0},\"large_orange_square\":{\"a\":\"Large Orange Square\",\"b\":\"1F7E7\",\"j\":[\"orange_square\"],\"k\":[37,4],\"o\":12},\"mage\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D9-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d9-1f3fb.png\",\"sheet_x\":50,\"sheet_y\":18,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D9-1F3FB-200D-2640-FE0F\"},\"1F3FC\":{\"unified\":\"1F9D9-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d9-1f3fc.png\",\"sheet_x\":50,\"sheet_y\":19,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D9-1F3FC-200D-2640-FE0F\"},\"1F3FD\":{\"unified\":\"1F9D9-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d9-1f3fd.png\",\"sheet_x\":50,\"sheet_y\":20,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D9-1F3FD-200D-2640-FE0F\"},\"1F3FE\":{\"unified\":\"1F9D9-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d9-1f3fe.png\",\"sheet_x\":50,\"sheet_y\":21,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D9-1F3FE-200D-2640-FE0F\"},\"1F3FF\":{\"unified\":\"1F9D9-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d9-1f3ff.png\",\"sheet_x\":50,\"sheet_y\":22,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D9-1F3FF-200D-2640-FE0F\"}},\"obsoleted_by\":\"1F9D9-200D-2640-FE0F\",\"a\":\"Mage\",\"b\":\"1F9D9\",\"j\":[\"mage\",\"magic\"],\"k\":[50,17],\"o\":5},\"screwdriver\":{\"a\":\"Screwdriver\",\"b\":\"1FA9B\",\"j\":[\"screwdriver\",\"tools\"],\"k\":[52,43],\"o\":13},\"flag-pt\":{\"a\":\"Portugal Flag\",\"b\":\"1F1F5-1F1F9\",\"j\":[\"flag_portugal\",\"pt\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,46],\"o\":2},\"lightning\":{\"a\":\"Cloud with Lightning\",\"b\":\"1F329-FE0F\",\"c\":\"1F329\",\"j\":[\"cloud_with_lightning\",\"weather\",\"thunder\"],\"k\":[5,53],\"n\":[\"lightning_cloud\"],\"o\":0},\"nut_and_bolt\":{\"a\":\"Nut and Bolt\",\"b\":\"1F529\",\"j\":[\"nut_and_bolt\",\"handy\",\"tools\",\"fix\"],\"k\":[28,11],\"o\":0},\"large_yellow_square\":{\"a\":\"Large Yellow Square\",\"b\":\"1F7E8\",\"j\":[\"yellow_square\"],\"k\":[37,5],\"o\":12},\"male_mage\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D9-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9D9-1F3FB-200D-2642\",\"image\":\"1f9d9-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":12,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D9-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9D9-1F3FC-200D-2642\",\"image\":\"1f9d9-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":13,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D9-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9D9-1F3FD-200D-2642\",\"image\":\"1f9d9-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":14,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D9-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9D9-1F3FE-200D-2642\",\"image\":\"1f9d9-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":15,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D9-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9D9-1F3FF-200D-2642\",\"image\":\"1f9d9-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":16,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Mage\",\"b\":\"1F9D9-200D-2642-FE0F\",\"c\":\"1F9D9-200D-2642\",\"j\":[\"man_mage\",\"man\",\"male\",\"mage\",\"sorcerer\"],\"k\":[50,11],\"o\":5},\"flag-pw\":{\"a\":\"Palau Flag\",\"b\":\"1F1F5-1F1FC\",\"j\":[\"flag_palau\",\"pw\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,47],\"o\":2},\"tornado\":{\"a\":\"Tornado\",\"b\":\"1F32A-FE0F\",\"c\":\"1F32A\",\"j\":[\"tornado\",\"weather\",\"cyclone\",\"twister\"],\"k\":[5,54],\"n\":[\"tornado_cloud\"],\"o\":0},\"large_green_square\":{\"a\":\"Large Green Square\",\"b\":\"1F7E9\",\"j\":[\"green_square\"],\"k\":[37,6],\"o\":12},\"female_mage\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D9-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9D9-1F3FB-200D-2640\",\"image\":\"1f9d9-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":6,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D9-1F3FB\"},\"1F3FC\":{\"unified\":\"1F9D9-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9D9-1F3FC-200D-2640\",\"image\":\"1f9d9-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":7,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D9-1F3FC\"},\"1F3FD\":{\"unified\":\"1F9D9-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9D9-1F3FD-200D-2640\",\"image\":\"1f9d9-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":8,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D9-1F3FD\"},\"1F3FE\":{\"unified\":\"1F9D9-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9D9-1F3FE-200D-2640\",\"image\":\"1f9d9-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":9,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D9-1F3FE\"},\"1F3FF\":{\"unified\":\"1F9D9-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9D9-1F3FF-200D-2640\",\"image\":\"1f9d9-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":10,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D9-1F3FF\"}},\"obsoletes\":\"1F9D9\",\"a\":\"Woman Mage\",\"b\":\"1F9D9-200D-2640-FE0F\",\"c\":\"1F9D9-200D-2640\",\"j\":[\"woman_mage\",\"woman\",\"female\",\"mage\",\"witch\"],\"k\":[50,5],\"o\":5},\"gear\":{\"a\":\"Gear\",\"b\":\"2699-FE0F\",\"c\":\"2699\",\"j\":[\"gear\",\"cog\"],\"k\":[54,52],\"o\":1},\"flag-py\":{\"a\":\"Paraguay Flag\",\"b\":\"1F1F5-1F1FE\",\"j\":[\"flag_paraguay\",\"py\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,48],\"o\":2},\"fog\":{\"a\":\"Fog\",\"b\":\"1F32B-FE0F\",\"c\":\"1F32B\",\"j\":[\"fog\",\"weather\"],\"k\":[5,55],\"o\":0},\"compression\":{\"a\":\"Clamp\",\"b\":\"1F5DC-FE0F\",\"c\":\"1F5DC\",\"j\":[\"clamp\",\"tool\"],\"k\":[30,18],\"o\":0},\"large_blue_square\":{\"a\":\"Large Blue Square\",\"b\":\"1F7E6\",\"j\":[\"blue_square\"],\"k\":[37,3],\"o\":12},\"fairy\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DA-1F3FB\",\"non_qualified\":null,\"image\":\"1f9da-1f3fb.png\",\"sheet_x\":50,\"sheet_y\":36,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DA-1F3FB-200D-2640-FE0F\"},\"1F3FC\":{\"unified\":\"1F9DA-1F3FC\",\"non_qualified\":null,\"image\":\"1f9da-1f3fc.png\",\"sheet_x\":50,\"sheet_y\":37,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DA-1F3FC-200D-2640-FE0F\"},\"1F3FD\":{\"unified\":\"1F9DA-1F3FD\",\"non_qualified\":null,\"image\":\"1f9da-1f3fd.png\",\"sheet_x\":50,\"sheet_y\":38,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DA-1F3FD-200D-2640-FE0F\"},\"1F3FE\":{\"unified\":\"1F9DA-1F3FE\",\"non_qualified\":null,\"image\":\"1f9da-1f3fe.png\",\"sheet_x\":50,\"sheet_y\":39,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DA-1F3FE-200D-2640-FE0F\"},\"1F3FF\":{\"unified\":\"1F9DA-1F3FF\",\"non_qualified\":null,\"image\":\"1f9da-1f3ff.png\",\"sheet_x\":50,\"sheet_y\":40,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DA-1F3FF-200D-2640-FE0F\"}},\"obsoleted_by\":\"1F9DA-200D-2640-FE0F\",\"a\":\"Fairy\",\"b\":\"1F9DA\",\"j\":[\"fairy\",\"wings\",\"magical\"],\"k\":[50,35],\"o\":5},\"flag-qa\":{\"a\":\"Qatar Flag\",\"b\":\"1F1F6-1F1E6\",\"j\":[\"flag_qatar\",\"qa\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,49],\"o\":2},\"wind_blowing_face\":{\"a\":\"Wind Face\",\"b\":\"1F32C-FE0F\",\"c\":\"1F32C\",\"j\":[\"wind_face\",\"gust\",\"air\"],\"k\":[5,56],\"o\":0},\"large_purple_square\":{\"a\":\"Large Purple Square\",\"b\":\"1F7EA\",\"j\":[\"purple_square\"],\"k\":[37,7],\"o\":12},\"male_fairy\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DA-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9DA-1F3FB-200D-2642\",\"image\":\"1f9da-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":30,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9DA-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9DA-1F3FC-200D-2642\",\"image\":\"1f9da-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":31,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9DA-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9DA-1F3FD-200D-2642\",\"image\":\"1f9da-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":32,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9DA-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9DA-1F3FE-200D-2642\",\"image\":\"1f9da-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":33,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9DA-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9DA-1F3FF-200D-2642\",\"image\":\"1f9da-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":34,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Fairy\",\"b\":\"1F9DA-200D-2642-FE0F\",\"c\":\"1F9DA-200D-2642\",\"j\":[\"man_fairy\",\"man\",\"male\"],\"k\":[50,29],\"o\":5},\"scales\":{\"a\":\"Balance Scale\",\"b\":\"2696-FE0F\",\"c\":\"2696\",\"j\":[\"balance_scale\",\"law\",\"fairness\",\"weight\"],\"k\":[54,50],\"o\":1},\"flag-re\":{\"a\":\"Réunion Flag\",\"b\":\"1F1F7-1F1EA\",\"j\":[\"flag_reunion\",\"réunion\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,50],\"o\":2},\"cyclone\":{\"a\":\"Cyclone\",\"b\":\"1F300\",\"j\":[\"cyclone\",\"weather\",\"swirl\",\"blue\",\"cloud\",\"vortex\",\"spiral\",\"whirlpool\",\"spin\",\"tornado\",\"hurricane\",\"typhoon\"],\"k\":[5,14],\"o\":0},\"large_brown_square\":{\"a\":\"Large Brown Square\",\"b\":\"1F7EB\",\"j\":[\"brown_square\"],\"k\":[37,8],\"o\":12},\"probing_cane\":{\"a\":\"Probing Cane\",\"b\":\"1F9AF\",\"j\":[\"probing_cane\",\"accessibility\"],\"k\":[43,22],\"o\":12},\"female_fairy\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DA-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9DA-1F3FB-200D-2640\",\"image\":\"1f9da-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":24,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DA-1F3FB\"},\"1F3FC\":{\"unified\":\"1F9DA-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9DA-1F3FC-200D-2640\",\"image\":\"1f9da-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":25,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DA-1F3FC\"},\"1F3FD\":{\"unified\":\"1F9DA-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9DA-1F3FD-200D-2640\",\"image\":\"1f9da-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":26,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DA-1F3FD\"},\"1F3FE\":{\"unified\":\"1F9DA-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9DA-1F3FE-200D-2640\",\"image\":\"1f9da-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":27,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DA-1F3FE\"},\"1F3FF\":{\"unified\":\"1F9DA-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9DA-1F3FF-200D-2640\",\"image\":\"1f9da-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":28,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DA-1F3FF\"}},\"obsoletes\":\"1F9DA\",\"a\":\"Woman Fairy\",\"b\":\"1F9DA-200D-2640-FE0F\",\"c\":\"1F9DA-200D-2640\",\"j\":[\"woman_fairy\",\"woman\",\"female\"],\"k\":[50,23],\"o\":5},\"flag-ro\":{\"a\":\"Romania Flag\",\"b\":\"1F1F7-1F1F4\",\"j\":[\"flag_romania\",\"ro\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,51],\"o\":2},\"rainbow\":{\"a\":\"Rainbow\",\"b\":\"1F308\",\"j\":[\"rainbow\",\"nature\",\"happy\",\"unicorn_face\",\"photo\",\"sky\",\"spring\"],\"k\":[5,22],\"o\":0},\"link\":{\"a\":\"Link Symbol\",\"b\":\"1F517\",\"j\":[\"link\",\"rings\",\"url\"],\"k\":[27,51],\"o\":0},\"vampire\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DB-1F3FB\",\"non_qualified\":null,\"image\":\"1f9db-1f3fb.png\",\"sheet_x\":50,\"sheet_y\":54,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DB-1F3FB-200D-2640-FE0F\"},\"1F3FC\":{\"unified\":\"1F9DB-1F3FC\",\"non_qualified\":null,\"image\":\"1f9db-1f3fc.png\",\"sheet_x\":50,\"sheet_y\":55,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DB-1F3FC-200D-2640-FE0F\"},\"1F3FD\":{\"unified\":\"1F9DB-1F3FD\",\"non_qualified\":null,\"image\":\"1f9db-1f3fd.png\",\"sheet_x\":50,\"sheet_y\":56,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DB-1F3FD-200D-2640-FE0F\"},\"1F3FE\":{\"unified\":\"1F9DB-1F3FE\",\"non_qualified\":null,\"image\":\"1f9db-1f3fe.png\",\"sheet_x\":50,\"sheet_y\":57,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DB-1F3FE-200D-2640-FE0F\"},\"1F3FF\":{\"unified\":\"1F9DB-1F3FF\",\"non_qualified\":null,\"image\":\"1f9db-1f3ff.png\",\"sheet_x\":51,\"sheet_y\":0,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DB-1F3FF-200D-2640-FE0F\"}},\"obsoleted_by\":\"1F9DB-200D-2640-FE0F\",\"a\":\"Vampire\",\"b\":\"1F9DB\",\"j\":[\"vampire\",\"blood\",\"twilight\"],\"k\":[50,53],\"o\":5},\"black_large_square\":{\"a\":\"Black Large Square\",\"b\":\"2B1B\",\"j\":[\"black_large_square\",\"shape\",\"icon\",\"button\"],\"k\":[56,44],\"o\":0},\"flag-rs\":{\"a\":\"Serbia Flag\",\"b\":\"1F1F7-1F1F8\",\"j\":[\"flag_serbia\",\"rs\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,52],\"o\":2},\"closed_umbrella\":{\"a\":\"Closed Umbrella\",\"b\":\"1F302\",\"j\":[\"closed_umbrella\",\"weather\",\"rain\",\"drizzle\"],\"k\":[5,16],\"o\":0},\"male_vampire\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DB-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9DB-1F3FB-200D-2642\",\"image\":\"1f9db-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":48,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9DB-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9DB-1F3FC-200D-2642\",\"image\":\"1f9db-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":49,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9DB-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9DB-1F3FD-200D-2642\",\"image\":\"1f9db-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":50,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9DB-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9DB-1F3FE-200D-2642\",\"image\":\"1f9db-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":51,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9DB-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9DB-1F3FF-200D-2642\",\"image\":\"1f9db-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":50,\"sheet_y\":52,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Vampire\",\"b\":\"1F9DB-200D-2642-FE0F\",\"c\":\"1F9DB-200D-2642\",\"j\":[\"man_vampire\",\"man\",\"male\",\"dracula\"],\"k\":[50,47],\"o\":5},\"chains\":{\"a\":\"Chains\",\"b\":\"26D3-FE0F\",\"c\":\"26D3\",\"j\":[\"chains\",\"lock\",\"arrest\"],\"k\":[55,12],\"o\":0},\"white_large_square\":{\"a\":\"White Large Square\",\"b\":\"2B1C\",\"j\":[\"white_large_square\",\"shape\",\"icon\",\"stone\",\"button\"],\"k\":[56,45],\"o\":0},\"ru\":{\"a\":\"Russia Flag\",\"b\":\"1F1F7-1F1FA\",\"j\":[\"flag_russia\",\"russian\",\"federation\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,53],\"n\":[\"flag-ru\"],\"o\":0},\"female_vampire\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DB-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9DB-1F3FB-200D-2640\",\"image\":\"1f9db-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":42,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DB-1F3FB\"},\"1F3FC\":{\"unified\":\"1F9DB-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9DB-1F3FC-200D-2640\",\"image\":\"1f9db-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":43,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DB-1F3FC\"},\"1F3FD\":{\"unified\":\"1F9DB-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9DB-1F3FD-200D-2640\",\"image\":\"1f9db-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":44,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DB-1F3FD\"},\"1F3FE\":{\"unified\":\"1F9DB-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9DB-1F3FE-200D-2640\",\"image\":\"1f9db-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":45,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DB-1F3FE\"},\"1F3FF\":{\"unified\":\"1F9DB-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9DB-1F3FF-200D-2640\",\"image\":\"1f9db-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":50,\"sheet_y\":46,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DB-1F3FF\"}},\"obsoletes\":\"1F9DB\",\"a\":\"Woman Vampire\",\"b\":\"1F9DB-200D-2640-FE0F\",\"c\":\"1F9DB-200D-2640\",\"j\":[\"woman_vampire\",\"woman\",\"female\"],\"k\":[50,41],\"o\":5},\"hook\":{\"a\":\"Hook\",\"b\":\"1FA9D\",\"j\":[\"hook\",\"tools\"],\"k\":[52,45],\"o\":13},\"black_medium_square\":{\"a\":\"Black Medium Square\",\"b\":\"25FC-FE0F\",\"c\":\"25FC\",\"j\":[\"black_medium_square\",\"shape\",\"button\",\"icon\"],\"k\":[53,52],\"o\":0},\"umbrella\":{\"a\":\"Umbrella\",\"b\":\"2602-FE0F\",\"c\":\"2602\",\"j\":[\"umbrella\",\"weather\",\"spring\"],\"k\":[53,57],\"o\":0},\"flag-rw\":{\"a\":\"Rwanda Flag\",\"b\":\"1F1F7-1F1FC\",\"j\":[\"flag_rwanda\",\"rw\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,54],\"o\":2},\"merperson\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DC-1F3FB\",\"non_qualified\":null,\"image\":\"1f9dc-1f3fb.png\",\"sheet_x\":51,\"sheet_y\":14,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DC-1F3FB-200D-2642-FE0F\"},\"1F3FC\":{\"unified\":\"1F9DC-1F3FC\",\"non_qualified\":null,\"image\":\"1f9dc-1f3fc.png\",\"sheet_x\":51,\"sheet_y\":15,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DC-1F3FC-200D-2642-FE0F\"},\"1F3FD\":{\"unified\":\"1F9DC-1F3FD\",\"non_qualified\":null,\"image\":\"1f9dc-1f3fd.png\",\"sheet_x\":51,\"sheet_y\":16,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DC-1F3FD-200D-2642-FE0F\"},\"1F3FE\":{\"unified\":\"1F9DC-1F3FE\",\"non_qualified\":null,\"image\":\"1f9dc-1f3fe.png\",\"sheet_x\":51,\"sheet_y\":17,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DC-1F3FE-200D-2642-FE0F\"},\"1F3FF\":{\"unified\":\"1F9DC-1F3FF\",\"non_qualified\":null,\"image\":\"1f9dc-1f3ff.png\",\"sheet_x\":51,\"sheet_y\":18,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DC-1F3FF-200D-2642-FE0F\"}},\"obsoleted_by\":\"1F9DC-200D-2642-FE0F\",\"a\":\"Merperson\",\"b\":\"1F9DC\",\"j\":[\"merperson\",\"sea\"],\"k\":[51,13],\"o\":5},\"toolbox\":{\"a\":\"Toolbox\",\"b\":\"1F9F0\",\"j\":[\"toolbox\",\"tools\",\"diy\",\"fix\",\"maintainer\",\"mechanic\"],\"k\":[52,1],\"o\":11},\"white_medium_square\":{\"a\":\"White Medium Square\",\"b\":\"25FB-FE0F\",\"c\":\"25FB\",\"j\":[\"white_medium_square\",\"shape\",\"stone\",\"icon\"],\"k\":[53,51],\"o\":0},\"umbrella_with_rain_drops\":{\"a\":\"Umbrella with Rain Drops\",\"b\":\"2614\",\"j\":[\"umbrella_with_rain_drops\",\"rainy\",\"weather\",\"spring\"],\"k\":[54,4],\"o\":0},\"flag-sa\":{\"a\":\"Saudi Arabia Flag\",\"b\":\"1F1F8-1F1E6\",\"j\":[\"flag_saudi_arabia\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,55],\"o\":2},\"merman\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DC-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9DC-1F3FB-200D-2642\",\"image\":\"1f9dc-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":8,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DC-1F3FB\"},\"1F3FC\":{\"unified\":\"1F9DC-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9DC-1F3FC-200D-2642\",\"image\":\"1f9dc-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":9,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DC-1F3FC\"},\"1F3FD\":{\"unified\":\"1F9DC-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9DC-1F3FD-200D-2642\",\"image\":\"1f9dc-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":10,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DC-1F3FD\"},\"1F3FE\":{\"unified\":\"1F9DC-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9DC-1F3FE-200D-2642\",\"image\":\"1f9dc-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":11,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DC-1F3FE\"},\"1F3FF\":{\"unified\":\"1F9DC-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9DC-1F3FF-200D-2642\",\"image\":\"1f9dc-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":12,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DC-1F3FF\"}},\"obsoletes\":\"1F9DC\",\"a\":\"Merman\",\"b\":\"1F9DC-200D-2642-FE0F\",\"c\":\"1F9DC-200D-2642\",\"j\":[\"merman\",\"man\",\"male\",\"triton\"],\"k\":[51,7],\"o\":5},\"magnet\":{\"a\":\"Magnet\",\"b\":\"1F9F2\",\"j\":[\"magnet\",\"attraction\",\"magnetic\"],\"k\":[52,3],\"o\":11},\"black_medium_small_square\":{\"a\":\"Black Medium Small Square\",\"b\":\"25FE\",\"j\":[\"black_medium_small_square\",\"icon\",\"shape\",\"button\"],\"k\":[53,54],\"o\":0},\"umbrella_on_ground\":{\"a\":\"Umbrella on Ground\",\"b\":\"26F1-FE0F\",\"c\":\"26F1\",\"j\":[\"umbrella_on_ground\",\"weather\",\"summer\"],\"k\":[55,17],\"o\":0},\"flag-sb\":{\"a\":\"Solomon Islands Flag\",\"b\":\"1F1F8-1F1E7\",\"j\":[\"flag_solomon_islands\",\"solomon\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,56],\"o\":2},\"mermaid\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DC-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9DC-1F3FB-200D-2640\",\"image\":\"1f9dc-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":2,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9DC-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9DC-1F3FC-200D-2640\",\"image\":\"1f9dc-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":3,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9DC-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9DC-1F3FD-200D-2640\",\"image\":\"1f9dc-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":4,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9DC-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9DC-1F3FE-200D-2640\",\"image\":\"1f9dc-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":5,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9DC-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9DC-1F3FF-200D-2640\",\"image\":\"1f9dc-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":6,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Mermaid\",\"b\":\"1F9DC-200D-2640-FE0F\",\"c\":\"1F9DC-200D-2640\",\"j\":[\"mermaid\",\"woman\",\"female\",\"merwoman\",\"ariel\"],\"k\":[51,1],\"o\":5},\"ladder\":{\"a\":\"Ladder\",\"b\":\"1FA9C\",\"j\":[\"ladder\",\"tools\"],\"k\":[52,44],\"o\":13},\"white_medium_small_square\":{\"a\":\"White Medium Small Square\",\"b\":\"25FD\",\"j\":[\"white_medium_small_square\",\"shape\",\"stone\",\"icon\",\"button\"],\"k\":[53,53],\"o\":0},\"zap\":{\"a\":\"High Voltage Sign\",\"b\":\"26A1\",\"j\":[\"high_voltage\",\"thunder\",\"weather\",\"lightning bolt\",\"fast\"],\"k\":[54,56],\"o\":0},\"flag-sc\":{\"a\":\"Seychelles Flag\",\"b\":\"1F1F8-1F1E8\",\"j\":[\"flag_seychelles\",\"sc\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[3,57],\"o\":2},\"elf\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DD-1F3FB\",\"non_qualified\":null,\"image\":\"1f9dd-1f3fb.png\",\"sheet_x\":51,\"sheet_y\":32,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DD-1F3FB-200D-2642-FE0F\"},\"1F3FC\":{\"unified\":\"1F9DD-1F3FC\",\"non_qualified\":null,\"image\":\"1f9dd-1f3fc.png\",\"sheet_x\":51,\"sheet_y\":33,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DD-1F3FC-200D-2642-FE0F\"},\"1F3FD\":{\"unified\":\"1F9DD-1F3FD\",\"non_qualified\":null,\"image\":\"1f9dd-1f3fd.png\",\"sheet_x\":51,\"sheet_y\":34,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DD-1F3FD-200D-2642-FE0F\"},\"1F3FE\":{\"unified\":\"1F9DD-1F3FE\",\"non_qualified\":null,\"image\":\"1f9dd-1f3fe.png\",\"sheet_x\":51,\"sheet_y\":35,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DD-1F3FE-200D-2642-FE0F\"},\"1F3FF\":{\"unified\":\"1F9DD-1F3FF\",\"non_qualified\":null,\"image\":\"1f9dd-1f3ff.png\",\"sheet_x\":51,\"sheet_y\":36,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9DD-1F3FF-200D-2642-FE0F\"}},\"obsoleted_by\":\"1F9DD-200D-2642-FE0F\",\"a\":\"Elf\",\"b\":\"1F9DD\",\"j\":[\"elf\",\"magical\"],\"k\":[51,31],\"o\":5},\"black_small_square\":{\"a\":\"Black Small Square\",\"b\":\"25AA-FE0F\",\"c\":\"25AA\",\"j\":[\"black_small_square\",\"shape\",\"icon\"],\"k\":[53,47],\"o\":0},\"alembic\":{\"a\":\"Alembic\",\"b\":\"2697-FE0F\",\"c\":\"2697\",\"j\":[\"alembic\",\"distilling\",\"science\",\"experiment\",\"chemistry\"],\"k\":[54,51],\"o\":1},\"snowflake\":{\"a\":\"Snowflake\",\"b\":\"2744-FE0F\",\"c\":\"2744\",\"j\":[\"snowflake\",\"winter\",\"season\",\"cold\",\"weather\",\"christmas\",\"xmas\"],\"k\":[56,23],\"o\":0},\"flag-sd\":{\"a\":\"Sudan Flag\",\"b\":\"1F1F8-1F1E9\",\"j\":[\"flag_sudan\",\"sd\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,0],\"o\":2},\"male_elf\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DD-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9DD-1F3FB-200D-2642\",\"image\":\"1f9dd-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":26,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DD-1F3FB\"},\"1F3FC\":{\"unified\":\"1F9DD-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9DD-1F3FC-200D-2642\",\"image\":\"1f9dd-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":27,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DD-1F3FC\"},\"1F3FD\":{\"unified\":\"1F9DD-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9DD-1F3FD-200D-2642\",\"image\":\"1f9dd-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":28,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DD-1F3FD\"},\"1F3FE\":{\"unified\":\"1F9DD-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9DD-1F3FE-200D-2642\",\"image\":\"1f9dd-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":29,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DD-1F3FE\"},\"1F3FF\":{\"unified\":\"1F9DD-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9DD-1F3FF-200D-2642\",\"image\":\"1f9dd-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":51,\"sheet_y\":30,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9DD-1F3FF\"}},\"obsoletes\":\"1F9DD\",\"a\":\"Man Elf\",\"b\":\"1F9DD-200D-2642-FE0F\",\"c\":\"1F9DD-200D-2642\",\"j\":[\"man_elf\",\"man\",\"male\"],\"k\":[51,25],\"o\":5},\"test_tube\":{\"a\":\"Test Tube\",\"b\":\"1F9EA\",\"j\":[\"test_tube\",\"chemistry\",\"experiment\",\"lab\",\"science\"],\"k\":[51,53],\"o\":11},\"white_small_square\":{\"a\":\"White Small Square\",\"b\":\"25AB-FE0F\",\"c\":\"25AB\",\"j\":[\"white_small_square\",\"shape\",\"icon\"],\"k\":[53,48],\"o\":0},\"snowman\":{\"a\":\"Snowman\",\"b\":\"2603-FE0F\",\"c\":\"2603\",\"j\":[\"snowman\",\"winter\",\"season\",\"cold\",\"weather\",\"christmas\",\"xmas\",\"frozen\"],\"k\":[54,0],\"o\":0},\"flag-se\":{\"a\":\"Sweden Flag\",\"b\":\"1F1F8-1F1EA\",\"j\":[\"flag_sweden\",\"se\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,1],\"o\":2},\"large_orange_diamond\":{\"a\":\"Large Orange Diamond\",\"b\":\"1F536\",\"j\":[\"large_orange_diamond\",\"shape\",\"jewel\",\"gem\"],\"k\":[28,24],\"o\":0},\"female_elf\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9DD-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9DD-1F3FB-200D-2640\",\"image\":\"1f9dd-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":20,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9DD-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9DD-1F3FC-200D-2640\",\"image\":\"1f9dd-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":21,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9DD-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9DD-1F3FD-200D-2640\",\"image\":\"1f9dd-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":22,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9DD-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9DD-1F3FE-200D-2640\",\"image\":\"1f9dd-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":23,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9DD-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9DD-1F3FF-200D-2640\",\"image\":\"1f9dd-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":51,\"sheet_y\":24,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Elf\",\"b\":\"1F9DD-200D-2640-FE0F\",\"c\":\"1F9DD-200D-2640\",\"j\":[\"woman_elf\",\"woman\",\"female\"],\"k\":[51,19],\"o\":5},\"petri_dish\":{\"a\":\"Petri Dish\",\"b\":\"1F9EB\",\"j\":[\"petri_dish\",\"bacteria\",\"biology\",\"culture\",\"lab\"],\"k\":[51,54],\"o\":11},\"snowman_without_snow\":{\"a\":\"Snowman Without Snow\",\"b\":\"26C4\",\"j\":[\"snowman_without_snow\",\"winter\",\"season\",\"cold\",\"weather\",\"christmas\",\"xmas\",\"frozen\",\"without_snow\"],\"k\":[55,6],\"o\":0},\"flag-sg\":{\"a\":\"Singapore Flag\",\"b\":\"1F1F8-1F1EC\",\"j\":[\"flag_singapore\",\"sg\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,2],\"o\":2},\"large_blue_diamond\":{\"a\":\"Large Blue Diamond\",\"b\":\"1F537\",\"j\":[\"large_blue_diamond\",\"shape\",\"jewel\",\"gem\"],\"k\":[28,25],\"o\":0},\"genie\":{\"obsoleted_by\":\"1F9DE-200D-2642-FE0F\",\"a\":\"Genie\",\"b\":\"1F9DE\",\"j\":[\"genie\",\"magical\",\"wishes\"],\"k\":[51,39],\"o\":5},\"dna\":{\"a\":\"Dna Double Helix\",\"b\":\"1F9EC\",\"j\":[\"dna\",\"biologist\",\"genetics\",\"life\"],\"k\":[51,55],\"o\":11},\"comet\":{\"a\":\"Comet\",\"b\":\"2604-FE0F\",\"c\":\"2604\",\"j\":[\"comet\",\"space\"],\"k\":[54,1],\"o\":1},\"flag-sh\":{\"a\":\"St. Helena Flag\",\"b\":\"1F1F8-1F1ED\",\"j\":[\"flag_st_helena\",\"saint\",\"helena\",\"ascension\",\"tristan\",\"cunha\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,3],\"o\":2},\"fire\":{\"a\":\"Fire\",\"b\":\"1F525\",\"j\":[\"fire\",\"hot\",\"cook\",\"flame\"],\"k\":[28,7],\"o\":0},\"microscope\":{\"a\":\"Microscope\",\"b\":\"1F52C\",\"j\":[\"microscope\",\"laboratory\",\"experiment\",\"zoomin\",\"science\",\"study\"],\"k\":[28,14],\"o\":1},\"small_orange_diamond\":{\"a\":\"Small Orange Diamond\",\"b\":\"1F538\",\"j\":[\"small_orange_diamond\",\"shape\",\"jewel\",\"gem\"],\"k\":[28,26],\"o\":0},\"male_genie\":{\"obsoletes\":\"1F9DE\",\"a\":\"Man Genie\",\"b\":\"1F9DE-200D-2642-FE0F\",\"c\":\"1F9DE-200D-2642\",\"j\":[\"man_genie\",\"man\",\"male\"],\"k\":[51,38],\"o\":5},\"flag-si\":{\"a\":\"Slovenia Flag\",\"b\":\"1F1F8-1F1EE\",\"j\":[\"flag_slovenia\",\"si\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,4],\"o\":2},\"droplet\":{\"a\":\"Droplet\",\"b\":\"1F4A7\",\"j\":[\"droplet\",\"water\",\"drip\",\"faucet\",\"spring\"],\"k\":[25,51],\"o\":0},\"telescope\":{\"a\":\"Telescope\",\"b\":\"1F52D\",\"j\":[\"telescope\",\"stars\",\"space\",\"zoom\",\"science\",\"astronomy\"],\"k\":[28,15],\"o\":1},\"small_blue_diamond\":{\"a\":\"Small Blue Diamond\",\"b\":\"1F539\",\"j\":[\"small_blue_diamond\",\"shape\",\"jewel\",\"gem\"],\"k\":[28,27],\"o\":0},\"female_genie\":{\"a\":\"Woman Genie\",\"b\":\"1F9DE-200D-2640-FE0F\",\"c\":\"1F9DE-200D-2640\",\"j\":[\"woman_genie\",\"woman\",\"female\"],\"k\":[51,37],\"o\":5},\"flag-sj\":{\"a\":\"Svalbard & Jan Mayen Flag\",\"b\":\"1F1F8-1F1EF\",\"j\":[\"flag_svalbard_jan_mayen\"],\"k\":[4,5],\"o\":2},\"ocean\":{\"a\":\"Water Wave\",\"b\":\"1F30A\",\"j\":[\"water_wave\",\"sea\",\"water\",\"wave\",\"nature\",\"tsunami\",\"disaster\"],\"k\":[5,24],\"o\":0},\"satellite_antenna\":{\"a\":\"Satellite Antenna\",\"b\":\"1F4E1\",\"j\":[\"satellite_antenna\",\"communication\",\"future\",\"radio\",\"space\"],\"k\":[26,56],\"o\":0},\"small_red_triangle\":{\"a\":\"Up-Pointing Red Triangle\",\"b\":\"1F53A\",\"j\":[\"red_triangle_pointed_up\",\"shape\",\"direction\",\"up\",\"top\"],\"k\":[28,28],\"o\":0},\"zombie\":{\"obsoleted_by\":\"1F9DF-200D-2642-FE0F\",\"a\":\"Zombie\",\"b\":\"1F9DF\",\"j\":[\"zombie\",\"dead\"],\"k\":[51,42],\"o\":5},\"flag-sk\":{\"a\":\"Slovakia Flag\",\"b\":\"1F1F8-1F1F0\",\"j\":[\"flag_slovakia\",\"sk\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,6],\"o\":2},\"syringe\":{\"a\":\"Syringe\",\"b\":\"1F489\",\"j\":[\"syringe\",\"health\",\"hospital\",\"drugs\",\"blood\",\"medicine\",\"needle\",\"doctor\",\"nurse\"],\"k\":[25,21],\"o\":0},\"small_red_triangle_down\":{\"a\":\"Down-Pointing Red Triangle\",\"b\":\"1F53B\",\"j\":[\"red_triangle_pointed_down\",\"shape\",\"direction\",\"bottom\"],\"k\":[28,29],\"o\":0},\"male_zombie\":{\"obsoletes\":\"1F9DF\",\"a\":\"Man Zombie\",\"b\":\"1F9DF-200D-2642-FE0F\",\"c\":\"1F9DF-200D-2642\",\"j\":[\"man_zombie\",\"man\",\"male\",\"dracula\",\"undead\",\"walking dead\"],\"k\":[51,41],\"o\":5},\"flag-sl\":{\"a\":\"Sierra Leone Flag\",\"b\":\"1F1F8-1F1F1\",\"j\":[\"flag_sierra_leone\",\"sierra\",\"leone\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,7],\"o\":2},\"diamond_shape_with_a_dot_inside\":{\"a\":\"Diamond Shape with a Dot Inside\",\"b\":\"1F4A0\",\"j\":[\"diamond_with_a_dot\",\"jewel\",\"blue\",\"gem\",\"crystal\",\"fancy\"],\"k\":[25,44],\"o\":0},\"female_zombie\":{\"a\":\"Woman Zombie\",\"b\":\"1F9DF-200D-2640-FE0F\",\"c\":\"1F9DF-200D-2640\",\"j\":[\"woman_zombie\",\"woman\",\"female\",\"undead\",\"walking dead\"],\"k\":[51,40],\"o\":5},\"drop_of_blood\":{\"a\":\"Drop of Blood\",\"b\":\"1FA78\",\"j\":[\"drop_of_blood\",\"period\",\"hurt\",\"harm\",\"wound\"],\"k\":[52,22],\"o\":12},\"flag-sm\":{\"a\":\"San Marino Flag\",\"b\":\"1F1F8-1F1F2\",\"j\":[\"flag_san_marino\",\"san\",\"marino\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,8],\"o\":2},\"massage\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F486-1F3FB\",\"non_qualified\":null,\"image\":\"1f486-1f3fb.png\",\"sheet_x\":24,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F486-1F3FC\",\"non_qualified\":null,\"image\":\"1f486-1f3fc.png\",\"sheet_x\":24,\"sheet_y\":56,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F486-1F3FD\",\"non_qualified\":null,\"image\":\"1f486-1f3fd.png\",\"sheet_x\":24,\"sheet_y\":57,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F486-1F3FE\",\"non_qualified\":null,\"image\":\"1f486-1f3fe.png\",\"sheet_x\":25,\"sheet_y\":0,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F486-1F3FF\",\"non_qualified\":null,\"image\":\"1f486-1f3ff.png\",\"sheet_x\":25,\"sheet_y\":1,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F486-200D-2640-FE0F\",\"a\":\"Face Massage\",\"b\":\"1F486\",\"j\":[\"person_getting_massage\",\"relax\"],\"k\":[24,54],\"o\":0},\"pill\":{\"a\":\"Pill\",\"b\":\"1F48A\",\"j\":[\"pill\",\"health\",\"medicine\",\"doctor\",\"pharmacy\",\"drug\"],\"k\":[25,22],\"o\":0},\"radio_button\":{\"a\":\"Radio Button\",\"b\":\"1F518\",\"j\":[\"radio_button\",\"input\",\"old\",\"music\",\"circle\"],\"k\":[27,52],\"o\":0},\"flag-sn\":{\"a\":\"Senegal Flag\",\"b\":\"1F1F8-1F1F3\",\"j\":[\"flag_senegal\",\"sn\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,9],\"o\":2},\"man-getting-massage\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F486-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F486-1F3FB-200D-2642\",\"image\":\"1f486-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F486-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F486-1F3FC-200D-2642\",\"image\":\"1f486-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":50,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F486-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F486-1F3FD-200D-2642\",\"image\":\"1f486-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":51,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F486-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F486-1F3FE-200D-2642\",\"image\":\"1f486-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F486-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F486-1F3FF-200D-2642\",\"image\":\"1f486-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":24,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Getting Massage\",\"b\":\"1F486-200D-2642-FE0F\",\"c\":\"1F486-200D-2642\",\"j\":[\"man_getting_massage\",\"male\",\"boy\",\"man\",\"head\"],\"k\":[24,48],\"o\":4},\"white_square_button\":{\"a\":\"White Square Button\",\"b\":\"1F533\",\"j\":[\"white_square_button\",\"shape\",\"input\"],\"k\":[28,21],\"o\":0},\"adhesive_bandage\":{\"a\":\"Adhesive Bandage\",\"b\":\"1FA79\",\"j\":[\"adhesive_bandage\",\"heal\"],\"k\":[52,23],\"o\":12},\"flag-so\":{\"a\":\"Somalia Flag\",\"b\":\"1F1F8-1F1F4\",\"j\":[\"flag_somalia\",\"so\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,10],\"o\":2},\"woman-getting-massage\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F486-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F486-1F3FB-200D-2640\",\"image\":\"1f486-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F486-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F486-1F3FC-200D-2640\",\"image\":\"1f486-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":44,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F486-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F486-1F3FD-200D-2640\",\"image\":\"1f486-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F486-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F486-1F3FE-200D-2640\",\"image\":\"1f486-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F486-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F486-1F3FF-200D-2640\",\"image\":\"1f486-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":24,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F486\",\"a\":\"Woman Getting Massage\",\"b\":\"1F486-200D-2640-FE0F\",\"c\":\"1F486-200D-2640\",\"j\":[\"woman_getting_massage\",\"female\",\"girl\",\"woman\",\"head\"],\"k\":[24,42],\"o\":4},\"black_square_button\":{\"a\":\"Black Square Button\",\"b\":\"1F532\",\"j\":[\"black_square_button\",\"shape\",\"input\",\"frame\"],\"k\":[28,20],\"o\":0},\"stethoscope\":{\"a\":\"Stethoscope\",\"b\":\"1FA7A\",\"j\":[\"stethoscope\",\"health\"],\"k\":[52,24],\"o\":12},\"flag-sr\":{\"a\":\"Suriname Flag\",\"b\":\"1F1F8-1F1F7\",\"j\":[\"flag_suriname\",\"sr\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,11],\"o\":2},\"haircut\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F487-1F3FB\",\"non_qualified\":null,\"image\":\"1f487-1f3fb.png\",\"sheet_x\":25,\"sheet_y\":15,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F487-1F3FC\",\"non_qualified\":null,\"image\":\"1f487-1f3fc.png\",\"sheet_x\":25,\"sheet_y\":16,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F487-1F3FD\",\"non_qualified\":null,\"image\":\"1f487-1f3fd.png\",\"sheet_x\":25,\"sheet_y\":17,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F487-1F3FE\",\"non_qualified\":null,\"image\":\"1f487-1f3fe.png\",\"sheet_x\":25,\"sheet_y\":18,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F487-1F3FF\",\"non_qualified\":null,\"image\":\"1f487-1f3ff.png\",\"sheet_x\":25,\"sheet_y\":19,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F487-200D-2640-FE0F\",\"a\":\"Haircut\",\"b\":\"1F487\",\"j\":[\"person_getting_haircut\",\"hairstyle\"],\"k\":[25,14],\"o\":0},\"door\":{\"a\":\"Door\",\"b\":\"1F6AA\",\"j\":[\"door\",\"house\",\"entry\",\"exit\"],\"k\":[34,51],\"o\":0},\"flag-ss\":{\"a\":\"South Sudan Flag\",\"b\":\"1F1F8-1F1F8\",\"j\":[\"flag_south_sudan\",\"south\",\"sd\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,12],\"o\":2},\"man-getting-haircut\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F487-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F487-1F3FB-200D-2642\",\"image\":\"1f487-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":25,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F487-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F487-1F3FC-200D-2642\",\"image\":\"1f487-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":25,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F487-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F487-1F3FD-200D-2642\",\"image\":\"1f487-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":25,\"sheet_y\":11,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F487-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F487-1F3FE-200D-2642\",\"image\":\"1f487-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":25,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F487-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F487-1F3FF-200D-2642\",\"image\":\"1f487-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":25,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Getting Haircut\",\"b\":\"1F487-200D-2642-FE0F\",\"c\":\"1F487-200D-2642\",\"j\":[\"man_getting_haircut\",\"male\",\"boy\",\"man\"],\"k\":[25,8],\"o\":4},\"elevator\":{\"a\":\"Elevator\",\"b\":\"1F6D7\",\"j\":[\"elevator\",\"lift\"],\"k\":[36,34],\"o\":13},\"flag-st\":{\"a\":\"São Tomé & Príncipe Flag\",\"b\":\"1F1F8-1F1F9\",\"j\":[\"flag_sao_tome_principe\",\"sao\",\"tome\",\"principe\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,13],\"o\":2},\"woman-getting-haircut\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F487-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F487-1F3FB-200D-2640\",\"image\":\"1f487-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":25,\"sheet_y\":3,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F487-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F487-1F3FC-200D-2640\",\"image\":\"1f487-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":25,\"sheet_y\":4,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F487-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F487-1F3FD-200D-2640\",\"image\":\"1f487-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":25,\"sheet_y\":5,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F487-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F487-1F3FE-200D-2640\",\"image\":\"1f487-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":25,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F487-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F487-1F3FF-200D-2640\",\"image\":\"1f487-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":25,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F487\",\"a\":\"Woman Getting Haircut\",\"b\":\"1F487-200D-2640-FE0F\",\"c\":\"1F487-200D-2640\",\"j\":[\"woman_getting_haircut\",\"female\",\"girl\",\"woman\"],\"k\":[25,2],\"o\":4},\"mirror\":{\"a\":\"Mirror\",\"b\":\"1FA9E\",\"j\":[\"mirror\",\"reflection\"],\"k\":[52,46],\"o\":13},\"flag-sv\":{\"a\":\"El Salvador Flag\",\"b\":\"1F1F8-1F1FB\",\"j\":[\"flag_el_salvador\",\"el\",\"salvador\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,14],\"o\":2},\"walking\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B6-1F3FB\",\"non_qualified\":null,\"image\":\"1f6b6-1f3fb.png\",\"sheet_x\":35,\"sheet_y\":52,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B6-1F3FC\",\"non_qualified\":null,\"image\":\"1f6b6-1f3fc.png\",\"sheet_x\":35,\"sheet_y\":53,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B6-1F3FD\",\"non_qualified\":null,\"image\":\"1f6b6-1f3fd.png\",\"sheet_x\":35,\"sheet_y\":54,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B6-1F3FE\",\"non_qualified\":null,\"image\":\"1f6b6-1f3fe.png\",\"sheet_x\":35,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B6-1F3FF\",\"non_qualified\":null,\"image\":\"1f6b6-1f3ff.png\",\"sheet_x\":35,\"sheet_y\":56,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F6B6-200D-2642-FE0F\",\"a\":\"Pedestrian\",\"b\":\"1F6B6\",\"j\":[\"person_walking\",\"move\"],\"k\":[35,51],\"o\":0},\"window\":{\"a\":\"Window\",\"b\":\"1FA9F\",\"j\":[\"window\",\"scenery\"],\"k\":[52,47],\"o\":13},\"flag-sx\":{\"a\":\"Sint Maarten Flag\",\"b\":\"1F1F8-1F1FD\",\"j\":[\"flag_sint_maarten\",\"sint\",\"maarten\",\"dutch\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,15],\"o\":2},\"man-walking\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B6-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F6B6-1F3FB-200D-2642\",\"image\":\"1f6b6-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B6-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F6B6-1F3FC-200D-2642\",\"image\":\"1f6b6-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B6-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F6B6-1F3FD-200D-2642\",\"image\":\"1f6b6-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B6-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F6B6-1F3FE-200D-2642\",\"image\":\"1f6b6-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B6-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F6B6-1F3FF-200D-2642\",\"image\":\"1f6b6-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":50,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F6B6\",\"a\":\"Man Walking\",\"b\":\"1F6B6-200D-2642-FE0F\",\"c\":\"1F6B6-200D-2642\",\"j\":[\"man_walking\",\"human\",\"feet\",\"steps\"],\"k\":[35,45],\"o\":4},\"bed\":{\"a\":\"Bed\",\"b\":\"1F6CF-FE0F\",\"c\":\"1F6CF\",\"j\":[\"bed\",\"sleep\",\"rest\"],\"k\":[36,28],\"o\":0},\"flag-sy\":{\"a\":\"Syria Flag\",\"b\":\"1F1F8-1F1FE\",\"j\":[\"flag_syria\",\"syrian\",\"arab\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,16],\"o\":2},\"woman-walking\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B6-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F6B6-1F3FB-200D-2640\",\"image\":\"1f6b6-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":40,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B6-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F6B6-1F3FC-200D-2640\",\"image\":\"1f6b6-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":41,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B6-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F6B6-1F3FD-200D-2640\",\"image\":\"1f6b6-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":42,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B6-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F6B6-1F3FE-200D-2640\",\"image\":\"1f6b6-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B6-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F6B6-1F3FF-200D-2640\",\"image\":\"1f6b6-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":44,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Walking\",\"b\":\"1F6B6-200D-2640-FE0F\",\"c\":\"1F6B6-200D-2640\",\"j\":[\"woman_walking\",\"human\",\"feet\",\"steps\",\"woman\",\"female\"],\"k\":[35,39],\"o\":4},\"couch_and_lamp\":{\"a\":\"Couch and Lamp\",\"b\":\"1F6CB-FE0F\",\"c\":\"1F6CB\",\"j\":[\"couch_and_lamp\",\"read\",\"chill\"],\"k\":[36,19],\"o\":0},\"flag-sz\":{\"a\":\"Eswatini Flag\",\"b\":\"1F1F8-1F1FF\",\"j\":[\"flag_eswatini\",\"sz\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,17],\"o\":2},\"standing_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CD-1F3FB\",\"non_qualified\":null,\"image\":\"1f9cd-1f3fb.png\",\"sheet_x\":44,\"sheet_y\":51,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CD-1F3FC\",\"non_qualified\":null,\"image\":\"1f9cd-1f3fc.png\",\"sheet_x\":44,\"sheet_y\":52,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CD-1F3FD\",\"non_qualified\":null,\"image\":\"1f9cd-1f3fd.png\",\"sheet_x\":44,\"sheet_y\":53,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CD-1F3FE\",\"non_qualified\":null,\"image\":\"1f9cd-1f3fe.png\",\"sheet_x\":44,\"sheet_y\":54,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CD-1F3FF\",\"non_qualified\":null,\"image\":\"1f9cd-1f3ff.png\",\"sheet_x\":44,\"sheet_y\":55,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Standing Person\",\"b\":\"1F9CD\",\"j\":[\"person_standing\",\"still\"],\"k\":[44,50],\"o\":12},\"chair\":{\"a\":\"Chair\",\"b\":\"1FA91\",\"j\":[\"chair\",\"sit\",\"furniture\"],\"k\":[52,33],\"o\":12},\"flag-ta\":{\"a\":\"Tristan Da Cunha Flag\",\"b\":\"1F1F9-1F1E6\",\"j\":[\"flag_tristan_da_cunha\"],\"k\":[4,18],\"o\":2},\"toilet\":{\"a\":\"Toilet\",\"b\":\"1F6BD\",\"j\":[\"toilet\",\"restroom\",\"wc\",\"washroom\",\"bathroom\",\"potty\"],\"k\":[36,5],\"o\":0},\"man_standing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CD-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9CD-1F3FB-200D-2642\",\"image\":\"1f9cd-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":45,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CD-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9CD-1F3FC-200D-2642\",\"image\":\"1f9cd-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":46,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CD-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9CD-1F3FD-200D-2642\",\"image\":\"1f9cd-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":47,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CD-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9CD-1F3FE-200D-2642\",\"image\":\"1f9cd-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":48,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CD-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9CD-1F3FF-200D-2642\",\"image\":\"1f9cd-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":44,\"sheet_y\":49,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Standing\",\"b\":\"1F9CD-200D-2642-FE0F\",\"c\":\"1F9CD-200D-2642\",\"j\":[\"man_standing\",\"still\"],\"k\":[44,44],\"o\":12},\"flag-tc\":{\"a\":\"Turks & Caicos Islands Flag\",\"b\":\"1F1F9-1F1E8\",\"j\":[\"flag_turks_caicos_islands\",\"turks\",\"caicos\",\"islands\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,19],\"o\":2},\"woman_standing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CD-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9CD-1F3FB-200D-2640\",\"image\":\"1f9cd-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":39,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CD-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9CD-1F3FC-200D-2640\",\"image\":\"1f9cd-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":40,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CD-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9CD-1F3FD-200D-2640\",\"image\":\"1f9cd-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":41,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CD-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9CD-1F3FE-200D-2640\",\"image\":\"1f9cd-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":42,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CD-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9CD-1F3FF-200D-2640\",\"image\":\"1f9cd-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":43,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Standing\",\"b\":\"1F9CD-200D-2640-FE0F\",\"c\":\"1F9CD-200D-2640\",\"j\":[\"woman_standing\",\"still\"],\"k\":[44,38],\"o\":12},\"plunger\":{\"a\":\"Plunger\",\"b\":\"1FAA0\",\"j\":[\"plunger\",\"toilet\"],\"k\":[52,48],\"o\":13},\"flag-td\":{\"a\":\"Chad Flag\",\"b\":\"1F1F9-1F1E9\",\"j\":[\"flag_chad\",\"td\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,20],\"o\":2},\"shower\":{\"a\":\"Shower\",\"b\":\"1F6BF\",\"j\":[\"shower\",\"clean\",\"water\",\"bathroom\"],\"k\":[36,7],\"o\":1},\"kneeling_person\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CE-1F3FB\",\"non_qualified\":null,\"image\":\"1f9ce-1f3fb.png\",\"sheet_x\":45,\"sheet_y\":11,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CE-1F3FC\",\"non_qualified\":null,\"image\":\"1f9ce-1f3fc.png\",\"sheet_x\":45,\"sheet_y\":12,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CE-1F3FD\",\"non_qualified\":null,\"image\":\"1f9ce-1f3fd.png\",\"sheet_x\":45,\"sheet_y\":13,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CE-1F3FE\",\"non_qualified\":null,\"image\":\"1f9ce-1f3fe.png\",\"sheet_x\":45,\"sheet_y\":14,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CE-1F3FF\",\"non_qualified\":null,\"image\":\"1f9ce-1f3ff.png\",\"sheet_x\":45,\"sheet_y\":15,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Kneeling Person\",\"b\":\"1F9CE\",\"j\":[\"person_kneeling\",\"pray\",\"respectful\"],\"k\":[45,10],\"o\":12},\"flag-tf\":{\"a\":\"French Southern Territories Flag\",\"b\":\"1F1F9-1F1EB\",\"j\":[\"flag_french_southern_territories\",\"french\",\"southern\",\"territories\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,21],\"o\":2},\"bathtub\":{\"a\":\"Bathtub\",\"b\":\"1F6C1\",\"j\":[\"bathtub\",\"clean\",\"shower\",\"bathroom\"],\"k\":[36,14],\"o\":1},\"man_kneeling\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CE-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9CE-1F3FB-200D-2642\",\"image\":\"1f9ce-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":5,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CE-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9CE-1F3FC-200D-2642\",\"image\":\"1f9ce-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":6,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CE-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9CE-1F3FD-200D-2642\",\"image\":\"1f9ce-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":7,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CE-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9CE-1F3FE-200D-2642\",\"image\":\"1f9ce-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":8,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CE-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9CE-1F3FF-200D-2642\",\"image\":\"1f9ce-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":45,\"sheet_y\":9,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Kneeling\",\"b\":\"1F9CE-200D-2642-FE0F\",\"c\":\"1F9CE-200D-2642\",\"j\":[\"man_kneeling\",\"pray\",\"respectful\"],\"k\":[45,4],\"o\":12},\"flag-tg\":{\"a\":\"Togo Flag\",\"b\":\"1F1F9-1F1EC\",\"j\":[\"flag_togo\",\"tg\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,22],\"o\":2},\"woman_kneeling\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9CE-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9CE-1F3FB-200D-2640\",\"image\":\"1f9ce-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":44,\"sheet_y\":57,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9CE-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9CE-1F3FC-200D-2640\",\"image\":\"1f9ce-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":0,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9CE-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9CE-1F3FD-200D-2640\",\"image\":\"1f9ce-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":1,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9CE-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9CE-1F3FE-200D-2640\",\"image\":\"1f9ce-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":2,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9CE-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9CE-1F3FF-200D-2640\",\"image\":\"1f9ce-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":45,\"sheet_y\":3,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Kneeling\",\"b\":\"1F9CE-200D-2640-FE0F\",\"c\":\"1F9CE-200D-2640\",\"j\":[\"woman_kneeling\",\"respectful\",\"pray\"],\"k\":[44,56],\"o\":12},\"mouse_trap\":{\"a\":\"Mouse Trap\",\"b\":\"1FAA4\",\"j\":[\"mouse trap\",\"cheese\"],\"k\":[52,52],\"o\":13},\"flag-th\":{\"a\":\"Thailand Flag\",\"b\":\"1F1F9-1F1ED\",\"j\":[\"flag_thailand\",\"th\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,23],\"o\":2},\"person_with_probing_cane\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f9af.png\",\"sheet_x\":47,\"sheet_y\":36,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f9af.png\",\"sheet_x\":47,\"sheet_y\":37,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f9af.png\",\"sheet_x\":47,\"sheet_y\":38,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f9af.png\",\"sheet_x\":47,\"sheet_y\":39,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f9af.png\",\"sheet_x\":47,\"sheet_y\":40,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person with White Cane\",\"b\":\"1F9D1-200D-1F9AF\",\"j\":[\"person_with_probing_cane\",\"blind\"],\"k\":[47,35],\"o\":12},\"razor\":{\"a\":\"Razor\",\"b\":\"1FA92\",\"j\":[\"razor\",\"cut\"],\"k\":[52,34],\"o\":12},\"flag-tj\":{\"a\":\"Tajikistan Flag\",\"b\":\"1F1F9-1F1EF\",\"j\":[\"flag_tajikistan\",\"tj\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,24],\"o\":2},\"man_with_probing_cane\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f9af.png\",\"sheet_x\":16,\"sheet_y\":11,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f9af.png\",\"sheet_x\":16,\"sheet_y\":12,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f9af.png\",\"sheet_x\":16,\"sheet_y\":13,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f9af.png\",\"sheet_x\":16,\"sheet_y\":14,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f9af.png\",\"sheet_x\":16,\"sheet_y\":15,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man with White Cane\",\"b\":\"1F468-200D-1F9AF\",\"j\":[\"man_with_probing_cane\",\"blind\"],\"k\":[16,10],\"o\":12},\"lotion_bottle\":{\"a\":\"Lotion Bottle\",\"b\":\"1F9F4\",\"j\":[\"lotion_bottle\",\"moisturizer\",\"sunscreen\"],\"k\":[52,5],\"o\":11},\"flag-tk\":{\"a\":\"Tokelau Flag\",\"b\":\"1F1F9-1F1F0\",\"j\":[\"flag_tokelau\",\"tk\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,25],\"o\":2},\"woman_with_probing_cane\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f9af.png\",\"sheet_x\":18,\"sheet_y\":57,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f9af.png\",\"sheet_x\":19,\"sheet_y\":0,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f9af.png\",\"sheet_x\":19,\"sheet_y\":1,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f9af.png\",\"sheet_x\":19,\"sheet_y\":2,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F9AF\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f9af.png\",\"sheet_x\":19,\"sheet_y\":3,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman with White Cane\",\"b\":\"1F469-200D-1F9AF\",\"j\":[\"woman_with_probing_cane\",\"blind\"],\"k\":[18,56],\"o\":12},\"safety_pin\":{\"a\":\"Safety Pin\",\"b\":\"1F9F7\",\"j\":[\"safety_pin\",\"diaper\"],\"k\":[52,8],\"o\":11},\"flag-tl\":{\"a\":\"Timor-Leste Flag\",\"b\":\"1F1F9-1F1F1\",\"j\":[\"flag_timor_leste\",\"timor\",\"leste\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,26],\"o\":2},\"person_in_motorized_wheelchair\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f9bc.png\",\"sheet_x\":48,\"sheet_y\":8,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f9bc.png\",\"sheet_x\":48,\"sheet_y\":9,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f9bc.png\",\"sheet_x\":48,\"sheet_y\":10,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f9bc.png\",\"sheet_x\":48,\"sheet_y\":11,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f9bc.png\",\"sheet_x\":48,\"sheet_y\":12,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person in Motorized Wheelchair\",\"b\":\"1F9D1-200D-1F9BC\",\"j\":[\"person_in_motorized_wheelchair\",\"disability\",\"accessibility\"],\"k\":[48,7],\"o\":12},\"broom\":{\"a\":\"Broom\",\"b\":\"1F9F9\",\"j\":[\"broom\",\"cleaning\",\"sweeping\",\"witch\"],\"k\":[52,10],\"o\":11},\"flag-tm\":{\"a\":\"Turkmenistan Flag\",\"b\":\"1F1F9-1F1F2\",\"j\":[\"flag_turkmenistan\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,27],\"o\":2},\"man_in_motorized_wheelchair\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f9bc.png\",\"sheet_x\":16,\"sheet_y\":41,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f9bc.png\",\"sheet_x\":16,\"sheet_y\":42,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f9bc.png\",\"sheet_x\":16,\"sheet_y\":43,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f9bc.png\",\"sheet_x\":16,\"sheet_y\":44,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f9bc.png\",\"sheet_x\":16,\"sheet_y\":45,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man in Motorized Wheelchair\",\"b\":\"1F468-200D-1F9BC\",\"j\":[\"man_in_motorized_wheelchair\",\"disability\",\"accessibility\"],\"k\":[16,40],\"o\":12},\"basket\":{\"a\":\"Basket\",\"b\":\"1F9FA\",\"j\":[\"basket\",\"laundry\"],\"k\":[52,11],\"o\":11},\"flag-tn\":{\"a\":\"Tunisia Flag\",\"b\":\"1F1F9-1F1F3\",\"j\":[\"flag_tunisia\",\"tn\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,28],\"o\":2},\"woman_in_motorized_wheelchair\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f9bc.png\",\"sheet_x\":19,\"sheet_y\":29,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f9bc.png\",\"sheet_x\":19,\"sheet_y\":30,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f9bc.png\",\"sheet_x\":19,\"sheet_y\":31,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f9bc.png\",\"sheet_x\":19,\"sheet_y\":32,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F9BC\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f9bc.png\",\"sheet_x\":19,\"sheet_y\":33,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman in Motorized Wheelchair\",\"b\":\"1F469-200D-1F9BC\",\"j\":[\"woman_in_motorized_wheelchair\",\"disability\",\"accessibility\"],\"k\":[19,28],\"o\":12},\"roll_of_paper\":{\"a\":\"Roll of Paper\",\"b\":\"1F9FB\",\"j\":[\"roll_of_paper\",\"roll\"],\"k\":[52,12],\"o\":11},\"flag-to\":{\"a\":\"Tonga Flag\",\"b\":\"1F1F9-1F1F4\",\"j\":[\"flag_tonga\",\"to\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,29],\"o\":2},\"person_in_manual_wheelchair\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f9bd.png\",\"sheet_x\":48,\"sheet_y\":14,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f9bd.png\",\"sheet_x\":48,\"sheet_y\":15,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f9bd.png\",\"sheet_x\":48,\"sheet_y\":16,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f9bd.png\",\"sheet_x\":48,\"sheet_y\":17,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f9bd.png\",\"sheet_x\":48,\"sheet_y\":18,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person in Manual Wheelchair\",\"b\":\"1F9D1-200D-1F9BD\",\"j\":[\"person_in_manual_wheelchair\",\"disability\",\"accessibility\"],\"k\":[48,13],\"o\":12},\"bucket\":{\"a\":\"Bucket\",\"b\":\"1FAA3\",\"j\":[\"bucket\",\"water\",\"container\"],\"k\":[52,51],\"o\":13},\"flag-tr\":{\"a\":\"Turkey Flag\",\"b\":\"1F1F9-1F1F7\",\"j\":[\"flag_turkey\",\"turkey\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,30],\"o\":2},\"man_in_manual_wheelchair\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F468-1F3FB-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f9bd.png\",\"sheet_x\":16,\"sheet_y\":47,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F468-1F3FC-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f9bd.png\",\"sheet_x\":16,\"sheet_y\":48,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F468-1F3FD-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f9bd.png\",\"sheet_x\":16,\"sheet_y\":49,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F468-1F3FE-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f9bd.png\",\"sheet_x\":16,\"sheet_y\":50,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F468-1F3FF-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f9bd.png\",\"sheet_x\":16,\"sheet_y\":51,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man in Manual Wheelchair\",\"b\":\"1F468-200D-1F9BD\",\"j\":[\"man_in_manual_wheelchair\",\"disability\",\"accessibility\"],\"k\":[16,46],\"o\":12},\"soap\":{\"a\":\"Bar of Soap\",\"b\":\"1F9FC\",\"j\":[\"soap\",\"bar\",\"bathing\",\"cleaning\",\"lather\"],\"k\":[52,13],\"o\":11},\"flag-tt\":{\"a\":\"Trinidad & Tobago Flag\",\"b\":\"1F1F9-1F1F9\",\"j\":[\"flag_trinidad_tobago\",\"trinidad\",\"tobago\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,31],\"o\":2},\"woman_in_manual_wheelchair\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F469-1F3FB-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f9bd.png\",\"sheet_x\":19,\"sheet_y\":35,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F469-1F3FC-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f9bd.png\",\"sheet_x\":19,\"sheet_y\":36,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F469-1F3FD-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f9bd.png\",\"sheet_x\":19,\"sheet_y\":37,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F469-1F3FE-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f9bd.png\",\"sheet_x\":19,\"sheet_y\":38,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F469-1F3FF-200D-1F9BD\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f9bd.png\",\"sheet_x\":19,\"sheet_y\":39,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman in Manual Wheelchair\",\"b\":\"1F469-200D-1F9BD\",\"j\":[\"woman_in_manual_wheelchair\",\"disability\",\"accessibility\"],\"k\":[19,34],\"o\":12},\"toothbrush\":{\"a\":\"Toothbrush\",\"b\":\"1FAA5\",\"j\":[\"toothbrush\",\"hygiene\",\"dental\"],\"k\":[52,53],\"o\":13},\"flag-tv\":{\"a\":\"Tuvalu Flag\",\"b\":\"1F1F9-1F1FB\",\"j\":[\"flag_tuvalu\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,32],\"o\":2},\"runner\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3C3-1F3FB\",\"non_qualified\":null,\"image\":\"1f3c3-1f3fb.png\",\"sheet_x\":8,\"sheet_y\":51,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3C3-1F3FC\",\"non_qualified\":null,\"image\":\"1f3c3-1f3fc.png\",\"sheet_x\":8,\"sheet_y\":52,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3C3-1F3FD\",\"non_qualified\":null,\"image\":\"1f3c3-1f3fd.png\",\"sheet_x\":8,\"sheet_y\":53,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3C3-1F3FE\",\"non_qualified\":null,\"image\":\"1f3c3-1f3fe.png\",\"sheet_x\":8,\"sheet_y\":54,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3C3-1F3FF\",\"non_qualified\":null,\"image\":\"1f3c3-1f3ff.png\",\"sheet_x\":8,\"sheet_y\":55,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F3C3-200D-2642-FE0F\",\"a\":\"Runner\",\"b\":\"1F3C3\",\"j\":[\"person_running\",\"move\"],\"k\":[8,50],\"n\":[\"running\"],\"o\":0},\"sponge\":{\"a\":\"Sponge\",\"b\":\"1F9FD\",\"j\":[\"sponge\",\"absorbing\",\"cleaning\",\"porous\"],\"k\":[52,14],\"o\":11},\"flag-tw\":{\"a\":\"Taiwan Flag\",\"b\":\"1F1F9-1F1FC\",\"j\":[\"flag_taiwan\",\"tw\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,33],\"o\":2},\"man-running\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3C3-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F3C3-1F3FB-200D-2642\",\"image\":\"1f3c3-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":8,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3C3-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F3C3-1F3FC-200D-2642\",\"image\":\"1f3c3-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":8,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3C3-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F3C3-1F3FD-200D-2642\",\"image\":\"1f3c3-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":8,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3C3-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F3C3-1F3FE-200D-2642\",\"image\":\"1f3c3-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":8,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3C3-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F3C3-1F3FF-200D-2642\",\"image\":\"1f3c3-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":8,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F3C3\",\"a\":\"Man Running\",\"b\":\"1F3C3-200D-2642-FE0F\",\"c\":\"1F3C3-200D-2642\",\"j\":[\"man_running\",\"man\",\"walking\",\"exercise\",\"race\",\"running\"],\"k\":[8,44],\"o\":4},\"fire_extinguisher\":{\"a\":\"Fire Extinguisher\",\"b\":\"1F9EF\",\"j\":[\"fire_extinguisher\",\"quench\"],\"k\":[52,0],\"o\":11},\"flag-tz\":{\"a\":\"Tanzania Flag\",\"b\":\"1F1F9-1F1FF\",\"j\":[\"flag_tanzania\",\"tanzania\",\"united\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,34],\"o\":2},\"woman-running\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3C3-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F3C3-1F3FB-200D-2640\",\"image\":\"1f3c3-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":8,\"sheet_y\":39,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3C3-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F3C3-1F3FC-200D-2640\",\"image\":\"1f3c3-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":8,\"sheet_y\":40,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3C3-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F3C3-1F3FD-200D-2640\",\"image\":\"1f3c3-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":8,\"sheet_y\":41,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3C3-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F3C3-1F3FE-200D-2640\",\"image\":\"1f3c3-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":8,\"sheet_y\":42,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3C3-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F3C3-1F3FF-200D-2640\",\"image\":\"1f3c3-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":8,\"sheet_y\":43,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Running\",\"b\":\"1F3C3-200D-2640-FE0F\",\"c\":\"1F3C3-200D-2640\",\"j\":[\"woman_running\",\"woman\",\"walking\",\"exercise\",\"race\",\"running\",\"female\"],\"k\":[8,38],\"o\":4},\"shopping_trolley\":{\"a\":\"Shopping Trolley\",\"b\":\"1F6D2\",\"j\":[\"shopping_cart\",\"trolley\"],\"k\":[36,31],\"o\":3},\"flag-ua\":{\"a\":\"Ukraine Flag\",\"b\":\"1F1FA-1F1E6\",\"j\":[\"flag_ukraine\",\"ua\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,35],\"o\":2},\"dancer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F483-1F3FB\",\"non_qualified\":null,\"image\":\"1f483-1f3fb.png\",\"sheet_x\":24,\"sheet_y\":30,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F483-1F3FC\",\"non_qualified\":null,\"image\":\"1f483-1f3fc.png\",\"sheet_x\":24,\"sheet_y\":31,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F483-1F3FD\",\"non_qualified\":null,\"image\":\"1f483-1f3fd.png\",\"sheet_x\":24,\"sheet_y\":32,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F483-1F3FE\",\"non_qualified\":null,\"image\":\"1f483-1f3fe.png\",\"sheet_x\":24,\"sheet_y\":33,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F483-1F3FF\",\"non_qualified\":null,\"image\":\"1f483-1f3ff.png\",\"sheet_x\":24,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Dancer\",\"b\":\"1F483\",\"j\":[\"woman_dancing\",\"female\",\"girl\",\"woman\",\"fun\"],\"k\":[24,29],\"o\":0},\"smoking\":{\"a\":\"Smoking Symbol\",\"b\":\"1F6AC\",\"j\":[\"cigarette\",\"kills\",\"tobacco\",\"cigarette\",\"joint\",\"smoke\"],\"k\":[34,53],\"o\":0},\"flag-ug\":{\"a\":\"Uganda Flag\",\"b\":\"1F1FA-1F1EC\",\"j\":[\"flag_uganda\",\"ug\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,36],\"o\":2},\"man_dancing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F57A-1F3FB\",\"non_qualified\":null,\"image\":\"1f57a-1f3fb.png\",\"sheet_x\":29,\"sheet_y\":36,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F57A-1F3FC\",\"non_qualified\":null,\"image\":\"1f57a-1f3fc.png\",\"sheet_x\":29,\"sheet_y\":37,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F57A-1F3FD\",\"non_qualified\":null,\"image\":\"1f57a-1f3fd.png\",\"sheet_x\":29,\"sheet_y\":38,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F57A-1F3FE\",\"non_qualified\":null,\"image\":\"1f57a-1f3fe.png\",\"sheet_x\":29,\"sheet_y\":39,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F57A-1F3FF\",\"non_qualified\":null,\"image\":\"1f57a-1f3ff.png\",\"sheet_x\":29,\"sheet_y\":40,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Dancing\",\"b\":\"1F57A\",\"j\":[\"man_dancing\",\"male\",\"boy\",\"fun\",\"dancer\"],\"k\":[29,35],\"o\":3},\"coffin\":{\"a\":\"Coffin\",\"b\":\"26B0-FE0F\",\"c\":\"26B0\",\"j\":[\"coffin\",\"vampire\",\"dead\",\"die\",\"death\",\"rip\",\"graveyard\",\"cemetery\",\"casket\",\"funeral\",\"box\"],\"k\":[55,2],\"o\":1},\"flag-um\":{\"a\":\"U.s. Outlying Islands Flag\",\"b\":\"1F1FA-1F1F2\",\"j\":[\"flag_u_s_outlying_islands\"],\"k\":[4,37],\"o\":2},\"man_in_business_suit_levitating\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F574-1F3FB\",\"non_qualified\":null,\"image\":\"1f574-1f3fb.png\",\"sheet_x\":29,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F574-1F3FC\",\"non_qualified\":null,\"image\":\"1f574-1f3fc.png\",\"sheet_x\":29,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F574-1F3FD\",\"non_qualified\":null,\"image\":\"1f574-1f3fd.png\",\"sheet_x\":29,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F574-1F3FE\",\"non_qualified\":null,\"image\":\"1f574-1f3fe.png\",\"sheet_x\":29,\"sheet_y\":11,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F574-1F3FF\",\"non_qualified\":null,\"image\":\"1f574-1f3ff.png\",\"sheet_x\":29,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person in Suit Levitating\",\"b\":\"1F574-FE0F\",\"c\":\"1F574\",\"j\":[\"man_in_suit_levitating\",\"suit\",\"business\",\"levitate\",\"hover\",\"jump\"],\"k\":[29,7],\"o\":0},\"headstone\":{\"a\":\"Headstone\",\"b\":\"1FAA6\",\"j\":[\"headstone\",\"death\",\"rip\",\"grave\"],\"k\":[52,54],\"o\":13},\"flag-un\":{\"a\":\"United Nations Flag\",\"b\":\"1F1FA-1F1F3\",\"j\":[\"flag_united_nations\",\"un\",\"flag\",\"banner\"],\"k\":[4,38],\"o\":4},\"dancers\":{\"obsoleted_by\":\"1F46F-200D-2640-FE0F\",\"a\":\"Woman with Bunny Ears\",\"b\":\"1F46F\",\"j\":[\"people_with_bunny_ears\",\"perform\",\"costume\"],\"k\":[21,51],\"o\":0},\"funeral_urn\":{\"a\":\"Funeral Urn\",\"b\":\"26B1-FE0F\",\"c\":\"26B1\",\"j\":[\"funeral_urn\",\"dead\",\"die\",\"death\",\"rip\",\"ashes\"],\"k\":[55,3],\"o\":1},\"us\":{\"a\":\"United States Flag\",\"b\":\"1F1FA-1F1F8\",\"j\":[\"flag_united_states\",\"united\",\"states\",\"america\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,39],\"n\":[\"flag-us\"],\"o\":0},\"man-with-bunny-ears-partying\":{\"a\":\"Men with Bunny Ears\",\"b\":\"1F46F-200D-2642-FE0F\",\"c\":\"1F46F-200D-2642\",\"j\":[\"men_with_bunny_ears\",\"male\",\"bunny\",\"men\",\"boys\"],\"k\":[21,50],\"o\":4},\"moyai\":{\"a\":\"Moyai\",\"b\":\"1F5FF\",\"j\":[\"moai\",\"rock\",\"easter island\",\"moai\"],\"k\":[30,31],\"o\":0},\"flag-uy\":{\"a\":\"Uruguay Flag\",\"b\":\"1F1FA-1F1FE\",\"j\":[\"flag_uruguay\",\"uy\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,40],\"o\":2},\"woman-with-bunny-ears-partying\":{\"obsoletes\":\"1F46F\",\"a\":\"Women with Bunny Ears\",\"b\":\"1F46F-200D-2640-FE0F\",\"c\":\"1F46F-200D-2640\",\"j\":[\"women_with_bunny_ears\",\"female\",\"bunny\",\"women\",\"girls\"],\"k\":[21,49],\"o\":4},\"placard\":{\"a\":\"Placard\",\"b\":\"1FAA7\",\"j\":[\"placard\",\"announcement\"],\"k\":[52,55],\"o\":13},\"flag-uz\":{\"a\":\"Uzbekistan Flag\",\"b\":\"1F1FA-1F1FF\",\"j\":[\"flag_uzbekistan\",\"uz\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,41],\"o\":2},\"person_in_steamy_room\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D6-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d6-1f3fb.png\",\"sheet_x\":49,\"sheet_y\":22,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D6-1F3FB-200D-2642-FE0F\"},\"1F3FC\":{\"unified\":\"1F9D6-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d6-1f3fc.png\",\"sheet_x\":49,\"sheet_y\":23,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D6-1F3FC-200D-2642-FE0F\"},\"1F3FD\":{\"unified\":\"1F9D6-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d6-1f3fd.png\",\"sheet_x\":49,\"sheet_y\":24,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D6-1F3FD-200D-2642-FE0F\"},\"1F3FE\":{\"unified\":\"1F9D6-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d6-1f3fe.png\",\"sheet_x\":49,\"sheet_y\":25,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D6-1F3FE-200D-2642-FE0F\"},\"1F3FF\":{\"unified\":\"1F9D6-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d6-1f3ff.png\",\"sheet_x\":49,\"sheet_y\":26,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D6-1F3FF-200D-2642-FE0F\"}},\"obsoleted_by\":\"1F9D6-200D-2642-FE0F\",\"a\":\"Person in Steamy Room\",\"b\":\"1F9D6\",\"j\":[\"person_in_steamy_room\",\"relax\",\"spa\"],\"k\":[49,21],\"o\":5},\"flag-va\":{\"a\":\"Vatican City Flag\",\"b\":\"1F1FB-1F1E6\",\"j\":[\"flag_vatican_city\",\"vatican\",\"city\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,42],\"o\":2},\"man_in_steamy_room\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D6-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9D6-1F3FB-200D-2642\",\"image\":\"1f9d6-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":16,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D6-1F3FB\"},\"1F3FC\":{\"unified\":\"1F9D6-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9D6-1F3FC-200D-2642\",\"image\":\"1f9d6-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":17,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D6-1F3FC\"},\"1F3FD\":{\"unified\":\"1F9D6-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9D6-1F3FD-200D-2642\",\"image\":\"1f9d6-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":18,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D6-1F3FD\"},\"1F3FE\":{\"unified\":\"1F9D6-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9D6-1F3FE-200D-2642\",\"image\":\"1f9d6-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":19,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D6-1F3FE\"},\"1F3FF\":{\"unified\":\"1F9D6-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9D6-1F3FF-200D-2642\",\"image\":\"1f9d6-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":20,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D6-1F3FF\"}},\"obsoletes\":\"1F9D6\",\"a\":\"Man in Steamy Room\",\"b\":\"1F9D6-200D-2642-FE0F\",\"c\":\"1F9D6-200D-2642\",\"j\":[\"man_in_steamy_room\",\"male\",\"man\",\"spa\",\"steamroom\",\"sauna\"],\"k\":[49,15],\"o\":5},\"flag-vc\":{\"a\":\"St. Vincent & Grenadines Flag\",\"b\":\"1F1FB-1F1E8\",\"j\":[\"flag_st_vincent_grenadines\",\"saint\",\"vincent\",\"grenadines\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,43],\"o\":2},\"woman_in_steamy_room\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D6-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9D6-1F3FB-200D-2640\",\"image\":\"1f9d6-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":10,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D6-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9D6-1F3FC-200D-2640\",\"image\":\"1f9d6-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":11,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D6-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9D6-1F3FD-200D-2640\",\"image\":\"1f9d6-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":12,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D6-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9D6-1F3FE-200D-2640\",\"image\":\"1f9d6-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":13,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D6-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9D6-1F3FF-200D-2640\",\"image\":\"1f9d6-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":14,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman in Steamy Room\",\"b\":\"1F9D6-200D-2640-FE0F\",\"c\":\"1F9D6-200D-2640\",\"j\":[\"woman_in_steamy_room\",\"female\",\"woman\",\"spa\",\"steamroom\",\"sauna\"],\"k\":[49,9],\"o\":5},\"flag-ve\":{\"a\":\"Venezuela Flag\",\"b\":\"1F1FB-1F1EA\",\"j\":[\"flag_venezuela\",\"ve\",\"bolivarian\",\"republic\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,44],\"o\":2},\"person_climbing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D7-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d7-1f3fb.png\",\"sheet_x\":49,\"sheet_y\":40,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D7-1F3FB-200D-2640-FE0F\"},\"1F3FC\":{\"unified\":\"1F9D7-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d7-1f3fc.png\",\"sheet_x\":49,\"sheet_y\":41,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D7-1F3FC-200D-2640-FE0F\"},\"1F3FD\":{\"unified\":\"1F9D7-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d7-1f3fd.png\",\"sheet_x\":49,\"sheet_y\":42,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D7-1F3FD-200D-2640-FE0F\"},\"1F3FE\":{\"unified\":\"1F9D7-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d7-1f3fe.png\",\"sheet_x\":49,\"sheet_y\":43,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D7-1F3FE-200D-2640-FE0F\"},\"1F3FF\":{\"unified\":\"1F9D7-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d7-1f3ff.png\",\"sheet_x\":49,\"sheet_y\":44,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D7-1F3FF-200D-2640-FE0F\"}},\"obsoleted_by\":\"1F9D7-200D-2640-FE0F\",\"a\":\"Person Climbing\",\"b\":\"1F9D7\",\"j\":[\"person_climbing\",\"sport\"],\"k\":[49,39],\"o\":5},\"flag-vg\":{\"a\":\"British Virgin Islands Flag\",\"b\":\"1F1FB-1F1EC\",\"j\":[\"flag_british_virgin_islands\",\"british\",\"virgin\",\"islands\",\"bvi\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,45],\"o\":2},\"man_climbing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D7-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9D7-1F3FB-200D-2642\",\"image\":\"1f9d7-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":34,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D7-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9D7-1F3FC-200D-2642\",\"image\":\"1f9d7-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":35,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D7-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9D7-1F3FD-200D-2642\",\"image\":\"1f9d7-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":36,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D7-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9D7-1F3FE-200D-2642\",\"image\":\"1f9d7-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":37,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D7-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9D7-1F3FF-200D-2642\",\"image\":\"1f9d7-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":38,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Climbing\",\"b\":\"1F9D7-200D-2642-FE0F\",\"c\":\"1F9D7-200D-2642\",\"j\":[\"man_climbing\",\"sports\",\"hobby\",\"man\",\"male\",\"rock\"],\"k\":[49,33],\"o\":5},\"flag-vi\":{\"a\":\"U.s. Virgin Islands Flag\",\"b\":\"1F1FB-1F1EE\",\"j\":[\"flag_u_s_virgin_islands\",\"virgin\",\"islands\",\"us\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,46],\"o\":2},\"woman_climbing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D7-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9D7-1F3FB-200D-2640\",\"image\":\"1f9d7-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":28,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D7-1F3FB\"},\"1F3FC\":{\"unified\":\"1F9D7-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9D7-1F3FC-200D-2640\",\"image\":\"1f9d7-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":29,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D7-1F3FC\"},\"1F3FD\":{\"unified\":\"1F9D7-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9D7-1F3FD-200D-2640\",\"image\":\"1f9d7-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":30,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D7-1F3FD\"},\"1F3FE\":{\"unified\":\"1F9D7-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9D7-1F3FE-200D-2640\",\"image\":\"1f9d7-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":31,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D7-1F3FE\"},\"1F3FF\":{\"unified\":\"1F9D7-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9D7-1F3FF-200D-2640\",\"image\":\"1f9d7-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":32,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D7-1F3FF\"}},\"obsoletes\":\"1F9D7\",\"a\":\"Woman Climbing\",\"b\":\"1F9D7-200D-2640-FE0F\",\"c\":\"1F9D7-200D-2640\",\"j\":[\"woman_climbing\",\"sports\",\"hobby\",\"woman\",\"female\",\"rock\"],\"k\":[49,27],\"o\":5},\"flag-vn\":{\"a\":\"Vietnam Flag\",\"b\":\"1F1FB-1F1F3\",\"j\":[\"flag_vietnam\",\"viet\",\"nam\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,47],\"o\":2},\"fencer\":{\"a\":\"Fencer\",\"b\":\"1F93A\",\"j\":[\"person_fencing\",\"sports\",\"fencing\",\"sword\"],\"k\":[40,41],\"o\":3},\"flag-vu\":{\"a\":\"Vanuatu Flag\",\"b\":\"1F1FB-1F1FA\",\"j\":[\"flag_vanuatu\",\"vu\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,48],\"o\":2},\"horse_racing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3C7-1F3FB\",\"non_qualified\":null,\"image\":\"1f3c7-1f3fb.png\",\"sheet_x\":9,\"sheet_y\":19,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3C7-1F3FC\",\"non_qualified\":null,\"image\":\"1f3c7-1f3fc.png\",\"sheet_x\":9,\"sheet_y\":20,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3C7-1F3FD\",\"non_qualified\":null,\"image\":\"1f3c7-1f3fd.png\",\"sheet_x\":9,\"sheet_y\":21,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3C7-1F3FE\",\"non_qualified\":null,\"image\":\"1f3c7-1f3fe.png\",\"sheet_x\":9,\"sheet_y\":22,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3C7-1F3FF\",\"non_qualified\":null,\"image\":\"1f3c7-1f3ff.png\",\"sheet_x\":9,\"sheet_y\":23,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Horse Racing\",\"b\":\"1F3C7\",\"j\":[\"horse_racing\",\"animal\",\"betting\",\"competition\",\"gambling\",\"luck\"],\"k\":[9,18],\"o\":1},\"flag-wf\":{\"a\":\"Wallis & Futuna Flag\",\"b\":\"1F1FC-1F1EB\",\"j\":[\"flag_wallis_futuna\",\"wallis\",\"futuna\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,49],\"o\":2},\"skier\":{\"a\":\"Skier\",\"b\":\"26F7-FE0F\",\"c\":\"26F7\",\"j\":[\"skier\",\"sports\",\"winter\",\"snow\"],\"k\":[55,22],\"o\":0},\"flag-ws\":{\"a\":\"Samoa Flag\",\"b\":\"1F1FC-1F1F8\",\"j\":[\"flag_samoa\",\"ws\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,50],\"o\":2},\"snowboarder\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3C2-1F3FB\",\"non_qualified\":null,\"image\":\"1f3c2-1f3fb.png\",\"sheet_x\":8,\"sheet_y\":33,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3C2-1F3FC\",\"non_qualified\":null,\"image\":\"1f3c2-1f3fc.png\",\"sheet_x\":8,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3C2-1F3FD\",\"non_qualified\":null,\"image\":\"1f3c2-1f3fd.png\",\"sheet_x\":8,\"sheet_y\":35,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3C2-1F3FE\",\"non_qualified\":null,\"image\":\"1f3c2-1f3fe.png\",\"sheet_x\":8,\"sheet_y\":36,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3C2-1F3FF\",\"non_qualified\":null,\"image\":\"1f3c2-1f3ff.png\",\"sheet_x\":8,\"sheet_y\":37,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Snowboarder\",\"b\":\"1F3C2\",\"j\":[\"snowboarder\",\"sports\",\"winter\"],\"k\":[8,32],\"o\":0},\"flag-xk\":{\"a\":\"Kosovo Flag\",\"b\":\"1F1FD-1F1F0\",\"j\":[\"flag_kosovo\",\"xk\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,51],\"o\":2},\"golfer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CC-1F3FB\",\"non_qualified\":null,\"image\":\"1f3cc-1f3fb.png\",\"sheet_x\":10,\"sheet_y\":17,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CC-1F3FC\",\"non_qualified\":null,\"image\":\"1f3cc-1f3fc.png\",\"sheet_x\":10,\"sheet_y\":18,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CC-1F3FD\",\"non_qualified\":null,\"image\":\"1f3cc-1f3fd.png\",\"sheet_x\":10,\"sheet_y\":19,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CC-1F3FE\",\"non_qualified\":null,\"image\":\"1f3cc-1f3fe.png\",\"sheet_x\":10,\"sheet_y\":20,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CC-1F3FF\",\"non_qualified\":null,\"image\":\"1f3cc-1f3ff.png\",\"sheet_x\":10,\"sheet_y\":21,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F3CC-FE0F-200D-2642-FE0F\",\"a\":\"Person Golfing\",\"b\":\"1F3CC-FE0F\",\"c\":\"1F3CC\",\"j\":[\"person_golfing\",\"sports\",\"business\"],\"k\":[10,16],\"o\":0},\"flag-ye\":{\"a\":\"Yemen Flag\",\"b\":\"1F1FE-1F1EA\",\"j\":[\"flag_yemen\",\"ye\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,52],\"o\":2},\"man-golfing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CC-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F3CC-1F3FB-200D-2642\",\"image\":\"1f3cc-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":10,\"sheet_y\":11,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CC-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F3CC-1F3FC-200D-2642\",\"image\":\"1f3cc-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":10,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CC-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F3CC-1F3FD-200D-2642\",\"image\":\"1f3cc-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":10,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CC-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F3CC-1F3FE-200D-2642\",\"image\":\"1f3cc-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":10,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CC-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F3CC-1F3FF-200D-2642\",\"image\":\"1f3cc-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":10,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F3CC-FE0F\",\"a\":\"Man Golfing\",\"b\":\"1F3CC-FE0F-200D-2642-FE0F\",\"j\":[\"man_golfing\",\"sport\"],\"k\":[10,10],\"o\":4},\"flag-yt\":{\"a\":\"Mayotte Flag\",\"b\":\"1F1FE-1F1F9\",\"j\":[\"flag_mayotte\",\"yt\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,53],\"o\":2},\"woman-golfing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CC-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F3CC-1F3FB-200D-2640\",\"image\":\"1f3cc-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":10,\"sheet_y\":5,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CC-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F3CC-1F3FC-200D-2640\",\"image\":\"1f3cc-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":10,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CC-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F3CC-1F3FD-200D-2640\",\"image\":\"1f3cc-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":10,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CC-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F3CC-1F3FE-200D-2640\",\"image\":\"1f3cc-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":10,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CC-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F3CC-1F3FF-200D-2640\",\"image\":\"1f3cc-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":10,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Golfing\",\"b\":\"1F3CC-FE0F-200D-2640-FE0F\",\"j\":[\"woman_golfing\",\"sports\",\"business\",\"woman\",\"female\"],\"k\":[10,4],\"o\":4},\"flag-za\":{\"a\":\"South Africa Flag\",\"b\":\"1F1FF-1F1E6\",\"j\":[\"flag_south_africa\",\"south\",\"africa\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,54],\"o\":2},\"surfer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3C4-1F3FB\",\"non_qualified\":null,\"image\":\"1f3c4-1f3fb.png\",\"sheet_x\":9,\"sheet_y\":11,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3C4-1F3FC\",\"non_qualified\":null,\"image\":\"1f3c4-1f3fc.png\",\"sheet_x\":9,\"sheet_y\":12,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3C4-1F3FD\",\"non_qualified\":null,\"image\":\"1f3c4-1f3fd.png\",\"sheet_x\":9,\"sheet_y\":13,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3C4-1F3FE\",\"non_qualified\":null,\"image\":\"1f3c4-1f3fe.png\",\"sheet_x\":9,\"sheet_y\":14,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3C4-1F3FF\",\"non_qualified\":null,\"image\":\"1f3c4-1f3ff.png\",\"sheet_x\":9,\"sheet_y\":15,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F3C4-200D-2642-FE0F\",\"a\":\"Surfer\",\"b\":\"1F3C4\",\"j\":[\"person_surfing\",\"sport\",\"sea\"],\"k\":[9,10],\"o\":0},\"flag-zm\":{\"a\":\"Zambia Flag\",\"b\":\"1F1FF-1F1F2\",\"j\":[\"flag_zambia\",\"zm\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,55],\"o\":2},\"man-surfing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3C4-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F3C4-1F3FB-200D-2642\",\"image\":\"1f3c4-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":5,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3C4-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F3C4-1F3FC-200D-2642\",\"image\":\"1f3c4-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3C4-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F3C4-1F3FD-200D-2642\",\"image\":\"1f3c4-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3C4-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F3C4-1F3FE-200D-2642\",\"image\":\"1f3c4-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3C4-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F3C4-1F3FF-200D-2642\",\"image\":\"1f3c4-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F3C4\",\"a\":\"Man Surfing\",\"b\":\"1F3C4-200D-2642-FE0F\",\"c\":\"1F3C4-200D-2642\",\"j\":[\"man_surfing\",\"sports\",\"ocean\",\"sea\",\"summer\",\"beach\"],\"k\":[9,4],\"o\":4},\"flag-zw\":{\"a\":\"Zimbabwe Flag\",\"b\":\"1F1FF-1F1FC\",\"j\":[\"flag_zimbabwe\",\"zw\",\"flag\",\"nation\",\"country\",\"banner\"],\"k\":[4,56],\"o\":2},\"woman-surfing\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3C4-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F3C4-1F3FB-200D-2640\",\"image\":\"1f3c4-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":8,\"sheet_y\":57,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3C4-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F3C4-1F3FC-200D-2640\",\"image\":\"1f3c4-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":0,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3C4-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F3C4-1F3FD-200D-2640\",\"image\":\"1f3c4-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":1,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3C4-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F3C4-1F3FE-200D-2640\",\"image\":\"1f3c4-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":2,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3C4-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F3C4-1F3FF-200D-2640\",\"image\":\"1f3c4-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":3,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Surfing\",\"b\":\"1F3C4-200D-2640-FE0F\",\"c\":\"1F3C4-200D-2640\",\"j\":[\"woman_surfing\",\"sports\",\"ocean\",\"sea\",\"summer\",\"beach\",\"woman\",\"female\"],\"k\":[8,56],\"o\":4},\"flag-england\":{\"a\":\"England Flag\",\"b\":\"1F3F4-E0067-E0062-E0065-E006E-E0067-E007F\",\"j\":[\"flag_england\",\"flag\",\"english\"],\"k\":[11,4],\"o\":5},\"rowboat\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6A3-1F3FB\",\"non_qualified\":null,\"image\":\"1f6a3-1f3fb.png\",\"sheet_x\":34,\"sheet_y\":40,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6A3-1F3FC\",\"non_qualified\":null,\"image\":\"1f6a3-1f3fc.png\",\"sheet_x\":34,\"sheet_y\":41,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6A3-1F3FD\",\"non_qualified\":null,\"image\":\"1f6a3-1f3fd.png\",\"sheet_x\":34,\"sheet_y\":42,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6A3-1F3FE\",\"non_qualified\":null,\"image\":\"1f6a3-1f3fe.png\",\"sheet_x\":34,\"sheet_y\":43,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6A3-1F3FF\",\"non_qualified\":null,\"image\":\"1f6a3-1f3ff.png\",\"sheet_x\":34,\"sheet_y\":44,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F6A3-200D-2642-FE0F\",\"a\":\"Rowboat\",\"b\":\"1F6A3\",\"j\":[\"person_rowing_boat\",\"sport\",\"move\"],\"k\":[34,39],\"o\":1},\"flag-scotland\":{\"a\":\"Scotland Flag\",\"b\":\"1F3F4-E0067-E0062-E0073-E0063-E0074-E007F\",\"j\":[\"flag_scotland\",\"flag\",\"scottish\"],\"k\":[11,5],\"o\":5},\"man-rowing-boat\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6A3-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F6A3-1F3FB-200D-2642\",\"image\":\"1f6a3-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":34,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6A3-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F6A3-1F3FC-200D-2642\",\"image\":\"1f6a3-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":34,\"sheet_y\":35,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6A3-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F6A3-1F3FD-200D-2642\",\"image\":\"1f6a3-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":34,\"sheet_y\":36,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6A3-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F6A3-1F3FE-200D-2642\",\"image\":\"1f6a3-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":34,\"sheet_y\":37,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6A3-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F6A3-1F3FF-200D-2642\",\"image\":\"1f6a3-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":34,\"sheet_y\":38,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F6A3\",\"a\":\"Man Rowing Boat\",\"b\":\"1F6A3-200D-2642-FE0F\",\"c\":\"1F6A3-200D-2642\",\"j\":[\"man_rowing_boat\",\"sports\",\"hobby\",\"water\",\"ship\"],\"k\":[34,33],\"o\":4},\"flag-wales\":{\"a\":\"Wales Flag\",\"b\":\"1F3F4-E0067-E0062-E0077-E006C-E0073-E007F\",\"j\":[\"flag_wales\",\"flag\",\"welsh\"],\"k\":[11,6],\"o\":5},\"woman-rowing-boat\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6A3-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F6A3-1F3FB-200D-2640\",\"image\":\"1f6a3-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":34,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6A3-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F6A3-1F3FC-200D-2640\",\"image\":\"1f6a3-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":34,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6A3-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F6A3-1F3FD-200D-2640\",\"image\":\"1f6a3-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":34,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6A3-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F6A3-1F3FE-200D-2640\",\"image\":\"1f6a3-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":34,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6A3-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F6A3-1F3FF-200D-2640\",\"image\":\"1f6a3-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":34,\"sheet_y\":32,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Rowing Boat\",\"b\":\"1F6A3-200D-2640-FE0F\",\"c\":\"1F6A3-200D-2640\",\"j\":[\"woman_rowing_boat\",\"sports\",\"hobby\",\"water\",\"ship\",\"woman\",\"female\"],\"k\":[34,27],\"o\":4},\"swimmer\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CA-1F3FB\",\"non_qualified\":null,\"image\":\"1f3ca-1f3fb.png\",\"sheet_x\":9,\"sheet_y\":39,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CA-1F3FC\",\"non_qualified\":null,\"image\":\"1f3ca-1f3fc.png\",\"sheet_x\":9,\"sheet_y\":40,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CA-1F3FD\",\"non_qualified\":null,\"image\":\"1f3ca-1f3fd.png\",\"sheet_x\":9,\"sheet_y\":41,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CA-1F3FE\",\"non_qualified\":null,\"image\":\"1f3ca-1f3fe.png\",\"sheet_x\":9,\"sheet_y\":42,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CA-1F3FF\",\"non_qualified\":null,\"image\":\"1f3ca-1f3ff.png\",\"sheet_x\":9,\"sheet_y\":43,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F3CA-200D-2642-FE0F\",\"a\":\"Swimmer\",\"b\":\"1F3CA\",\"j\":[\"person_swimming\",\"sport\",\"pool\"],\"k\":[9,38],\"o\":0},\"man-swimming\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CA-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F3CA-1F3FB-200D-2642\",\"image\":\"1f3ca-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":33,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CA-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F3CA-1F3FC-200D-2642\",\"image\":\"1f3ca-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CA-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F3CA-1F3FD-200D-2642\",\"image\":\"1f3ca-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":35,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CA-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F3CA-1F3FE-200D-2642\",\"image\":\"1f3ca-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":36,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CA-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F3CA-1F3FF-200D-2642\",\"image\":\"1f3ca-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":37,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F3CA\",\"a\":\"Man Swimming\",\"b\":\"1F3CA-200D-2642-FE0F\",\"c\":\"1F3CA-200D-2642\",\"j\":[\"man_swimming\",\"sports\",\"exercise\",\"human\",\"athlete\",\"water\",\"summer\"],\"k\":[9,32],\"o\":4},\"woman-swimming\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CA-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F3CA-1F3FB-200D-2640\",\"image\":\"1f3ca-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":27,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CA-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F3CA-1F3FC-200D-2640\",\"image\":\"1f3ca-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CA-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F3CA-1F3FD-200D-2640\",\"image\":\"1f3ca-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CA-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F3CA-1F3FE-200D-2640\",\"image\":\"1f3ca-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CA-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F3CA-1F3FF-200D-2640\",\"image\":\"1f3ca-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Swimming\",\"b\":\"1F3CA-200D-2640-FE0F\",\"c\":\"1F3CA-200D-2640\",\"j\":[\"woman_swimming\",\"sports\",\"exercise\",\"human\",\"athlete\",\"water\",\"summer\",\"woman\",\"female\"],\"k\":[9,26],\"o\":4},\"person_with_ball\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"26F9-1F3FB\",\"non_qualified\":null,\"image\":\"26f9-1f3fb.png\",\"sheet_x\":55,\"sheet_y\":37,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"26F9-1F3FC\",\"non_qualified\":null,\"image\":\"26f9-1f3fc.png\",\"sheet_x\":55,\"sheet_y\":38,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"26F9-1F3FD\",\"non_qualified\":null,\"image\":\"26f9-1f3fd.png\",\"sheet_x\":55,\"sheet_y\":39,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"26F9-1F3FE\",\"non_qualified\":null,\"image\":\"26f9-1f3fe.png\",\"sheet_x\":55,\"sheet_y\":40,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"26F9-1F3FF\",\"non_qualified\":null,\"image\":\"26f9-1f3ff.png\",\"sheet_x\":55,\"sheet_y\":41,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"26F9-FE0F-200D-2642-FE0F\",\"a\":\"Person Bouncing Ball\",\"b\":\"26F9-FE0F\",\"c\":\"26F9\",\"j\":[\"person_bouncing_ball\",\"sports\",\"human\"],\"k\":[55,36],\"o\":0},\"man-bouncing-ball\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"26F9-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"26F9-1F3FB-200D-2642\",\"image\":\"26f9-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":55,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"26F9-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"26F9-1F3FC-200D-2642\",\"image\":\"26f9-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":55,\"sheet_y\":32,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"26F9-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"26F9-1F3FD-200D-2642\",\"image\":\"26f9-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":55,\"sheet_y\":33,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"26F9-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"26F9-1F3FE-200D-2642\",\"image\":\"26f9-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":55,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"26F9-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"26F9-1F3FF-200D-2642\",\"image\":\"26f9-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":55,\"sheet_y\":35,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"26F9-FE0F\",\"a\":\"Man Bouncing Ball\",\"b\":\"26F9-FE0F-200D-2642-FE0F\",\"j\":[\"man_bouncing_ball\",\"sport\"],\"k\":[55,30],\"o\":4},\"woman-bouncing-ball\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"26F9-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"26F9-1F3FB-200D-2640\",\"image\":\"26f9-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":55,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"26F9-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"26F9-1F3FC-200D-2640\",\"image\":\"26f9-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":55,\"sheet_y\":26,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"26F9-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"26F9-1F3FD-200D-2640\",\"image\":\"26f9-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":55,\"sheet_y\":27,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"26F9-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"26F9-1F3FE-200D-2640\",\"image\":\"26f9-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":55,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"26F9-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"26F9-1F3FF-200D-2640\",\"image\":\"26f9-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":55,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Bouncing Ball\",\"b\":\"26F9-FE0F-200D-2640-FE0F\",\"j\":[\"woman_bouncing_ball\",\"sports\",\"human\",\"woman\",\"female\"],\"k\":[55,24],\"o\":4},\"weight_lifter\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CB-1F3FB\",\"non_qualified\":null,\"image\":\"1f3cb-1f3fb.png\",\"sheet_x\":9,\"sheet_y\":57,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CB-1F3FC\",\"non_qualified\":null,\"image\":\"1f3cb-1f3fc.png\",\"sheet_x\":10,\"sheet_y\":0,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CB-1F3FD\",\"non_qualified\":null,\"image\":\"1f3cb-1f3fd.png\",\"sheet_x\":10,\"sheet_y\":1,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CB-1F3FE\",\"non_qualified\":null,\"image\":\"1f3cb-1f3fe.png\",\"sheet_x\":10,\"sheet_y\":2,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CB-1F3FF\",\"non_qualified\":null,\"image\":\"1f3cb-1f3ff.png\",\"sheet_x\":10,\"sheet_y\":3,\"added_in\":\"2.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F3CB-FE0F-200D-2642-FE0F\",\"a\":\"Person Lifting Weights\",\"b\":\"1F3CB-FE0F\",\"c\":\"1F3CB\",\"j\":[\"person_lifting_weights\",\"sports\",\"training\",\"exercise\"],\"k\":[9,56],\"o\":0},\"man-lifting-weights\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CB-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F3CB-1F3FB-200D-2642\",\"image\":\"1f3cb-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":51,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CB-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F3CB-1F3FC-200D-2642\",\"image\":\"1f3cb-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CB-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F3CB-1F3FD-200D-2642\",\"image\":\"1f3cb-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CB-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F3CB-1F3FE-200D-2642\",\"image\":\"1f3cb-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CB-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F3CB-1F3FF-200D-2642\",\"image\":\"1f3cb-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":9,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F3CB-FE0F\",\"a\":\"Man Lifting Weights\",\"b\":\"1F3CB-FE0F-200D-2642-FE0F\",\"j\":[\"man_lifting_weights\",\"sport\"],\"k\":[9,50],\"o\":4},\"woman-lifting-weights\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F3CB-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F3CB-1F3FB-200D-2640\",\"image\":\"1f3cb-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":45,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F3CB-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F3CB-1F3FC-200D-2640\",\"image\":\"1f3cb-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F3CB-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F3CB-1F3FD-200D-2640\",\"image\":\"1f3cb-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F3CB-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F3CB-1F3FE-200D-2640\",\"image\":\"1f3cb-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F3CB-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F3CB-1F3FF-200D-2640\",\"image\":\"1f3cb-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":9,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Lifting Weights\",\"b\":\"1F3CB-FE0F-200D-2640-FE0F\",\"j\":[\"woman_lifting_weights\",\"sports\",\"training\",\"exercise\",\"woman\",\"female\"],\"k\":[9,44],\"o\":4},\"bicyclist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B4-1F3FB\",\"non_qualified\":null,\"image\":\"1f6b4-1f3fb.png\",\"sheet_x\":35,\"sheet_y\":16,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B4-1F3FC\",\"non_qualified\":null,\"image\":\"1f6b4-1f3fc.png\",\"sheet_x\":35,\"sheet_y\":17,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B4-1F3FD\",\"non_qualified\":null,\"image\":\"1f6b4-1f3fd.png\",\"sheet_x\":35,\"sheet_y\":18,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B4-1F3FE\",\"non_qualified\":null,\"image\":\"1f6b4-1f3fe.png\",\"sheet_x\":35,\"sheet_y\":19,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B4-1F3FF\",\"non_qualified\":null,\"image\":\"1f6b4-1f3ff.png\",\"sheet_x\":35,\"sheet_y\":20,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F6B4-200D-2642-FE0F\",\"a\":\"Bicyclist\",\"b\":\"1F6B4\",\"j\":[\"person_biking\",\"sport\",\"move\"],\"k\":[35,15],\"o\":1},\"man-biking\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B4-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F6B4-1F3FB-200D-2642\",\"image\":\"1f6b4-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B4-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F6B4-1F3FC-200D-2642\",\"image\":\"1f6b4-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":11,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B4-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F6B4-1F3FD-200D-2642\",\"image\":\"1f6b4-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B4-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F6B4-1F3FE-200D-2642\",\"image\":\"1f6b4-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B4-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F6B4-1F3FF-200D-2642\",\"image\":\"1f6b4-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F6B4\",\"a\":\"Man Biking\",\"b\":\"1F6B4-200D-2642-FE0F\",\"c\":\"1F6B4-200D-2642\",\"j\":[\"man_biking\",\"sports\",\"bike\",\"exercise\",\"hipster\"],\"k\":[35,9],\"o\":4},\"woman-biking\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B4-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F6B4-1F3FB-200D-2640\",\"image\":\"1f6b4-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":4,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B4-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F6B4-1F3FC-200D-2640\",\"image\":\"1f6b4-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":5,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B4-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F6B4-1F3FD-200D-2640\",\"image\":\"1f6b4-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B4-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F6B4-1F3FE-200D-2640\",\"image\":\"1f6b4-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B4-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F6B4-1F3FF-200D-2640\",\"image\":\"1f6b4-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Biking\",\"b\":\"1F6B4-200D-2640-FE0F\",\"c\":\"1F6B4-200D-2640\",\"j\":[\"woman_biking\",\"sports\",\"bike\",\"exercise\",\"hipster\",\"woman\",\"female\"],\"k\":[35,3],\"o\":4},\"mountain_bicyclist\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B5-1F3FB\",\"non_qualified\":null,\"image\":\"1f6b5-1f3fb.png\",\"sheet_x\":35,\"sheet_y\":34,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B5-1F3FC\",\"non_qualified\":null,\"image\":\"1f6b5-1f3fc.png\",\"sheet_x\":35,\"sheet_y\":35,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B5-1F3FD\",\"non_qualified\":null,\"image\":\"1f6b5-1f3fd.png\",\"sheet_x\":35,\"sheet_y\":36,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B5-1F3FE\",\"non_qualified\":null,\"image\":\"1f6b5-1f3fe.png\",\"sheet_x\":35,\"sheet_y\":37,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B5-1F3FF\",\"non_qualified\":null,\"image\":\"1f6b5-1f3ff.png\",\"sheet_x\":35,\"sheet_y\":38,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoleted_by\":\"1F6B5-200D-2642-FE0F\",\"a\":\"Mountain Bicyclist\",\"b\":\"1F6B5\",\"j\":[\"person_mountain_biking\",\"sport\",\"move\"],\"k\":[35,33],\"o\":1},\"man-mountain-biking\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B5-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F6B5-1F3FB-200D-2642\",\"image\":\"1f6b5-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B5-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F6B5-1F3FC-200D-2642\",\"image\":\"1f6b5-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":29,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B5-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F6B5-1F3FD-200D-2642\",\"image\":\"1f6b5-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B5-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F6B5-1F3FE-200D-2642\",\"image\":\"1f6b5-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B5-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F6B5-1F3FF-200D-2642\",\"image\":\"1f6b5-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":35,\"sheet_y\":32,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"obsoletes\":\"1F6B5\",\"a\":\"Man Mountain Biking\",\"b\":\"1F6B5-200D-2642-FE0F\",\"c\":\"1F6B5-200D-2642\",\"j\":[\"man_mountain_biking\",\"transportation\",\"sports\",\"human\",\"race\",\"bike\"],\"k\":[35,27],\"o\":4},\"woman-mountain-biking\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6B5-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F6B5-1F3FB-200D-2640\",\"image\":\"1f6b5-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6B5-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F6B5-1F3FC-200D-2640\",\"image\":\"1f6b5-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6B5-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F6B5-1F3FD-200D-2640\",\"image\":\"1f6b5-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6B5-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F6B5-1F3FE-200D-2640\",\"image\":\"1f6b5-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6B5-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F6B5-1F3FF-200D-2640\",\"image\":\"1f6b5-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":35,\"sheet_y\":26,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Mountain Biking\",\"b\":\"1F6B5-200D-2640-FE0F\",\"c\":\"1F6B5-200D-2640\",\"j\":[\"woman_mountain_biking\",\"transportation\",\"sports\",\"human\",\"race\",\"bike\",\"woman\",\"female\"],\"k\":[35,21],\"o\":4},\"person_doing_cartwheel\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F938-1F3FB\",\"non_qualified\":null,\"image\":\"1f938-1f3fb.png\",\"sheet_x\":40,\"sheet_y\":18,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F938-1F3FC\",\"non_qualified\":null,\"image\":\"1f938-1f3fc.png\",\"sheet_x\":40,\"sheet_y\":19,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F938-1F3FD\",\"non_qualified\":null,\"image\":\"1f938-1f3fd.png\",\"sheet_x\":40,\"sheet_y\":20,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F938-1F3FE\",\"non_qualified\":null,\"image\":\"1f938-1f3fe.png\",\"sheet_x\":40,\"sheet_y\":21,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F938-1F3FF\",\"non_qualified\":null,\"image\":\"1f938-1f3ff.png\",\"sheet_x\":40,\"sheet_y\":22,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Person Doing Cartwheel\",\"b\":\"1F938\",\"j\":[\"person_cartwheeling\",\"sport\",\"gymnastic\"],\"k\":[40,17],\"o\":3},\"man-cartwheeling\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F938-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F938-1F3FB-200D-2642\",\"image\":\"1f938-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F938-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F938-1F3FC-200D-2642\",\"image\":\"1f938-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F938-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F938-1F3FD-200D-2642\",\"image\":\"1f938-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F938-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F938-1F3FE-200D-2642\",\"image\":\"1f938-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F938-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F938-1F3FF-200D-2642\",\"image\":\"1f938-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":16,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Cartwheeling\",\"b\":\"1F938-200D-2642-FE0F\",\"c\":\"1F938-200D-2642\",\"j\":[\"man_cartwheeling\",\"gymnastics\"],\"k\":[40,11],\"o\":4},\"woman-cartwheeling\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F938-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F938-1F3FB-200D-2640\",\"image\":\"1f938-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F938-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F938-1F3FC-200D-2640\",\"image\":\"1f938-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F938-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F938-1F3FD-200D-2640\",\"image\":\"1f938-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F938-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F938-1F3FE-200D-2640\",\"image\":\"1f938-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F938-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F938-1F3FF-200D-2640\",\"image\":\"1f938-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Cartwheeling\",\"b\":\"1F938-200D-2640-FE0F\",\"c\":\"1F938-200D-2640\",\"j\":[\"woman_cartwheeling\",\"gymnastics\"],\"k\":[40,5],\"o\":4},\"wrestlers\":{\"a\":\"Wrestlers\",\"b\":\"1F93C\",\"j\":[\"people_wrestling\",\"sport\"],\"k\":[40,44],\"o\":3},\"man-wrestling\":{\"a\":\"Men Wrestling\",\"b\":\"1F93C-200D-2642-FE0F\",\"c\":\"1F93C-200D-2642\",\"j\":[\"men_wrestling\",\"sports\",\"wrestlers\"],\"k\":[40,43],\"o\":4},\"woman-wrestling\":{\"a\":\"Women Wrestling\",\"b\":\"1F93C-200D-2640-FE0F\",\"c\":\"1F93C-200D-2640\",\"j\":[\"women_wrestling\",\"sports\",\"wrestlers\"],\"k\":[40,42],\"o\":4},\"water_polo\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F93D-1F3FB\",\"non_qualified\":null,\"image\":\"1f93d-1f3fb.png\",\"sheet_x\":41,\"sheet_y\":0,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F93D-1F3FC\",\"non_qualified\":null,\"image\":\"1f93d-1f3fc.png\",\"sheet_x\":41,\"sheet_y\":1,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F93D-1F3FD\",\"non_qualified\":null,\"image\":\"1f93d-1f3fd.png\",\"sheet_x\":41,\"sheet_y\":2,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F93D-1F3FE\",\"non_qualified\":null,\"image\":\"1f93d-1f3fe.png\",\"sheet_x\":41,\"sheet_y\":3,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F93D-1F3FF\",\"non_qualified\":null,\"image\":\"1f93d-1f3ff.png\",\"sheet_x\":41,\"sheet_y\":4,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Water Polo\",\"b\":\"1F93D\",\"j\":[\"person_playing_water_polo\",\"sport\"],\"k\":[40,57],\"o\":3},\"man-playing-water-polo\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F93D-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F93D-1F3FB-200D-2642\",\"image\":\"1f93d-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":52,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F93D-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F93D-1F3FC-200D-2642\",\"image\":\"1f93d-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":53,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F93D-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F93D-1F3FD-200D-2642\",\"image\":\"1f93d-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":54,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F93D-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F93D-1F3FE-200D-2642\",\"image\":\"1f93d-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":55,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F93D-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F93D-1F3FF-200D-2642\",\"image\":\"1f93d-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":56,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Playing Water Polo\",\"b\":\"1F93D-200D-2642-FE0F\",\"c\":\"1F93D-200D-2642\",\"j\":[\"man_playing_water_polo\",\"sports\",\"pool\"],\"k\":[40,51],\"o\":4},\"woman-playing-water-polo\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F93D-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F93D-1F3FB-200D-2640\",\"image\":\"1f93d-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":46,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F93D-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F93D-1F3FC-200D-2640\",\"image\":\"1f93d-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":47,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F93D-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F93D-1F3FD-200D-2640\",\"image\":\"1f93d-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":48,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F93D-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F93D-1F3FE-200D-2640\",\"image\":\"1f93d-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":49,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F93D-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F93D-1F3FF-200D-2640\",\"image\":\"1f93d-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":50,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Playing Water Polo\",\"b\":\"1F93D-200D-2640-FE0F\",\"c\":\"1F93D-200D-2640\",\"j\":[\"woman_playing_water_polo\",\"sports\",\"pool\"],\"k\":[40,45],\"o\":4},\"handball\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F93E-1F3FB\",\"non_qualified\":null,\"image\":\"1f93e-1f3fb.png\",\"sheet_x\":41,\"sheet_y\":18,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F93E-1F3FC\",\"non_qualified\":null,\"image\":\"1f93e-1f3fc.png\",\"sheet_x\":41,\"sheet_y\":19,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F93E-1F3FD\",\"non_qualified\":null,\"image\":\"1f93e-1f3fd.png\",\"sheet_x\":41,\"sheet_y\":20,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F93E-1F3FE\",\"non_qualified\":null,\"image\":\"1f93e-1f3fe.png\",\"sheet_x\":41,\"sheet_y\":21,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F93E-1F3FF\",\"non_qualified\":null,\"image\":\"1f93e-1f3ff.png\",\"sheet_x\":41,\"sheet_y\":22,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Handball\",\"b\":\"1F93E\",\"j\":[\"person_playing_handball\",\"sport\"],\"k\":[41,17],\"o\":3},\"man-playing-handball\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F93E-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F93E-1F3FB-200D-2642\",\"image\":\"1f93e-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":41,\"sheet_y\":12,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F93E-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F93E-1F3FC-200D-2642\",\"image\":\"1f93e-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":41,\"sheet_y\":13,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F93E-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F93E-1F3FD-200D-2642\",\"image\":\"1f93e-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":41,\"sheet_y\":14,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F93E-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F93E-1F3FE-200D-2642\",\"image\":\"1f93e-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":41,\"sheet_y\":15,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F93E-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F93E-1F3FF-200D-2642\",\"image\":\"1f93e-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":41,\"sheet_y\":16,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Playing Handball\",\"b\":\"1F93E-200D-2642-FE0F\",\"c\":\"1F93E-200D-2642\",\"j\":[\"man_playing_handball\",\"sports\"],\"k\":[41,11],\"o\":4},\"woman-playing-handball\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F93E-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F93E-1F3FB-200D-2640\",\"image\":\"1f93e-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":41,\"sheet_y\":6,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F93E-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F93E-1F3FC-200D-2640\",\"image\":\"1f93e-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":41,\"sheet_y\":7,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F93E-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F93E-1F3FD-200D-2640\",\"image\":\"1f93e-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":41,\"sheet_y\":8,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F93E-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F93E-1F3FE-200D-2640\",\"image\":\"1f93e-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":41,\"sheet_y\":9,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F93E-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F93E-1F3FF-200D-2640\",\"image\":\"1f93e-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":41,\"sheet_y\":10,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Playing Handball\",\"b\":\"1F93E-200D-2640-FE0F\",\"c\":\"1F93E-200D-2640\",\"j\":[\"woman_playing_handball\",\"sports\"],\"k\":[41,5],\"o\":4},\"juggling\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F939-1F3FB\",\"non_qualified\":null,\"image\":\"1f939-1f3fb.png\",\"sheet_x\":40,\"sheet_y\":36,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F939-1F3FC\",\"non_qualified\":null,\"image\":\"1f939-1f3fc.png\",\"sheet_x\":40,\"sheet_y\":37,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F939-1F3FD\",\"non_qualified\":null,\"image\":\"1f939-1f3fd.png\",\"sheet_x\":40,\"sheet_y\":38,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F939-1F3FE\",\"non_qualified\":null,\"image\":\"1f939-1f3fe.png\",\"sheet_x\":40,\"sheet_y\":39,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F939-1F3FF\",\"non_qualified\":null,\"image\":\"1f939-1f3ff.png\",\"sheet_x\":40,\"sheet_y\":40,\"added_in\":\"3.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Juggling\",\"b\":\"1F939\",\"j\":[\"person_juggling\",\"performance\",\"balance\"],\"k\":[40,35],\"o\":3},\"man-juggling\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F939-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F939-1F3FB-200D-2642\",\"image\":\"1f939-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":30,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F939-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F939-1F3FC-200D-2642\",\"image\":\"1f939-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":31,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F939-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F939-1F3FD-200D-2642\",\"image\":\"1f939-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":32,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F939-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F939-1F3FE-200D-2642\",\"image\":\"1f939-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":33,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F939-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F939-1F3FF-200D-2642\",\"image\":\"1f939-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":40,\"sheet_y\":34,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man Juggling\",\"b\":\"1F939-200D-2642-FE0F\",\"c\":\"1F939-200D-2642\",\"j\":[\"man_juggling\",\"juggle\",\"balance\",\"skill\",\"multitask\"],\"k\":[40,29],\"o\":4},\"woman-juggling\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F939-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F939-1F3FB-200D-2640\",\"image\":\"1f939-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F939-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F939-1F3FC-200D-2640\",\"image\":\"1f939-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F939-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F939-1F3FD-200D-2640\",\"image\":\"1f939-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":26,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F939-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F939-1F3FE-200D-2640\",\"image\":\"1f939-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":27,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F939-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F939-1F3FF-200D-2640\",\"image\":\"1f939-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":40,\"sheet_y\":28,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Woman Juggling\",\"b\":\"1F939-200D-2640-FE0F\",\"c\":\"1F939-200D-2640\",\"j\":[\"woman_juggling\",\"juggle\",\"balance\",\"skill\",\"multitask\"],\"k\":[40,23],\"o\":4},\"person_in_lotus_position\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D8-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d8-1f3fb.png\",\"sheet_x\":50,\"sheet_y\":0,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D8-1F3FB-200D-2640-FE0F\"},\"1F3FC\":{\"unified\":\"1F9D8-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d8-1f3fc.png\",\"sheet_x\":50,\"sheet_y\":1,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D8-1F3FC-200D-2640-FE0F\"},\"1F3FD\":{\"unified\":\"1F9D8-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d8-1f3fd.png\",\"sheet_x\":50,\"sheet_y\":2,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D8-1F3FD-200D-2640-FE0F\"},\"1F3FE\":{\"unified\":\"1F9D8-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d8-1f3fe.png\",\"sheet_x\":50,\"sheet_y\":3,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D8-1F3FE-200D-2640-FE0F\"},\"1F3FF\":{\"unified\":\"1F9D8-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d8-1f3ff.png\",\"sheet_x\":50,\"sheet_y\":4,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoleted_by\":\"1F9D8-1F3FF-200D-2640-FE0F\"}},\"obsoleted_by\":\"1F9D8-200D-2640-FE0F\",\"a\":\"Person in Lotus Position\",\"b\":\"1F9D8\",\"j\":[\"person_in_lotus_position\",\"meditate\"],\"k\":[49,57],\"o\":5},\"man_in_lotus_position\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D8-1F3FB-200D-2642-FE0F\",\"non_qualified\":\"1F9D8-1F3FB-200D-2642\",\"image\":\"1f9d8-1f3fb-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":52,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F9D8-1F3FC-200D-2642-FE0F\",\"non_qualified\":\"1F9D8-1F3FC-200D-2642\",\"image\":\"1f9d8-1f3fc-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":53,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F9D8-1F3FD-200D-2642-FE0F\",\"non_qualified\":\"1F9D8-1F3FD-200D-2642\",\"image\":\"1f9d8-1f3fd-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":54,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F9D8-1F3FE-200D-2642-FE0F\",\"non_qualified\":\"1F9D8-1F3FE-200D-2642\",\"image\":\"1f9d8-1f3fe-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":55,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F9D8-1F3FF-200D-2642-FE0F\",\"non_qualified\":\"1F9D8-1F3FF-200D-2642\",\"image\":\"1f9d8-1f3ff-200d-2642-fe0f.png\",\"sheet_x\":49,\"sheet_y\":56,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man in Lotus Position\",\"b\":\"1F9D8-200D-2642-FE0F\",\"c\":\"1F9D8-200D-2642\",\"j\":[\"man_in_lotus_position\",\"man\",\"male\",\"meditation\",\"yoga\",\"serenity\",\"zen\",\"mindfulness\"],\"k\":[49,51],\"o\":5},\"woman_in_lotus_position\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F9D8-1F3FB-200D-2640-FE0F\",\"non_qualified\":\"1F9D8-1F3FB-200D-2640\",\"image\":\"1f9d8-1f3fb-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":46,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D8-1F3FB\"},\"1F3FC\":{\"unified\":\"1F9D8-1F3FC-200D-2640-FE0F\",\"non_qualified\":\"1F9D8-1F3FC-200D-2640\",\"image\":\"1f9d8-1f3fc-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":47,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D8-1F3FC\"},\"1F3FD\":{\"unified\":\"1F9D8-1F3FD-200D-2640-FE0F\",\"non_qualified\":\"1F9D8-1F3FD-200D-2640\",\"image\":\"1f9d8-1f3fd-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":48,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D8-1F3FD\"},\"1F3FE\":{\"unified\":\"1F9D8-1F3FE-200D-2640-FE0F\",\"non_qualified\":\"1F9D8-1F3FE-200D-2640\",\"image\":\"1f9d8-1f3fe-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":49,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D8-1F3FE\"},\"1F3FF\":{\"unified\":\"1F9D8-1F3FF-200D-2640-FE0F\",\"non_qualified\":\"1F9D8-1F3FF-200D-2640\",\"image\":\"1f9d8-1f3ff-200d-2640-fe0f.png\",\"sheet_x\":49,\"sheet_y\":50,\"added_in\":\"5.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true,\"obsoletes\":\"1F9D8-1F3FF\"}},\"obsoletes\":\"1F9D8\",\"a\":\"Woman in Lotus Position\",\"b\":\"1F9D8-200D-2640-FE0F\",\"c\":\"1F9D8-200D-2640\",\"j\":[\"woman_in_lotus_position\",\"woman\",\"female\",\"meditation\",\"yoga\",\"serenity\",\"zen\",\"mindfulness\"],\"k\":[49,45],\"o\":5},\"bath\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6C0-1F3FB\",\"non_qualified\":null,\"image\":\"1f6c0-1f3fb.png\",\"sheet_x\":36,\"sheet_y\":9,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6C0-1F3FC\",\"non_qualified\":null,\"image\":\"1f6c0-1f3fc.png\",\"sheet_x\":36,\"sheet_y\":10,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6C0-1F3FD\",\"non_qualified\":null,\"image\":\"1f6c0-1f3fd.png\",\"sheet_x\":36,\"sheet_y\":11,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6C0-1F3FE\",\"non_qualified\":null,\"image\":\"1f6c0-1f3fe.png\",\"sheet_x\":36,\"sheet_y\":12,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6C0-1F3FF\",\"non_qualified\":null,\"image\":\"1f6c0-1f3ff.png\",\"sheet_x\":36,\"sheet_y\":13,\"added_in\":\"1.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Bath\",\"b\":\"1F6C0\",\"j\":[\"person_taking_bath\",\"clean\",\"shower\",\"bathroom\"],\"k\":[36,8],\"o\":0},\"sleeping_accommodation\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F6CC-1F3FB\",\"non_qualified\":null,\"image\":\"1f6cc-1f3fb.png\",\"sheet_x\":36,\"sheet_y\":21,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F6CC-1F3FC\",\"non_qualified\":null,\"image\":\"1f6cc-1f3fc.png\",\"sheet_x\":36,\"sheet_y\":22,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F6CC-1F3FD\",\"non_qualified\":null,\"image\":\"1f6cc-1f3fd.png\",\"sheet_x\":36,\"sheet_y\":23,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F6CC-1F3FE\",\"non_qualified\":null,\"image\":\"1f6cc-1f3fe.png\",\"sheet_x\":36,\"sheet_y\":24,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F6CC-1F3FF\",\"non_qualified\":null,\"image\":\"1f6cc-1f3ff.png\",\"sheet_x\":36,\"sheet_y\":25,\"added_in\":\"4.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Sleeping Accommodation\",\"b\":\"1F6CC\",\"j\":[\"person_in_bed\",\"bed\",\"rest\"],\"k\":[36,20],\"o\":1},\"people_holding_hands\":{\"skin_variations\":{\"1F3FB-1F3FB\":{\"unified\":\"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png\",\"sheet_x\":47,\"sheet_y\":10,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FB-1F3FC\":{\"unified\":\"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png\",\"sheet_x\":47,\"sheet_y\":11,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FD\":{\"unified\":\"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png\",\"sheet_x\":47,\"sheet_y\":12,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FE\":{\"unified\":\"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png\",\"sheet_x\":47,\"sheet_y\":13,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FF\":{\"unified\":\"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png\",\"sheet_x\":47,\"sheet_y\":14,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FB\":{\"unified\":\"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png\",\"sheet_x\":47,\"sheet_y\":15,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC-1F3FC\":{\"unified\":\"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png\",\"sheet_x\":47,\"sheet_y\":16,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC-1F3FD\":{\"unified\":\"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png\",\"sheet_x\":47,\"sheet_y\":17,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FE\":{\"unified\":\"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png\",\"sheet_x\":47,\"sheet_y\":18,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FF\":{\"unified\":\"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png\",\"sheet_x\":47,\"sheet_y\":19,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FD-1F3FB\":{\"unified\":\"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png\",\"sheet_x\":47,\"sheet_y\":20,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FC\":{\"unified\":\"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png\",\"sheet_x\":47,\"sheet_y\":21,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FD\":{\"unified\":\"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png\",\"sheet_x\":47,\"sheet_y\":22,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FE\":{\"unified\":\"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png\",\"sheet_x\":47,\"sheet_y\":23,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FD-1F3FF\":{\"unified\":\"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png\",\"sheet_x\":47,\"sheet_y\":24,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FE-1F3FB\":{\"unified\":\"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png\",\"sheet_x\":47,\"sheet_y\":25,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FC\":{\"unified\":\"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png\",\"sheet_x\":47,\"sheet_y\":26,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FD\":{\"unified\":\"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png\",\"sheet_x\":47,\"sheet_y\":27,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FE\":{\"unified\":\"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png\",\"sheet_x\":47,\"sheet_y\":28,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FF\":{\"unified\":\"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png\",\"sheet_x\":47,\"sheet_y\":29,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FF-1F3FB\":{\"unified\":\"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png\",\"sheet_x\":47,\"sheet_y\":30,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FC\":{\"unified\":\"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png\",\"sheet_x\":47,\"sheet_y\":31,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FD\":{\"unified\":\"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png\",\"sheet_x\":47,\"sheet_y\":32,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FE\":{\"unified\":\"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png\",\"sheet_x\":47,\"sheet_y\":33,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FF\":{\"unified\":\"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF\",\"non_qualified\":null,\"image\":\"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png\",\"sheet_x\":47,\"sheet_y\":34,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"People Holding Hands\",\"b\":\"1F9D1-200D-1F91D-200D-1F9D1\",\"j\":[\"people_holding_hands\",\"friendship\"],\"k\":[47,9],\"o\":12},\"two_women_holding_hands\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F46D-1F3FB\",\"non_qualified\":null,\"image\":\"1f46d-1f3fb.png\",\"sheet_x\":21,\"sheet_y\":6,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F46D-1F3FC\",\"non_qualified\":null,\"image\":\"1f46d-1f3fc.png\",\"sheet_x\":21,\"sheet_y\":7,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F46D-1F3FD\",\"non_qualified\":null,\"image\":\"1f46d-1f3fd.png\",\"sheet_x\":21,\"sheet_y\":8,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F46D-1F3FE\",\"non_qualified\":null,\"image\":\"1f46d-1f3fe.png\",\"sheet_x\":21,\"sheet_y\":9,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F46D-1F3FF\",\"non_qualified\":null,\"image\":\"1f46d-1f3ff.png\",\"sheet_x\":21,\"sheet_y\":10,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FB-1F3FC\":{\"unified\":\"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png\",\"sheet_x\":21,\"sheet_y\":11,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FD\":{\"unified\":\"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png\",\"sheet_x\":21,\"sheet_y\":12,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FE\":{\"unified\":\"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png\",\"sheet_x\":21,\"sheet_y\":13,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FF\":{\"unified\":\"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png\",\"sheet_x\":21,\"sheet_y\":14,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FB\":{\"unified\":\"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png\",\"sheet_x\":21,\"sheet_y\":15,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC-1F3FD\":{\"unified\":\"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png\",\"sheet_x\":21,\"sheet_y\":16,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FE\":{\"unified\":\"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png\",\"sheet_x\":21,\"sheet_y\":17,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FF\":{\"unified\":\"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png\",\"sheet_x\":21,\"sheet_y\":18,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FD-1F3FB\":{\"unified\":\"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png\",\"sheet_x\":21,\"sheet_y\":19,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FC\":{\"unified\":\"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png\",\"sheet_x\":21,\"sheet_y\":20,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FE\":{\"unified\":\"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png\",\"sheet_x\":21,\"sheet_y\":21,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FD-1F3FF\":{\"unified\":\"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png\",\"sheet_x\":21,\"sheet_y\":22,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FE-1F3FB\":{\"unified\":\"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png\",\"sheet_x\":21,\"sheet_y\":23,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FC\":{\"unified\":\"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png\",\"sheet_x\":21,\"sheet_y\":24,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FD\":{\"unified\":\"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png\",\"sheet_x\":21,\"sheet_y\":25,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FF\":{\"unified\":\"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png\",\"sheet_x\":21,\"sheet_y\":26,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FF-1F3FB\":{\"unified\":\"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png\",\"sheet_x\":21,\"sheet_y\":27,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FC\":{\"unified\":\"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png\",\"sheet_x\":21,\"sheet_y\":28,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FD\":{\"unified\":\"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png\",\"sheet_x\":21,\"sheet_y\":29,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FE\":{\"unified\":\"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png\",\"sheet_x\":21,\"sheet_y\":30,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Two Women Holding Hands\",\"b\":\"1F46D\",\"j\":[\"women_holding_hands\",\"pair\",\"friendship\",\"couple\",\"love\",\"like\",\"female\",\"people\",\"human\"],\"k\":[21,5],\"n\":[\"women_holding_hands\"],\"o\":1},\"man_and_woman_holding_hands\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F46B-1F3FB\",\"non_qualified\":null,\"image\":\"1f46b-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":12,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F46B-1F3FC\",\"non_qualified\":null,\"image\":\"1f46b-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":13,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F46B-1F3FD\",\"non_qualified\":null,\"image\":\"1f46b-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":14,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F46B-1F3FE\",\"non_qualified\":null,\"image\":\"1f46b-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":15,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F46B-1F3FF\",\"non_qualified\":null,\"image\":\"1f46b-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":16,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FB-1F3FC\":{\"unified\":\"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":17,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FB-1F3FD\":{\"unified\":\"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":18,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FB-1F3FE\":{\"unified\":\"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":19,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FB-1F3FF\":{\"unified\":\"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":20,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC-1F3FB\":{\"unified\":\"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":21,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC-1F3FD\":{\"unified\":\"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":22,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC-1F3FE\":{\"unified\":\"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":23,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC-1F3FF\":{\"unified\":\"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":24,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FB\":{\"unified\":\"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":25,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FC\":{\"unified\":\"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":26,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FE\":{\"unified\":\"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":27,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FF\":{\"unified\":\"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":28,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FB\":{\"unified\":\"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":29,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FC\":{\"unified\":\"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":30,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FD\":{\"unified\":\"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":31,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FF\":{\"unified\":\"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":32,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FB\":{\"unified\":\"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":33,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FC\":{\"unified\":\"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":34,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FD\":{\"unified\":\"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":35,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FE\":{\"unified\":\"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":36,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Man and Woman Holding Hands\",\"b\":\"1F46B\",\"j\":[\"woman_and_man_holding_hands\",\"pair\",\"people\",\"human\",\"love\",\"date\",\"dating\",\"like\",\"affection\",\"valentines\",\"marriage\"],\"k\":[20,11],\"n\":[\"woman_and_man_holding_hands\",\"couple\"],\"o\":0},\"two_men_holding_hands\":{\"skin_variations\":{\"1F3FB\":{\"unified\":\"1F46C-1F3FB\",\"non_qualified\":null,\"image\":\"1f46c-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":38,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC\":{\"unified\":\"1F46C-1F3FC\",\"non_qualified\":null,\"image\":\"1f46c-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":39,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD\":{\"unified\":\"1F46C-1F3FD\",\"non_qualified\":null,\"image\":\"1f46c-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":40,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE\":{\"unified\":\"1F46C-1F3FE\",\"non_qualified\":null,\"image\":\"1f46c-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":41,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF\":{\"unified\":\"1F46C-1F3FF\",\"non_qualified\":null,\"image\":\"1f46c-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":42,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FB-1F3FC\":{\"unified\":\"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":43,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FD\":{\"unified\":\"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":44,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FE\":{\"unified\":\"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":45,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FB-1F3FF\":{\"unified\":\"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":46,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FB\":{\"unified\":\"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":47,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FC-1F3FD\":{\"unified\":\"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":48,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FE\":{\"unified\":\"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":49,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FC-1F3FF\":{\"unified\":\"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":50,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FD-1F3FB\":{\"unified\":\"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":51,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FC\":{\"unified\":\"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":52,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FD-1F3FE\":{\"unified\":\"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png\",\"sheet_x\":20,\"sheet_y\":53,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FD-1F3FF\":{\"unified\":\"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png\",\"sheet_x\":20,\"sheet_y\":54,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FE-1F3FB\":{\"unified\":\"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png\",\"sheet_x\":20,\"sheet_y\":55,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FC\":{\"unified\":\"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png\",\"sheet_x\":20,\"sheet_y\":56,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FD\":{\"unified\":\"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png\",\"sheet_x\":20,\"sheet_y\":57,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FE-1F3FF\":{\"unified\":\"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF\",\"non_qualified\":null,\"image\":\"1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png\",\"sheet_x\":21,\"sheet_y\":0,\"added_in\":\"12.1\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":false},\"1F3FF-1F3FB\":{\"unified\":\"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png\",\"sheet_x\":21,\"sheet_y\":1,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FC\":{\"unified\":\"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png\",\"sheet_x\":21,\"sheet_y\":2,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FD\":{\"unified\":\"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png\",\"sheet_x\":21,\"sheet_y\":3,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true},\"1F3FF-1F3FE\":{\"unified\":\"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE\",\"non_qualified\":null,\"image\":\"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png\",\"sheet_x\":21,\"sheet_y\":4,\"added_in\":\"12.0\",\"has_img_apple\":true,\"has_img_google\":true,\"has_img_twitter\":true,\"has_img_facebook\":true}},\"a\":\"Two Men Holding Hands\",\"b\":\"1F46C\",\"j\":[\"men_holding_hands\",\"pair\",\"couple\",\"love\",\"like\",\"bromance\",\"friendship\",\"people\",\"human\"],\"k\":[20,37],\"n\":[\"men_holding_hands\"],\"o\":1},\"couplekiss\":{\"obsoleted_by\":\"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468\",\"a\":\"Kiss\",\"b\":\"1F48F\",\"j\":[\"kiss\",\"pair\",\"valentines\",\"love\",\"like\",\"dating\",\"marriage\"],\"k\":[25,27],\"o\":0},\"woman-kiss-man\":{\"obsoletes\":\"1F48F\",\"a\":\"Kiss: Woman, Man\",\"b\":\"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468\",\"c\":\"1F469-200D-2764-200D-1F48B-200D-1F468\",\"j\":[\"kiss_woman_man\",\"love\"],\"k\":[20,2],\"o\":2},\"man-kiss-man\":{\"a\":\"Kiss: Man, Man\",\"b\":\"1F468-200D-2764-FE0F-200D-1F48B-200D-1F468\",\"c\":\"1F468-200D-2764-200D-1F48B-200D-1F468\",\"j\":[\"kiss_man_man\",\"pair\",\"valentines\",\"love\",\"like\",\"dating\",\"marriage\"],\"k\":[17,13],\"o\":2},\"woman-kiss-woman\":{\"a\":\"Kiss: Woman, Woman\",\"b\":\"1F469-200D-2764-FE0F-200D-1F48B-200D-1F469\",\"c\":\"1F469-200D-2764-200D-1F48B-200D-1F469\",\"j\":[\"kiss_woman_woman\",\"pair\",\"valentines\",\"love\",\"like\",\"dating\",\"marriage\"],\"k\":[20,3],\"o\":2},\"couple_with_heart\":{\"obsoleted_by\":\"1F469-200D-2764-FE0F-200D-1F468\",\"a\":\"Couple with Heart\",\"b\":\"1F491\",\"j\":[\"couple_with_heart\",\"pair\",\"love\",\"like\",\"affection\",\"human\",\"dating\",\"valentines\",\"marriage\"],\"k\":[25,29],\"o\":0},\"woman-heart-man\":{\"obsoletes\":\"1F491\",\"a\":\"Couple with Heart: Woman, Man\",\"b\":\"1F469-200D-2764-FE0F-200D-1F468\",\"c\":\"1F469-200D-2764-200D-1F468\",\"j\":[\"couple_with_heart_woman_man\",\"love\"],\"k\":[20,0],\"o\":2},\"man-heart-man\":{\"a\":\"Couple with Heart: Man, Man\",\"b\":\"1F468-200D-2764-FE0F-200D-1F468\",\"c\":\"1F468-200D-2764-200D-1F468\",\"j\":[\"couple_with_heart_man_man\",\"pair\",\"love\",\"like\",\"affection\",\"human\",\"dating\",\"valentines\",\"marriage\"],\"k\":[17,12],\"o\":2},\"woman-heart-woman\":{\"a\":\"Couple with Heart: Woman, Woman\",\"b\":\"1F469-200D-2764-FE0F-200D-1F469\",\"c\":\"1F469-200D-2764-200D-1F469\",\"j\":[\"couple_with_heart_woman_woman\",\"pair\",\"love\",\"like\",\"affection\",\"human\",\"dating\",\"valentines\",\"marriage\"],\"k\":[20,1],\"o\":2},\"family\":{\"obsoleted_by\":\"1F468-200D-1F469-200D-1F466\",\"a\":\"Family\",\"b\":\"1F46A\",\"j\":[\"family\",\"home\",\"parents\",\"child\",\"mom\",\"dad\",\"father\",\"mother\",\"people\",\"human\"],\"k\":[20,10],\"o\":0},\"man-woman-boy\":{\"obsoletes\":\"1F46A\",\"a\":\"Family: Man, Woman, Boy\",\"b\":\"1F468-200D-1F469-200D-1F466\",\"j\":[\"family_man_woman_boy\",\"love\"],\"k\":[15,27],\"o\":2},\"man-woman-girl\":{\"a\":\"Family: Man, Woman, Girl\",\"b\":\"1F468-200D-1F469-200D-1F467\",\"j\":[\"family_man_woman_girl\",\"home\",\"parents\",\"people\",\"human\",\"child\"],\"k\":[15,29],\"o\":2},\"man-woman-girl-boy\":{\"a\":\"Family: Man, Woman, Girl, Boy\",\"b\":\"1F468-200D-1F469-200D-1F467-200D-1F466\",\"j\":[\"family_man_woman_girl_boy\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[15,30],\"o\":2},\"man-woman-boy-boy\":{\"a\":\"Family: Man, Woman, Boy, Boy\",\"b\":\"1F468-200D-1F469-200D-1F466-200D-1F466\",\"j\":[\"family_man_woman_boy_boy\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[15,28],\"o\":2},\"man-woman-girl-girl\":{\"a\":\"Family: Man, Woman, Girl, Girl\",\"b\":\"1F468-200D-1F469-200D-1F467-200D-1F467\",\"j\":[\"family_man_woman_girl_girl\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[15,31],\"o\":2},\"man-man-boy\":{\"a\":\"Family: Man, Man, Boy\",\"b\":\"1F468-200D-1F468-200D-1F466\",\"j\":[\"family_man_man_boy\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[15,22],\"o\":2},\"man-man-girl\":{\"a\":\"Family: Man, Man, Girl\",\"b\":\"1F468-200D-1F468-200D-1F467\",\"j\":[\"family_man_man_girl\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[15,24],\"o\":2},\"man-man-girl-boy\":{\"a\":\"Family: Man, Man, Girl, Boy\",\"b\":\"1F468-200D-1F468-200D-1F467-200D-1F466\",\"j\":[\"family_man_man_girl_boy\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[15,25],\"o\":2},\"man-man-boy-boy\":{\"a\":\"Family: Man, Man, Boy, Boy\",\"b\":\"1F468-200D-1F468-200D-1F466-200D-1F466\",\"j\":[\"family_man_man_boy_boy\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[15,23],\"o\":2},\"man-man-girl-girl\":{\"a\":\"Family: Man, Man, Girl, Girl\",\"b\":\"1F468-200D-1F468-200D-1F467-200D-1F467\",\"j\":[\"family_man_man_girl_girl\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[15,26],\"o\":2},\"woman-woman-boy\":{\"a\":\"Family: Woman, Woman, Boy\",\"b\":\"1F469-200D-1F469-200D-1F466\",\"j\":[\"family_woman_woman_boy\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[18,15],\"o\":2},\"woman-woman-girl\":{\"a\":\"Family: Woman, Woman, Girl\",\"b\":\"1F469-200D-1F469-200D-1F467\",\"j\":[\"family_woman_woman_girl\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[18,17],\"o\":2},\"woman-woman-girl-boy\":{\"a\":\"Family: Woman, Woman, Girl, Boy\",\"b\":\"1F469-200D-1F469-200D-1F467-200D-1F466\",\"j\":[\"family_woman_woman_girl_boy\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[18,18],\"o\":2},\"woman-woman-boy-boy\":{\"a\":\"Family: Woman, Woman, Boy, Boy\",\"b\":\"1F469-200D-1F469-200D-1F466-200D-1F466\",\"j\":[\"family_woman_woman_boy_boy\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[18,16],\"o\":2},\"woman-woman-girl-girl\":{\"a\":\"Family: Woman, Woman, Girl, Girl\",\"b\":\"1F469-200D-1F469-200D-1F467-200D-1F467\",\"j\":[\"family_woman_woman_girl_girl\",\"home\",\"parents\",\"people\",\"human\",\"children\"],\"k\":[18,19],\"o\":2},\"man-boy\":{\"a\":\"Family: Man, Boy\",\"b\":\"1F468-200D-1F466\",\"j\":[\"family_man_boy\",\"home\",\"parent\",\"people\",\"human\",\"child\"],\"k\":[15,18],\"o\":4},\"man-boy-boy\":{\"a\":\"Family: Man, Boy, Boy\",\"b\":\"1F468-200D-1F466-200D-1F466\",\"j\":[\"family_man_boy_boy\",\"home\",\"parent\",\"people\",\"human\",\"children\"],\"k\":[15,17],\"o\":4},\"man-girl\":{\"a\":\"Family: Man, Girl\",\"b\":\"1F468-200D-1F467\",\"j\":[\"family_man_girl\",\"home\",\"parent\",\"people\",\"human\",\"child\"],\"k\":[15,21],\"o\":4},\"man-girl-boy\":{\"a\":\"Family: Man, Girl, Boy\",\"b\":\"1F468-200D-1F467-200D-1F466\",\"j\":[\"family_man_girl_boy\",\"home\",\"parent\",\"people\",\"human\",\"children\"],\"k\":[15,19],\"o\":4},\"man-girl-girl\":{\"a\":\"Family: Man, Girl, Girl\",\"b\":\"1F468-200D-1F467-200D-1F467\",\"j\":[\"family_man_girl_girl\",\"home\",\"parent\",\"people\",\"human\",\"children\"],\"k\":[15,20],\"o\":4},\"woman-boy\":{\"a\":\"Family: Woman, Boy\",\"b\":\"1F469-200D-1F466\",\"j\":[\"family_woman_boy\",\"home\",\"parent\",\"people\",\"human\",\"child\"],\"k\":[18,11],\"o\":4},\"woman-boy-boy\":{\"a\":\"Family: Woman, Boy, Boy\",\"b\":\"1F469-200D-1F466-200D-1F466\",\"j\":[\"family_woman_boy_boy\",\"home\",\"parent\",\"people\",\"human\",\"children\"],\"k\":[18,10],\"o\":4},\"woman-girl\":{\"a\":\"Family: Woman, Girl\",\"b\":\"1F469-200D-1F467\",\"j\":[\"family_woman_girl\",\"home\",\"parent\",\"people\",\"human\",\"child\"],\"k\":[18,14],\"o\":4},\"woman-girl-boy\":{\"a\":\"Family: Woman, Girl, Boy\",\"b\":\"1F469-200D-1F467-200D-1F466\",\"j\":[\"family_woman_girl_boy\",\"home\",\"parent\",\"people\",\"human\",\"children\"],\"k\":[18,12],\"o\":4},\"woman-girl-girl\":{\"a\":\"Family: Woman, Girl, Girl\",\"b\":\"1F469-200D-1F467-200D-1F467\",\"j\":[\"family_woman_girl_girl\",\"home\",\"parent\",\"people\",\"human\",\"children\"],\"k\":[18,13],\"o\":4},\"speaking_head_in_silhouette\":{\"a\":\"Speaking Head\",\"b\":\"1F5E3-FE0F\",\"c\":\"1F5E3\",\"j\":[\"speaking_head\",\"user\",\"person\",\"human\",\"sing\",\"say\",\"talk\"],\"k\":[30,22],\"o\":0},\"bust_in_silhouette\":{\"a\":\"Bust in Silhouette\",\"b\":\"1F464\",\"j\":[\"bust_in_silhouette\",\"user\",\"person\",\"human\"],\"k\":[14,13],\"o\":0},\"busts_in_silhouette\":{\"a\":\"Busts in Silhouette\",\"b\":\"1F465\",\"j\":[\"busts_in_silhouette\",\"user\",\"person\",\"human\",\"group\",\"team\"],\"k\":[14,14],\"o\":1},\"people_hugging\":{\"a\":\"People Hugging\",\"b\":\"1FAC2\",\"j\":[\"people hugging\",\"care\"],\"k\":[53,8],\"o\":13},\"footprints\":{\"a\":\"Footprints\",\"b\":\"1F463\",\"j\":[\"footprints\",\"feet\",\"tracking\",\"walking\",\"beach\"],\"k\":[14,12],\"o\":0}},\"aliases\":{\"raised_hand\":\"hand\",\"satisfied\":\"laughing\",\"tshirt\":\"shirt\",\"hand_with_index_and_middle_fingers_crossed\":\"crossed_fingers\",\"sign_of_the_horns\":\"the_horns\",\"grinning_face_with_star_eyes\":\"star-struck\",\"reversed_hand_with_middle_finger_extended\":\"middle_finger\",\"thumbsup\":\"+1\",\"thumbsdown\":\"-1\",\"punch\":\"facepunch\",\"grinning_face_with_one_large_and_one_small_eye\":\"zany_face\",\"shoe\":\"mans_shoe\",\"smiling_face_with_smiling_eyes_and_hand_covering_mouth\":\"face_with_hand_over_mouth\",\"face_with_finger_covering_closed_lips\":\"shushing_face\",\"face_with_one_eyebrow_raised\":\"face_with_raised_eyebrow\",\"face_with_open_mouth_vomiting\":\"face_vomiting\",\"flag-cn\":\"cn\",\"shocked_face_with_exploding_head\":\"exploding_head\",\"cooking\":\"fried_egg\",\"paw_prints\":\"feet\",\"flag-de\":\"de\",\"telephone\":\"phone\",\"flag-es\":\"es\",\"flag-fr\":\"fr\",\"red_car\":\"car\",\"uk\":\"gb\",\"flag-gb\":\"gb\",\"serious_face_with_symbols_covering_mouth\":\"face_with_symbols_on_mouth\",\"flipper\":\"dolphin\",\"poop\":\"hankey\",\"shit\":\"hankey\",\"lantern\":\"izakaya_lantern\",\"honeybee\":\"bee\",\"lady_beetle\":\"ladybug\",\"open_book\":\"book\",\"heavy_exclamation_mark\":\"exclamation\",\"staff_of_aesculapius\":\"medical_symbol\",\"sailboat\":\"boat\",\"flag-it\":\"it\",\"flag-jp\":\"jp\",\"knife\":\"hocho\",\"envelope\":\"email\",\"flag-kr\":\"kr\",\"collision\":\"boom\",\"pencil\":\"memo\",\"waxing_gibbous_moon\":\"moon\",\"mother_christmas\":\"mrs_claus\",\"sun_small_cloud\":\"mostly_sunny\",\"sun_behind_cloud\":\"barely_sunny\",\"sun_behind_rain_cloud\":\"partly_sunny_rain\",\"lightning_cloud\":\"lightning\",\"tornado_cloud\":\"tornado\",\"flag-ru\":\"ru\",\"running\":\"runner\",\"flag-us\":\"us\",\"women_holding_hands\":\"two_women_holding_hands\",\"woman_and_man_holding_hands\":\"man_and_woman_holding_hands\",\"couple\":\"man_and_woman_holding_hands\",\"men_holding_hands\":\"two_men_holding_hands\"}}");

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "df7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var toString = __webpack_require__("577e");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e0c5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ "e128":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UsersMuted_vue_vue_type_style_index_0_id_31ef7722_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("91c8");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UsersMuted_vue_vue_type_style_index_0_id_31ef7722_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UsersMuted_vue_vue_type_style_index_0_id_31ef7722_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e181":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollAnswers_vue_vue_type_style_index_0_id_530fee57_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f330");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollAnswers_vue_vue_type_style_index_0_id_530fee57_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PollAnswers_vue_vue_type_style_index_0_id_530fee57_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e1d3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineProperty = __webpack_require__("9bf2").f;
var defineIterator = __webpack_require__("7dd0");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e330":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = bind && bind.bind(call, call);

module.exports = bind ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "e391":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("577e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e5cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var isPrototypeOf = __webpack_require__("3a9b");
var setPrototypeOf = __webpack_require__("d2bb");
var copyConstructorProperties = __webpack_require__("e893");
var inheritIfRequired = __webpack_require__("7156");
var normalizeStringArgument = __webpack_require__("e391");
var installErrorCause = __webpack_require__("ab36");
var clearErrorStack = __webpack_require__("c770");
var ERROR_STACK_INSTALLABLE = __webpack_require__("b980");
var IS_PURE = __webpack_require__("c430");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e683":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var call = __webpack_require__("c65b");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var aCallable = __webpack_require__("59ed");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var anInstance = __webpack_require__("19aa");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var Queue = __webpack_require__("01b4");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var IS_BROWSER = __webpack_require__("6069");
var IS_NODE = __webpack_require__("605d");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';

var getInternalState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromisePrototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    // eslint-disable-next-line unicorn/no-thenable -- safe
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      state.parent = true;
      reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable(onRejected) && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      if (state.state == PENDING) state.reactions.add(reaction);
      else microtask(function () {
        callReaction(reaction, state);
      });
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e81d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e9b1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e9c4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");

var Array = global.Array;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      for (var i = 0, l = arguments.length, args = Array(l); i < l; i++) args[i] = arguments[i];
      var result = apply($stringify, null, args);
      return typeof result == 'string' ? replace(result, tester, fix) : result;
    }
  });
}


/***/ }),

/***/ "ea49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatTextMessage_vue_vue_type_style_index_1_id_3188c232_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9cb8");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatTextMessage_vue_vue_type_style_index_1_id_3188c232_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatTextMessage_vue_vue_type_style_index_1_id_3188c232_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ebe4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ "ec18":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
            '_'
        ),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
            '_'
        ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ "ec29":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ec2e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ "eccd":
/***/ (function(module) {

module.exports = JSON.parse("{\"emojiPicker\":{\"search\":\"Search\",\"skintone\":\"Skintone\",\"notfound\":\"No Emoji Found\",\"categories\":{\"search\":\"Search Results\",\"recent\":\"Frequently Used\",\"smileys\":\"Smileys & Emoticon\",\"people\":\"People & Body\",\"nature\":\"Animals & Nature\",\"foods\":\"Food & Drink\",\"activity\":\"Activity\",\"places\":\"Travel & Places\",\"objects\":\"Objects\",\"symbols\":\"Symbols\",\"flags\":\"Flags\",\"custom\":\"Custom\"}},\"s8c\":{\"Active\":\"Active\",\"Admin\":\"Admin\",\"Agree\":\"Agree\",\"All\":\"All\",\"Assign roles to certain Chatters e\":{},\"Assign roles to certain Chatters e.g for enabling them to moderate a chatroom\":\"Assign roles to certain Chatters e.g for enabling them to moderate a chatroom\",\"Avatar\":\"Avatar\",\"Bad\":\"Bad\",\"Badge\":\"Badge\",\"Ban ends on\":\"Ban ends on\",\"Cancel\":\"Cancel\",\"Chat rooms\":\"Chat rooms\",\"Close\":\"Close\",\"Come back in 30 days.\":\"Come back in 30 days.\",\"Confirm\":\"Confirm\",\"Disagree\":\"Disagree\",\"Dismiss pinned message\":\"Dismiss pinned message\",\"Edit side panel profile\":\"Edit side panel profile\",\"Email or password incorrect. Please try again.\":\"Email or password incorrect. Please try again.\",\"Enter your own text to require first-time viewers to agree to your rules before chatting. One rule per line.\":\"Enter your own text to require first-time viewers to agree to your rules before chatting. One rule per line.\",\"Food\":\"Food\",\"Gaming\":\"Gaming\",\"Incorrect input. Please check id or username of user\":\"Incorrect input. Please check id or username of user\",\"Loyalty\":\"Loyalty\",\"Manage basic chat functionality like Slow Mode, Chat Rules, etc.\":\"Manage basic chat functionality like Slow Mode, Chat Rules, etc.\",\"Manage basic chat functionality like Slow Mode, Pinned messages, etc.\":\"Manage basic chat functionality like Slow Mode, Pinned messages, etc.\",\"Moderator\":\"Moderator\",\"Monsters\":\"Monsters\",\"Music\":\"Music\",\"Muted\":\"Muted\",\"NEW\":\"NEW\",\"Nature\":\"Nature\",\"Origami\":\"Origami\",\"Password is missing or incorrect. Please try again!\":\"Password is missing or incorrect. Please try again!\",\"Replies\":\"Replies\",\"Report\":\"Report\",\"Resume\":\"Resume\",\"Retro\":\"Retro\",\"Robots\":\"Robots\",\"Settings menu\":\"Settings menu\",\"Side Panel Profile\":\"Side Panel Profile\",\"Sports\":\"Sports\",\"Start chatting\":\"Start chatting\",\"Submit\":\"Submit\",\"Tell us how you want to present yourself in the side panel.\":\"Tell us how you want to present yourself in the side panel.\",\"Unmute\":\"Unmute\",\"Username\":\"Username\",\"We received your report and will not process it What a terrible day\":\"We received your report and will not process it. What a terrible day..\",\"Your report is already being processed, don't worry.\":\"Your report is already being processed, don't worry.\",\"apply\":\"Apply changes\",\"badWord\":\"Your message contains a forbidden term.\",\"banUser\":\"Ban User\",\"banWarning\":\"You were banned from chat by a moderator.\",\"banned\":\"banned\",\"bannedMessageText\":\"{type} has been {action}\",\"blockedMessageNotification\":\"Your last message contained a blocked term or phrase and was blocked from chat.\",\"changeLanguage\":\"Change Language\",\"charLimit\":\"Your message exceeds the character limit ({0}).\",\"customize\":\"Customize your profile\",\"delete\":\"Delete message\",\"deleted\":\"deleted\",\"enabled\":\"enabled\",\"errors\":{},\"features\":\"Features\",\"hyperlink\":\"Messages containing links are not allowed.\",\"ignore\":\"Ignore User\",\"inputLabel\":\"Join the chat!\",\"loyaltyHighlightMessageDesc\":\"This purchase enables you to send a highlighted message. You will be able to do so right away or at any point in the future.\",\"loyaltyPinMessageDesc\":\"This purchase enables you to pin a message for a limited duration. You can either pin an existing message from chat or you create a new one\",\"loyaltyStartPollDesc\":\"The purchase enables you to create and start a poll. You will be able to do so right away or at any point in the future.\",\"loyaltyUnlockNameColorDesc\":\"This purchase unlocks a new name color permanently (Green). Visit your profile to see available colors and switch them.\",\"andMore\":\"and {num} more.\",\"moreActions\":\"More actions\",\"mute\":{\"warning\":\"You are muted\"},\"muteUser\":\"Mute User\",\"once\":\"Once is enough\",\"oops\":\"Something went wrong..\",\"pin\":{\"already\":\"Message already pinned\",\"message\":\"Pin message\"},\"pinnedMessage\":\"Pinned Message\",\"profile\":{\"create\":\"Create profile\",\"heading\":\"Tell us how you want to present yourself in the side panel\"},\"rateLimit\":\"You're sending too many messages.\",\"reaction\":{\"add\":\"Add reaction\"},\"reply\":\"reply | replies\",\"replyTooltip\":\"Reply\",\"report\":{\"avatarHarmful\":\"This profile picture is abusive or harmful\",\"header\":\"Report message or user\",\"messageHarmful\":\"This message is abusive or harmful\",\"messageSpam\":\"This message is suspicious or spam\",\"received\":\"We received your report and will process it soon. Thank You for contributing to a safe chat experience.\",\"subheader\":\"Let us know what is wrong with this message or user.\",\"success\":\"Successful Report\",\"usernameHarmful\":\"This username is abusive or harmful\"},\"response\":{\"genericError\":\"An error occured.\",\"BAD_WORD\":\"Your message contained a forbidden term and was blocked from chat.\",\"CHAR_LIMIT\":\"Your message exceeded the character limit and was blocked from chat ({0}).\",\"HYPERLINK\":\"Messages containing links are not allowed.\",\"RATE_LIMIT\":\"You've sent too many messages! Slow down.\",\"SAME_MESSAGE_COUNT\":\"You've sent too many identical messages in a row ({0}).\",\"USER_BANNED\":\"You have been banned by an admin or moderator. Please come back later.\",\"USER_MUTED\":\"You have been muted by an admin or moderator. Please come back later.\"},\"role\":{\"assign\":\"Assign roles to certain Chatters e.g for enabling them to moderate a chatroom\"},\"thisMessage\":\"This message\",\"thisUser\":\"This user\",\"unbanUser\":\"Unban {0}?\",\"scrollingPaused\":\"Chat is paused due to scrolling.\",\"muted\":\"muted\",\"time\":{\"hours\":\"{value} hour | {value} hours\",\"minutes\":\"{value} minute | {value} minutes\",\"days\":\"{value} day | {value} days\",\"weeks\":\"{value} week | {value} weeks\",\"indefinite\":\"Indefinite\"}},\"polls\":{\"active\":\"Active polls\",\"adminPublish\":\"An admin or moderator will publish the results shortly.\",\"addAnswer\":\"ADD ANOTHER ANSWER\",\"answer\":\"Answer {num}\",\"answered\":\"ANSWERED\",\"answerLimit\":\"Answers are limited to {chars} characters\",\"answerReceived\":\"Your answer has been received!\",\"createdBy\":\"Created by\",\"createNew\":\"Create new poll\",\"duration\":\"Poll duration\",\"ended\":\"Poll ended\",\"hideResults\":\"Hide results\",\"left\":\"left\",\"minutes\":\"{num} minutes\",\"missed\":\"MISSED\",\"none\":\"There are no active polls\",\"open\":\"OPEN\",\"past\":\"Past polls\",\"publish\":\"The results will be published shortly.\",\"publishConfirm\":\"Are you sure? This action cannot be undone.\",\"publishNo\":\"No\",\"publishYes\":\"Yes\",\"publishResults\":\"Publish results\",\"question\":\"Question\",\"setDuration\":\"Set poll duration\",\"showOverlayResults\":\"Show results in overlay\",\"showResults\":\"Show results\",\"showWordcloud\":\"Show wordcloud\",\"submitted\":\"User submitted answer\",\"submittedBy\":\"User submitted answer by {displayName}\",\"typeAnswer\":\"Type your own answer\",\"voted\":\"Voted\",\"singleWordValidationMessage\":\"Answers are limited to one word\",\"votesRemaining\":\"{votes} vote remaining | {votes} votes remaining\"}}");

/***/ }),

/***/ "ed99":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/startAPoll.605a01fa.png";

/***/ }),

/***/ "eda5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
            '_'
        ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ "ee6f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("59ed");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f183":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var hiddenKeys = __webpack_require__("d012");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternalModule = __webpack_require__("057f");
var isExtensible = __webpack_require__("4fadd");
var uid = __webpack_require__("90e3");
var FREEZING = __webpack_require__("bb2f");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "f260":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
            '_'
        ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ "f330":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f36a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "f3ff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ "f527":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f543":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/pinMessage.46b8e613.png";

/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ "f6b49":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "f748":
/***/ (function(module, exports) {

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f799":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChannelSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dbd3");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChannelSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChannelSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f8c9":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var setToStringTag = __webpack_require__("d44e");

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),

/***/ "facd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "handlePollEvents", function() { return /* reexport */ handlePollEvents; });
__webpack_require__.d(__webpack_exports__, "Spect8Chat", function() { return /* reexport */ components_Chat; });

// NAMESPACE OBJECT: ./node_modules/vuetify/lib/services/goto/easing-patterns.js
var easing_patterns_namespaceObject = {};
__webpack_require__.r(easing_patterns_namespaceObject);
__webpack_require__.d(easing_patterns_namespaceObject, "linear", function() { return linear; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInQuad", function() { return easeInQuad; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeOutQuad", function() { return easeOutQuad; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInOutQuad", function() { return easeInOutQuad; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInCubic", function() { return easeInCubic; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeOutCubic", function() { return easeOutCubic; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInOutCubic", function() { return easeInOutCubic; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInQuart", function() { return easeInQuart; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeOutQuart", function() { return easeOutQuart; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInOutQuart", function() { return easeInOutQuart; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInQuint", function() { return easeInQuint; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeOutQuint", function() { return easeOutQuint; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInOutQuint", function() { return easeInOutQuint; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./src/auth/store/mutations.ts

var mutations = {
  setAuthentication: function setAuthentication(state, payload) {
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "authenticated", payload.authenticated);
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "userInfoIsValid", payload.userInfoIsValid);
  }
};
// CONCATENATED MODULE: ./src/auth/store/getters.ts
var getters_getters = {
  authenticated: function authenticated(state) {
    return state.authenticated;
  },
  userInfoIsValid: function userInfoIsValid(state) {
    return state.userInfoIsValid;
  }
};
// CONCATENATED MODULE: ./src/auth/store/actions.ts
var actions = {};
// CONCATENATED MODULE: ./src/auth/store/index.ts



var store_state = {
  authenticated: false,
  userInfoIsValid: false
};
var AUTH_NAMESPACE = "spect8-chat-auth";
var namespaced = true;
var store_auth = {
  namespaced: namespaced,
  state: store_state,
  getters: getters_getters,
  actions: actions,
  mutations: mutations
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Chat.vue?vue&type=template&id=8edea27c&scoped=true&
var Chatvue_type_template_id_8edea27c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"chat-container"}},[(_vm.isPinnedMessage && _vm.isFetched && !_vm.dismissed)?_c('PinnedMessage'):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.userBanned || _vm.userBanned.softBan),expression:"!userBanned || userBanned.softBan"}],staticClass:"message-container"},[_c('v-list',{directives:[{name:"scroll",rawName:"v-scroll.self",value:(_vm.handleScroll),expression:"handleScroll",modifiers:{"self":true}}],ref:"scrollMain",staticStyle:{"overflow-y":"auto"},attrs:{"id":"MessageList","color":"background"}},[_vm._l((_vm.messagesFiltered),function(item){return [_c('ChatItem',{key:item.id,attrs:{"message":item},on:{"reply":_vm.handleReply,"height-change":_vm.handleHeightChange,"pauseScrolling":function($event){_vm.scrollingPaused = true}}})]})],2)],1),_c('v-scale-transition',{attrs:{"origin":"bottom left 0"}},[(_vm.enabledFeatures.THREADS && _vm.threadOpen)?_c('v-sheet',{directives:[{name:"click-outside",rawName:"v-click-outside",value:({ handler: _vm.closeThread, include: _vm.include }),expression:"{ handler: closeThread, include: include }"}],staticClass:"threadContainer d-flex flex-column justify-space-between align-self-stretch",attrs:{"elevation":"4"}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"0.4em","right":"0.4em","z-index":"12"},attrs:{"color":"primary"},on:{"click":_vm.closeThread}},[_vm._v("mdi-close ")]),_c('v-subheader',{staticStyle:{"padding":"0.5rem 0 0.5rem 1rem"}},[_vm._v(_vm._s(_vm.$t("s8c.Replies")))]),_c('v-list',{ref:"scrollThread",staticClass:"threadContainerInner"},[_c('ChatItem',{attrs:{"simple":"true","message":_vm.threadActive}}),_vm._l((_vm.threadActive.submessages),function(item){return [_c('ChatItem',{key:item.id,attrs:{"simple":"true","indent":"true","message":item}})]})],2)],1):_vm._e()],1),(_vm.userBanned && !_vm.userBanned.softBan)?_c('v-container',{staticClass:"flex-grow-1",attrs:{"color":"background"}},[_c('v-row',{staticStyle:{"min-height":"100%"},attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"align-self":"center","cols":"auto"}},[_c('v-card',{staticClass:"mx-auto text-center",attrs:{"tile":"","color":"background","flat":""}},[_c('v-icon',{staticClass:"text-h2 mx-auto mb-4",attrs:{"color":"error","x-large":""}},[_vm._v("mdi-alert")]),_c('p',{staticClass:"body-1 text-center"},[_vm._v(" "+_vm._s(_vm.$t("s8c.banWarning"))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.$t("s8c.Ban ends on"))+" "+_vm._s(new Date(_vm.userBanned.bannedUntil).toString())+" ")])],1)],1)],1)],1):_vm._e(),_c('v-snackbar',{staticClass:"snackbar",staticStyle:{"margin-bottom":"5.2rem","z-index":"7"},attrs:{"color":_vm.$vuetify.theme.dark ? 'background lighten-2' : 'background',"transition":"scroll-y-reverse-transition","timeout":"-1","elevation":"3","rounded":"","dense":"","dismissible":""},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":_vm.$vuetify.theme.dark ? 'white' : 'black',"plain":"","z-index":"4"},on:{"click":function($event){_vm.scrollingPaused = false}}},'v-btn',attrs,false),[_c('span',{staticClass:"snackbar-text"},[_vm._v(" "+_vm._s(_vm.$t("s8c.Resume"))+" ")])])]}}]),model:{value:(_vm.scrollingPaused),callback:function ($$v) {_vm.scrollingPaused=$$v},expression:"scrollingPaused"}},[_c('span',{class:((_vm.$vuetify.theme.dark ? 'white' : 'black') + "--text snackbar-text")},[_vm._v(" "+_vm._s(_vm.$t("s8c.scrollingPaused"))+" ")])]),_c('v-snackbar',{staticClass:"lighten-2",staticStyle:{"margin-bottom":"5rem"},attrs:{"transition":"scroll-y-reverse-transition","color":"error","timeout":"5000","elevation":"4","left":"","rounded":"","dense":"","dismissible":""},scopedSlots:_vm._u([{key:"action",fn:function(ref){
      var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":_vm.$vuetify.theme.dark ? 'white' : 'black',"plain":"","text":""},on:{"click":function($event){_vm.messageErrorVisible = false}}},'v-btn',attrs,false),[_vm._v(" "+_vm._s(_vm.$t("s8c.Close"))+" ")])]}}]),model:{value:(_vm.messageErrorVisible),callback:function ($$v) {_vm.messageErrorVisible=$$v},expression:"messageErrorVisible"}},[_c('span',{class:((_vm.$vuetify.theme.dark ? 'white' : 'black') + "--text")},[_vm._v(" "+_vm._s(_vm.getErrorText))])]),_c('v-row',{staticClass:"align-center flex-nowrap ma-0 flex-grow-0",style:(_vm.inputStyle),attrs:{"id":"s8chat-textinput"}},[_c('at-ta',{staticClass:"flex-grow-1",attrs:{"members":_vm.activeUsers,"name-key":"displayName"},scopedSlots:_vm._u([{key:"item",fn:function(s){return [_c('img',{directives:[{name:"show",rawName:"v-show",value:(s.item.imageUrl),expression:"s.item.imageUrl"}],attrs:{"src":s.item.imageUrl}}),_c('span',{domProps:{"textContent":_vm._s(s.item.displayName)}})]}}])},[_c('v-textarea',{ref:"input",class:[
          _vm.enabledFeatures.FOOTER ? 'py-0' : 'py-2',
          _vm.styleConfig.alternativeLayout.textInputSendButtonAlign
            ? 'mr-1'
            : '' ],style:({ borderRadius: _vm.inputStyle.borderRadius }),attrs:{"label":_vm.hasNoVoice ? this.$t('s8c.mute.warning') : _vm.$t('s8c.inputLabel'),"filled":"","outlined":"","single-line":"","hide-details":"auto","dense":"","auto-grow":"","counter":_vm.textInputCounterVisible,"rules":[_vm.textMessageRules.maxLength],"disabled":_vm.hasNoVoice,"rows":"1"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.sendMessage.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.closeThread.apply(null, arguments)}]},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-menu',{attrs:{"close-on-content-click":false,"offset-y":"","left":"","top":"","z-index":"10"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [(_vm.styleConfig.visible.textInputEmojiButton)?_c('v-icon',_vm._g({staticClass:"mr-1"},on),[_vm._v(" mdi-emoticon-happy ")]):_vm._e()]}}]),model:{value:(_vm.emojiPicker),callback:function ($$v) {_vm.emojiPicker=$$v},expression:"emojiPicker"}},[_c('ChatEmojiPicker',{attrs:{"dark":_vm.$vuetify.theme.dark},on:{"emoji":_vm.selectEmoji}})],1)]},proxy:true}]),model:{value:(_vm.textInput),callback:function ($$v) {_vm.textInput=$$v},expression:"textInput"}})],1),(
        !_vm.enabledFeatures.FOOTER ||
        _vm.styleConfig.alternativeLayout.textInputSendButtonAlign
      )?_c('v-btn',{staticClass:"ml-2",class:_vm.brandTextColorLight ? 'white--text' : 'black--text',staticStyle:{"height":"98%","max-height":"2.6rem"},style:(_vm.buttonStyle),attrs:{"small":"","rounded-lg":"","color":"brand"},on:{"click":_vm.sendMessage}},[_vm._v("Chat ")]):_vm._e()],1),(_vm.enabledFeatures.FOOTER)?_c('v-footer',{staticClass:"flex-grow-0 px-2",attrs:{"dense":"","color":"background"}},[(_vm.enabledFeatures.CHANNEL_LIST)?_c('channel-select',{attrs:{"loading":_vm.loadingChannels}}):_vm._e(),_c('v-spacer'),(_vm.enabledFeatures.SETTINGS_MENU)?_c('settings-menu'):_vm._e(),(_vm.enabledFeatures.USER_LIST)?_c('user-list',{on:{"user-clicked":_vm.handleUserListClick}}):_vm._e(),(!_vm.styleConfig.alternativeLayout.textInputSendButtonAlign)?_c('v-btn',{staticClass:"my-0",class:_vm.brandTextColorLight ? 'white--text' : 'black--text',style:(_vm.buttonStyle),attrs:{"small":"","rounded-lg":"","color":"brand"},on:{"click":_vm.sendMessage}},[_vm._v("Chat ")]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Chat.vue?vue&type=template&id=8edea27c&scoped=true&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__("00b4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js








function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("4ae1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.to-string-tag.js
var es_reflect_to_string_tag = __webpack_require__("f8c9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js



function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js






function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace-all.js
var es_string_replace_all = __webpack_require__("5b81");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat-map.js
var es_array_flat_map = __webpack_require__("5db7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat-map.js
var es_array_unscopables_flat_map = __webpack_require__("73d9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.all-settled.js
var es_promise_all_settled = __webpack_require__("820e");

// CONCATENATED MODULE: ./src/store/types.ts
var MessageType;

(function (MessageType) {
  MessageType["TEXT"] = "TEXT";
  MessageType["IMAGE"] = "IMAGE";
  MessageType["VIDEO"] = "VIDEO";
  MessageType["AUDIO"] = "AUDIO";
  MessageType["POLL"] = "POLL";
})(MessageType || (MessageType = {}));

var MentionType;

(function (MentionType) {
  MentionType[MentionType["USER"] = 0] = "USER";
  MentionType[MentionType["LINK"] = 1] = "LINK";
})(MentionType || (MentionType = {}));

var ActionType;

(function (ActionType) {
  ActionType["ADD_MESSAGE"] = "ADD_MESSAGE";
  ActionType["EDIT_MESSAGE"] = "EDIT_MESSAGE";
  ActionType["DELETE_MESSAGE"] = "DELETE_MESSAGE";
  ActionType["RESTORE_MESSAGE"] = "RESTORE_MESSAGE";
  ActionType["ADD_SUB_MESSAGE"] = "ADD_SUB_MESSAGE";
  ActionType["EDIT_SUB_MESSAGE"] = "EDIT_SUB_MESSAGE";
  ActionType["DELETE_SUB_MESSAGE"] = "DELETE_SUB_MESSAGE";
  ActionType["ADD_REACTION"] = "ADD_REACTION";
  ActionType["DELETE_REACTION"] = "DELETE_REACTION";
})(ActionType || (ActionType = {}));

var EventType;

(function (EventType) {
  EventType["CHANNEL_ADDED"] = "CHANNEL_ADDED";
  EventType["CHANNEL_DELETED"] = "CHANNEL_DELETED";
  EventType["CHANNEL_RENAMED"] = "CHANNEL_RENAMED";
  EventType["CHANNEL_PRIVATIZED"] = "CHANNEL_PRIVATIZED";
  EventType["USER_JOINED"] = "USER_JOINED";
  EventType["USER_LEFT"] = "USER_LEFT";
  EventType["USER_BANNED"] = "USER_BANNED";
  EventType["USER_UNBANNED"] = "USER_UNBANNED";
  EventType["USER_EDITED"] = "USER_EDITED";
  EventType["MESSAGE_PINNED"] = "MESSAGE_PINNED";
  EventType["MESSAGE_REJECTED"] = "MESSAGE_REJECTED";
  EventType["PIN_ADDED"] = "PIN_ADDED";
  EventType["PIN_REMOVED"] = "PIN_REMOVED";
  EventType["RULES_CHANGED"] = "RULES_CHANGED";
  EventType["CHAT_SETTINGS_CHANGED"] = "CHAT_SETTINGS_CHANGED";
  EventType["GOODBYE"] = "GOODBYE"; // Polls

  EventType["POLL_VOTED"] = "POLL_VOTED";
  EventType["POLL_STARTED"] = "POLL_STARTED";
  EventType["POLL_ENDED"] = "POLL_ENDED";
  EventType["POLL_DELETED"] = "POLL_DELETED";
})(EventType || (EventType = {}));

var ReportType;

(function (ReportType) {
  ReportType["MESSAGE_HARMFUL"] = "MESSAGE_HARMFUL";
  ReportType["MESSAGE_SPAM"] = "MESSAGE_SPAM";
  ReportType["USERNAME_HARMFUL"] = "USERNAME_HARMFUL";
  ReportType["AVATAR_HARMFUL"] = "AVATAR_HARMFUL";
})(ReportType || (ReportType = {}));
// CONCATENATED MODULE: ./src/services/spect8-api.service.ts



var http;

function setApiService(apiService) {
  http = apiService;
}

var sendToNchan = function sendToNchan(data, chan, broadcastId, tenantId) {
  return http.post("/pub/".concat(tenantId, ":").concat(broadcastId, ":").concat(chan.id), data);
};

var spect8_api_service_fetchChannels = function fetchChannels(broadcastId) {
  return http.get("/channel/broadcast/all", {
    params: {
      broadcastId: broadcastId
    }
  }).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_fetchHistory = function fetchHistory(channelId) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  return http.get("message/history/".concat(channelId, "/").concat(count)).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_fetchBansBroadcast = function fetchBansBroadcast(broadcastId) {
  return http.get("/ban/broadcasts?broadcastIds=".concat(broadcastId)).then(function (res) {
    return res.data.map(function (ban) {
      return _objectSpread2(_objectSpread2({}, ban), {}, {
        bannedUntil: Date.parse(ban.bannedUntil),
        timeBanned: Date.parse(ban.timeBanned)
      });
    });
  });
};

var spect8_api_service_fetchBansChannels = function fetchBansChannels(channelIds) {
  return http.get("/ban/channels?channelIds=".concat(channelIds)).then(function (res) {
    return res.data.map(function (ban) {
      return _objectSpread2(_objectSpread2({}, ban), {}, {
        bannedUntil: Date.parse(ban.bannedUntil),
        timeBanned: Date.parse(ban.timeBanned)
      });
    });
  });
};

var spect8_api_service_fetchChannelUsers = function fetchChannelUsers(channelId) {
  return http.get("/users/active/channel/".concat(channelId)).then(function (res) {
    return res.data;
  });
};

var setActiveUser = function setActiveUser(channelId) {
  return http.post("users/active/user/channel", null, {
    params: {
      channelId: channelId
    }
  }).then(function (res) {
    return res.data;
  });
};

var unsetActiveUser = function unsetActiveUser(channelId) {
  return http.delete("users/active/user/channel/".concat(channelId)).then(function (res) {
    return res.data;
  });
};

var getPins = function getPins(channelId) {
  return http.get("/pinnedmessages/channel/".concat(channelId)).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_pin = function pin(messageId, durationMs) {
  return http.post("/pinnedmessages/".concat(messageId), {}, {
    params: {
      durationMs: durationMs
    }
  }).then(function (res) {
    return res.data;
  });
};

var unpin = function unpin(messageId) {
  return http.delete("/pinnedmessages/".concat(messageId)).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_ban = function ban(_ban) {
  return http.post("/ban", _ban).then(function (res) {
    return _objectSpread2(_objectSpread2({}, res.data), {}, {
      bannedUntil: Date.parse(res.data.bannedUntil),
      timeBanned: Date.parse(res.data.timeBanned)
    });
  });
};

var unban = function unban(banId) {
  return http.delete("/ban/".concat(banId)).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_addChannel = function addChannel(channelName, broadcastId) {
  return http.post("/channel", null, {
    params: {
      channelName: channelName,
      broadcastId: broadcastId
    }
  }).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_deleteChannel = function deleteChannel(channelId) {
  return http.delete("/channel/".concat(channelId)).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_report = function report(_report) {
  return http.post("/report", _report).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_changeLanguage = function changeLanguage(language) {
  return http.put("/userinfo/language/".concat(language)).then(function (res) {
    return res.data;
  });
}; // :hmm:


var spect8_api_service_changeColor = function changeColor(userinfo) {
  return http.put("/userinfo", userinfo).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_keepAlive = function keepAlive() {
  return http.post("/keepalive").then(function (res) {
    return res.data;
  });
};

var spect8_api_service_fetchSettings = function fetchSettings(broadcastId) {
  return http.get("/settings/chat", {
    params: {
      broadcastId: broadcastId
    }
  }).then(function (res) {
    return res.data;
  });
};

var spect8_api_service_fetchBans = function fetchBans() {
  return http.get("/bans").then(function (res) {
    return res.data.map(function (ban) {
      return _objectSpread2(_objectSpread2({}, ban), {}, {
        bannedUntil: Date.parse(ban.bannedUntil),
        timeBanned: Date.parse(ban.timeBanned)
      });
    });
  });
};

var apiChat = {
  sendToNchan: sendToNchan,
  fetchChannels: spect8_api_service_fetchChannels,
  fetchHistory: spect8_api_service_fetchHistory,
  fetchBansBroadcast: spect8_api_service_fetchBansBroadcast,
  fetchBansChannels: spect8_api_service_fetchBansChannels,
  fetchChannelUsers: spect8_api_service_fetchChannelUsers,
  setActiveUser: setActiveUser,
  unsetActiveUser: unsetActiveUser,
  getPins: getPins,
  pin: spect8_api_service_pin,
  unpin: unpin,
  ban: spect8_api_service_ban,
  unban: unban,
  addChannel: spect8_api_service_addChannel,
  deleteChannel: spect8_api_service_deleteChannel,
  report: spect8_api_service_report,
  changeLanguage: spect8_api_service_changeLanguage,
  changeColor: spect8_api_service_changeColor,
  keepAlive: spect8_api_service_keepAlive,
  fetchSettings: spect8_api_service_fetchSettings,
  fetchBans: spect8_api_service_fetchBans
};

// CONCATENATED MODULE: ./src/config/types.ts
// Modes define certain restrictions for users
// 'all', 'subscribers' & 'followers' set a minimum class requirement for voice rights
// 'slow' allows everybody to talk but with more restrictive timings
var ChatMode;

(function (ChatMode) {
  ChatMode["all"] = "all";
  ChatMode["subscribers"] = "subscribers";
  ChatMode["followers"] = "followers";
  ChatMode["slow"] = "slow";
})(ChatMode || (ChatMode = {}));

var UserColorMode;

(function (UserColorMode) {
  UserColorMode["NONE"] = "NONE";
  UserColorMode["RANDOM"] = "RANDOM";
  UserColorMode["PICK_FROM_SET"] = "PICK_FROM_SET";
  UserColorMode["PICK_ANY"] = "PICK_ANY";
})(UserColorMode || (UserColorMode = {}));

var Feature;

(function (Feature) {
  Feature["THREADS"] = "THREADS";
  Feature["FOOTER"] = "FOOTER";
  Feature["USER_LIST"] = "USER_LIST";
  Feature["CHANNEL_LIST"] = "CHANNEL_LIST";
  Feature["COMPACT_MESSAGES"] = "COMPACT_MESSAGES";
  Feature["NAME_COLORS"] = "NAME_COLORS";
  Feature["LOYALTY"] = "LOYALTY";
  Feature["REPORTS"] = "REPORTS";
  Feature["IGNORE"] = "IGNORE";
  Feature["HISTORY"] = "HISTORY";
  Feature["SETTINGS_MENU"] = "SETTINGS_MENU";
  Feature["VIDEO_CONFERENCING"] = "VIDEO_CONFERENCING";
})(Feature || (Feature = {}));

var SettingsLevel;

(function (SettingsLevel) {
  SettingsLevel[SettingsLevel["TENANT"] = 0] = "TENANT";
  SettingsLevel[SettingsLevel["BROADCAST"] = 1] = "BROADCAST";
  SettingsLevel[SettingsLevel["CHANNEL"] = 2] = "CHANNEL";
})(SettingsLevel || (SettingsLevel = {}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// CONCATENATED MODULE: ./src/shared/user/types.ts
var Role;

(function (Role) {
  Role["ROLE_ADMIN"] = "ROLE_ADMIN";
  Role["ROLE_MODERATOR"] = "ROLE_MODERATOR";
  Role["ROLE_USER"] = "ROLE_USER";
})(Role || (Role = {}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// CONCATENATED MODULE: ./src/shared/utils/MimeType.ts


function getImageMimeType(path) {
  return "image/" + path.split(".").pop();
}
// CONCATENATED MODULE: ./src/shared/user/store/mutations.ts






function toUserInfo(user) {
  var userInfo = {
    avatar: {
      src: null,
      mimeType: null
    },
    badge: {
      src: null,
      mimeType: null
    },
    color: null,
    colorIndex: null,
    displayName: null,
    firstName: null,
    id: user.id,
    lastName: null,
    roles: [Role.ROLE_USER],
    username: user.username
  };

  if (user.editRequest !== null) {
    var _user$editRequest$dis, _user$editRequest$col, _user$editRequest$ava, _user$editRequest$bad;

    userInfo.displayName = (_user$editRequest$dis = user.editRequest.displayName) !== null && _user$editRequest$dis !== void 0 ? _user$editRequest$dis : null;
    userInfo.color = (_user$editRequest$col = user.editRequest.color) !== null && _user$editRequest$col !== void 0 ? _user$editRequest$col : null;

    if ((_user$editRequest$ava = user.editRequest.avatar) !== null && _user$editRequest$ava !== void 0 && _user$editRequest$ava.src) {
      userInfo.avatar = {
        src: user.editRequest.avatar.src,
        mimeType: getImageMimeType(user.editRequest.avatar.src)
      };
    }

    if ((_user$editRequest$bad = user.editRequest.badge) !== null && _user$editRequest$bad !== void 0 && _user$editRequest$bad.src) {
      var _user$editRequest$bad2;

      userInfo.badge = {
        src: (_user$editRequest$bad2 = user.editRequest.badge) === null || _user$editRequest$bad2 === void 0 ? void 0 : _user$editRequest$bad2.src,
        mimeType: getImageMimeType(user.editRequest.badge.src)
      };
    }
  }

  userInfo.roles = user.roles;
  return userInfo;
}
var mutations_mutations = {
  setUser: function setUser(state, user) {
    if (!user.blockedUsers) {
      user.blockedUsers = [];
    }

    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "user", user); // Vue.set(state, "user.blockedUsers", Array<UserInfo>());

    if (user.editRequest !== null) {
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "created", true);
    }

    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "userInfo", toUserInfo(user));
  },
  setUpdateError: function setUpdateError(state, updateError) {
    state.hasUpdateError = updateError;
  },
  ignoreUser: function ignoreUser(state, payload) {
    if (!state.user) return;
    if (!state.user.blockedUsers) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state.user, "blockedUsers", Array());
    if (!state.user.blockedUsers.some(function (u) {
      return payload.id === u.id;
    })) state.user.blockedUsers.push(payload);
  },
  unignoreUser: function unignoreUser(state, payload) {
    if (!state.user) return;
    if (!state.user.blockedUsers) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state.user, "blockedUsers", Array());
    var i = state.user.blockedUsers.findIndex(function (u) {
      return u.id === payload.id;
    });
    if (i >= 0) state.user.blockedUsers.splice(i, 1);
  },
  addUsernameHistory: function addUsernameHistory(state, payload) {
    if (payload && !state.usernameHistory.some(function (s) {
      return s === payload;
    })) state.usernameHistory.push(payload);
  },
  setService: function setService(state, service) {
    if (service) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "subService", service);
  },
  deleteService: function deleteService(state) {
    if (state.subService) {
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.delete(state, "subService");
    } else console.error("No subscriber was deleted.");
  }
};
// CONCATENATED MODULE: ./src/shared/user/store/getters.ts



var store_getters_getters = {
  created: function created(state) {
    return state.created;
  },
  hasUpdateError: function hasUpdateError(state) {
    return state.hasUpdateError;
  },
  isAdmin: function isAdmin(state) {
    var _state$user$roles$inc, _state$user;

    return (_state$user$roles$inc = (_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.roles.includes(Role.ROLE_ADMIN)) !== null && _state$user$roles$inc !== void 0 ? _state$user$roles$inc : false;
  },
  isModerator: function isModerator(state) {
    var _state$user$roles$inc2, _state$user2;

    return (_state$user$roles$inc2 = (_state$user2 = state.user) === null || _state$user2 === void 0 ? void 0 : _state$user2.roles.includes(Role.ROLE_MODERATOR)) !== null && _state$user$roles$inc2 !== void 0 ? _state$user$roles$inc2 : false;
  },
  userInfo: function userInfo(state) {
    return state.userInfo;
  },
  userInfoIsValid: function userInfoIsValid(state) {
    var _state$userInfo;

    return ((_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.displayName) !== null;
  },
  user: function user(state) {
    return state.user;
  },
  ignored: function ignored(state) {
    var _state$user$blockedUs, _state$user3;

    return (_state$user$blockedUs = (_state$user3 = state.user) === null || _state$user3 === void 0 ? void 0 : _state$user3.blockedUsers) !== null && _state$user$blockedUs !== void 0 ? _state$user$blockedUs : [];
  },
  usernameHistory: function usernameHistory(state) {
    return state.usernameHistory;
  }
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.sub.js
var es_string_sub = __webpack_require__("4c53");

// EXTERNAL MODULE: ./node_modules/nchan/NchanSubscriber.js
var NchanSubscriber = __webpack_require__("9439");
var NchanSubscriber_default = /*#__PURE__*/__webpack_require__.n(NchanSubscriber);

// CONCATENATED MODULE: ./src/services/nchan.service.ts





var nchan_service_NchanService = /*#__PURE__*/_createClass(function NchanService( // channel: string,
//     broadcastId: string,
//     tenantId: string,
nchanUrl, path) {
  var messageHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (m) {
    console.log(m);
  };
  var connectHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    console.log("Subscribing to ".concat(path, "..."));
  };
  var disconnectHandler = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    console.log("Unsubscribing to ".concat(path, "..."));
  };

  _classCallCheck(this, NchanService);

  this.messageHandler = messageHandler;
  this.connectHandler = connectHandler;
  this.disconnectHandler = disconnectHandler; //     const base = nchanUrl;
  //     const path = `${tenantId}:${broadcastId}:spect8-ia`;
  //     this.url = `${base}${path}`;

  var url = "".concat(nchanUrl, "/sub/").concat(path);
  var sub = new NchanSubscriber_default.a(url, {
    subscriber: "websocket"
  });
  sub.on("message", this.messageHandler);
  sub.on("connect", this.connectHandler);
  sub.on("disconnect", this.disconnectHandler);
  sub.start();
  this.sub = sub;
});
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__("bc3a");
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);

// CONCATENATED MODULE: ./src/shared/user/store/actions.ts










var actions_actions = {
  fetch: function fetch(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, dispatch, _res$data$editRequest, res;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, dispatch = _ref.dispatch;
              _context.prev = 1;
              _context.next = 4;
              return http.get("/userinfo");

            case 4:
              res = _context.sent;
              commit("addUsernameHistory", (_res$data$editRequest = res.data.editRequest) === null || _res$data$editRequest === void 0 ? void 0 : _res$data$editRequest.displayName);
              commit("setUser", res.data);
              dispatch("startListening");
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }))();
  },
  update: function update(context, updatePayload) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var editRequest, response, user, _error$response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              context.commit("setUpdateError", false);
              editRequest = {
                avatar: null,
                badge: null,
                color: updatePayload.color,
                displayName: updatePayload.displayName
              };

              if (updatePayload.avatarUrl && updatePayload.avatarUrl !== "") {
                editRequest.avatar = {
                  src: updatePayload.avatarUrl,
                  mimeType: getImageMimeType(updatePayload.avatarUrl)
                };
              } // else if (updatePayload.imageFile) {
              //   const url = await uploadImage(updatePayload.imageFile);
              //   if (url) {
              //     editRequest.avatar = {
              //       src: url,
              //       mimeType: getImageMimeType(url)
              //     };
              //   }
              // }


              if (updatePayload.badgeUrl && updatePayload.badgeUrl !== "") {
                editRequest.badge = {
                  src: updatePayload.badgeUrl,
                  mimeType: getImageMimeType(updatePayload.badgeUrl)
                };
              }

              _context2.prev = 4;
              _context2.next = 7;
              return http.put("/userinfo", editRequest);

            case 7:
              response = _context2.sent;
              user = response.data;
              context.commit("setUser", user);
              console.log("User update success", user);
              _context2.next = 17;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](4);

              if (axios_default.a.isAxiosError(_context2.t0) && ((_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 400) {
                context.commit("setUpdateError", true);
              }

              console.error(_context2.t0);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 13]]);
    }))();
  },
  startListening: function startListening(_ref2) {
    var _state$user, _state$user2;

    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;

    if (state.subService) {
      state.subService.sub.start();
      return;
    }

    var _getAppConfig = getAppConfig(this),
        nchanUrl = _getAppConfig.nchanUrl;

    if (!((_state$user = state.user) !== null && _state$user !== void 0 && _state$user.id) || !nchanUrl) return;

    var message = function message(m) {
      console.log("\n# Incoming message on userchan");

      try {
        var dto = JSON.parse(m);
        if (typeof dto.payload === "string") dto.payload = JSON.parse(dto.payload); // === Message parsing switch ===

        switch (dto.type) {
          case EventType.MESSAGE_REJECTED:
            {
              var rejection = dto.payload;
              dispatch(store_CHAT_NAMESPACE + "/setMessageError", rejection, {
                root: true
              });
              break;
            }

          case EventType.GOODBYE:
            {
              // prep shutdown
              console.log("Goodbye");
              break;
            }

          default:
            {
              console.warn("Invalid message type.");
            }
        }
      } catch (e) {
        console.log(e.message);
      }
    };

    var connect = function connect() {
      console.log("Subscribing to user-chan");
    };

    var disconnect = function disconnect() {
      console.log("Unsubscribing from user-chan");
    };

    var nchanService = new nchan_service_NchanService(nchanUrl, "user:".concat((_state$user2 = state.user) === null || _state$user2 === void 0 ? void 0 : _state$user2.id), message, connect, disconnect);
    commit("setService", nchanService);
  },
  ignoreUser: function ignoreUser(_ref3, user) {
    var commit = _ref3.commit;
    console.log("Ignoring user ".concat(user.displayName));
    return http.post("/userinfo/block", null, {
      params: {
        id: user.id
      }
    }).then(function (res) {
      if (res.status === 200) {
        commit("ignoreUser", user);
      }
    }).catch(function (err) {
      if (err.response) {
        if (err.response.status === 409) console.log(err.response.data.message);
      } else console.log("Error", err.message);
    });
  },
  unignoreUser: function unignoreUser(_ref4, user) {
    var commit = _ref4.commit;
    console.log("Unignoring user ".concat(user.displayName));
    return http.post("/userinfo/unblock", null, {
      params: {
        id: user.id
      }
    }).then(function (res) {
      if (res.status === 200) {
        commit("unignoreUser", user);
      }
    }).catch(function (err) {
      if (err.response) {
        if (err.response.status === 409) console.log(err.response.data.message);
      } else console.log("Error", err.message);
    });
  }
};
// CONCATENATED MODULE: ./src/shared/user/store/index.ts



var USER_NAMESPACE = "spect8-chat-user";
var store_namespaced = true;
var user_store_state = {
  created: false,
  hasUpdateError: false,
  usernameHistory: []
};
var store_user = {
  namespaced: store_namespaced,
  state: user_store_state,
  getters: store_getters_getters,
  actions: actions_actions,
  mutations: mutations_mutations
};
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js







function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("4fad");

// EXTERNAL MODULE: ./src/plugins/i18n/locales/en.json
var en = __webpack_require__("eccd");

// EXTERNAL MODULE: ./src/plugins/i18n/locales/de.json
var de = __webpack_require__("1189");

// CONCATENATED MODULE: ./src/plugins/i18n/vue-i18n-plugin.ts




var _baseMessages;





var i18n;
var Locale;

(function (Locale) {
  Locale["EN"] = "en";
  Locale["DE"] = "de";
})(Locale || (Locale = {}));

var baseMessages = (_baseMessages = {}, _defineProperty(_baseMessages, Locale.EN, en), _defineProperty(_baseMessages, Locale.DE, de), _baseMessages);
var i18nNamespace = "s8c";
var vue_i18n_plugin_initI18n = function initI18n(i18nInstance) {
  if (!i18nInstance) {
    throw new Error("Please initialise plugin with an i18n service");
  } // Assign i18n instance to scoped i18n variable so that we can reference/use in helper functions outside of Vue.


  i18n = i18nInstance; // Add our translations

  for (var _i = 0, _Object$entries = Object.entries(baseMessages); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        lang = _Object$entries$_i[0],
        messages = _Object$entries$_i[1];

    if (i18nInstance.messages[lang]) {
      i18nInstance.setLocaleMessage(lang, _objectSpread2(_objectSpread2({}, messages), i18nInstance.messages[lang]));
    } else {
      i18nInstance.setLocaleMessage(lang, _objectSpread2({}, messages));
    }
  }
};
// CONCATENATED MODULE: ./src/components/Polls/types.ts
var PollAction;

(function (PollAction) {
  PollAction["GET_POLL"] = "GET_POLL";
  PollAction["GET_USERS_VOTES"] = "GET_USERS_VOTES";
  PollAction["VOTE"] = "VOTE";
  PollAction["UPDATE_POLL"] = "UPDATE_POLL";
  PollAction["DELETE_POLL"] = "DELETE_POLL";
  PollAction["START_POLL"] = "START_POLL";
  PollAction["END_POLL"] = "END_POLL";
})(PollAction || (PollAction = {}));

var PollNchanEvents = {
  POLL_VOTED: PollAction.UPDATE_POLL,
  POLL_DELETED: PollAction.DELETE_POLL,
  POLL_STARTED: PollAction.START_POLL,
  POLL_ENDED: PollAction.END_POLL
};
var PollStatus;

(function (PollStatus) {
  PollStatus["DRAFT"] = "DRAFT";
  PollStatus["ACTIVE"] = "ACTIVE";
  PollStatus["SCHEDULED"] = "SCHEDULED";
  PollStatus["ENDED"] = "ENDED";
})(PollStatus || (PollStatus = {}));

var PollResultVisibility;

(function (PollResultVisibility) {
  PollResultVisibility["LIVE"] = "LIVE";
  PollResultVisibility["ON_DEMAND"] = "ON_DEMAND";
  PollResultVisibility["ON_POLL_END"] = "ON_POLL_END";
})(PollResultVisibility || (PollResultVisibility = {}));

var PollType;

(function (PollType) {
  PollType["DEFAULT"] = "DEFAULT";
  PollType["OPEN"] = "OPEN";
  PollType["IMAGE"] = "IMAGE"; //   GEMA = "GEMA"
})(PollType || (PollType = {}));

var PollLocation;

(function (PollLocation) {
  PollLocation["DEFAULT"] = "DEFAULT";
  PollLocation["INLINE"] = "INLINE"; //   PINNED = "PINNED" // Tab Panel & Chat Panel - Pinned Messages
})(PollLocation || (PollLocation = {}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// CONCATENATED MODULE: ./src/helpers/constants.ts
var API_BASE_URL = "https://core.dev.s8c.vaud.one/api/v1" || false;
var UPMAN_MEDIA_BASE_URL = "https://s8cul.s3.nl-ams.scw.cloud/" || false;
var CHAT_NAMESPACE = "spect8-chat";
var CONFIG_NAMESPACE = CHAT_NAMESPACE + "-config";
var constants_AUTH_NAMESPACE = CHAT_NAMESPACE + "-auth";
var constants_USER_NAMESPACE = CHAT_NAMESPACE + "-user";
// CONCATENATED MODULE: ./src/services/axios-base.ts





function getAxiosInstance(axiosConfig, store) {
  var axiosInstance = axios_default.a.create(axiosConfig);
  axiosInstance.interceptors.request.use(function (config) {
    var accessToken = store.getters["auth/accessToken"];

    if (accessToken) {
      config.headers.Authorization = "Bearer ".concat(accessToken);
    }

    return config;
  }, function (error) {
    return Promise.reject(error);
  });
  axiosInstance.interceptors.response.use(function (res) {
    return res;
  }, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(error) {
      var originalRequest, accessToken;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              originalRequest = error.config;

              if (!(error.response.status === 401 && !originalRequest._retry)) {
                _context.next = 9;
                break;
              }

              originalRequest._retry = true;
              _context.next = 5;
              return store.dispatch("auth/refresh");

            case 5:
              accessToken = _context.sent;

              if (!(accessToken !== null)) {
                _context.next = 9;
                break;
              }

              originalRequest.headers["Authorization"] = "Bearer ".concat(accessToken);
              return _context.abrupt("return", axiosInstance(originalRequest));

            case 9:
              return _context.abrupt("return", Promise.reject(error));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  return axiosInstance;
}
// CONCATENATED MODULE: ./src/services/polls-service.ts










var polls_service_PollsService = /*#__PURE__*/function () {
  function PollsService(axios) {
    _classCallCheck(this, PollsService);

    this.pollsEndpoint = "/polls";
    this.pollVotesEndpoint = "/pollvotes";
    this.axios = axios;
  }

  _createClass(PollsService, [{
    key: "getPollById",
    value: function () {
      var _getPollById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pollId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.axios.get("".concat(this.pollsEndpoint, "/").concat(pollId)).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPollById(_x) {
        return _getPollById.apply(this, arguments);
      }

      return getPollById;
    }()
  }, {
    key: "getPollsByBroadcastIds",
    value: function () {
      var _getPollsByBroadcastIds = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tenantId, broadcastIds) {
        var ids;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ids = broadcastIds.join(",");
                return _context2.abrupt("return", this.axios.get("".concat(this.pollsEndpoint, "/broadcasts?tenantId=").concat(tenantId, "&broadcastIds=").concat(ids)).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPollsByBroadcastIds(_x2, _x3) {
        return _getPollsByBroadcastIds.apply(this, arguments);
      }

      return getPollsByBroadcastIds;
    }()
  }, {
    key: "getPollsByChannelIds",
    value: function () {
      var _getPollsByChannelIds = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(tenantId, channelIds) {
        var ids;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ids = channelIds.join(",");
                return _context3.abrupt("return", this.axios.get("".concat(this.pollsEndpoint, "/broadcasts?tenantId=").concat(tenantId, "&channelIds=").concat(ids)).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPollsByChannelIds(_x4, _x5) {
        return _getPollsByChannelIds.apply(this, arguments);
      }

      return getPollsByChannelIds;
    }()
  }, {
    key: "getPollVotesByPollIdAndUserId",
    value: function () {
      var _getPollVotesByPollIdAndUserId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(pollId, userId) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.axios.get("".concat(this.pollVotesEndpoint, "/").concat(pollId, "/").concat(userId)).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getPollVotesByPollIdAndUserId(_x6, _x7) {
        return _getPollVotesByPollIdAndUserId.apply(this, arguments);
      }

      return getPollVotesByPollIdAndUserId;
    }()
  }, {
    key: "saveVote",
    value: function () {
      var _saveVote = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref) {
        var userId, pollId, pollAnswer;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                userId = _ref.userId, pollId = _ref.pollId, pollAnswer = _ref.pollAnswer;
                return _context5.abrupt("return", this.axios.post("".concat(this.pollVotesEndpoint, "/").concat(pollId), {
                  userId: userId,
                  pollAnswer: pollAnswer
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function saveVote(_x8) {
        return _saveVote.apply(this, arguments);
      }

      return saveVote;
    }()
  }, {
    key: "createPoll",
    value: function () {
      var _createPoll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(poll) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.axios.post("".concat(this.pollsEndpoint), poll).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createPoll(_x9) {
        return _createPoll.apply(this, arguments);
      }

      return createPoll;
    }()
  }, {
    key: "publishPollResults",
    value: function () {
      var _publishPollResults = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(pollId) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.axios.post("".concat(this.pollsEndpoint, "/").concat(pollId, "/results/publish")));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function publishPollResults(_x10) {
        return _publishPollResults.apply(this, arguments);
      }

      return publishPollResults;
    }()
  }, {
    key: "triggerPollResults",
    value: function () {
      var _triggerPollResults = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(pollId) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.axios.post("".concat(this.pollsEndpoint, "/").concat(pollId, "/results")));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function triggerPollResults(_x11) {
        return _triggerPollResults.apply(this, arguments);
      }

      return triggerPollResults;
    }()
  }]);

  return PollsService;
}();

var pollsService;

function initPollsService(store) {
  if (pollsService) {
    return pollsService;
  }

  if (!API_BASE_URL) {
    throw new Error("Missing env var - API_BASE_URL");
  }

  var axiosInstance = getAxiosInstance({
    baseURL: API_BASE_URL,
    responseType: "json",
    withCredentials: true
  }, store);
  pollsService = new polls_service_PollsService(axiosInstance);
  return pollsService;
}


// CONCATENATED MODULE: ./src/components/Polls/store/actions.ts




var _actions;








var fetchPollById = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, pollId) {
    var commit, poll;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return pollsService.getPollById(pollId);

          case 3:
            poll = _context.sent;
            commit("updatePoll", poll);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchPollById(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getUsersVotes = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context, pollId) {
    var userInfo, userVotes;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            userInfo = context.rootGetters[USER_NAMESPACE + "/userInfo"];

            if (!(!userInfo || !userInfo.id)) {
              _context2.next = 4;
              break;
            }

            throw new Error("Missing user id");

          case 4:
            _context2.next = 6;
            return pollsService.getPollVotesByPollIdAndUserId(pollId, userInfo.id);

          case 6:
            userVotes = _context2.sent;
            context.commit("setUserVotes", {
              pollId: pollId,
              userVotes: userVotes
            });
            _context2.next = 12;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function getUsersVotes(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

var endPoll = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context, poll) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            context.commit("updatePoll", _objectSpread2(_objectSpread2({}, poll), {}, {
              status: PollStatus.ENDED
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function endPoll(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var actions_startPoll = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(context, poll) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            context.commit("startPoll", poll);

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function startPoll(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

var vote = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(context, _ref6) {
    var pollId, pollVote, userInfo, userVotes;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            pollId = _ref6.pollId, pollVote = _ref6.pollVote;
            console.log("vote");
            _context5.prev = 2;
            userInfo = context.rootGetters[USER_NAMESPACE + "/userInfo"];
            console.log({
              userInfo: userInfo
            });

            if (!(!userInfo || !userInfo.id)) {
              _context5.next = 7;
              break;
            }

            throw new Error("Missing user Id");

          case 7:
            _context5.next = 9;
            return pollsService.saveVote({
              id: "",
              pollId: pollId,
              pollAnswer: pollVote,
              userId: userInfo.id,
              date: new Date().toISOString()
            });

          case 9:
            userVotes = _context5.sent;
            context.commit("setUserVotes", {
              pollId: pollId,
              userVotes: userVotes
            });
            _context5.next = 15;
            break;

          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](2);

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 13]]);
  }));

  return function vote(_x9, _x10) {
    return _ref7.apply(this, arguments);
  };
}();

var actions_deletePoll = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(context, poll) {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            context.commit("deletePoll", poll);

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function deletePoll(_x11, _x12) {
    return _ref8.apply(this, arguments);
  };
}();

var actions_updatePoll = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(context, poll) {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            console.log("update poll", {
              poll: poll
            });
            context.commit("updatePoll", poll);

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function updatePoll(_x13, _x14) {
    return _ref9.apply(this, arguments);
  };
}();

var store_actions_actions = (_actions = {}, _defineProperty(_actions, PollAction.GET_USERS_VOTES, getUsersVotes), _defineProperty(_actions, PollAction.VOTE, vote), _defineProperty(_actions, PollAction.UPDATE_POLL, actions_updatePoll), _defineProperty(_actions, PollAction.DELETE_POLL, actions_deletePoll), _defineProperty(_actions, PollAction.START_POLL, actions_startPoll), _defineProperty(_actions, PollAction.END_POLL, endPoll), _defineProperty(_actions, PollAction.GET_POLL, fetchPollById), _actions);
// CONCATENATED MODULE: ./src/components/Polls/store/getters.ts
var Polls_store_getters_getters = {
  polls: function polls(state) {
    return state.polls;
  },
  userVotes: function userVotes(state) {
    return state.pollVotes;
  }
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("4e82");

// CONCATENATED MODULE: ./src/components/Polls/store/mutations.ts









function sortPolls(polls) {
  var now = Date.now();
  return polls.sort(function (a, b) {
    var timeRemainingA = new Date(a.endDate).getTime() - now;
    var timeRemainingB = new Date(b.endDate).getTime() - now;
    return timeRemainingA === timeRemainingB ? 0 : timeRemainingA < timeRemainingB ? 1 : -1;
  });
}

var store_mutations_mutations = {
  setPolls: function setPolls(state, polls) {
    polls.map(function (poll) {
      return poll.moderatorShowResults = false;
    });
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "polls", sortPolls(polls));
  },
  startPoll: function startPoll(state, poll) {
    var polls = _toConsumableArray(state.polls);

    poll.moderatorShowResults = false;

    if (!polls.some(function (p) {
      return p.id === poll.id;
    })) {
      polls.push(poll);
    } else {
      polls = polls.map(function (p) {
        return p.id === poll.id ? poll : p;
      });
    }

    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "polls", sortPolls(polls));
  },
  deletePoll: function deletePoll(state, deletedPoll) {
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "polls", state.polls.filter(function (poll) {
      return poll.id !== deletedPoll.id;
    }));
  },
  updatePoll: function updatePoll(state, updatedPoll) {
    var existingPollIndex = state.polls.findIndex(function (poll) {
      return poll.id === updatedPoll.id;
    });

    if (existingPollIndex > -1) {
      updatedPoll.moderatorShowResults = state.polls[existingPollIndex].moderatorShowResults;
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state.polls, existingPollIndex, updatedPoll);
    } else {
      updatedPoll.moderatorShowResults = false;
      state.polls = sortPolls([].concat(_toConsumableArray(state.polls), [updatedPoll]));
    }
  },
  setUserVotes: function setUserVotes(state, _ref) {
    var pollId = _ref.pollId,
        userVotes = _ref.userVotes;
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state.pollVotes, pollId, userVotes);
  },
  togglePollResults: function togglePollResults(state, pollId) {
    state.polls = state.polls.map(function (poll) {
      if (poll.id === pollId) {
        poll.moderatorShowResults = !poll.moderatorShowResults;
      }

      return poll;
    });
  }
};
// CONCATENATED MODULE: ./src/components/Polls/store/index.ts



var Polls_store_state = {
  polls: [],
  pollVotes: {}
};
var POLL_NAMESPACE = "poll";
var Polls_store_namespaced = true;
var store_poll = {
  namespaced: Polls_store_namespaced,
  state: Polls_store_state,
  getters: Polls_store_getters_getters,
  actions: store_actions_actions,
  mutations: store_mutations_mutations
};
// CONCATENATED MODULE: ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function esm_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function esm_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return esm_awaiter(this, void 0, void 0, function () {
                    var _a;
                    return esm_generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return esm_awaiter(this, void 0, void 0, function () {
                    var _a;
                    return esm_generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var esm_config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!esm_config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return esm_awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return esm_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return esm_awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return esm_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("6062");

// CONCATENATED MODULE: ./src/util/deepMerge.ts













// istanbul ignore next
var deepMerge_isObject = function isObject(obj) {
  if (_typeof(obj) === "object" && obj !== null) {
    if (typeof Object.getPrototypeOf === "function") {
      var prototype = Object.getPrototypeOf(obj);
      return prototype === Object.prototype || prototype === null;
    }

    return Object.prototype.toString.call(obj) === "[object Object]";
  }

  return false;
};

var merge = function merge() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return objects.reduce(function (result, current) {
    Object.keys(current).forEach(function (key) {
      if (Array.isArray(result[key]) && Array.isArray(current[key])) {
        result[key] = merge.options.mergeArrays ? Array.from(new Set(result[key].concat(current[key]))) : current[key];
      } else if (deepMerge_isObject(result[key]) && deepMerge_isObject(current[key])) {
        result[key] = merge(result[key], current[key]);
      } else {
        result[key] = current[key];
      }
    });
    return result;
  }, {});
};

var defaultOptions = {
  mergeArrays: true
};
merge.options = defaultOptions;

merge.withOptions = function (options) {
  merge.options = _objectSpread2({
    mergeArrays: true
  }, options);

  for (var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    objects[_key2 - 1] = arguments[_key2];
  }

  var result = merge.apply(void 0, objects);
  merge.options = defaultOptions;
  return result;
};

/* harmony default export */ var deepMerge = (merge);
// CONCATENATED MODULE: ./src/config/store.ts














var store_ConfigModule = /*#__PURE__*/function (_VuexModule) {
  _inherits(ConfigModule, _VuexModule);

  var _super = _createSuper(ConfigModule);

  function ConfigModule() {
    var _this$enabledFeatures;

    var _this;

    _classCallCheck(this, ConfigModule);

    _this = _super.apply(this, arguments);
    _this.appConfig = null;
    _this.userColors = null;
    _this.generalSettings = null;
    _this.roleBadges = {};
    _this.enabledFeatures = (_this$enabledFeatures = {}, _defineProperty(_this$enabledFeatures, Feature.FOOTER, true), _defineProperty(_this$enabledFeatures, Feature.USER_LIST, true), _defineProperty(_this$enabledFeatures, Feature.CHANNEL_LIST, true), _defineProperty(_this$enabledFeatures, Feature.NAME_COLORS, true), _defineProperty(_this$enabledFeatures, Feature.THREADS, true), _defineProperty(_this$enabledFeatures, Feature.REPORTS, true), _defineProperty(_this$enabledFeatures, Feature.HISTORY, true), _defineProperty(_this$enabledFeatures, Feature.IGNORE, true), _defineProperty(_this$enabledFeatures, Feature.SETTINGS_MENU, true), _defineProperty(_this$enabledFeatures, Feature.COMPACT_MESSAGES, false), _defineProperty(_this$enabledFeatures, Feature.LOYALTY, false), _defineProperty(_this$enabledFeatures, Feature.VIDEO_CONFERENCING, false), _this$enabledFeatures);
    _this.generalSettingsSpecificity = 0;
    _this.styleConfig = {
      padding: {
        textInput: {
          left: 8,
          right: 8
        },
        messages: {
          left: 16,
          right: 0
        }
      },
      borderRadius: {
        textInput: 6,
        buttons: 6
      },
      visible: {
        textInputEmojiButton: true
      },
      alternativeLayout: {
        textInputSendButtonAlign: false
      }
    };
    _this.mediaUploadBaseUrl = UPMAN_MEDIA_BASE_URL;
    return _this;
  }

  _createClass(ConfigModule, [{
    key: "fetchSettings",
    value: function fetchSettings() {
      var _this$appConfig,
          _this2 = this;

      return apiChat.fetchSettings(((_this$appConfig = this.appConfig) === null || _this$appConfig === void 0 ? void 0 : _this$appConfig.broadcastId) || "").then(function (config) {
        _this2.context.commit("setGeneralSettings", {
          config: config,
          specificity: SettingsLevel.BROADCAST
        });
      }).catch(function (err) {
        return console.error(err);
      });
    }
  }, {
    key: "setConfig",
    value: function setConfig(payload) {
      var _this3 = this;

      if (payload.appConfig) {
        this.appConfig = payload.appConfig;
      }

      if (payload.enabledFeatures) {
        this.enabledFeatures = {};
        payload.enabledFeatures.forEach(function (f) {
          return _this3.enabledFeatures[f] = true;
        });
      }

      if (payload.disabledFeatures) {
        payload.disabledFeatures.forEach(function (c) {
          _this3.enabledFeatures[c] = false;
        });
      }

      if (payload.userColors) {
        this.userColors = payload.userColors;
      }

      if (payload.style) {
        this.styleConfig = this.styleConfig ? deepMerge(this.styleConfig, payload.style) : payload.style;
      }

      if (payload.roleBadges) {
        this.roleBadges = payload.roleBadges;
      }

      if (payload.mediaUploadBaseUrl) {
        this.mediaUploadBaseUrl = payload.mediaUploadBaseUrl;
      }
    }
  }, {
    key: "setGeneralSettings",
    value: function setGeneralSettings(payload) {
      if (payload.specificity >= this.generalSettingsSpecificity) {
        this.generalSettings = payload.config;
        this.generalSettingsSpecificity = payload.specificity;
      }
    }
  }]);

  return ConfigModule;
}(VuexModule);

__decorate([Action], store_ConfigModule.prototype, "fetchSettings", null);

__decorate([Mutation], store_ConfigModule.prototype, "setConfig", null);

__decorate([Mutation], store_ConfigModule.prototype, "setGeneralSettings", null);

store_ConfigModule = __decorate([Module({
  namespaced: true,
  name: CONFIG_NAMESPACE,
  stateFactory: true
})], store_ConfigModule);

// CONCATENATED MODULE: ./src/store/actions.ts



































function toReactionSetBetter(reactions, userId) {
  var res = {};

  for (var icon in reactions) {
    if (reactions[icon].length <= 0) continue;
    res[icon] = {
      count: reactions[icon].length,
      aliases: [reactions[icon][0].name],
      liked: reactions[icon].some(function (r) {
        return r.fromUser.id === userId;
      }),
      reactions: reactions[icon].map(function (rpl) {
        return _objectSpread2(_objectSpread2({}, rpl), {}, {
          timestampCreated: Date.parse(rpl.timestampCreated),
          aliases: [rpl.name]
        });
      })
    };
  }

  return res;
}

function getAppConfig(store) {
  var _getModule = getModule(store_ConfigModule, store),
      appConfig = _getModule.appConfig;

  if (!appConfig) throw "no appconfig!";
  return appConfig;
}
var src_store_actions_actions = {
  startListening: function startListening(context, chan) {
    if (chan.subService) {
      context.commit("startService", chan);
      return;
    }

    var _getAppConfig = getAppConfig(this),
        broadcastId = _getAppConfig.broadcastId,
        tenantId = _getAppConfig.tenantId,
        nchanUrl = _getAppConfig.nchanUrl;

    var user = context.rootGetters["".concat(USER_NAMESPACE, "/user")];
    if (!chan || !broadcastId || !tenantId || !nchanUrl) return;

    var message = function message(m) {
      return context.dispatch("processMessage", {
        message: m,
        chan: chan
      });
    };

    var connect = function connect() {
      console.log("Subscribing to ".concat(chan.name, "..."));
      apiChat.setActiveUser(chan.id || chan.name).then(function (dto) {
        context.commit("addUserToChannel", {
          user: dto.userInfo,
          chan: chan
        });
      }).catch(function (e) {
        return console.error(e);
      });
    };

    var disconnect = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("Unsubscribing from ".concat(chan.name, "..."));

                if (chan.id) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                apiChat.unsetActiveUser(chan.id).then(function () {
                  return context.commit("deleteUserFromChannel", {
                    userId: user.id,
                    chan: chan
                  });
                }).catch(function (e) {
                  return console.error(e);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function disconnect() {
        return _ref.apply(this, arguments);
      };
    }();

    var nchanService = new nchan_service_NchanService(nchanUrl, "".concat(tenantId, ":").concat(broadcastId, ":").concat(chan.id), message, connect, disconnect);
    context.commit("setServiceChannel", {
      service: nchanService,
      channel: chan
    });
  },
  stopListening: function stopListening(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;
    if (state.channelActive) commit("stopService", state.channelActive);
  },
  stopListeningToChannel: function stopListeningToChannel(_ref3, chan) {
    var commit = _ref3.commit;
    commit("stopSubscriber", chan);
  },
  stopListeningAll: function stopListeningAll(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;
    state.channels.forEach(function (chan) {
      if (chan.subService) commit("stopService", chan);
    });
  },
  startListeningBroadcast: function startListeningBroadcast(_ref5) {
    var _this = this;

    var commit = _ref5.commit,
        rootGetters = _ref5.rootGetters,
        dispatch = _ref5.dispatch,
        state = _ref5.state;

    if (state.broadcast.subService) {
      commit("startService", state.broadcast);
      return;
    }

    var _getAppConfig2 = getAppConfig(this),
        broadcastId = _getAppConfig2.broadcastId,
        tenantId = _getAppConfig2.tenantId,
        nchanUrl = _getAppConfig2.nchanUrl;

    if (!broadcastId || !tenantId || !nchanUrl) return;

    var message = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(m) {
        var dto, payload, b, ban, _b, _payload, activeChannel, _payload2, _payload3;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("\n# Incoming message on broadcast");
                _context2.prev = 1;
                dto = JSON.parse(m);
                if (typeof dto.payload === "string") dto.payload = JSON.parse(dto.payload);
                console.log(dto); // === Message parsing switch ===

                _context2.t0 = dto.type;
                _context2.next = _context2.t0 === EventType.CHANNEL_ADDED ? 8 : _context2.t0 === EventType.CHANNEL_DELETED ? 11 : _context2.t0 === EventType.USER_BANNED ? 13 : _context2.t0 === EventType.USER_UNBANNED ? 17 : _context2.t0 === EventType.RULES_CHANGED ? 20 : _context2.t0 === EventType.CHAT_SETTINGS_CHANGED ? 22 : _context2.t0 === EventType.GOODBYE ? 24 : _context2.t0 === EventType.POLL_VOTED ? 26 : _context2.t0 === EventType.POLL_STARTED ? 28 : _context2.t0 === EventType.POLL_ENDED ? 36 : _context2.t0 === EventType.POLL_DELETED ? 43 : 47;
                break;

              case 8:
                payload = dto.payload;
                commit("addChannel", {
                  id: payload.id,
                  name: payload.channelName,
                  private: false,
                  messages: [],
                  users: [],
                  banned: [],
                  unread: 0,
                  unreadMentions: 0
                });
                return _context2.abrupt("break", 48);

              case 11:
                commit("deleteChannel", dto.channelId);
                return _context2.abrupt("break", 48);

              case 13:
                b = dto.payload;
                ban = _objectSpread2(_objectSpread2({}, b), {}, {
                  bannedUntil: Date.parse(b.bannedUntil),
                  timeBanned: Date.parse(b.timeBanned)
                });
                commit("ban", ban);
                return _context2.abrupt("break", 48);

              case 17:
                _b = dto.payload;
                commit("unban", _b);
                return _context2.abrupt("break", 48);

              case 20:
                // should be possible to change settings per channel
                commit("setRules", dto.payload.chatRules);
                return _context2.abrupt("break", 48);

              case 22:
                // should be possible to change settings per channel
                getModule(store_ConfigModule, _this).setGeneralSettings({
                  config: dto.payload,
                  specificity: SettingsLevel.BROADCAST
                });
                return _context2.abrupt("break", 48);

              case 24:
                // prep shutdown
                console.log("Goodbye");
                return _context2.abrupt("break", 48);

              case 26:
                if (handlePollEvents) {
                  dispatch("".concat(POLL_NAMESPACE, "/").concat(PollNchanEvents.POLL_VOTED), dto.payload, {
                    root: true
                  });
                }

                return _context2.abrupt("break", 48);

              case 28:
                if (!handlePollEvents) {
                  _context2.next = 31;
                  break;
                }

                _context2.next = 31;
                return dispatch("".concat(POLL_NAMESPACE, "/").concat(PollNchanEvents.POLL_STARTED), dto.payload, {
                  root: true
                });

              case 31:
                // Mock Poll chat message
                _payload = dto.payload;

                if (!(_payload.location === PollLocation.DEFAULT)) {
                  _context2.next = 34;
                  break;
                }

                return _context2.abrupt("break", 48);

              case 34:
                commit("addMessage", {
                  id: _payload.id + "_start",
                  timestampCreated: Date.now(),
                  deleted: false,
                  fromUser: null,
                  type: MessageType.POLL,
                  submessages: [],
                  reactions: {},
                  data: {
                    entityId: _payload.id,
                    media: null,
                    title: _payload.title,
                    description: _payload.question,
                    endDate: Date.now() + 1000 * 60 * 60
                  }
                });
                return _context2.abrupt("break", 48);

              case 36:
                if (handlePollEvents) {
                  dispatch("".concat(POLL_NAMESPACE, "/").concat(PollNchanEvents.POLL_ENDED), dto.payload, {
                    root: true
                  });
                } // Mock Poll chat message


                activeChannel = rootGetters["".concat(store_CHAT_NAMESPACE, "/getChannelActive")];
                _payload2 = dto.payload;

                if (!(_payload2.location === PollLocation.DEFAULT || activeChannel.messages.slice(-5).some(function (message) {
                  var _message$data;

                  return ((_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.entityId) === _payload2.id;
                }))) {
                  _context2.next = 41;
                  break;
                }

                return _context2.abrupt("break", 48);

              case 41:
                commit("addMessage", {
                  id: _payload2.id + "_end",
                  timestampCreated: Date.now(),
                  deleted: false,
                  fromUser: null,
                  type: MessageType.POLL,
                  submessages: [],
                  reactions: {},
                  data: {
                    entityId: _payload2.id,
                    media: null,
                    title: _payload2.title,
                    description: _payload2.question,
                    endDate: Date.now() + 1000 * 60 * 60
                  }
                });
                return _context2.abrupt("break", 48);

              case 43:
                _payload3 = dto.payload;
                commit("deletePollMessage", _payload3.id);

                if (handlePollEvents) {
                  dispatch("".concat(POLL_NAMESPACE, "/").concat(PollNchanEvents.POLL_DELETED), dto.payload, {
                    root: true
                  });
                }

                return _context2.abrupt("break", 48);

              case 47:
                console.warn("Invalid message type.");

              case 48:
                _context2.next = 53;
                break;

              case 50:
                _context2.prev = 50;
                _context2.t1 = _context2["catch"](1);
                console.log(_context2.t1.message);

              case 53:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 50]]);
      }));

      return function message(_x) {
        return _ref6.apply(this, arguments);
      };
    }();

    var connect = function connect() {
      var _state$broadcast$name;

      console.log("Subscribing to broadcast ".concat((_state$broadcast$name = state.broadcast.name) !== null && _state$broadcast$name !== void 0 ? _state$broadcast$name : state.broadcast.id, "..."));
    };

    var disconnect = function disconnect() {
      var _state$broadcast$name2;

      console.log("Unsubscribing from broadcast ".concat((_state$broadcast$name2 = state.broadcast.name) !== null && _state$broadcast$name2 !== void 0 ? _state$broadcast$name2 : state.broadcast.id, "..."));
    };

    var nchanService = new nchan_service_NchanService(nchanUrl, "".concat(tenantId, ":").concat(broadcastId), message, connect, disconnect);
    commit("setServiceBroadcast", nchanService);
  },
  startListeningTenant: function startListeningTenant(_ref7) {
    var _this2 = this;

    var commit = _ref7.commit,
        state = _ref7.state;

    if (state.tenant.subService) {
      commit("startService", state.tenant);
      return;
    }

    var _getAppConfig3 = getAppConfig(this),
        tenantId = _getAppConfig3.tenantId,
        nchanUrl = _getAppConfig3.nchanUrl;

    var message = function message(m) {
      console.log("\n# Incoming message on tenant");

      try {
        var dto = JSON.parse(m);
        if (typeof dto.payload === "string") dto.payload = JSON.parse(dto.payload);
        console.log(dto); // === Message parsing switch ===

        switch (dto.type) {
          case EventType.CHAT_SETTINGS_CHANGED:
            {
              // should be possible to change settings per channel
              getModule(store_ConfigModule, _this2).setGeneralSettings({
                config: dto.payload,
                specificity: SettingsLevel.TENANT
              });
              break;
            }

          case EventType.USER_JOINED:
            {
              break;
            }

          case EventType.GOODBYE:
            {
              // prep shutdown
              console.log("Goodbye");
              break;
            }

          default:
            {
              console.warn("Invalid message type.");
            }
        }
      } catch (e) {
        console.log(e.message);
      }
    };

    var connect = function connect() {
      console.log("Subscribing to tenant ".concat(state.tenant.id, "..."));
    };

    var disconnect = function disconnect() {
      console.log("Unsubscribing from tenant ".concat(state.tenant.id, "..."));
    };

    var nchanService = new nchan_service_NchanService(nchanUrl, "".concat(tenantId), message, connect, disconnect);
    commit("setServiceTenant", nchanService);
  },
  processMessage: function processMessage(_ref8, _ref9) {
    var commit = _ref8.commit,
        rootGetters = _ref8.rootGetters,
        dispatch = _ref8.dispatch;
    var message = _ref9.message,
        chan = _ref9.chan;

    var _getAppConfig4 = getAppConfig(this),
        broadcastId = _getAppConfig4.broadcastId,
        tenantId = _getAppConfig4.tenantId,
        nchanUrl = _getAppConfig4.nchanUrl;

    var user = rootGetters["".concat(USER_NAMESPACE, "/user")];
    if (!chan || !broadcastId || !tenantId || !nchanUrl) return;
    console.log("# Incoming message");

    try {
      var dto = JSON.parse(message);
      if (typeof dto.payload === "string") dto.payload = JSON.parse(dto.payload);
      console.log(dto); // === Message parsing switch ===

      switch (dto.type) {
        case ActionType.ADD_MESSAGE:
          {
            if ("type" in dto.payload && dto.payload.type === MessageType.TEXT) {
              var _payload$mentions;

              var payload = dto.payload;
              if (!payload.timestampCreated || chan.messages.some(function (i) {
                return i.id === payload.id;
              })) break;

              var msg = _objectSpread2(_objectSpread2({}, payload), {}, {
                deleted: false,
                restorable: true,
                submessages: [],
                reactions: {}
              });

              var mentioned = (_payload$mentions = payload.mentions) === null || _payload$mentions === void 0 ? void 0 : _payload$mentions.some(function (m) {
                return m.payload.id === user.id;
              });
              commit("addMessageToChannel", {
                message: msg,
                chan: chan,
                mentioned: mentioned
              });
              commit("setLastRead");
            }

            break;
          }

        case ActionType.DELETE_MESSAGE:
          {
            var target = chan.messages.find(function (i) {
              return i.id === dto.messageId;
            });

            if (target) {
              console.log("".concat(target.id, " will be deleted!"));
              commit("deleteMessage", {
                restorable: dto.payload.restorable,
                target: target
              });
            }

            break;
          }

        case ActionType.RESTORE_MESSAGE:
          {
            var _target = chan.messages.find(function (i) {
              return i.id === dto.messageId;
            });

            if (_target) {
              console.log("".concat(_target.id, " will be restored!"));
              commit("restoreMessage", _target);
            }

            break;
          }

        case ActionType.ADD_SUB_MESSAGE:
          {
            if ("type" in dto.payload && dto.payload.type === MessageType.TEXT) {
              var _payload4 = dto.payload;
              var parent = chan.messages.find(function (i) {
                return i.id === dto.messageId;
              });
              if (!_payload4.timestampCreated) break;
              if (!parent) throw Error("Parent of submessage not found!");

              var _msg = _objectSpread2(_objectSpread2({}, _payload4), {}, {
                deleted: false,
                restorable: true,
                parent: parent,
                submessages: [],
                reactions: {}
              });

              commit("addChild", {
                message: _msg,
                parent: parent
              });
            }

            break;
          }

        case ActionType.DELETE_SUB_MESSAGE:
          {
            // //! might change backend
            // const payload = dto.payload as TextMessagePayload;
            // const parent = chan.messages.find(i => i.id === dto.messageId);
            // if (!payload.timestampCreated) break;
            // const msg: TextMessage = {
            //   timestampCreated: Date.parse(payload.timestampCreated),
            //   timestampEdited: payload.timestampEdited
            //     ? Date.parse(payload.timestampEdited)
            //     : undefined,
            //   timestampDeleted: payload.timestampDeleted
            //     ? Date.parse(payload.timestampDeleted)
            //     : undefined,
            //   deleted: false,
            //   fromUser: payload.fromUser,
            //   type: payload.type,
            //   parent: parent,
            //   submessages: [],
            //   reactions: {},
            //   content: payload.content
            // };
            // if (parent)
            //   commit("addChild", { message: msg, parent: parent });
            break;
          }

        case ActionType.ADD_REACTION:
          {
            var _parent$reactions$rea, _parent$reactions$rea2;

            var pl = dto.payload;
            var author = chan.users.find(function (u) {
              return u.id === pl.fromUser.id;
            });

            var reaction = _objectSpread2(_objectSpread2({}, pl), {}, {
              fromUser: author !== null && author !== void 0 ? author : pl.fromUser,
              aliases: [pl.name],
              timestampCreated: Date.parse(pl.timestampCreated)
            });

            var byMyself = reaction.fromUser.id === user.id;

            var _parent = chan.messages.find(function (i) {
              return i.id === dto.messageId;
            });

            if (!_parent) throw Error("Target of reaction not found!"); // test whether the fromUser already reacted this way

            if ((_parent$reactions$rea = _parent.reactions[reaction.icon]) !== null && _parent$reactions$rea !== void 0 && (_parent$reactions$rea2 = _parent$reactions$rea.reactions) !== null && _parent$reactions$rea2 !== void 0 && _parent$reactions$rea2.some(function (r) {
              return r.fromUser.id === reaction.fromUser.id;
            })) break;
            commit("addReaction", {
              reaction: reaction,
              parent: _parent,
              byMyself: byMyself
            });
            break;
          }

        case ActionType.DELETE_REACTION:
          {
            var _parent2$reactions$_p, _parent2$reactions$_p2;

            var _payload5 = dto.payload;

            var _byMyself = _payload5.fromUser === user.id;

            var _parent2 = chan.messages.find(function (i) {
              return i.id === dto.messageId;
            });

            if (!_parent2) throw Error("Target of reaction not found!");
            if (!_parent2.reactions[_payload5.icon]) break;
            var i = (_parent2$reactions$_p = _parent2.reactions[_payload5.icon]) === null || _parent2$reactions$_p === void 0 ? void 0 : (_parent2$reactions$_p2 = _parent2$reactions$_p.reactions) === null || _parent2$reactions$_p2 === void 0 ? void 0 : _parent2$reactions$_p2.findIndex(function (r) {
              return r.fromUser.id === _payload5.fromUser;
            });

            if (i >= 0) {
              commit("deleteReaction", {
                parent: _parent2,
                icon: _payload5.icon,
                i: i,
                byMyself: _byMyself
              });
            }

            break;
          }

        case EventType.CHANNEL_ADDED:
          {
            var _payload6 = dto.payload;
            commit("addChannel", {
              id: _payload6.id,
              name: _payload6.channelName,
              private: false,
              messages: [],
              users: [],
              banned: [],
              unread: 0,
              unreadMentions: 0
            });
            break;
          }

        case EventType.CHANNEL_DELETED:
          {
            commit("deleteChannel", dto.channelId);
            break;
          }

        case EventType.CHANNEL_RENAMED:
          {
            console.log("tbd -- channel_rename");
            break;
          }

        case EventType.CHANNEL_PRIVATIZED:
          {
            console.log("tbd -- channel_privatize");
            break;
          }

        case EventType.USER_JOINED:
          {
            var userInfo = dto.user;
            commit("addUserToChannel", {
              chan: chan,
              user: userInfo
            });
            break;
          }

        case EventType.USER_LEFT:
          {
            commit("deleteUserFromChannel", {
              chan: chan,
              userId: dto.userId
            });
            break;
          }

        case EventType.USER_EDITED:
          {
            var _userInfo = dto.payload;

            if (_userInfo.id === user.id) {
              dispatch("".concat(USER_NAMESPACE, "/fetch"), null, {
                root: true
              });
            }

            commit("editUser", {
              chan: chan,
              user: _userInfo
            });
            break;
          }

        case EventType.USER_BANNED:
          {
            var b = dto.payload;

            var ban = _objectSpread2(_objectSpread2({}, b), {}, {
              bannedUntil: Date.parse(b.bannedUntil),
              timeBanned: Date.parse(b.timeBanned)
            });

            commit("ban", ban);
            break;
          }

        case EventType.USER_UNBANNED:
          {
            var _b2 = dto.payload;
            commit("unban", _b2);
            break;
          }

        case EventType.MESSAGE_PINNED:
          {
            break;
          }

        case EventType.PIN_ADDED:
          {
            var _b3 = dto.payload;
            commit("setPinnedMessages", _b3);
            break;
          }

        case EventType.PIN_REMOVED:
          {
            var _b4 = dto.pinId;
            commit("removePinnedMessage", _b4);
            break;
          }

        case EventType.RULES_CHANGED:
          {
            // should be possible to change settings per channel
            commit("setRules", dto.payload.chatRules);
            break;
          }

        case EventType.CHAT_SETTINGS_CHANGED:
          {
            // should be possible to change settings per channel
            getModule(store_ConfigModule, this).setGeneralSettings({
              config: dto.payload,
              specificity: SettingsLevel.CHANNEL
            });
            break;
          }

        case EventType.GOODBYE:
          {
            // prep shutdown
            console.log("Goodbye");
            break;
          }

        default:
          {
            console.warn("Invalid message type.");
          }
      }
    } catch (e) {
      console.log(e.message, e);
    }
  },
  sendMessage: function sendMessage(_ref10, _ref11) {
    var rootGetters = _ref10.rootGetters,
        state = _ref10.state;
    var content = _ref11.content,
        type = _ref11.type,
        parent = _ref11.parent,
        channel = _ref11.channel;
    var user = rootGetters["".concat(USER_NAMESPACE, "/user")];

    var _getAppConfig5 = getAppConfig(this),
        tenantId = _getAppConfig5.tenantId,
        broadcastId = _getAppConfig5.broadcastId;

    var pl = {
      channel: channel.name,
      type: type
    };

    switch (type) {
      case MessageType.TEXT:
        pl.content = content.replaceAll(/\B@\S+/g, function (m) {
          var _state$channelActive;

          // state.channelActive?.users.some( (u: UserInfo) => u.displayName === m.slice(1))
          var u = (_state$channelActive = state.channelActive) === null || _state$channelActive === void 0 ? void 0 : _state$channelActive.users.find(function (u) {
            return u.displayName === m.slice(1);
          });
          return u ? "<@".concat(u.id, "|").concat("de6001ea-f477-41f8-8d66-c0d2d2ccc3bd", "|").concat(user.id, "> ") : m;
        });
        break;

      default:
        console.warn("Invalid message type!");
    }

    var action = {
      type: parent ? ActionType.ADD_SUB_MESSAGE : ActionType.ADD_MESSAGE,
      messageId: parent ? parent.id : null,
      payload: pl
    }; // if (parent) console.log(`...answering to ${parent.id}`);
    // console.log(pl);

    return apiChat.sendToNchan(action, channel, broadcastId, tenantId);
  },
  deleteMessage: function deleteMessage(_ref12, message) {
    var state = _ref12.state;
    if (!message.id) return;
    var action = {
      type: ActionType.DELETE_MESSAGE,
      messageId: message.id
    };

    var _getAppConfig6 = getAppConfig(this),
        broadcastId = _getAppConfig6.broadcastId,
        tenantId = _getAppConfig6.tenantId;

    if (state.channelActive) return apiChat.sendToNchan(action, state.channelActive, broadcastId, tenantId);
  },
  restoreMessage: function restoreMessage(_ref13, message) {
    var state = _ref13.state;
    if (!message.id) return;
    var action = {
      type: ActionType.RESTORE_MESSAGE,
      messageId: message.id
    };

    var _getAppConfig7 = getAppConfig(this),
        broadcastId = _getAppConfig7.broadcastId,
        tenantId = _getAppConfig7.tenantId;

    if (state.channelActive) return apiChat.sendToNchan(action, state.channelActive, broadcastId, tenantId);
  },
  fetchChannels: function fetchChannels(_ref14) {
    var commit = _ref14.commit,
        state = _ref14.state,
        dispatch = _ref14.dispatch;

    var _getAppConfig8 = getAppConfig(this),
        broadcastId = _getAppConfig8.broadcastId;

    return apiChat.fetchChannels(broadcastId).then(function (channels) {
      commit("addChannels", channels.map(function (c) {
        return {
          id: c.id,
          name: c.channelName,
          private: false,
          unread: 0,
          unreadMentions: 0,
          messages: [],
          users: [],
          banned: []
        };
      }));

      if (!state.channelActive && state.channels) {
        dispatch("setChannelActive", state.channels[0]);
      }

      if (state.channelActive && state.channelActive.subService) {
        commit("startSubscriber", state.channelActive);
      }
    }).catch(function (err) {
      return console.error(err);
    });
  },
  setChannelActive: function setChannelActive(_ref15, chan) {
    var commit = _ref15.commit,
        state = _ref15.state,
        dispatch = _ref15.dispatch;
    return new Promise(function (resolve) {
      commit("setIsPinnedMessage", false);
      commit("setisFetched", false);

      if (chan) {
        dispatch("getPinnedMessages", chan.id);

        if (state.channelActive) {
          commit("setChannelPrevious", state.channelActive);
          commit("setLastRead");
        }

        dispatch("fetchChannelUsers", chan);
        commit("setChannelActive", chan); // if (process.env.VUE_APP_MOCK_DATA === "true") {
        //   for (let i = 0; i < 20; i++) {
        //     const uc = faker.helpers.userCard();
        //     const u: User = {
        //       id: faker.datatype.uuid(),
        //       username: uc.username,
        //       displayName: uc.username,
        //       email: uc.email,
        //       roles: [Role.ROLE_USER],
        //       blockedUsers: []
        //     };
        //     commit("addUser", u);
        //   }
        // }

        if (!chan.subService) dispatch("startListening", chan);
        resolve();
      }
    });
  },
  fetchHistory: function fetchHistory(_ref16) {
    var state = _ref16.state,
        commit = _ref16.commit,
        rootGetters = _ref16.rootGetters;
    var user = rootGetters["".concat(USER_NAMESPACE, "/user")];
    var settings = getModule(store_ConfigModule, this).generalSettings; // rootGetters[`${CONFIG_NAMESPACE}/generalSettings`];

    var messageHistoryCount = settings ? settings.messageHistoryCount : 0;
    return Promise.all(state.channels.map(function (chan) {
      return !chan.id ? Promise.reject() : apiChat.fetchHistory(chan.id, messageHistoryCount).then(function (messages) {
        commit("clearChannel", chan);
        commit("addMessagesToChannelNoUnread", {
          messages: messages.reverse().map(function (message) {
            var _message$submessages, _message$reactions;

            return _objectSpread2(_objectSpread2({}, message), {}, {
              fromUser: message.fromUser,
              submessages: (_message$submessages = message.submessages) !== null && _message$submessages !== void 0 ? _message$submessages : [],
              reactions: toReactionSetBetter((_message$reactions = message.reactions) !== null && _message$reactions !== void 0 ? _message$reactions : {}, user.id)
            });
          }),
          chan: chan
        });
      });
    }));
  },
  fetchBans: function fetchBans(_ref17) {
    var state = _ref17.state,
        commit = _ref17.commit;
    var p1 = apiChat.fetchBansBroadcast(state.broadcast.id).then(function (bans) {
      bans.forEach(function (ban) {
        commit("ban", ban);
      });
    });
    var channelIds = state.channels.flatMap(function (c) {
      return c.id ? [c.id] : [];
    });
    var p2 = apiChat.fetchBansChannels(channelIds).then(function (bans) {
      bans.forEach(function (ban) {
        commit("ban", ban);
      });
    });
    return Promise.allSettled([p1, p2]);
  },
  fetchBroadcast: function fetchBroadcast(_ref18) {
    var _this3 = this;

    var commit = _ref18.commit,
        state = _ref18.state,
        dispatch = _ref18.dispatch;
    return new Promise(function (resolve) {
      if (state.broadcast.initialized) resolve();

      var _getAppConfig9 = getAppConfig(_this3),
          broadcastId = _getAppConfig9.broadcastId; // console.log(res.data);


      if (!state.broadcast.subService) dispatch("startListeningBroadcast", state.broadcast);else commit("startService", state.broadcast);
      commit("setupBroadcast", {
        broadcastId: broadcastId
      });
      resolve();
    });
  },
  setupTenant: function setupTenant(_ref19) {
    var _this4 = this;

    var commit = _ref19.commit,
        state = _ref19.state,
        dispatch = _ref19.dispatch;
    return new Promise(function (resolve) {
      if (state.tenant.initialized) resolve();

      var _getAppConfig10 = getAppConfig(_this4),
          tenantId = _getAppConfig10.tenantId;

      if (!state.tenant.subService) dispatch("startListeningTenant", state.tenant);else commit("startService", state.tenant);
      commit("setupTenant", {
        tenantId: tenantId
      });
      resolve();
    });
  },
  getPinnedMessages: function getPinnedMessages(_ref20, channelId) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, response;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref20.commit;
              _context3.next = 3;
              return apiChat.getPins(channelId);

            case 3:
              response = _context3.sent;
              response.forEach(function (pin) {
                commit("setPinnedMessages", pin);
              });
              commit("setisFetched", true);

              if (response.length !== 0) {
                commit("setIsPinnedMessage", true);
              }

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  pinMessage: function pinMessage(_ref21, _ref22) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var state, message, durationMs, i;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = _ref21.state;
              message = _ref22.message, durationMs = _ref22.durationMs;
              i = state.pinnedMessages.findIndex(function (p) {
                return p.pinnedMessage === message.content;
              });

              if (!(i === -1 && message.id)) {
                _context4.next = 6;
                break;
              }

              _context4.next = 6;
              return apiChat.pin(message.id, durationMs);

            case 6:
              return _context4.abrupt("return", i);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  removePinnedMessage: function removePinnedMessage(_ref23, messageId) {
    var commit = _ref23.commit;
    commit("removePinnedMessage", messageId);
  },
  deletePinnedMessage: function deletePinnedMessage(_, data) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return apiChat.unpin(data.messageId);

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  fetchChannelUsers: function fetchChannelUsers(_ref24, chan) {
    var commit = _ref24.commit;
    return apiChat.fetchChannelUsers(chan.id || chan.name).then(function (activeUsers) {
      activeUsers.forEach(function (activeUser) {
        commit("addUserToChannel", {
          chan: chan,
          user: {
            avatar: {},
            id: activeUser.userId,
            displayName: activeUser.displayName,
            roles: []
          }
        });
      });
    });
  },
  banUser: function banUser(_, _ref25) {
    var _message$content;

    var message = _ref25.message,
        time = _ref25.time,
        soft = _ref25.soft;

    var _getAppConfig11 = getAppConfig(this),
        broadcastId = _getAppConfig11.broadcastId;

    console.log("".concat(soft ? "Muting" : "Banning", " user ").concat(message.fromUser.displayName, " (").concat(message.fromUser.id, ")..."));
    var b = {
      bannedMessage: (_message$content = message.content) !== null && _message$content !== void 0 ? _message$content : "",
      banDurationSeconds: time,
      userId: message.fromUser.id,
      messageRouterPayload: {
        tenantWide: false,
        channelIds: [],
        broadcastIds: [broadcastId]
      },
      softBan: soft
    };
    return apiChat.ban(b);
  },
  unbanUser: function unbanUser(_ref26, user) {
    var state = _ref26.state,
        commit = _ref26.commit;
    var ban = state.bans.find(function (b) {
      return b.userInfo.id === user.id;
    });
    if (!ban) return;
    console.log("".concat(ban.softBan ? "Muting" : "Banning", " user ").concat(user.displayName, " (").concat(user.id, ")..."));
    return apiChat.unban(ban.id).then(function () {
      commit("unban", [ban]);
    }).catch(function (err) {
      if (err.response) {
        if (err.response.status === 409) console.log(err.response.data.message);
      } else {
        console.log("Error", err.message);
      }
    });
  },
  toggleReaction: function toggleReaction(_ref27, _ref28) {
    var dispatch = _ref27.dispatch;
    var icon = _ref28.icon,
        aliases = _ref28.aliases,
        parent = _ref28.parent;
    var reaction = {
      icon: icon,
      // aliases: aliases,
      name: aliases[0]
    };

    if (parent !== null && parent !== void 0 && parent.reactions[icon] && parent.reactions[icon].liked) {
      dispatch("sendReactionDelete", {
        reaction: reaction,
        parent: parent
      });
    } else {
      dispatch("sendReaction", {
        reaction: reaction,
        parent: parent
      });
    }
  },
  sendReaction: function sendReaction(_ref29, payload) {
    var state = _ref29.state;
    var action = {
      type: ActionType.ADD_REACTION,
      messageId: payload.parent.id,
      payload: payload.reaction
    };

    var _getAppConfig12 = getAppConfig(this),
        broadcastId = _getAppConfig12.broadcastId,
        tenantId = _getAppConfig12.tenantId;

    if (state.channelActive) return apiChat.sendToNchan(action, state.channelActive, broadcastId, tenantId);
  },
  // params: reaction, parent
  sendReactionDelete: function sendReactionDelete(_ref30, payload) {
    var state = _ref30.state;
    // const idx = (payload.parent as Message).reactions[
    //   payload.reaction.icon
    // ].reactions.findIndex(
    //   (r: Reaction) =>
    //     r.fromUser.id === user.id ||
    //     (r.fromUser as any).fusionAuthId === user.id
    // );
    var action = {
      type: ActionType.DELETE_REACTION,
      messageId: payload.parent.id,
      payload: _objectSpread2(_objectSpread2({}, payload.reaction), {}, {
        name: undefined
      })
    };
    var conf = getAppConfig(this);
    if (state.channelActive && conf) return apiChat.sendToNchan(action, state.channelActive, conf.broadcastId, conf.tenantId);
  },
  addChannel: function addChannel(_ref31, name) {
    var commit = _ref31.commit,
        dispatch = _ref31.dispatch;
    var conf = getAppConfig(this);
    return apiChat.addChannel(name, conf.broadcastId).then(function (res) {
      var chan = {
        id: res.id,
        name: res.channelName,
        private: false,
        unread: 0,
        messages: [],
        users: [],
        banned: []
      };
      commit("addChannel", chan);
      dispatch("setChannelActive", chan);
    }).catch(function (err) {
      return console.error(err);
    });
  },
  deleteChannel: function deleteChannel(_ref32, chan) {
    var state = _ref32.state,
        dispatch = _ref32.dispatch,
        commit = _ref32.commit;
    if (!chan.id) return;
    return apiChat.deleteChannel(chan.id).then(function () {
      var _state$channelActive2;

      if (((_state$channelActive2 = state.channelActive) === null || _state$channelActive2 === void 0 ? void 0 : _state$channelActive2.name) === chan.name) dispatch("setChannelActive", state.channelPrevious || state.channels[0]);
      commit("deleteChannel", chan);
    }).catch(function (err) {
      return console.error(err);
    });
  },
  sendReport: function sendReport(_, payload) {
    var _getAppConfig13 = getAppConfig(this),
        broadcastId = _getAppConfig13.broadcastId;

    var reportType = payload.type;
    var report = {
      broadcastId: broadcastId,
      reportedUser: payload.message.fromUser.id,
      // reportedMessage: payload.message.content, //msg content
      type: reportType,
      text: reportType
    };
    return apiChat.report(report);
  },
  changeLanguage: function changeLanguage(_, userData) {
    return apiChat.changeLanguage(userData.preferredLanguage.toUpperCase());
  },
  changeColor: function changeColor(_, data) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var putRequestData, res;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              putRequestData = {
                firstName: null,
                lastName: null,
                avatar: {
                  src: null,
                  mimeType: null
                },
                displayName: null,
                color: data.color,
                badge: {
                  src: null,
                  mimeType: null
                }
              };
              _context6.next = 3;
              return apiChat.changeColor(putRequestData);

            case 3:
              res = _context6.sent;
              console.log("Succesfully changed color to:", data.color);
              return _context6.abrupt("return", res);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  keepAlive: function keepAlive() {
    return apiChat.keepAlive();
  },
  setMessageError: function setMessageError(_ref33, error) {
    var commit = _ref33.commit,
        dispatch = _ref33.dispatch;

    if (typeof error === "string") {
      commit("setMessageError", i18n.t("s8c.response." + error));
    } else {
      commit("setMessageError", i18n.t("s8c.response." + error.reason, error.allowedValue ? [error.allowedValue] : undefined));
    }

    dispatch("setMessageErrorVisible", true);
  },
  setMessageErrorVisible: function setMessageErrorVisible(_ref34, visible) {
    var commit = _ref34.commit;
    commit("setMessageErrorVisible", visible);
  }
};
// CONCATENATED MODULE: ./src/store/getters.ts





var src_store_getters_getters = {
  getChannels: function getChannels(state) {
    return state.channels;
  },
  getChannelActive: function getChannelActive(state) {
    return state.channelActive;
  },
  getMessages: function getMessages(state) {
    var _state$channelActive$, _state$channelActive;

    return (_state$channelActive$ = (_state$channelActive = state.channelActive) === null || _state$channelActive === void 0 ? void 0 : _state$channelActive.messages) !== null && _state$channelActive$ !== void 0 ? _state$channelActive$ : [];
  },
  getMessagesOrphans: function getMessagesOrphans(state) {
    var _state$channelActive$2, _state$channelActive2, _state$channelActive3;

    return (_state$channelActive$2 = (_state$channelActive2 = state.channelActive) === null || _state$channelActive2 === void 0 ? void 0 : (_state$channelActive3 = _state$channelActive2.messages) === null || _state$channelActive3 === void 0 ? void 0 : _state$channelActive3.filter(function (message) {
      return !message.parent;
    })) !== null && _state$channelActive$2 !== void 0 ? _state$channelActive$2 : [];
  },
  getThreadActive: function getThreadActive(state) {
    return state.threadActive;
  },
  getIsPinnedMessage: function getIsPinnedMessage(state) {
    return state.isPinnedMessage;
  },
  getChannelsSubscribed: function getChannelsSubscribed(state) {
    return state.channels.filter(function (i) {
      return i.subService;
    });
  },
  getPinnedMessages: function getPinnedMessages(state) {
    return state.pinnedMessages.sort(function (a, b) {
      return b.dateCreated - a.dateCreated;
    });
  },
  isFetched: function isFetched(state) {
    return state.isFetched;
  },
  dismissedPinnedMessage: function dismissedPinnedMessage(state) {
    return state.dismissedPinnedMessage;
  },
  getBroadcast: function getBroadcast(state) {
    return state.broadcast;
  },
  messageError: function messageError(state) {
    return state.messageError;
  },
  messageErrorVisible: function messageErrorVisible(state) {
    return state.messageErrorVisible;
  },
  // If a ban obj includes channelIds one of them has to be the currently active channel.
  // All others are active for the whole broadcast.
  bans: function bans(state) {
    return state.bans.filter(function (ban) {
      var _ban$messageRouter, _ban$messageRouter$ch;

      return ((_ban$messageRouter = ban.messageRouter) === null || _ban$messageRouter === void 0 ? void 0 : (_ban$messageRouter$ch = _ban$messageRouter.channels) === null || _ban$messageRouter$ch === void 0 ? void 0 : _ban$messageRouter$ch.length) > 0 ? ban.messageRouter.channels.some(function (chan) {
        return state.channelActive && chan.channelId === state.channelActive.id;
      }) : true;
    });
  },
  userBanned: function userBanned(state, getters, _, rootGetters) {
    var hit = getters["messageRouterHit"];
    var user = rootGetters["".concat(USER_NAMESPACE, "/userInfo")];
    if (!user) return;
    var res = state.bans.find(function (b) {
      return hit(b.messageRouter) && b.userInfo.id === user.id;
    });
    return res;
  },
  // Returns true if the passed messageRouter describes the current state
  messageRouterHit: function messageRouterHit(state) {
    return function (messageRouter) {
      var res = false;

      if (state.channelActive) {
        res = messageRouter.channels.some(function (c) {
          var _state$channelActive4;

          return c.broadcastId === ((_state$channelActive4 = state.channelActive) === null || _state$channelActive4 === void 0 ? void 0 : _state$channelActive4.id);
        });
      }

      if (!res) {
        res = messageRouter.broadcasts.some(function (b) {
          return b.broadcastId === state.broadcast.id;
        });
      }

      return res;
    };
  }
};
// CONCATENATED MODULE: ./src/store/mutations.ts














var src_store_mutations_mutations = {
  setConfigChannel: function setConfigChannel(_, payload) {
    payload.chan.config = payload.conf;
  },
  setChannels: function setChannels(state, channels) {
    state.channels = channels;
  },
  addChannel: function addChannel(state, channel) {
    if (!state.channels.some(function (c) {
      return c.id === channel.id;
    })) state.channels.push(channel);
  },
  addChannels: function addChannels(state, channels) {
    channels.forEach(function (ch) {
      if (!state.channels.some(function (c) {
        return c.id === ch.id;
      })) state.channels.push(ch);
    });
  },
  deleteChannel: function deleteChannel(state, channel) {
    var i = state.channels.indexOf(channel);
    if (i >= 0) state.channels.splice(i, 1);
  },
  deleteChannelById: function deleteChannelById(state, id) {
    var chan = state.channels.find(function (c) {
      return c.id === id;
    });
    if (!chan) return;
    var i = state.channels.indexOf(chan);
    if (i >= 0) state.channels.splice(i, 1);
  },
  setChannelActive: function setChannelActive(state, channel) {
    channel.unread = 0;
    channel.unreadMentions = 0;
    state.channelActive = channel;
  },
  setChannelPrevious: function setChannelPrevious(state, channel) {
    state.channelPrevious = channel;
  },
  setLastRead: function setLastRead(state) {
    var chan = state.channelActive;
    if (chan) chan.lastRead = chan.messages[chan.messages.length - 1];
  },
  setMessages: function setMessages(state, messages) {
    if (state.channelActive) state.channelActive.messages = messages;
  },
  addMessage: function addMessage(state, message) {
    var _state$channelActive, _state$channelActive$;

    (_state$channelActive = state.channelActive) === null || _state$channelActive === void 0 ? void 0 : (_state$channelActive$ = _state$channelActive.messages) === null || _state$channelActive$ === void 0 ? void 0 : _state$channelActive$.push(message);
  },
  deletePollMessage: function deletePollMessage(state, pollId) {
    var _state$channelActive2;

    if (!((_state$channelActive2 = state.channelActive) !== null && _state$channelActive2 !== void 0 && _state$channelActive2.messages)) return;
    state.channelActive.messages = state.channelActive.messages.filter(function (message) {
      var _message$data;

      return !(message.type === MessageType.POLL && ((_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.entityId) === pollId);
    });
  },
  addMessageToChannel: function addMessageToChannel(state, _ref) {
    var _state$channelActive3;

    var message = _ref.message,
        chan = _ref.chan,
        mentioned = _ref.mentioned;
    chan.messages.push(message);

    if (!(chan.name === ((_state$channelActive3 = state.channelActive) === null || _state$channelActive3 === void 0 ? void 0 : _state$channelActive3.name))) {
      chan.unread++;
      if (mentioned) chan.unreadMentions++;
    }
  },
  addMessagesToChannelNoUnread: function addMessagesToChannelNoUnread(_, payload) {
    var _payload$chan$message;

    (_payload$chan$message = payload.chan.messages).unshift.apply(_payload$chan$message, _toConsumableArray(payload.messages));
  },
  clearChannel: function clearChannel(_, channel) {
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(channel, "messages", []);
  },
  deleteMessage: function deleteMessage(_, _ref2) {
    var restorable = _ref2.restorable,
        target = _ref2.target;
    target.deleted = true;
    target.restorable = restorable;
    target.timestampDeleted = Date.now();
  },
  ban: function ban(state, _ban) {
    if (!state.bans.some(function (b) {
      return b.id === _ban.id;
    })) state.bans.push(_ban);
  },
  unban: function unban(state, bans) {
    state.bans = state.bans.filter(function (b) {
      return !bans.includes(b.id);
    });
  },
  restoreMessage: function restoreMessage(_, message) {
    message.deleted = false;
  },
  addUser: function addUser(state, user) {
    var _state$channelActive4;

    if (!((_state$channelActive4 = state.channelActive) !== null && _state$channelActive4 !== void 0 && _state$channelActive4.users)) return;
    var existingUser = state.channelActive.users.find(function (m) {
      return m.id === user.id;
    });

    if (!existingUser) {
      state.channelActive.users.push(user);
      return;
    }

    if (user.displayName && existingUser.displayName !== user.displayName) {
      var activeChannel = state.channelActive;
      activeChannel.users = activeChannel.users.map(function (u) {
        if (u.id === existingUser.id) {
          u.displayName = user.displayName;
        }

        return u;
      });
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state, "channelActive", activeChannel);
    }
  },
  addUserToChannel: function addUserToChannel(_, payload) {
    var _payload$user = payload.user,
        id = _payload$user.id,
        displayName = _payload$user.displayName;
    var existingUser = payload.chan.users.find(function (m) {
      if (m.id === id) return m;
    });

    if (!existingUser) {
      payload.chan.users.push(payload.user);
      return;
    }

    if (displayName && existingUser.displayName !== displayName) {
      payload.chan.users = payload.chan.users.map(function (user) {
        if (user.id === existingUser.id) {
          user.displayName = displayName;
        }

        return user;
      });
    }
  },
  deleteUser: function deleteUser(state, user) {
    var _state$channelActive5;

    if (!((_state$channelActive5 = state.channelActive) !== null && _state$channelActive5 !== void 0 && _state$channelActive5.users)) return;
    var i = state.channelActive.users.indexOf(user);
    if (i >= 0) state.channelActive.users.splice(i, 1);
  },
  deleteUserFromChannel: function deleteUserFromChannel(_, payload) {
    var i = payload.chan.users.findIndex(function (m) {
      return m.id === payload.userId;
    });
    if (i >= 0) payload.chan.users.splice(i, 1);
  },
  editUser: function editUser(_, payload) {// ???? this does nothing
    // const u = payload.chan.users.find((u) => u.id === payload.user.id);
    // Object.assign(u, payload.user);
  },
  editUserMessage: function editUserMessage(_, payload) {
    payload.message.fromUser = payload.user;
  },
  setThreadActive: function setThreadActive(state, thread) {
    state.threadActive = thread;
  },
  addChild: function addChild(_, _ref3) {
    var message = _ref3.message,
        parent = _ref3.parent;
    if (!parent.submessages) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(parent, "submessages", Array());
    parent.submessages.push(message);
  },
  addReaction: function addReaction(_, _ref4) {
    var reaction = _ref4.reaction,
        parent = _ref4.parent,
        byMyself = _ref4.byMyself;
    if (!parent.reactions[reaction.icon]) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(parent.reactions, "".concat(reaction.icon), {
      count: 1,
      aliases: reaction.aliases,
      liked: byMyself,
      reactions: [reaction]
    });else {
      parent.reactions[reaction.icon].reactions.push(reaction);
      parent.reactions[reaction.icon].count++;
      if (byMyself) parent.reactions[reaction.icon].liked = true;
    }
  },
  deleteReaction: function deleteReaction(_, _ref5) {
    var parent = _ref5.parent,
        icon = _ref5.icon,
        i = _ref5.i,
        byMyself = _ref5.byMyself;

    if (parent.reactions[icon].count <= 1) {
      console.log(parent.reactions[icon]);
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.delete(parent.reactions, "".concat(icon));
    } else {
      parent.reactions[icon].reactions.splice(i, 1);
      parent.reactions[icon].count--;
      if (byMyself) parent.reactions[icon].liked = false;
    }
  },
  // nchan subscriber logic
  setServiceChannel: function setServiceChannel(_, payload) {
    if (payload.chan && payload.service) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(payload.chan, "subService", payload.service);
  },
  deleteServiceChannel: function deleteServiceChannel(_, chan) {
    if (chan.subService) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.delete(chan, "subscriber");
  },
  setServiceBroadcast: function setServiceBroadcast(state, service) {
    if (service) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state.broadcast, "subService", service);
  },
  deleteServiceBroadcast: function deleteServiceBroadcast(state) {
    if (state.broadcast.subService) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.delete(state.broadcast, "subService");
  },
  setServiceTenant: function setServiceTenant(state, service) {
    if (service) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(state.tenant, "subService", service);
  },
  deleteServiceTenant: function deleteServiceTenant(state) {
    if (state.tenant.subService) external_commonjs_vue_commonjs2_vue_root_Vue_default.a.delete(state.tenant, "subService");
  },
  startService: function startService(_, pl) {
    var _pl$subService$sub;

    if (pl.subService && !((_pl$subService$sub = pl.subService.sub) !== null && _pl$subService$sub !== void 0 && _pl$subService$sub.running)) pl.subService.sub.start();
  },
  stopService: function stopService(_, pl) {
    var _pl$subService$sub2;

    if (pl.subService && (_pl$subService$sub2 = pl.subService.sub) !== null && _pl$subService$sub2 !== void 0 && _pl$subService$sub2.running) pl.subService.sub.stop();
  },
  setIsPinnedMessage: function setIsPinnedMessage(state, value) {
    state.isPinnedMessage = value;
  },
  setDismissPinnedMessage: function setDismissPinnedMessage(state, value) {
    state.dismissedPinnedMessage = value;
  },
  setPinnedMessages: function setPinnedMessages(state, pinnedMessages) {
    if (!state.pinnedMessages.some(function (obj) {
      return pinnedMessages.id === obj.id;
    })) {
      state.pinnedMessages.push(pinnedMessages);
      state.isFetched = true;
      state.isPinnedMessage = true;
    }
  },
  removePinnedMessage: function removePinnedMessage(state, id) {
    var i = state.pinnedMessages.findIndex(function (p) {
      return p.id === id;
    });
    if (i > -1) state.pinnedMessages.splice(i, 1);

    if (state.pinnedMessages.length <= 0) {
      state.isPinnedMessage = false;
      state.isFetched = true;
    }
  },
  setisFetched: function setisFetched(state, value) {
    state.isFetched = value;
  },
  setRules: function setRules(state, payload) {
    state.rules = payload;
  },
  setupBroadcast: function setupBroadcast(state, payload) {
    state.broadcast.id = payload.broadcastId;
    state.broadcast.initialized = true;
  },
  setupTenant: function setupTenant(state, payload) {
    state.tenant.id = payload.tenantId;
    state.tenant.initialized = true;
  },
  setMessageError: function setMessageError(state, error) {
    state.messageError = error;
  },
  setMessageErrorVisible: function setMessageErrorVisible(state, visible) {
    state.messageErrorVisible = visible;
  }
};
// CONCATENATED MODULE: ./src/store/index.ts



var src_store_state = {
  isPinnedMessage: false,
  channels: [],
  channelActive: undefined,
  threadActive: undefined,
  broadcast: {
    id: "",
    initialized: false,
    banned: []
  },
  tenant: {
    id: "",
    initialized: false
  },
  settings: {
    showUnreadBadges: true,
    showUnreadBadgesForAllMessages: false
  },
  rules: "Be good",
  isFetched: false,
  pinnedMessages: [],
  dismissedPinnedMessage: false,
  messageError: "",
  messageErrorVisible: false,
  bans: []
};
var store_CHAT_NAMESPACE = "spect8-chat";
var src_store_namespaced = true;
var chat = {
  namespaced: src_store_namespaced,
  state: src_store_state,
  getters: src_store_getters_getters,
  actions: src_store_actions_actions,
  mutations: src_store_mutations_mutations
};
// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function vue_class_component_esm_typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    vue_class_component_esm_typeof = function (obj) {
      return typeof obj;
    };
  } else {
    vue_class_component_esm_typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return vue_class_component_esm_typeof(obj);
}

function vue_class_component_esm_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function vue_class_component_esm_toConsumableArray(arr) {
  return vue_class_component_esm_arrayWithoutHoles(arr) || vue_class_component_esm_iterableToArray(arr) || vue_class_component_esm_nonIterableSpread();
}

function vue_class_component_esm_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function vue_class_component_esm_iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function vue_class_component_esm_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = vue_class_component_esm_typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return vue_class_component_esm_defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof external_commonjs_vue_commonjs2_vue_root_Vue_default.a ? superProto.constructor : external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = [// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter'];
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function vue_class_component_esm_Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, vue_class_component_esm_toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (vue_class_component_esm_Component);


// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var Emit_spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, Emit_spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, Emit_spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Inject.js

/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/helpers/provideInject.js
function needToProduceProvide(original) {
    return (typeof original !== 'function' ||
        (!original.managed && !original.managedReactive));
}
function produceProvide(original) {
    var provide = function () {
        var _this = this;
        var rv = typeof original === 'function' ? original.call(this) : original;
        rv = Object.create(rv || null);
        // set reactive services (propagates previous services if necessary)
        rv[reactiveInjectKey] = Object.create(this[reactiveInjectKey] || {});
        for (var i in provide.managed) {
            rv[provide.managed[i]] = this[i];
        }
        var _loop_1 = function (i) {
            rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
            Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                enumerable: true,
                configurable: true,
                get: function () { return _this[i]; },
            });
        };
        var this_1 = this;
        for (var i in provide.managedReactive) {
            _loop_1(i);
        }
        return rv;
    };
    provide.managed = {};
    provide.managedReactive = {};
    return provide;
}
/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
function inheritInjected(componentOptions) {
    // inject parent reactive services (if any)
    if (!Array.isArray(componentOptions.inject)) {
        componentOptions.inject = componentOptions.inject || {};
        componentOptions.inject[reactiveInjectKey] = {
            from: reactiveInjectKey,
            default: {},
        };
    }
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/InjectReactive.js


/**
 * decorator of a reactive inject
 * @param from key
 * @return PropertyDecorator
 */
function InjectReactive(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            var fromKey_1 = !!options ? options.from || options : key;
            var defaultVal_1 = (!!options && options.default) || undefined;
            if (!componentOptions.computed)
                componentOptions.computed = {};
            componentOptions.computed[key] = function () {
                var obj = this[reactiveInjectKey];
                return obj ? obj[fromKey_1] : defaultVal_1;
            };
            componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
        }
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Provide.js


/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        inheritInjected(componentOptions);
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managed[k] = key || k;
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/ProvideReactive.js


/**
 * decorator of a reactive provide
 * @param key key
 * @return PropertyDecorator | void
 */
function ProvideReactive(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        inheritInjected(componentOptions);
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managedReactive[k] = key || k;
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Ref.js

/**
 * decorator of a ref prop
 * @param refKey the ref key defined in template
 */
function Ref(refKey) {
    return createDecorator(function (options, key) {
        options.computed = options.computed || {};
        options.computed[key] = {
            cache: false,
            get: function () {
                return this.$refs[refKey || key];
            },
        };
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/VModel.js

/**
 * decorator for capturings v-model binding to component
 * @param options the options for the prop
 */
function VModel(options) {
    if (options === void 0) { options = {}; }
    var valueKey = 'value';
    return createDecorator(function (componentOptions, key) {
        ;
        (componentOptions.props || (componentOptions.props = {}))[valueKey] = options;
        (componentOptions.computed || (componentOptions.computed = {}))[key] = {
            get: function () {
                return this[valueKey];
            },
            set: function (value) {
                this.$emit('input', value);
            },
        };
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>
















// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("2f62");

// CONCATENATED MODULE: ./node_modules/vuex-class/lib/bindings.js


var State = createBindingHelper('computed', vuex_esm["d" /* mapState */]);
var Getter = createBindingHelper('computed', vuex_esm["b" /* mapGetters */]);
var bindings_Action = createBindingHelper('methods', vuex_esm["a" /* mapActions */]);
var bindings_Mutation = createBindingHelper('methods', vuex_esm["c" /* mapMutations */]);
function bindings_namespace(namespace, helper) {
    function createNamespacedHelper(helper) {
        function namespacedHelper(a, b) {
            if (typeof b === 'string') {
                var key = b;
                var proto = a;
                return helper(key, { namespace: namespace })(proto, key);
            }
            var type = a;
            var options = bindings_merge(b || {}, { namespace: namespace });
            return helper(type, options);
        }
        return namespacedHelper;
    }
    if (helper) {
        console.warn('[vuex-class] passing the 2nd argument to `namespace` function is deprecated. pass only namespace string instead.');
        return createNamespacedHelper(helper);
    }
    return {
        State: createNamespacedHelper(State),
        Getter: createNamespacedHelper(Getter),
        Mutation: createNamespacedHelper(bindings_Mutation),
        Action: createNamespacedHelper(bindings_Action)
    };
}
function createBindingHelper(bindTo, mapFn) {
    function makeDecorator(map, namespace) {
        return createDecorator(function (componentOptions, key) {
            if (!componentOptions[bindTo]) {
                componentOptions[bindTo] = {};
            }
            var mapObject = (_a = {}, _a[key] = map, _a);
            componentOptions[bindTo][key] = namespace !== undefined
                ? mapFn(namespace, mapObject)[key]
                : mapFn(mapObject)[key];
            var _a;
        });
    }
    function helper(a, b) {
        if (typeof b === 'string') {
            var key = b;
            var proto = a;
            return makeDecorator(key, undefined)(proto, key);
        }
        var namespace = extractNamespace(b);
        var type = a;
        return makeDecorator(type, namespace);
    }
    return helper;
}
function extractNamespace(options) {
    var n = options && options.namespace;
    if (typeof n !== 'string') {
        return undefined;
    }
    if (n[n.length - 1] !== '/') {
        return n + '/';
    }
    return n;
}
function bindings_merge(a, b) {
    var res = {};
    [a, b].forEach(function (obj) {
        Object.keys(obj).forEach(function (key) {
            res[key] = obj[key];
        });
    });
    return res;
}

// CONCATENATED MODULE: ./node_modules/vuex-class/lib/index.js


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatItem.vue?vue&type=template&id=ebe6302c&scoped=true&
var ChatItemvue_type_template_id_ebe6302c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message.type === 'TEXT')?_c('ChatTextMessage',_vm._g(_vm._b({},'ChatTextMessage',_vm.$props,false),_vm.$listeners)):(_vm.message.type === 'POLL')?_c('ChatPollMessage',_vm._g(_vm._b({},'ChatPollMessage',_vm.$props,false),_vm.$listeners)):_vm._e()}
var ChatItemvue_type_template_id_ebe6302c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ChatItem.vue?vue&type=template&id=ebe6302c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatTextMessage.vue?vue&type=template&id=3188c232&scoped=true&
var ChatTextMessagevue_type_template_id_3188c232_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('div',[(_vm.messageVisible)?_c('v-list-item',{key:_vm.message.id,class:[
        _vm.isMentioned ? 'background lighten-1' : '',
        _vm.$vuetify.theme.dark ? 'hover-lighter' : 'hover-darker' ],style:({
        paddingLeft:
          _vm.styleConfig.padding.messages.left + (_vm.indent ? 24 : 0) + 'px',
        paddingRight: _vm.styleConfig.padding.messages.right + 'px',
      }),attrs:{"selectable":"","dense":_vm.enabledFeatures.COMPACT_MESSAGES}},[(!_vm.enabledFeatures.COMPACT_MESSAGES)?_c('v-list-item-avatar',{staticClass:"mr-3 mt-3 align-self-start",attrs:{"color":"grey darken-1"}},[(_vm.avatarUri)?_c('img',{attrs:{"src":_vm.avatarUri,"width":"40px"}}):_c('v-icon',{attrs:{"size":"40"}},[_vm._v("mdi-account-circle")])],1):_vm._e(),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"d-flex flex-row align-baseline justify-start",staticStyle:{"z-index":"3"}},[_c('ChatModBadge',{attrs:{"color":_vm.nameColor,"userInfo":_vm.message.fromUser}}),(_vm.nameIsLink)?_c('a',{staticClass:"text-subtitle-2 author-link font-weight-light",style:({
              color: _vm.nameColor,
            }),on:{"click":_vm.handleUserMenuOpen}},[_vm._v(_vm._s(_vm.message.fromUser.displayName)+" ")]):_c('span',{staticClass:"text-subtitle-2 author-link font-weight-light",style:({
              color: _vm.nameColor,
            })},[_vm._v(" "+_vm._s(_vm.message.fromUser.displayName)+" ")]),(
              !_vm.enabledFeatures.COMPACT_MESSAGES &&
              _vm.message.fromUser.badge &&
              _vm.message.fromUser.badge.src !== ''
            )?_c('v-img',{staticClass:"ml-2",attrs:{"contain":"","max-width":"18","max-height":"18","src":_vm.userBadge}}):_vm._e(),_c('span',{staticClass:"text-caption ml-2 text--disabled"},[_vm._v(_vm._s(_vm.formattedDate)+" ")])],1),_c('v-list-item-subtitle',{staticClass:"text-body-2 text--primary",staticStyle:{"overflow-wrap":"break-word","white-space":"initial"},domProps:{"innerHTML":_vm._s(_vm.formattedContent)}}),_c('v-list-item-subtitle',[(
              _vm.message.submessages && _vm.message.submessages.length > 0 && !_vm.simple
            )?_c('span',[(_vm.enabledFeatures.THREADS)?_c('v-btn',{staticClass:"my-1 reply-button lighten-2",attrs:{"x-small":"","elevation":"2","color":_vm.isMentionedChildren ? 'brand50' : 'background'},on:{"click":_vm.handleReply}},[_vm._v(" "+_vm._s(_vm.message.submessages.length + " " + _vm.$tc("s8c.reply", _vm.message.submessages.length))+" ")]):_vm._e()],1):_vm._e(),(_vm.message.reactions)?_c('span',[_vm._l((_vm.message.reactions),function(reactions,icon){return _c('v-tooltip',{directives:[{name:"show",rawName:"v-show",value:(reactions.count > 0),expression:"reactions.count > 0"}],key:reactions.aliases[0],attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
            var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"my-1 ml-1 pl-1 pr-1 reaction-indicator",class:reactions.liked ? 'reaction-liked' : '',staticStyle:{"z-index":"3"},attrs:{"rounded":"","x-small":"","elevation":"1"},on:{"click":function($event){return _vm.handleReactionClick(icon, reactions.aliases[0])}}},'v-btn',attrs,false),on),[_c('span',{staticClass:"d-flex justify-space-around reaction-emoji",staticStyle:{"width":"0.875rem","height":"0.875rem","margin-right":"2px"},domProps:{"innerHTML":_vm._s(_vm.transformEmoji(icon))}}),_c('span',[_vm._v(" "+_vm._s(("" + (reactions.count)))+" ")])])]}}],null,true)},[_vm._v(" "+_vm._s(_vm.makeUsersString(reactions.reactions))+" ")])}),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.reactionsVisible),expression:"reactionsVisible"}],staticClass:"my-1 ml-2 pa-1 reaction-add-inline",staticStyle:{"z-index":"3"},attrs:{"rounded":"","x-small":"","plain":"","icon":"","elevation":"0"},on:{"click":_vm.handleEmojiPickerOpen}},[_c('v-icon',[_vm._v("mdi-face-woman-shimmer")])],1)],2):_vm._e()])],1),_c('v-fade-transition',[(hover)?_c('div',{class:!_vm.enabledFeatures.COMPACT_MESSAGES
              ? 'd-flex mt-1 ml-auto mb-auto justify-end align-center'
              : 'd-flex justify-center align-center',attrs:{"id":"floating-menu"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
              var attrs = ref.attrs;
return [(_vm.authenticated && !_vm.simple)?_c('v-btn',_vm._g(_vm._b({staticClass:"mr-1",attrs:{"icon":"","small":"","color":_vm.$vuetify.theme.dark ? 'white' : 'black'},on:{"click":_vm.handleEmojiPickerOpen}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-face-woman-shimmer-outline")])],1):_vm._e()]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t("s8c.reaction.add")))])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
              var attrs = ref.attrs;
return [(
                  _vm.authenticated &&
                  _vm.enabledFeatures.THREADS &&
                  !_vm.message.parent &&
                  !_vm.simple
                )?_c('v-btn',_vm._g(_vm._b({staticClass:"mr-1",attrs:{"icon":"","small":"","color":_vm.$vuetify.theme.dark ? 'white' : 'black'},on:{"click":_vm.handleReply}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-reply")])],1):_vm._e()]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$tc("s8c.replyTooltip")))])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                var on = ref.on;
                var attrs = ref.attrs;
return [(
                  _vm.authenticated &&
                  !_vm.message.parent &&
                  !_vm.simple &&
                  (_vm.isMod || _vm.isAuthor)
                )?_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","small":"","color":_vm.$vuetify.theme.dark ? 'white' : 'black'},on:{"click":_vm.handleMoreMenuOpen}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1):_vm._e()]}}],null,true)},[_vm._v(" "+_vm._s(_vm.$t("s8c.moreActions"))+" ")])],1):_vm._e()])],1):_c('v-list-item',{staticClass:"text-caption text--secondary",style:({
        paddingLeft: _vm.styleConfig.padding.messages.left + 24 + 'px',
        paddingRight: _vm.styleConfig.padding.messages.right + 'px',
      }),attrs:{"dense":""}},[(_vm.isMod && _vm.message.restorable)?_c('v-list-item-content',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.handleRestore(_vm.message)}}},[_vm._v(" "+_vm._s(_vm.getBannedMessageText())+" ")])]):_c('v-list-item-content',{staticClass:"pl-8 text-caption text--secondary"},[_vm._v(" "+_vm._s(_vm.getBannedMessageText())+" ")])],1),_c('v-menu',{attrs:{"absolute":"","position-x":_vm.userMenuX,"position-y":_vm.userMenuY,"close-on-content-click":false},model:{value:(_vm.userMenu),callback:function ($$v) {_vm.userMenu=$$v},expression:"userMenu"}},[_c('v-list',{attrs:{"dense":""}},[(!_vm.isAuthor && !_vm.authorIsMod && _vm.isMod)?_c('v-menu',{attrs:{"open-on-hover":"","offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
      var attrs = ref.attrs;
return [_c('v-list-item',_vm._g({attrs:{"attrs":attrs}},on),[_c('v-list-item-content',[_c('v-list-item-title',{class:("error--text text--" + (_vm.$vuetify.theme.dark ? 'lighten-1' : 'darken-1'))},[_vm._v(" "+_vm._s(_vm.$t("s8c.muteUser"))+" ")])],1)],1)]}}],null,true)},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.muteTimes),function(time){return _c('v-list-item',{key:time[0],on:{"click":function($event){return _vm.handleBanSelect(_vm.message, time[0], true)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(time[1])+" ")])],1)],1)}),1)],1):_vm._e(),(_vm.enabledFeatures.IGNORE)?_c('v-list-item',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAuthor),expression:"!isAuthor"}],on:{"click":_vm.handleIgnore}},[_c('v-list-item-content',[_c('v-list-item-title',{class:("error--text text--" + (_vm.$vuetify.theme.dark ? 'lighten-1' : 'darken-1'))},[_vm._v(" "+_vm._s(_vm.$t("s8c.ignore"))+" ")])],1)],1):_vm._e(),(_vm.enabledFeatures.REPORTS)?_c('v-list-item',{staticClass:"error--text",on:{"click":_vm.handleReportDialogOpen}},[_c('v-list-item-icon',{staticClass:"mr-0"},[_c('v-icon',{attrs:{"color":_vm.$vuetify.theme.dark ? 'white' : 'black',"small":""}},[_vm._v(" mdi-flag ")])],1),_c('v-list-item-content',{staticClass:"pr-4 pl-2"},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("s8c.Report")))])],1)],1):_vm._e()],1)],1),_c('v-menu',{attrs:{"close-on-content-click":true,"position-x":_vm.moreMenuX,"position-y":_vm.moreMenuY},model:{value:(_vm.moreMenu),callback:function ($$v) {_vm.moreMenu=$$v},expression:"moreMenu"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-menu',{attrs:{"open-on-click":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
              var attrs = ref.attrs;
return [(_vm.authenticated && !_vm.message.parent && !_vm.simple && _vm.isMod)?_c('v-list-item',_vm._g({attrs:{"attrs":attrs}},on),[_c('v-list-item-icon',{staticClass:"mr-0"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pin")])],1),_c('v-list-item-content',{staticClass:"pr-4 pl-2"},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("s8c.pin.message")))])],1)],1):_vm._e()]}}],null,true)},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.pinTimes),function(time){return _c('v-list-item',{key:time[0],on:{"click":function($event){return _vm.pinMessage(_vm.message, time[0])}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(time[1])+" ")])],1)],1)}),1)],1),(_vm.isMod)?_c('v-divider',{staticClass:"my-2"}):_vm._e(),_c('v-list-item',{staticClass:"error white--text",on:{"click":function($event){return _vm.deleteMessage(_vm.message)}}},[_c('v-list-item-icon',{staticClass:"mr-0"},[_c('v-icon',{attrs:{"color":"white","small":""}},[_vm._v("mdi-delete")])],1),_c('v-list-item-content',{staticClass:"pr-4 pl-2 white--text"},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("s8c.delete")))])],1)],1)],1)],1),_c('v-menu',{attrs:{"position-x":_vm.emojiPickerX,"position-y":_vm.emojiPickerY,"close-on-content-click":false,"z-index":"20","origin":"bottom"},model:{value:(_vm.emojiPicker),callback:function ($$v) {_vm.emojiPicker=$$v},expression:"emojiPicker"}},[_c('ChatEmojiPicker',{attrs:{"dark":_vm.$vuetify.theme.dark},on:{"emoji":_vm.handleReactionNew}})],1),(_vm.enabledFeatures.REPORTS)?_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.reportDialog),callback:function ($$v) {_vm.reportDialog=$$v},expression:"reportDialog"}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card-title',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.$t("s8c.report.header"))+" ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t("s8c.report.subheader"))+" ")]),_c('v-spacer'),_c('v-card-actions',[_c('v-radio-group',{staticClass:"px-2",model:{value:(_vm.reportSelect),callback:function ($$v) {_vm.reportSelect=$$v},expression:"reportSelect"}},_vm._l((Object.entries(_vm.reportTypes)),function(ref){
              var report = ref[0];
              var rDesc = ref[1];
return _c('v-radio',{key:report,attrs:{"label":_vm.$t(rDesc),"value":report}})}),1),_c('v-spacer')],1),_c('v-card-actions',[_c('v-btn',{staticClass:"ml-auto",attrs:{"text":""},on:{"click":function($event){_vm.reportDialog = false}}},[_vm._v(" "+_vm._s(_vm.$t("s8c.Cancel")))]),_c('v-btn',{staticClass:"ml-4",attrs:{"text":"","color":"success","disabled":_vm.reportSelect === '',"loading":_vm.reportLoading},on:{"click":_vm.handleReport}},[_vm._v(_vm._s(_vm.$t("s8c.Submit")))])],1)],1)],1):_vm._e(),(_vm.enabledFeatures.REPORTS)?_c('v-dialog',{staticClass:"text-center",attrs:{"max-width":"300px"},model:{value:(_vm.reportResultDialog),callback:function ($$v) {_vm.reportResultDialog=$$v},expression:"reportResultDialog"}},[_c('v-card',{staticClass:"mx-auto",attrs:{"loading":_vm.reportLoading}},[(_vm.reportSuccess && _vm.reportStatus === 200)?[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("s8c.report.success")))]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t("s8c.report.received")))]),_c('v-card-actions',[_c('v-btn',{staticClass:"ml-auto",attrs:{"color":"success","text":""},on:{"click":function($event){_vm.reportResultDialog = false}}},[_vm._v(" OK ")])],1)]:(_vm.reportSuccess && _vm.reportStatus === 204)?[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("s8c.once")))]),_c('v-card-text',[_vm._v(_vm._s(_vm.$t("s8c.Your report is already being processed, don't worry."))+" ")]),_c('v-card-actions',[_c('v-btn',{staticClass:"ml-auto",attrs:{"color":"success","text":""},on:{"click":function($event){_vm.reportResultDialog = false}}},[_vm._v(" OK ")])],1)]:[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("s8c.Bad")))]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t("s8c.report.received")))]),_c('v-card-actions',[_c('v-btn',{staticClass:"ml-auto",attrs:{"color":"success","text":""},on:{"click":function($event){_vm.reportResultDialog = false}}},[_vm._v(" OK ")])],1)]],2)],1):_vm._e(),_c('v-dialog',{attrs:{"persistent":"","max-width":"460"},model:{value:(_vm.unbanDialog),callback:function ($$v) {_vm.unbanDialog=$$v},expression:"unbanDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("s8c.unbanUser", [_vm.message.fromUser.displayName]))+" ")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary darken-1","text":""},on:{"click":function($event){_vm.unbanDialog = false}}},[_vm._v(" "+_vm._s(_vm.$t("s8c.Disagree"))+" ")]),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":_vm.handleUnban}},[_vm._v(" "+_vm._s(_vm.$t("s8c.Agree"))+" ")])],1)],1)],1),_c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(ref){
              var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":function($event){_vm.pinSnackbar = false}}},'v-btn',attrs,false),[_vm._v(" "+_vm._s(_vm.$t("s8c.Close"))+" ")])]}}],null,true),model:{value:(_vm.pinSnackbar),callback:function ($$v) {_vm.pinSnackbar=$$v},expression:"pinSnackbar"}},[_vm._v(" "+_vm._s(_vm.$t("s8c.pin.already"))+" ")])],1)]}}])})}
var ChatTextMessagevue_type_template_id_3188c232_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ChatTextMessage.vue?vue&type=template&id=3188c232&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/LocaleDataStore.js
// Fallback locale.
// (when not a single one of the supplied "preferred" locales is available)
var LocaleDataStore_defaultLocale = 'en'; // For all locales added
// their relative time formatter messages will be stored here.

var localesData = {}; // According to the spec BCP 47 language tags are case-insensitive.
// https://tools.ietf.org/html/rfc5646

var lowercaseLocaleLookup = {};
function getDefaultLocale() {
  return LocaleDataStore_defaultLocale;
}
function setDefaultLocale(locale) {
  LocaleDataStore_defaultLocale = locale;
}
/**
 * Gets locale data previously added by `addLocaleData()`.
 * @return  {object} [localeData]
 */

function getLocaleData(locale) {
  return localesData[locale];
}
/**
 * Adds locale data.
 * Is called by `RelativeTimeFormat.addLocale(...)`.
 * @param  {object} localeData
 */

function addLocaleData(localeData) {
  if (!localeData) {
    throw new Error('No locale data passed');
  } // This locale data is stored in a global variable
  // and later used when calling `.format(time)`.


  localesData[localeData.locale] = localeData;
  lowercaseLocaleLookup[localeData.locale.toLowerCase()] = localeData.locale;
}
/**
 * Returns a locale for which locale data has been added
 * via `RelativeTimeFormat.addLocale(...)`.
 * @param  {string} locale
 * @return {string} [locale]
 */

function resolveLocale(locale) {
  if (localesData[locale]) {
    return locale;
  }

  if (lowercaseLocaleLookup[locale.toLowerCase()]) {
    return lowercaseLocaleLookup[locale.toLowerCase()];
  }
}
//# sourceMappingURL=LocaleDataStore.js.map
// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/resolveLocale.js

/**
 * Resolves a locale to a supported one (if any).
 * @param  {string} locale
 * @param {Object} [options] - An object that may have the following property:
 * @param {string} [options.localeMatcher="lookup"] - The locale matching algorithm to use. Possible values are "lookup" and "best fit". Currently only "lookup" is supported.
 * @return {string} [locale]
 * @example
 * // Returns "sr"
 * resolveLocale("sr-Cyrl-BA")
 * // Returns `undefined`
 * resolveLocale("xx-Latn")
 */

function resolveLocale_resolveLocale(locale) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localeMatcher = options.localeMatcher || 'lookup';

  switch (localeMatcher) {
    case 'lookup':
      return resolveLocaleLookup(locale);
    // "best fit" locale matching is not supported.
    // https://github.com/catamphetamine/relative-time-format/issues/2

    case 'best fit':
      // return resolveLocaleBestFit(locale)
      return resolveLocaleLookup(locale);

    default:
      throw new RangeError("Invalid \"localeMatcher\" option: ".concat(localeMatcher));
  }
}
/**
 * Resolves a locale to a supported one (if any).
 * Starts from the most specific locale and gradually
 * falls back to less specific ones.
 * This is a basic implementation of the "lookup" algorithm.
 * https://tools.ietf.org/html/rfc4647#section-3.4
 * @param  {string} locale
 * @return {string} [locale]
 * @example
 * // Returns "sr"
 * resolveLocaleLookup("sr-Cyrl-BA")
 * // Returns `undefined`
 * resolveLocaleLookup("xx-Latn")
 */

function resolveLocaleLookup(locale) {
  var resolvedLocale = resolveLocale(locale);

  if (resolvedLocale) {
    return resolvedLocale;
  } // `sr-Cyrl-BA` -> `sr-Cyrl` -> `sr`.


  var parts = locale.split('-');

  while (locale.length > 1) {
    parts.pop();
    locale = parts.join('-');

    var _resolvedLocale = resolveLocale(locale);

    if (_resolvedLocale) {
      return _resolvedLocale;
    }
  }
}
//# sourceMappingURL=resolveLocale.js.map
// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/PluralRuleFunctions.js
// (this file was autogenerated by `generate-locales`)
// "plural rules" functions are not stored in locale JSON files because they're not strings.
// This file isn't big — it's about 5 kilobytes in size (minified).
// Alternatively, the pluralization rules for each locale could be stored
// in their JSON files in a non-parsed form and later parsed via `make-plural` library.
// But `make-plural` library itself is relatively big in size:
// `make-plural.min.js` is about 6 kilobytes (https://unpkg.com/make-plural/).
// So, it's more practical to bypass runtime `make-plural` pluralization rules compilation
// and just include the already compiled pluarlization rules for all locales in the library code.
var $ = {
  af: function af(n) {
    return n == 1 ? 'one' : 'other';
  },
  am: function am(n) {
    return n >= 0 && n <= 1 ? 'one' : 'other';
  },
  ar: function ar(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
  },
  ast: function ast(n) {
    var s = String(n).split('.'),
        v0 = !s[1];
    return n == 1 && v0 ? 'one' : 'other';
  },
  be: function be(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    return n10 == 1 && n100 != 11 ? 'one' : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? 'few' : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? 'many' : 'other';
  },
  br: function br(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        n1000000 = t0 && s[0].slice(-6);
    return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? 'one' : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? 'two' : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? 'few' : n != 0 && t0 && n1000000 == 0 ? 'many' : 'other';
  },
  bs: function bs(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  },
  ceb: function ceb(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        f10 = f.slice(-1);
    return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
  },
  cs: function cs(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1];
    return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
  },
  cy: function cy(n) {
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 ? 'few' : n == 6 ? 'many' : 'other';
  },
  da: function da(n) {
    var s = String(n).split('.'),
        i = s[0],
        t0 = Number(s[0]) == n;
    return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
  },
  dsb: function dsb(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i100 = i.slice(-2),
        f100 = f.slice(-2);
    return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
  },
  dz: function dz(n) {
    return 'other';
  },
  ff: function ff(n) {
    return n >= 0 && n < 2 ? 'one' : 'other';
  },
  fr: function fr(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i1000000 = i.slice(-6);
    return n >= 0 && n < 2 ? 'one' : i != 0 && i1000000 == 0 && v0 ? 'many' : 'other';
  },
  ga: function ga(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    return n == 1 ? 'one' : n == 2 ? 'two' : t0 && n >= 3 && n <= 6 ? 'few' : t0 && n >= 7 && n <= 10 ? 'many' : 'other';
  },
  gd: function gd(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? 'few' : 'other';
  },
  he: function he(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1);
    return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
  },
  is: function is(n) {
    var s = String(n).split('.'),
        i = s[0],
        t0 = Number(s[0]) == n,
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return t0 && i10 == 1 && i100 != 11 || !t0 ? 'one' : 'other';
  },
  ksh: function ksh(n) {
    return n == 0 ? 'zero' : n == 1 ? 'one' : 'other';
  },
  lt: function lt(n) {
    var s = String(n).split('.'),
        f = s[1] || '',
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    return n10 == 1 && (n100 < 11 || n100 > 19) ? 'one' : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? 'few' : f != 0 ? 'many' : 'other';
  },
  lv: function lv(n) {
    var s = String(n).split('.'),
        f = s[1] || '',
        v = f.length,
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        f100 = f.slice(-2),
        f10 = f.slice(-1);
    return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
  },
  mk: function mk(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : 'other';
  },
  mt: function mt(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 1 ? 'one' : n == 0 || n100 >= 2 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 19 ? 'many' : 'other';
  },
  pa: function pa(n) {
    return n == 0 || n == 1 ? 'one' : 'other';
  },
  pl: function pl(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return n == 1 && v0 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? 'many' : 'other';
  },
  pt: function pt(n) {
    var s = String(n).split('.'),
        i = s[0];
    return i == 0 || i == 1 ? 'one' : 'other';
  },
  ro: function ro(n) {
    var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
  },
  ru: function ru(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
  },
  se: function se(n) {
    return n == 1 ? 'one' : n == 2 ? 'two' : 'other';
  },
  si: function si(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '';
    return n == 0 || n == 1 || i == 0 && f == 1 ? 'one' : 'other';
  },
  sl: function sl(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i100 = i.slice(-2);
    return v0 && i100 == 1 ? 'one' : v0 && i100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few' : 'other';
  }
};
$.as = $.am;
$.az = $.af;
$.bg = $.af;
$.bn = $.am;
$.ca = $.ast;
$.ce = $.af;
$.chr = $.af;
$.de = $.ast;
$.ee = $.af;
$.el = $.af;
$.en = $.ast;
$.es = $.af;
$.et = $.ast;
$.eu = $.af;
$.fa = $.am;
$.fi = $.ast;
$.fil = $.ceb;
$.fo = $.af;
$.fur = $.af;
$.fy = $.ast;
$.gl = $.ast;
$.gu = $.am;
$.ha = $.af;
$.hi = $.am;
$.hr = $.bs;
$.hsb = $.dsb;
$.hu = $.af;
$.hy = $.ff;
$.ia = $.ast;
$.id = $.dz;
$.ig = $.dz;
$.it = $.ast;
$.ja = $.dz;
$.jgo = $.af;
$.jv = $.dz;
$.ka = $.af;
$.kea = $.dz;
$.kk = $.af;
$.kl = $.af;
$.km = $.dz;
$.kn = $.am;
$.ko = $.dz;
$.ku = $.af;
$.ky = $.af;
$.lb = $.af;
$.lkt = $.dz;
$.lo = $.dz;
$.ml = $.af;
$.mn = $.af;
$.mr = $.af;
$.ms = $.dz;
$.my = $.dz;
$.nb = $.af;
$.ne = $.af;
$.nl = $.ast;
$.nn = $.af;
$.no = $.af;
$.or = $.af;
$.pcm = $.am;
$.ps = $.af;
$.rm = $.af;
$.sah = $.dz;
$.sd = $.af;
$.sk = $.cs;
$.so = $.af;
$.sq = $.af;
$.sr = $.bs;
$.su = $.dz;
$.sv = $.ast;
$.sw = $.ast;
$.ta = $.af;
$.te = $.af;
$.th = $.dz;
$.ti = $.pa;
$.tk = $.af;
$.to = $.dz;
$.tr = $.af;
$.ug = $.af;
$.uk = $.ru;
$.ur = $.ast;
$.uz = $.af;
$.vi = $.dz;
$.wae = $.af;
$.wo = $.dz;
$.yi = $.ast;
$.yo = $.dz;
$.yue = $.dz;
$.zh = $.dz;
$.zu = $.am;
/* harmony default export */ var PluralRuleFunctions = ($);
//# sourceMappingURL=PluralRuleFunctions.js.map
// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/getPluralRulesLocale.js
/**
 * Returns a `locale` for which a function exists in `./PluralRuleFunctions.js`.
 * @param  {string} locale
 * @return {string}
 * @example
 * getPluralRulesLocale("ru-RU-Cyrl") // Returns "ru".
 */
function getPluralRulesLocale(locale) {
  // "pt" language is the only one having different pluralization rules
  // for the one ("pt") (Portuguese) locale and the other ("pt-PT") (European Portuguese).
  // http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html
  // (see the entries for "pt" and "pt_PT" there)
  if (locale === 'pt-PT') {
    return locale;
  }

  return getLanguageFromLanguageTag(locale);
}
/**
 * Extracts language from an IETF BCP 47 language tag.
 * @param {string} languageTag - IETF BCP 47 language tag.
 * @return {string}
 * @example
 * // Returns "he"
 * getLanguageFromLanguageTag("he-IL-u-ca-hebrew-tz-jeruslm")
 * // Returns "ar"
 * getLanguageFromLanguageTag("ar-u-nu-latn")
 */

var LANGUAGE_REG_EXP = /^([a-z0-9]+)/i;

function getLanguageFromLanguageTag(languageTag) {
  var match = languageTag.match(LANGUAGE_REG_EXP);

  if (!match) {
    throw new TypeError("Invalid locale: ".concat(languageTag));
  }

  return match[1];
}
//# sourceMappingURL=getPluralRulesLocale.js.map
// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/PluralRules.js
function PluralRules_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PluralRules_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PluralRules_createClass(Constructor, protoProps, staticProps) { if (protoProps) PluralRules_defineProperties(Constructor.prototype, protoProps); if (staticProps) PluralRules_defineProperties(Constructor, staticProps); return Constructor; }

// Importing `PluralRule` polyfill from a separate package
// results in a bundle that is larger by 1kB for some reason.
// export { default as default } from 'intl-plural-rules-polyfill/cardinal'


/**
 * `Intl.PluralRules` polyfill.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/PluralRules
 */

var PluralRules_PluralRules =
/*#__PURE__*/
function () {
  function PluralRules(locale, options) {
    PluralRules_classCallCheck(this, PluralRules);

    var locales = PluralRules.supportedLocalesOf(locale);

    if (locales.length === 0) {
      throw new RangeError("Unsupported locale: " + locale);
    }

    if (options && options.type !== "cardinal") {
      throw new RangeError("Only \"cardinal\" \"type\" is supported");
    }

    this.$ = PluralRuleFunctions[getPluralRulesLocale(locales[0])];
  }

  PluralRules_createClass(PluralRules, [{
    key: "select",
    value: function select(number) {
      return this.$(number);
    }
  }], [{
    key: "supportedLocalesOf",
    value: function supportedLocalesOf(locales) {
      if (typeof locales === "string") {
        locales = [locales];
      }

      return locales.filter(function (locale) {
        return PluralRuleFunctions[getPluralRulesLocale(locale)];
      });
    }
  }]);

  return PluralRules;
}();


//# sourceMappingURL=PluralRules.js.map
// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/RelativeTimeFormat.js
function RelativeTimeFormat_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { RelativeTimeFormat_typeof = function _typeof(obj) { return typeof obj; }; } else { RelativeTimeFormat_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return RelativeTimeFormat_typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { RelativeTimeFormat_defineProperty(target, key, source[key]); }); } return target; }

function RelativeTimeFormat_slicedToArray(arr, i) { return RelativeTimeFormat_arrayWithHoles(arr) || RelativeTimeFormat_iterableToArrayLimit(arr, i) || RelativeTimeFormat_nonIterableRest(); }

function RelativeTimeFormat_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function RelativeTimeFormat_iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function RelativeTimeFormat_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function RelativeTimeFormat_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RelativeTimeFormat_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function RelativeTimeFormat_createClass(Constructor, protoProps, staticProps) { if (protoProps) RelativeTimeFormat_defineProperties(Constructor.prototype, protoProps); if (staticProps) RelativeTimeFormat_defineProperties(Constructor, staticProps); return Constructor; }

function RelativeTimeFormat_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Importing `PluralRule` polyfill from a separate package
// results in a bundle that is larger by 1kB for some reason.
// import PluralRules from 'intl-plural-rules-polyfill/cardinal'
// Valid time units.

var UNITS = ["second", "minute", "hour", "day", "week", "month", "quarter", "year"]; // Valid values for the `numeric` option.

var NUMERIC_VALUES = ["auto", "always"]; // Valid values for the `style` option.

var STYLE_VALUES = ["long", "short", "narrow"]; // Valid values for the `localeMatcher` option.

var LOCALE_MATCHER_VALUES = ["lookup", "best fit"];
/**
 * Polyfill for `Intl.RelativeTimeFormat` proposal.
 * https://github.com/tc39/proposal-intl-relative-time
 * https://github.com/tc39/proposal-intl-relative-time/issues/55
 */

var RelativeTimeFormat_RelativeTimeFormat =
/*#__PURE__*/
function () {
  /**
   * @param {(string|string[])} [locales] - Preferred locales (or locale).
   * @param {Object} [options] - Formatting options.
   * @param {string} [options.style="long"] - One of: "long", "short", "narrow".
   * @param {string} [options.numeric="always"] - (Version >= 2) One of: "always", "auto".
   * @param {string} [options.localeMatcher="lookup"] - One of: "lookup", "best fit". Currently only "lookup" is supported.
   * @param {boolean} [options.styleFallback] - If "style" is missing from locale data then fall back to an existing one (for example, "long"). Is used in `javascript-time-ago`.
   */
  function RelativeTimeFormat() {
    var locales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    RelativeTimeFormat_classCallCheck(this, RelativeTimeFormat);

    RelativeTimeFormat_defineProperty(this, "numeric", "always");

    RelativeTimeFormat_defineProperty(this, "style", "long");

    RelativeTimeFormat_defineProperty(this, "localeMatcher", "lookup");

    var numeric = options.numeric,
        style = options.style,
        styleFallback = options.styleFallback,
        localeMatcher = options.localeMatcher; // Set `numeric` option.

    if (numeric !== undefined) {
      if (NUMERIC_VALUES.indexOf(numeric) < 0) {
        throw new RangeError("Invalid \"numeric\" option: ".concat(numeric));
      }

      this.numeric = numeric;
    } // Set `style` option.


    if (style !== undefined) {
      if (STYLE_VALUES.indexOf(style) < 0 && !styleFallback) {
        throw new RangeError("Invalid \"style\" option: ".concat(style));
      }

      this.style = style;
    } // Set `localeMatcher` option.


    if (localeMatcher !== undefined) {
      if (LOCALE_MATCHER_VALUES.indexOf(localeMatcher) < 0) {
        throw new RangeError("Invalid \"localeMatcher\" option: ".concat(localeMatcher));
      }

      this.localeMatcher = localeMatcher;
    } // Set `locale`.
    // Convert `locales` to an array.


    if (typeof locales === 'string') {
      locales = [locales];
    } // Add default locale.


    locales.push(getDefaultLocale()); // Choose the most appropriate locale.

    this.locale = RelativeTimeFormat.supportedLocalesOf(locales, {
      localeMatcher: this.localeMatcher
    })[0];

    if (!this.locale) {
      throw new Error("No supported locale was found");
    } // Construct an `Intl.PluralRules` instance (polyfill).


    if (PluralRules_PluralRules.supportedLocalesOf(this.locale).length > 0) {
      this.pluralRules = new PluralRules_PluralRules(this.locale);
    } else {
      console.warn("\"".concat(this.locale, "\" locale is not supported"));
    } // Use `Intl.NumberFormat` for formatting numbers (when available).


    if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
      this.numberFormat = new Intl.NumberFormat(this.locale);
      this.numberingSystem = this.numberFormat.resolvedOptions().numberingSystem;
    } else {
      this.numberingSystem = 'latn';
    }

    this.locale = resolveLocale_resolveLocale(this.locale, {
      localeMatcher: this.localeMatcher
    }); // Fall back to another style if `style` is not supported for the `locale`.

    if (styleFallback) {
      var styles = Object.keys(getLocaleData(this.locale));

      var _arr = [this.style].concat(STYLE_VALUES, [styles[0]]);

      for (var _i = 0; _i < _arr.length; _i++) {
        var _style = _arr[_i];

        if (styles.indexOf(_style) >= 0) {
          this.style = _style;
          break;
        }
      }
    }
  }
  /**
   * Formats time `number` in `units` (either in past or in future).
   * @param {number} number - Time interval value.
   * @param {string} unit - Time interval measurement unit.
   * @return {string}
   * @throws {RangeError} If unit is not one of "second", "minute", "hour", "day", "week", "month", "quarter".
   * @example
   * // Returns "2 days ago"
   * rtf.format(-2, "day")
   * // Returns "in 5 minutes"
   * rtf.format(5, "minute")
   */


  RelativeTimeFormat_createClass(RelativeTimeFormat, [{
    key: "format",
    value: function format() {
      var _parseFormatArgs = parseFormatArgs(arguments),
          _parseFormatArgs2 = RelativeTimeFormat_slicedToArray(_parseFormatArgs, 2),
          number = _parseFormatArgs2[0],
          unit = _parseFormatArgs2[1];

      return this.getRule(number, unit).replace('{0}', this.formatNumber(Math.abs(number)));
    }
    /**
     * Formats time `number` in `units` (either in past or in future).
     * @param {number} number - Time interval value.
     * @param {string} unit - Time interval measurement unit.
     * @return {Object[]} The parts (`{ type, value, unit? }`).
     * @throws {RangeError} If unit is not one of "second", "minute", "hour", "day", "week", "month", "quarter".
     * @example
     * // Version 1 (deprecated).
     * // Returns [
     * //   { type: "literal", value: "in " },
     * //   { type: "day", value: "100" },
     * //   { type: "literal", value: " days" }
     * // ]
     * rtf.formatToParts(100, "day")
     * //
     * // Version 2.
     * // Returns [
     * //   { type: "literal", value: "in " },
     * //   { type: "integer", value: "100", unit: "day" },
     * //   { type: "literal", value: " days" }
     * // ]
     * rtf.formatToParts(100, "day")
     */

  }, {
    key: "formatToParts",
    value: function formatToParts() {
      var _parseFormatArgs3 = parseFormatArgs(arguments),
          _parseFormatArgs4 = RelativeTimeFormat_slicedToArray(_parseFormatArgs3, 2),
          number = _parseFormatArgs4[0],
          unit = _parseFormatArgs4[1];

      var rule = this.getRule(number, unit);
      var valueIndex = rule.indexOf("{0}"); // "yesterday"/"today"/"tomorrow".

      if (valueIndex < 0) {
        return [{
          type: "literal",
          value: rule
        }];
      }

      var parts = [];

      if (valueIndex > 0) {
        parts.push({
          type: "literal",
          value: rule.slice(0, valueIndex)
        });
      }

      parts = parts.concat(this.formatNumberToParts(Math.abs(number)).map(function (part) {
        return _objectSpread({}, part, {
          unit: unit
        });
      }));

      if (valueIndex + "{0}".length < rule.length - 1) {
        parts.push({
          type: "literal",
          value: rule.slice(valueIndex + "{0}".length)
        });
      }

      return parts;
    }
    /**
     * Returns formatting rule for `value` in `units` (either in past or in future).
     * @param {number} value - Time interval value.
     * @param {string} unit - Time interval measurement unit.
     * @return {string}
     * @throws {RangeError} If unit is not one of "second", "minute", "hour", "day", "week", "month", "quarter".
     * @example
     * // Returns "{0} days ago"
     * getRule(-2, "day")
     */

  }, {
    key: "getRule",
    value: function getRule(value, unit) {
      // Get locale-specific time interval formatting rules
      // of a given `style` for the given value of measurement `unit`.
      //
      // E.g.:
      //
      // ```json
      // {
      //  "past": {
      //    "one": "a second ago",
      //    "other": "{0} seconds ago"
      //  },
      //  "future": {
      //    "one": "in a second",
      //    "other": "in {0} seconds"
      //  }
      // }
      // ```
      //
      var unitMessages = getLocaleData(this.locale)[this.style][unit]; // Bundle size optimization technique for styles like
      // "tiny" in `javascript-time-ago`: "1m", "2h", "3d"...

      if (typeof unitMessages === 'string') {
        return unitMessages;
      } // Special case for "yesterday"/"today"/"tomorrow".


      if (this.numeric === "auto") {
        // "yesterday", "the day before yesterday", etc.
        if (value === -2 || value === -1) {
          var message = unitMessages["previous".concat(value === -1 ? '' : '-' + Math.abs(value))];

          if (message) {
            return message;
          }
        } // "tomorrow", "the day after tomorrow", etc.
        else if (value === 1 || value === 2) {
            var _message = unitMessages["next".concat(value === 1 ? '' : '-' + Math.abs(value))];

            if (_message) {
              return _message;
            }
          } // "today"
          else if (value === 0) {
              if (unitMessages.current) {
                return unitMessages.current;
              }
            }
      } // Choose either "past" or "future" based on time `value` sign.
      // If there's only "other" then it's being collapsed.
      // (the resulting bundle size optimization technique)


      var pluralizedMessages = unitMessages[isNegative(value) ? "past" : "future"]; // Bundle size optimization technique for styles like "narrow"
      // having messages like "in {0} d." or "{0} d. ago".

      if (typeof pluralizedMessages === "string") {
        return pluralizedMessages;
      } // Quantify `value`.
      // There seems to be no such locale in CLDR
      // for which "plural rules" function is missing.


      var quantifier = this.pluralRules && this.pluralRules.select(Math.abs(value)) || 'other'; // "other" rule is supposed to be always present.
      // If only "other" rule is present then "rules" is not an object and is a string.

      return pluralizedMessages[quantifier] || pluralizedMessages.other;
    }
    /**
     * Formats a number into a string.
     * Uses `Intl.NumberFormat` when available.
     * @param  {number} number
     * @return {string}
     */

  }, {
    key: "formatNumber",
    value: function formatNumber(number) {
      return this.numberFormat ? this.numberFormat.format(number) : String(number);
    }
    /**
     * Formats a number into a list of parts.
     * Uses `Intl.NumberFormat` when available.
     * @param  {number} number
     * @return {object[]}
     */

  }, {
    key: "formatNumberToParts",
    value: function formatNumberToParts(number) {
      // `Intl.NumberFormat.formatToParts()` is not present, for example,
      // in Node.js 8.x while `Intl.NumberFormat` itself is present.
      return this.numberFormat && this.numberFormat.formatToParts ? this.numberFormat.formatToParts(number) : [{
        type: "integer",
        value: this.formatNumber(number)
      }];
    }
    /**
     * Returns a new object with properties reflecting the locale and date and time formatting options computed during initialization of this DateTimeFormat object.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/resolvedOptions
     * @return {Object}
     */

  }, {
    key: "resolvedOptions",
    value: function resolvedOptions() {
      return {
        locale: this.locale,
        style: this.style,
        numeric: this.numeric,
        numberingSystem: this.numberingSystem
      };
    }
  }]);

  return RelativeTimeFormat;
}();
/**
 * Returns an array containing those of the provided locales
 * that are supported in collation without having to fall back
 * to the runtime's default locale.
 * @param {(string|string[])} locale - A string with a BCP 47 language tag, or an array of such strings. For the general form of the locales argument, see the Intl page.
 * @param {Object} [options] - An object that may have the following property:
 * @param {string} [options.localeMatcher="lookup"] - The locale matching algorithm to use. Possible values are "lookup" and "best fit". Currently only "lookup" is supported.
 * @return {string[]} An array of strings representing a subset of the given locale tags that are supported in collation without having to fall back to the runtime's default locale.
 * @example
 * var locales = ['ban', 'id-u-co-pinyin', 'es-PY']
 * var options = { localeMatcher: 'lookup' }
 * // Returns ["id", "es-PY"]
 * Intl.RelativeTimeFormat.supportedLocalesOf(locales, options)
 */




RelativeTimeFormat_RelativeTimeFormat.supportedLocalesOf = function (locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Convert `locales` to an array.
  if (typeof locales === 'string') {
    locales = [locales];
  } else if (!Array.isArray(locales)) {
    throw new TypeError('Invalid "locales" argument');
  }

  return locales.filter(function (locale) {
    return resolveLocale_resolveLocale(locale, options);
  });
};
/**
 * Adds locale data for a specific locale.
 * @param {Object} localeData
 */


RelativeTimeFormat_RelativeTimeFormat.addLocale = addLocaleData;
/**
 * Sets default locale.
 * @param  {string} locale
 */

RelativeTimeFormat_RelativeTimeFormat.setDefaultLocale = setDefaultLocale;
/**
 * Gets default locale.
 * @return  {string} locale
 */

RelativeTimeFormat_RelativeTimeFormat.getDefaultLocale = getDefaultLocale;
/**
 * Export `Intl.PluralRules` just in case it's used somewhere else.
 */

RelativeTimeFormat_RelativeTimeFormat.PluralRules = PluralRules_PluralRules; // The specification allows units to be in plural form.
// Convert plural to singular.
// Example: "seconds" -> "second".

var UNIT_ERROR = 'Invalid "unit" argument';

function parseUnit(unit) {
  if (RelativeTimeFormat_typeof(unit) === 'symbol') {
    throw new TypeError(UNIT_ERROR);
  }

  if (typeof unit !== 'string') {
    throw new RangeError("".concat(UNIT_ERROR, ": ").concat(unit));
  }

  if (unit[unit.length - 1] === 's') {
    unit = unit.slice(0, unit.length - 1);
  }

  if (UNITS.indexOf(unit) < 0) {
    throw new RangeError("".concat(UNIT_ERROR, ": ").concat(unit));
  }

  return unit;
} // Converts `value` to a `Number`.
// The specification allows value to be a non-number.
// For example, "-0" is supposed to be treated as `-0`.
// Also checks if `value` is a finite number.


var NUMBER_ERROR = 'Invalid "number" argument';

function parseNumber(value) {
  value = Number(value);

  if (Number.isFinite) {
    if (!Number.isFinite(value)) {
      throw new RangeError("".concat(NUMBER_ERROR, ": ").concat(value));
    }
  }

  return value;
}
/**
 * Tells `0` from `-0`.
 * https://stackoverflow.com/questions/7223359/are-0-and-0-the-same
 * @param  {number} number
 * @return {Boolean}
 * @example
 * isNegativeZero(0); // false
 * isNegativeZero(-0); // true
 */


function isNegativeZero(number) {
  return 1 / number === -Infinity;
}

function isNegative(number) {
  return number < 0 || number === 0 && isNegativeZero(number);
}

function parseFormatArgs(args) {
  if (args.length < 2) {
    throw new TypeError("\"unit\" argument is required");
  }

  return [parseNumber(args[0]), parseUnit(args[1])];
}
//# sourceMappingURL=RelativeTimeFormat.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/cache.js
function cache_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { cache_typeof = function _typeof(obj) { return typeof obj; }; } else { cache_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return cache_typeof(obj); }

function cache_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cache_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function cache_createClass(Constructor, protoProps, staticProps) { if (protoProps) cache_defineProperties(Constructor.prototype, protoProps); if (staticProps) cache_defineProperties(Constructor, staticProps); return Constructor; }

function cache_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A basic in-memory cache.
 *
 * import Cache from 'javascript-time-ago/Cache'
 * const cache = new Cache()
 * const object = cache.get('key1', 'key2', ...) || cache.put('key1', 'key2', ..., createObject())
 */
var Cache =
/*#__PURE__*/
function () {
  function Cache() {
    cache_classCallCheck(this, Cache);

    cache_defineProperty(this, "cache", {});
  }

  cache_createClass(Cache, [{
    key: "get",
    value: function get() {
      var cache = this.cache;

      for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
        keys[_key] = arguments[_key];
      }

      for (var _i = 0; _i < keys.length; _i++) {
        var key = keys[_i];

        if (cache_typeof(cache) !== 'object') {
          return;
        }

        cache = cache[key];
      }

      return cache;
    }
  }, {
    key: "put",
    value: function put() {
      for (var _len2 = arguments.length, keys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        keys[_key2] = arguments[_key2];
      }

      var value = keys.pop();
      var lastKey = keys.pop();
      var cache = this.cache;

      for (var _i2 = 0; _i2 < keys.length; _i2++) {
        var key = keys[_i2];

        if (cache_typeof(cache[key]) !== 'object') {
          cache[key] = {};
        }

        cache = cache[key];
      }

      return cache[lastKey] = value;
    }
  }]);

  return Cache;
}();


//# sourceMappingURL=cache.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/locale.js
function locale_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { locale_typeof = function _typeof(obj) { return typeof obj; }; } else { locale_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return locale_typeof(obj); }

/**
 * Chooses the most appropriate locale
 * (one of the registered ones)
 * based on the list of preferred `locales` supplied by the user.
 *
 * @param {string[]} locales - the list of preferable locales (in [IETF format](https://en.wikipedia.org/wiki/IETF_language_tag)).
 * @param {Function} isLocaleDataAvailable - tests if a locale is available.
 *
 * @returns {string} The most suitable locale.
 *
 * @example
 * // Returns 'en'
 * chooseLocale(['en-US'], undefined, (locale) => locale === 'ru' || locale === 'en')
 */
function chooseLocale(locales, isLocaleDataAvailable) {
  // This is not an intelligent algorithm,
  // but it will do for this library's case.
  // `sr-Cyrl-BA` -> `sr-Cyrl` -> `sr`.
  for (var _iterator = locales, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var locale = _ref;

    if (isLocaleDataAvailable(locale)) {
      return locale;
    }

    var parts = locale.split('-');

    while (parts.length > 1) {
      parts.pop();
      locale = parts.join('-');

      if (isLocaleDataAvailable(locale)) {
        return locale;
      }
    }
  }

  throw new Error("No locale data has been registered for any of the locales: ".concat(locales.join(', ')));
}
/**
 * Whether can use `Intl.DateTimeFormat` for these `locales`.
 * Returns the first suitable one.
 * @param  {(string|string[])} locales
 * @return {?string} The first locale that can be used.
 */

function intlDateTimeFormatSupportedLocale(locales) {
  /* istanbul ignore else */
  if (intlDateTimeFormatSupported()) {
    return Intl.DateTimeFormat.supportedLocalesOf(locales)[0];
  }
}
/**
 * Whether can use `Intl.DateTimeFormat`.
 * @return {boolean}
 */

function intlDateTimeFormatSupported() {
  // Babel transforms `typeof` into some "branches"
  // so istanbul will show this as "branch not covered".

  /* istanbul ignore next */
  var isIntlAvailable = (typeof Intl === "undefined" ? "undefined" : locale_typeof(Intl)) === 'object';
  return isIntlAvailable && typeof Intl.DateTimeFormat === 'function';
}
//# sourceMappingURL=locale.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/units.js
var minute = 60; // in seconds

var hour = 60 * minute; // in seconds

var day = 24 * hour; // in seconds

var week = 7 * day; // in seconds
// https://www.quora.com/What-is-the-average-number-of-days-in-a-month

var month = 30.44 * day; // in seconds
// "400 years have 146097 days (taking into account leap year rules)"

var year = 146097 / 400 * day; // in seconds

function getSecondsInUnit(unit) {
  switch (unit) {
    case 'second':
      return 1;

    case 'minute':
      return minute;

    case 'hour':
      return hour;

    case 'day':
      return day;

    case 'week':
      return week;

    case 'month':
      return month;

    case 'year':
      return year;
  }
} // export function getPreviousUnitFor(unit) {
// 	switch (unit) {
// 		case 'second':
// 			return 'now'
// 		case 'minute':
// 			return 'second'
// 		case 'hour':
// 			return 'minute'
// 		case 'day':
// 			return 'hour'
// 		case 'week':
// 			return 'day'
// 		case 'month':
// 			return 'week'
// 		case 'year':
// 			return 'month'
// 	}
// }
//# sourceMappingURL=units.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/getStepDenominator.js

function getStepDenominator(step) {
  // `factor` is a legacy property.
  if (step.factor !== undefined) {
    return step.factor;
  } // "unit" is now called "formatAs".


  return getSecondsInUnit(step.unit || step.formatAs) || 1;
}
//# sourceMappingURL=getStepDenominator.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/round.js
function getRoundFunction(round) {
  switch (round) {
    case 'floor':
      return Math.floor;

    default:
      return Math.round;
  }
} // For non-negative numbers.

function getDiffRatioToNextRoundedNumber(round) {
  switch (round) {
    case 'floor':
      // Math.floor(x) = x
      // Math.floor(x + 1) = x + 1
      return 1;

    default:
      // Math.round(x) = x
      // Math.round(x + 0.5) = x + 1
      return 0.5;
  }
}
//# sourceMappingURL=round.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/getStepMinTime.js
function getStepMinTime_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { getStepMinTime_typeof = function _typeof(obj) { return typeof obj; }; } else { getStepMinTime_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return getStepMinTime_typeof(obj); }



function getStepMinTime(step, _ref) {
  var prevStep = _ref.prevStep,
      timestamp = _ref.timestamp,
      now = _ref.now,
      future = _ref.future,
      round = _ref.round;
  var minTime; // "threshold_for_xxx" is a legacy property.

  if (prevStep) {
    if (prevStep.id || prevStep.unit) {
      minTime = step["threshold_for_".concat(prevStep.id || prevStep.unit)];
    }
  }

  if (minTime === undefined) {
    // "threshold" is a legacy property.
    if (step.threshold !== undefined) {
      // "threshold" is a legacy name for "minTime".
      minTime = step.threshold; // "threshold" function is deprecated.

      if (typeof minTime === 'function') {
        minTime = minTime(now, future);
      }
    }
  }

  if (minTime === undefined) {
    minTime = step.minTime;
  } // A deprecated way of specifying a different threshold
  // depending on the previous step's unit.


  if (getStepMinTime_typeof(minTime) === 'object') {
    if (prevStep && prevStep.id && minTime[prevStep.id] !== undefined) {
      minTime = minTime[prevStep.id];
    } else {
      minTime = minTime.default;
    }
  }

  if (typeof minTime === 'function') {
    minTime = minTime(timestamp, {
      future: future,
      getMinTimeForUnit: function getMinTimeForUnit(toUnit, fromUnit) {
        return _getMinTimeForUnit(toUnit, fromUnit || prevStep && prevStep.formatAs, {
          round: round
        });
      }
    });
  } // Evaluate the `test()` function.
  // `test()` function is deprecated.


  if (minTime === undefined) {
    if (step.test) {
      if (step.test(timestamp, {
        now: now,
        future: future
      })) {
        // `0` threshold always passes.
        minTime = 0;
      } else {
        // `MAX_SAFE_INTEGER` threshold won't ever pass in real life.
        minTime = 9007199254740991; // Number.MAX_SAFE_INTEGER
      }
    }
  }

  if (minTime === undefined) {
    if (prevStep) {
      if (step.formatAs && prevStep.formatAs) {
        minTime = _getMinTimeForUnit(step.formatAs, prevStep.formatAs, {
          round: round
        });
      }
    } else {
      // The first step's `minTime` is `0` by default.
      minTime = 0;
    }
  } // Warn if no `minTime` was defined or could be deduced.


  if (minTime === undefined) {
    console.warn('[javascript-time-ago] A step should specify `minTime`:\n' + JSON.stringify(step, null, 2));
  }

  return minTime;
}

function _getMinTimeForUnit(toUnit, fromUnit, _ref2) {
  var round = _ref2.round;
  var toUnitAmount = getSecondsInUnit(toUnit); // if (!fromUnit) {
  // 	return toUnitAmount;
  // }
  // if (!fromUnit) {
  // 	fromUnit = getPreviousUnitFor(toUnit)
  // }

  var fromUnitAmount;

  if (fromUnit === 'now') {
    fromUnitAmount = getSecondsInUnit(toUnit);
  } else {
    fromUnitAmount = getSecondsInUnit(fromUnit);
  }

  if (toUnitAmount !== undefined && fromUnitAmount !== undefined) {
    return toUnitAmount - fromUnitAmount * (1 - getDiffRatioToNextRoundedNumber(round));
  }
}
//# sourceMappingURL=getStepMinTime.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/getStep.js
function getStep_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { getStep_defineProperty(target, key, source[key]); }); } return target; }

function getStep_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/**
 * Finds an appropriate `step` of `steps` for the time interval (in seconds).
 *
 * @param {Object[]} steps - Time formatting steps.
 *
 * @param {number} secondsPassed - Time interval (in seconds).
 *                                 `< 0` for past dates and `> 0` for future dates.
 *
 * @param {number} options.now - Current timestamp.
 *
 * @param {boolean} [options.future] - Whether the date should be formatted as a future one
 *                                     instead of a past one.
 *
 * @param {string} [options.round] - (undocumented) Rounding mechanism.
 *
 * @param {string[]} [options.units] - A list of allowed time units.
 *                                     (Example: ['second', 'minute', 'hour', …])
 *
 * @param {boolean} [options.getNextStep] - Pass true to return `[step, nextStep]` instead of just `step`.
 *
 * @return {Object|Object[]} [step] — Either a `step` or `[prevStep, step, nextStep]`.
 */

function getStep(steps, secondsPassed, _ref) {
  var now = _ref.now,
      future = _ref.future,
      round = _ref.round,
      units = _ref.units,
      getNextStep = _ref.getNextStep;
  // Ignore steps having not-supported time units in `formatAs`.
  steps = filterStepsByUnits(steps, units);

  var step = getStep_getStep(steps, secondsPassed, {
    now: now,
    future: future,
    round: round
  });

  if (getNextStep) {
    if (step) {
      var prevStep = steps[steps.indexOf(step) - 1];
      var nextStep = steps[steps.indexOf(step) + 1];
      return [prevStep, step, nextStep];
    }

    return [undefined, undefined, steps[0]];
  }

  return step;
}

function getStep_getStep(steps, secondsPassed, _ref2) {
  var now = _ref2.now,
      future = _ref2.future,
      round = _ref2.round;

  // If no steps fit the conditions then return nothing.
  if (steps.length === 0) {
    return;
  } // Find the most appropriate step.


  var i = getStepIndex(steps, secondsPassed, {
    now: now,
    future: future || secondsPassed < 0,
    round: round
  }); // If no step is applicable the return nothing.

  if (i === -1) {
    return;
  }

  var step = steps[i]; // Apply granularity to the time amount
  // (and fall back to the previous step
  //  if the first level of granularity
  //  isn't met by this amount)

  if (step.granularity) {
    // Recalculate the amount of seconds passed based on `granularity`.
    var secondsPassedGranular = getRoundFunction(round)(Math.abs(secondsPassed) / getStepDenominator(step) / step.granularity) * step.granularity; // If the granularity for this step is too high,
    // then fall back to the previous step.
    // (if there is any previous step)

    if (secondsPassedGranular === 0 && i > 0) {
      return steps[i - 1];
    }
  }

  return step;
}
/**
 * Iterates through steps until it finds the maximum one satisfying the `minTime` threshold.
 * @param  {Object} steps - Steps.
 * @param  {number} secondsPassed - How much seconds have passed since the date till `now`.
 * @param  {number} options.now - Current timestamp.
 * @param  {boolean} options.future - Whether the time interval should be formatted as a future one.
 * @param  {number} [i] - Gradation step currently being tested.
 * @return {number} Gradation step index.
 */


function getStepIndex(steps, secondsPassed, options) {
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var minTime = getStepMinTime(steps[i], getStep_objectSpread({
    prevStep: steps[i - 1],
    timestamp: options.now - secondsPassed * 1000
  }, options)); // If `minTime` isn't defined or deduceable for this step, then stop.

  if (minTime === undefined) {
    return i - 1;
  } // If the `minTime` threshold for moving from previous step
  // to this step is too high then return the previous step.


  if (Math.abs(secondsPassed) < minTime) {
    return i - 1;
  } // If it's the last step then return it.


  if (i === steps.length - 1) {
    return i;
  } // Move to the next step.


  return getStepIndex(steps, secondsPassed, options, i + 1);
}
/**
 * Leaves only allowed steps.
 * @param  {Object[]} steps
 * @param  {string[]} units - Allowed time units.
 * @return {Object[]}
 */


function filterStepsByUnits(steps, units) {
  return steps.filter(function (_ref3) {
    var unit = _ref3.unit,
        formatAs = _ref3.formatAs;
    // "unit" is now called "formatAs".
    unit = unit || formatAs; // If this step has a `unit` defined
    // then this `unit` must be in the list of allowed `units`.

    if (unit) {
      return units.indexOf(unit) >= 0;
    } // A step is not required to specify a `unit`:
    // alternatively, it could specify `format()`.
    // (see "twitter" style for an example)


    return true;
  });
}
//# sourceMappingURL=getStep.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/getTimeToNextUpdateForUnit.js


/**
 * Gets the time to next update for a step with a time unit defined.
 * @param  {string} unit
 * @param  {number} date — The date passed to `.format()`, converted to a timestamp.
 * @param  {number} options.now
 * @param  {string} [options.round] — (undocumented) Rounding mechanism.
 * @return {number} [timeToNextUpdate]
 */

function getTimeToNextUpdateForUnit_getTimeToNextUpdateForUnit(unit, timestamp, _ref) {
  var now = _ref.now,
      round = _ref.round;

  // For some units, like "now", there's no defined amount of seconds in them.
  if (!getSecondsInUnit(unit)) {
    // If there's no amount of seconds defined for this unit
    // then the update interval can't be determined reliably.
    return;
  }

  var unitDenominator = getSecondsInUnit(unit) * 1000;
  var future = timestamp > now;
  var preciseAmount = Math.abs(timestamp - now);
  var roundedAmount = getRoundFunction(round)(preciseAmount / unitDenominator) * unitDenominator;

  if (future) {
    if (roundedAmount > 0) {
      // Amount decreases with time.
      return preciseAmount - roundedAmount + getDiffToPreviousRoundedNumber(round, unitDenominator);
    } else {
      // Refresh right after the zero point,
      // when "future" changes to "past".
      return preciseAmount - roundedAmount + 1;
    }
  } // Amount increases with time.


  return -(preciseAmount - roundedAmount) + getDiffToNextRoundedNumber(round, unitDenominator);
}

function getDiffToNextRoundedNumber(round, unitDenominator) {
  return getDiffRatioToNextRoundedNumber(round) * unitDenominator;
}

function getDiffToPreviousRoundedNumber(round, unitDenominator) {
  return (1 - getDiffRatioToNextRoundedNumber(round)) * unitDenominator + 1;
}
//# sourceMappingURL=getTimeToNextUpdateForUnit.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/getTimeToNextUpdate.js


 // A thousand years is practically a metaphor for "infinity".

var YEAR = 365 * 24 * 60 * 60 * 1000;
var INFINITY = 1000 * YEAR;
/**
 * Gets the time to next update for a date and a step.
 * @param  {number} date — The date passed to `.format()`, converted to a timestamp.
 * @param  {object} step
 * @param  {object} [options.previousStep]
 * @param  {object} [options.nextStep]
 * @param  {number} options.now
 * @param  {boolean} options.future
 * @param  {string} [options.round] - (undocumented) Rounding mechanism.
 * @return {number} [timeToNextUpdate]
 */

function getTimeToNextUpdate(date, step, _ref) {
  var prevStep = _ref.prevStep,
      nextStep = _ref.nextStep,
      now = _ref.now,
      future = _ref.future,
      round = _ref.round;
  var timestamp = date.getTime ? date.getTime() : date;

  var getTimeToNextUpdateForUnit = function getTimeToNextUpdateForUnit(unit) {
    return getTimeToNextUpdateForUnit_getTimeToNextUpdateForUnit(unit, timestamp, {
      now: now,
      round: round
    });
  }; // For future dates, steps move from the last one to the first one,
  // while for past dates, steps move from the first one to the last one,
  // due to the fact that time flows in one direction,
  // and future dates' interval naturally becomes smaller
  // while past dates' interval naturally grows larger.
  //
  // For future dates, it's the transition
  // from the current step to the previous step,
  // therefore check the `minTime` of the current step.
  //
  // For past dates, it's the transition
  // from the current step to the next step,
  // therefore check the `minTime` of the next step.
  //


  var timeToStepChange = getTimeToStepChange(future ? step : nextStep, timestamp, {
    future: future,
    now: now,
    round: round,
    prevStep: future ? prevStep : step // isFirstStep: future && isFirstStep

  });

  if (timeToStepChange === undefined) {
    // Can't reliably determine "time to next update"
    // if not all of the steps provide `minTime`.
    return;
  }

  var timeToNextUpdate;

  if (step) {
    if (step.getTimeToNextUpdate) {
      timeToNextUpdate = step.getTimeToNextUpdate(timestamp, {
        getTimeToNextUpdateForUnit: getTimeToNextUpdateForUnit,
        getRoundFunction: getRoundFunction,
        now: now,
        future: future,
        round: round
      });
    }

    if (timeToNextUpdate === undefined) {
      // "unit" is now called "formatAs".
      var unit = step.unit || step.formatAs;

      if (unit) {
        // For some units, like "now", there's no defined amount of seconds in them.
        // In such cases, `getTimeToNextUpdateForUnit()` returns `undefined`,
        // and the next step's `minTime` could be used to calculate the update interval:
        // it will just assume that the label never changes for this step.
        timeToNextUpdate = getTimeToNextUpdateForUnit(unit);
      }
    }
  }

  if (timeToNextUpdate === undefined) {
    return timeToStepChange;
  }

  return Math.min(timeToNextUpdate, timeToStepChange);
}
function getStepChangesAt(currentOrNextStep, timestamp, _ref2) {
  var now = _ref2.now,
      future = _ref2.future,
      round = _ref2.round,
      prevStep = _ref2.prevStep;
  // The first step's `minTime` is `0` by default.
  // It doesn't "change" steps at zero point
  // but it does change the wording when switching
  // from "future" to "past": "in ..." -> "... ago".
  // Therefore, the label should be updated at zero-point too.
  var minTime = getStepMinTime(currentOrNextStep, {
    timestamp: timestamp,
    now: now,
    future: future,
    round: round,
    prevStep: prevStep
  });

  if (minTime === undefined) {
    return;
  }

  if (future) {
    // The step changes to the previous step
    // as soon as `timestamp - now` becomes
    // less than the `minTime` of the current step:
    // `timestamp - now === minTime - 1`
    // => `now === timestamp - minTime + 1`.
    return timestamp - minTime * 1000 + 1;
  } else {
    // The step changes to the next step
    // as soon as `now - timestamp` becomes
    // equal to `minTime` of the next step:
    // `now - timestamp === minTime`
    // => `now === timestamp + minTime`.
    // This is a special case when double-update could be skipped.
    if (minTime === 0 && timestamp === now) {
      return INFINITY;
    }

    return timestamp + minTime * 1000;
  }
}
function getTimeToStepChange(step, timestamp, _ref3) {
  var now = _ref3.now,
      future = _ref3.future,
      round = _ref3.round,
      prevStep = _ref3.prevStep;

  if (step) {
    var stepChangesAt = getStepChangesAt(step, timestamp, {
      now: now,
      future: future,
      round: round,
      prevStep: prevStep
    });

    if (stepChangesAt === undefined) {
      return;
    }

    return stepChangesAt - now;
  } else {
    if (future) {
      // No step.
      // Update right after zero point, when it changes from "future" to "past".
      return timestamp - now + 1;
    } else {
      // The last step doesn't ever change when `date` is in the past.
      return INFINITY;
    }
  }
}
//# sourceMappingURL=getTimeToNextUpdate.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/LocaleDataStore.js
// For all locales added
// their relative time formatter messages will be stored here.
var LocaleDataStore_localesData = {};
function LocaleDataStore_getLocaleData(locale) {
  return LocaleDataStore_localesData[locale];
}
function LocaleDataStore_addLocaleData(localeData) {
  if (!localeData) {
    throw new Error('[javascript-time-ago] No locale data passed.');
  } // This locale data is stored in a global variable
  // and later used when calling `.format(time)`.


  LocaleDataStore_localesData[localeData.locale] = localeData;
}
//# sourceMappingURL=LocaleDataStore.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/round.js
// just now
// 1 second ago
// 2 seconds ago
// …
// 59 seconds ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 hour ago
// 2 hours ago
// …
// 24 hours ago
// 1 day ago
// 2 days ago
// …
// 6 days ago
// 1 week ago
// 2 weeks ago
// …
// 3 weeks ago
// 1 month ago
// 2 months ago
// …
// 11 months ago
// 1 year ago
// 2 years ago
// …
/* harmony default export */ var steps_round = ([{
  formatAs: 'now'
}, {
  formatAs: 'second'
}, {
  formatAs: 'minute'
}, {
  formatAs: 'hour'
}, {
  formatAs: 'day'
}, {
  formatAs: 'week'
}, {
  formatAs: 'month'
}, {
  formatAs: 'year'
}]);
//# sourceMappingURL=round.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/round.js
 // just now
// 1 second ago
// 2 seconds ago
// …
// 59 seconds ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 hour ago
// 2 hours ago
// …
// 24 hours ago
// 1 day ago
// 2 days ago
// …
// 6 days ago
// 1 week ago
// 2 weeks ago
// 3 weeks ago
// 4 weeks ago
// 1 month ago
// 2 months ago
// …
// 11 months ago
// 1 year ago
// 2 years ago
// …
//

/* harmony default export */ var style_round = ({
  steps: steps_round,
  labels: 'long'
});
//# sourceMappingURL=round.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/roundMinute.js
function roundMinute_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { roundMinute_defineProperty(target, key, source[key]); }); } return target; }

function roundMinute_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // just now
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 hour ago
// 2 hours ago
// …
// 24 hours ago
// 1 day ago
// 2 days ago
// …
// 6 days ago
// 1 week ago
// 2 weeks ago
// 3 weeks ago
// 4 weeks ago
// 1 month ago
// 2 months ago
// …
// 11 months ago
// 1 year ago
// 2 years ago
// …
//

/* harmony default export */ var roundMinute = (roundMinute_objectSpread({}, style_round, {
  // Skip "seconds".
  steps: style_round.steps.filter(function (step) {
    return step.formatAs !== 'second';
  })
}));
//# sourceMappingURL=roundMinute.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/approximate.js
 // "factor" is a legacy property.
// Developers shouldn't need to use it in their custom steps.
// "threshold" is a legacy name of "min".
// Developers should use "min" property name instead of "threshold".
// "threshold_for_idOrUnit: value" is a legacy way of specifying "min: { id: value }".
// Developers should use "min" property instead of "threshold".
// just now
// 1 minute ago
// 2 minutes ago
// 5 minutes ago
// 10 minutes ago
// 15 minutes ago
// 20 minutes ago
// …
// 50 minutes ago
// an hour ago
// 2 hours ago
// …
// 20 hours ago
// a day ago
// 2 days ago
// 5 days ago
// a week ago
// 2 weeks ago
// 3 weeks ago
// a month ago
// 2 months ago
// 4 months ago
// a year ago
// 2 years ago
// …

/* harmony default export */ var approximate = ([{
  // This step returns the amount of seconds
  // by dividing the amount of seconds by `1`.
  factor: 1,
  // "now" labels are used for formatting the output.
  unit: 'now'
}, {
  // When the language doesn't support `now` unit,
  // the first step is ignored, and it uses this `second` unit.
  threshold: 1,
  // `threshold_for_now` should be the same as `threshold` on minutes.
  threshold_for_now: 45.5,
  // This step returns the amount of seconds
  // by dividing the amount of seconds by `1`.
  factor: 1,
  // "second" labels are used for formatting the output.
  unit: 'second'
}, {
  // `threshold` should be the same as `threshold_for_now` on seconds.
  threshold: 45.5,
  // Return the amount of minutes by dividing the amount
  // of seconds by the amount of seconds in a minute.
  factor: minute,
  // "minute" labels are used for formatting the output.
  unit: 'minute'
}, {
  // This step is effective starting from 2.5 minutes.
  threshold: 2.5 * minute,
  // Allow only 5-minute increments of minutes starting from 2.5 minutes.
  // `granularity` — (advanced) Time interval value "granularity".
  // For example, it could be set to `5` for minutes to allow only 5-minute increments
  // when formatting time intervals: `0 minutes`, `5 minutes`, `10 minutes`, etc.
  // Perhaps this feature will be removed because there seem to be no use cases
  // of it in the real world.
  granularity: 5,
  // Return the amount of minutes by dividing the amount
  // of seconds by the amount of seconds in a minute.
  factor: minute,
  // "minute" labels are used for formatting the output.
  unit: 'minute'
}, {
  // This step is effective starting from 22.5 minutes.
  threshold: 22.5 * minute,
  // Return the amount of minutes by dividing the amount
  // of seconds by the amount of seconds in  half-an-hour.
  factor: 0.5 * hour,
  // "half-hour" labels are used for formatting the output.
  // (if available, which is no longer the case)
  unit: 'half-hour'
}, {
  // This step is effective starting from 42.5 minutes.
  threshold: 42.5 * minute,
  threshold_for_minute: 52.5 * minute,
  // Return the amount of minutes by dividing the amount
  // of seconds by the amount of seconds in an hour.
  factor: hour,
  // "hour" labels are used for formatting the output.
  unit: 'hour'
}, {
  // This step is effective starting from 20.5 hours.
  threshold: 20.5 / 24 * day,
  // Return the amount of minutes by dividing the amount
  // of seconds by the amount of seconds in a day.
  factor: day,
  // "day" labels are used for formatting the output.
  unit: 'day'
}, {
  // This step is effective starting from 5.5 days.
  threshold: 5.5 * day,
  // Return the amount of minutes by dividing the amount
  // of seconds by the amount of seconds in a week.
  factor: week,
  // "week" labels are used for formatting the output.
  unit: 'week'
}, {
  // This step is effective starting from 3.5 weeks.
  threshold: 3.5 * week,
  // Return the amount of minutes by dividing the amount
  // of seconds by the amount of seconds in a month.
  factor: month,
  // "month" labels are used for formatting the output.
  unit: 'month'
}, {
  // This step is effective starting from 10.5 months.
  threshold: 10.5 * month,
  // Return the amount of minutes by dividing the amount
  // of seconds by the amount of seconds in a year.
  factor: year,
  // "year" labels are used for formatting the output.
  unit: 'year'
}]);
//# sourceMappingURL=approximate.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/approximate.js
 // "gradation" is a legacy name for "steps".
// It's here just for legacy compatibility.
// Use "steps" name instead.
// "flavour" is a legacy name for "labels".
// It's here just for legacy compatibility.
// Use "labels" name instead.
// "units" is a legacy property.
// It's here just for legacy compatibility.
// Developers shouldn't need to use it in their custom styles.

/* harmony default export */ var style_approximate = ({
  gradation: approximate,
  flavour: 'long',
  units: ['now', 'minute', 'hour', 'day', 'week', 'month', 'year']
});
//# sourceMappingURL=approximate.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/approximateTime.js
 // "gradation" is a legacy name for "steps".
// It's here just for legacy compatibility.
// Use "steps" name instead.
// "flavour" is a legacy name for "labels".
// It's here just for legacy compatibility.
// Use "labels" name instead.
// "units" is a legacy property.
// It's here just for legacy compatibility.
// Developers shouldn't need to use it in their custom styles.
// Similar to the default style but with "ago" omitted.
//
// just now
// 5 minutes
// 10 minutes
// 15 minutes
// 20 minutes
// an hour
// 2 hours
// …
// 20 hours
// 1 day
// 2 days
// a week
// 2 weeks
// 3 weeks
// a month
// 2 months
// 3 months
// 4 months
// a year
// 2 years
//

/* harmony default export */ var approximateTime = ({
  gradation: approximate,
  flavour: 'long-time',
  units: ['now', 'minute', 'hour', 'day', 'week', 'month', 'year']
});
//# sourceMappingURL=approximateTime.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/steps/helpers.js
// Looks like this one's deprecated.
// /**
//  * Returns a step corresponding to the unit.
//  * @param  {Object[]} steps
//  * @param  {string} unit
//  * @return {?Object}
//  */
// export function getStepForUnit(steps, unit) {
// 	for (const step of steps) {
// 		if (step.unit === unit) {
// 			return step
// 		}
// 	}
// }
// Looks like this one won't be used in the next major version.

/**
 * Converts value to a `Date`
 * @param {(number|Date)} value
 * @return {Date}
 */
function getDate(value) {
  return value instanceof Date ? value : new Date(value);
}
//# sourceMappingURL=helpers.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/twitter.js

 // For compatibility with the old versions of this library.

 // Twitter-style relative date/time formatting.
// ("1m", "2h", "Mar 3", "Apr 4, 2012").
//
// Seconds, minutes or hours are shown for shorter intervals,
// and longer intervals are formatted using full date format.

var twitter_steps = [{
  formatAs: 'second'
}, {
  formatAs: 'minute'
}, {
  formatAs: 'hour'
}]; // A cache for `Intl.DateTimeFormat` formatters
// for various locales (is a global variable).

var formatters = {}; // Starting from day intervals, output month and day.

var monthAndDay = {
  minTime: function minTime(timestamp, _ref) {
    var future = _ref.future,
        getMinTimeForUnit = _ref.getMinTimeForUnit;
    // Returns `23.5 * 60 * 60` when `round` is "round",
    // and `24 * 60 * 60` when `round` is "floor".
    return getMinTimeForUnit('day');
  },
  format: function format(value, locale) {
    /* istanbul ignore else */
    if (!formatters[locale]) {
      formatters[locale] = {};
    }
    /* istanbul ignore else */


    if (!formatters[locale].dayMonth) {
      // "Apr 11" (MMMd)
      formatters[locale].dayMonth = new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric'
      });
    } // Output month and day.


    return formatters[locale].dayMonth.format(getDate(value));
  }
}; // If the `date` happened/happens outside of current year,
// then output day, month and year.
// The interval should be such that the `date` lies outside of the current year.

var yearMonthAndDay = {
  minTime: function minTime(timestamp, _ref2) {
    var future = _ref2.future;

    if (future) {
      // January 1, 00:00, of the `date`'s year is right after
      // the maximum `now` for formatting a future date:
      // When `now` is before that date, the `date` is formatted as "day/month/year" (this step),
      // When `now` is equal to or after that date, the `date` is formatted as "day/month" (another step).
      // After that, it's hours, minutes, seconds, and after that it's no longer `future`.
      // The date is right after the maximum `now` for formatting a future date,
      // so subtract 1 millisecond from it.
      var maxFittingNow = new Date(new Date(timestamp).getFullYear(), 0).getTime() - 1; // Return `minTime` (in seconds).

      return (timestamp - maxFittingNow) / 1000;
    } else {
      // January 1, 00:00, of the year following the `date`'s year
      // is the minimum `now` for formatting a past date:
      // When `now` is before that date, the `date` is formatted as "day/month" (another step),
      // When `now` is equal to or after that date, the `date` is formatted as "day/month/year" (this step).
      // After that, it's hours, minutes, seconds, and after that it's no longer `future`.
      var minFittingNow = new Date(new Date(timestamp).getFullYear() + 1, 0).getTime(); // Return `minTime` (in seconds).

      return (minFittingNow - timestamp) / 1000;
    }
  },
  format: function format(value, locale) {
    /* istanbul ignore if */
    if (!formatters[locale]) {
      formatters[locale] = {};
    }
    /* istanbul ignore else */


    if (!formatters[locale].dayMonthYear) {
      // "Apr 11, 2017" (yMMMd)
      formatters[locale].dayMonthYear = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } // Output day, month and year.


    return formatters[locale].dayMonthYear.format(getDate(value));
  }
}; // If `Intl.DateTimeFormat` is supported,
// then longer time intervals will be formatted as dates.

/* istanbul ignore else */

if (intlDateTimeFormatSupported()) {
  twitter_steps.push(monthAndDay, yearMonthAndDay);
} // Otherwise, if `Intl.DateTimeFormat` is not supported,
// which could be the case when using Internet Explorer,
// then simply mimick "round" steps.
else {
    twitter_steps.push({
      formatAs: 'day'
    }, {
      formatAs: 'week'
    }, {
      formatAs: 'month'
    }, {
      formatAs: 'year'
    });
  }

/* harmony default export */ var twitter = ({
  steps: twitter_steps,
  labels: [// "mini" labels are only defined for a few languages.
  'mini', // "short-time" labels are only defined for a few languages.
  'short-time', // "narrow" and "short" labels are defined for all languages.
  // "narrow" labels can sometimes be weird (like "+5d."),
  // but "short" labels have the " ago" part, so "narrow" seem
  // more appropriate.
  // "short" labels would have been more appropriate if they
  // didn't have the " ago" part, hence the "short-time" above.
  'narrow', // Since "narrow" labels are always present, "short" element
  // of this array can be removed.
  'short']
});
//# sourceMappingURL=twitter.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/twitterNow.js
function twitterNow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { twitterNow_defineProperty(target, key, source[key]); }); } return target; }

function twitterNow_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var twitterNow = (twitterNow_objectSpread({}, twitter, {
  // Add "now".
  steps: [{
    formatAs: 'now'
  }].concat(twitter.steps)
}));
//# sourceMappingURL=twitterNow.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/twitterMinute.js
function twitterMinute_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { twitterMinute_defineProperty(target, key, source[key]); }); } return target; }

function twitterMinute_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var twitterMinute = (twitterMinute_objectSpread({}, twitter, {
  // Skip "seconds".
  steps: twitter.steps.filter(function (step) {
    return step.formatAs !== 'second';
  })
}));
//# sourceMappingURL=twitterMinute.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/twitterMinuteNow.js
function twitterMinuteNow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { twitterMinuteNow_defineProperty(target, key, source[key]); }); } return target; }

function twitterMinuteNow_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var twitterMinuteNow = (twitterMinuteNow_objectSpread({}, twitterMinute, {
  // Add "now".
  steps: [{
    formatAs: 'now'
  }].concat(twitterMinute.steps)
}));
//# sourceMappingURL=twitterMinuteNow.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/twitterFirstMinute.js
function twitterFirstMinute_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { twitterFirstMinute_defineProperty(target, key, source[key]); }); } return target; }

function twitterFirstMinute_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ var twitterFirstMinute = (twitterFirstMinute_objectSpread({}, twitter, {
  // Skip "seconds".
  steps: twitter.steps.filter(function (step) {
    return step.formatAs !== 'second';
  }) // Start showing `1m` from the first minute.
  .map(function (step) {
    return step.formatAs === 'minute' ? twitterFirstMinute_objectSpread({}, step, {
      minTime: minute
    }) : step;
  })
}));
//# sourceMappingURL=twitterFirstMinute.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/mini.js
/* harmony default export */ var mini = ({
  steps: [{
    formatAs: 'second'
  }, {
    formatAs: 'minute'
  }, {
    formatAs: 'hour'
  }, {
    formatAs: 'day'
  }, {
    formatAs: 'month'
  }, {
    formatAs: 'year'
  }],
  labels: [// "mini" labels are only defined for a few languages.
  'mini', // "short-time" labels are only defined for a few languages.
  'short-time', // "narrow" and "short" labels are defined for all languages.
  // "narrow" labels can sometimes be weird (like "+5d."),
  // but "short" labels have the " ago" part, so "narrow" seem
  // more appropriate.
  // "short" labels would have been more appropriate if they
  // didn't have the " ago" part, hence the "short-time" above.
  'narrow', // Since "narrow" labels are always present, "short" element
  // of this array can be removed.
  'short']
});
//# sourceMappingURL=mini.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/miniNow.js
function miniNow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { miniNow_defineProperty(target, key, source[key]); }); } return target; }

function miniNow_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var miniNow = (miniNow_objectSpread({}, mini, {
  // Add "now".
  steps: [{
    formatAs: 'now'
  }].concat(mini.steps)
}));
//# sourceMappingURL=miniNow.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/miniMinute.js
function miniMinute_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { miniMinute_defineProperty(target, key, source[key]); }); } return target; }

function miniMinute_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var miniMinute = (miniMinute_objectSpread({}, mini, {
  // Skip "seconds".
  steps: mini.steps.filter(function (step) {
    return step.formatAs !== 'second';
  })
}));
//# sourceMappingURL=miniMinute.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/miniMinuteNow.js
function miniMinuteNow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { miniMinuteNow_defineProperty(target, key, source[key]); }); } return target; }

function miniMinuteNow_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var miniMinuteNow = (miniMinuteNow_objectSpread({}, miniMinute, {
  // Add "now".
  steps: [{
    formatAs: 'now'
  }].concat(miniMinute.steps)
}));
//# sourceMappingURL=miniMinuteNow.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/style/getStyleByName.js

 // `approximate` style is deprecated.

 // `approximateTime` style is deprecated.











function getStyleByName(style) {
  switch (style) {
    // "default" style name is deprecated.
    case 'default':
    case 'round':
      return style_round;

    case 'round-minute':
      return roundMinute;

    case 'approximate':
      return style_approximate;
    // "time" style name is deprecated.

    case 'time':
    case 'approximate-time':
      return approximateTime;

    case 'mini':
      return mini;

    case 'mini-now':
      return miniNow;

    case 'mini-minute':
      return miniMinute;

    case 'mini-minute-now':
      return miniMinuteNow;

    case 'twitter':
      return twitter;

    case 'twitter-now':
      return twitterNow;

    case 'twitter-minute':
      return twitterMinute;

    case 'twitter-minute-now':
      return twitterMinuteNow;

    case 'twitter-first-minute':
      return twitterFirstMinute;

    default:
      // For historical reasons, the default style is "approximate".
      return style_approximate;
  }
}
//# sourceMappingURL=getStyleByName.js.map
// CONCATENATED MODULE: ./node_modules/javascript-time-ago/modules/TimeAgo.js
function TimeAgo_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TimeAgo_typeof = function _typeof(obj) { return typeof obj; }; } else { TimeAgo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TimeAgo_typeof(obj); }

function TimeAgo_slicedToArray(arr, i) { return TimeAgo_arrayWithHoles(arr) || TimeAgo_iterableToArrayLimit(arr, i) || TimeAgo_nonIterableRest(); }

function TimeAgo_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function TimeAgo_iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function TimeAgo_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function TimeAgo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimeAgo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TimeAgo_createClass(Constructor, protoProps, staticProps) { if (protoProps) TimeAgo_defineProperties(Constructor.prototype, protoProps); if (staticProps) TimeAgo_defineProperties(Constructor, staticProps); return Constructor; }










 // Valid time units.

var TimeAgo_UNITS = ['now', // The rest are the same as in `Intl.RelativeTimeFormat`.
'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'];

var TimeAgo_TimeAgo =
/*#__PURE__*/
function () {
  /**
   * @param {(string|string[])} locales=[] - Preferred locales (or locale).
   * @param {boolean} [polyfill] — Pass `false` to use native `Intl.RelativeTimeFormat` and `Intl.PluralRules` instead of the polyfills.
   */
  function TimeAgo() {
    var locales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        polyfill = _ref.polyfill;

    TimeAgo_classCallCheck(this, TimeAgo);

    // Convert `locales` to an array.
    if (typeof locales === 'string') {
      locales = [locales];
    } // Choose the most appropriate locale
    // from the list of `locales` added by the user.
    // For example, new TimeAgo("en-US") -> "en".


    this.locale = chooseLocale(locales.concat(TimeAgo.getDefaultLocale()), LocaleDataStore_getLocaleData);

    if (typeof Intl !== 'undefined') {
      // Use `Intl.NumberFormat` for formatting numbers (when available).
      if (Intl.NumberFormat) {
        this.numberFormat = new Intl.NumberFormat(this.locale);
      }
    } // Some people have requested the ability to use native
    // `Intl.RelativeTimeFormat` and `Intl.PluralRules`
    // instead of the polyfills.
    // https://github.com/catamphetamine/javascript-time-ago/issues/21


    if (polyfill === false) {
      this.IntlRelativeTimeFormat = Intl.RelativeTimeFormat;
      this.IntlPluralRules = Intl.PluralRules;
    } else {
      this.IntlRelativeTimeFormat = RelativeTimeFormat_RelativeTimeFormat;
      this.IntlPluralRules = RelativeTimeFormat_RelativeTimeFormat.PluralRules;
    } // Cache `Intl.RelativeTimeFormat` instance.


    this.relativeTimeFormatCache = new Cache(); // Cache `Intl.PluralRules` instance.

    this.pluralRulesCache = new Cache();
  }
  /**
   * Formats relative date/time.
   *
   * @param {number} [options.now] - Sets the current date timestamp.
   *
   * @param  {boolean} [options.future] — Tells how to format value `0`:
   *         as "future" (`true`) or "past" (`false`).
   *         Is `false` by default, but should have been `true` actually,
   *         in order to correspond to `Intl.RelativeTimeFormat`
   *         that uses `future` formatting for `0` unless `-0` is passed.
   *
   * @param {string} [options.round] — Rounding method. Overrides the style's one.
   *
   * @param {boolean} [options.getTimeToNextUpdate] — Pass `true` to return `[formattedDate, timeToNextUpdate]` instead of just `formattedDate`.
   *
   * @return {string} The formatted relative date/time. If no eligible `step` is found, then an empty string is returned.
   */


  TimeAgo_createClass(TimeAgo, [{
    key: "format",
    value: function format(input, style, options) {
      if (!options) {
        if (style && !isStyle(style)) {
          options = style;
          style = undefined;
        } else {
          options = {};
        }
      }

      if (!style) {
        style = roundMinute;
      }

      if (typeof style === 'string') {
        style = getStyleByName(style);
      }

      var timestamp = getTimestamp(input); // Get locale messages for this type of labels.
      // "flavour" is a legacy name for "labels".

      var _this$getLabels = this.getLabels(style.flavour || style.labels),
          labels = _this$getLabels.labels,
          labelsType = _this$getLabels.labelsType;

      var now; // Can pass a custom `now`, e.g. for testing purposes.
      //
      // Legacy way was passing `now` in `style`.
      // That way is deprecated.

      if (style.now !== undefined) {
        now = style.now;
      } // The new way is passing `now` option to `.format()`.


      if (now === undefined && options.now !== undefined) {
        now = options.now;
      }

      if (now === undefined) {
        now = Date.now();
      } // how much time has passed (in seconds)


      var secondsPassed = (now - timestamp) / 1000; // in seconds

      var future = options.future || secondsPassed < 0;
      var nowLabel = getNowLabel(labels, LocaleDataStore_getLocaleData(this.locale).now, LocaleDataStore_getLocaleData(this.locale).long, future); // `custom` – A function of `{ elapsed, time, date, now, locale }`.
      //
      // Looks like `custom` function is deprecated and will be removed
      // in the next major version.
      //
      // If this function returns a value, then the `.format()` call will return that value.
      // Otherwise the relative date/time is formatted as usual.
      // This feature is currently not used anywhere and is here
      // just for providing the ultimate customization point
      // in case anyone would ever need that. Prefer using
      // `steps[step].format(value, locale)` instead.
      //

      if (style.custom) {
        var custom = style.custom({
          now: now,
          date: new Date(timestamp),
          time: timestamp,
          elapsed: secondsPassed,
          locale: this.locale
        });

        if (custom !== undefined) {
          // Won't return `timeToNextUpdate` here
          // because `custom()` seems deprecated.
          return custom;
        }
      } // Get the list of available time interval units.


      var units = getTimeIntervalMeasurementUnits( // Controlling `style.steps` through `style.units` seems to be deprecated:
      // create a new custom `style` instead.
      style.units, labels, nowLabel); // // If no available time unit is suitable, just output an empty string.
      // if (units.length === 0) {
      // 	console.error(`None of the "${units.join(', ')}" time units have been found in "${labelsType}" labels for "${this.locale}" locale.`)
      // 	return ''
      // }

      var round = options.round || style.round; // Choose the appropriate time measurement unit
      // and get the corresponding rounded time amount.

      var _getStep = getStep( // "gradation" is a legacy name for "steps".
      // For historical reasons, "approximate" steps are used by default.
      // In the next major version, there'll be no default for `steps`.
      style.gradation || style.steps || roundMinute.steps, secondsPassed, {
        now: now,
        units: units,
        round: round,
        future: future,
        getNextStep: true
      }),
          _getStep2 = TimeAgo_slicedToArray(_getStep, 3),
          prevStep = _getStep2[0],
          step = _getStep2[1],
          nextStep = _getStep2[2];

      var formattedDate = this.formatDateForStep(timestamp, step, secondsPassed, {
        labels: labels,
        labelsType: labelsType,
        nowLabel: nowLabel,
        now: now,
        future: future,
        round: round
      }) || '';

      if (options.getTimeToNextUpdate) {
        var timeToNextUpdate = getTimeToNextUpdate(timestamp, step, {
          nextStep: nextStep,
          prevStep: prevStep,
          now: now,
          future: future,
          round: round
        });
        return [formattedDate, timeToNextUpdate];
      }

      return formattedDate;
    }
  }, {
    key: "formatDateForStep",
    value: function formatDateForStep(timestamp, step, secondsPassed, _ref2) {
      var _this = this;

      var labels = _ref2.labels,
          labelsType = _ref2.labelsType,
          nowLabel = _ref2.nowLabel,
          now = _ref2.now,
          future = _ref2.future,
          round = _ref2.round;

      // If no step matches, then output an empty string.
      if (!step) {
        return;
      }

      if (step.format) {
        return step.format(timestamp, this.locale, {
          formatAs: function formatAs(unit, value) {
            // Mimicks `Intl.RelativeTimeFormat.format()`.
            return _this.formatValue(value, unit, {
              labels: labels,
              future: future
            });
          },
          now: now,
          future: future
        });
      } // "unit" is now called "formatAs".


      var unit = step.unit || step.formatAs;

      if (!unit) {
        throw new Error("[javascript-time-ago] Each step must define either `formatAs` or `format()`. Step: ".concat(JSON.stringify(step)));
      } // `Intl.RelativeTimeFormat` doesn't operate in "now" units.
      // Therefore, threat "now" as a special case.


      if (unit === 'now') {
        return nowLabel;
      } // Amount in units.


      var amount = Math.abs(secondsPassed) / getStepDenominator(step); // Apply granularity to the time amount
      // (and fallback to the previous step
      //  if the first level of granularity
      //  isn't met by this amount)
      //
      // `granularity` — (advanced) Time interval value "granularity".
      // For example, it could be set to `5` for minutes to allow only 5-minute increments
      // when formatting time intervals: `0 minutes`, `5 minutes`, `10 minutes`, etc.
      // Perhaps this feature will be removed because there seem to be no use cases
      // of it in the real world.
      //

      if (step.granularity) {
        // Recalculate the amount of seconds passed based on granularity
        amount = getRoundFunction(round)(amount / step.granularity) * step.granularity;
      }

      var valueForFormatting = -1 * Math.sign(secondsPassed) * getRoundFunction(round)(amount); // By default, this library formats a `0` in "past" mode,
      // unless `future: true` option is passed.
      // This is different to `relative-time-format`'s behavior
      // which formats a `0` in "future" mode by default, unless it's a `-0`.
      // So, convert `0` to `-0` if `future: true` option wasn't passed.
      // `=== 0` matches both `0` and `-0`.

      if (valueForFormatting === 0) {
        if (future) {
          valueForFormatting = 0;
        } else {
          valueForFormatting = -0;
        }
      }

      switch (labelsType) {
        case 'long':
        case 'short':
        case 'narrow':
          // Format the amount using `Intl.RelativeTimeFormat`.
          return this.getFormatter(labelsType).format(valueForFormatting, unit);

        default:
          // Format the amount.
          // (mimicks `Intl.RelativeTimeFormat` behavior for other time label styles)
          return this.formatValue(valueForFormatting, unit, {
            labels: labels,
            future: future
          });
      }
    }
    /**
     * Mimicks what `Intl.RelativeTimeFormat` does for additional locale styles.
     * @param  {number} value
     * @param  {string} unit
     * @param  {object} options.labels — Relative time labels.
     * @param  {boolean} [options.future] — Tells how to format value `0`: as "future" (`true`) or "past" (`false`). Is `false` by default, but should have been `true` actually.
     * @return {string}
     */

  }, {
    key: "formatValue",
    value: function formatValue(value, unit, _ref3) {
      var labels = _ref3.labels,
          future = _ref3.future;
      return this.getFormattingRule(labels, unit, value, {
        future: future
      }).replace('{0}', this.formatNumber(Math.abs(value)));
    }
    /**
     * Returns formatting rule for `value` in `units` (either in past or in future).
     * @param {object} formattingRules — Relative time labels for different units.
     * @param {string} unit - Time interval measurement unit.
     * @param {number} value - Time interval value.
     * @param  {boolean} [options.future] — Tells how to format value `0`: as "future" (`true`) or "past" (`false`). Is `false` by default.
     * @return {string}
     * @example
     * // Returns "{0} days ago"
     * getFormattingRule(en.long, "day", -2, 'en')
     */

  }, {
    key: "getFormattingRule",
    value: function getFormattingRule(formattingRules, unit, value, _ref4) {
      var future = _ref4.future;
      // Passing the language is required in order to
      // be able to correctly classify the `value` as a number.
      var locale = this.locale;
      formattingRules = formattingRules[unit]; // Check for a special "compacted" rules case:
      // if formatting rules are the same for "past" and "future",
      // and also for all possible `value`s, then those rules are
      // stored as a single string.

      if (typeof formattingRules === 'string') {
        return formattingRules;
      } // Choose either "past" or "future" based on time `value` sign.
      // If "past" is same as "future" then they're stored as "other".
      // If there's only "other" then it's being collapsed.


      var pastOrFuture = value === 0 ? future ? 'future' : 'past' : value < 0 ? 'past' : 'future';
      var quantifierRules = formattingRules[pastOrFuture] || formattingRules; // Bundle size optimization technique.

      if (typeof quantifierRules === 'string') {
        return quantifierRules;
      } // Quantify `value`.


      var quantifier = this.getPluralRules().select(Math.abs(value)); // "other" rule is supposed to always be present.
      // If only "other" rule is present then "rules" is not an object and is a string.

      return quantifierRules[quantifier] || quantifierRules.other;
    }
    /**
     * Formats a number into a string.
     * Uses `Intl.NumberFormat` when available.
     * @param  {number} number
     * @return {string}
     */

  }, {
    key: "formatNumber",
    value: function formatNumber(number) {
      return this.numberFormat ? this.numberFormat.format(number) : String(number);
    }
    /**
     * Returns an `Intl.RelativeTimeFormat` for a given `labelsType`.
     * @param {string} labelsType
     * @return {object} `Intl.RelativeTimeFormat` instance
     */

  }, {
    key: "getFormatter",
    value: function getFormatter(labelsType) {
      // `Intl.RelativeTimeFormat` instance creation is (hypothetically) assumed
      // a lengthy operation so the instances are cached and reused.
      return this.relativeTimeFormatCache.get(this.locale, labelsType) || this.relativeTimeFormatCache.put(this.locale, labelsType, new this.IntlRelativeTimeFormat(this.locale, {
        style: labelsType
      }));
    }
    /**
     * Returns an `Intl.PluralRules` instance.
     * @return {object} `Intl.PluralRules` instance
     */

  }, {
    key: "getPluralRules",
    value: function getPluralRules() {
      // `Intl.PluralRules` instance creation is (hypothetically) assumed
      // a lengthy operation so the instances are cached and reused.
      return this.pluralRulesCache.get(this.locale) || this.pluralRulesCache.put(this.locale, new this.IntlPluralRules(this.locale));
    }
    /**
     * Gets localized labels for this type of labels.
     *
     * @param {(string|string[])} labelsType - Relative date/time labels type.
     *                                     If it's an array then all label types are tried
     *                                     until a suitable one is found.
     *
     * @returns {Object} Returns an object of shape { labelsType, labels }
     */

  }, {
    key: "getLabels",
    value: function getLabels() {
      var labelsType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      // Convert `labels` to an array.
      if (typeof labelsType === 'string') {
        labelsType = [labelsType];
      } // Supports legacy "tiny" and "mini-time" label styles.


      labelsType = labelsType.map(function (labelsType) {
        switch (labelsType) {
          case 'tiny':
          case 'mini-time':
            return 'mini';

          default:
            return labelsType;
        }
      }); // "long" labels type is the default one.
      // (it's always present for all languages)

      labelsType = labelsType.concat('long'); // Find a suitable labels type.

      var localeData = LocaleDataStore_getLocaleData(this.locale);

      for (var _iterator = labelsType, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray) {
          if (_i2 >= _iterator.length) break;
          _ref5 = _iterator[_i2++];
        } else {
          _i2 = _iterator.next();
          if (_i2.done) break;
          _ref5 = _i2.value;
        }

        var _labelsType = _ref5;

        if (localeData[_labelsType]) {
          return {
            labelsType: _labelsType,
            labels: localeData[_labelsType]
          };
        }
      }
    }
  }]);

  return TimeAgo;
}();
/**
 * Default locale global variable.
 */



var TimeAgo_defaultLocale = 'en';
/**
 * Gets default locale.
 * @return  {string} locale
 */

TimeAgo_TimeAgo.getDefaultLocale = function () {
  return TimeAgo_defaultLocale;
};
/**
 * Sets default locale.
 * @param  {string} locale
 */


TimeAgo_TimeAgo.setDefaultLocale = function (locale) {
  return TimeAgo_defaultLocale = locale;
};
/**
 * Adds locale data for a specific locale and marks the locale as default.
 * @param {Object} localeData
 */


TimeAgo_TimeAgo.addDefaultLocale = function (localeData) {
  if (defaultLocaleHasBeenSpecified) {
    return console.error('[javascript-time-ago] `TimeAgo.addDefaultLocale()` can only be called once. To add other locales, use `TimeAgo.addLocale()`.');
  }

  defaultLocaleHasBeenSpecified = true;
  TimeAgo_TimeAgo.setDefaultLocale(localeData.locale);
  TimeAgo_TimeAgo.addLocale(localeData);
};

var defaultLocaleHasBeenSpecified;
/**
 * Adds locale data for a specific locale.
 * @param {Object} localeData
 */

TimeAgo_TimeAgo.addLocale = function (localeData) {
  LocaleDataStore_addLocaleData(localeData);
  RelativeTimeFormat_RelativeTimeFormat.addLocale(localeData);
};
/**
 * (legacy alias)
 * Adds locale data for a specific locale.
 * @param {Object} localeData
 * @deprecated
 */


TimeAgo_TimeAgo.locale = TimeAgo_TimeAgo.addLocale;
/**
 * Adds custom labels to locale data.
 * @param {string} locale
 * @param {string} name
 * @param {object} labels
 */

TimeAgo_TimeAgo.addLabels = function (locale, name, labels) {
  var localeData = LocaleDataStore_getLocaleData(locale);

  if (!localeData) {
    LocaleDataStore_addLocaleData({
      locale: locale
    });
    localeData = LocaleDataStore_getLocaleData(locale); // throw new Error(`[javascript-time-ago] No data for locale "${locale}"`)
  }

  localeData[name] = labels;
}; // Normalizes `.format()` `time` argument.


function getTimestamp(input) {
  if (input.constructor === Date || isMockedDate(input)) {
    return input.getTime();
  }

  if (typeof input === 'number') {
    return input;
  } // For some weird reason istanbul doesn't see this `throw` covered.

  /* istanbul ignore next */


  throw new Error("Unsupported relative time formatter input: ".concat(TimeAgo_typeof(input), ", ").concat(input));
} // During testing via some testing libraries `Date`s aren't actually `Date`s.
// https://github.com/catamphetamine/javascript-time-ago/issues/22


function isMockedDate(object) {
  return TimeAgo_typeof(object) === 'object' && typeof object.getTime === 'function';
} // Get available time interval measurement units.


function getTimeIntervalMeasurementUnits(allowedUnits, labels, nowLabel) {
  // Get all time interval measurement units that're available
  // in locale data for a given time labels style.
  var units = Object.keys(labels); // `now` unit is handled separately and is shipped in its own `now.json` file.
  // `now.json` isn't present for all locales, so it could be substituted with
  // ".second.current".
  // Add `now` unit if it's available in locale data.

  if (nowLabel) {
    units.push('now');
  } // If only a specific set of available time measurement units can be used
  // then only those units are allowed (if they're present in locale data).


  if (allowedUnits) {
    units = allowedUnits.filter(function (unit) {
      return unit === 'now' || units.indexOf(unit) >= 0;
    });
  }

  return units;
}

function getNowLabel(labels, nowLabels, longLabels, future) {
  var nowLabel = labels.now || nowLabels && nowLabels.now; // Specific "now" message form extended locale data (if present).

  if (nowLabel) {
    // Bundle size optimization technique.
    if (typeof nowLabel === 'string') {
      return nowLabel;
    } // Not handling `value === 0` as `localeData.now.current` here
    // because it wouldn't make sense: "now" is a moment,
    // so one can't possibly differentiate between a
    // "previous" moment, a "current" moment and a "next moment".
    // It can only be differentiated between "past" and "future".


    if (future) {
      return nowLabel.future;
    } else {
      return nowLabel.past;
    }
  } // Use ".second.current" as "now" message.


  if (longLabels && longLabels.second && longLabels.second.current) {
    return longLabels.second.current;
  }
}

var OBJECT_CONSTRUCTOR = {}.constructor;

function TimeAgo_isObject(object) {
  return TimeAgo_typeof(object) !== undefined && object !== null && object.constructor === OBJECT_CONSTRUCTOR;
}

function isStyle(variable) {
  return typeof variable === 'string' || isStyleObject(variable);
}

function isStyleObject(object) {
  return TimeAgo_isObject(object) && (Array.isArray(object.steps) || // `gradation` property is deprecated: it has been renamed to `steps`.
  Array.isArray(object.gradation) || // `flavour` property is deprecated: it has been renamed to `labels`.
  Array.isArray(object.flavour) || typeof object.flavour === 'string' || Array.isArray(object.labels) || typeof object.labels === 'string' || // `units` property is deprecated.
  Array.isArray(object.units) || // `custom` property is deprecated.
  typeof object.custom === 'function');
}
//# sourceMappingURL=TimeAgo.js.map
// EXTERNAL MODULE: ./node_modules/javascript-time-ago/locale/en.json
var locale_en = __webpack_require__("541d");

// EXTERNAL MODULE: ./node_modules/javascript-time-ago/locale/de.json
var locale_de = __webpack_require__("d675");

// CONCATENATED MODULE: ./src/plugins/timeago.ts



TimeAgo_TimeAgo.addLocale(locale_de);
TimeAgo_TimeAgo.addLocale(locale_en);
var timeAgo = new TimeAgo_TimeAgo(["en-US", "de-DE"]);
// EXTERNAL MODULE: ./node_modules/humanize-duration/humanize-duration.js
var humanize_duration = __webpack_require__("8f14");
var humanize_duration_default = /*#__PURE__*/__webpack_require__.n(humanize_duration);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("c1df");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatModBadge.vue?vue&type=template&id=80cd0324&scoped=true&
var ChatModBadgevue_type_template_id_80cd0324_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin || _vm.isModerator)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-1",attrs:{"size":"18","color":_vm.roleBadge.color},domProps:{"textContent":_vm._s(_vm.roleBadge.icon)}},'v-icon',attrs,false),on))]}}],null,false,3085759282)},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.tooltipText)))])]):_vm._e()}
var ChatModBadgevue_type_template_id_80cd0324_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ChatModBadge.vue?vue&type=template&id=80cd0324&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatModBadge.vue?vue&type=script&lang=ts&














var ChatModBadgevue_type_script_lang_ts_ChatModBadge = /*#__PURE__*/function (_Vue) {
  _inherits(ChatModBadge, _Vue);

  var _super = _createSuper(ChatModBadge);

  function ChatModBadge() {
    var _this;

    _classCallCheck(this, ChatModBadge);

    _this = _super.apply(this, arguments);
    _this.roleBadges = getModule(store_ConfigModule, _this.$store).roleBadges;
    return _this;
  }

  _createClass(ChatModBadge, [{
    key: "isAdmin",
    get: function get() {
      var _this$userInfo$roles$, _this$userInfo$roles;

      return (_this$userInfo$roles$ = (_this$userInfo$roles = this.userInfo.roles) === null || _this$userInfo$roles === void 0 ? void 0 : _this$userInfo$roles.includes(Role.ROLE_ADMIN)) !== null && _this$userInfo$roles$ !== void 0 ? _this$userInfo$roles$ : false;
    }
  }, {
    key: "isModerator",
    get: function get() {
      var _this$userInfo$roles$2, _this$userInfo$roles2;

      return (_this$userInfo$roles$2 = (_this$userInfo$roles2 = this.userInfo.roles) === null || _this$userInfo$roles2 === void 0 ? void 0 : _this$userInfo$roles2.includes(Role.ROLE_MODERATOR)) !== null && _this$userInfo$roles$2 !== void 0 ? _this$userInfo$roles$2 : false;
    }
  }, {
    key: "roleBadge",
    get: function get() {
      var role = this.isAdmin ? Role.ROLE_ADMIN : Role.ROLE_MODERATOR;
      var themeMode = this.$vuetify.theme.dark ? "dark" : "light";
      var customBadges = this.roleBadges[themeMode];
      var customRoleBadge = customBadges && customBadges[role];
      return customRoleBadge ? customRoleBadge : this.getDefaultBadge(role);
    }
  }, {
    key: "tooltipText",
    get: function get() {
      return this.isAdmin ? "s8c.Admin" : "s8c.Moderator";
    }
  }, {
    key: "getDefaultBadge",
    value: function getDefaultBadge(role) {
      return role === Role.ROLE_ADMIN ? {
        color: this.color,
        icon: "mdi-shield-crown"
      } : {
        color: this.color,
        icon: "mdi-shield-sword"
      };
    }
  }]);

  return ChatModBadge;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], ChatModBadgevue_type_script_lang_ts_ChatModBadge.prototype, "color", void 0);

__decorate([Prop({
  required: true
})], ChatModBadgevue_type_script_lang_ts_ChatModBadge.prototype, "userInfo", void 0);

ChatModBadgevue_type_script_lang_ts_ChatModBadge = __decorate([vue_class_component_esm({})], ChatModBadgevue_type_script_lang_ts_ChatModBadge);
/* harmony default export */ var ChatModBadgevue_type_script_lang_ts_ = (ChatModBadgevue_type_script_lang_ts_ChatModBadge);
// CONCATENATED MODULE: ./src/components/ChatModBadge.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ChatModBadgevue_type_script_lang_ts_ = (ChatModBadgevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("c96a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VIcon/VIcon.sass
var VIcon = __webpack_require__("4804");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/binds-attrs/index.js

/**
 * This mixin provides `attrs$` and `listeners$` to work around
 * vue bug https://github.com/vuejs/vue/issues/10115
 */

function makeWatcher(property) {
  return function (val, oldVal) {
    for (var attr in oldVal) {
      if (!Object.prototype.hasOwnProperty.call(val, attr)) {
        this.$delete(this.$data[property], attr);
      }
    }

    for (var _attr in val) {
      this.$set(this.$data[property], _attr, val[_attr]);
    }
  };
}

/* harmony default export */ var binds_attrs = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  data: function data() {
    return {
      attrs$: {},
      listeners$: {}
    };
  },
  created: function created() {
    // Work around unwanted re-renders: https://github.com/vuejs/vue/issues/10115
    // Make sure to use `attrs$` instead of `$attrs` (confusing right?)
    this.$watch('$attrs', makeWatcher('attrs$'), {
      immediate: true
    });
    this.$watch('$listeners', makeWatcher('listeners$'), {
      immediate: true
    });
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.repeat.js
var es_string_repeat = __webpack_require__("38cf");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/install.js


function install_install(Vue) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (install_install.installed) return;
  install_install.installed = true;

  if (external_commonjs_vue_commonjs2_vue_root_Vue_default.a !== Vue) {
    consoleError("Multiple instances of Vue detected\nSee https://github.com/vuetifyjs/vuetify/issues/4068\n\nIf you're seeing \"$attrs is readonly\", it's caused by this");
  }

  var components = args.components || {};
  var directives = args.directives || {};

  for (var name in directives) {
    var directive = directives[name];
    Vue.directive(name, directive);
  }

  (function registerComponents(components) {
    if (components) {
      for (var key in components) {
        var component = components[key];

        if (component && !registerComponents(component.$_vuetify_subcomponents)) {
          Vue.component(key, component);
        }
      }

      return true;
    }

    return false;
  })(components); // Used to avoid multiple mixins being setup
  // when in dev mode and hot module reload
  // https://github.com/vuejs/vue/issues/5089#issuecomment-284260111


  if (Vue.$_vuetify_installed) return;
  Vue.$_vuetify_installed = true;
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;

      if (options.vuetify) {
        options.vuetify.init(this, this.$ssrContext);
        this.$vuetify = Vue.observable(options.vuetify.framework);
      } else {
        this.$vuetify = options.parent && options.parent.$vuetify || this;
      }
    },
    beforeMount: function beforeMount() {
      // @ts-ignore
      if (this.$options.vuetify && this.$el && this.$el.hasAttribute('data-server-rendered')) {
        // @ts-ignore
        this.$vuetify.isHydrating = true; // @ts-ignore

        this.$vuetify.breakpoint.update(true);
      }
    },
    mounted: function mounted() {
      // @ts-ignore
      if (this.$options.vuetify && this.$vuetify.isHydrating) {
        // @ts-ignore
        this.$vuetify.isHydrating = false; // @ts-ignore

        this.$vuetify.breakpoint.update();
      }
    }
  });
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/vuetify/src/styles/main.sass
var main = __webpack_require__("95ed");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/locale/en.js
/* harmony default export */ var lib_locale_en = ({
  badge: 'Badge',
  close: 'Close',
  dataIterator: {
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...'
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: 'Sorted descending.',
      sortAscending: 'Sorted ascending.',
      sortNone: 'Not sorted.',
      activateNone: 'Activate to remove sorting.',
      activateDescending: 'Activate to sort descending.',
      activateAscending: 'Activate to sort ascending.'
    },
    sortBy: 'Sort by'
  },
  dataFooter: {
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
    pageText: '{0}-{1} of {2}'
  },
  datePicker: {
    itemsSelected: '{0} selected',
    nextMonthAriaLabel: 'Next month',
    nextYearAriaLabel: 'Next year',
    prevMonthAriaLabel: 'Previous month',
    prevYearAriaLabel: 'Previous year'
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'Previous visual',
    next: 'Next visual',
    ariaLabel: {
      delimiter: 'Carousel slide {0} of {1}'
    }
  },
  calendar: {
    moreEvents: '{0} more'
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)'
  },
  timePicker: {
    am: 'AM',
    pm: 'PM'
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Pagination Navigation',
      next: 'Next page',
      previous: 'Previous page',
      page: 'Goto Page {0}',
      currentPage: 'Current Page, Page {0}'
    }
  },
  rating: {
    ariaLabel: {
      icon: 'Rating {0} of {1}'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vuetify/lib/presets/default/index.js
// Styles
 // Locale


var default_preset = {
  breakpoint: {
    // TODO: update to MD2 spec in v3 - 1280
    mobileBreakpoint: 1264,
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920
    }
  },
  icons: {
    // TODO: remove v3
    iconfont: 'mdi',
    values: {}
  },
  lang: {
    current: 'en',
    locales: {
      en: lib_locale_en
    },
    // Default translator exists in lang service
    t: undefined
  },
  rtl: false,
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: undefined,
      minifyTheme: undefined,
      themeCache: undefined,
      variations: true
    },
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      },
      dark: {
        primary: '#2196F3',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  }
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__("dca8");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__("b680");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("cb29");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/helpers.js

























function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  var name = arguments.length > 2 ? arguments[2] : undefined;
  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: name || c.replace(/__/g, '-'),
    functional: true,
    props: {
      tag: {
        type: String,
        default: el
      }
    },
    render: function render(h, _ref) {
      var data = _ref.data,
          props = _ref.props,
          children = _ref.children;
      data.staticClass = "".concat(c, " ").concat(data.staticClass || '').trim();
      return h(props.tag, data, children);
    }
  });
}
function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread2(_objectSpread2(_objectSpread2({}, defaults), binding.modifiers), {}, {
    value: binding.arg
  }, binding.value || {});
}
function addOnceEventListener(el, eventName, cb) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var once = function once(event) {
    cb(event);
    el.removeEventListener(eventName, once, options);
  };

  el.addEventListener(eventName, once, options);
}
var passiveSupported = false;

try {
  if (typeof window !== 'undefined') {
    var testListenerOpts = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });
    window.addEventListener('testListener', testListenerOpts, testListenerOpts);
    window.removeEventListener('testListener', testListenerOpts, testListenerOpts);
  }
} catch (e) {
  console.warn(e);
}
/* eslint-disable-line no-console */



function addPassiveEventListener(el, event, cb, options) {
  el.addEventListener(event, cb, passiveSupported ? options : false);
}
function getNestedValue(obj, path, fallback) {
  var last = path.length - 1;
  if (last < 0) return obj === undefined ? fallback : obj;

  for (var i = 0; i < last; i++) {
    if (obj == null) {
      return fallback;
    }

    obj = obj[path[i]];
  }

  if (obj == null) return fallback;
  return obj[path[last]] === undefined ? fallback : obj[path[last]];
}
function deepEqual(a, b) {
  if (a === b) return true;

  if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) {
    // If the values are Date, compare them as timestamps
    return false;
  }

  if (a !== Object(a) || b !== Object(b)) {
    // If the values aren't objects, they were already checked for equality
    return false;
  }

  var props = Object.keys(a);

  if (props.length !== Object.keys(b).length) {
    // Different number of props, don't bother to check
    return false;
  }

  return props.every(function (p) {
    return deepEqual(a[p], b[p]);
  });
}
function getObjectValueByPath(obj, path, fallback) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (obj == null || !path || typeof path !== 'string') return fallback;
  if (obj[path] !== undefined) return obj[path];
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

  path = path.replace(/^\./, ''); // strip a leading dot

  return getNestedValue(obj, path.split('.'), fallback);
}
function getPropertyFromItem(item, property, fallback) {
  if (property == null) return item === undefined ? fallback : item;
  if (item !== Object(item)) return fallback === undefined ? item : fallback;
  if (typeof property === 'string') return getObjectValueByPath(item, property, fallback);
  if (Array.isArray(property)) return getNestedValue(item, property, fallback);
  if (typeof property !== 'function') return fallback;
  var value = property(item, fallback);
  return typeof value === 'undefined' ? fallback : value;
}
function createRange(length) {
  return Array.from({
    length: length
  }, function (v, k) {
    return k;
  });
}
function getZIndex(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
  var index = +window.getComputedStyle(el).getPropertyValue('z-index');
  if (!index) return getZIndex(el.parentNode);
  return index;
}
var tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
};
function escapeHTML(str) {
  return str.replace(/[&<>]/g, function (tag) {
    return tagsToReplace[tag] || tag;
  });
}
function filterObjectOnKeys(obj, keys) {
  var filtered = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (typeof obj[key] !== 'undefined') {
      filtered[key] = obj[key];
    }
  }

  return filtered;
}
function convertToUnit(str) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';

  if (str == null || str === '') {
    return undefined;
  } else if (isNaN(+str)) {
    return String(str);
  } else {
    return "".concat(Number(str)).concat(unit);
  }
}
function kebabCase(str) {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function helpers_isObject(obj) {
  return obj !== null && _typeof(obj) === 'object';
} // KeyboardEvent.keyCode aliases

var keyCodes = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
});
/**
 * This remaps internal names like '$cancel' or '$vuetify.icons.cancel'
 * to the current name or component for that icon.
 */

function remapInternalIcon(vm, iconName) {
  // Look for custom component in the configuration
  var component = vm.$vuetify.icons.component; // Look for overrides

  if (iconName.startsWith('$')) {
    // Get the target icon name
    var iconPath = "$vuetify.icons.values.".concat(iconName.split('$').pop().split('.').pop()); // Now look up icon indirection name,
    // e.g. '$vuetify.icons.values.cancel'

    var override = getObjectValueByPath(vm, iconPath, iconName);
    if (typeof override === 'string') iconName = override;else return override;
  }

  if (component == null) {
    return iconName;
  }

  return {
    component: component,
    props: {
      icon: iconName
    }
  };
}
function keys(o) {
  return Object.keys(o);
}
/**
 * Camelize a hyphen-delimited string.
 */

var camelizeRE = /-(\w)/g;
var camelize = function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c ? c.toUpperCase() : '';
  });
};
/**
 * Returns the set difference of B and A, i.e. the set of elements in B but not in A
 */

function arrayDiff(a, b) {
  var diff = [];

  for (var i = 0; i < b.length; i++) {
    if (a.indexOf(b[i]) < 0) diff.push(b[i]);
  }

  return diff;
}
/**
 * Makes the first character of a string uppercase
 */

function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function groupItems(items, groupBy, groupDesc) {
  var key = groupBy[0];
  var groups = [];
  var current;

  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var val = getObjectValueByPath(item, key, null);

    if (current !== val) {
      current = val;
      groups.push({
        name: val != null ? val : '',
        items: []
      });
    }

    groups[groups.length - 1].items.push(item);
  }

  return groups;
}
function wrapInArray(v) {
  return v != null ? Array.isArray(v) ? v : [v] : [];
}
function sortItems(items, sortBy, sortDesc, locale, customSorters) {
  if (sortBy === null || !sortBy.length) return items;
  var stringCollator = new Intl.Collator(locale, {
    sensitivity: 'accent',
    usage: 'sort'
  });
  return items.sort(function (a, b) {
    for (var i = 0; i < sortBy.length; i++) {
      var sortKey = sortBy[i];
      var sortA = getObjectValueByPath(a, sortKey);
      var sortB = getObjectValueByPath(b, sortKey);

      if (sortDesc[i]) {
        var _ref2 = [sortB, sortA];
        sortA = _ref2[0];
        sortB = _ref2[1];
      }

      if (customSorters && customSorters[sortKey]) {
        var customResult = customSorters[sortKey](sortA, sortB);
        if (!customResult) continue;
        return customResult;
      } // Check if both cannot be evaluated


      if (sortA === null && sortB === null) {
        continue;
      } // Dates should be compared numerically


      if (sortA instanceof Date && sortB instanceof Date) {
        return sortA.getTime() - sortB.getTime();
      }

      var _map = [sortA, sortB].map(function (s) {
        return (s || '').toString().toLocaleLowerCase();
      });

      var _map2 = _slicedToArray(_map, 2);

      sortA = _map2[0];
      sortB = _map2[1];

      if (sortA !== sortB) {
        if (!isNaN(sortA) && !isNaN(sortB)) return Number(sortA) - Number(sortB);
        return stringCollator.compare(sortA, sortB);
      }
    }

    return 0;
  });
}
function defaultFilter(value, search, item) {
  return value != null && search != null && typeof value !== 'boolean' && value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
}
function searchItems(items, search) {
  if (!search) return items;
  search = search.toString().toLowerCase();
  if (search.trim() === '') return items;
  return items.filter(function (item) {
    return Object.keys(item).some(function (key) {
      return defaultFilter(getObjectValueByPath(item, key), search, item);
    });
  });
}
/**
 * Returns:
 *  - 'normal' for old style slots - `<template slot="default">`
 *  - 'scoped' for old style scoped slots (`<template slot="default" slot-scope="data">`) or bound v-slot (`#default="data"`)
 *  - 'v-slot' for unbound v-slot (`#default`) - only if the third param is true, otherwise counts as scoped
 */

function getSlotType(vm, name, split) {
  if (vm.$slots.hasOwnProperty(name) && vm.$scopedSlots.hasOwnProperty(name) && vm.$scopedSlots[name].name) {
    return split ? 'v-slot' : 'scoped';
  }

  if (vm.$slots.hasOwnProperty(name)) return 'normal';
  if (vm.$scopedSlots.hasOwnProperty(name)) return 'scoped';
}
function debounce(fn, delay) {
  var timeoutId = 0;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return fn.apply(void 0, args);
    }, delay);
  };
}
function throttle(fn, limit) {
  var throttling = false;
  return function () {
    if (!throttling) {
      throttling = true;
      setTimeout(function () {
        return throttling = false;
      }, limit);
      return fn.apply(void 0, arguments);
    }
  };
}
function getPrefixedScopedSlots(prefix, scopedSlots) {
  return Object.keys(scopedSlots).filter(function (k) {
    return k.startsWith(prefix);
  }).reduce(function (obj, k) {
    obj[k.replace(prefix, '')] = scopedSlots[k];
    return obj;
  }, {});
}
function getSlot(vm) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var optional = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (vm.$scopedSlots.hasOwnProperty(name)) {
    return vm.$scopedSlots[name](data instanceof Function ? data() : data);
  } else if (vm.$slots.hasOwnProperty(name) && (!data || optional)) {
    return vm.$slots[name];
  }

  return undefined;
}
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Math.max(min, Math.min(max, value));
}
function padEnd(str, length) {
  var char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  return str + char.repeat(Math.max(0, length - str.length));
}
function chunk(str) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var chunked = [];
  var index = 0;

  while (index < str.length) {
    chunked.push(str.substr(index, size));
    index += size;
  }

  return chunked;
}
function humanReadableFileSize(bytes) {
  var binary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var base = binary ? 1024 : 1000;

  if (bytes < base) {
    return "".concat(bytes, " B");
  }

  var prefix = binary ? ['Ki', 'Mi', 'Gi'] : ['k', 'M', 'G'];
  var unit = -1;

  while (Math.abs(bytes) >= base && unit < prefix.length - 1) {
    bytes /= base;
    ++unit;
  }

  return "".concat(bytes.toFixed(1), " ").concat(prefix[unit], "B");
}
function camelizeObjectKeys(obj) {
  if (!obj) return {};
  return Object.keys(obj).reduce(function (o, key) {
    o[camelize(key)] = obj[key];
    return o;
  }, {});
}
function mergeDeep() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var key in target) {
    var sourceProperty = source[key];
    var targetProperty = target[key]; // Only continue deep merging if
    // both properties are objects

    if (helpers_isObject(sourceProperty) && helpers_isObject(targetProperty)) {
      source[key] = mergeDeep(sourceProperty, targetProperty);
      continue;
    }

    source[key] = targetProperty;
  }

  return source;
}
function fillArray(length, obj) {
  return Array(length).fill(obj);
}
/**  Polyfill for Event.prototype.composedPath */

function composedPath(e) {
  if (e.composedPath) return e.composedPath();
  var path = [];
  var el = e.target;

  while (el) {
    path.push(el);

    if (el.tagName === 'HTML') {
      path.push(document);
      path.push(window);
      return path;
    }

    el = el.parentElement;
  }

  return path;
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/service/index.js


var service_Service = /*#__PURE__*/function () {
  function Service() {
    _classCallCheck(this, Service);

    this.framework = {};
  }

  _createClass(Service, [{
    key: "init",
    value: function init(root, ssrContext) {}
  }]);

  return Service;
}();
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/presets/index.js





var _excluded = ["preset"];
// Preset
 // Utilities




var presets_Presets = /*#__PURE__*/function (_Service) {
  _inherits(Presets, _Service);

  var _super = _createSuper(Presets);

  function Presets(parentPreset, parent) {
    var _this;

    _classCallCheck(this, Presets);

    _this = _super.call(this); // The default preset

    var defaultPreset = mergeDeep({}, default_preset); // The user provided preset

    var userPreset = parent.userPreset; // The user provided global preset

    var _userPreset$preset = userPreset.preset,
        globalPreset = _userPreset$preset === void 0 ? {} : _userPreset$preset,
        preset = _objectWithoutProperties(userPreset, _excluded);

    if (globalPreset.preset != null) {
      consoleWarn('Global presets do not support the **preset** option, it can be safely omitted');
    }

    parent.preset = mergeDeep(mergeDeep(defaultPreset, globalPreset), preset);
    return _this;
  }

  return _createClass(Presets);
}(service_Service);
presets_Presets.property = 'presets';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/application/index.js






// Extensions

var application_Application = /*#__PURE__*/function (_Service) {
  _inherits(Application, _Service);

  var _super = _createSuper(Application);

  function Application() {
    var _this;

    _classCallCheck(this, Application);

    _this = _super.apply(this, arguments);
    _this.bar = 0;
    _this.top = 0;
    _this.left = 0;
    _this.insetFooter = 0;
    _this.right = 0;
    _this.bottom = 0;
    _this.footer = 0;
    _this.application = {
      bar: {},
      top: {},
      left: {},
      insetFooter: {},
      right: {},
      bottom: {},
      footer: {}
    };
    return _this;
  }

  _createClass(Application, [{
    key: "register",
    value: function register(uid, location, size) {
      this.application[location][uid] = size;
      this.update(location);
    }
  }, {
    key: "unregister",
    value: function unregister(uid, location) {
      if (this.application[location][uid] == null) return;
      delete this.application[location][uid];
      this.update(location);
    }
  }, {
    key: "update",
    value: function update(location) {
      this[location] = Object.values(this.application[location]).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    }
  }]);

  return Application;
}(service_Service);
application_Application.property = 'application';
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/breakpoint/index.js





// Extensions

var breakpoint_Breakpoint = /*#__PURE__*/function (_Service) {
  _inherits(Breakpoint, _Service);

  var _super = _createSuper(Breakpoint);

  function Breakpoint(preset) {
    var _this;

    _classCallCheck(this, Breakpoint);

    _this = _super.call(this); // Public

    _this.xs = false;
    _this.sm = false;
    _this.md = false;
    _this.lg = false;
    _this.xl = false;
    _this.xsOnly = false;
    _this.smOnly = false;
    _this.smAndDown = false;
    _this.smAndUp = false;
    _this.mdOnly = false;
    _this.mdAndDown = false;
    _this.mdAndUp = false;
    _this.lgOnly = false;
    _this.lgAndDown = false;
    _this.lgAndUp = false;
    _this.xlOnly = false; // Value is xs to match v2.x functionality

    _this.name = 'xs';
    _this.height = 0;
    _this.width = 0; // TODO: Add functionality to detect this dynamically in v3
    // Value is true to match v2.x functionality

    _this.mobile = true;
    _this.resizeTimeout = 0;
    var _preset$Breakpoint$pr = preset[Breakpoint.property],
        mobileBreakpoint = _preset$Breakpoint$pr.mobileBreakpoint,
        scrollBarWidth = _preset$Breakpoint$pr.scrollBarWidth,
        thresholds = _preset$Breakpoint$pr.thresholds;
    _this.mobileBreakpoint = mobileBreakpoint;
    _this.scrollBarWidth = scrollBarWidth;
    _this.thresholds = thresholds;
    return _this;
  }

  _createClass(Breakpoint, [{
    key: "init",
    value: function init() {
      this.update();
      /* istanbul ignore if */

      if (typeof window === 'undefined') return;
      window.addEventListener('resize', this.onResize.bind(this), {
        passive: true
      });
    }
    /* eslint-disable-next-line max-statements */

  }, {
    key: "update",
    value: function update() {
      var ssr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var height = ssr ? 0 : this.getClientHeight();
      var width = ssr ? 0 : this.getClientWidth();
      var xs = width < this.thresholds.xs;
      var sm = width < this.thresholds.sm && !xs;
      var md = width < this.thresholds.md - this.scrollBarWidth && !(sm || xs);
      var lg = width < this.thresholds.lg - this.scrollBarWidth && !(md || sm || xs);
      var xl = width >= this.thresholds.lg - this.scrollBarWidth;
      this.height = height;
      this.width = width;
      this.xs = xs;
      this.sm = sm;
      this.md = md;
      this.lg = lg;
      this.xl = xl;
      this.xsOnly = xs;
      this.smOnly = sm;
      this.smAndDown = (xs || sm) && !(md || lg || xl);
      this.smAndUp = !xs && (sm || md || lg || xl);
      this.mdOnly = md;
      this.mdAndDown = (xs || sm || md) && !(lg || xl);
      this.mdAndUp = !(xs || sm) && (md || lg || xl);
      this.lgOnly = lg;
      this.lgAndDown = (xs || sm || md || lg) && !xl;
      this.lgAndUp = !(xs || sm || md) && (lg || xl);
      this.xlOnly = xl;

      switch (true) {
        case xs:
          this.name = 'xs';
          break;

        case sm:
          this.name = 'sm';
          break;

        case md:
          this.name = 'md';
          break;

        case lg:
          this.name = 'lg';
          break;

        default:
          this.name = 'xl';
          break;
      }

      if (typeof this.mobileBreakpoint === 'number') {
        this.mobile = width < parseInt(this.mobileBreakpoint, 10);
        return;
      }

      var breakpoints = {
        xs: 0,
        sm: 1,
        md: 2,
        lg: 3,
        xl: 4
      };
      var current = breakpoints[this.name];
      var max = breakpoints[this.mobileBreakpoint];
      this.mobile = current <= max;
    }
  }, {
    key: "onResize",
    value: function onResize() {
      clearTimeout(this.resizeTimeout); // Added debounce to match what
      // v-resize used to do but was
      // removed due to a memory leak
      // https://github.com/vuetifyjs/vuetify/pull/2997

      this.resizeTimeout = window.setTimeout(this.update.bind(this), 200);
    } // Cross-browser support as described in:
    // https://stackoverflow.com/questions/1248081

  }, {
    key: "getClientWidth",
    value: function getClientWidth() {
      /* istanbul ignore if */
      if (typeof document === 'undefined') return 0; // SSR

      return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
  }, {
    key: "getClientHeight",
    value: function getClientHeight() {
      /* istanbul ignore if */
      if (typeof document === 'undefined') return 0; // SSR

      return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }
  }]);

  return Breakpoint;
}(service_Service);
breakpoint_Breakpoint.property = 'breakpoint';
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/goto/easing-patterns.js
// linear
var linear = function linear(t) {
  return t;
}; // accelerating from zero velocity

var easeInQuad = function easeInQuad(t) {
  return Math.pow(t, 2);
}; // decelerating to zero velocity

var easeOutQuad = function easeOutQuad(t) {
  return t * (2 - t);
}; // acceleration until halfway, then deceleration

var easeInOutQuad = function easeInOutQuad(t) {
  return t < 0.5 ? 2 * Math.pow(t, 2) : -1 + (4 - 2 * t) * t;
}; // accelerating from zero velocity

var easeInCubic = function easeInCubic(t) {
  return Math.pow(t, 3);
}; // decelerating to zero velocity

var easeOutCubic = function easeOutCubic(t) {
  return Math.pow(--t, 3) + 1;
}; // acceleration until halfway, then deceleration

var easeInOutCubic = function easeInOutCubic(t) {
  return t < 0.5 ? 4 * Math.pow(t, 3) : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}; // accelerating from zero velocity

var easeInQuart = function easeInQuart(t) {
  return Math.pow(t, 4);
}; // decelerating to zero velocity

var easeOutQuart = function easeOutQuart(t) {
  return 1 - Math.pow(--t, 4);
}; // acceleration until halfway, then deceleration

var easeInOutQuart = function easeInOutQuart(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
}; // accelerating from zero velocity

var easeInQuint = function easeInQuint(t) {
  return Math.pow(t, 5);
}; // decelerating to zero velocity

var easeOutQuint = function easeOutQuint(t) {
  return 1 + Math.pow(--t, 5);
}; // acceleration until halfway, then deceleration

var easeInOutQuint = function easeInOutQuint(t) {
  return t < 0.5 ? 16 * Math.pow(t, 5) : 1 + 16 * Math.pow(--t, 5);
};
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/goto/util.js


// Return target's cumulative offset from the top
function getOffset(target) {
  if (typeof target === 'number') {
    return target;
  }

  var el = util_$(target);

  if (!el) {
    throw typeof target === 'string' ? new Error("Target element \"".concat(target, "\" not found.")) : new TypeError("Target must be a Number/Selector/HTMLElement/VueComponent, received ".concat(util_type(target), " instead."));
  }

  var totalOffset = 0;

  while (el) {
    totalOffset += el.offsetTop;
    el = el.offsetParent;
  }

  return totalOffset;
}
function getContainer(container) {
  var el = util_$(container);
  if (el) return el;
  throw typeof container === 'string' ? new Error("Container element \"".concat(container, "\" not found.")) : new TypeError("Container must be a Selector/HTMLElement/VueComponent, received ".concat(util_type(container), " instead."));
}

function util_type(el) {
  return el == null ? el : el.constructor.name;
}

function util_$(el) {
  if (typeof el === 'string') {
    return document.querySelector(el);
  } else if (el && el._isVue) {
    return el.$el;
  } else if (el instanceof HTMLElement) {
    return el;
  } else {
    return null;
  }
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/goto/index.js









// Extensions
 // Utilities



function goTo(_target) {
  var _settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var settings = _objectSpread2({
    container: document.scrollingElement || document.body || document.documentElement,
    duration: 500,
    offset: 0,
    easing: 'easeInOutCubic',
    appOffset: true
  }, _settings);

  var container = getContainer(settings.container);
  /* istanbul ignore else */

  if (settings.appOffset && goTo.framework.application) {
    var isDrawer = container.classList.contains('v-navigation-drawer');
    var isClipped = container.classList.contains('v-navigation-drawer--clipped');
    var _goTo$framework$appli = goTo.framework.application,
        bar = _goTo$framework$appli.bar,
        top = _goTo$framework$appli.top;
    settings.offset += bar;
    /* istanbul ignore else */

    if (!isDrawer || isClipped) settings.offset += top;
  }

  var startTime = performance.now();
  var targetLocation;

  if (typeof _target === 'number') {
    targetLocation = getOffset(_target) - settings.offset;
  } else {
    targetLocation = getOffset(_target) - getOffset(container) - settings.offset;
  }

  var startLocation = container.scrollTop;
  if (targetLocation === startLocation) return Promise.resolve(targetLocation);
  var ease = typeof settings.easing === 'function' ? settings.easing : easing_patterns_namespaceObject[settings.easing];
  /* istanbul ignore else */

  if (!ease) throw new TypeError("Easing function \"".concat(settings.easing, "\" not found.")); // Cannot be tested properly in jsdom

  /* istanbul ignore next */

  return new Promise(function (resolve) {
    return requestAnimationFrame(function step(currentTime) {
      var timeElapsed = currentTime - startTime;
      var progress = Math.abs(settings.duration ? Math.min(timeElapsed / settings.duration, 1) : 1);
      container.scrollTop = Math.floor(startLocation + (targetLocation - startLocation) * ease(progress));
      var clientHeight = container === document.body ? document.documentElement.clientHeight : container.clientHeight;
      var reachBottom = clientHeight + container.scrollTop >= container.scrollHeight;

      if (progress === 1 || // Need to go lower but reach bottom
      targetLocation > container.scrollTop && reachBottom) {
        return resolve(targetLocation);
      }

      requestAnimationFrame(step);
    });
  });
}
goTo.framework = {};

goTo.init = function () {};

var goto_Goto = /*#__PURE__*/function (_Service) {
  _inherits(Goto, _Service);

  var _super = _createSuper(Goto);

  function Goto() {
    var _this;

    _classCallCheck(this, Goto);

    _this = _super.call(this);
    return _possibleConstructorReturn(_this, goTo);
  }

  return _createClass(Goto);
}(service_Service);
goto_Goto.property = 'goTo';
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/mdi-svg.js
var icons = {
  complete: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z',
  cancel: 'M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z',
  close: 'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z',
  delete: 'M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z',
  clear: 'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z',
  success: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z',
  info: 'M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  warning: 'M11,4.5H13V15.5H11V4.5M13,17.5V19.5H11V17.5H13Z',
  error: 'M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z',
  prev: 'M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z',
  next: 'M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z',
  checkboxOn: 'M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z',
  checkboxOff: 'M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z',
  checkboxIndeterminate: 'M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z',
  delimiter: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  sort: 'M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z',
  expand: 'M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z',
  menu: 'M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z',
  subgroup: 'M7,10L12,15L17,10H7Z',
  dropdown: 'M7,10L12,15L17,10H7Z',
  radioOn: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z',
  radioOff: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  edit: 'M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z',
  ratingEmpty: 'M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z',
  ratingFull: 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z',
  ratingHalf: 'M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z',
  loading: 'M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12',
  first: 'M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z',
  last: 'M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z',
  unfold: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z',
  file: 'M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z',
  plus: 'M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z',
  minus: 'M19,13H5V11H19V13Z'
};
/* harmony default export */ var mdi_svg = (icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/md.js
var md_icons = {
  complete: 'check',
  cancel: 'cancel',
  close: 'close',
  delete: 'cancel',
  clear: 'clear',
  success: 'check_circle',
  info: 'info',
  warning: 'priority_high',
  error: 'warning',
  prev: 'chevron_left',
  next: 'chevron_right',
  checkboxOn: 'check_box',
  checkboxOff: 'check_box_outline_blank',
  checkboxIndeterminate: 'indeterminate_check_box',
  delimiter: 'fiber_manual_record',
  sort: 'arrow_upward',
  expand: 'keyboard_arrow_down',
  menu: 'menu',
  subgroup: 'arrow_drop_down',
  dropdown: 'arrow_drop_down',
  radioOn: 'radio_button_checked',
  radioOff: 'radio_button_unchecked',
  edit: 'edit',
  ratingEmpty: 'star_border',
  ratingFull: 'star',
  ratingHalf: 'star_half',
  loading: 'cached',
  first: 'first_page',
  last: 'last_page',
  unfold: 'unfold_more',
  file: 'attach_file',
  plus: 'add',
  minus: 'remove'
};
/* harmony default export */ var md = (md_icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/mdi.js
var mdi_icons = {
  complete: 'mdi-check',
  cancel: 'mdi-close-circle',
  close: 'mdi-close',
  delete: 'mdi-close-circle',
  clear: 'mdi-close',
  success: 'mdi-check-circle',
  info: 'mdi-information',
  warning: 'mdi-exclamation',
  error: 'mdi-alert',
  prev: 'mdi-chevron-left',
  next: 'mdi-chevron-right',
  checkboxOn: 'mdi-checkbox-marked',
  checkboxOff: 'mdi-checkbox-blank-outline',
  checkboxIndeterminate: 'mdi-minus-box',
  delimiter: 'mdi-circle',
  sort: 'mdi-arrow-up',
  expand: 'mdi-chevron-down',
  menu: 'mdi-menu',
  subgroup: 'mdi-menu-down',
  dropdown: 'mdi-menu-down',
  radioOn: 'mdi-radiobox-marked',
  radioOff: 'mdi-radiobox-blank',
  edit: 'mdi-pencil',
  ratingEmpty: 'mdi-star-outline',
  ratingFull: 'mdi-star',
  ratingHalf: 'mdi-star-half-full',
  loading: 'mdi-cached',
  first: 'mdi-page-first',
  last: 'mdi-page-last',
  unfold: 'mdi-unfold-more-horizontal',
  file: 'mdi-paperclip',
  plus: 'mdi-plus',
  minus: 'mdi-minus'
};
/* harmony default export */ var mdi = (mdi_icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/fa.js
var fa_icons = {
  complete: 'fas fa-check',
  cancel: 'fas fa-times-circle',
  close: 'fas fa-times',
  delete: 'fas fa-times-circle',
  clear: 'fas fa-times-circle',
  success: 'fas fa-check-circle',
  info: 'fas fa-info-circle',
  warning: 'fas fa-exclamation',
  error: 'fas fa-exclamation-triangle',
  prev: 'fas fa-chevron-left',
  next: 'fas fa-chevron-right',
  checkboxOn: 'fas fa-check-square',
  checkboxOff: 'far fa-square',
  checkboxIndeterminate: 'fas fa-minus-square',
  delimiter: 'fas fa-circle',
  sort: 'fas fa-sort-up',
  expand: 'fas fa-chevron-down',
  menu: 'fas fa-bars',
  subgroup: 'fas fa-caret-down',
  dropdown: 'fas fa-caret-down',
  radioOn: 'far fa-dot-circle',
  radioOff: 'far fa-circle',
  edit: 'fas fa-edit',
  ratingEmpty: 'far fa-star',
  ratingFull: 'fas fa-star',
  ratingHalf: 'fas fa-star-half',
  loading: 'fas fa-sync',
  first: 'fas fa-step-backward',
  last: 'fas fa-step-forward',
  unfold: 'fas fa-arrows-alt-v',
  file: 'fas fa-paperclip',
  plus: 'fas fa-plus',
  minus: 'fas fa-minus'
};
/* harmony default export */ var fa = (fa_icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/fa4.js
var fa4_icons = {
  complete: 'fa fa-check',
  cancel: 'fa fa-times-circle',
  close: 'fa fa-times',
  delete: 'fa fa-times-circle',
  clear: 'fa fa-times-circle',
  success: 'fa fa-check-circle',
  info: 'fa fa-info-circle',
  warning: 'fa fa-exclamation',
  error: 'fa fa-exclamation-triangle',
  prev: 'fa fa-chevron-left',
  next: 'fa fa-chevron-right',
  checkboxOn: 'fa fa-check-square',
  checkboxOff: 'fa fa-square-o',
  checkboxIndeterminate: 'fa fa-minus-square',
  delimiter: 'fa fa-circle',
  sort: 'fa fa-sort-up',
  expand: 'fa fa-chevron-down',
  menu: 'fa fa-bars',
  subgroup: 'fa fa-caret-down',
  dropdown: 'fa fa-caret-down',
  radioOn: 'fa fa-dot-circle-o',
  radioOff: 'fa fa-circle-o',
  edit: 'fa fa-pencil',
  ratingEmpty: 'fa fa-star-o',
  ratingFull: 'fa fa-star',
  ratingHalf: 'fa fa-star-half-o',
  loading: 'fa fa-refresh',
  first: 'fa fa-step-backward',
  last: 'fa fa-step-forward',
  unfold: 'fa fa-angle-double-down',
  file: 'fa fa-paperclip',
  plus: 'fa fa-plus',
  minus: 'fa fa-minus'
};
/* harmony default export */ var fa4 = (fa4_icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/fa-svg.js



function convertToComponentDeclarations(component, iconSet) {
  var result = {};

  for (var key in iconSet) {
    result[key] = {
      component: component,
      props: {
        icon: iconSet[key].split(' fa-')
      }
    };
  }

  return result;
}
/* harmony default export */ var fa_svg = (convertToComponentDeclarations('font-awesome-icon', fa));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/index.js







/* harmony default export */ var presets = (Object.freeze({
  mdiSvg: mdi_svg,
  md: md,
  mdi: mdi,
  fa: fa,
  fa4: fa4,
  faSvg: fa_svg
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/index.js







// Extensions
 // Utilities

 // Presets


var icons_Icons = /*#__PURE__*/function (_Service) {
  _inherits(Icons, _Service);

  var _super = _createSuper(Icons);

  function Icons(preset) {
    var _this;

    _classCallCheck(this, Icons);

    _this = _super.call(this);
    var _preset$Icons$propert = preset[Icons.property],
        iconfont = _preset$Icons$propert.iconfont,
        values = _preset$Icons$propert.values,
        component = _preset$Icons$propert.component;
    _this.component = component;
    _this.iconfont = iconfont;
    _this.values = mergeDeep(presets[iconfont], values);
    return _this;
  }

  return _createClass(Icons);
}(service_Service);
icons_Icons.property = 'icons';
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/lang/index.js











// Extensions
 // Utilities



var LANG_PREFIX = '$vuetify.';
var lang_fallback = Symbol('Lang fallback');

function getTranslation(locale, key) {
  var usingDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var defaultLocale = arguments.length > 3 ? arguments[3] : undefined;
  var shortKey = key.replace(LANG_PREFIX, '');
  var translation = getObjectValueByPath(locale, shortKey, lang_fallback);

  if (translation === lang_fallback) {
    if (usingDefault) {
      consoleError("Translation key \"".concat(shortKey, "\" not found in fallback"));
      translation = key;
    } else {
      consoleWarn("Translation key \"".concat(shortKey, "\" not found, falling back to default"));
      translation = getTranslation(defaultLocale, key, true, defaultLocale);
    }
  }

  return translation;
}

var lang_Lang = /*#__PURE__*/function (_Service) {
  _inherits(Lang, _Service);

  var _super = _createSuper(Lang);

  function Lang(preset) {
    var _this;

    _classCallCheck(this, Lang);

    _this = _super.call(this);
    _this.defaultLocale = 'en';
    var _preset$Lang$property = preset[Lang.property],
        current = _preset$Lang$property.current,
        locales = _preset$Lang$property.locales,
        t = _preset$Lang$property.t;
    _this.current = current;
    _this.locales = locales;
    _this.translator = t || _this.defaultTranslator;
    return _this;
  }

  _createClass(Lang, [{
    key: "currentLocale",
    value: function currentLocale(key) {
      var translation = this.locales[this.current];
      var defaultLocale = this.locales[this.defaultLocale];
      return getTranslation(translation, key, false, defaultLocale);
    }
  }, {
    key: "t",
    value: function t(key) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      if (!key.startsWith(LANG_PREFIX)) return this.replace(key, params);
      return this.translator.apply(this, [key].concat(params));
    }
  }, {
    key: "defaultTranslator",
    value: function defaultTranslator(key) {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      return this.replace(this.currentLocale(key), params);
    }
  }, {
    key: "replace",
    value: function replace(str, params) {
      return str.replace(/\{(\d+)\}/g, function (match, index) {
        /* istanbul ignore next */
        return String(params[+index]);
      });
    }
  }]);

  return Lang;
}(service_Service);
lang_Lang.property = 'lang';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__("18a5");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/color/transformSRGB.js
 // For converting XYZ to sRGB

var srgbForwardMatrix = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.2040, 1.0570]]; // Forward gamma adjust

var srgbForwardTransform = function srgbForwardTransform(C) {
  return C <= 0.0031308 ? C * 12.92 : 1.055 * Math.pow(C, 1 / 2.4) - 0.055;
}; // For converting sRGB to XYZ


var srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]]; // Reverse gamma adjust

var srgbReverseTransform = function srgbReverseTransform(C) {
  return C <= 0.04045 ? C / 12.92 : Math.pow((C + 0.055) / 1.055, 2.4);
};

function fromXYZ(xyz) {
  var rgb = Array(3);
  var transform = srgbForwardTransform;
  var matrix = srgbForwardMatrix; // Matrix transform, then gamma adjustment

  for (var i = 0; i < 3; ++i) {
    rgb[i] = Math.round(clamp(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
  } // Rescale back to [0, 255]


  return (rgb[0] << 16) + (rgb[1] << 8) + (rgb[2] << 0);
}
function toXYZ(rgb) {
  var xyz = [0, 0, 0];
  var transform = srgbReverseTransform;
  var matrix = srgbReverseMatrix; // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB

  var r = transform((rgb >> 16 & 0xff) / 255);
  var g = transform((rgb >> 8 & 0xff) / 255);
  var b = transform((rgb >> 0 & 0xff) / 255); // Matrix color space transform

  for (var i = 0; i < 3; ++i) {
    xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
  }

  return xyz;
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/colorUtils.js


















// Utilities



function isCssColor(color) {
  return !!color && !!color.match(/^(#|var\(--|(rgb|hsl)a?\()/);
}
function colorToInt(color) {
  var rgb;

  if (typeof color === 'number') {
    rgb = color;
  } else if (typeof color === 'string') {
    var c = color[0] === '#' ? color.substring(1) : color;

    if (c.length === 3) {
      c = c.split('').map(function (char) {
        return char + char;
      }).join('');
    }

    if (c.length !== 6) {
      consoleWarn("'".concat(color, "' is not a valid rgb color"));
    }

    rgb = parseInt(c, 16);
  } else {
    throw new TypeError("Colors can only be numbers or strings, recieved ".concat(color == null ? color : color.constructor.name, " instead"));
  }

  if (rgb < 0) {
    consoleWarn("Colors cannot be negative: '".concat(color, "'"));
    rgb = 0;
  } else if (rgb > 0xffffff || isNaN(rgb)) {
    consoleWarn("'".concat(color, "' is not a valid rgb color"));
    rgb = 0xffffff;
  }

  return rgb;
}
function classToHex(color, colors, currentTheme) {
  var _color$toString$trim$ = color.toString().trim().replace('-', '').split(' ', 2),
      _color$toString$trim$2 = _slicedToArray(_color$toString$trim$, 2),
      colorName = _color$toString$trim$2[0],
      colorModifier = _color$toString$trim$2[1];

  var hexColor = '';

  if (colorName && colorName in colors) {
    if (colorModifier && colorModifier in colors[colorName]) {
      hexColor = colors[colorName][colorModifier];
    } else if ('base' in colors[colorName]) {
      hexColor = colors[colorName].base;
    }
  } else if (colorName && colorName in currentTheme) {
    hexColor = currentTheme[colorName];
  }

  return hexColor;
}
function intToHex(color) {
  var hexColor = color.toString(16);
  if (hexColor.length < 6) hexColor = '0'.repeat(6 - hexColor.length) + hexColor;
  return '#' + hexColor;
}
function colorToHex(color) {
  return intToHex(colorToInt(color));
}
/**
 * Converts HSVA to RGBA. Based on formula from https://en.wikipedia.org/wiki/HSL_and_HSV
 *
 * @param color HSVA color as an array [0-360, 0-1, 0-1, 0-1]
 */

function HSVAtoRGBA(hsva) {
  var h = hsva.h,
      s = hsva.s,
      v = hsva.v,
      a = hsva.a;

  var f = function f(n) {
    var k = (n + h / 60) % 6;
    return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  };

  var rgb = [f(5), f(3), f(1)].map(function (v) {
    return Math.round(v * 255);
  });
  return {
    r: rgb[0],
    g: rgb[1],
    b: rgb[2],
    a: a
  };
}
/**
 * Converts RGBA to HSVA. Based on formula from https://en.wikipedia.org/wiki/HSL_and_HSV
 *
 * @param color RGBA color as an array [0-255, 0-255, 0-255, 0-1]
 */

function RGBAtoHSVA(rgba) {
  if (!rgba) return {
    h: 0,
    s: 1,
    v: 1,
    a: 1
  };
  var r = rgba.r / 255;
  var g = rgba.g / 255;
  var b = rgba.b / 255;
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = 0;

  if (max !== min) {
    if (max === r) {
      h = 60 * (0 + (g - b) / (max - min));
    } else if (max === g) {
      h = 60 * (2 + (b - r) / (max - min));
    } else if (max === b) {
      h = 60 * (4 + (r - g) / (max - min));
    }
  }

  if (h < 0) h = h + 360;
  var s = max === 0 ? 0 : (max - min) / max;
  var hsv = [h, s, max];
  return {
    h: hsv[0],
    s: hsv[1],
    v: hsv[2],
    a: rgba.a
  };
}
function HSVAtoHSLA(hsva) {
  var h = hsva.h,
      s = hsva.s,
      v = hsva.v,
      a = hsva.a;
  var l = v - v * s / 2;
  var sprime = l === 1 || l === 0 ? 0 : (v - l) / Math.min(l, 1 - l);
  return {
    h: h,
    s: sprime,
    l: l,
    a: a
  };
}
function HSLAtoHSVA(hsl) {
  var h = hsl.h,
      s = hsl.s,
      l = hsl.l,
      a = hsl.a;
  var v = l + s * Math.min(l, 1 - l);
  var sprime = v === 0 ? 0 : 2 - 2 * l / v;
  return {
    h: h,
    s: sprime,
    v: v,
    a: a
  };
}
function RGBAtoCSS(rgba) {
  return "rgba(".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ", ").concat(rgba.a, ")");
}
function RGBtoCSS(rgba) {
  return RGBAtoCSS(_objectSpread2(_objectSpread2({}, rgba), {}, {
    a: 1
  }));
}
function RGBAtoHex(rgba) {
  var toHex = function toHex(v) {
    var h = Math.round(v).toString(16);
    return ('00'.substr(0, 2 - h.length) + h).toUpperCase();
  };

  return "#".concat([toHex(rgba.r), toHex(rgba.g), toHex(rgba.b), toHex(Math.round(rgba.a * 255))].join(''));
}
function HexToRGBA(hex) {
  var rgba = chunk(hex.slice(1), 2).map(function (c) {
    return parseInt(c, 16);
  });
  return {
    r: rgba[0],
    g: rgba[1],
    b: rgba[2],
    a: Math.round(rgba[3] / 255 * 100) / 100
  };
}
function HexToHSVA(hex) {
  var rgb = HexToRGBA(hex);
  return RGBAtoHSVA(rgb);
}
function HSVAtoHex(hsva) {
  return RGBAtoHex(HSVAtoRGBA(hsva));
}
function parseHex(hex) {
  if (hex.startsWith('#')) {
    hex = hex.slice(1);
  }

  hex = hex.replace(/([^0-9a-f])/gi, 'F');

  if (hex.length === 3 || hex.length === 4) {
    hex = hex.split('').map(function (x) {
      return x + x;
    }).join('');
  }

  if (hex.length === 6) {
    hex = padEnd(hex, 8, 'F');
  } else {
    hex = padEnd(padEnd(hex, 6), 8, 'F');
  }

  return "#".concat(hex).toUpperCase().substr(0, 9);
}
function parseGradient(gradient, colors, currentTheme) {
  return gradient.replace(/([a-z]+(\s[a-z]+-[1-5])?)(?=$|,)/gi, function (x) {
    return classToHex(x, colors, currentTheme) || x;
  }).replace(/(rgba\()#[0-9a-f]+(?=,)/gi, function (x) {
    return 'rgba(' + Object.values(HexToRGBA(parseHex(x.replace(/rgba\(/, '')))).slice(0, 3).join(',');
  });
}
function RGBtoInt(rgba) {
  return (rgba.r << 16) + (rgba.g << 8) + rgba.b;
}
/**
 * Returns the contrast ratio (1-21) between two colors.
 *
 * @param c1 First color
 * @param c2 Second color
 */

function contrastRatio(c1, c2) {
  var _toXYZ = toXYZ(RGBtoInt(c1)),
      _toXYZ2 = _slicedToArray(_toXYZ, 2),
      y1 = _toXYZ2[1];

  var _toXYZ3 = toXYZ(RGBtoInt(c2)),
      _toXYZ4 = _slicedToArray(_toXYZ3, 2),
      y2 = _toXYZ4[1];

  return (Math.max(y1, y2) + 0.05) / (Math.min(y1, y2) + 0.05);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.cbrt.js
var es_math_cbrt = __webpack_require__("3ea3");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/color/transformCIELAB.js

var delta = 0.20689655172413793; // 6÷29

var cielabForwardTransform = function cielabForwardTransform(t) {
  return t > Math.pow(delta, 3) ? Math.cbrt(t) : t / (3 * Math.pow(delta, 2)) + 4 / 29;
};

var cielabReverseTransform = function cielabReverseTransform(t) {
  return t > delta ? Math.pow(t, 3) : 3 * Math.pow(delta, 2) * (t - 4 / 29);
};

function transformCIELAB_fromXYZ(xyz) {
  var transform = cielabForwardTransform;
  var transformedY = transform(xyz[1]);
  return [116 * transformedY - 16, 500 * (transform(xyz[0] / 0.95047) - transformedY), 200 * (transformedY - transform(xyz[2] / 1.08883))];
}
function transformCIELAB_toXYZ(lab) {
  var transform = cielabReverseTransform;
  var Ln = (lab[0] + 16) / 116;
  return [transform(Ln + lab[1] / 500) * 0.95047, transform(Ln), transform(Ln - lab[2] / 200) * 1.08883];
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/theme/utils.js



var utils_excluded = ["anchor"],
    _excluded2 = ["anchor"];










function parse(theme) {
  var isItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var variations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var anchor = theme.anchor,
      variant = _objectWithoutProperties(theme, utils_excluded);

  var colors = Object.keys(variant);
  var parsedTheme = {};

  for (var i = 0; i < colors.length; ++i) {
    var name = colors[i];
    var value = theme[name];
    if (value == null) continue;

    if (!variations) {
      parsedTheme[name] = {
        base: intToHex(colorToInt(value))
      };
    } else if (isItem) {
      /* istanbul ignore else */
      if (name === 'base' || name.startsWith('lighten') || name.startsWith('darken')) {
        parsedTheme[name] = colorToHex(value);
      }
    } else if (_typeof(value) === 'object') {
      parsedTheme[name] = parse(value, true, variations);
    } else {
      parsedTheme[name] = genVariations(name, colorToInt(value));
    }
  }

  if (!isItem) {
    parsedTheme.anchor = anchor || parsedTheme.base || parsedTheme.primary.base;
  }

  return parsedTheme;
}
/**
 * Generate the CSS for a base color (.primary)
 */

var genBaseColor = function genBaseColor(name, value) {
  return "\n.v-application .".concat(name, " {\n  background-color: ").concat(value, " !important;\n  border-color: ").concat(value, " !important;\n}\n.v-application .").concat(name, "--text {\n  color: ").concat(value, " !important;\n  caret-color: ").concat(value, " !important;\n}");
};
/**
 * Generate the CSS for a variant color (.primary.darken-2)
 */


var utils_genVariantColor = function genVariantColor(name, variant, value) {
  var _variant$split = variant.split(/(\d)/, 2),
      _variant$split2 = _slicedToArray(_variant$split, 2),
      type = _variant$split2[0],
      n = _variant$split2[1];

  return "\n.v-application .".concat(name, ".").concat(type, "-").concat(n, " {\n  background-color: ").concat(value, " !important;\n  border-color: ").concat(value, " !important;\n}\n.v-application .").concat(name, "--text.text--").concat(type, "-").concat(n, " {\n  color: ").concat(value, " !important;\n  caret-color: ").concat(value, " !important;\n}");
};

var genColorVariableName = function genColorVariableName(name) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
  return "--v-".concat(name, "-").concat(variant);
};

var genColorVariable = function genColorVariable(name) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
  return "var(".concat(genColorVariableName(name, variant), ")");
};

function genStyles(theme) {
  var cssVar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var anchor = theme.anchor,
      variant = _objectWithoutProperties(theme, _excluded2);

  var colors = Object.keys(variant);
  if (!colors.length) return '';
  var variablesCss = '';
  var css = '';
  var aColor = cssVar ? genColorVariable('anchor') : anchor;
  css += ".v-application a { color: ".concat(aColor, "; }");
  cssVar && (variablesCss += "  ".concat(genColorVariableName('anchor'), ": ").concat(anchor, ";\n"));

  for (var i = 0; i < colors.length; ++i) {
    var name = colors[i];
    var value = theme[name];
    css += genBaseColor(name, cssVar ? genColorVariable(name) : value.base);
    cssVar && (variablesCss += "  ".concat(genColorVariableName(name), ": ").concat(value.base, ";\n"));
    var variants = keys(value);

    for (var _i = 0; _i < variants.length; ++_i) {
      var _variant = variants[_i];
      var variantValue = value[_variant];
      if (_variant === 'base') continue;
      css += utils_genVariantColor(name, _variant, cssVar ? genColorVariable(name, _variant) : variantValue);
      cssVar && (variablesCss += "  ".concat(genColorVariableName(name, _variant), ": ").concat(variantValue, ";\n"));
    }
  }

  if (cssVar) {
    variablesCss = ":root {\n".concat(variablesCss, "}\n\n");
  }

  return variablesCss + css;
}
function genVariations(name, value) {
  var values = {
    base: intToHex(value)
  };

  for (var i = 5; i > 0; --i) {
    values["lighten".concat(i)] = intToHex(lighten(value, i));
  }

  for (var _i2 = 1; _i2 <= 4; ++_i2) {
    values["darken".concat(_i2)] = intToHex(darken(value, _i2));
  }

  return values;
}
function lighten(value, amount) {
  var lab = transformCIELAB_fromXYZ(toXYZ(value));
  lab[0] = lab[0] + amount * 10;
  return fromXYZ(transformCIELAB_toXYZ(lab));
}
function darken(value, amount) {
  var lab = transformCIELAB_fromXYZ(toXYZ(value));
  lab[0] = lab[0] - amount * 10;
  return fromXYZ(transformCIELAB_toXYZ(lab));
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/theme/index.js










/* eslint-disable no-multi-spaces */
// Extensions
 // Utilities


 // Types


var theme_Theme = /*#__PURE__*/function (_Service) {
  _inherits(Theme, _Service);

  var _super = _createSuper(Theme);

  function Theme(preset) {
    var _this;

    _classCallCheck(this, Theme);

    _this = _super.call(this);
    _this.disabled = false;
    _this.isDark = null;
    _this.unwatch = null;
    _this.vueMeta = null;
    var _preset$Theme$propert = preset[Theme.property],
        dark = _preset$Theme$propert.dark,
        disable = _preset$Theme$propert.disable,
        options = _preset$Theme$propert.options,
        themes = _preset$Theme$propert.themes;
    _this.dark = Boolean(dark);
    _this.defaults = _this.themes = themes;
    _this.options = options;

    if (disable) {
      _this.disabled = true;
      return _possibleConstructorReturn(_this);
    }

    _this.themes = {
      dark: _this.fillVariant(themes.dark, true),
      light: _this.fillVariant(themes.light, false)
    };
    return _this;
  } // When setting css, check for element and apply new values

  /* eslint-disable-next-line accessor-pairs */


  _createClass(Theme, [{
    key: "css",
    set: function set(val) {
      if (this.vueMeta) {
        if (this.isVueMeta23) {
          this.applyVueMeta23();
        }

        return;
      }

      this.checkOrCreateStyleElement() && (this.styleEl.innerHTML = val);
    }
  }, {
    key: "dark",
    get: function get() {
      return Boolean(this.isDark);
    } // Apply current theme default
    // only called on client side
    ,
    set: function set(val) {
      var oldDark = this.isDark;
      this.isDark = val; // Only apply theme after dark
      // has already been set before

      oldDark != null && this.applyTheme();
    }
  }, {
    key: "applyTheme",
    value: function applyTheme() {
      if (this.disabled) return this.clearCss();
      this.css = this.generatedStyles;
    }
  }, {
    key: "clearCss",
    value: function clearCss() {
      this.css = '';
    } // Initialize theme for SSR and SPA
    // Attach to ssrContext head or
    // apply new theme to document

  }, {
    key: "init",
    value: function init(root, ssrContext) {
      if (this.disabled) return;
      /* istanbul ignore else */

      if (root.$meta) {
        this.initVueMeta(root);
      } else if (ssrContext) {
        this.initSSR(ssrContext);
      }

      this.initTheme(root);
    } // Allows for you to set target theme

  }, {
    key: "setTheme",
    value: function setTheme(theme, value) {
      this.themes[theme] = Object.assign(this.themes[theme], value);
      this.applyTheme();
    } // Reset theme defaults

  }, {
    key: "resetThemes",
    value: function resetThemes() {
      this.themes.light = Object.assign({}, this.defaults.light);
      this.themes.dark = Object.assign({}, this.defaults.dark);
      this.applyTheme();
    } // Check for existence of style element

  }, {
    key: "checkOrCreateStyleElement",
    value: function checkOrCreateStyleElement() {
      this.styleEl = document.getElementById('vuetify-theme-stylesheet');
      /* istanbul ignore next */

      if (this.styleEl) return true;
      this.genStyleElement(); // If doesn't have it, create it

      return Boolean(this.styleEl);
    }
  }, {
    key: "fillVariant",
    value: function fillVariant() {
      var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var dark = arguments.length > 1 ? arguments[1] : undefined;
      var defaultTheme = this.themes[dark ? 'dark' : 'light'];
      return Object.assign({}, defaultTheme, theme);
    } // Generate the style element
    // if applicable

  }, {
    key: "genStyleElement",
    value: function genStyleElement() {
      /* istanbul ignore if */
      if (typeof document === 'undefined') return;
      /* istanbul ignore next */

      this.styleEl = document.createElement('style');
      this.styleEl.type = 'text/css';
      this.styleEl.id = 'vuetify-theme-stylesheet';

      if (this.options.cspNonce) {
        this.styleEl.setAttribute('nonce', this.options.cspNonce);
      }

      document.head.appendChild(this.styleEl);
    }
  }, {
    key: "initVueMeta",
    value: function initVueMeta(root) {
      var _this2 = this;

      this.vueMeta = root.$meta();

      if (this.isVueMeta23) {
        // vue-meta needs to apply after mounted()
        root.$nextTick(function () {
          _this2.applyVueMeta23();
        });
        return;
      }

      var metaKeyName = typeof this.vueMeta.getOptions === 'function' ? this.vueMeta.getOptions().keyName : 'metaInfo';
      var metaInfo = root.$options[metaKeyName] || {};

      root.$options[metaKeyName] = function () {
        metaInfo.style = metaInfo.style || [];
        var vuetifyStylesheet = metaInfo.style.find(function (s) {
          return s.id === 'vuetify-theme-stylesheet';
        });

        if (!vuetifyStylesheet) {
          metaInfo.style.push({
            cssText: _this2.generatedStyles,
            type: 'text/css',
            id: 'vuetify-theme-stylesheet',
            nonce: (_this2.options || {}).cspNonce
          });
        } else {
          vuetifyStylesheet.cssText = _this2.generatedStyles;
        }

        return metaInfo;
      };
    }
  }, {
    key: "applyVueMeta23",
    value: function applyVueMeta23() {
      var _this$vueMeta$addApp = this.vueMeta.addApp('vuetify'),
          set = _this$vueMeta$addApp.set;

      set({
        style: [{
          cssText: this.generatedStyles,
          type: 'text/css',
          id: 'vuetify-theme-stylesheet',
          nonce: this.options.cspNonce
        }]
      });
    }
  }, {
    key: "initSSR",
    value: function initSSR(ssrContext) {
      // SSR
      var nonce = this.options.cspNonce ? " nonce=\"".concat(this.options.cspNonce, "\"") : '';
      ssrContext.head = ssrContext.head || '';
      ssrContext.head += "<style type=\"text/css\" id=\"vuetify-theme-stylesheet\"".concat(nonce, ">").concat(this.generatedStyles, "</style>");
    }
  }, {
    key: "initTheme",
    value: function initTheme(root) {
      var _this3 = this;

      // Only watch for reactivity on client side
      if (typeof document === 'undefined') return; // If we get here somehow, ensure
      // existing instance is removed

      if (this.unwatch) {
        this.unwatch();
        this.unwatch = null;
      } // TODO: Update to use RFC if merged
      // https://github.com/vuejs/rfcs/blob/advanced-reactivity-api/active-rfcs/0000-advanced-reactivity-api.md


      root.$once('hook:created', function () {
        var obs = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.observable({
          themes: _this3.themes
        });
        _this3.unwatch = root.$watch(function () {
          return obs.themes;
        }, function () {
          return _this3.applyTheme();
        }, {
          deep: true
        });
      });
      this.applyTheme();
    }
  }, {
    key: "currentTheme",
    get: function get() {
      var target = this.dark ? 'dark' : 'light';
      return this.themes[target];
    }
  }, {
    key: "generatedStyles",
    get: function get() {
      var theme = this.parsedTheme;
      /* istanbul ignore next */

      var options = this.options || {};
      var css;

      if (options.themeCache != null) {
        css = options.themeCache.get(theme);
        /* istanbul ignore if */

        if (css != null) return css;
      }

      css = genStyles(theme, options.customProperties);

      if (options.minifyTheme != null) {
        css = options.minifyTheme(css);
      }

      if (options.themeCache != null) {
        options.themeCache.set(theme, css);
      }

      return css;
    }
  }, {
    key: "parsedTheme",
    get: function get() {
      return parse(this.currentTheme || {}, undefined, getNestedValue(this.options, ['variations'], true));
    } // Is using v2.3 of vue-meta
    // https://github.com/nuxt/vue-meta/releases/tag/v2.3.0

  }, {
    key: "isVueMeta23",
    get: function get() {
      return typeof this.vueMeta.addApp === 'function';
    }
  }]);

  return Theme;
}(service_Service);
theme_Theme.property = 'theme';
// CONCATENATED MODULE: ./node_modules/vuetify/lib/framework.js






 // Services



var framework_Vuetify = /*#__PURE__*/function () {
  function Vuetify() {
    var userPreset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Vuetify);

    this.framework = {
      isHydrating: false
    };
    this.installed = [];
    this.preset = {};
    this.userPreset = {};
    this.userPreset = userPreset;
    this.use(presets_Presets);
    this.use(application_Application);
    this.use(breakpoint_Breakpoint);
    this.use(goto_Goto);
    this.use(icons_Icons);
    this.use(lang_Lang);
    this.use(theme_Theme);
  } // Called on the new vuetify instance
  // bootstrap in install beforeCreate
  // Exposes ssrContext if available


  _createClass(Vuetify, [{
    key: "init",
    value: function init(root, ssrContext) {
      var _this = this;

      this.installed.forEach(function (property) {
        var service = _this.framework[property];
        service.framework = _this.framework;
        service.init(root, ssrContext);
      }); // rtl is not installed and
      // will never be called by
      // the init process

      this.framework.rtl = Boolean(this.preset.rtl);
    } // Instantiate a VuetifyService

  }, {
    key: "use",
    value: function use(Service) {
      var property = Service.property;
      if (this.installed.includes(property)) return; // TODO maybe a specific type for arg 2?

      this.framework[property] = new Service(this.preset, this);
      this.installed.push(property);
    }
  }]);

  return Vuetify;
}();


framework_Vuetify.install = install_install;
framework_Vuetify.installed = false;
framework_Vuetify.version = "2.6.2";
framework_Vuetify.config = {
  silent: false
};
// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/console.js











/* eslint-disable no-console */


function createMessage(message, vm, parent) {
  if (framework_Vuetify.config.silent) return;

  if (parent) {
    vm = {
      _isVue: true,
      $parent: parent,
      $options: vm
    };
  }

  if (vm) {
    // Only show each message once per instance
    vm.$_alreadyWarned = vm.$_alreadyWarned || [];
    if (vm.$_alreadyWarned.includes(message)) return;
    vm.$_alreadyWarned.push(message);
  }

  return "[Vuetify] ".concat(message) + (vm ? generateComponentTrace(vm) : '');
}

function consoleInfo(message, vm, parent) {
  var newMessage = createMessage(message, vm, parent);
  newMessage != null && console.info(newMessage);
}
function consoleWarn(message, vm, parent) {
  var newMessage = createMessage(message, vm, parent);
  newMessage != null && console.warn(newMessage);
}
function consoleError(message, vm, parent) {
  var newMessage = createMessage(message, vm, parent);
  newMessage != null && console.error(newMessage);
}
function deprecate(original, replacement, vm, parent) {
  consoleWarn("[UPGRADE] '".concat(original, "' is deprecated, use '").concat(replacement, "' instead."), vm, parent);
}
function breaking(original, replacement, vm, parent) {
  consoleError("[BREAKING] '".concat(original, "' has been removed, use '").concat(replacement, "' instead. For more information, see the upgrade guide https://github.com/vuetifyjs/vuetify/releases/tag/v2.0.0#user-content-upgrade-guide"), vm, parent);
}
function removed(original, vm, parent) {
  consoleWarn("[REMOVED] '".concat(original, "' has been removed. You can safely omit it."), vm, parent);
}
/**
 * Shamelessly stolen from vuejs/vue/blob/dev/src/core/util/debug.js
 */

var classifyRE = /(?:^|[-_])(\w)/g;

var classify = function classify(str) {
  return str.replace(classifyRE, function (c) {
    return c.toUpperCase();
  }).replace(/[-_]/g, '');
};

function formatComponentName(vm, includeFile) {
  if (vm.$root === vm) {
    return '<Root>';
  }

  var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
  var name = options.name || options._componentTag;
  var file = options.__file;

  if (!name && file) {
    var match = file.match(/([^/\\]+)\.vue$/);
    name = match && match[1];
  }

  return (name ? "<".concat(classify(name), ">") : "<Anonymous>") + (file && includeFile !== false ? " at ".concat(file) : '');
}

function generateComponentTrace(vm) {
  if (vm._isVue && vm.$parent) {
    var tree = [];
    var currentRecursiveSequence = 0;

    while (vm) {
      if (tree.length > 0) {
        var last = tree[tree.length - 1];

        if (last.constructor === vm.constructor) {
          currentRecursiveSequence++;
          vm = vm.$parent;
          continue;
        } else if (currentRecursiveSequence > 0) {
          tree[tree.length - 1] = [last, currentRecursiveSequence];
          currentRecursiveSequence = 0;
        }
      }

      tree.push(vm);
      vm = vm.$parent;
    }

    return '\n\nfound in\n\n' + tree.map(function (vm, i) {
      return "".concat(i === 0 ? '---> ' : ' '.repeat(5 + i * 2)).concat(Array.isArray(vm) ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)") : formatComponentName(vm));
    }).join('\n');
  } else {
    return "\n\n(found in ".concat(formatComponentName(vm), ")");
  }
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js











/* harmony default export */ var colorable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'colorable',
  props: {
    color: String
  },
  methods: {
    setBackgroundColor: function setBackgroundColor(color) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof data.style === 'string') {
        // istanbul ignore next
        consoleError('style must be an object', this); // istanbul ignore next

        return data;
      }

      if (typeof data.class === 'string') {
        // istanbul ignore next
        consoleError('class must be an object', this); // istanbul ignore next

        return data;
      }

      if (isCssColor(color)) {
        data.style = _objectSpread2(_objectSpread2({}, data.style), {}, {
          'background-color': "".concat(color),
          'border-color': "".concat(color)
        });
      } else if (color) {
        data.class = _objectSpread2(_objectSpread2({}, data.class), {}, _defineProperty({}, color, true));
      }

      return data;
    },
    setTextColor: function setTextColor(color) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof data.style === 'string') {
        // istanbul ignore next
        consoleError('style must be an object', this); // istanbul ignore next

        return data;
      }

      if (typeof data.class === 'string') {
        // istanbul ignore next
        consoleError('class must be an object', this); // istanbul ignore next

        return data;
      }

      if (isCssColor(color)) {
        data.style = _objectSpread2(_objectSpread2({}, data.style), {}, {
          color: "".concat(color),
          'caret-color': "".concat(color)
        });
      } else if (color) {
        var _color$toString$trim$ = color.toString().trim().split(' ', 2),
            _color$toString$trim$2 = _slicedToArray(_color$toString$trim$, 2),
            colorName = _color$toString$trim$2[0],
            colorModifier = _color$toString$trim$2[1];

        data.class = _objectSpread2(_objectSpread2({}, data.class), {}, _defineProperty({}, colorName + '--text', true));

        if (colorModifier) {
          data.class['text--' + colorModifier] = true;
        }
      }

      return data;
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/sizeable/index.js


/* harmony default export */ var sizeable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'sizeable',
  props: {
    large: Boolean,
    small: Boolean,
    xLarge: Boolean,
    xSmall: Boolean
  },
  computed: {
    medium: function medium() {
      return Boolean(!this.xSmall && !this.small && !this.large && !this.xLarge);
    },
    sizeableClasses: function sizeableClasses() {
      return {
        'v-size--x-small': this.xSmall,
        'v-size--small': this.small,
        'v-size--default': this.medium,
        'v-size--large': this.large,
        'v-size--x-large': this.xLarge
      };
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js


/* @vue/component */

var Themeable = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend().extend({
  name: 'themeable',
  provide: function provide() {
    return {
      theme: this.themeableProvide
    };
  },
  inject: {
    theme: {
      default: {
        isDark: false
      }
    }
  },
  props: {
    dark: {
      type: Boolean,
      default: null
    },
    light: {
      type: Boolean,
      default: null
    }
  },
  data: function data() {
    return {
      themeableProvide: {
        isDark: false
      }
    };
  },
  computed: {
    appIsDark: function appIsDark() {
      return this.$vuetify.theme.dark || false;
    },
    isDark: function isDark() {
      if (this.dark === true) {
        // explicitly dark
        return true;
      } else if (this.light === true) {
        // explicitly light
        return false;
      } else {
        // inherit from parent, or default false if there is none
        return this.theme.isDark;
      }
    },
    themeClasses: function themeClasses() {
      return {
        'theme--dark': this.isDark,
        'theme--light': !this.isDark
      };
    },

    /** Used by menus and dialogs, inherits from v-app instead of the parent */
    rootIsDark: function rootIsDark() {
      if (this.dark === true) {
        // explicitly dark
        return true;
      } else if (this.light === true) {
        // explicitly light
        return false;
      } else {
        // inherit from v-app
        return this.appIsDark;
      }
    },
    rootThemeClasses: function rootThemeClasses() {
      return {
        'theme--dark': this.rootIsDark,
        'theme--light': !this.rootIsDark
      };
    }
  },
  watch: {
    isDark: {
      handler: function handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.themeableProvide.isDark = this.isDark;
        }
      },
      immediate: true
    }
  }
});
/* harmony default export */ var themeable = (Themeable);
function functionalThemeClasses(context) {
  var vm = _objectSpread2(_objectSpread2({}, context.props), context.injections);

  var isDark = Themeable.options.computed.isDark.call(vm);
  return Themeable.options.computed.themeClasses.call({
    isDark: isDark
  });
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/mixins.js
/* eslint-disable max-len, import/export, no-use-before-define */

function mixins_mixins() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    mixins: args
  });
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VIcon/VIcon.js











 // Mixins




 // Util

 // Types



var SIZE_MAP;

(function (SIZE_MAP) {
  SIZE_MAP["xSmall"] = "12px";
  SIZE_MAP["small"] = "16px";
  SIZE_MAP["default"] = "24px";
  SIZE_MAP["medium"] = "28px";
  SIZE_MAP["large"] = "36px";
  SIZE_MAP["xLarge"] = "40px";
})(SIZE_MAP || (SIZE_MAP = {}));

function isFontAwesome5(iconType) {
  return ['fas', 'far', 'fal', 'fab', 'fad', 'fak'].some(function (val) {
    return iconType.includes(val);
  });
}

function isSvgPath(icon) {
  return /^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(icon) && /[\dz]$/i.test(icon) && icon.length > 4;
}

var VIcon_VIcon = mixins_mixins(binds_attrs, colorable, sizeable, themeable
/* @vue/component */
).extend({
  name: 'v-icon',
  props: {
    dense: Boolean,
    disabled: Boolean,
    left: Boolean,
    right: Boolean,
    size: [Number, String],
    tag: {
      type: String,
      required: false,
      default: 'i'
    }
  },
  computed: {
    medium: function medium() {
      return false;
    },
    hasClickListener: function hasClickListener() {
      return Boolean(this.listeners$.click || this.listeners$['!click']);
    }
  },
  methods: {
    getIcon: function getIcon() {
      var iconName = '';
      if (this.$slots.default) iconName = this.$slots.default[0].text.trim();
      return remapInternalIcon(this, iconName);
    },
    getSize: function getSize() {
      var sizes = {
        xSmall: this.xSmall,
        small: this.small,
        medium: this.medium,
        large: this.large,
        xLarge: this.xLarge
      };
      var explicitSize = keys(sizes).find(function (key) {
        return sizes[key];
      });
      return explicitSize && SIZE_MAP[explicitSize] || convertToUnit(this.size);
    },
    // Component data for both font icon and SVG wrapper span
    getDefaultData: function getDefaultData() {
      return {
        staticClass: 'v-icon notranslate',
        class: {
          'v-icon--disabled': this.disabled,
          'v-icon--left': this.left,
          'v-icon--link': this.hasClickListener,
          'v-icon--right': this.right,
          'v-icon--dense': this.dense
        },
        attrs: _objectSpread2({
          'aria-hidden': !this.hasClickListener,
          disabled: this.hasClickListener && this.disabled,
          type: this.hasClickListener ? 'button' : undefined
        }, this.attrs$),
        on: this.listeners$
      };
    },
    getSvgWrapperData: function getSvgWrapperData() {
      var fontSize = this.getSize();

      var wrapperData = _objectSpread2(_objectSpread2({}, this.getDefaultData()), {}, {
        style: fontSize ? {
          fontSize: fontSize,
          height: fontSize,
          width: fontSize
        } : undefined
      });

      this.applyColors(wrapperData);
      return wrapperData;
    },
    applyColors: function applyColors(data) {
      data.class = _objectSpread2(_objectSpread2({}, data.class), this.themeClasses);
      this.setTextColor(this.color, data);
    },
    renderFontIcon: function renderFontIcon(icon, h) {
      var newChildren = [];
      var data = this.getDefaultData();
      var iconType = 'material-icons'; // Material Icon delimiter is _
      // https://material.io/icons/

      var delimiterIndex = icon.indexOf('-');
      var isMaterialIcon = delimiterIndex <= -1;

      if (isMaterialIcon) {
        // Material icon uses ligatures.
        newChildren.push(icon);
      } else {
        iconType = icon.slice(0, delimiterIndex);
        if (isFontAwesome5(iconType)) iconType = '';
      }

      data.class[iconType] = true;
      data.class[icon] = !isMaterialIcon;
      var fontSize = this.getSize();
      if (fontSize) data.style = {
        fontSize: fontSize
      };
      this.applyColors(data);
      return h(this.hasClickListener ? 'button' : this.tag, data, newChildren);
    },
    renderSvgIcon: function renderSvgIcon(icon, h) {
      var svgData = {
        class: 'v-icon__svg',
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 24 24',
          role: 'img',
          'aria-hidden': true
        }
      };
      var size = this.getSize();

      if (size) {
        svgData.style = {
          fontSize: size,
          height: size,
          width: size
        };
      }

      return h(this.hasClickListener ? 'button' : 'span', this.getSvgWrapperData(), [h('svg', svgData, [h('path', {
        attrs: {
          d: icon
        }
      })])]);
    },
    renderSvgIconComponent: function renderSvgIconComponent(icon, h) {
      var data = {
        class: {
          'v-icon__component': true
        }
      };
      var size = this.getSize();

      if (size) {
        data.style = {
          fontSize: size,
          height: size,
          width: size
        };
      }

      this.applyColors(data);
      var component = icon.component;
      data.props = icon.props;
      data.nativeOn = data.on;
      return h(this.hasClickListener ? 'button' : 'span', this.getSvgWrapperData(), [h(component, data)]);
    }
  },
  render: function render(h) {
    var icon = this.getIcon();

    if (typeof icon === 'string') {
      if (isSvgPath(icon)) {
        return this.renderSvgIcon(icon, h);
      }

      return this.renderFontIcon(icon, h);
    }

    return this.renderSvgIconComponent(icon, h);
  }
});
/* harmony default export */ var components_VIcon_VIcon = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-icon',
  $_wrapperFor: VIcon_VIcon,
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;
    var iconName = ''; // Support usage of v-text and v-html

    if (data.domProps) {
      iconName = data.domProps.textContent || data.domProps.innerHTML || iconName; // Remove nodes so it doesn't
      // overwrite our changes

      delete data.domProps.textContent;
      delete data.domProps.innerHTML;
    }

    return h(VIcon_VIcon, data, iconName ? [iconName] : children);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VTooltip/VTooltip.sass
var VTooltip = __webpack_require__("9734");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/delayable/index.js


/**
 * Delayable
 *
 * @mixin
 *
 * Changes the open or close delay time for elements
 */

/* harmony default export */ var delayable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend().extend({
  name: 'delayable',
  props: {
    openDelay: {
      type: [Number, String],
      default: 0
    },
    closeDelay: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      openTimeout: undefined,
      closeTimeout: undefined
    };
  },
  methods: {
    /**
     * Clear any pending delay timers from executing
     */
    clearDelay: function clearDelay() {
      clearTimeout(this.openTimeout);
      clearTimeout(this.closeTimeout);
    },

    /**
     * Runs callback after a specified delay
     */
    runDelay: function runDelay(type, cb) {
      var _this = this;

      this.clearDelay();
      var delay = parseInt(this["".concat(type, "Delay")], 10);
      this["".concat(type, "Timeout")] = setTimeout(cb || function () {
        _this.isActive = {
          open: true,
          close: false
        }[type];
      }, delay);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/toggleable/index.js


function factory() {
  var _watch;

  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'value';
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'input';
  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: 'toggleable',
    model: {
      prop: prop,
      event: event
    },
    props: _defineProperty({}, prop, {
      required: false
    }),
    data: function data() {
      return {
        isActive: !!this[prop]
      };
    },
    watch: (_watch = {}, _defineProperty(_watch, prop, function (val) {
      this.isActive = !!val;
    }), _defineProperty(_watch, "isActive", function isActive(val) {
      !!val !== this[prop] && this.$emit(event, val);
    }), _watch)
  });
}
/* eslint-disable-next-line @typescript-eslint/no-redeclare */

var Toggleable = factory();
/* harmony default export */ var toggleable = (Toggleable);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/activatable/index.js






// Mixins

 // Utilities




var baseMixins = mixins_mixins(delayable, toggleable);
/* @vue/component */

/* harmony default export */ var activatable = (baseMixins.extend({
  name: 'activatable',
  props: {
    activator: {
      default: null,
      validator: function validator(val) {
        return ['string', 'object'].includes(_typeof(val));
      }
    },
    disabled: Boolean,
    internalActivator: Boolean,
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: Boolean,
    openOnFocus: Boolean
  },
  data: function data() {
    return {
      // Do not use this directly, call getActivator() instead
      activatorElement: null,
      activatorNode: [],
      events: ['click', 'mouseenter', 'mouseleave', 'focus'],
      listeners: {}
    };
  },
  watch: {
    activator: 'resetActivator',
    openOnFocus: 'resetActivator',
    openOnHover: 'resetActivator'
  },
  mounted: function mounted() {
    var slotType = getSlotType(this, 'activator', true);

    if (slotType && ['v-slot', 'normal'].includes(slotType)) {
      consoleError("The activator slot must be bound, try '<template v-slot:activator=\"{ on }\"><v-btn v-on=\"on\">'", this);
    }

    this.addActivatorEvents();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeActivatorEvents();
  },
  methods: {
    addActivatorEvents: function addActivatorEvents() {
      if (!this.activator || this.disabled || !this.getActivator()) return;
      this.listeners = this.genActivatorListeners();
      var keys = Object.keys(this.listeners);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        this.getActivator().addEventListener(key, this.listeners[key]);
      }
    },
    genActivator: function genActivator() {
      var node = getSlot(this, 'activator', Object.assign(this.getValueProxy(), {
        on: this.genActivatorListeners(),
        attrs: this.genActivatorAttributes()
      })) || [];
      this.activatorNode = node;
      return node;
    },
    genActivatorAttributes: function genActivatorAttributes() {
      return {
        role: this.openOnClick && !this.openOnHover ? 'button' : undefined,
        'aria-haspopup': true,
        'aria-expanded': String(this.isActive)
      };
    },
    genActivatorListeners: function genActivatorListeners() {
      var _this = this;

      if (this.disabled) return {};
      var listeners = {};

      if (this.openOnHover) {
        listeners.mouseenter = function (e) {
          _this.getActivator(e);

          _this.runDelay('open');
        };

        listeners.mouseleave = function (e) {
          _this.getActivator(e);

          _this.runDelay('close');
        };
      } else if (this.openOnClick) {
        listeners.click = function (e) {
          var activator = _this.getActivator(e);

          if (activator) activator.focus();
          e.stopPropagation();
          _this.isActive = !_this.isActive;
        };
      }

      if (this.openOnFocus) {
        listeners.focus = function (e) {
          _this.getActivator(e);

          e.stopPropagation();
          _this.isActive = !_this.isActive;
        };
      }

      return listeners;
    },
    getActivator: function getActivator(e) {
      var _activator; // If we've already fetched the activator, re-use


      if (this.activatorElement) return this.activatorElement;
      var activator = null;

      if (this.activator) {
        var target = this.internalActivator ? this.$el : document;

        if (typeof this.activator === 'string') {
          // Selector
          activator = target.querySelector(this.activator);
        } else if (this.activator.$el) {
          // Component (ref)
          activator = this.activator.$el;
        } else {
          // HTMLElement | Element
          activator = this.activator;
        }
      } else if (this.activatorNode.length === 1 || this.activatorNode.length && !e) {
        // Use the contents of the activator slot
        // There's either only one element in it or we
        // don't have a click event to use as a last resort
        var vm = this.activatorNode[0].componentInstance;

        if (vm && vm.$options.mixins && //                         Activatable is indirectly used via Menuable
        vm.$options.mixins.some(function (m) {
          return m.options && ['activatable', 'menuable'].includes(m.options.name);
        })) {
          // Activator is actually another activatible component, use its activator (#8846)
          activator = vm.getActivator();
        } else {
          activator = this.activatorNode[0].elm;
        }
      } else if (e) {
        // Activated by a click or focus event
        activator = e.currentTarget || e.target;
      } // The activator should only be a valid element (Ignore comments and text nodes)


      this.activatorElement = ((_activator = activator) == null ? void 0 : _activator.nodeType) === Node.ELEMENT_NODE ? activator : null;
      return this.activatorElement;
    },
    getContentSlot: function getContentSlot() {
      return getSlot(this, 'default', this.getValueProxy(), true);
    },
    getValueProxy: function getValueProxy() {
      var self = this;
      return {
        get value() {
          return self.isActive;
        },

        set value(isActive) {
          self.isActive = isActive;
        }

      };
    },
    removeActivatorEvents: function removeActivatorEvents() {
      if (!this.activator || !this.activatorElement) return;
      var keys = Object.keys(this.listeners);

      for (var _i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++) {
        var key = _keys2[_i2];
        this.activatorElement.removeEventListener(key, this.listeners[key]);
      }

      this.listeners = {};
    },
    resetActivator: function resetActivator() {
      this.removeActivatorEvents();
      this.activatorElement = null;
      this.getActivator();
      this.addActivatorEvents();
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/dependent/index.js



function searchChildren(children) {
  var results = [];

  for (var index = 0; index < children.length; index++) {
    var child = children[index];

    if (child.isActive && child.isDependent) {
      results.push(child);
    } else {
      results.push.apply(results, _toConsumableArray(searchChildren(child.$children)));
    }
  }

  return results;
}
/* @vue/component */


/* harmony default export */ var dependent = (mixins_mixins().extend({
  name: 'dependent',
  data: function data() {
    return {
      closeDependents: true,
      isActive: false,
      isDependent: true
    };
  },
  watch: {
    isActive: function isActive(val) {
      if (val) return;
      var openDependents = this.getOpenDependents();

      for (var index = 0; index < openDependents.length; index++) {
        openDependents[index].isActive = false;
      }
    }
  },
  methods: {
    getOpenDependents: function getOpenDependents() {
      if (this.closeDependents) return searchChildren(this.$children);
      return [];
    },
    getOpenDependentElements: function getOpenDependentElements() {
      var result = [];
      var openDependents = this.getOpenDependents();

      for (var index = 0; index < openDependents.length; index++) {
        result.push.apply(result, _toConsumableArray(openDependents[index].getClickableDependentElements()));
      }

      return result;
    },
    getClickableDependentElements: function getClickableDependentElements() {
      var result = [this.$el];
      if (this.$refs.content) result.push(this.$refs.content);
      if (this.overlay) result.push(this.overlay.$el);
      result.push.apply(result, _toConsumableArray(this.getOpenDependentElements()));
      return result;
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/stackable/index.js






/* @vue/component */

/* harmony default export */ var stackable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend().extend({
  name: 'stackable',
  data: function data() {
    return {
      stackElement: null,
      stackExclude: null,
      stackMinZIndex: 0,
      isActive: false
    };
  },
  computed: {
    activeZIndex: function activeZIndex() {
      if (typeof window === 'undefined') return 0;
      var content = this.stackElement || this.$refs.content; // Return current zindex if not active

      var index = !this.isActive ? getZIndex(content) : this.getMaxZIndex(this.stackExclude || [content]) + 2;
      if (index == null) return index; // Return max current z-index (excluding self) + 2
      // (2 to leave room for an overlay below, if needed)

      return parseInt(index);
    }
  },
  methods: {
    getMaxZIndex: function getMaxZIndex() {
      var exclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var base = this.$el; // Start with lowest allowed z-index or z-index of
      // base component's element, whichever is greater

      var zis = [this.stackMinZIndex, getZIndex(base)]; // Convert the NodeList to an array to
      // prevent an Edge bug with Symbol.iterator
      // https://github.com/vuetifyjs/vuetify/issues/2146

      var activeElements = [].concat(_toConsumableArray(document.getElementsByClassName('v-menu__content--active')), _toConsumableArray(document.getElementsByClassName('v-dialog__content--active'))); // Get z-index for all active dialogs

      for (var index = 0; index < activeElements.length; index++) {
        if (!exclude.includes(activeElements[index])) {
          zis.push(getZIndex(activeElements[index]));
        }
      }

      return Math.max.apply(Math, zis);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/positionable/index.js


var availableProps = {
  absolute: Boolean,
  bottom: Boolean,
  fixed: Boolean,
  left: Boolean,
  right: Boolean,
  top: Boolean
};
function positionable_factory() {
  var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: 'positionable',
    props: selected.length ? filterObjectOnKeys(availableProps, selected) : availableProps
  });
}
/* harmony default export */ var positionable = (positionable_factory()); // Add a `*` before the second `/`

/* Tests /
let single = factory(['top']).extend({
  created () {
    this.top
    this.bottom
    this.absolute
  }
})

let some = factory(['top', 'bottom']).extend({
  created () {
    this.top
    this.bottom
    this.absolute
  }
})

let all = factory().extend({
  created () {
    this.top
    this.bottom
    this.absolute
    this.foobar
  }
})
/**/
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/bootable/index.js
// Utilities
 // Types


/**
 * Bootable
 * @mixin
 *
 * Used to add lazy content functionality to components
 * Looks for change in "isActive" to automatically boot
 * Otherwise can be set manually
 */

/* @vue/component */

/* harmony default export */ var bootable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend().extend({
  name: 'bootable',
  props: {
    eager: Boolean
  },
  data: function data() {
    return {
      isBooted: false
    };
  },
  computed: {
    hasContent: function hasContent() {
      return this.isBooted || this.eager || this.isActive;
    }
  },
  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if ('lazy' in this.$attrs) {
      removed('lazy', this);
    }
  },
  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.hasContent && content ? content() : [this.$createElement()];
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/detachable/index.js








// Mixins
 // Utilities





function validateAttachTarget(val) {
  var type = _typeof(val);

  if (type === 'boolean' || type === 'string') return true;
  return val.nodeType === Node.ELEMENT_NODE;
}

function removeActivator(activator) {
  activator.forEach(function (node) {
    node.elm && node.elm.parentNode && node.elm.parentNode.removeChild(node.elm);
  });
}
/* @vue/component */


/* harmony default export */ var detachable = (mixins_mixins(bootable).extend({
  name: 'detachable',
  props: {
    attach: {
      default: false,
      validator: validateAttachTarget
    },
    contentClass: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      activatorNode: null,
      hasDetached: false
    };
  },
  watch: {
    attach: function attach() {
      this.hasDetached = false;
      this.initDetach();
    },
    hasContent: function hasContent() {
      this.$nextTick(this.initDetach);
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.activatorNode) {
        var activator = Array.isArray(_this.activatorNode) ? _this.activatorNode : [_this.activatorNode];
        activator.forEach(function (node) {
          if (!node.elm) return;
          if (!_this.$el.parentNode) return;
          var target = _this.$el === _this.$el.parentNode.firstChild ? _this.$el : _this.$el.nextSibling;

          _this.$el.parentNode.insertBefore(node.elm, target);
        });
      }
    });
  },
  mounted: function mounted() {
    this.hasContent && this.initDetach();
  },
  deactivated: function deactivated() {
    this.isActive = false;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$refs.content && this.$refs.content.parentNode) {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    }
  },
  destroyed: function destroyed() {
    var _this2 = this;

    if (this.activatorNode) {
      var activator = Array.isArray(this.activatorNode) ? this.activatorNode : [this.activatorNode];

      if (this.$el.isConnected) {
        // Component has been destroyed but the element still exists, we must be in a transition
        // Wait for the transition to finish before cleaning up the detached activator
        var observer = new MutationObserver(function (list) {
          if (list.some(function (record) {
            return Array.from(record.removedNodes).includes(_this2.$el);
          })) {
            observer.disconnect();
            removeActivator(activator);
          }
        });
        observer.observe(this.$el.parentNode, {
          subtree: false,
          childList: true
        });
      } else {
        removeActivator(activator);
      }
    }
  },
  methods: {
    getScopeIdAttrs: function getScopeIdAttrs() {
      var scopeId = getObjectValueByPath(this.$vnode, 'context.$options._scopeId');
      return scopeId && _defineProperty({}, scopeId, '');
    },
    initDetach: function initDetach() {
      if (this._isDestroyed || !this.$refs.content || this.hasDetached || // Leave menu in place if attached
      // and dev has not changed target
      this.attach === '' || // If used as a boolean prop (<v-menu attach>)
      this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
      this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
      ) return;
      var target;

      if (this.attach === false) {
        // Default, detach to app
        target = document.querySelector('[data-app]');
      } else if (typeof this.attach === 'string') {
        // CSS selector
        target = document.querySelector(this.attach);
      } else {
        // DOM Element
        target = this.attach;
      }

      if (!target) {
        consoleWarn("Unable to locate target ".concat(this.attach || '[data-app]'), this);
        return;
      }

      target.appendChild(this.$refs.content);
      this.hasDetached = true;
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/menuable/index.js




// Mixins



 // Utilities



var menuable_baseMixins = mixins_mixins(stackable, positionable_factory(['top', 'right', 'bottom', 'left', 'absolute']), activatable, detachable);
/* @vue/component */

/* harmony default export */ var menuable = (menuable_baseMixins.extend().extend({
  name: 'menuable',
  props: {
    allowOverflow: Boolean,
    light: Boolean,
    dark: Boolean,
    maxWidth: {
      type: [Number, String],
      default: 'auto'
    },
    minWidth: [Number, String],
    nudgeBottom: {
      type: [Number, String],
      default: 0
    },
    nudgeLeft: {
      type: [Number, String],
      default: 0
    },
    nudgeRight: {
      type: [Number, String],
      default: 0
    },
    nudgeTop: {
      type: [Number, String],
      default: 0
    },
    nudgeWidth: {
      type: [Number, String],
      default: 0
    },
    offsetOverflow: Boolean,
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    zIndex: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      activatorNode: [],
      absoluteX: 0,
      absoluteY: 0,
      activatedBy: null,
      activatorFixed: false,
      dimensions: {
        activator: {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: 0,
          height: 0,
          offsetTop: 0,
          scrollHeight: 0,
          offsetLeft: 0
        },
        content: {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: 0,
          height: 0,
          offsetTop: 0,
          scrollHeight: 0
        }
      },
      relativeYOffset: 0,
      hasJustFocused: false,
      hasWindow: false,
      inputActivator: false,
      isContentActive: false,
      pageWidth: 0,
      pageYOffset: 0,
      stackClass: 'v-menu__content--active',
      stackMinZIndex: 6
    };
  },
  computed: {
    computedLeft: function computedLeft() {
      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var activatorLeft = (this.attach !== false ? a.offsetLeft : a.left) || 0;
      var minWidth = Math.max(a.width, c.width);
      var left = 0;
      left += this.left ? activatorLeft - (minWidth - a.width) : activatorLeft;

      if (this.offsetX) {
        var maxWidth = isNaN(Number(this.maxWidth)) ? a.width : Math.min(a.width, Number(this.maxWidth));
        left += this.left ? -maxWidth : a.width;
      }

      if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
      if (this.nudgeRight) left += parseInt(this.nudgeRight);
      return left;
    },
    computedTop: function computedTop() {
      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = 0;
      if (this.top) top += a.height - c.height;
      if (this.attach !== false) top += a.offsetTop;else top += a.top + this.pageYOffset;
      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= parseInt(this.nudgeTop);
      if (this.nudgeBottom) top += parseInt(this.nudgeBottom);
      return top;
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || !!this.$scopedSlots.activator || !!this.activator || !!this.inputActivator;
    },
    absoluteYOffset: function absoluteYOffset() {
      return this.pageYOffset - this.relativeYOffset;
    }
  },
  watch: {
    disabled: function disabled(val) {
      val && this.callDeactivate();
    },
    isActive: function isActive(val) {
      if (this.disabled) return;
      val ? this.callActivate() : this.callDeactivate();
    },
    positionX: 'updateDimensions',
    positionY: 'updateDimensions'
  },
  beforeMount: function beforeMount() {
    this.hasWindow = typeof window !== 'undefined';

    if (this.hasWindow) {
      window.addEventListener('resize', this.updateDimensions, false);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.hasWindow) {
      window.removeEventListener('resize', this.updateDimensions, false);
    }
  },
  methods: {
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: this.positionY || this.absoluteY,
        offsetLeft: this.positionX || this.absoluteX,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    activate: function activate() {},
    calcLeft: function calcLeft(menuWidth) {
      return convertToUnit(this.attach !== false ? this.computedLeft : this.calcXOverflow(this.computedLeft, menuWidth));
    },
    calcTop: function calcTop() {
      return convertToUnit(this.attach !== false ? this.computedTop : this.calcYOverflow(this.computedTop));
    },
    calcXOverflow: function calcXOverflow(left, menuWidth) {
      var xOverflow = left + menuWidth - this.pageWidth + 12;

      if ((!this.left || this.right) && xOverflow > 0) {
        left = Math.max(left - xOverflow, 0);
      } else {
        left = Math.max(left, 12);
      }

      return left + this.getOffsetLeft();
    },
    calcYOverflow: function calcYOverflow(top) {
      var documentHeight = this.getInnerHeight();
      var toTop = this.absoluteYOffset + documentHeight;
      var activator = this.dimensions.activator;
      var contentHeight = this.dimensions.content.height;
      var totalHeight = top + contentHeight;
      var isOverflowing = toTop < totalHeight; // If overflowing bottom and offset
      // TODO: set 'bottom' position instead of 'top'

      if (isOverflowing && this.offsetOverflow && // If we don't have enough room to offset
      // the overflow, don't offset
      activator.top > contentHeight) {
        top = this.pageYOffset + (activator.top - contentHeight); // If overflowing bottom
      } else if (isOverflowing && !this.allowOverflow) {
        top = toTop - contentHeight - 12; // If overflowing top
      } else if (top < this.absoluteYOffset && !this.allowOverflow) {
        top = this.absoluteYOffset + 12;
      }

      return top < 12 ? 12 : top;
    },
    callActivate: function callActivate() {
      if (!this.hasWindow) return;
      this.activate();
    },
    callDeactivate: function callDeactivate() {
      this.isContentActive = false;
      this.deactivate();
    },
    checkForPageYOffset: function checkForPageYOffset() {
      if (this.hasWindow) {
        this.pageYOffset = this.activatorFixed ? 0 : this.getOffsetTop();
      }
    },
    checkActivatorFixed: function checkActivatorFixed() {
      if (this.attach !== false) return;
      var el = this.getActivator();

      while (el) {
        if (window.getComputedStyle(el).position === 'fixed') {
          this.activatorFixed = true;
          return;
        }

        el = el.offsetParent;
      }

      this.activatorFixed = false;
    },
    deactivate: function deactivate() {},
    genActivatorListeners: function genActivatorListeners() {
      var _this = this;

      var listeners = activatable.options.methods.genActivatorListeners.call(this);
      var onClick = listeners.click;

      if (onClick) {
        listeners.click = function (e) {
          if (_this.openOnClick) {
            onClick && onClick(e);
          }

          _this.absoluteX = e.clientX;
          _this.absoluteY = e.clientY;
        };
      }

      return listeners;
    },
    getInnerHeight: function getInnerHeight() {
      if (!this.hasWindow) return 0;
      return window.innerHeight || document.documentElement.clientHeight;
    },
    getOffsetLeft: function getOffsetLeft() {
      if (!this.hasWindow) return 0;
      return window.pageXOffset || document.documentElement.scrollLeft;
    },
    getOffsetTop: function getOffsetTop() {
      if (!this.hasWindow) return 0;
      return window.pageYOffset || document.documentElement.scrollTop;
    },
    getRoundedBoundedClientRect: function getRoundedBoundedClientRect(el) {
      var rect = el.getBoundingClientRect();
      return {
        top: Math.round(rect.top),
        left: Math.round(rect.left),
        bottom: Math.round(rect.bottom),
        right: Math.round(rect.right),
        width: Math.round(rect.width),
        height: Math.round(rect.height)
      };
    },
    measure: function measure(el) {
      if (!el || !this.hasWindow) return null;
      var rect = this.getRoundedBoundedClientRect(el); // Account for activator margin

      if (this.attach !== false) {
        var style = window.getComputedStyle(el);
        rect.left = parseInt(style.marginLeft);
        rect.top = parseInt(style.marginTop);
      }

      return rect;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this2 = this;

      requestAnimationFrame(function () {
        var el = _this2.$refs.content;

        if (!el || el.style.display !== 'none') {
          cb();
          return;
        }

        el.style.display = 'inline-block';
        cb();
        el.style.display = 'none';
      });
    },
    startTransition: function startTransition() {
      var _this3 = this;

      return new Promise(function (resolve) {
        return requestAnimationFrame(function () {
          _this3.isContentActive = _this3.hasJustFocused = _this3.isActive;
          resolve();
        });
      });
    },
    updateDimensions: function updateDimensions() {
      var _this4 = this;

      this.hasWindow = typeof window !== 'undefined';
      this.checkActivatorFixed();
      this.checkForPageYOffset();
      this.pageWidth = document.documentElement.clientWidth;
      var dimensions = {
        activator: _objectSpread2({}, this.dimensions.activator),
        content: _objectSpread2({}, this.dimensions.content)
      }; // Activator should already be shown

      if (!this.hasActivator || this.absolute) {
        dimensions.activator = this.absolutePosition();
      } else {
        var activator = this.getActivator();
        if (!activator) return;
        dimensions.activator = this.measure(activator);
        dimensions.activator.offsetLeft = activator.offsetLeft;

        if (this.attach !== false) {
          // account for css padding causing things to not line up
          // this is mostly for v-autocomplete, hopefully it won't break anything
          dimensions.activator.offsetTop = activator.offsetTop;
        } else {
          dimensions.activator.offsetTop = 0;
        }
      } // Display and hide to get dimensions


      this.sneakPeek(function () {
        if (_this4.$refs.content) {
          if (_this4.$refs.content.offsetParent) {
            var offsetRect = _this4.getRoundedBoundedClientRect(_this4.$refs.content.offsetParent);

            _this4.relativeYOffset = window.pageYOffset + offsetRect.top;
            dimensions.activator.top -= _this4.relativeYOffset;
            dimensions.activator.left -= window.pageXOffset + offsetRect.left;
          }

          dimensions.content = _this4.measure(_this4.$refs.content);
        }

        _this4.dimensions = dimensions;
      });
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTooltip/VTooltip.js


 // Mixins






 // Helpers




/* @vue/component */

/* harmony default export */ var VTooltip_VTooltip = (mixins_mixins(colorable, delayable, dependent, menuable, toggleable).extend({
  name: 'v-tooltip',
  props: {
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    disabled: Boolean,
    openDelay: {
      type: [Number, String],
      default: 0
    },
    openOnHover: {
      type: Boolean,
      default: true
    },
    openOnFocus: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'span'
    },
    transition: String
  },
  data: function data() {
    return {
      calculatedMinWidth: 0,
      closeDependents: false
    };
  },
  computed: {
    calculatedLeft: function calculatedLeft() {
      var _this$dimensions = this.dimensions,
          activator = _this$dimensions.activator,
          content = _this$dimensions.content;
      var unknown = !this.bottom && !this.left && !this.top && !this.right;
      var activatorLeft = this.attach !== false ? activator.offsetLeft : activator.left;
      var left = 0;

      if (this.top || this.bottom || unknown) {
        left = activatorLeft + activator.width / 2 - content.width / 2;
      } else if (this.left || this.right) {
        left = activatorLeft + (this.right ? activator.width : -content.width) + (this.right ? 10 : -10);
      }

      if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
      if (this.nudgeRight) left += parseInt(this.nudgeRight);
      return "".concat(this.calcXOverflow(left, this.dimensions.content.width), "px");
    },
    calculatedTop: function calculatedTop() {
      var _this$dimensions2 = this.dimensions,
          activator = _this$dimensions2.activator,
          content = _this$dimensions2.content;
      var activatorTop = this.attach !== false ? activator.offsetTop : activator.top;
      var top = 0;

      if (this.top || this.bottom) {
        top = activatorTop + (this.bottom ? activator.height : -content.height) + (this.bottom ? 10 : -10);
      } else if (this.left || this.right) {
        top = activatorTop + activator.height / 2 - content.height / 2;
      }

      if (this.nudgeTop) top -= parseInt(this.nudgeTop);
      if (this.nudgeBottom) top += parseInt(this.nudgeBottom);
      if (this.attach === false) top += this.pageYOffset;
      return "".concat(this.calcYOverflow(top), "px");
    },
    classes: function classes() {
      return {
        'v-tooltip--top': this.top,
        'v-tooltip--right': this.right,
        'v-tooltip--bottom': this.bottom,
        'v-tooltip--left': this.left,
        'v-tooltip--attached': this.attach === '' || this.attach === true || this.attach === 'attach'
      };
    },
    computedTransition: function computedTransition() {
      if (this.transition) return this.transition;
      return this.isActive ? 'scale-transition' : 'fade-transition';
    },
    offsetY: function offsetY() {
      return this.top || this.bottom;
    },
    offsetX: function offsetX() {
      return this.left || this.right;
    },
    styles: function styles() {
      return {
        left: this.calculatedLeft,
        maxWidth: convertToUnit(this.maxWidth),
        minWidth: convertToUnit(this.minWidth),
        top: this.calculatedTop,
        zIndex: this.zIndex || this.activeZIndex
      };
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$nextTick(function () {
      _this.value && _this.callActivate();
    });
  },
  mounted: function mounted() {
    if (getSlotType(this, 'activator', true) === 'v-slot') {
      consoleError("v-tooltip's activator slot must be bound, try '<template #activator=\"data\"><v-btn v-on=\"data.on>'", this);
    }
  },
  methods: {
    activate: function activate() {
      // Update coordinates and dimensions of menu
      // and its activator
      this.updateDimensions(); // Start the transition

      requestAnimationFrame(this.startTransition);
    },
    deactivate: function deactivate() {
      this.runDelay('close');
    },
    genActivatorListeners: function genActivatorListeners() {
      var _this2 = this;

      var listeners = activatable.options.methods.genActivatorListeners.call(this);

      if (this.openOnFocus) {
        listeners.focus = function (e) {
          _this2.getActivator(e);

          _this2.runDelay('open');
        };

        listeners.blur = function (e) {
          _this2.getActivator(e);

          _this2.runDelay('close');
        };
      }

      listeners.keydown = function (e) {
        if (e.keyCode === keyCodes.esc) {
          _this2.getActivator(e);

          _this2.runDelay('close');
        }
      };

      return listeners;
    },
    genActivatorAttributes: function genActivatorAttributes() {
      return {
        'aria-haspopup': true,
        'aria-expanded': String(this.isActive)
      };
    },
    genTransition: function genTransition() {
      var content = this.genContent();
      if (!this.computedTransition) return content;
      return this.$createElement('transition', {
        props: {
          name: this.computedTransition
        }
      }, [content]);
    },
    genContent: function genContent() {
      var _class;

      return this.$createElement('div', this.setBackgroundColor(this.color, {
        staticClass: 'v-tooltip__content',
        class: (_class = {}, _defineProperty(_class, this.contentClass, true), _defineProperty(_class, "menuable__content__active", this.isActive), _defineProperty(_class, 'v-tooltip__content--fixed', this.activatorFixed), _class),
        style: this.styles,
        attrs: this.getScopeIdAttrs(),
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        ref: 'content'
      }), this.getContentSlot());
    }
  },
  render: function render(h) {
    var _this3 = this;

    return h(this.tag, {
      staticClass: 'v-tooltip',
      class: this.classes
    }, [this.showLazyContent(function () {
      return [_this3.genTransition()];
    }), this.genActivator()]);
  }
}));
// CONCATENATED MODULE: ./src/components/ChatModBadge.vue





/* normalize component */

var ChatModBadge_component = normalizeComponent(
  components_ChatModBadgevue_type_script_lang_ts_,
  ChatModBadgevue_type_template_id_80cd0324_scoped_true_render,
  ChatModBadgevue_type_template_id_80cd0324_scoped_true_staticRenderFns,
  false,
  null,
  "80cd0324",
  null
  
)

/* harmony default export */ var components_ChatModBadge = (ChatModBadge_component.exports);

/* vuetify-loader */



installComponents_default()(ChatModBadge_component, {VIcon: components_VIcon_VIcon,VTooltip: VTooltip_VTooltip})

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("8a79");

// EXTERNAL MODULE: ./node_modules/emoji-mart-vue-fast/data/twitter.json
var data_twitter = __webpack_require__("de38");

// EXTERNAL MODULE: ./node_modules/emoji-mart-vue-fast/dist/emoji-mart.js
var emoji_mart = __webpack_require__("41fb");

// EXTERNAL MODULE: ./node_modules/emoji-regex/index.js
var emoji_regex = __webpack_require__("b855");
var emoji_regex_default = /*#__PURE__*/__webpack_require__.n(emoji_regex);

// CONCATENATED MODULE: ./src/util/emojis.ts







var emojiIndex = new emoji_mart["EmojiIndex"](data_twitter);
var unicodeEmojiRegex = emoji_regex_default()();
function emojiNativeToData(text, type) {
  return text.replace(unicodeEmojiRegex, function (match, offset) {
    var before = text.substring(0, offset);

    if (before.endsWith('alt="') || before.endsWith('data-text="')) {
      return match;
    }

    var emoji = emojiIndex.nativeEmoji(match);

    if (!emoji) {
      return match;
    }

    if (type === "message") {
      return "<div style=\"width: 1.2rem; height: 1.2rem; display: inline-block; margin-right: 2px; margin-left: 2px;\">".concat(emojiDataToSvg(emoji), "</div>");
    } else {
      return emojiDataToSvg(emoji);
    }
  });
}
function emojiUnicodeToData(text) {
  var emoji = emojiIndex.nativeEmoji(text);
  return emojiDataToSvg(emoji);
}
function emojiColonsToData(text) {
  var emoji = emojiIndex.findEmoji(text);

  if (emoji) {
    return "<div style=\"width: 1.2rem; height: 1.2rem; display: inline-block; margin-right: 2px; margin-left: 2px;\">".concat(emojiDataToSvg(emoji), "</div>");
  }
}
function emojiDataToSvg(emoji) {
  var position = emoji.getPosition();
  return "<span data-text=\"".concat(emoji.native, "\" alt=\"").concat(emoji.colons, "\" class=\"emoji-type-image emoji-set-twitter\" style=\"width: 100%; height: 100%; background-position: ").concat(position, "; background-size: 5750%; display: block\"></span>");
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatEmojiPicker.vue?vue&type=template&id=eb3a3ba6&
var ChatEmojiPickervue_type_template_id_eb3a3ba6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-0 d-flex"},[_c('Picker',{staticClass:"emoji-mart-picker",attrs:{"data":_vm.emojiIndex,"set":"twitter","title":_vm.$t('emojiPicker.skintone'),"i18n":_vm.$t('emojiPicker'),"emoji":"slightly_smiling_face"},on:{"select":_vm.emitEmoji}})],1)}
var ChatEmojiPickervue_type_template_id_eb3a3ba6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ChatEmojiPicker.vue?vue&type=template&id=eb3a3ba6&

// EXTERNAL MODULE: ./node_modules/emoji-mart-vue-fast/css/emoji-mart.css
var css_emoji_mart = __webpack_require__("01ce");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatEmojiPicker.vue?vue&type=script&lang=ts&










var ChatEmojiPickervue_type_script_lang_ts_ChatEmojiPicker = /*#__PURE__*/function (_Vue) {
  _inherits(ChatEmojiPicker, _Vue);

  var _super = _createSuper(ChatEmojiPicker);

  function ChatEmojiPicker() {
    var _this;

    _classCallCheck(this, ChatEmojiPicker);

    _this = _super.apply(this, arguments);
    _this.emojiIndex = new emoji_mart["EmojiIndex"](data_twitter);
    return _this;
  }

  _createClass(ChatEmojiPicker, [{
    key: "emitEmoji",
    value: function emitEmoji(emoji) {
      this.$emit("emoji", emoji);
    }
  }]);

  return ChatEmojiPicker;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

ChatEmojiPickervue_type_script_lang_ts_ChatEmojiPicker = __decorate([vue_class_component_esm({
  components: {
    Picker: emoji_mart["Picker"]
  }
})], ChatEmojiPickervue_type_script_lang_ts_ChatEmojiPicker);
/* harmony default export */ var ChatEmojiPickervue_type_script_lang_ts_ = (ChatEmojiPickervue_type_script_lang_ts_ChatEmojiPicker);
// CONCATENATED MODULE: ./src/components/ChatEmojiPicker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ChatEmojiPickervue_type_script_lang_ts_ = (ChatEmojiPickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/ChatEmojiPicker.vue?vue&type=style&index=0&lang=css&
var ChatEmojiPickervue_type_style_index_0_lang_css_ = __webpack_require__("bd2f");

// CONCATENATED MODULE: ./src/components/ChatEmojiPicker.vue






/* normalize component */

var ChatEmojiPicker_component = normalizeComponent(
  components_ChatEmojiPickervue_type_script_lang_ts_,
  ChatEmojiPickervue_type_template_id_eb3a3ba6_render,
  ChatEmojiPickervue_type_template_id_eb3a3ba6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_ChatEmojiPicker = (ChatEmojiPicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatTextMessage.vue?vue&type=script&lang=ts&






































var ChatTextMessagevue_type_script_lang_ts_ChatTextMessage = /*#__PURE__*/function (_Vue) {
  _inherits(ChatTextMessage, _Vue);

  var _super = _createSuper(ChatTextMessage);

  function ChatTextMessage() {
    var _this;

    _classCallCheck(this, ChatTextMessage);

    _this = _super.apply(this, arguments);
    _this.configModule = getModule(store_ConfigModule, _this.$store);
    _this.generalSettings = getModule(store_ConfigModule, _this.$store).generalSettings;
    _this.userColors = getModule(store_ConfigModule, _this.$store).userColors;
    _this.styleConfig = getModule(store_ConfigModule, _this.$store).styleConfig;
    _this.enabledFeatures = getModule(store_ConfigModule, _this.$store).enabledFeatures;
    _this.formattedDate = _this.timestampFormatted();
    _this.menu = false;
    _this.currentDateString = moment_default()().toISOString();
    _this.currentDate = moment_default()();
    _this.pinSnackbar = false;
    _this.unbanDialog = false;
    _this.emojiPicker = false;
    _this.emojiPickerX = 0;
    _this.emojiPickerY = 0;
    _this.userMenu = false;
    _this.userMenuX = 0;
    _this.userMenuY = 0;
    _this.moreMenu = false;
    _this.moreMenuX = 0;
    _this.moreMenuY = 0;
    _this.reportDialog = false;
    _this.reportSelect = "";
    _this.reportResultDialog = false;
    _this.reportLoading = false;
    _this.reportSuccess = false;
    _this.reportStatus = -1;
    _this.reportTypes = {
      MESSAGE_HARMFUL: "s8c.report.messageHarmful",
      MESSAGE_SPAM: "s8c.report.messageSpam",
      USERNAME_HARMFUL: "s8c.report.usernameHarmful",
      AVATAR_HARMFUL: "s8c.report.avatarHarmful"
    };
    _this.mentionRegEx = /<@([^|>]+)\|([^|>]+)\|([^|>]+)>/g;
    _this.urlRegEx = /<link\|([^|]+)\|([^|]+)>/;
    _this.emojiColonsRegEx = /([^:]+)?(:[a-zA-Z0-9-_+]+:(:skin-tone-[2-6]:)?)/g;
    return _this;
  } // hardcoded for now, times will be fetched from somewhere


  _createClass(ChatTextMessage, [{
    key: "banTimes",
    get: function get() {
      var _this2 = this;

      return [60000, 600000, 3600000, 86400000].map(function (t) {
        return [t, humanize_duration_default()(t, {
          language: _this2.$i18n.locale
        })];
      });
    }
  }, {
    key: "muteTimes",
    get: function get() {
      var _this3 = this;

      return [60000, 600000, 3600000, 86400000].map(function (t) {
        return [t, humanize_duration_default()(t, {
          language: _this3.$i18n.locale
        })];
      });
    }
  }, {
    key: "pinTimes",
    get: function get() {
      var _this4 = this;

      return [600000, 1800000, 3600000, -1].map(function (t) {
        if (t === -1) return [t, _this4.$t("s8c.time.indefinite").toString()];
        return [t, humanize_duration_default()(t, {
          language: _this4.$i18n.locale
        })];
      });
    }
  }, {
    key: "created",
    value: function created() {
      this.clock = setInterval(this.timestampFormatted, 1000);
    }
  }, {
    key: "getBannedMessageText",
    value: function getBannedMessageText() {
      var translatedString = this.$t("s8c.bannedMessageText", {
        type: this.banned ? this.$t("s8c.thisUser") : this.$t("s8c.thisMessage"),
        action: this.banned ? this.banned.softBan ? this.$t("s8c.muted") : this.$t("s8c.banned") : this.$t("s8c.deleted")
      });
      return "<" + translatedString + ">";
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      clearInterval(this.clock);
    }
  }, {
    key: "timestampFormatted",
    value: function timestampFormatted() {
      var _this$message$timesta;

      var ts = (_this$message$timesta = this.message.timestampEdited) !== null && _this$message$timesta !== void 0 ? _this$message$timesta : this.message.timestampCreated;
      var res = timeAgo.format(ts, "mini-minute-now");
      this.formattedDate = res;
      return res;
    } // Count all reactions and replies and watch changes

  }, {
    key: "subitems",
    get: function get() {
      return this.simple ? 0 : Object.entries(this.message.reactions).length + this.message.submessages.length;
    } // If item count goes from or to 0 the height of the
    // ItemList will change so an event will be emitted

  }, {
    key: "onSubitemsChange",
    value: function onSubitemsChange(subitems, oldSubitems) {
      // console.log(`${oldSubitems} -> ${subitems}`);
      if (oldSubitems === 0 || subitems === 0) this.$emit("height-change");
    }
  }, {
    key: "onBannedChange",
    value: function onBannedChange() {
      this.$emit("height-change");
    } // Determines the namecolor based on config & available userinfo
    // If colormode is PICK_ANY the color property is read
    // Else if mode is anything but NONE the colorIndex is resolved to a theme color
    // As a fallback use theme.primary and fallback to that use white/black

  }, {
    key: "nameColor",
    get: function get() {
      var _this$configModule$ge, _this$userColors, _this$userColors2, _colors$idx;

      var fallback = this.$vuetify.theme.dark ? "#fdfdfd" : "#0a0a0a";
      var mode = (_this$configModule$ge = this.configModule.generalSettings) === null || _this$configModule$ge === void 0 ? void 0 : _this$configModule$ge.userColorMode;

      if (mode === undefined || mode === UserColorMode.NONE || !this.enabledFeatures.NAME_COLORS) {
        return fallback;
      }

      if (mode === UserColorMode.PICK_ANY || mode === UserColorMode.PICK_FROM_SET) {
        var c = this.message.fromUser.color; // TODO: proper color check?

        if (typeof c === "string") return c;
      } // const colors = this.$vuetify.theme.dark ? this.userColors.dark : this.userColors.light


      var colors = this.$vuetify.theme.dark ? (_this$userColors = this.userColors) === null || _this$userColors === void 0 ? void 0 : _this$userColors.dark : (_this$userColors2 = this.userColors) === null || _this$userColors2 === void 0 ? void 0 : _this$userColors2.light;
      if (!colors || !this.message.fromUser.colorIndex) return fallback;
      var idx = this.message.fromUser.colorIndex % colors.length;
      return (_colors$idx = colors[idx]) !== null && _colors$idx !== void 0 ? _colors$idx : fallback;
    } // Determines if there should be a user menu for the current message author

  }, {
    key: "nameIsLink",
    get: function get() {
      return !this.isAuthor && (this.isMod || this.enabledFeatures.REPORTS); // isAuthor -> authors are never linked to themselves
      // isMod -> mods have options in list
      // ignore & reports -> at least one needs to exist for nonmods to have any options
    }
  }, {
    key: "banned",
    get: function get() {
      var _this5 = this;

      return this.bans.find(function (b) {
        return b.userInfo.id === _this5.message.fromUser.id;
      });
    }
  }, {
    key: "messageVisible",
    get: function get() {
      return !(this.message.deleted || this.banned);
    }
  }, {
    key: "userBadge",
    get: function get() {
      var _this$message$fromUse;

      if (!((_this$message$fromUse = this.message.fromUser.badge) !== null && _this$message$fromUse !== void 0 && _this$message$fromUse.src)) return "";
      var badge = !this.$vuetify.theme.dark ? this.message.fromUser.badge.src.replace(/WHITE/g, "BLACK").replace(/_w/g, "_b") : this.message.fromUser.badge.src.replace(/BLACK/g, "WHITE").replace(/_b/g, "_w");
      return badge;
    }
  }, {
    key: "avatarUri",
    get: function get() {
      var _this$message$fromUse2, _this$message$fromUse3;

      return ((_this$message$fromUse2 = this.message.fromUser) === null || _this$message$fromUse2 === void 0 ? void 0 : (_this$message$fromUse3 = _this$message$fromUse2.avatar) === null || _this$message$fromUse3 === void 0 ? void 0 : _this$message$fromUse3.src) || ""; // if (this.message.fromUser.avatar && this.message.fromUser.avatar.src) {
      //   return this.message.fromUser.avatar.src;
      // }
      // return undefined;
    } // Check whether this message is the last read but not the last existing message of the current channel
    //   get isLastRead(): boolean {
    //     return (
    //       typeof this.message.parent === "undefined" &&
    //       this.channelActive.lastRead?.id === this.message.id &&
    //       this.channelActive.messages[this.channelActive.messages.length - 1].id !==
    //         this.message.id
    //     );
    //   }

  }, {
    key: "reactionsVisible",
    get: function get() {
      return Object.keys(this.message.reactions).length > 0;
    } // virtually the same as 'hasElevatedRight' -> should be refactored into a better roles/rights system in the future

  }, {
    key: "isMod",
    get: function get() {
      var _this$user, _this$user2;

      return ((_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.roles.includes(Role.ROLE_ADMIN)) || ((_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.roles.includes(Role.ROLE_MODERATOR));
    }
  }, {
    key: "isAuthor",
    get: function get() {
      return this.user.id === this.message.fromUser.id;
    }
  }, {
    key: "authorIsMod",
    get: function get() {
      var roles = this.message.fromUser.roles;
      if (!roles) return false;
      return (roles === null || roles === void 0 ? void 0 : roles.indexOf(Role.ROLE_ADMIN)) !== -1 || (roles === null || roles === void 0 ? void 0 : roles.indexOf(Role.ROLE_MODERATOR)) !== -1;
    }
  }, {
    key: "isMentioned",
    get: function get() {
      var _this$message$mention,
          _this6 = this;

      return ((_this$message$mention = this.message.mentions) === null || _this$message$mention === void 0 ? void 0 : _this$message$mention.some(function (e) {
        var _this6$user$editReque;

        return e.name === ((_this6$user$editReque = _this6.user.editRequest) === null || _this6$user$editReque === void 0 ? void 0 : _this6$user$editReque.displayName);
      })) || false;
    }
  }, {
    key: "isMentionedChildren",
    get: function get() {
      var _this7 = this;

      return this.message.submessages.some(function (m) {
        var _m$mentions;

        return (_m$mentions = m.mentions) === null || _m$mentions === void 0 ? void 0 : _m$mentions.some(function (e) {
          var _this7$user$editReque;

          return e.name === ((_this7$user$editReque = _this7.user.editRequest) === null || _this7$user$editReque === void 0 ? void 0 : _this7$user$editReque.displayName);
        });
      });
    }
  }, {
    key: "handleEmojiPickerOpen",
    value: function handleEmojiPickerOpen(e) {
      if (!this.emojiPicker) {
        this.emojiPickerX = e.clientX;
        this.emojiPickerY = e.clientY;
        this.emojiPicker = true;
      }
    } // When creating an emoji reaction that did not exist before

  }, {
    key: "handleReactionNew",
    value: function handleReactionNew(emoji) {
      this.emojiPicker = false;
      this.toggleReaction({
        icon: emoji.native,
        aliases: [emoji.colons],
        parent: this.message
      });
    } // When clicking on an existing emoji reaction

  }, {
    key: "handleReactionClick",
    value: function handleReactionClick(emoji, name) {
      this.toggleReaction({
        icon: emoji,
        aliases: [name],
        parent: this.message
      });
    }
  }, {
    key: "handleReply",
    value: function handleReply() {
      this.$emit("reply", this.message); // this.setThreadActive(this.message);
    }
  }, {
    key: "handleMoreMenuOpen",
    value: function handleMoreMenuOpen(e) {
      if (!this.moreMenu) {
        this.moreMenuX = e.clientX;
        this.moreMenuY = e.clientY;
        this.moreMenu = true;
      }
    }
  }, {
    key: "handleUserMenuOpen",
    value: function handleUserMenuOpen(e) {
      if (!this.userMenu) {
        this.userMenuX = e.clientX;
        this.userMenuY = e.clientY;
        this.userMenu = true;
      }
    }
  }, {
    key: "handleReportDialogOpen",
    value: function handleReportDialogOpen() {
      if (!this.reportDialog) this.reportDialog = true;
    }
  }, {
    key: "handleBanSelect",
    value: function handleBanSelect(message, time, soft) {
      this.userMenu = false;
      this.banUser({
        message: message,
        time: time / 1000,
        soft: soft
      });
    }
  }, {
    key: "handleDeleteSelect",
    value: function handleDeleteSelect(message) {
      this.userMenu = false;
      this.deleteMessage(message);
    }
  }, {
    key: "pinMessage",
    value: function pinMessage(message, durationMs) {
      var _this8 = this;

      if (typeof durationMs === "string") durationMs = parseInt(durationMs);
      this.pinMessageAction({
        message: message,
        durationMs: durationMs
      }).then(function (value) {
        if (value !== -1) _this8.pinSnackbar = true;
      });
      this.moreMenu = false;
    } // Creates the tooltip user summary for reactions

  }, {
    key: "makeUsersString",
    value: function makeUsersString(reactions) {
      var _this9 = this;

      return reactions.reduce(function (acc, curr, i) {
        return i <= 0 ? "".concat(curr.fromUser.displayName) : i <= 2 ? "".concat(acc, ", ").concat(curr.fromUser.displayName) : i === 3 ? "".concat(acc, " ") + _this9.$t("s8c.andMore", {
          num: reactions.length - i
        }) : acc;
      }, "");
    }
  }, {
    key: "formattedContent",
    get: function get() {
      var _this10 = this;

      return this.message.content.split(/[\s]+/).map(function (word) {
        // find type of word & format accordingly
        // word.charAt(0) === "@"
        if (word.match(_this10.mentionRegEx)) return _this10.transformMention(word);
        if (word.match(_this10.urlRegEx)) return _this10.transformLinkAlt(word);
        if (word.match(_this10.emojiColonsRegEx)) return emojiColonsToData(word);
        return _this10.transformEmoji(word, "message");
      }).join(" ");
    }
  }, {
    key: "formatUser",
    value: function formatUser(s) {
      var _this11 = this;

      return s.replaceAll(/\B@\w+/g, function (s) {
        return "<span class='font-weight-bold ".concat(_this11.usernameHistory.some(function (name) {
          return name === s.slice(1);
        }) ? "brand--text" : "", "'>").concat(s, "</span>");
      });
    }
  }, {
    key: "transformLinkAlt",
    value: function transformLinkAlt(s) {
      var _this12 = this;

      var re = /<link\|([^|]+)\|([^|]+)>/;
      return s.replace(re, function (_, p1, p2) {
        var _this12$user$tenant;

        return "<a href=\"".concat(p1, "?tid=").concat((_this12$user$tenant = _this12.user.tenant) === null || _this12$user$tenant === void 0 ? void 0 : _this12$user$tenant.tenantId, "&uid=").concat(_this12.hash(_this12.user.id), "\" target=\"_blank\">").concat(p2, "</a>");
      });
    }
  }, {
    key: "transformMention",
    value: function transformMention(s) {
      var _this13 = this;

      return s.replace(this.mentionRegEx, function (_, p1) {
        return "<span class='font-weight-bold ".concat(_this13.usernameHistory.some(function (name) {
          return name === p1;
        }) ? "brand--text" : "" // p1 === this.user.editRequest?.displayName ? "brand--text" : ""
        , "'>@").concat(p1, "</span>");
      });
    }
  }, {
    key: "transformEmoji",
    value: function transformEmoji(s, type) {
      return emojiNativeToData(s, type);
    }
  }, {
    key: "hash",
    value: function hash(s) {
      var hash = 0;
      var chr = 0;
      if (s.length === 0) return hash;

      for (var i = 0; i < s.length; i++) {
        chr = s.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }

      return hash;
    } // formatSmartLink(s: string): string {
    //   let res = s;
    //   for (const link of Object.values(linkMapNew)) {
    //     if (s.match(new RegExp("\\b(" + link.tokens.join("|") + ")\\b", "gi"))) {
    //       const url = link.links[Math.floor(Math.random() * link.links.length)];
    //       res = `<a href="${url}" target="_blank">${s}</a>`;
    //     }
    //   }
    //   return res;
    // }

  }, {
    key: "handleIgnore",
    value: function handleIgnore() {
      this.userMenu = false;
      var fromUser = this.message.fromUser;
      this.ignoreUser({
        id: fromUser.id,
        displayName: fromUser.displayName || "",
        avatar: fromUser.avatar,
        dateBlocked: Date.now()
      });
    }
  }, {
    key: "closeReportDialog",
    value: function closeReportDialog() {
      this.reportDialog = false;
      this.reportSelect = "";
    }
  }, {
    key: "handleReport",
    value: function handleReport() {
      var _this14 = this;

      this.reportLoading = true;
      this.sendReport({
        message: this.message,
        type: this.reportSelect
      }).then(function (res) {
        var _res$status;

        _this14.reportLoading = false;
        _this14.reportDialog = false;
        _this14.reportSuccess = true;
        _this14.reportResultDialog = true;
        _this14.reportStatus = (_res$status = res.status) !== null && _res$status !== void 0 ? _res$status : 200;
      }).catch(function (e) {
        _this14.reportLoading = false;
        _this14.reportDialog = false;
        _this14.reportSuccess = false;
        _this14.reportResultDialog = true;
        _this14.reportStatus = e.response ? e.response.status : 400;
        console.error(e.message);
      });
    }
  }, {
    key: "handleRestore",
    value: function handleRestore(message) {
      if (this.banned) {
        this.unbanDialog = true;
        return;
      }

      if (message.restorable) {
        this.restoreMessage(message);
      }
    }
  }, {
    key: "handleUnban",
    value: function handleUnban() {
      this.unbanDialog = false;
      this.unbanUser(this.message.fromUser);
    }
  }]);

  return ChatTextMessage;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "message", void 0);

__decorate([Prop({
  default: false
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "simple", void 0);

__decorate([Prop({
  default: false
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "indent", void 0);

__decorate([Getter("getChannelActive", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "channelActive", void 0);

__decorate([Getter("getBroadcast", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "broadcast", void 0);

__decorate([Getter("authenticated", {
  namespace: AUTH_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "authenticated", void 0);

__decorate([Getter("user", {
  namespace: USER_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "user", void 0);

__decorate([Getter("usernameHistory", {
  namespace: USER_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "usernameHistory", void 0);

__decorate([Getter("bans", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "bans", void 0);

__decorate([bindings_Action("toggleReaction", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "toggleReaction", void 0);

__decorate([bindings_Action("deleteMessage", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "deleteMessage", void 0);

__decorate([bindings_Action("restoreMessage", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "restoreMessage", void 0);

__decorate([bindings_Action("banUser", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "banUser", void 0);

__decorate([bindings_Action("unbanUser", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "unbanUser", void 0);

__decorate([bindings_Action("pinMessage", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "pinMessageAction", void 0);

__decorate([bindings_Action("ignoreUser", {
  namespace: USER_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "ignoreUser", void 0);

__decorate([bindings_Action("sendReport", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "sendReport", void 0);

__decorate([bindings_Mutation("setThreadActive", {
  namespace: store_CHAT_NAMESPACE
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "setThreadActive", void 0);

__decorate([Watch("subitems")], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "onSubitemsChange", null);

__decorate([Watch("banned")], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage.prototype, "onBannedChange", null);

ChatTextMessagevue_type_script_lang_ts_ChatTextMessage = __decorate([vue_class_component_esm({
  components: {
    ChatModBadge: components_ChatModBadge,
    ChatEmojiPicker: components_ChatEmojiPicker
  }
})], ChatTextMessagevue_type_script_lang_ts_ChatTextMessage);
/* harmony default export */ var ChatTextMessagevue_type_script_lang_ts_ = (ChatTextMessagevue_type_script_lang_ts_ChatTextMessage);
// CONCATENATED MODULE: ./src/components/ChatTextMessage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ChatTextMessagevue_type_script_lang_ts_ = (ChatTextMessagevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/ChatTextMessage.vue?vue&type=style&index=0&lang=scss&
var ChatTextMessagevue_type_style_index_0_lang_scss_ = __webpack_require__("c30f");

// EXTERNAL MODULE: ./src/components/ChatTextMessage.vue?vue&type=style&index=1&id=3188c232&lang=scss&scoped=true&
var ChatTextMessagevue_type_style_index_1_id_3188c232_lang_scss_scoped_true_ = __webpack_require__("ea49");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.fixed.js
var es_string_fixed = __webpack_require__("c7cd");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__("e9c4");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VBtn/VBtn.sass
var VBtn = __webpack_require__("86cc");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSheet/VSheet.sass
var VSheet = __webpack_require__("25a8");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/elevatable/index.js



/* harmony default export */ var elevatable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'elevatable',
  props: {
    elevation: [Number, String]
  },
  computed: {
    computedElevation: function computedElevation() {
      return this.elevation;
    },
    elevationClasses: function elevationClasses() {
      var elevation = this.computedElevation;
      if (elevation == null) return {};
      if (isNaN(parseInt(elevation))) return {};
      return _defineProperty({}, "elevation-".concat(this.elevation), true);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/measurable/index.js

// Helpers
 // Types


/* harmony default export */ var measurable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'measurable',
  props: {
    height: [Number, String],
    maxHeight: [Number, String],
    maxWidth: [Number, String],
    minHeight: [Number, String],
    minWidth: [Number, String],
    width: [Number, String]
  },
  computed: {
    measurableStyles: function measurableStyles() {
      var styles = {};
      var height = convertToUnit(this.height);
      var minHeight = convertToUnit(this.minHeight);
      var minWidth = convertToUnit(this.minWidth);
      var maxHeight = convertToUnit(this.maxHeight);
      var maxWidth = convertToUnit(this.maxWidth);
      var width = convertToUnit(this.width);
      if (height) styles.height = height;
      if (minHeight) styles.minHeight = minHeight;
      if (minWidth) styles.minWidth = minWidth;
      if (maxHeight) styles.maxHeight = maxHeight;
      if (maxWidth) styles.maxWidth = maxWidth;
      if (width) styles.width = width;
      return styles;
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js









function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/roundable/index.js






/* @vue/component */

/* harmony default export */ var roundable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'roundable',
  props: {
    rounded: [Boolean, String],
    tile: Boolean
  },
  computed: {
    roundedClasses: function roundedClasses() {
      var composite = [];
      var rounded = typeof this.rounded === 'string' ? String(this.rounded) : this.rounded === true;

      if (this.tile) {
        composite.push('rounded-0');
      } else if (typeof rounded === 'string') {
        var values = rounded.split(' ');

        var _iterator = _createForOfIteratorHelper(values),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var value = _step.value;
            composite.push("rounded-".concat(value));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (rounded) {
        composite.push('rounded');
      }

      return composite.length > 0 ? _defineProperty({}, composite.join(' '), true) : {};
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSheet/VSheet.js

// Styles
 // Mixins






 // Helpers


/* @vue/component */

/* harmony default export */ var VSheet_VSheet = (mixins_mixins(binds_attrs, colorable, elevatable, measurable, roundable, themeable).extend({
  name: 'v-sheet',
  props: {
    outlined: Boolean,
    shaped: Boolean,
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2(_objectSpread2({
        'v-sheet': true,
        'v-sheet--outlined': this.outlined,
        'v-sheet--shaped': this.shaped
      }, this.themeClasses), this.elevationClasses), this.roundedClasses);
    },
    styles: function styles() {
      return this.measurableStyles;
    }
  },
  render: function render(h) {
    var data = {
      class: this.classes,
      style: this.styles,
      on: this.listeners$
    };
    return h(this.tag, this.setBackgroundColor(this.color, data), this.$slots.default);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSheet/index.js


/* harmony default export */ var components_VSheet = (VSheet_VSheet);
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VProgressCircular/VProgressCircular.sass
var VProgressCircular = __webpack_require__("8d4f");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/directives/intersect/index.js



function inserted(el, binding, vnode) {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;
  var modifiers = binding.modifiers || {};
  var value = binding.value;

  var _ref = _typeof(value) === 'object' ? value : {
    handler: value,
    options: {}
  },
      handler = _ref.handler,
      options = _ref.options;

  var observer = new IntersectionObserver(function () {
    var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var observer = arguments.length > 1 ? arguments[1] : undefined;

    var _el$_observe;

    var _observe = (_el$_observe = el._observe) == null ? void 0 : _el$_observe[vnode.context._uid];

    if (!_observe) return; // Just in case, should never fire

    var isIntersecting = entries.some(function (entry) {
      return entry.isIntersecting;
    }); // If is not quiet or has already been
    // initted, invoke the user callback

    if (handler && (!modifiers.quiet || _observe.init) && (!modifiers.once || isIntersecting || _observe.init)) {
      handler(entries, observer, isIntersecting);
    }

    if (isIntersecting && modifiers.once) unbind(el, binding, vnode);else _observe.init = true;
  }, options);
  el._observe = Object(el._observe);
  el._observe[vnode.context._uid] = {
    init: false,
    observer: observer
  };
  observer.observe(el);
}

function unbind(el, binding, vnode) {
  var _el$_observe2;

  var observe = (_el$_observe2 = el._observe) == null ? void 0 : _el$_observe2[vnode.context._uid];
  if (!observe) return;
  observe.observer.unobserve(el);
  delete el._observe[vnode.context._uid];
}

var Intersect = {
  inserted: inserted,
  unbind: unbind
};
/* harmony default export */ var intersect = (Intersect);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.js


// Styles
 // Directives

 // Mixins

 // Utils


/* @vue/component */

/* harmony default export */ var VProgressCircular_VProgressCircular = (colorable.extend({
  name: 'v-progress-circular',
  directives: {
    intersect: intersect
  },
  props: {
    button: Boolean,
    indeterminate: Boolean,
    rotate: {
      type: [Number, String],
      default: 0
    },
    size: {
      type: [Number, String],
      default: 32
    },
    width: {
      type: [Number, String],
      default: 4
    },
    value: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      radius: 20,
      isVisible: true
    };
  },
  computed: {
    calculatedSize: function calculatedSize() {
      return Number(this.size) + (this.button ? 8 : 0);
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'v-progress-circular--visible': this.isVisible,
        'v-progress-circular--indeterminate': this.indeterminate,
        'v-progress-circular--button': this.button
      };
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return parseFloat(this.value);
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    strokeWidth: function strokeWidth() {
      return Number(this.width) / +this.size * this.viewBoxSize * 2;
    },
    styles: function styles() {
      return {
        height: convertToUnit(this.calculatedSize),
        width: convertToUnit(this.calculatedSize)
      };
    },
    svgStyles: function svgStyles() {
      return {
        transform: "rotate(".concat(Number(this.rotate), "deg)")
      };
    },
    viewBoxSize: function viewBoxSize() {
      return this.radius / (1 - Number(this.width) / +this.size);
    }
  },
  methods: {
    genCircle: function genCircle(name, offset) {
      return this.$createElement('circle', {
        class: "v-progress-circular__".concat(name),
        attrs: {
          fill: 'transparent',
          cx: 2 * this.viewBoxSize,
          cy: 2 * this.viewBoxSize,
          r: this.radius,
          'stroke-width': this.strokeWidth,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg() {
      var children = [this.indeterminate || this.genCircle('underlay', 0), this.genCircle('overlay', this.strokeDashOffset)];
      return this.$createElement('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: "".concat(this.viewBoxSize, " ").concat(this.viewBoxSize, " ").concat(2 * this.viewBoxSize, " ").concat(2 * this.viewBoxSize)
        }
      }, children);
    },
    genInfo: function genInfo() {
      return this.$createElement('div', {
        staticClass: 'v-progress-circular__info'
      }, this.$slots.default);
    },
    onObserve: function onObserve(entries, observer, isIntersecting) {
      this.isVisible = isIntersecting;
    }
  },
  render: function render(h) {
    return h('div', this.setTextColor(this.color, {
      staticClass: 'v-progress-circular',
      attrs: {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': 100,
        'aria-valuenow': this.indeterminate ? undefined : this.normalizedValue
      },
      class: this.classes,
      directives: [{
        name: 'intersect',
        value: this.onObserve
      }],
      style: this.styles,
      on: this.$listeners
    }), [this.genSvg(), this.genInfo()]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VProgressCircular/index.js


/* harmony default export */ var components_VProgressCircular = (VProgressCircular_VProgressCircular);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/registrable/index.js





function generateWarning(child, parent) {
  return function () {
    return consoleWarn("The ".concat(child, " component must be used inside a ").concat(parent));
  };
}

function inject(namespace, child, parent) {
  var defaultImpl = child && parent ? {
    register: generateWarning(child, parent),
    unregister: generateWarning(child, parent)
  } : null;
  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: 'registrable-inject',
    inject: _defineProperty({}, namespace, {
      default: defaultImpl
    })
  });
}
function registrable_provide(namespace) {
  var self = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: 'registrable-provide',
    provide: function provide() {
      return _defineProperty({}, namespace, self ? this : {
        register: this.register,
        unregister: this.unregister
      });
    }
  });
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/groupable/index.js

// Mixins

function groupable_factory(namespace, child, parent) {
  return inject(namespace, child, parent).extend({
    name: 'groupable',
    props: {
      activeClass: {
        type: String,
        default: function _default() {
          if (!this[namespace]) return undefined;
          return this[namespace].activeClass;
        }
      },
      disabled: Boolean
    },
    data: function data() {
      return {
        isActive: false
      };
    },
    computed: {
      groupClasses: function groupClasses() {
        if (!this.activeClass) return {};
        return _defineProperty({}, this.activeClass, this.isActive);
      }
    },
    created: function created() {
      this[namespace] && this[namespace].register(this);
    },
    beforeDestroy: function beforeDestroy() {
      this[namespace] && this[namespace].unregister(this);
    },
    methods: {
      toggle: function toggle() {
        this.$emit('change');
      }
    }
  });
}
/* eslint-disable-next-line @typescript-eslint/no-redeclare */

var Groupable = groupable_factory('itemGroup');
/* harmony default export */ var groupable = (Groupable);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("9911");

// EXTERNAL MODULE: ./node_modules/vuetify/src/directives/ripple/VRipple.sass
var VRipple = __webpack_require__("7435");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/directives/ripple/index.js



// Styles
 // Utilities



var DELAY_RIPPLE = 80;

function ripple_transform(el, value) {
  el.style.transform = value;
  el.style.webkitTransform = value;
}

function ripple_isTouchEvent(e) {
  return e.constructor.name === 'TouchEvent';
}

function isKeyboardEvent(e) {
  return e.constructor.name === 'KeyboardEvent';
}

var calculate = function calculate(e, el) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localX = 0;
  var localY = 0;

  if (!isKeyboardEvent(e)) {
    var offset = el.getBoundingClientRect();
    var target = ripple_isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
    localX = target.clientX - offset.left;
    localY = target.clientY - offset.top;
  }

  var radius = 0;
  var scale = 0.3;

  if (el._ripple && el._ripple.circle) {
    scale = 0.15;
    radius = el.clientWidth / 2;
    radius = value.center ? radius : radius + Math.sqrt(Math.pow(localX - radius, 2) + Math.pow(localY - radius, 2)) / 4;
  } else {
    radius = Math.sqrt(Math.pow(el.clientWidth, 2) + Math.pow(el.clientHeight, 2)) / 2;
  }

  var centerX = "".concat((el.clientWidth - radius * 2) / 2, "px");
  var centerY = "".concat((el.clientHeight - radius * 2) / 2, "px");
  var x = value.center ? centerX : "".concat(localX - radius, "px");
  var y = value.center ? centerY : "".concat(localY - radius, "px");
  return {
    radius: radius,
    scale: scale,
    x: x,
    y: y,
    centerX: centerX,
    centerY: centerY
  };
};

var ripples = {
  /* eslint-disable max-statements */
  show: function show(e, el) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!el._ripple || !el._ripple.enabled) {
      return;
    }

    var container = document.createElement('span');
    var animation = document.createElement('span');
    container.appendChild(animation);
    container.className = 'v-ripple__container';

    if (value.class) {
      container.className += " ".concat(value.class);
    }

    var _calculate = calculate(e, el, value),
        radius = _calculate.radius,
        scale = _calculate.scale,
        x = _calculate.x,
        y = _calculate.y,
        centerX = _calculate.centerX,
        centerY = _calculate.centerY;

    var size = "".concat(radius * 2, "px");
    animation.className = 'v-ripple__animation';
    animation.style.width = size;
    animation.style.height = size;
    el.appendChild(container);
    var computed = window.getComputedStyle(el);

    if (computed && computed.position === 'static') {
      el.style.position = 'relative';
      el.dataset.previousPosition = 'static';
    }

    animation.classList.add('v-ripple__animation--enter');
    animation.classList.add('v-ripple__animation--visible');
    ripple_transform(animation, "translate(".concat(x, ", ").concat(y, ") scale3d(").concat(scale, ",").concat(scale, ",").concat(scale, ")"));
    animation.dataset.activated = String(performance.now());
    setTimeout(function () {
      animation.classList.remove('v-ripple__animation--enter');
      animation.classList.add('v-ripple__animation--in');
      ripple_transform(animation, "translate(".concat(centerX, ", ").concat(centerY, ") scale3d(1,1,1)"));
    }, 0);
  },
  hide: function hide(el) {
    if (!el || !el._ripple || !el._ripple.enabled) return;
    var ripples = el.getElementsByClassName('v-ripple__animation');
    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    if (animation.dataset.isHiding) return;else animation.dataset.isHiding = 'true';
    var diff = performance.now() - Number(animation.dataset.activated);
    var delay = Math.max(250 - diff, 0);
    setTimeout(function () {
      animation.classList.remove('v-ripple__animation--in');
      animation.classList.add('v-ripple__animation--out');
      setTimeout(function () {
        var ripples = el.getElementsByClassName('v-ripple__animation');

        if (ripples.length === 1 && el.dataset.previousPosition) {
          el.style.position = el.dataset.previousPosition;
          delete el.dataset.previousPosition;
        }

        animation.parentNode && el.removeChild(animation.parentNode);
      }, 300);
    }, delay);
  }
};

function isRippleEnabled(value) {
  return typeof value === 'undefined' || !!value;
}

function rippleShow(e) {
  var value = {};
  var element = e.currentTarget;
  if (!element || !element._ripple || element._ripple.touched || e.rippleStop) return; // Don't allow the event to trigger ripples on any other elements

  e.rippleStop = true;

  if (ripple_isTouchEvent(e)) {
    element._ripple.touched = true;
    element._ripple.isTouch = true;
  } else {
    // It's possible for touch events to fire
    // as mouse events on Android/iOS, this
    // will skip the event call if it has
    // already been registered as touch
    if (element._ripple.isTouch) return;
  }

  value.center = element._ripple.centered || isKeyboardEvent(e);

  if (element._ripple.class) {
    value.class = element._ripple.class;
  }

  if (ripple_isTouchEvent(e)) {
    // already queued that shows or hides the ripple
    if (element._ripple.showTimerCommit) return;

    element._ripple.showTimerCommit = function () {
      ripples.show(e, element, value);
    };

    element._ripple.showTimer = window.setTimeout(function () {
      if (element && element._ripple && element._ripple.showTimerCommit) {
        element._ripple.showTimerCommit();

        element._ripple.showTimerCommit = null;
      }
    }, DELAY_RIPPLE);
  } else {
    ripples.show(e, element, value);
  }
}

function rippleHide(e) {
  var element = e.currentTarget;
  if (!element || !element._ripple) return;
  window.clearTimeout(element._ripple.showTimer); // The touch interaction occurs before the show timer is triggered.
  // We still want to show ripple effect.

  if (e.type === 'touchend' && element._ripple.showTimerCommit) {
    element._ripple.showTimerCommit();

    element._ripple.showTimerCommit = null; // re-queue ripple hiding

    element._ripple.showTimer = setTimeout(function () {
      rippleHide(e);
    });
    return;
  }

  window.setTimeout(function () {
    if (element._ripple) {
      element._ripple.touched = false;
    }
  });
  ripples.hide(element);
}

function rippleCancelShow(e) {
  var element = e.currentTarget;
  if (!element || !element._ripple) return;

  if (element._ripple.showTimerCommit) {
    element._ripple.showTimerCommit = null;
  }

  window.clearTimeout(element._ripple.showTimer);
}

var keyboardRipple = false;

function keyboardRippleShow(e) {
  if (!keyboardRipple && (e.keyCode === keyCodes.enter || e.keyCode === keyCodes.space)) {
    keyboardRipple = true;
    rippleShow(e);
  }
}

function keyboardRippleHide(e) {
  keyboardRipple = false;
  rippleHide(e);
}

function focusRippleHide(e) {
  if (keyboardRipple === true) {
    keyboardRipple = false;
    rippleHide(e);
  }
}

function updateRipple(el, binding, wasEnabled) {
  var enabled = isRippleEnabled(binding.value);

  if (!enabled) {
    ripples.hide(el);
  }

  el._ripple = el._ripple || {};
  el._ripple.enabled = enabled;
  var value = binding.value || {};

  if (value.center) {
    el._ripple.centered = true;
  }

  if (value.class) {
    el._ripple.class = binding.value.class;
  }

  if (value.circle) {
    el._ripple.circle = value.circle;
  }

  if (enabled && !wasEnabled) {
    el.addEventListener('touchstart', rippleShow, {
      passive: true
    });
    el.addEventListener('touchend', rippleHide, {
      passive: true
    });
    el.addEventListener('touchmove', rippleCancelShow, {
      passive: true
    });
    el.addEventListener('touchcancel', rippleHide);
    el.addEventListener('mousedown', rippleShow);
    el.addEventListener('mouseup', rippleHide);
    el.addEventListener('mouseleave', rippleHide);
    el.addEventListener('keydown', keyboardRippleShow);
    el.addEventListener('keyup', keyboardRippleHide);
    el.addEventListener('blur', focusRippleHide); // Anchor tags can be dragged, causes other hides to fail - #1537

    el.addEventListener('dragstart', rippleHide, {
      passive: true
    });
  } else if (!enabled && wasEnabled) {
    removeListeners(el);
  }
}

function removeListeners(el) {
  el.removeEventListener('mousedown', rippleShow);
  el.removeEventListener('touchstart', rippleShow);
  el.removeEventListener('touchend', rippleHide);
  el.removeEventListener('touchmove', rippleCancelShow);
  el.removeEventListener('touchcancel', rippleHide);
  el.removeEventListener('mouseup', rippleHide);
  el.removeEventListener('mouseleave', rippleHide);
  el.removeEventListener('keydown', keyboardRippleShow);
  el.removeEventListener('keyup', keyboardRippleHide);
  el.removeEventListener('dragstart', rippleHide);
  el.removeEventListener('blur', focusRippleHide);
}

function ripple_directive(el, binding, node) {
  updateRipple(el, binding, false);

  if (false) {}
}

function ripple_unbind(el) {
  delete el._ripple;
  removeListeners(el);
}

function ripple_update(el, binding) {
  if (binding.value === binding.oldValue) {
    return;
  }

  var wasEnabled = isRippleEnabled(binding.oldValue);
  updateRipple(el, binding, wasEnabled);
}

var Ripple = {
  bind: ripple_directive,
  unbind: ripple_unbind,
  update: ripple_update
};
/* harmony default export */ var ripple = (Ripple);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/routable/index.js








 // Directives

 // Utilities


/* harmony default export */ var routable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'routable',
  directives: {
    Ripple: ripple
  },
  props: {
    activeClass: String,
    append: Boolean,
    disabled: Boolean,
    exact: {
      type: Boolean,
      default: undefined
    },
    exactPath: Boolean,
    exactActiveClass: String,
    link: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: null
    },
    tag: String,
    target: String
  },
  data: function data() {
    return {
      isActive: false,
      proxyClass: ''
    };
  },
  computed: {
    classes: function classes() {
      var classes = {};
      if (this.to) return classes;
      if (this.activeClass) classes[this.activeClass] = this.isActive;
      if (this.proxyClass) classes[this.proxyClass] = this.isActive;
      return classes;
    },
    computedRipple: function computedRipple() {
      var _this$ripple;

      return (_this$ripple = this.ripple) != null ? _this$ripple : !this.disabled && this.isClickable;
    },
    isClickable: function isClickable() {
      if (this.disabled) return false;
      return Boolean(this.isLink || this.$listeners.click || this.$listeners['!click'] || this.$attrs.tabindex);
    },
    isLink: function isLink() {
      return this.to || this.href || this.link;
    },
    styles: function styles() {
      return {};
    }
  },
  watch: {
    $route: 'onRouteChange'
  },
  mounted: function mounted() {
    this.onRouteChange();
  },
  methods: {
    generateRouteLink: function generateRouteLink() {
      var _data;

      var exact = this.exact;
      var tag;
      var data = (_data = {
        attrs: {
          tabindex: 'tabindex' in this.$attrs ? this.$attrs.tabindex : undefined
        },
        class: this.classes,
        style: this.styles,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.computedRipple
        }]
      }, _defineProperty(_data, this.to ? 'nativeOn' : 'on', _objectSpread2(_objectSpread2({}, this.$listeners), 'click' in this ? {
        click: this.click
      } : undefined)), _defineProperty(_data, "ref", 'link'), _data);

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        // Add a special activeClass hook
        // for component level styles
        var activeClass = this.activeClass;
        var exactActiveClass = this.exactActiveClass || activeClass;

        if (this.proxyClass) {
          activeClass = "".concat(activeClass, " ").concat(this.proxyClass).trim();
          exactActiveClass = "".concat(exactActiveClass, " ").concat(this.proxyClass).trim();
        }

        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        Object.assign(data.props, {
          to: this.to,
          exact: exact,
          exactPath: this.exactPath,
          activeClass: activeClass,
          exactActiveClass: exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      } else {
        tag = this.href && 'a' || this.tag || 'div';
        if (tag === 'a' && this.href) data.attrs.href = this.href;
      }

      if (this.target) data.attrs.target = this.target;
      return {
        tag: tag,
        data: data
      };
    },
    onRouteChange: function onRouteChange() {
      var _this = this;

      if (!this.to || !this.$refs.link || !this.$route) return;
      var activeClass = "".concat(this.activeClass || '', " ").concat(this.proxyClass || '').trim();
      var exactActiveClass = "".concat(this.exactActiveClass || '', " ").concat(this.proxyClass || '').trim() || activeClass;
      var path = '_vnode.data.class.' + (this.exact ? exactActiveClass : activeClass);
      this.$nextTick(function () {
        /* istanbul ignore else */
        if (!getObjectValueByPath(_this.$refs.link, path) === _this.isActive) {
          _this.toggle();
        }
      });
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VBtn/VBtn.js








// Styles
 // Extensions

 // Components

 // Mixins






 // Utilities



var VBtn_baseMixins = mixins_mixins(components_VSheet, routable, positionable, sizeable, groupable_factory('btnToggle'), factory('inputValue')
/* @vue/component */
);
/* harmony default export */ var VBtn_VBtn = (VBtn_baseMixins.extend().extend({
  name: 'v-btn',
  props: {
    activeClass: {
      type: String,
      default: function _default() {
        if (!this.btnToggle) return '';
        return this.btnToggle.activeClass;
      }
    },
    block: Boolean,
    depressed: Boolean,
    fab: Boolean,
    icon: Boolean,
    loading: Boolean,
    outlined: Boolean,
    plain: Boolean,
    retainFocusOnClick: Boolean,
    rounded: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    text: Boolean,
    tile: Boolean,
    type: {
      type: String,
      default: 'button'
    },
    value: null
  },
  data: function data() {
    return {
      proxyClass: 'v-btn--active'
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
        'v-btn': true
      }, routable.options.computed.classes.call(this)), {}, {
        'v-btn--absolute': this.absolute,
        'v-btn--block': this.block,
        'v-btn--bottom': this.bottom,
        'v-btn--disabled': this.disabled,
        'v-btn--is-elevated': this.isElevated,
        'v-btn--fab': this.fab,
        'v-btn--fixed': this.fixed,
        'v-btn--has-bg': this.hasBg,
        'v-btn--icon': this.icon,
        'v-btn--left': this.left,
        'v-btn--loading': this.loading,
        'v-btn--outlined': this.outlined,
        'v-btn--plain': this.plain,
        'v-btn--right': this.right,
        'v-btn--round': this.isRound,
        'v-btn--rounded': this.rounded,
        'v-btn--router': this.to,
        'v-btn--text': this.text,
        'v-btn--tile': this.tile,
        'v-btn--top': this.top
      }, this.themeClasses), this.groupClasses), this.elevationClasses), this.sizeableClasses);
    },
    computedElevation: function computedElevation() {
      if (this.disabled) return undefined;
      return elevatable.options.computed.computedElevation.call(this);
    },
    computedRipple: function computedRipple() {
      var _this$ripple;

      var defaultRipple = this.icon || this.fab ? {
        circle: true
      } : true;
      if (this.disabled) return false;else return (_this$ripple = this.ripple) != null ? _this$ripple : defaultRipple;
    },
    hasBg: function hasBg() {
      return !this.text && !this.plain && !this.outlined && !this.icon;
    },
    isElevated: function isElevated() {
      return Boolean(!this.icon && !this.text && !this.outlined && !this.depressed && !this.disabled && !this.plain && (this.elevation == null || Number(this.elevation) > 0));
    },
    isRound: function isRound() {
      return Boolean(this.icon || this.fab);
    },
    styles: function styles() {
      return _objectSpread2({}, this.measurableStyles);
    }
  },
  created: function created() {
    var _this = this;

    var breakingProps = [['flat', 'text'], ['outline', 'outlined'], ['round', 'rounded']];
    /* istanbul ignore next */

    breakingProps.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          original = _ref2[0],
          replacement = _ref2[1];

      if (_this.$attrs.hasOwnProperty(original)) breaking(original, replacement, _this);
    });
  },
  methods: {
    click: function click(e) {
      // TODO: Remove this in v3
      !this.retainFocusOnClick && !this.fab && e.detail && this.$el.blur();
      this.$emit('click', e);
      this.btnToggle && this.toggle();
    },
    genContent: function genContent() {
      return this.$createElement('span', {
        staticClass: 'v-btn__content'
      }, this.$slots.default);
    },
    genLoader: function genLoader() {
      return this.$createElement('span', {
        class: 'v-btn__loader'
      }, this.$slots.loader || [this.$createElement(components_VProgressCircular, {
        props: {
          indeterminate: true,
          size: 23,
          width: 2
        }
      })]);
    }
  },
  render: function render(h) {
    var children = [this.genContent(), this.loading && this.genLoader()];

    var _this$generateRouteLi = this.generateRouteLink(),
        tag = _this$generateRouteLi.tag,
        data = _this$generateRouteLi.data;

    var setColor = this.hasBg ? this.setBackgroundColor : this.setTextColor;

    if (tag === 'button') {
      data.attrs.type = this.type;
      data.attrs.disabled = this.disabled;
    }

    data.attrs.value = ['string', 'number'].includes(_typeof(this.value)) ? this.value : JSON.stringify(this.value);
    return h(tag, this.disabled ? data : setColor(this.color, data), children);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("0481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("4069");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VCard/VCard.sass
var VCard = __webpack_require__("615b");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VProgressLinear/VProgressLinear.sass
var VProgressLinear = __webpack_require__("6ece");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/mergeData.js









var pattern = {
  styleList: /;(?![^(]*\))/g,
  styleProp: /:(.*)/
};

function parseStyle(style) {
  var styleMap = {};

  var _iterator = _createForOfIteratorHelper(style.split(pattern.styleList)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;

      var _s$split = s.split(pattern.styleProp),
          _s$split2 = _slicedToArray(_s$split, 2),
          key = _s$split2[0],
          val = _s$split2[1];

      key = key.trim();

      if (!key) {
        continue;
      } // May be undefined if the `key: value` pair is incomplete.


      if (typeof val === 'string') {
        val = val.trim();
      }

      styleMap[camelize(key)] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return styleMap;
}

function mergeData() {
  var mergeTarget = {};
  var i = arguments.length;
  var prop; // Allow for variadic argument length.

  while (i--) {
    // Iterate through the data properties and execute merge strategies
    // Object.keys eliminates need for hasOwnProperty call
    for (var _i = 0, _Object$keys = Object.keys(arguments[i]); _i < _Object$keys.length; _i++) {
      prop = _Object$keys[_i];

      switch (prop) {
        // Array merge strategy (array concatenation)
        case 'class':
        case 'directives':
          if (arguments[i][prop]) {
            mergeTarget[prop] = mergeClasses(mergeTarget[prop], arguments[i][prop]);
          }

          break;

        case 'style':
          if (arguments[i][prop]) {
            mergeTarget[prop] = mergeStyles(mergeTarget[prop], arguments[i][prop]);
          }

          break;
        // Space delimited string concatenation strategy

        case 'staticClass':
          if (!arguments[i][prop]) {
            break;
          }

          if (mergeTarget[prop] === undefined) {
            mergeTarget[prop] = '';
          }

          if (mergeTarget[prop]) {
            // Not an empty string, so concatenate
            mergeTarget[prop] += ' ';
          }

          mergeTarget[prop] += arguments[i][prop].trim();
          break;
        // Object, the properties of which to merge via array merge strategy (array concatenation).
        // Callback merge strategy merges callbacks to the beginning of the array,
        // so that the last defined callback will be invoked first.
        // This is done since to mimic how Object.assign merging
        // uses the last given value to assign.

        case 'on':
        case 'nativeOn':
          if (arguments[i][prop]) {
            mergeTarget[prop] = mergeListeners(mergeTarget[prop], arguments[i][prop]);
          }

          break;
        // Object merge strategy

        case 'attrs':
        case 'props':
        case 'domProps':
        case 'scopedSlots':
        case 'staticStyle':
        case 'hook':
        case 'transition':
          if (!arguments[i][prop]) {
            break;
          }

          if (!mergeTarget[prop]) {
            mergeTarget[prop] = {};
          }

          mergeTarget[prop] = _objectSpread2(_objectSpread2({}, arguments[i][prop]), mergeTarget[prop]);
          break;
        // Reassignment strategy (no merge)

        default:
          // slot, key, ref, tag, show, keepAlive
          if (!mergeTarget[prop]) {
            mergeTarget[prop] = arguments[i][prop];
          }

      }
    }
  }

  return mergeTarget;
}
function mergeStyles(target, source) {
  if (!target) return source;
  if (!source) return target;
  target = wrapInArray(typeof target === 'string' ? parseStyle(target) : target);
  return target.concat(typeof source === 'string' ? parseStyle(source) : source);
}
function mergeClasses(target, source) {
  if (!source) return target;
  if (!target) return source;
  return target ? wrapInArray(target).concat(source) : source;
}
function mergeListeners() {
  if (!(arguments.length <= 0 ? undefined : arguments[0])) return arguments.length <= 1 ? undefined : arguments[1];
  if (!(arguments.length <= 1 ? undefined : arguments[1])) return arguments.length <= 0 ? undefined : arguments[0];
  var dest = {};

  for (var i = 2; i--;) {
    var arg = i < 0 || arguments.length <= i ? undefined : arguments[i];

    for (var event in arg) {
      if (!arg[event]) continue;

      if (dest[event]) {
        // Merge current listeners before (because we are iterating backwards).
        // Note that neither "target" or "source" must be altered.
        dest[event] = [].concat(arg[event], dest[event]);
      } else {
        // Straight assign.
        dest[event] = arg[event];
      }
    }
  }

  return dest;
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/transitions/createTransition.js



function mergeTransitions() {
  var _Array;

  var dest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  for (var _len = arguments.length, transitions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    transitions[_key - 1] = arguments[_key];
  }

  /* eslint-disable-next-line no-array-constructor */
  return (_Array = Array()).concat.apply(_Array, [dest].concat(transitions));
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments.length > 2 ? arguments[2] : undefined;
  return {
    name: name,
    functional: true,
    props: {
      group: {
        type: Boolean,
        default: false
      },
      hideOnLeave: {
        type: Boolean,
        default: false
      },
      leaveAbsolute: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: mode
      },
      origin: {
        type: String,
        default: origin
      }
    },
    render: function render(h, context) {
      var tag = "transition".concat(context.props.group ? '-group' : '');
      var data = {
        props: {
          name: name,
          mode: context.props.mode
        },
        on: {
          beforeEnter: function beforeEnter(el) {
            el.style.transformOrigin = context.props.origin;
            el.style.webkitTransformOrigin = context.props.origin;
          }
        }
      };

      if (context.props.leaveAbsolute) {
        data.on.leave = mergeTransitions(data.on.leave, function (el) {
          var offsetTop = el.offsetTop,
              offsetLeft = el.offsetLeft,
              offsetWidth = el.offsetWidth,
              offsetHeight = el.offsetHeight;
          el._transitionInitialStyles = {
            position: el.style.position,
            top: el.style.top,
            left: el.style.left,
            width: el.style.width,
            height: el.style.height
          };
          el.style.position = 'absolute';
          el.style.top = offsetTop + 'px';
          el.style.left = offsetLeft + 'px';
          el.style.width = offsetWidth + 'px';
          el.style.height = offsetHeight + 'px';
        });
        data.on.afterLeave = mergeTransitions(data.on.afterLeave, function (el) {
          if (el && el._transitionInitialStyles) {
            var _el$_transitionInitia = el._transitionInitialStyles,
                position = _el$_transitionInitia.position,
                top = _el$_transitionInitia.top,
                left = _el$_transitionInitia.left,
                width = _el$_transitionInitia.width,
                height = _el$_transitionInitia.height;
            delete el._transitionInitialStyles;
            el.style.position = position || '';
            el.style.top = top || '';
            el.style.left = left || '';
            el.style.width = width || '';
            el.style.height = height || '';
          }
        });
      }

      if (context.props.hideOnLeave) {
        data.on.leave = mergeTransitions(data.on.leave, function (el) {
          el.style.setProperty('display', 'none', 'important');
        });
      }

      return h(tag, mergeData(context.data, data), context.children);
    }
  };
}
function createJavascriptTransition(name, functions) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'in-out';
  return {
    name: name,
    functional: true,
    props: {
      mode: {
        type: String,
        default: mode
      }
    },
    render: function render(h, context) {
      return h('transition', mergeData(context.data, {
        props: {
          name: name
        },
        on: functions
      }), context.children);
    }
  };
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/transitions/expand-transition.js


/* harmony default export */ var expand_transition = (function () {
  var expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sizeProperty = x ? 'width' : 'height';
  var offsetProperty = "offset".concat(upperFirst(sizeProperty));
  return {
    beforeEnter: function beforeEnter(el) {
      el._parent = el.parentNode;
      el._initialStyle = _defineProperty({
        transition: el.style.transition,
        overflow: el.style.overflow
      }, sizeProperty, el.style[sizeProperty]);
    },
    enter: function enter(el) {
      var initialStyle = el._initialStyle;
      el.style.setProperty('transition', 'none', 'important'); // Hide overflow to account for collapsed margins in the calculated height

      el.style.overflow = 'hidden';
      var offset = "".concat(el[offsetProperty], "px");
      el.style[sizeProperty] = '0';
      void el.offsetHeight; // force reflow

      el.style.transition = initialStyle.transition;

      if (expandedParentClass && el._parent) {
        el._parent.classList.add(expandedParentClass);
      }

      requestAnimationFrame(function () {
        el.style[sizeProperty] = offset;
      });
    },
    afterEnter: resetStyles,
    enterCancelled: resetStyles,
    leave: function leave(el) {
      el._initialStyle = _defineProperty({
        transition: '',
        overflow: el.style.overflow
      }, sizeProperty, el.style[sizeProperty]);
      el.style.overflow = 'hidden';
      el.style[sizeProperty] = "".concat(el[offsetProperty], "px");
      void el.offsetHeight; // force reflow

      requestAnimationFrame(function () {
        return el.style[sizeProperty] = '0';
      });
    },
    afterLeave: afterLeave,
    leaveCancelled: afterLeave
  };

  function afterLeave(el) {
    if (expandedParentClass && el._parent) {
      el._parent.classList.remove(expandedParentClass);
    }

    resetStyles(el);
  }

  function resetStyles(el) {
    var size = el._initialStyle[sizeProperty];
    el.style.overflow = el._initialStyle.overflow;
    if (size != null) el.style[sizeProperty] = size;
    delete el._initialStyle;
  }
});
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/transitions/index.js

 // Component specific transitions

var VCarouselTransition = createSimpleTransition('carousel-transition');
var VCarouselReverseTransition = createSimpleTransition('carousel-reverse-transition');
var VTabTransition = createSimpleTransition('tab-transition');
var VTabReverseTransition = createSimpleTransition('tab-reverse-transition');
var VMenuTransition = createSimpleTransition('menu-transition');
var VFabTransition = createSimpleTransition('fab-transition', 'center center', 'out-in'); // Generic transitions

var VDialogTransition = createSimpleTransition('dialog-transition');
var VDialogBottomTransition = createSimpleTransition('dialog-bottom-transition');
var VDialogTopTransition = createSimpleTransition('dialog-top-transition');
var VFadeTransition = createSimpleTransition('fade-transition');
var VScaleTransition = createSimpleTransition('scale-transition');
var VScrollXTransition = createSimpleTransition('scroll-x-transition');
var VScrollXReverseTransition = createSimpleTransition('scroll-x-reverse-transition');
var VScrollYTransition = createSimpleTransition('scroll-y-transition');
var VScrollYReverseTransition = createSimpleTransition('scroll-y-reverse-transition');
var VSlideXTransition = createSimpleTransition('slide-x-transition');
var VSlideXReverseTransition = createSimpleTransition('slide-x-reverse-transition');
var VSlideYTransition = createSimpleTransition('slide-y-transition');
var VSlideYReverseTransition = createSimpleTransition('slide-y-reverse-transition'); // Javascript transitions

var VExpandTransition = createJavascriptTransition('expand-transition', expand_transition());
var VExpandXTransition = createJavascriptTransition('expand-x-transition', expand_transition('', true));
/* harmony default export */ var transitions = ({
  $_vuetify_subcomponents: {
    VCarouselTransition: VCarouselTransition,
    VCarouselReverseTransition: VCarouselReverseTransition,
    VDialogTransition: VDialogTransition,
    VDialogBottomTransition: VDialogBottomTransition,
    VDialogTopTransition: VDialogTopTransition,
    VFabTransition: VFabTransition,
    VFadeTransition: VFadeTransition,
    VMenuTransition: VMenuTransition,
    VScaleTransition: VScaleTransition,
    VScrollXTransition: VScrollXTransition,
    VScrollXReverseTransition: VScrollXReverseTransition,
    VScrollYTransition: VScrollYTransition,
    VScrollYReverseTransition: VScrollYReverseTransition,
    VSlideXTransition: VSlideXTransition,
    VSlideXReverseTransition: VSlideXReverseTransition,
    VSlideYTransition: VSlideYTransition,
    VSlideYReverseTransition: VSlideYReverseTransition,
    VTabReverseTransition: VTabReverseTransition,
    VTabTransition: VTabTransition,
    VExpandTransition: VExpandTransition,
    VExpandXTransition: VExpandXTransition
  }
});
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/proxyable/index.js


function proxyable_factory() {
  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'value';
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'change';
  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: 'proxyable',
    model: {
      prop: prop,
      event: event
    },
    props: _defineProperty({}, prop, {
      required: false
    }),
    data: function data() {
      return {
        internalLazyValue: this[prop]
      };
    },
    computed: {
      internalValue: {
        get: function get() {
          return this.internalLazyValue;
        },
        set: function set(val) {
          if (val === this.internalLazyValue) return;
          this.internalLazyValue = val;
          this.$emit(event, val);
        }
      }
    },
    watch: _defineProperty({}, prop, function (val) {
      this.internalLazyValue = val;
    })
  });
}
/* eslint-disable-next-line @typescript-eslint/no-redeclare */

var Proxyable = proxyable_factory();
/* harmony default export */ var proxyable = (Proxyable);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VProgressLinear/VProgressLinear.js




 // Components

 // Directives

 // Mixins




 // Utilities



var VProgressLinear_baseMixins = mixins_mixins(colorable, positionable_factory(['absolute', 'fixed', 'top', 'bottom']), proxyable, themeable);
/* @vue/component */

/* harmony default export */ var VProgressLinear_VProgressLinear = (VProgressLinear_baseMixins.extend({
  name: 'v-progress-linear',
  directives: {
    intersect: intersect
  },
  props: {
    active: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: null
    },
    backgroundOpacity: {
      type: [Number, String],
      default: null
    },
    bufferValue: {
      type: [Number, String],
      default: 100
    },
    color: {
      type: String,
      default: 'primary'
    },
    height: {
      type: [Number, String],
      default: 4
    },
    indeterminate: Boolean,
    query: Boolean,
    reverse: Boolean,
    rounded: Boolean,
    stream: Boolean,
    striped: Boolean,
    value: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      internalLazyValue: this.value || 0,
      isVisible: true
    };
  },
  computed: {
    __cachedBackground: function __cachedBackground() {
      return this.$createElement('div', this.setBackgroundColor(this.backgroundColor || this.color, {
        staticClass: 'v-progress-linear__background',
        style: this.backgroundStyle
      }));
    },
    __cachedBar: function __cachedBar() {
      return this.$createElement(this.computedTransition, [this.__cachedBarType]);
    },
    __cachedBarType: function __cachedBarType() {
      return this.indeterminate ? this.__cachedIndeterminate : this.__cachedDeterminate;
    },
    __cachedBuffer: function __cachedBuffer() {
      return this.$createElement('div', {
        staticClass: 'v-progress-linear__buffer',
        style: this.styles
      });
    },
    __cachedDeterminate: function __cachedDeterminate() {
      return this.$createElement('div', this.setBackgroundColor(this.color, {
        staticClass: "v-progress-linear__determinate",
        style: {
          width: convertToUnit(this.normalizedValue, '%')
        }
      }));
    },
    __cachedIndeterminate: function __cachedIndeterminate() {
      return this.$createElement('div', {
        staticClass: 'v-progress-linear__indeterminate',
        class: {
          'v-progress-linear__indeterminate--active': this.active
        }
      }, [this.genProgressBar('long'), this.genProgressBar('short')]);
    },
    __cachedStream: function __cachedStream() {
      if (!this.stream) return null;
      return this.$createElement('div', this.setTextColor(this.color, {
        staticClass: 'v-progress-linear__stream',
        style: {
          width: convertToUnit(100 - this.normalizedBuffer, '%')
        }
      }));
    },
    backgroundStyle: function backgroundStyle() {
      var _ref;

      var backgroundOpacity = this.backgroundOpacity == null ? this.backgroundColor ? 1 : 0.3 : parseFloat(this.backgroundOpacity);
      return _ref = {
        opacity: backgroundOpacity
      }, _defineProperty(_ref, this.isReversed ? 'right' : 'left', convertToUnit(this.normalizedValue, '%')), _defineProperty(_ref, "width", convertToUnit(Math.max(0, this.normalizedBuffer - this.normalizedValue), '%')), _ref;
    },
    classes: function classes() {
      return _objectSpread2({
        'v-progress-linear--absolute': this.absolute,
        'v-progress-linear--fixed': this.fixed,
        'v-progress-linear--query': this.query,
        'v-progress-linear--reactive': this.reactive,
        'v-progress-linear--reverse': this.isReversed,
        'v-progress-linear--rounded': this.rounded,
        'v-progress-linear--striped': this.striped,
        'v-progress-linear--visible': this.isVisible
      }, this.themeClasses);
    },
    computedTransition: function computedTransition() {
      return this.indeterminate ? VFadeTransition : VSlideXTransition;
    },
    isReversed: function isReversed() {
      return this.$vuetify.rtl !== this.reverse;
    },
    normalizedBuffer: function normalizedBuffer() {
      return this.normalize(this.bufferValue);
    },
    normalizedValue: function normalizedValue() {
      return this.normalize(this.internalLazyValue);
    },
    reactive: function reactive() {
      return Boolean(this.$listeners.change);
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (!this.indeterminate && parseFloat(this.normalizedBuffer) !== 100) {
        styles.width = convertToUnit(this.normalizedBuffer, '%');
      }

      return styles;
    }
  },
  methods: {
    genContent: function genContent() {
      var slot = getSlot(this, 'default', {
        value: this.internalLazyValue
      });
      if (!slot) return null;
      return this.$createElement('div', {
        staticClass: 'v-progress-linear__content'
      }, slot);
    },
    genListeners: function genListeners() {
      var listeners = this.$listeners;

      if (this.reactive) {
        listeners.click = this.onClick;
      }

      return listeners;
    },
    genProgressBar: function genProgressBar(name) {
      return this.$createElement('div', this.setBackgroundColor(this.color, {
        staticClass: 'v-progress-linear__indeterminate',
        class: _defineProperty({}, name, true)
      }));
    },
    onClick: function onClick(e) {
      if (!this.reactive) return;

      var _this$$el$getBounding = this.$el.getBoundingClientRect(),
          width = _this$$el$getBounding.width;

      this.internalValue = e.offsetX / width * 100;
    },
    onObserve: function onObserve(entries, observer, isIntersecting) {
      this.isVisible = isIntersecting;
    },
    normalize: function normalize(value) {
      if (value < 0) return 0;
      if (value > 100) return 100;
      return parseFloat(value);
    }
  },
  render: function render(h) {
    var data = {
      staticClass: 'v-progress-linear',
      attrs: {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': this.normalizedBuffer,
        'aria-valuenow': this.indeterminate ? undefined : this.normalizedValue
      },
      class: this.classes,
      directives: [{
        name: 'intersect',
        value: this.onObserve
      }],
      style: {
        bottom: this.bottom ? 0 : undefined,
        height: this.active ? convertToUnit(this.height) : 0,
        top: this.top ? 0 : undefined
      },
      on: this.genListeners()
    };
    return h('div', data, [this.__cachedStream, this.__cachedBackground, this.__cachedBuffer, this.__cachedBar, this.genContent()]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VProgressLinear/index.js


/* harmony default export */ var components_VProgressLinear = (VProgressLinear_VProgressLinear);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/loadable/index.js



/**
 * Loadable
 *
 * @mixin
 *
 * Used to add linear progress bar to components
 * Can use a default bar with a specific color
 * or designate a custom progress linear bar
 */

/* @vue/component */

/* harmony default export */ var loadable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend().extend({
  name: 'loadable',
  props: {
    loading: {
      type: [Boolean, String],
      default: false
    },
    loaderHeight: {
      type: [Number, String],
      default: 2
    }
  },
  methods: {
    genProgress: function genProgress() {
      if (this.loading === false) return null;
      return this.$slots.progress || this.$createElement(components_VProgressLinear, {
        props: {
          absolute: true,
          color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
          height: this.loaderHeight,
          indeterminate: true
        }
      });
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VCard/VCard.js




// Styles
 // Extensions

 // Mixins


 // Helpers


/* @vue/component */

/* harmony default export */ var VCard_VCard = (mixins_mixins(loadable, routable, components_VSheet).extend({
  name: 'v-card',
  props: {
    flat: Boolean,
    hover: Boolean,
    img: String,
    link: Boolean,
    loaderHeight: {
      type: [Number, String],
      default: 4
    },
    raised: Boolean
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({
        'v-card': true
      }, routable.options.computed.classes.call(this)), {}, {
        'v-card--flat': this.flat,
        'v-card--hover': this.hover,
        'v-card--link': this.isClickable,
        'v-card--loading': this.loading,
        'v-card--disabled': this.disabled,
        'v-card--raised': this.raised
      }, components_VSheet.options.computed.classes.call(this));
    },
    styles: function styles() {
      var style = _objectSpread2({}, components_VSheet.options.computed.styles.call(this));

      if (this.img) {
        style.background = "url(\"".concat(this.img, "\") center center / cover no-repeat");
      }

      return style;
    }
  },
  methods: {
    genProgress: function genProgress() {
      var render = loadable.options.methods.genProgress.call(this);
      if (!render) return null;
      return this.$createElement('div', {
        staticClass: 'v-card__progress',
        key: 'progress'
      }, [render]);
    }
  },
  render: function render(h) {
    var _this$generateRouteLi = this.generateRouteLink(),
        tag = _this$generateRouteLi.tag,
        data = _this$generateRouteLi.data;

    data.style = this.styles;

    if (this.isClickable) {
      data.attrs = data.attrs || {};
      data.attrs.tabindex = 0;
    }

    return h(tag, this.setBackgroundColor(this.color, data), [this.genProgress(), this.$slots.default]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VCard/index.js


var VCardActions = createSimpleFunctional('v-card__actions');
var VCardSubtitle = createSimpleFunctional('v-card__subtitle');
var VCardText = createSimpleFunctional('v-card__text');
var VCardTitle = createSimpleFunctional('v-card__title');

/* harmony default export */ var components_VCard = ({
  $_vuetify_subcomponents: {
    VCard: VCard_VCard,
    VCardActions: VCardActions,
    VCardSubtitle: VCardSubtitle,
    VCardText: VCardText,
    VCardTitle: VCardTitle
  }
});
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDialog/VDialog.sass
var VDialog = __webpack_require__("368e");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VThemeProvider/VThemeProvider.js


// Mixins

/* @vue/component */

/* harmony default export */ var VThemeProvider = (themeable.extend({
  name: 'v-theme-provider',
  props: {
    root: Boolean
  },
  computed: {
    isDark: function isDark() {
      return this.root ? this.rootIsDark : themeable.options.computed.isDark.call(this);
    }
  },
  render: function render() {
    /* istanbul ignore next */
    return this.$slots.default && this.$slots.default.find(function (node) {
      return !node.isComment && node.text !== ' ';
    });
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VOverlay/VOverlay.sass
var VOverlay = __webpack_require__("3c93");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VOverlay/VOverlay.js


// Styles
 // Mixins



 // Utilities


/* @vue/component */

/* harmony default export */ var VOverlay_VOverlay = (mixins_mixins(colorable, themeable, toggleable).extend({
  name: 'v-overlay',
  props: {
    absolute: Boolean,
    color: {
      type: String,
      default: '#212121'
    },
    dark: {
      type: Boolean,
      default: true
    },
    opacity: {
      type: [Number, String],
      default: 0.46
    },
    value: {
      default: true
    },
    zIndex: {
      type: [Number, String],
      default: 5
    }
  },
  computed: {
    __scrim: function __scrim() {
      var data = this.setBackgroundColor(this.color, {
        staticClass: 'v-overlay__scrim',
        style: {
          opacity: this.computedOpacity
        }
      });
      return this.$createElement('div', data);
    },
    classes: function classes() {
      return _objectSpread2({
        'v-overlay--absolute': this.absolute,
        'v-overlay--active': this.isActive
      }, this.themeClasses);
    },
    computedOpacity: function computedOpacity() {
      return Number(this.isActive ? this.opacity : 0);
    },
    styles: function styles() {
      return {
        zIndex: this.zIndex
      };
    }
  },
  methods: {
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-overlay__content'
      }, this.$slots.default);
    }
  },
  render: function render(h) {
    var children = [this.__scrim];
    if (this.isActive) children.push(this.genContent());
    return h('div', {
      staticClass: 'v-overlay',
      on: this.$listeners,
      class: this.classes,
      style: this.styles
    }, children);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VOverlay/index.js


/* harmony default export */ var components_VOverlay = (VOverlay_VOverlay);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/overlayable/index.js



// Components
 // Utilities

 // Types


/* @vue/component */

/* harmony default export */ var overlayable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend().extend({
  name: 'overlayable',
  props: {
    hideOverlay: Boolean,
    overlayColor: String,
    overlayOpacity: [Number, String]
  },
  data: function data() {
    return {
      animationFrame: 0,
      overlay: null
    };
  },
  watch: {
    hideOverlay: function hideOverlay(value) {
      if (!this.isActive) return;
      if (value) this.removeOverlay();else this.genOverlay();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },
  methods: {
    createOverlay: function createOverlay() {
      var overlay = new components_VOverlay({
        propsData: {
          absolute: this.absolute,
          value: false,
          color: this.overlayColor,
          opacity: this.overlayOpacity
        }
      });
      overlay.$mount();
      var parent = this.absolute ? this.$el.parentNode : document.querySelector('[data-app]');
      parent && parent.insertBefore(overlay.$el, parent.firstChild);
      this.overlay = overlay;
    },
    genOverlay: function genOverlay() {
      var _this = this;

      this.hideScroll();
      if (this.hideOverlay) return;
      if (!this.overlay) this.createOverlay();
      this.animationFrame = requestAnimationFrame(function () {
        if (!_this.overlay) return;

        if (_this.activeZIndex !== undefined) {
          _this.overlay.zIndex = String(_this.activeZIndex - 1);
        } else if (_this.$el) {
          _this.overlay.zIndex = getZIndex(_this.$el);
        }

        _this.overlay.value = true;
      });
      return true;
    },

    /** removeOverlay(false) will not restore the scollbar afterwards */
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      var showScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.overlay) {
        addOnceEventListener(this.overlay.$el, 'transitionend', function () {
          if (!_this2.overlay || !_this2.overlay.$el || !_this2.overlay.$el.parentNode || _this2.overlay.value || _this2.isActive) return;

          _this2.overlay.$el.parentNode.removeChild(_this2.overlay.$el);

          _this2.overlay.$destroy();

          _this2.overlay = null;
        }); // Cancel animation frame in case
        // overlay is removed before it
        // has finished its animation

        cancelAnimationFrame(this.animationFrame);
        this.overlay.value = false;
      }

      showScroll && this.showScroll();
    },
    scrollListener: function scrollListener(e) {
      if (e.type === 'keydown') {
        if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName) || // https://github.com/vuetifyjs/vuetify/issues/4715
        e.target.isContentEditable) return;
        var up = [keyCodes.up, keyCodes.pageup];
        var down = [keyCodes.down, keyCodes.pagedown];

        if (up.includes(e.keyCode)) {
          e.deltaY = -1;
        } else if (down.includes(e.keyCode)) {
          e.deltaY = 1;
        } else {
          return;
        }
      }

      if (e.target === this.overlay || e.type !== 'keydown' && e.target === document.body || this.checkPath(e)) e.preventDefault();
    },
    hasScrollbar: function hasScrollbar(el) {
      if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
      var style = window.getComputedStyle(el);
      return (['auto', 'scroll'].includes(style.overflowY) || el.tagName === 'SELECT') && el.scrollHeight > el.clientHeight || ['auto', 'scroll'].includes(style.overflowX) && el.scrollWidth > el.clientWidth;
    },
    shouldScroll: function shouldScroll(el, e) {
      if (el.hasAttribute('data-app')) return false;
      var dir = e.shiftKey || e.deltaX ? 'x' : 'y';
      var delta = dir === 'y' ? e.deltaY : e.deltaX || e.deltaY;
      var alreadyAtStart;
      var alreadyAtEnd;

      if (dir === 'y') {
        alreadyAtStart = el.scrollTop === 0;
        alreadyAtEnd = el.scrollTop + el.clientHeight === el.scrollHeight;
      } else {
        alreadyAtStart = el.scrollLeft === 0;
        alreadyAtEnd = el.scrollLeft + el.clientWidth === el.scrollWidth;
      }

      var scrollingUp = delta < 0;
      var scrollingDown = delta > 0;
      if (!alreadyAtStart && scrollingUp) return true;
      if (!alreadyAtEnd && scrollingDown) return true;

      if (alreadyAtStart || alreadyAtEnd) {
        return this.shouldScroll(el.parentNode, e);
      }

      return false;
    },
    isInside: function isInside(el, parent) {
      if (el === parent) {
        return true;
      } else if (el === null || el === document.body) {
        return false;
      } else {
        return this.isInside(el.parentNode, parent);
      }
    },
    checkPath: function checkPath(e) {
      var path = composedPath(e);

      if (e.type === 'keydown' && path[0] === document.body) {
        var dialog = this.$refs.dialog; // getSelection returns null in firefox in some edge cases, can be ignored

        var selected = window.getSelection().anchorNode;

        if (dialog && this.hasScrollbar(dialog) && this.isInside(selected, dialog)) {
          return !this.shouldScroll(dialog, e);
        }

        return true;
      }

      for (var index = 0; index < path.length; index++) {
        var el = path[index];
        if (el === document) return true;
        if (el === document.documentElement) return true;
        if (el === this.$refs.content) return true;
        if (this.hasScrollbar(el)) return !this.shouldScroll(el, e);
      }

      return true;
    },
    hideScroll: function hideScroll() {
      if (this.$vuetify.breakpoint.smAndDown) {
        document.documentElement.classList.add('overflow-y-hidden');
      } else {
        addPassiveEventListener(window, 'wheel', this.scrollListener, {
          passive: false
        });
        window.addEventListener('keydown', this.scrollListener);
      }
    },
    showScroll: function showScroll() {
      document.documentElement.classList.remove('overflow-y-hidden');
      window.removeEventListener('wheel', this.scrollListener);
      window.removeEventListener('keydown', this.scrollListener);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/returnable/index.js

/* @vue/component */

/* harmony default export */ var returnable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'returnable',
  props: {
    returnValue: null
  },
  data: function data() {
    return {
      isActive: false,
      originalValue: null
    };
  },
  watch: {
    isActive: function isActive(val) {
      if (val) {
        this.originalValue = this.returnValue;
      } else {
        this.$emit('update:return-value', this.originalValue);
      }
    }
  },
  methods: {
    save: function save(value) {
      var _this = this;

      this.originalValue = value;
      setTimeout(function () {
        _this.isActive = false;
      });
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/dom.js
/**
 * Returns:
 *  - 'null' if the node is not attached to the DOM
 *  - the root node (HTMLDocument | ShadowRoot) otherwise
 */
function attachedRoot(node) {
  /* istanbul ignore next */
  if (typeof node.getRootNode !== 'function') {
    // Shadow DOM not supported (IE11), lets find the root of this node
    while (node.parentNode) {
      node = node.parentNode;
    } // The root parent is the document if the node is attached to the DOM


    if (node !== document) return null;
    return document;
  }

  var root = node.getRootNode(); // The composed root node is the document if the node is attached to the DOM

  if (root !== document && root.getRootNode({
    composed: true
  }) !== document) return null;
  return root;
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/directives/click-outside/index.js




function defaultConditional() {
  return true;
}

function checkEvent(e, el, binding) {
  // The include element callbacks below can be expensive
  // so we should avoid calling them when we're not active.
  // Explicitly check for false to allow fallback compatibility
  // with non-toggleable components
  if (!e || checkIsActive(e, binding) === false) return false; // If we're clicking inside the shadowroot, then the app root doesn't get the same
  // level of introspection as to _what_ we're clicking. We want to check to see if
  // our target is the shadowroot parent container, and if it is, ignore.

  var root = attachedRoot(el);
  if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot && root.host === e.target) return false; // Check if additional elements were passed to be included in check
  // (click must be outside all included elements, if any)

  var elements = (_typeof(binding.value) === 'object' && binding.value.include || function () {
    return [];
  })(); // Add the root element for the component this directive was defined on


  elements.push(el); // Check if it's a click outside our elements, and then if our callback returns true.
  // Non-toggleable components should take action in their callback and return falsy.
  // Toggleable can return true if it wants to deactivate.
  // Note that, because we're in the capture phase, this callback will occur before
  // the bubbling click event on any outside elements.

  return !elements.some(function (el) {
    return el.contains(e.target);
  });
}

function checkIsActive(e, binding) {
  var isActive = _typeof(binding.value) === 'object' && binding.value.closeConditional || defaultConditional;
  return isActive(e);
}

function click_outside_directive(e, el, binding, vnode) {
  var handler = typeof binding.value === 'function' ? binding.value : binding.value.handler;
  el._clickOutside.lastMousedownWasOutside && checkEvent(e, el, binding) && setTimeout(function () {
    checkIsActive(e, binding) && handler && handler(e);
  }, 0);
}

function handleShadow(el, callback) {
  var root = attachedRoot(el);
  callback(document);

  if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot) {
    callback(root);
  }
}

var ClickOutside = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  inserted: function inserted(el, binding, vnode) {
    var onClick = function onClick(e) {
      return click_outside_directive(e, el, binding, vnode);
    };

    var onMousedown = function onMousedown(e) {
      el._clickOutside.lastMousedownWasOutside = checkEvent(e, el, binding);
    };

    handleShadow(el, function (app) {
      app.addEventListener('click', onClick, true);
      app.addEventListener('mousedown', onMousedown, true);
    });

    if (!el._clickOutside) {
      el._clickOutside = {
        lastMousedownWasOutside: true
      };
    }

    el._clickOutside[vnode.context._uid] = {
      onClick: onClick,
      onMousedown: onMousedown
    };
  },
  unbind: function unbind(el, binding, vnode) {
    if (!el._clickOutside) return;
    handleShadow(el, function (app) {
      var _el$_clickOutside;

      if (!app || !((_el$_clickOutside = el._clickOutside) != null && _el$_clickOutside[vnode.context._uid])) return;
      var _el$_clickOutside$vno = el._clickOutside[vnode.context._uid],
          onClick = _el$_clickOutside$vno.onClick,
          onMousedown = _el$_clickOutside$vno.onMousedown;
      app.removeEventListener('click', onClick, true);
      app.removeEventListener('mousedown', onMousedown, true);
    });
    delete el._clickOutside[vnode.context._uid];
  }
};
/* harmony default export */ var click_outside = (ClickOutside);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDialog/VDialog.js









// Styles
 // Components

 // Mixins







 // Directives

 // Helpers




var VDialog_baseMixins = mixins_mixins(activatable, dependent, detachable, overlayable, returnable, stackable, toggleable);
/* @vue/component */

/* harmony default export */ var VDialog_VDialog = (VDialog_baseMixins.extend({
  name: 'v-dialog',
  directives: {
    ClickOutside: click_outside
  },
  props: {
    dark: Boolean,
    disabled: Boolean,
    fullscreen: Boolean,
    light: Boolean,
    maxWidth: [String, Number],
    noClickAnimation: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    persistent: Boolean,
    retainFocus: {
      type: Boolean,
      default: true
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    },
    width: [String, Number]
  },
  data: function data() {
    return {
      activatedBy: null,
      animate: false,
      animateTimeout: -1,
      isActive: !!this.value,
      stackMinZIndex: 200,
      previousActiveElement: null
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, "v-dialog ".concat(this.contentClass).trim(), true), _defineProperty(_ref, 'v-dialog--active', this.isActive), _defineProperty(_ref, 'v-dialog--persistent', this.persistent), _defineProperty(_ref, 'v-dialog--fullscreen', this.fullscreen), _defineProperty(_ref, 'v-dialog--scrollable', this.scrollable), _defineProperty(_ref, 'v-dialog--animated', this.animate), _ref;
    },
    contentClasses: function contentClasses() {
      return {
        'v-dialog__content': true,
        'v-dialog__content--active': this.isActive
      };
    },
    hasActivator: function hasActivator() {
      return Boolean(!!this.$slots.activator || !!this.$scopedSlots.activator);
    }
  },
  watch: {
    isActive: function isActive(val) {
      if (val) {
        this.show();
        this.hideScroll();
      } else {
        var _this$previousActiveE;

        this.removeOverlay();
        this.unbind();
        (_this$previousActiveE = this.previousActiveElement) == null ? void 0 : _this$previousActiveE.focus();
      }
    },
    fullscreen: function fullscreen(val) {
      if (!this.isActive) return;

      if (val) {
        this.hideScroll();
        this.removeOverlay(false);
      } else {
        this.showScroll();
        this.genOverlay();
      }
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('full-width')) {
      removed('full-width', this);
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$nextTick(function () {
      _this.isBooted = _this.isActive;
      _this.isActive && _this.show();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') this.unbind();
  },
  methods: {
    animateClick: function animateClick() {
      var _this2 = this;

      this.animate = false; // Needed for when clicking very fast
      // outside of the dialog

      this.$nextTick(function () {
        _this2.animate = true;
        window.clearTimeout(_this2.animateTimeout);
        _this2.animateTimeout = window.setTimeout(function () {
          return _this2.animate = false;
        }, 150);
      });
    },
    closeConditional: function closeConditional(e) {
      var target = e.target; // Ignore the click if the dialog is closed or destroyed,
      // if it was on an element inside the content,
      // if it was dragged onto the overlay (#6969),
      // or if this isn't the topmost dialog (#9907)

      return !(this._isDestroyed || !this.isActive || this.$refs.content.contains(target) || this.overlay && target && !this.overlay.$el.contains(target)) && this.activeZIndex >= this.getMaxZIndex();
    },
    hideScroll: function hideScroll() {
      if (this.fullscreen) {
        document.documentElement.classList.add('overflow-y-hidden');
      } else {
        overlayable.options.methods.hideScroll.call(this);
      }
    },
    show: function show() {
      var _this3 = this;

      !this.fullscreen && !this.hideOverlay && this.genOverlay(); // Double nextTick to wait for lazy content to be generated

      this.$nextTick(function () {
        _this3.$nextTick(function () {
          if (!_this3.$refs.content.contains(document.activeElement)) {
            _this3.previousActiveElement = document.activeElement;

            _this3.$refs.content.focus();
          }

          _this3.bind();
        });
      });
    },
    bind: function bind() {
      window.addEventListener('focusin', this.onFocusin);
    },
    unbind: function unbind() {
      window.removeEventListener('focusin', this.onFocusin);
    },
    onClickOutside: function onClickOutside(e) {
      this.$emit('click:outside', e);

      if (this.persistent) {
        this.noClickAnimation || this.animateClick();
      } else {
        this.isActive = false;
      }
    },
    onKeydown: function onKeydown(e) {
      if (e.keyCode === keyCodes.esc && !this.getOpenDependents().length) {
        if (!this.persistent) {
          this.isActive = false;
          var activator = this.getActivator();
          this.$nextTick(function () {
            return activator && activator.focus();
          });
        } else if (!this.noClickAnimation) {
          this.animateClick();
        }
      }

      this.$emit('keydown', e);
    },
    // On focus change, wrap focus to stay inside the dialog
    // https://github.com/vuetifyjs/vuetify/issues/6892
    onFocusin: function onFocusin(e) {
      if (!e || !this.retainFocus) return;
      var target = e.target;

      if (!!target && // It isn't the document or the dialog body
      ![document, this.$refs.content].includes(target) && // It isn't inside the dialog body
      !this.$refs.content.contains(target) && // We're the topmost dialog
      this.activeZIndex >= this.getMaxZIndex() && // It isn't inside a dependent element (like a menu)
      !this.getOpenDependentElements().some(function (el) {
        return el.contains(target);
      }) // So we must have focused something outside the dialog and its children
      ) {
        // Find and focus the first available element inside the dialog
        var focusable = this.$refs.content.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

        var el = _toConsumableArray(focusable).find(function (el) {
          return !el.hasAttribute('disabled');
        });

        el && el.focus();
      }
    },
    genContent: function genContent() {
      var _this4 = this;

      return this.showLazyContent(function () {
        return [_this4.$createElement(VThemeProvider, {
          props: {
            root: true,
            light: _this4.light,
            dark: _this4.dark
          }
        }, [_this4.$createElement('div', {
          class: _this4.contentClasses,
          attrs: _objectSpread2({
            role: 'document',
            tabindex: _this4.isActive ? 0 : undefined
          }, _this4.getScopeIdAttrs()),
          on: {
            keydown: _this4.onKeydown
          },
          style: {
            zIndex: _this4.activeZIndex
          },
          ref: 'content'
        }, [_this4.genTransition()])])];
      });
    },
    genTransition: function genTransition() {
      var content = this.genInnerContent();
      if (!this.transition) return content;
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin,
          appear: true
        }
      }, [content]);
    },
    genInnerContent: function genInnerContent() {
      var data = {
        class: this.classes,
        ref: 'dialog',
        directives: [{
          name: 'click-outside',
          value: {
            handler: this.onClickOutside,
            closeConditional: this.closeConditional,
            include: this.getOpenDependentElements
          }
        }, {
          name: 'show',
          value: this.isActive
        }],
        style: {
          transformOrigin: this.origin
        }
      };

      if (!this.fullscreen) {
        data.style = _objectSpread2(_objectSpread2({}, data.style), {}, {
          maxWidth: convertToUnit(this.maxWidth),
          width: convertToUnit(this.width)
        });
      }

      return this.$createElement('div', data, this.getContentSlot());
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-dialog__container',
      class: {
        'v-dialog__container--attached': this.attach === '' || this.attach === true || this.attach === 'attach'
      },
      attrs: {
        role: 'dialog'
      }
    }, [this.genActivator(), this.genContent()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDivider/VDivider.sass
var VDivider = __webpack_require__("8ce9");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDivider/VDivider.js

// Styles
 // Mixins


/* harmony default export */ var VDivider_VDivider = (themeable.extend({
  name: 'v-divider',
  props: {
    inset: Boolean,
    vertical: Boolean
  },
  render: function render(h) {
    // WAI-ARIA attributes
    var orientation;

    if (!this.$attrs.role || this.$attrs.role === 'separator') {
      orientation = this.vertical ? 'vertical' : 'horizontal';
    }

    return h('hr', {
      class: _objectSpread2({
        'v-divider': true,
        'v-divider--inset': this.inset,
        'v-divider--vertical': this.vertical
      }, this.themeClasses),
      attrs: _objectSpread2({
        role: 'separator',
        'aria-orientation': orientation
      }, this.$attrs),
      on: this.$listeners
    });
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VHover/VHover.js
// Mixins

 // Utilities



/* harmony default export */ var VHover = (mixins_mixins(delayable, toggleable
/* @vue/component */
).extend({
  name: 'v-hover',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: undefined
    }
  },
  methods: {
    onMouseEnter: function onMouseEnter() {
      this.runDelay('open');
    },
    onMouseLeave: function onMouseLeave() {
      this.runDelay('close');
    }
  },
  render: function render() {
    if (!this.$scopedSlots.default && this.value === undefined) {
      consoleWarn('v-hover is missing a default scopedSlot or bound value', this);
      return null;
    }

    var element;
    /* istanbul ignore else */

    if (this.$scopedSlots.default) {
      element = this.$scopedSlots.default({
        hover: this.isActive
      });
    }

    if (Array.isArray(element) && element.length === 1) {
      element = element[0];
    }

    if (!element || Array.isArray(element) || !element.tag) {
      consoleWarn('v-hover should only contain a single element', this);
      return element;
    }

    if (!this.disabled) {
      element.data = element.data || {};

      this._g(element.data, {
        mouseenter: this.onMouseEnter,
        mouseleave: this.onMouseLeave
      });
    }

    return element;
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VImg/VImg.sass
var VImg = __webpack_require__("8efc");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VResponsive/VResponsive.sass
var VResponsive = __webpack_require__("36a7");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VResponsive/VResponsive.js

 // Mixins

 // Utils


/* @vue/component */

/* harmony default export */ var VResponsive_VResponsive = (mixins_mixins(measurable).extend({
  name: 'v-responsive',
  props: {
    aspectRatio: [String, Number],
    contentClass: String
  },
  computed: {
    computedAspectRatio: function computedAspectRatio() {
      return Number(this.aspectRatio);
    },
    aspectStyle: function aspectStyle() {
      return this.computedAspectRatio ? {
        paddingBottom: 1 / this.computedAspectRatio * 100 + '%'
      } : undefined;
    },
    __cachedSizer: function __cachedSizer() {
      if (!this.aspectStyle) return [];
      return this.$createElement('div', {
        style: this.aspectStyle,
        staticClass: 'v-responsive__sizer'
      });
    }
  },
  methods: {
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-responsive__content',
        class: this.contentClass
      }, this.$slots.default);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-responsive',
      style: this.measurableStyles,
      on: this.$listeners
    }, [this.__cachedSizer, this.genContent()]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VResponsive/index.js


/* harmony default export */ var components_VResponsive = (VResponsive_VResponsive);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VImg/VImg.js





// Styles
 // Directives

 // Components

 // Mixins

 // Utils




var hasIntersect = typeof window !== 'undefined' && 'IntersectionObserver' in window;
/* @vue/component */

/* harmony default export */ var VImg_VImg = (mixins_mixins(components_VResponsive, themeable).extend({
  name: 'v-img',
  directives: {
    intersect: intersect
  },
  props: {
    alt: String,
    contain: Boolean,
    eager: Boolean,
    gradient: String,
    lazySrc: String,
    options: {
      type: Object,
      // For more information on types, navigate to:
      // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      default: function _default() {
        return {
          root: undefined,
          rootMargin: undefined,
          threshold: undefined
        };
      }
    },
    position: {
      type: String,
      default: 'center center'
    },
    sizes: String,
    src: {
      type: [String, Object],
      default: ''
    },
    srcset: String,
    transition: {
      type: [Boolean, String],
      default: 'fade-transition'
    }
  },
  data: function data() {
    return {
      currentSrc: '',
      image: null,
      isLoading: true,
      calculatedAspectRatio: undefined,
      naturalWidth: undefined,
      hasError: false
    };
  },
  computed: {
    computedAspectRatio: function computedAspectRatio() {
      return Number(this.normalisedSrc.aspect || this.calculatedAspectRatio);
    },
    normalisedSrc: function normalisedSrc() {
      return this.src && _typeof(this.src) === 'object' ? {
        src: this.src.src,
        srcset: this.srcset || this.src.srcset,
        lazySrc: this.lazySrc || this.src.lazySrc,
        aspect: Number(this.aspectRatio || this.src.aspect)
      } : {
        src: this.src,
        srcset: this.srcset,
        lazySrc: this.lazySrc,
        aspect: Number(this.aspectRatio || 0)
      };
    },
    __cachedImage: function __cachedImage() {
      if (!(this.normalisedSrc.src || this.normalisedSrc.lazySrc || this.gradient)) return [];
      var backgroundImage = [];
      var src = this.isLoading ? this.normalisedSrc.lazySrc : this.currentSrc;
      if (this.gradient) backgroundImage.push("linear-gradient(".concat(this.gradient, ")"));
      if (src) backgroundImage.push("url(\"".concat(src, "\")"));
      var image = this.$createElement('div', {
        staticClass: 'v-image__image',
        class: {
          'v-image__image--preload': this.isLoading,
          'v-image__image--contain': this.contain,
          'v-image__image--cover': !this.contain
        },
        style: {
          backgroundImage: backgroundImage.join(', '),
          backgroundPosition: this.position
        },
        key: +this.isLoading
      });
      /* istanbul ignore if */

      if (!this.transition) return image;
      return this.$createElement('transition', {
        attrs: {
          name: this.transition,
          mode: 'in-out'
        }
      }, [image]);
    }
  },
  watch: {
    src: function src() {
      // Force re-init when src changes
      if (!this.isLoading) this.init(undefined, undefined, true);else this.loadImage();
    },
    '$vuetify.breakpoint.width': 'getSrc'
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init(entries, observer, isIntersecting) {
      // If the current browser supports the intersection
      // observer api, the image is not observable, and
      // the eager prop isn't being used, do not load
      if (hasIntersect && !isIntersecting && !this.eager) return;

      if (this.normalisedSrc.lazySrc) {
        var lazyImg = new Image();
        lazyImg.src = this.normalisedSrc.lazySrc;
        this.pollForSize(lazyImg, null);
      }
      /* istanbul ignore else */


      if (this.normalisedSrc.src) this.loadImage();
    },
    onLoad: function onLoad() {
      this.getSrc();
      this.isLoading = false;
      this.$emit('load', this.src);

      if (this.image && (this.normalisedSrc.src.endsWith('.svg') || this.normalisedSrc.src.startsWith('data:image/svg+xml'))) {
        if (this.image.naturalHeight && this.image.naturalWidth) {
          this.naturalWidth = this.image.naturalWidth;
          this.calculatedAspectRatio = this.image.naturalWidth / this.image.naturalHeight;
        } else {
          this.calculatedAspectRatio = 1;
        }
      }
    },
    onError: function onError() {
      this.hasError = true;
      this.$emit('error', this.src);
    },
    getSrc: function getSrc() {
      /* istanbul ignore else */
      if (this.image) this.currentSrc = this.image.currentSrc || this.image.src;
    },
    loadImage: function loadImage() {
      var _this = this;

      var image = new Image();
      this.image = image;

      image.onload = function () {
        /* istanbul ignore if */
        if (image.decode) {
          image.decode().catch(function (err) {
            consoleWarn("Failed to decode image, trying to render anyway\n\n" + "src: ".concat(_this.normalisedSrc.src) + (err.message ? "\nOriginal error: ".concat(err.message) : ''), _this);
          }).then(_this.onLoad);
        } else {
          _this.onLoad();
        }
      };

      image.onerror = this.onError;
      this.hasError = false;
      this.sizes && (image.sizes = this.sizes);
      this.normalisedSrc.srcset && (image.srcset = this.normalisedSrc.srcset);
      image.src = this.normalisedSrc.src;
      this.$emit('loadstart', this.normalisedSrc.src);
      this.aspectRatio || this.pollForSize(image);
      this.getSrc();
    },
    pollForSize: function pollForSize(img) {
      var _this2 = this;

      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

      var poll = function poll() {
        var naturalHeight = img.naturalHeight,
            naturalWidth = img.naturalWidth;

        if (naturalHeight || naturalWidth) {
          _this2.naturalWidth = naturalWidth;
          _this2.calculatedAspectRatio = naturalWidth / naturalHeight;
        } else if (!img.complete && _this2.isLoading && !_this2.hasError && timeout != null) {
          setTimeout(poll, timeout);
        }
      };

      poll();
    },
    genContent: function genContent() {
      var content = components_VResponsive.options.methods.genContent.call(this);

      if (this.naturalWidth) {
        this._b(content.data, 'div', {
          style: {
            width: "".concat(this.naturalWidth, "px")
          }
        });
      }

      return content;
    },
    __genPlaceholder: function __genPlaceholder() {
      if (this.$slots.placeholder) {
        var placeholder = this.isLoading ? [this.$createElement('div', {
          staticClass: 'v-image__placeholder'
        }, this.$slots.placeholder)] : [];
        if (!this.transition) return placeholder[0];
        return this.$createElement('transition', {
          props: {
            appear: true,
            name: this.transition
          }
        }, placeholder);
      }
    }
  },
  render: function render(h) {
    var node = components_VResponsive.options.render.call(this, h);
    var data = mergeData(node.data, {
      staticClass: 'v-image',
      attrs: {
        'aria-label': this.alt,
        role: this.alt ? 'img' : undefined
      },
      class: this.themeClasses,
      // Only load intersect directive if it
      // will work in the current browser.
      directives: hasIntersect ? [{
        name: 'intersect',
        modifiers: {
          once: true
        },
        value: {
          handler: this.init,
          options: this.options
        }
      }] : undefined
    });
    node.children = [this.__cachedSizer, this.__cachedImage, this.__genPlaceholder(), this.genContent()];
    return h(node.tag, data, node.children);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VList/VList.sass
var VList = __webpack_require__("3ad0");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VList.js






// Styles
 // Components


/* @vue/component */

/* harmony default export */ var VList_VList = (VSheet_VSheet.extend().extend({
  name: 'v-list',
  provide: function provide() {
    return {
      isInList: true,
      list: this
    };
  },
  inject: {
    isInMenu: {
      default: false
    },
    isInNav: {
      default: false
    }
  },
  props: {
    dense: Boolean,
    disabled: Boolean,
    expand: Boolean,
    flat: Boolean,
    nav: Boolean,
    rounded: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },
  data: function data() {
    return {
      groups: []
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, VSheet_VSheet.options.computed.classes.call(this)), {}, {
        'v-list--dense': this.dense,
        'v-list--disabled': this.disabled,
        'v-list--flat': this.flat,
        'v-list--nav': this.nav,
        'v-list--rounded': this.rounded,
        'v-list--subheader': this.subheader,
        'v-list--two-line': this.twoLine,
        'v-list--three-line': this.threeLine
      });
    }
  },
  methods: {
    register: function register(content) {
      this.groups.push(content);
    },
    unregister: function unregister(content) {
      var index = this.groups.findIndex(function (g) {
        return g._uid === content._uid;
      });
      if (index > -1) this.groups.splice(index, 1);
    },
    listClick: function listClick(uid) {
      if (this.expand) return;

      var _iterator = _createForOfIteratorHelper(this.groups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          group.toggle(uid);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  },
  render: function render(h) {
    var data = {
      staticClass: 'v-list',
      class: this.classes,
      style: this.styles,
      attrs: _objectSpread2({
        role: this.isInNav || this.isInMenu ? undefined : 'list'
      }, this.attrs$)
    };
    return h(this.tag, this.setBackgroundColor(this.color, data), [this.$slots.default]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VList/VListItem.sass
var VListItem = __webpack_require__("61d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListItem.js

// Styles
 // Mixins





 // Directives

 // Utilities


 // Types


var VListItem_baseMixins = mixins_mixins(colorable, routable, themeable, groupable_factory('listItemGroup'), factory('inputValue'));
/* @vue/component */

/* harmony default export */ var VList_VListItem = (VListItem_baseMixins.extend().extend({
  name: 'v-list-item',
  directives: {
    Ripple: ripple
  },
  inject: {
    isInGroup: {
      default: false
    },
    isInList: {
      default: false
    },
    isInMenu: {
      default: false
    },
    isInNav: {
      default: false
    }
  },
  inheritAttrs: false,
  props: {
    activeClass: {
      type: String,
      default: function _default() {
        if (!this.listItemGroup) return '';
        return this.listItemGroup.activeClass;
      }
    },
    dense: Boolean,
    inactive: Boolean,
    link: Boolean,
    selectable: {
      type: Boolean
    },
    tag: {
      type: String,
      default: 'div'
    },
    threeLine: Boolean,
    twoLine: Boolean,
    value: null
  },
  data: function data() {
    return {
      proxyClass: 'v-list-item--active'
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({
        'v-list-item': true
      }, routable.options.computed.classes.call(this)), {}, {
        'v-list-item--dense': this.dense,
        'v-list-item--disabled': this.disabled,
        'v-list-item--link': this.isClickable && !this.inactive,
        'v-list-item--selectable': this.selectable,
        'v-list-item--three-line': this.threeLine,
        'v-list-item--two-line': this.twoLine
      }, this.themeClasses);
    },
    isClickable: function isClickable() {
      return Boolean(routable.options.computed.isClickable.call(this) || this.listItemGroup);
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('avatar')) {
      removed('avatar', this);
    }
  },
  methods: {
    click: function click(e) {
      if (e.detail) this.$el.blur();
      this.$emit('click', e);
      this.to || this.toggle();
    },
    genAttrs: function genAttrs() {
      var attrs = _objectSpread2({
        'aria-disabled': this.disabled ? true : undefined,
        tabindex: this.isClickable && !this.disabled ? 0 : -1
      }, this.$attrs);

      if (this.$attrs.hasOwnProperty('role')) {// do nothing, role already provided
      } else if (this.isInNav) {// do nothing, role is inherit
      } else if (this.isInGroup) {
        attrs.role = 'option';
        attrs['aria-selected'] = String(this.isActive);
      } else if (this.isInMenu) {
        attrs.role = this.isClickable ? 'menuitem' : undefined;
        attrs.id = attrs.id || "list-item-".concat(this._uid);
      } else if (this.isInList) {
        attrs.role = 'listitem';
      }

      return attrs;
    },
    toggle: function toggle() {
      if (this.to && this.inputValue === undefined) {
        this.isActive = !this.isActive;
      }

      this.$emit('change');
    }
  },
  render: function render(h) {
    var _this = this;

    var _this$generateRouteLi = this.generateRouteLink(),
        tag = _this$generateRouteLi.tag,
        data = _this$generateRouteLi.data;

    data.attrs = _objectSpread2(_objectSpread2({}, data.attrs), this.genAttrs());
    data[this.to ? 'nativeOn' : 'on'] = _objectSpread2(_objectSpread2({}, data[this.to ? 'nativeOn' : 'on']), {}, {
      keydown: function keydown(e) {
        /* istanbul ignore else */
        if (e.keyCode === keyCodes.enter) _this.click(e);

        _this.$emit('keydown', e);
      }
    });
    if (this.inactive) tag = 'div';

    if (this.inactive && this.to) {
      data.on = data.nativeOn;
      delete data.nativeOn;
    }

    var children = this.$scopedSlots.default ? this.$scopedSlots.default({
      active: this.isActive,
      toggle: this.toggle
    }) : this.$slots.default;
    return h(tag, this.isActive ? this.setTextColor(this.color, data) : data, children);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VAvatar/VAvatar.sass
var VAvatar = __webpack_require__("3408");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VAvatar/VAvatar.js


 // Mixins



 // Utilities



/* harmony default export */ var VAvatar_VAvatar = (mixins_mixins(colorable, measurable, roundable).extend({
  name: 'v-avatar',
  props: {
    left: Boolean,
    right: Boolean,
    size: {
      type: [Number, String],
      default: 48
    }
  },
  computed: {
    classes: function classes() {
      return _objectSpread2({
        'v-avatar--left': this.left,
        'v-avatar--right': this.right
      }, this.roundedClasses);
    },
    styles: function styles() {
      return _objectSpread2({
        height: convertToUnit(this.size),
        minWidth: convertToUnit(this.size),
        width: convertToUnit(this.size)
      }, this.measurableStyles);
    }
  },
  render: function render(h) {
    var data = {
      staticClass: 'v-avatar',
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    };
    return h('div', this.setBackgroundColor(this.color, data), this.$slots.default);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VAvatar/index.js


/* harmony default export */ var components_VAvatar = (VAvatar_VAvatar);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListItemAvatar.js


// Components

/* @vue/component */

/* harmony default export */ var VListItemAvatar = (components_VAvatar.extend({
  name: 'v-list-item-avatar',
  props: {
    horizontal: Boolean,
    size: {
      type: [Number, String],
      default: 40
    }
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({
        'v-list-item__avatar--horizontal': this.horizontal
      }, components_VAvatar.options.computed.classes.call(this)), {}, {
        'v-avatar--tile': this.tile || this.horizontal
      });
    }
  },
  render: function render(h) {
    var render = components_VAvatar.options.render.call(this, h);
    render.data = render.data || {};
    render.data.staticClass += ' v-list-item__avatar';
    return render;
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__("c607");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__("2c3e");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VList/VListGroup.sass
var VListGroup = __webpack_require__("db42");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js


/* harmony default export */ var components_VIcon = (components_VIcon_VIcon);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListItemIcon.js

// Types

/* @vue/component */

/* harmony default export */ var VListItemIcon = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-list-item-icon',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;
    data.staticClass = "v-list-item__icon ".concat(data.staticClass || '').trim();
    return h('div', data, children);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListGroup.js








// Styles
 // Components



 // Mixins





 // Directives

 // Transitions

 // Utils



var VListGroup_baseMixins = mixins_mixins(binds_attrs, bootable, colorable, inject('list'), toggleable);
/* harmony default export */ var VList_VListGroup = (VListGroup_baseMixins.extend().extend({
  name: 'v-list-group',
  directives: {
    ripple: ripple
  },
  props: {
    activeClass: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: '$expand'
    },
    color: {
      type: String,
      default: 'primary'
    },
    disabled: Boolean,
    group: [String, RegExp],
    noAction: Boolean,
    prependIcon: String,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    subGroup: Boolean
  },
  computed: {
    classes: function classes() {
      return {
        'v-list-group--active': this.isActive,
        'v-list-group--disabled': this.disabled,
        'v-list-group--no-action': this.noAction,
        'v-list-group--sub-group': this.subGroup
      };
    }
  },
  watch: {
    isActive: function isActive(val) {
      /* istanbul ignore else */
      if (!this.subGroup && val) {
        this.list && this.list.listClick(this._uid);
      }
    },
    $route: 'onRouteChange'
  },
  created: function created() {
    this.list && this.list.register(this);

    if (this.group && this.$route && this.value == null) {
      this.isActive = this.matchRoute(this.$route.path);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.list && this.list.unregister(this);
  },
  methods: {
    click: function click(e) {
      var _this = this;

      if (this.disabled) return;
      this.isBooted = true;
      this.$emit('click', e);
      this.$nextTick(function () {
        return _this.isActive = !_this.isActive;
      });
    },
    genIcon: function genIcon(icon) {
      return this.$createElement(components_VIcon, icon);
    },
    genAppendIcon: function genAppendIcon() {
      var icon = !this.subGroup ? this.appendIcon : false;
      if (!icon && !this.$slots.appendIcon) return null;
      return this.$createElement(VListItemIcon, {
        staticClass: 'v-list-group__header__append-icon'
      }, [this.$slots.appendIcon || this.genIcon(icon)]);
    },
    genHeader: function genHeader() {
      return this.$createElement(VList_VListItem, {
        staticClass: 'v-list-group__header',
        attrs: {
          'aria-expanded': String(this.isActive),
          role: 'button'
        },
        class: _defineProperty({}, this.activeClass, this.isActive),
        props: {
          inputValue: this.isActive
        },
        directives: [{
          name: 'ripple',
          value: this.ripple
        }],
        on: _objectSpread2(_objectSpread2({}, this.listeners$), {}, {
          click: this.click
        })
      }, [this.genPrependIcon(), this.$slots.activator, this.genAppendIcon()]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.showLazyContent(function () {
        return [_this2.$createElement('div', {
          staticClass: 'v-list-group__items',
          directives: [{
            name: 'show',
            value: _this2.isActive
          }]
        }, getSlot(_this2))];
      });
    },
    genPrependIcon: function genPrependIcon() {
      var icon = this.subGroup && this.prependIcon == null ? '$subgroup' : this.prependIcon;
      if (!icon && !this.$slots.prependIcon) return null;
      return this.$createElement(VListItemIcon, {
        staticClass: 'v-list-group__header__prepend-icon'
      }, [this.$slots.prependIcon || this.genIcon(icon)]);
    },
    onRouteChange: function onRouteChange(to) {
      /* istanbul ignore if */
      if (!this.group) return;
      var isActive = this.matchRoute(to.path);
      /* istanbul ignore else */

      if (isActive && this.isActive !== isActive) {
        this.list && this.list.listClick(this._uid);
      }

      this.isActive = isActive;
    },
    toggle: function toggle(uid) {
      var _this3 = this;

      var isActive = this._uid === uid;
      if (isActive) this.isBooted = true;
      this.$nextTick(function () {
        return _this3.isActive = isActive;
      });
    },
    matchRoute: function matchRoute(to) {
      return to.match(this.group) !== null;
    }
  },
  render: function render(h) {
    return h('div', this.setTextColor(this.isActive && this.color, {
      staticClass: 'v-list-group',
      class: this.classes
    }), [this.genHeader(), h(VExpandTransition, this.genItems())]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VList/VListItemGroup.sass
var VListItemGroup = __webpack_require__("899c");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VItemGroup/VItemGroup.sass
var VItemGroup = __webpack_require__("166a");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/comparable/index.js


/* harmony default export */ var comparable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'comparable',
  props: {
    valueComparator: {
      type: Function,
      default: deepEqual
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VItemGroup/VItemGroup.js









// Styles
 // Mixins



 // Utilities



var BaseItemGroup = mixins_mixins(comparable, proxyable, themeable).extend({
  name: 'base-item-group',
  props: {
    activeClass: {
      type: String,
      default: 'v-item--active'
    },
    mandatory: Boolean,
    max: {
      type: [Number, String],
      default: null
    },
    multiple: Boolean,
    tag: {
      type: String,
      default: 'div'
    }
  },
  data: function data() {
    return {
      // As long as a value is defined, show it
      // Otherwise, check if multiple
      // to determine which default to provide
      internalLazyValue: this.value !== undefined ? this.value : this.multiple ? [] : undefined,
      items: []
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2({
        'v-item-group': true
      }, this.themeClasses);
    },
    selectedIndex: function selectedIndex() {
      return this.selectedItem && this.items.indexOf(this.selectedItem) || -1;
    },
    selectedItem: function selectedItem() {
      if (this.multiple) return undefined;
      return this.selectedItems[0];
    },
    selectedItems: function selectedItems() {
      var _this = this;

      return this.items.filter(function (item, index) {
        return _this.toggleMethod(_this.getValue(item, index));
      });
    },
    selectedValues: function selectedValues() {
      if (this.internalValue == null) return [];
      return Array.isArray(this.internalValue) ? this.internalValue : [this.internalValue];
    },
    toggleMethod: function toggleMethod() {
      var _this2 = this;

      if (!this.multiple) {
        return function (v) {
          return _this2.valueComparator(_this2.internalValue, v);
        };
      }

      var internalValue = this.internalValue;

      if (Array.isArray(internalValue)) {
        return function (v) {
          return internalValue.some(function (intern) {
            return _this2.valueComparator(intern, v);
          });
        };
      }

      return function () {
        return false;
      };
    }
  },
  watch: {
    internalValue: 'updateItemsState',
    items: 'updateItemsState'
  },
  created: function created() {
    if (this.multiple && !Array.isArray(this.internalValue)) {
      consoleWarn('Model must be bound to an array if the multiple property is true.', this);
    }
  },
  methods: {
    genData: function genData() {
      return {
        class: this.classes
      };
    },
    getValue: function getValue(item, i) {
      return item.value === undefined ? i : item.value;
    },
    onClick: function onClick(item) {
      this.updateInternalValue(this.getValue(item, this.items.indexOf(item)));
    },
    register: function register(item) {
      var _this3 = this;

      var index = this.items.push(item) - 1;
      item.$on('change', function () {
        return _this3.onClick(item);
      }); // If no value provided and mandatory,
      // assign first registered item

      if (this.mandatory && !this.selectedValues.length) {
        this.updateMandatory();
      }

      this.updateItem(item, index);
    },
    unregister: function unregister(item) {
      if (this._isDestroyed) return;
      var index = this.items.indexOf(item);
      var value = this.getValue(item, index);
      this.items.splice(index, 1);
      var valueIndex = this.selectedValues.indexOf(value); // Items is not selected, do nothing

      if (valueIndex < 0) return; // If not mandatory, use regular update process

      if (!this.mandatory) {
        return this.updateInternalValue(value);
      } // Remove the value


      if (this.multiple && Array.isArray(this.internalValue)) {
        this.internalValue = this.internalValue.filter(function (v) {
          return v !== value;
        });
      } else {
        this.internalValue = undefined;
      } // If mandatory and we have no selection
      // add the last item as value

      /* istanbul ignore else */


      if (!this.selectedItems.length) {
        this.updateMandatory(true);
      }
    },
    updateItem: function updateItem(item, index) {
      var value = this.getValue(item, index);
      item.isActive = this.toggleMethod(value);
    },
    // https://github.com/vuetifyjs/vuetify/issues/5352
    updateItemsState: function updateItemsState() {
      var _this4 = this;

      this.$nextTick(function () {
        if (_this4.mandatory && !_this4.selectedItems.length) {
          return _this4.updateMandatory();
        } // TODO: Make this smarter so it
        // doesn't have to iterate every
        // child in an update


        _this4.items.forEach(_this4.updateItem);
      });
    },
    updateInternalValue: function updateInternalValue(value) {
      this.multiple ? this.updateMultiple(value) : this.updateSingle(value);
    },
    updateMandatory: function updateMandatory(last) {
      if (!this.items.length) return;
      var items = this.items.slice();
      if (last) items.reverse();
      var item = items.find(function (item) {
        return !item.disabled;
      }); // If no tabs are available
      // aborts mandatory value

      if (!item) return;
      var index = this.items.indexOf(item);
      this.updateInternalValue(this.getValue(item, index));
    },
    updateMultiple: function updateMultiple(value) {
      var defaultValue = Array.isArray(this.internalValue) ? this.internalValue : [];
      var internalValue = defaultValue.slice();
      var index = internalValue.findIndex(function (val) {
        return val === value;
      });
      if (this.mandatory && // Item already exists
      index > -1 && // value would be reduced below min
      internalValue.length - 1 < 1) return;
      if ( // Max is set
      this.max != null && // Item doesn't exist
      index < 0 && // value would be increased above max
      internalValue.length + 1 > this.max) return;
      index > -1 ? internalValue.splice(index, 1) : internalValue.push(value);
      this.internalValue = internalValue;
    },
    updateSingle: function updateSingle(value) {
      var isSame = value === this.internalValue;
      if (this.mandatory && isSame) return;
      this.internalValue = isSame ? undefined : value;
    }
  },
  render: function render(h) {
    return h(this.tag, this.genData(), this.$slots.default);
  }
});
/* harmony default export */ var VItemGroup_VItemGroup = (BaseItemGroup.extend({
  name: 'v-item-group',
  provide: function provide() {
    return {
      itemGroup: this
    };
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListItemGroup.js

// Styles
 // Extensions

 // Mixins

 // Utilities


/* harmony default export */ var VList_VListItemGroup = (mixins_mixins(BaseItemGroup, colorable).extend({
  name: 'v-list-item-group',
  provide: function provide() {
    return {
      isInGroup: true,
      listItemGroup: this
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, BaseItemGroup.options.computed.classes.call(this)), {}, {
        'v-list-item-group': true
      });
    }
  },
  methods: {
    genData: function genData() {
      return this.setTextColor(this.color, _objectSpread2(_objectSpread2({}, BaseItemGroup.options.methods.genData.call(this)), {}, {
        attrs: {
          role: 'listbox'
        }
      }));
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListItemAction.js


// Types

/* @vue/component */

/* harmony default export */ var VListItemAction = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-list-item-action',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === void 0 ? [] : _ref$children;
    data.staticClass = data.staticClass ? "v-list-item__action ".concat(data.staticClass) : 'v-list-item__action';
    var filteredChild = children.filter(function (VNode) {
      return VNode.isComment === false && VNode.text !== ' ';
    });
    if (filteredChild.length > 1) data.staticClass += ' v-list-item__action--stack';
    return h('div', data, children);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/index.js








var VListItemActionText = createSimpleFunctional('v-list-item__action-text', 'span');
var VListItemContent = createSimpleFunctional('v-list-item__content', 'div');
var VListItemTitle = createSimpleFunctional('v-list-item__title', 'div');
var VListItemSubtitle = createSimpleFunctional('v-list-item__subtitle', 'div');

/* harmony default export */ var components_VList = ({
  $_vuetify_subcomponents: {
    VList: VList_VList,
    VListGroup: VList_VListGroup,
    VListItem: VList_VListItem,
    VListItemAction: VListItemAction,
    VListItemActionText: VListItemActionText,
    VListItemAvatar: VListItemAvatar,
    VListItemContent: VListItemContent,
    VListItemGroup: VList_VListItemGroup,
    VListItemIcon: VListItemIcon,
    VListItemSubtitle: VListItemSubtitle,
    VListItemTitle: VListItemTitle
  }
});
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VMenu/VMenu.sass
var VMenu = __webpack_require__("ee6f");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/directives/resize/index.js
function resize_inserted(el, binding, vnode) {
  var callback = binding.value;
  var options = binding.options || {
    passive: true
  };
  window.addEventListener('resize', callback, options);
  el._onResize = Object(el._onResize);
  el._onResize[vnode.context._uid] = {
    callback: callback,
    options: options
  };

  if (!binding.modifiers || !binding.modifiers.quiet) {
    callback();
  }
}

function resize_unbind(el, binding, vnode) {
  var _el$_onResize;

  if (!((_el$_onResize = el._onResize) != null && _el$_onResize[vnode.context._uid])) return;
  var _el$_onResize$vnode$c = el._onResize[vnode.context._uid],
      callback = _el$_onResize$vnode$c.callback,
      options = _el$_onResize$vnode$c.options;
  window.removeEventListener('resize', callback, options);
  delete el._onResize[vnode.context._uid];
}

var Resize = {
  inserted: resize_inserted,
  unbind: resize_unbind
};
/* harmony default export */ var resize = (Resize);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VMenu/VMenu.js












// Styles
 // Components

 // Mixins








 // Directives


 // Utilities





var VMenu_baseMixins = mixins_mixins(dependent, delayable, menuable, returnable, roundable, toggleable, themeable);
/* @vue/component */

/* harmony default export */ var VMenu_VMenu = (VMenu_baseMixins.extend({
  name: 'v-menu',
  directives: {
    ClickOutside: click_outside,
    Resize: resize
  },
  provide: function provide() {
    return {
      isInMenu: true,
      // Pass theme through to default slot
      theme: this.theme
    };
  },
  props: {
    auto: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    disableKeys: Boolean,
    maxHeight: {
      type: [Number, String],
      default: 'auto'
    },
    offsetX: Boolean,
    offsetY: Boolean,
    openOnHover: Boolean,
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: [Boolean, String],
      default: 'v-menu-transition'
    }
  },
  data: function data() {
    return {
      calculatedTopAuto: 0,
      defaultOffset: 8,
      hasJustFocused: false,
      listIndex: -1,
      resizeTimeout: 0,
      selectedIndex: null,
      tiles: []
    };
  },
  computed: {
    activeTile: function activeTile() {
      return this.tiles[this.listIndex];
    },
    calculatedLeft: function calculatedLeft() {
      var menuWidth = Math.max(this.dimensions.content.width, parseFloat(this.calculatedMinWidth));
      if (!this.auto) return this.calcLeft(menuWidth) || '0';
      return convertToUnit(this.calcXOverflow(this.calcLeftAuto(), menuWidth)) || '0';
    },
    calculatedMaxHeight: function calculatedMaxHeight() {
      var height = this.auto ? '200px' : convertToUnit(this.maxHeight);
      return height || '0';
    },
    calculatedMaxWidth: function calculatedMaxWidth() {
      return convertToUnit(this.maxWidth) || '0';
    },
    calculatedMinWidth: function calculatedMinWidth() {
      if (this.minWidth) {
        return convertToUnit(this.minWidth) || '0';
      }

      var minWidth = Math.min(this.dimensions.activator.width + Number(this.nudgeWidth) + (this.auto ? 16 : 0), Math.max(this.pageWidth - 24, 0));
      var calculatedMaxWidth = isNaN(parseInt(this.calculatedMaxWidth)) ? minWidth : parseInt(this.calculatedMaxWidth);
      return convertToUnit(Math.min(calculatedMaxWidth, minWidth)) || '0';
    },
    calculatedTop: function calculatedTop() {
      var top = !this.auto ? this.calcTop() : convertToUnit(this.calcYOverflow(this.calculatedTopAuto));
      return top || '0';
    },
    hasClickableTiles: function hasClickableTiles() {
      return Boolean(this.tiles.find(function (tile) {
        return tile.tabIndex > -1;
      }));
    },
    styles: function styles() {
      return {
        maxHeight: this.calculatedMaxHeight,
        minWidth: this.calculatedMinWidth,
        maxWidth: this.calculatedMaxWidth,
        top: this.calculatedTop,
        left: this.calculatedLeft,
        transformOrigin: this.origin,
        zIndex: this.zIndex || this.activeZIndex
      };
    }
  },
  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    isContentActive: function isContentActive(val) {
      this.hasJustFocused = val;
    },
    listIndex: function listIndex(next, prev) {
      if (next in this.tiles) {
        var tile = this.tiles[next];
        tile.classList.add('v-list-item--highlighted');
        var scrollTop = this.$refs.content.scrollTop;
        var contentHeight = this.$refs.content.clientHeight;

        if (scrollTop > tile.offsetTop - 8) {
          goTo(tile.offsetTop - tile.clientHeight, {
            appOffset: false,
            duration: 300,
            container: this.$refs.content
          });
        } else if (scrollTop + contentHeight < tile.offsetTop + tile.clientHeight + 8) {
          goTo(tile.offsetTop - contentHeight + tile.clientHeight * 2, {
            appOffset: false,
            duration: 300,
            container: this.$refs.content
          });
        }
      }

      prev in this.tiles && this.tiles[prev].classList.remove('v-list-item--highlighted');
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('full-width')) {
      removed('full-width', this);
    }
  },
  mounted: function mounted() {
    this.isActive && this.callActivate();
  },
  methods: {
    activate: function activate() {
      var _this = this;

      // Update coordinates and dimensions of menu
      // and its activator
      this.updateDimensions(); // Start the transition

      requestAnimationFrame(function () {
        // Once transitioning, calculate scroll and top position
        _this.startTransition().then(function () {
          if (_this.$refs.content) {
            _this.calculatedTopAuto = _this.calcTopAuto();
            _this.auto && (_this.$refs.content.scrollTop = _this.calcScrollPosition());
          }
        });
      });
    },
    calcScrollPosition: function calcScrollPosition() {
      var $el = this.$refs.content;
      var activeTile = $el.querySelector('.v-list-item--active');
      var maxScrollTop = $el.scrollHeight - $el.offsetHeight;
      return activeTile ? Math.min(maxScrollTop, Math.max(0, activeTile.offsetTop - $el.offsetHeight / 2 + activeTile.offsetHeight / 2)) : $el.scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      return parseInt(this.dimensions.activator.left - this.defaultOffset * 2);
    },
    calcTopAuto: function calcTopAuto() {
      var $el = this.$refs.content;
      var activeTile = $el.querySelector('.v-list-item--active');

      if (!activeTile) {
        this.selectedIndex = null;
      }

      if (this.offsetY || !activeTile) {
        return this.computedTop;
      }

      this.selectedIndex = Array.from(this.tiles).indexOf(activeTile);
      var tileDistanceFromMenuTop = activeTile.offsetTop - this.calcScrollPosition();
      var firstTileOffsetTop = $el.querySelector('.v-list-item').offsetTop;
      return this.computedTop - tileDistanceFromMenuTop - firstTileOffsetTop - 1;
    },
    changeListIndex: function changeListIndex(e) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (!this.isActive || !this.hasClickableTiles) {
        return;
      } else if (e.keyCode === keyCodes.tab) {
        this.isActive = false;
        return;
      } else if (e.keyCode === keyCodes.down) {
        this.nextTile();
      } else if (e.keyCode === keyCodes.up) {
        this.prevTile();
      } else if (e.keyCode === keyCodes.end) {
        this.lastTile();
      } else if (e.keyCode === keyCodes.home) {
        this.firstTile();
      } else if (e.keyCode === keyCodes.enter && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      } else {
        return;
      } // One of the conditions was met, prevent default action (#2988)


      e.preventDefault();
    },
    closeConditional: function closeConditional(e) {
      var target = e.target;
      return this.isActive && !this._isDestroyed && this.closeOnClick && !this.$refs.content.contains(target);
    },
    genActivatorAttributes: function genActivatorAttributes() {
      var attributes = activatable.options.methods.genActivatorAttributes.call(this);

      if (this.activeTile && this.activeTile.id) {
        return _objectSpread2(_objectSpread2({}, attributes), {}, {
          'aria-activedescendant': this.activeTile.id
        });
      }

      return attributes;
    },
    genActivatorListeners: function genActivatorListeners() {
      var listeners = menuable.options.methods.genActivatorListeners.call(this);

      if (!this.disableKeys) {
        listeners.keydown = this.onKeyDown;
      }

      return listeners;
    },
    genTransition: function genTransition() {
      var content = this.genContent();
      if (!this.transition) return content;
      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, [content]);
    },
    genDirectives: function genDirectives() {
      var _this2 = this;

      var directives = [{
        name: 'show',
        value: this.isContentActive
      }]; // Do not add click outside for hover menu

      if (!this.openOnHover && this.closeOnClick) {
        directives.push({
          name: 'click-outside',
          value: {
            handler: function handler() {
              _this2.isActive = false;
            },
            closeConditional: this.closeConditional,
            include: function include() {
              return [_this2.$el].concat(_toConsumableArray(_this2.getOpenDependentElements()));
            }
          }
        });
      }

      return directives;
    },
    genContent: function genContent() {
      var _this3 = this;

      var options = {
        attrs: _objectSpread2(_objectSpread2({}, this.getScopeIdAttrs()), {}, {
          role: 'role' in this.$attrs ? this.$attrs.role : 'menu'
        }),
        staticClass: 'v-menu__content',
        class: _objectSpread2(_objectSpread2(_objectSpread2({}, this.rootThemeClasses), this.roundedClasses), {}, _defineProperty({
          'v-menu__content--auto': this.auto,
          'v-menu__content--fixed': this.activatorFixed,
          menuable__content__active: this.isActive
        }, this.contentClass.trim(), true)),
        style: this.styles,
        directives: this.genDirectives(),
        ref: 'content',
        on: {
          click: function click(e) {
            var target = e.target;
            if (target.getAttribute('disabled')) return;
            if (_this3.closeOnContentClick) _this3.isActive = false;
          },
          keydown: this.onKeyDown
        }
      };

      if (this.$listeners.scroll) {
        options.on = options.on || {};
        options.on.scroll = this.$listeners.scroll;
      }

      if (!this.disabled && this.openOnHover) {
        options.on = options.on || {};
        options.on.mouseenter = this.mouseEnterHandler;
      }

      if (this.openOnHover) {
        options.on = options.on || {};
        options.on.mouseleave = this.mouseLeaveHandler;
      }

      return this.$createElement('div', options, this.getContentSlot());
    },
    getTiles: function getTiles() {
      if (!this.$refs.content) return;
      this.tiles = Array.from(this.$refs.content.querySelectorAll('.v-list-item, .v-divider, .v-subheader'));
    },
    mouseEnterHandler: function mouseEnterHandler() {
      var _this4 = this;

      this.runDelay('open', function () {
        if (_this4.hasJustFocused) return;
        _this4.hasJustFocused = true;
      });
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      var _this5 = this;

      // Prevent accidental re-activation
      this.runDelay('close', function () {
        if (_this5.$refs.content.contains(e.relatedTarget)) return;
        requestAnimationFrame(function () {
          _this5.isActive = false;

          _this5.callDeactivate();
        });
      });
    },
    nextTile: function nextTile() {
      var tile = this.tiles[this.listIndex + 1];

      if (!tile) {
        if (!this.tiles.length) return;
        this.listIndex = -1;
        this.nextTile();
        return;
      }

      this.listIndex++;
      if (tile.tabIndex === -1) this.nextTile();
    },
    prevTile: function prevTile() {
      var tile = this.tiles[this.listIndex - 1];

      if (!tile) {
        if (!this.tiles.length) return;
        this.listIndex = this.tiles.length;
        this.prevTile();
        return;
      }

      this.listIndex--;
      if (tile.tabIndex === -1) this.prevTile();
    },
    lastTile: function lastTile() {
      var tile = this.tiles[this.tiles.length - 1];
      if (!tile) return;
      this.listIndex = this.tiles.length - 1;
      if (tile.tabIndex === -1) this.prevTile();
    },
    firstTile: function firstTile() {
      var tile = this.tiles[0];
      if (!tile) return;
      this.listIndex = 0;
      if (tile.tabIndex === -1) this.nextTile();
    },
    onKeyDown: function onKeyDown(e) {
      var _this6 = this;

      if (e.keyCode === keyCodes.esc) {
        // Wait for dependent elements to close first
        setTimeout(function () {
          _this6.isActive = false;
        });
        var activator = this.getActivator();
        this.$nextTick(function () {
          return activator && activator.focus();
        });
      } else if (!this.isActive && [keyCodes.up, keyCodes.down].includes(e.keyCode)) {
        this.isActive = true;
      } // Allow for isActive watcher to generate tile list


      this.$nextTick(function () {
        return _this6.changeListIndex(e);
      });
    },
    onResize: function onResize() {
      if (!this.isActive) return; // Account for screen resize
      // and orientation change
      // eslint-disable-next-line no-unused-expressions

      this.$refs.content.offsetWidth;
      this.updateDimensions(); // When resizing to a smaller width
      // content width is evaluated before
      // the new activator width has been
      // set, causing it to not size properly
      // hacky but will revisit in the future

      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = window.setTimeout(this.updateDimensions, 100);
    }
  },
  render: function render(h) {
    var _this7 = this;

    var data = {
      staticClass: 'v-menu',
      class: {
        'v-menu--attached': this.attach === '' || this.attach === true || this.attach === 'attach'
      },
      directives: [{
        arg: '500',
        name: 'resize',
        value: this.onResize
      }]
    };
    return h('div', data, [!this.activator && this.genActivator(), this.showLazyContent(function () {
      return [_this7.$createElement(VThemeProvider, {
        props: {
          root: true,
          light: _this7.light,
          dark: _this7.dark
        }
      }, [_this7.genTransition()])];
    })]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VRadioGroup/VRadio.sass
var VRadio = __webpack_require__("2c64");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VLabel/VLabel.sass
var VLabel = __webpack_require__("1b2c");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VLabel/VLabel.js


// Styles
 // Mixins



 // Helpers


/* @vue/component */

/* harmony default export */ var VLabel_VLabel = (mixins_mixins(themeable).extend({
  name: 'v-label',
  functional: true,
  props: {
    absolute: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    disabled: Boolean,
    focused: Boolean,
    for: String,
    left: {
      type: [Number, String],
      default: 0
    },
    right: {
      type: [Number, String],
      default: 'auto'
    },
    value: Boolean
  },
  render: function render(h, ctx) {
    var children = ctx.children,
        listeners = ctx.listeners,
        props = ctx.props;
    var data = {
      staticClass: 'v-label',
      class: _objectSpread2({
        'v-label--active': props.value,
        'v-label--is-disabled': props.disabled
      }, functionalThemeClasses(ctx)),
      attrs: {
        for: props.for,
        'aria-hidden': !props.for
      },
      on: listeners,
      style: {
        left: convertToUnit(props.left),
        right: convertToUnit(props.right),
        position: props.absolute ? 'absolute' : 'relative'
      },
      ref: 'label'
    };
    return h('label', colorable.options.methods.setTextColor(props.focused && props.color, data), children);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VLabel/index.js


/* harmony default export */ var components_VLabel = (VLabel_VLabel);
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VInput/VInput.sass
var VInput = __webpack_require__("d191");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VMessages/VMessages.sass
var VMessages = __webpack_require__("8ff2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VMessages/VMessages.js

// Styles
 // Mixins



 // Utilities


/* @vue/component */

/* harmony default export */ var VMessages_VMessages = (mixins_mixins(colorable, themeable).extend({
  name: 'v-messages',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    genChildren: function genChildren() {
      return this.$createElement('transition-group', {
        staticClass: 'v-messages__wrapper',
        attrs: {
          name: 'message-transition',
          tag: 'div'
        }
      }, this.value.map(this.genMessage));
    },
    genMessage: function genMessage(message, key) {
      return this.$createElement('div', {
        staticClass: 'v-messages__message',
        key: key
      }, getSlot(this, 'default', {
        message: message,
        key: key
      }) || [message]);
    }
  },
  render: function render(h) {
    return h('div', this.setTextColor(this.color, {
      staticClass: 'v-messages',
      class: this.themeClasses
    }), [this.genChildren()]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VMessages/index.js


/* harmony default export */ var components_VMessages = (VMessages_VMessages);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/validatable/index.js



// Mixins


 // Utilities




var validatable_baseMixins = mixins_mixins(colorable, inject('form'), themeable);
/* @vue/component */

/* harmony default export */ var validatable = (validatable_baseMixins.extend({
  name: 'validatable',
  props: {
    disabled: Boolean,
    error: Boolean,
    errorCount: {
      type: [Number, String],
      default: 1
    },
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    messages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    readonly: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    success: Boolean,
    successMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    validateOnBlur: Boolean,
    value: {
      required: false
    }
  },
  data: function data() {
    return {
      errorBucket: [],
      hasColor: false,
      hasFocused: false,
      hasInput: false,
      isFocused: false,
      isResetting: false,
      lazyValue: this.value,
      valid: false
    };
  },
  computed: {
    computedColor: function computedColor() {
      if (this.isDisabled) return undefined;
      if (this.color) return this.color; // It's assumed that if the input is on a
      // dark background, the user will want to
      // have a white color. If the entire app
      // is setup to be dark, then they will
      // like want to use their primary color

      if (this.isDark && !this.appIsDark) return 'white';else return 'primary';
    },
    hasError: function hasError() {
      return this.internalErrorMessages.length > 0 || this.errorBucket.length > 0 || this.error;
    },
    // TODO: Add logic that allows the user to enable based
    // upon a good validation
    hasSuccess: function hasSuccess() {
      return this.internalSuccessMessages.length > 0 || this.success;
    },
    externalError: function externalError() {
      return this.internalErrorMessages.length > 0 || this.error;
    },
    hasMessages: function hasMessages() {
      return this.validationTarget.length > 0;
    },
    hasState: function hasState() {
      if (this.isDisabled) return false;
      return this.hasSuccess || this.shouldValidate && this.hasError;
    },
    internalErrorMessages: function internalErrorMessages() {
      return this.genInternalMessages(this.errorMessages);
    },
    internalMessages: function internalMessages() {
      return this.genInternalMessages(this.messages);
    },
    internalSuccessMessages: function internalSuccessMessages() {
      return this.genInternalMessages(this.successMessages);
    },
    internalValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },
    isDisabled: function isDisabled() {
      return this.disabled || !!this.form && this.form.disabled;
    },
    isInteractive: function isInteractive() {
      return !this.isDisabled && !this.isReadonly;
    },
    isReadonly: function isReadonly() {
      return this.readonly || !!this.form && this.form.readonly;
    },
    shouldValidate: function shouldValidate() {
      if (this.externalError) return true;
      if (this.isResetting) return false;
      return this.validateOnBlur ? this.hasFocused && !this.isFocused : this.hasInput || this.hasFocused;
    },
    validations: function validations() {
      return this.validationTarget.slice(0, Number(this.errorCount));
    },
    validationState: function validationState() {
      if (this.isDisabled) return undefined;
      if (this.hasError && this.shouldValidate) return 'error';
      if (this.hasSuccess) return 'success';
      if (this.hasColor) return this.computedColor;
      return undefined;
    },
    validationTarget: function validationTarget() {
      if (this.internalErrorMessages.length > 0) {
        return this.internalErrorMessages;
      } else if (this.successMessages && this.successMessages.length > 0) {
        return this.internalSuccessMessages;
      } else if (this.messages && this.messages.length > 0) {
        return this.internalMessages;
      } else if (this.shouldValidate) {
        return this.errorBucket;
      } else return [];
    }
  },
  watch: {
    rules: {
      handler: function handler(newVal, oldVal) {
        if (deepEqual(newVal, oldVal)) return;
        this.validate();
      },
      deep: true
    },
    internalValue: function internalValue() {
      // If it's the first time we're setting input,
      // mark it with hasInput
      this.hasInput = true;
      this.validateOnBlur || this.$nextTick(this.validate);
    },
    isFocused: function isFocused(val) {
      // Should not check validation
      // if disabled
      if (!val && !this.isDisabled) {
        this.hasFocused = true;
        this.validateOnBlur && this.$nextTick(this.validate);
      }
    },
    isResetting: function isResetting() {
      var _this = this;

      setTimeout(function () {
        _this.hasInput = false;
        _this.hasFocused = false;
        _this.isResetting = false;

        _this.validate();
      }, 0);
    },
    hasError: function hasError(val) {
      if (this.shouldValidate) {
        this.$emit('update:error', val);
      }
    },
    value: function value(val) {
      this.lazyValue = val;
    }
  },
  beforeMount: function beforeMount() {
    this.validate();
  },
  created: function created() {
    this.form && this.form.register(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.form && this.form.unregister(this);
  },
  methods: {
    genInternalMessages: function genInternalMessages(messages) {
      if (!messages) return [];else if (Array.isArray(messages)) return messages;else return [messages];
    },

    /** @public */
    reset: function reset() {
      this.isResetting = true;
      this.internalValue = Array.isArray(this.internalValue) ? [] : null;
    },

    /** @public */
    resetValidation: function resetValidation() {
      this.isResetting = true;
    },

    /** @public */
    validate: function validate() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var value = arguments.length > 1 ? arguments[1] : undefined;
      var errorBucket = [];
      value = value || this.internalValue;
      if (force) this.hasInput = this.hasFocused = true;

      for (var index = 0; index < this.rules.length; index++) {
        var rule = this.rules[index];
        var valid = typeof rule === 'function' ? rule(value) : rule;

        if (valid === false || typeof valid === 'string') {
          errorBucket.push(valid || '');
        } else if (typeof valid !== 'boolean') {
          consoleError("Rules should return a string or boolean, received '".concat(_typeof(valid), "' instead"), this);
        }
      }

      this.errorBucket = errorBucket;
      this.valid = errorBucket.length === 0;
      return this.valid;
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VInput/VInput.js








// Styles
 // Components



 // Mixins


 // Utilities




var VInput_baseMixins = mixins_mixins(binds_attrs, validatable);
/* @vue/component */

/* harmony default export */ var VInput_VInput = (VInput_baseMixins.extend().extend({
  name: 'v-input',
  inheritAttrs: false,
  props: {
    appendIcon: String,
    backgroundColor: {
      type: String,
      default: ''
    },
    dense: Boolean,
    height: [Number, String],
    hideDetails: [Boolean, String],
    hideSpinButtons: Boolean,
    hint: String,
    id: String,
    label: String,
    loading: Boolean,
    persistentHint: Boolean,
    prependIcon: String,
    value: null
  },
  data: function data() {
    return {
      lazyValue: this.value,
      hasMouseDown: false
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2({
        'v-input--has-state': this.hasState,
        'v-input--hide-details': !this.showDetails,
        'v-input--is-label-active': this.isLabelActive,
        'v-input--is-dirty': this.isDirty,
        'v-input--is-disabled': this.isDisabled,
        'v-input--is-focused': this.isFocused,
        // <v-switch loading>.loading === '' so we can't just cast to boolean
        'v-input--is-loading': this.loading !== false && this.loading != null,
        'v-input--is-readonly': this.isReadonly,
        'v-input--dense': this.dense,
        'v-input--hide-spin-buttons': this.hideSpinButtons
      }, this.themeClasses);
    },
    computedId: function computedId() {
      return this.id || "input-".concat(this._uid);
    },
    hasDetails: function hasDetails() {
      return this.messagesToDisplay.length > 0;
    },
    hasHint: function hasHint() {
      return !this.hasMessages && !!this.hint && (this.persistentHint || this.isFocused);
    },
    hasLabel: function hasLabel() {
      return !!(this.$slots.label || this.label);
    },
    // Proxy for `lazyValue`
    // This allows an input
    // to function without
    // a provided model
    internalValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        this.lazyValue = val;
        this.$emit(this.$_modelEvent, val);
      }
    },
    isDirty: function isDirty() {
      return !!this.lazyValue;
    },
    isLabelActive: function isLabelActive() {
      return this.isDirty;
    },
    messagesToDisplay: function messagesToDisplay() {
      var _this = this;

      if (this.hasHint) return [this.hint];
      if (!this.hasMessages) return [];
      return this.validations.map(function (validation) {
        if (typeof validation === 'string') return validation;
        var validationResult = validation(_this.internalValue);
        return typeof validationResult === 'string' ? validationResult : '';
      }).filter(function (message) {
        return message !== '';
      });
    },
    showDetails: function showDetails() {
      return this.hideDetails === false || this.hideDetails === 'auto' && this.hasDetails;
    }
  },
  watch: {
    value: function value(val) {
      this.lazyValue = val;
    }
  },
  beforeCreate: function beforeCreate() {
    // v-radio-group needs to emit a different event
    // https://github.com/vuetifyjs/vuetify/issues/4752
    this.$_modelEvent = this.$options.model && this.$options.model.event || 'input';
  },
  methods: {
    genContent: function genContent() {
      return [this.genPrependSlot(), this.genControl(), this.genAppendSlot()];
    },
    genControl: function genControl() {
      return this.$createElement('div', {
        staticClass: 'v-input__control',
        attrs: {
          title: this.attrs$.title
        }
      }, [this.genInputSlot(), this.genMessages()]);
    },
    genDefaultSlot: function genDefaultSlot() {
      return [this.genLabel(), this.$slots.default];
    },
    genIcon: function genIcon(type, cb) {
      var _this2 = this;

      var extraData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var icon = this["".concat(type, "Icon")];
      var eventName = "click:".concat(kebabCase(type));
      var hasListener = !!(this.listeners$[eventName] || cb);
      var data = mergeData({
        attrs: {
          'aria-label': hasListener ? kebabCase(type).split('-')[0] + ' icon' : undefined,
          color: this.validationState,
          dark: this.dark,
          disabled: this.isDisabled,
          light: this.light
        },
        on: !hasListener ? undefined : {
          click: function click(e) {
            e.preventDefault();
            e.stopPropagation();

            _this2.$emit(eventName, e);

            cb && cb(e);
          },
          // Container has g event that will
          // trigger menu open if enclosed
          mouseup: function mouseup(e) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }, extraData);
      return this.$createElement('div', {
        staticClass: "v-input__icon",
        class: type ? "v-input__icon--".concat(kebabCase(type)) : undefined
      }, [this.$createElement(components_VIcon, data, icon)]);
    },
    genInputSlot: function genInputSlot() {
      return this.$createElement('div', this.setBackgroundColor(this.backgroundColor, {
        staticClass: 'v-input__slot',
        style: {
          height: convertToUnit(this.height)
        },
        on: {
          click: this.onClick,
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp
        },
        ref: 'input-slot'
      }), [this.genDefaultSlot()]);
    },
    genLabel: function genLabel() {
      if (!this.hasLabel) return null;
      return this.$createElement(components_VLabel, {
        props: {
          color: this.validationState,
          dark: this.dark,
          disabled: this.isDisabled,
          focused: this.hasState,
          for: this.computedId,
          light: this.light
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this3 = this;

      if (!this.showDetails) return null;
      return this.$createElement(components_VMessages, {
        props: {
          color: this.hasHint ? '' : this.validationState,
          dark: this.dark,
          light: this.light,
          value: this.messagesToDisplay
        },
        attrs: {
          role: this.hasMessages ? 'alert' : null
        },
        scopedSlots: {
          default: function _default(props) {
            return getSlot(_this3, 'message', props);
          }
        }
      });
    },
    genSlot: function genSlot(type, location, slot) {
      if (!slot.length) return null;
      var ref = "".concat(type, "-").concat(location);
      return this.$createElement('div', {
        staticClass: "v-input__".concat(ref),
        ref: ref
      }, slot);
    },
    genPrependSlot: function genPrependSlot() {
      var slot = [];

      if (this.$slots.prepend) {
        slot.push(this.$slots.prepend);
      } else if (this.prependIcon) {
        slot.push(this.genIcon('prepend'));
      }

      return this.genSlot('prepend', 'outer', slot);
    },
    genAppendSlot: function genAppendSlot() {
      var slot = []; // Append icon for text field was really
      // an appended inner icon, v-text-field
      // will overwrite this method in order to obtain
      // backwards compat

      if (this.$slots.append) {
        slot.push(this.$slots.append);
      } else if (this.appendIcon) {
        slot.push(this.genIcon('append'));
      }

      return this.genSlot('append', 'outer', slot);
    },
    onClick: function onClick(e) {
      this.$emit('click', e);
    },
    onMouseDown: function onMouseDown(e) {
      this.hasMouseDown = true;
      this.$emit('mousedown', e);
    },
    onMouseUp: function onMouseUp(e) {
      this.hasMouseDown = false;
      this.$emit('mouseup', e);
    }
  },
  render: function render(h) {
    return h('div', this.setTextColor(this.validationState, {
      staticClass: 'v-input',
      class: this.classes
    }), this.genContent());
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VInput/index.js


/* harmony default export */ var components_VInput = (VInput_VInput);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/rippleable/index.js
// Directives
 // Types


/* harmony default export */ var rippleable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'rippleable',
  directives: {
    ripple: ripple
  },
  props: {
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  methods: {
    genRipple: function genRipple() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.ripple) return null;
      data.staticClass = 'v-input--selection-controls__ripple';
      data.directives = data.directives || [];
      data.directives.push({
        name: 'ripple',
        value: {
          center: true
        }
      });
      return this.$createElement('div', data);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/selectable/index.js




// Components
 // Mixins


 // Utilities


function prevent(e) {
  e.preventDefault();
}
/* @vue/component */

/* harmony default export */ var selectable = (mixins_mixins(components_VInput, rippleable, comparable).extend({
  name: 'selectable',
  model: {
    prop: 'inputValue',
    event: 'change'
  },
  props: {
    id: String,
    inputValue: null,
    falseValue: null,
    trueValue: null,
    multiple: {
      type: Boolean,
      default: null
    },
    label: String
  },
  data: function data() {
    return {
      hasColor: this.inputValue,
      lazyValue: this.inputValue
    };
  },
  computed: {
    computedColor: function computedColor() {
      if (!this.isActive) return undefined;
      if (this.color) return this.color;
      if (this.isDark && !this.appIsDark) return 'white';
      return 'primary';
    },
    isMultiple: function isMultiple() {
      return this.multiple === true || this.multiple === null && Array.isArray(this.internalValue);
    },
    isActive: function isActive() {
      var _this = this;

      var value = this.value;
      var input = this.internalValue;

      if (this.isMultiple) {
        if (!Array.isArray(input)) return false;
        return input.some(function (item) {
          return _this.valueComparator(item, value);
        });
      }

      if (this.trueValue === undefined || this.falseValue === undefined) {
        return value ? this.valueComparator(value, input) : Boolean(input);
      }

      return this.valueComparator(input, this.trueValue);
    },
    isDirty: function isDirty() {
      return this.isActive;
    },
    rippleState: function rippleState() {
      return !this.isDisabled && !this.validationState ? undefined : this.validationState;
    }
  },
  watch: {
    inputValue: function inputValue(val) {
      this.lazyValue = val;
      this.hasColor = val;
    }
  },
  methods: {
    genLabel: function genLabel() {
      var label = components_VInput.options.methods.genLabel.call(this);
      if (!label) return label;
      label.data.on = {
        // Label shouldn't cause the input to focus
        click: prevent
      };
      return label;
    },
    genInput: function genInput(type, attrs) {
      return this.$createElement('input', {
        attrs: Object.assign({
          'aria-checked': this.isActive.toString(),
          disabled: this.isDisabled,
          id: this.computedId,
          role: type,
          type: type
        }, attrs),
        domProps: {
          value: this.value,
          checked: this.isActive
        },
        on: {
          blur: this.onBlur,
          change: this.onChange,
          focus: this.onFocus,
          keydown: this.onKeydown,
          click: prevent
        },
        ref: 'input'
      });
    },
    onBlur: function onBlur() {
      this.isFocused = false;
    },
    onClick: function onClick(e) {
      this.onChange();
      this.$emit('click', e);
    },
    onChange: function onChange() {
      var _this2 = this;

      if (!this.isInteractive) return;
      var value = this.value;
      var input = this.internalValue;

      if (this.isMultiple) {
        if (!Array.isArray(input)) {
          input = [];
        }

        var length = input.length;
        input = input.filter(function (item) {
          return !_this2.valueComparator(item, value);
        });

        if (input.length === length) {
          input.push(value);
        }
      } else if (this.trueValue !== undefined && this.falseValue !== undefined) {
        input = this.valueComparator(input, this.trueValue) ? this.falseValue : this.trueValue;
      } else if (value) {
        input = this.valueComparator(input, value) ? null : value;
      } else {
        input = !input;
      }

      this.validate(true, input);
      this.internalValue = input;
      this.hasColor = input;
    },
    onFocus: function onFocus() {
      this.isFocused = true;
    },

    /** @abstract */
    onKeydown: function onKeydown(e) {}
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VRadioGroup/VRadio.js


var VRadio_excluded = ["title"];

// Styles



 // Mixins






 // Utilities




var VRadio_baseMixins = mixins_mixins(binds_attrs, colorable, rippleable, groupable_factory('radioGroup'), themeable);
/* @vue/component */

/* harmony default export */ var VRadioGroup_VRadio = (VRadio_baseMixins.extend().extend({
  name: 'v-radio',
  inheritAttrs: false,
  props: {
    disabled: Boolean,
    id: String,
    label: String,
    name: String,
    offIcon: {
      type: String,
      default: '$radioOff'
    },
    onIcon: {
      type: String,
      default: '$radioOn'
    },
    readonly: Boolean,
    value: {
      default: null
    }
  },
  data: function data() {
    return {
      isFocused: false
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({
        'v-radio--is-disabled': this.isDisabled,
        'v-radio--is-focused': this.isFocused
      }, this.themeClasses), this.groupClasses);
    },
    computedColor: function computedColor() {
      return selectable.options.computed.computedColor.call(this);
    },
    computedIcon: function computedIcon() {
      return this.isActive ? this.onIcon : this.offIcon;
    },
    computedId: function computedId() {
      return components_VInput.options.computed.computedId.call(this);
    },
    hasLabel: components_VInput.options.computed.hasLabel,
    hasState: function hasState() {
      return (this.radioGroup || {}).hasState;
    },
    isDisabled: function isDisabled() {
      return this.disabled || !!this.radioGroup && this.radioGroup.isDisabled;
    },
    isReadonly: function isReadonly() {
      return this.readonly || !!this.radioGroup && this.radioGroup.isReadonly;
    },
    computedName: function computedName() {
      if (this.name || !this.radioGroup) {
        return this.name;
      }

      return this.radioGroup.name || "radio-".concat(this.radioGroup._uid);
    },
    rippleState: function rippleState() {
      return selectable.options.computed.rippleState.call(this);
    },
    validationState: function validationState() {
      return (this.radioGroup || {}).validationState || this.computedColor;
    }
  },
  methods: {
    genInput: function genInput(args) {
      // We can't actually use the mixin directly because
      // it's made for standalone components, but its
      // genInput method is exactly what we need
      return selectable.options.methods.genInput.call(this, 'radio', args);
    },
    genLabel: function genLabel() {
      if (!this.hasLabel) return null;
      return this.$createElement(components_VLabel, {
        on: {
          // Label shouldn't cause the input to focus
          click: prevent
        },
        attrs: {
          for: this.computedId
        },
        props: {
          color: this.validationState,
          focused: this.hasState
        }
      }, getSlot(this, 'label') || this.label);
    },
    genRadio: function genRadio() {
      var _this$attrs$ = this.attrs$,
          title = _this$attrs$.title,
          radioAttrs = _objectWithoutProperties(_this$attrs$, VRadio_excluded);

      return this.$createElement('div', {
        staticClass: 'v-input--selection-controls__input'
      }, [this.$createElement(components_VIcon, this.setTextColor(this.validationState, {
        props: {
          dense: this.radioGroup && this.radioGroup.dense
        }
      }), this.computedIcon), this.genInput(_objectSpread2({
        name: this.computedName,
        value: this.value
      }, radioAttrs)), this.genRipple(this.setTextColor(this.rippleState))]);
    },
    onFocus: function onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    onBlur: function onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    onChange: function onChange() {
      if (this.isDisabled || this.isReadonly || this.isActive) return;
      this.toggle();
    },
    onKeydown: function onKeydown() {}
  },
  render: function render(h) {
    var data = {
      staticClass: 'v-radio',
      class: this.classes,
      on: mergeListeners({
        click: this.onChange
      }, this.listeners$),
      attrs: {
        title: this.attrs$.title
      }
    };
    return h('div', data, [this.genRadio(), this.genLabel()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/styles/components/_selection-controls.sass
var _selection_controls = __webpack_require__("ec29");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VRadioGroup/VRadioGroup.sass
var VRadioGroup = __webpack_require__("3d86");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VRadioGroup/VRadioGroup.js


// Styles

 // Extensions


 // Types


var VRadioGroup_baseMixins = mixins_mixins(BaseItemGroup, components_VInput);
/* @vue/component */

/* harmony default export */ var VRadioGroup_VRadioGroup = (VRadioGroup_baseMixins.extend({
  name: 'v-radio-group',
  provide: function provide() {
    return {
      radioGroup: this
    };
  },
  props: {
    column: {
      type: Boolean,
      default: true
    },
    height: {
      type: [Number, String],
      default: 'auto'
    },
    name: String,
    row: Boolean,
    // If no value set on VRadio
    // will match valueComparator
    // force default to null
    value: null
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, components_VInput.options.computed.classes.call(this)), {}, {
        'v-input--selection-controls v-input--radio-group': true,
        'v-input--radio-group--column': this.column && !this.row,
        'v-input--radio-group--row': this.row
      });
    }
  },
  methods: {
    genDefaultSlot: function genDefaultSlot() {
      return this.$createElement('div', {
        staticClass: 'v-input--radio-group__input',
        attrs: {
          id: this.id,
          role: 'radiogroup',
          'aria-labelledby': this.computedId
        }
      }, components_VInput.options.methods.genDefaultSlot.call(this));
    },
    genInputSlot: function genInputSlot() {
      var render = components_VInput.options.methods.genInputSlot.call(this);
      delete render.data.on.click;
      return render;
    },
    genLabel: function genLabel() {
      var label = components_VInput.options.methods.genLabel.call(this);
      if (!label) return null;
      label.data.attrs.id = this.computedId; // WAI considers this an orphaned label

      delete label.data.attrs.for;
      label.tag = 'legend';
      return label;
    },
    onClick: BaseItemGroup.options.methods.onClick
  },
  render: function render(h) {
    var vnode = components_VInput.options.render.call(this, h);

    this._b(vnode.data, 'div', this.attrs$);

    return vnode;
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSnackbar/VSnackbar.sass
var VSnackbar = __webpack_require__("ca71");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSnackbar/VSnackbar.js



// Styles
 // Components

 // Mixins




 // Utilities




/* harmony default export */ var VSnackbar_VSnackbar = (mixins_mixins(VSheet_VSheet, colorable, toggleable, positionable_factory(['absolute', 'bottom', 'left', 'right', 'top'])
/* @vue/component */
).extend({
  name: 'v-snackbar',
  props: {
    app: Boolean,
    centered: Boolean,
    contentClass: {
      type: String,
      default: ''
    },
    multiLine: Boolean,
    text: Boolean,
    timeout: {
      type: [Number, String],
      default: 5000
    },
    transition: {
      type: [Boolean, String],
      default: 'v-snack-transition',
      validator: function validator(v) {
        return typeof v === 'string' || v === false;
      }
    },
    vertical: Boolean
  },
  data: function data() {
    return {
      activeTimeout: -1
    };
  },
  computed: {
    classes: function classes() {
      return {
        'v-snack--absolute': this.absolute,
        'v-snack--active': this.isActive,
        'v-snack--bottom': this.bottom || !this.top,
        'v-snack--centered': this.centered,
        'v-snack--has-background': this.hasBackground,
        'v-snack--left': this.left,
        'v-snack--multi-line': this.multiLine && !this.vertical,
        'v-snack--right': this.right,
        'v-snack--text': this.text,
        'v-snack--top': this.top,
        'v-snack--vertical': this.vertical
      };
    },
    // Text and outlined styles both
    // use transparent backgrounds
    hasBackground: function hasBackground() {
      return !this.text && !this.outlined;
    },
    // Snackbar is dark by default
    // override themeable logic.
    isDark: function isDark() {
      return this.hasBackground ? !this.light : themeable.options.computed.isDark.call(this);
    },
    styles: function styles() {
      if (this.absolute || !this.app) return {};
      var _this$$vuetify$applic = this.$vuetify.application,
          bar = _this$$vuetify$applic.bar,
          bottom = _this$$vuetify$applic.bottom,
          footer = _this$$vuetify$applic.footer,
          insetFooter = _this$$vuetify$applic.insetFooter,
          left = _this$$vuetify$applic.left,
          right = _this$$vuetify$applic.right,
          top = _this$$vuetify$applic.top;
      return {
        paddingBottom: convertToUnit(bottom + footer + insetFooter),
        paddingLeft: convertToUnit(left),
        paddingRight: convertToUnit(right),
        paddingTop: convertToUnit(bar + top)
      };
    }
  },
  watch: {
    isActive: 'setTimeout',
    timeout: 'setTimeout'
  },
  mounted: function mounted() {
    if (this.isActive) this.setTimeout();
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('auto-height')) {
      removed('auto-height', this);
    }
    /* istanbul ignore next */
    // eslint-disable-next-line eqeqeq


    if (this.timeout == 0) {
      deprecate('timeout="0"', '-1', this);
    }
  },
  methods: {
    genActions: function genActions() {
      return this.$createElement('div', {
        staticClass: 'v-snack__action '
      }, [getSlot(this, 'action', {
        attrs: {
          class: 'v-snack__btn'
        }
      })]);
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-snack__content',
        class: _defineProperty({}, this.contentClass, true),
        attrs: {
          role: 'status',
          'aria-live': 'polite'
        }
      }, [getSlot(this)]);
    },
    genWrapper: function genWrapper() {
      var _this = this;

      var setColor = this.hasBackground ? this.setBackgroundColor : this.setTextColor;
      var data = setColor(this.color, {
        staticClass: 'v-snack__wrapper',
        class: VSheet_VSheet.options.computed.classes.call(this),
        style: VSheet_VSheet.options.computed.styles.call(this),
        directives: [{
          name: 'show',
          value: this.isActive
        }],
        on: {
          pointerenter: function pointerenter() {
            return window.clearTimeout(_this.activeTimeout);
          },
          pointerleave: this.setTimeout
        }
      });
      return this.$createElement('div', data, [this.genContent(), this.genActions()]);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, [this.genWrapper()]);
    },
    setTimeout: function setTimeout() {
      var _this2 = this;

      window.clearTimeout(this.activeTimeout);
      var timeout = Number(this.timeout);

      if (!this.isActive || // TODO: remove 0 in v3
      [0, -1].includes(timeout)) {
        return;
      }

      this.activeTimeout = window.setTimeout(function () {
        _this2.isActive = false;
      }, timeout);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-snack',
      class: this.classes,
      style: this.styles
    }, [this.transition !== false ? this.genTransition() : this.genWrapper()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VGrid/_grid.sass
var _grid = __webpack_require__("20f6");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VGrid/VSpacer.js


/* harmony default export */ var VSpacer = (createSimpleFunctional('spacer', 'div', 'v-spacer'));
// CONCATENATED MODULE: ./src/components/ChatTextMessage.vue







/* normalize component */

var ChatTextMessage_component = normalizeComponent(
  components_ChatTextMessagevue_type_script_lang_ts_,
  ChatTextMessagevue_type_template_id_3188c232_scoped_true_render,
  ChatTextMessagevue_type_template_id_3188c232_scoped_true_staticRenderFns,
  false,
  null,
  "3188c232",
  null
  
)

/* harmony default export */ var components_ChatTextMessage = (ChatTextMessage_component.exports);

/* vuetify-loader */

























installComponents_default()(ChatTextMessage_component, {VBtn: VBtn_VBtn,VCard: VCard_VCard,VCardActions: VCardActions,VCardText: VCardText,VCardTitle: VCardTitle,VDialog: VDialog_VDialog,VDivider: VDivider_VDivider,VFadeTransition: VFadeTransition,VHover: VHover,VIcon: components_VIcon_VIcon,VImg: VImg_VImg,VList: VList_VList,VListItem: VList_VListItem,VListItemAvatar: VListItemAvatar,VListItemContent: VListItemContent,VListItemIcon: VListItemIcon,VListItemSubtitle: VListItemSubtitle,VListItemTitle: VListItemTitle,VMenu: VMenu_VMenu,VRadio: VRadioGroup_VRadio,VRadioGroup: VRadioGroup_VRadioGroup,VSnackbar: VSnackbar_VSnackbar,VSpacer: VSpacer,VTooltip: VTooltip_VTooltip})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatPollMessage.vue?vue&type=template&id=6f669440&
var ChatPollMessagevue_type_template_id_6f669440_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading && _vm.poll)?_c('PollItem',_vm._g({attrs:{"poll":_vm.poll}},_vm.$listeners)):_vm._e()}
var ChatPollMessagevue_type_template_id_6f669440_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ChatPollMessage.vue?vue&type=template&id=6f669440&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/PollItem.vue?vue&type=template&id=60526126&scoped=true&
var PollItemvue_type_template_id_60526126_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.componentName(),_vm._g({tag:"component",attrs:{"poll":_vm.poll,"isActive":_vm.isActive,"voteInProgress":_vm.voteInProgress},on:{"endPoll":_vm.triggerPollEnd,"vote":_vm.handleVote}},_vm.$listeners))],1)}
var PollItemvue_type_template_id_60526126_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/PollItem.vue?vue&type=template&id=60526126&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/DefaultPoll.vue?vue&type=template&id=40a374d6&
var DefaultPollvue_type_template_id_40a374d6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poll-item tertiary mb-3 mx-3 rounded"},[_c('div',{staticClass:"state"},[_vm._v(_vm._s(_vm.answerState))]),_c('PollQuestion',{attrs:{"image":_vm.poll.image,"question":_vm.poll.question,"title":_vm.poll.title},on:{"toggle":_vm.toggle}}),_c('v-expand-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExpanded),expression:"isExpanded"}]},[(_vm.isActive && !_vm.answered && !_vm.poll.moderatorShowResults)?_c('PollAnswers',{staticClass:"my-4",attrs:{"answers":_vm.answers,"disabled":_vm.disabled,"votes":_vm.pollVotes,"votesPerPerson":_vm.poll.options.votesPerPerson},on:{"vote":_vm.vote}}):(_vm.poll.showResults || _vm.poll.moderatorShowResults)?_c('PollResults',{staticClass:"my-4",attrs:{"answers":_vm.answers,"votes":_vm.pollVotes}}):_c('div',{staticClass:"pending my-4"},[_vm._v(" "+_vm._s(_vm.pendingPollResultsText())+" ")]),_c('div',{staticClass:"author"},[_vm._v(" "+_vm._s(_vm.$t("polls.createdBy"))+" "+_vm._s(_vm.poll.createdByUserInfo.displayName)+" • "+_vm._s(_vm.timeLeftState)+" "+_vm._s(_vm.answered ? " • " + _vm.$t("polls.voted") : null)+" ")])],1)])],1)}
var DefaultPollvue_type_template_id_40a374d6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/DefaultPoll.vue?vue&type=template&id=40a374d6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollAnswers.vue?vue&type=template&id=530fee57&scoped=true&
var PollAnswersvue_type_template_id_530fee57_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-radio-group',{attrs:{"disabled":_vm.disabled,"max":_vm.votesPerPerson,"multiple":"","hide-details":"auto"},model:{value:(_vm.selectedAnswers),callback:function ($$v) {_vm.selectedAnswers=$$v},expression:"selectedAnswers"}},_vm._l((_vm.answers),function(answer){return _c('v-radio',{key:answer.answerId,attrs:{"color":"brand","label":answer.value,"value":answer},on:{"change":function($event){return _vm.vote(answer)}}})}),1),(_vm.votesPerPerson > 1)?_c('p',{staticClass:"votes-remaining"},[_vm._v(" "+_vm._s(_vm.$tc("polls.votesRemaining", _vm.votesRemaining, { votes: _vm.votesRemaining }))+" ")]):_vm._e()],1)}
var PollAnswersvue_type_template_id_530fee57_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollAnswers.vue?vue&type=template&id=530fee57&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollAnswers.vue?vue&type=script&lang=ts&










var PollAnswersvue_type_script_lang_ts_PollAnswers = /*#__PURE__*/function (_Vue) {
  _inherits(PollAnswers, _Vue);

  var _super = _createSuper(PollAnswers);

  function PollAnswers() {
    var _this;

    _classCallCheck(this, PollAnswers);

    _this = _super.apply(this, arguments);
    _this.selectedAnswers = [];
    return _this;
  }

  _createClass(PollAnswers, [{
    key: "onVotesChanged",
    value: function onVotesChanged() {
      var _this2 = this;

      this.selectedAnswers = this.answers.filter(function (answer) {
        return _this2.votes.findIndex(function (vote) {
          return vote.pollAnswer.answerId === answer.answerId;
        }) !== -1;
      });
    }
  }, {
    key: "vote",
    value: function vote(pollAnswer) {
      this.$emit("vote", pollAnswer);
    }
  }, {
    key: "votesRemaining",
    get: function get() {
      return this.votesPerPerson - this.votes.length;
    }
  }]);

  return PollAnswers;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], PollAnswersvue_type_script_lang_ts_PollAnswers.prototype, "answers", void 0);

__decorate([Prop({
  required: true
})], PollAnswersvue_type_script_lang_ts_PollAnswers.prototype, "votes", void 0);

__decorate([Prop({
  required: true
})], PollAnswersvue_type_script_lang_ts_PollAnswers.prototype, "disabled", void 0);

__decorate([Prop({
  required: true
})], PollAnswersvue_type_script_lang_ts_PollAnswers.prototype, "votesPerPerson", void 0);

__decorate([Watch("votes", {
  immediate: true
})], PollAnswersvue_type_script_lang_ts_PollAnswers.prototype, "onVotesChanged", null);

PollAnswersvue_type_script_lang_ts_PollAnswers = __decorate([vue_class_component_esm({})], PollAnswersvue_type_script_lang_ts_PollAnswers);
/* harmony default export */ var PollAnswersvue_type_script_lang_ts_ = (PollAnswersvue_type_script_lang_ts_PollAnswers);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollAnswers.vue?vue&type=script&lang=ts&
 /* harmony default export */ var shared_components_PollAnswersvue_type_script_lang_ts_ = (PollAnswersvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Polls/components/templates/shared-components/PollAnswers.vue?vue&type=style&index=0&id=530fee57&lang=scss&scoped=true&
var PollAnswersvue_type_style_index_0_id_530fee57_lang_scss_scoped_true_ = __webpack_require__("e181");

// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollAnswers.vue






/* normalize component */

var PollAnswers_component = normalizeComponent(
  shared_components_PollAnswersvue_type_script_lang_ts_,
  PollAnswersvue_type_template_id_530fee57_scoped_true_render,
  PollAnswersvue_type_template_id_530fee57_scoped_true_staticRenderFns,
  false,
  null,
  "530fee57",
  null
  
)

/* harmony default export */ var shared_components_PollAnswers = (PollAnswers_component.exports);

/* vuetify-loader */



installComponents_default()(PollAnswers_component, {VRadio: VRadioGroup_VRadio,VRadioGroup: VRadioGroup_VRadioGroup})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollResults.vue?vue&type=template&id=18d88725&scoped=true&
var PollResultsvue_type_template_id_18d88725_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.wordCloud)?_c('div',[_c('v-btn',{staticClass:"mb-2 pa-0 text-none",attrs:{"plain":"","small":""},on:{"click":function($event){_vm.wordCloudVisible = !_vm.wordCloudVisible}}},[_vm._v(" "+_vm._s(_vm.wordCloudVisible ? _vm.$t("polls.showResults") : _vm.$t("polls.showWordcloud"))+" ")]),(_vm.wordCloudVisible)?_c('div',{staticClass:"word-cloud-container",style:({ height: _vm.wordCloudHeight })},[_c('vue-word-cloud',{attrs:{"words":_vm.wordCloudData,"color":"inherit","font-family":"Roboto"}})],1):_vm._e()],1):_vm._e(),(!_vm.wordCloudVisible)?_c('div',_vm._l((_vm.answers),function(answer){return _c('div',{key:answer.answerId},[(!answer.userSubmission)?_c('PollResult',{attrs:{"answer":answer,"percent":_vm.calcPercent(answer.voteCount),"selected":_vm.selected(answer.answerId)}}):_c('v-tooltip',{attrs:{"bottom":"","content-class":"poll-result-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('PollResult',{attrs:{"answer":answer,"percent":_vm.calcPercent(answer.voteCount),"selected":_vm.selected(answer.answerId)}})],1)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.showAuthorNames ? _vm.$t("polls.submittedBy", { displayName: answer.authorDisplayName, }) : _vm.$t("polls.submitted"))+" ")])])],1)}),0):_vm._e()])}
var PollResultsvue_type_template_id_18d88725_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollResults.vue?vue&type=template&id=18d88725&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollResult.vue?vue&type=template&id=27d0349d&scoped=true&
var PollResultvue_type_template_id_27d0349d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result"},[_c('div',{staticClass:"content d-flex align-center"},[(_vm.selected)?_c('div',{staticClass:"icon-wrapper"},[_c('v-icon',[_vm._v("mdi-check")])],1):_vm._e(),_c('div',{staticClass:"txt"},[_vm._v(_vm._s(_vm.answer.value))]),_c('v-spacer'),_c('div',{staticClass:"percent"},[_vm._v(_vm._s(_vm.percent)+"%")])],1),_c('v-progress-linear',{attrs:{"background-color":_vm.progressBackgroundColor,"color":_vm.progressColor,"rounded":"","value":_vm.percent}})],1)}
var PollResultvue_type_template_id_27d0349d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollResult.vue?vue&type=template&id=27d0349d&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollResult.vue?vue&type=script&lang=ts&







var PollResultvue_type_script_lang_ts_PollResult = /*#__PURE__*/function (_Vue) {
  _inherits(PollResult, _Vue);

  var _super = _createSuper(PollResult);

  function PollResult() {
    _classCallCheck(this, PollResult);

    return _super.apply(this, arguments);
  }

  _createClass(PollResult, [{
    key: "progressBackgroundColor",
    get: function get() {
      return this.$vuetify.theme.dark ? "background lighten-1" : "background darken-1";
    }
  }, {
    key: "progressColor",
    get: function get() {
      if (this.answer.userSubmission) {
        return this.$vuetify.theme.dark ? "brand lighten-2" : "brand darken-2";
      }

      return "brand";
    }
  }]);

  return PollResult;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], PollResultvue_type_script_lang_ts_PollResult.prototype, "answer", void 0);

__decorate([Prop({
  required: true
})], PollResultvue_type_script_lang_ts_PollResult.prototype, "percent", void 0);

__decorate([Prop({
  required: true
})], PollResultvue_type_script_lang_ts_PollResult.prototype, "selected", void 0);

PollResultvue_type_script_lang_ts_PollResult = __decorate([vue_class_component_esm({})], PollResultvue_type_script_lang_ts_PollResult);
/* harmony default export */ var PollResultvue_type_script_lang_ts_ = (PollResultvue_type_script_lang_ts_PollResult);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollResult.vue?vue&type=script&lang=ts&
 /* harmony default export */ var shared_components_PollResultvue_type_script_lang_ts_ = (PollResultvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Polls/components/templates/shared-components/PollResult.vue?vue&type=style&index=0&id=27d0349d&lang=scss&scoped=true&
var PollResultvue_type_style_index_0_id_27d0349d_lang_scss_scoped_true_ = __webpack_require__("929b");

// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollResult.vue






/* normalize component */

var PollResult_component = normalizeComponent(
  shared_components_PollResultvue_type_script_lang_ts_,
  PollResultvue_type_template_id_27d0349d_scoped_true_render,
  PollResultvue_type_template_id_27d0349d_scoped_true_staticRenderFns,
  false,
  null,
  "27d0349d",
  null
  
)

/* harmony default export */ var shared_components_PollResult = (PollResult_component.exports);

/* vuetify-loader */




installComponents_default()(PollResult_component, {VIcon: components_VIcon_VIcon,VProgressLinear: VProgressLinear_VProgressLinear,VSpacer: VSpacer})

// EXTERNAL MODULE: ./node_modules/vuewordcloud/index.js
var vuewordcloud = __webpack_require__("2d8a");
var vuewordcloud_default = /*#__PURE__*/__webpack_require__.n(vuewordcloud);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollResults.vue?vue&type=script&lang=ts&











var PollResultsvue_type_script_lang_ts_PollResults = /*#__PURE__*/function (_Vue) {
  _inherits(PollResults, _Vue);

  var _super = _createSuper(PollResults);

  function PollResults() {
    var _this;

    _classCallCheck(this, PollResults);

    _this = _super.apply(this, arguments);
    _this.wordCloudVisible = false;
    return _this;
  }

  _createClass(PollResults, [{
    key: "wordCloudData",
    get: function get() {
      return this.answers.map(function (answer) {
        return [answer.value, answer.voteCount];
      });
    }
  }, {
    key: "calcPercent",
    value: function calcPercent(votes) {
      var total = this.answers.reduce(function (a, b) {
        return a + b.voteCount;
      }, 0);

      if (total === 0) {
        return 0;
      }

      return Math.round(votes / total * 100);
    }
  }, {
    key: "selected",
    value: function selected(answerId) {
      return this.votes.some(function (pollVote) {
        return pollVote.pollAnswer.answerId === answerId;
      });
    }
  }]);

  return PollResults;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], PollResultsvue_type_script_lang_ts_PollResults.prototype, "answers", void 0);

__decorate([Prop({
  required: true
})], PollResultsvue_type_script_lang_ts_PollResults.prototype, "votes", void 0);

__decorate([Prop({
  default: false
})], PollResultsvue_type_script_lang_ts_PollResults.prototype, "wordCloud", void 0);

__decorate([Prop({
  default: "200px"
})], PollResultsvue_type_script_lang_ts_PollResults.prototype, "wordCloudHeight", void 0);

__decorate([Prop({
  default: false
})], PollResultsvue_type_script_lang_ts_PollResults.prototype, "showAuthorNames", void 0);

PollResultsvue_type_script_lang_ts_PollResults = __decorate([vue_class_component_esm({
  components: {
    PollResult: shared_components_PollResult,
    VueWordCloud: vuewordcloud_default.a
  }
})], PollResultsvue_type_script_lang_ts_PollResults);
/* harmony default export */ var PollResultsvue_type_script_lang_ts_ = (PollResultsvue_type_script_lang_ts_PollResults);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollResults.vue?vue&type=script&lang=ts&
 /* harmony default export */ var shared_components_PollResultsvue_type_script_lang_ts_ = (PollResultsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Polls/components/templates/shared-components/PollResults.vue?vue&type=style&index=0&id=18d88725&lang=scss&scoped=true&
var PollResultsvue_type_style_index_0_id_18d88725_lang_scss_scoped_true_ = __webpack_require__("01a2");

// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollResults.vue






/* normalize component */

var PollResults_component = normalizeComponent(
  shared_components_PollResultsvue_type_script_lang_ts_,
  PollResultsvue_type_template_id_18d88725_scoped_true_render,
  PollResultsvue_type_template_id_18d88725_scoped_true_staticRenderFns,
  false,
  null,
  "18d88725",
  null
  
)

/* harmony default export */ var shared_components_PollResults = (PollResults_component.exports);

/* vuetify-loader */



installComponents_default()(PollResults_component, {VBtn: VBtn_VBtn,VTooltip: VTooltip_VTooltip})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollQuestion.vue?vue&type=template&id=92a5fd40&scoped=true&
var PollQuestionvue_type_template_id_92a5fd40_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"my-0 question",class:{ 'toogle--active': _vm.toggleEnabled },attrs:{"no-gutters":""},on:{"click":_vm.toggle}},[_c('v-col',{attrs:{"cols":_vm.image ? 8 : 12}},[(_vm.title)?_c('div',{staticClass:"text--secondary text-uppercase"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.question))])]),(_vm.image)?_c('v-col',{staticClass:"pl-3",attrs:{"cols":"4"}},[_c('v-responsive',{style:(("background: url('" + _vm.imageUrl + "') no-repeat center; background-size: contain")),attrs:{"aspect-ratio":"1"}})],1):_vm._e()],1)}
var PollQuestionvue_type_template_id_92a5fd40_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollQuestion.vue?vue&type=template&id=92a5fd40&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollQuestion.vue?vue&type=script&lang=ts&









var PollQuestionvue_type_script_lang_ts_PollQuestion = /*#__PURE__*/function (_Vue) {
  _inherits(PollQuestion, _Vue);

  var _super = _createSuper(PollQuestion);

  function PollQuestion() {
    var _this;

    _classCallCheck(this, PollQuestion);

    _this = _super.apply(this, arguments);
    _this.mediaUploadBaseUrl = getModule(store_ConfigModule, _this.$store).mediaUploadBaseUrl;
    return _this;
  }

  _createClass(PollQuestion, [{
    key: "imageUrl",
    get: function get() {
      return this.image ? this.mediaUploadBaseUrl + this.image.publicPath : "";
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.toggleEnabled) {
        this.$emit("toggle");
      }
    }
  }]);

  return PollQuestion;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], PollQuestionvue_type_script_lang_ts_PollQuestion.prototype, "image", void 0);

__decorate([Prop()], PollQuestionvue_type_script_lang_ts_PollQuestion.prototype, "question", void 0);

__decorate([Prop()], PollQuestionvue_type_script_lang_ts_PollQuestion.prototype, "title", void 0);

__decorate([Prop({
  default: true
})], PollQuestionvue_type_script_lang_ts_PollQuestion.prototype, "toggleEnabled", void 0);

PollQuestionvue_type_script_lang_ts_PollQuestion = __decorate([vue_class_component_esm({})], PollQuestionvue_type_script_lang_ts_PollQuestion);
/* harmony default export */ var PollQuestionvue_type_script_lang_ts_ = (PollQuestionvue_type_script_lang_ts_PollQuestion);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollQuestion.vue?vue&type=script&lang=ts&
 /* harmony default export */ var shared_components_PollQuestionvue_type_script_lang_ts_ = (PollQuestionvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Polls/components/templates/shared-components/PollQuestion.vue?vue&type=style&index=0&id=92a5fd40&lang=scss&scoped=true&
var PollQuestionvue_type_style_index_0_id_92a5fd40_lang_scss_scoped_true_ = __webpack_require__("5104");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__("4ec9");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VGrid/VGrid.sass
var VGrid = __webpack_require__("4b85");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VGrid/VCol.js

















 // no xs

var breakpoints = ['sm', 'md', 'lg', 'xl'];

var breakpointProps = function () {
  return breakpoints.reduce(function (props, val) {
    props[val] = {
      type: [Boolean, String, Number],
      default: false
    };
    return props;
  }, {});
}();

var offsetProps = function () {
  return breakpoints.reduce(function (props, val) {
    props['offset' + upperFirst(val)] = {
      type: [String, Number],
      default: null
    };
    return props;
  }, {});
}();

var orderProps = function () {
  return breakpoints.reduce(function (props, val) {
    props['order' + upperFirst(val)] = {
      type: [String, Number],
      default: null
    };
    return props;
  }, {});
}();

var propMap = {
  col: Object.keys(breakpointProps),
  offset: Object.keys(offsetProps),
  order: Object.keys(orderProps)
};

function breakpointClass(type, prop, val) {
  var className = type;

  if (val == null || val === false) {
    return undefined;
  }

  if (prop) {
    var breakpoint = prop.replace(type, '');
    className += "-".concat(breakpoint);
  } // Handling the boolean style prop when accepting [Boolean, String, Number]
  // means Vue will not convert <v-col sm></v-col> to sm: true for us.
  // Since the default is false, an empty string indicates the prop's presence.


  if (type === 'col' && (val === '' || val === true)) {
    // .col-md
    return className.toLowerCase();
  } // .order-md-6


  className += "-".concat(val);
  return className.toLowerCase();
}

var cache = new Map();
/* harmony default export */ var VCol = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-col',
  functional: true,
  props: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    cols: {
      type: [Boolean, String, Number],
      default: false
    }
  }, breakpointProps), {}, {
    offset: {
      type: [String, Number],
      default: null
    }
  }, offsetProps), {}, {
    order: {
      type: [String, Number],
      default: null
    }
  }, orderProps), {}, {
    alignSelf: {
      type: String,
      default: null,
      validator: function validator(str) {
        return ['auto', 'start', 'end', 'center', 'baseline', 'stretch'].includes(str);
      }
    },
    tag: {
      type: String,
      default: 'div'
    }
  }),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children,
        parent = _ref.parent;
    // Super-fast memoization based on props, 5x faster than JSON.stringify
    var cacheKey = '';

    for (var prop in props) {
      cacheKey += String(props[prop]);
    }

    var classList = cache.get(cacheKey);

    if (!classList) {
      (function () {
        var _classList$push;

        classList = []; // Loop through `col`, `offset`, `order` breakpoint props

        var type;

        for (type in propMap) {
          propMap[type].forEach(function (prop) {
            var value = props[prop];
            var className = breakpointClass(type, prop, value);
            if (className) classList.push(className);
          });
        }

        var hasColClasses = classList.some(function (className) {
          return className.startsWith('col-');
        });
        classList.push((_classList$push = {
          // Default to .col if no other col-{bp}-* classes generated nor `cols` specified.
          col: !hasColClasses || !props.cols
        }, _defineProperty(_classList$push, "col-".concat(props.cols), props.cols), _defineProperty(_classList$push, "offset-".concat(props.offset), props.offset), _defineProperty(_classList$push, "order-".concat(props.order), props.order), _defineProperty(_classList$push, "align-self-".concat(props.alignSelf), props.alignSelf), _classList$push));
        cache.set(cacheKey, classList);
      })();
    }

    return h(props.tag, mergeData(data, {
      class: classList
    }), children);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VGrid/VRow.js

















 // no xs

var VRow_breakpoints = ['sm', 'md', 'lg', 'xl'];
var ALIGNMENT = ['start', 'end', 'center'];

function makeProps(prefix, def) {
  return VRow_breakpoints.reduce(function (props, val) {
    props[prefix + upperFirst(val)] = def();
    return props;
  }, {});
}

var alignValidator = function alignValidator(str) {
  return [].concat(ALIGNMENT, ['baseline', 'stretch']).includes(str);
};

var alignProps = makeProps('align', function () {
  return {
    type: String,
    default: null,
    validator: alignValidator
  };
});

var justifyValidator = function justifyValidator(str) {
  return [].concat(ALIGNMENT, ['space-between', 'space-around']).includes(str);
};

var justifyProps = makeProps('justify', function () {
  return {
    type: String,
    default: null,
    validator: justifyValidator
  };
});

var alignContentValidator = function alignContentValidator(str) {
  return [].concat(ALIGNMENT, ['space-between', 'space-around', 'stretch']).includes(str);
};

var alignContentProps = makeProps('alignContent', function () {
  return {
    type: String,
    default: null,
    validator: alignContentValidator
  };
});
var VRow_propMap = {
  align: Object.keys(alignProps),
  justify: Object.keys(justifyProps),
  alignContent: Object.keys(alignContentProps)
};
var classMap = {
  align: 'align',
  justify: 'justify',
  alignContent: 'align-content'
};

function VRow_breakpointClass(type, prop, val) {
  var className = classMap[type];

  if (val == null) {
    return undefined;
  }

  if (prop) {
    // alignSm -> Sm
    var breakpoint = prop.replace(type, '');
    className += "-".concat(breakpoint);
  } // .align-items-sm-center


  className += "-".concat(val);
  return className.toLowerCase();
}

var VRow_cache = new Map();
/* harmony default export */ var VRow = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-row',
  functional: true,
  props: _objectSpread2(_objectSpread2(_objectSpread2({
    tag: {
      type: String,
      default: 'div'
    },
    dense: Boolean,
    noGutters: Boolean,
    align: {
      type: String,
      default: null,
      validator: alignValidator
    }
  }, alignProps), {}, {
    justify: {
      type: String,
      default: null,
      validator: justifyValidator
    }
  }, justifyProps), {}, {
    alignContent: {
      type: String,
      default: null,
      validator: alignContentValidator
    }
  }, alignContentProps),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    // Super-fast memoization based on props, 5x faster than JSON.stringify
    var cacheKey = '';

    for (var prop in props) {
      cacheKey += String(props[prop]);
    }

    var classList = VRow_cache.get(cacheKey);

    if (!classList) {
      (function () {
        var _classList$push;

        classList = []; // Loop through `align`, `justify`, `alignContent` breakpoint props

        var type;

        for (type in VRow_propMap) {
          VRow_propMap[type].forEach(function (prop) {
            var value = props[prop];
            var className = VRow_breakpointClass(type, prop, value);
            if (className) classList.push(className);
          });
        }

        classList.push((_classList$push = {
          'no-gutters': props.noGutters,
          'row--dense': props.dense
        }, _defineProperty(_classList$push, "align-".concat(props.align), props.align), _defineProperty(_classList$push, "justify-".concat(props.justify), props.justify), _defineProperty(_classList$push, "align-content-".concat(props.alignContent), props.alignContent), _classList$push));
        VRow_cache.set(cacheKey, classList);
      })();
    }

    return h(props.tag, mergeData(data, {
      staticClass: 'row',
      class: classList
    }), children);
  }
}));
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollQuestion.vue






/* normalize component */

var PollQuestion_component = normalizeComponent(
  shared_components_PollQuestionvue_type_script_lang_ts_,
  PollQuestionvue_type_template_id_92a5fd40_scoped_true_render,
  PollQuestionvue_type_template_id_92a5fd40_scoped_true_staticRenderFns,
  false,
  null,
  "92a5fd40",
  null
  
)

/* harmony default export */ var shared_components_PollQuestion = (PollQuestion_component.exports);

/* vuetify-loader */




installComponents_default()(PollQuestion_component, {VCol: VCol,VResponsive: VResponsive_VResponsive,VRow: VRow})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/DefaultPoll.vue?vue&type=script&lang=ts&



















var DefaultPollvue_type_script_lang_ts_DefaultPoll = /*#__PURE__*/function (_Vue) {
  _inherits(DefaultPoll, _Vue);

  var _super = _createSuper(DefaultPoll);

  function DefaultPoll() {
    var _this;

    _classCallCheck(this, DefaultPoll);

    _this = _super.apply(this, arguments);
    _this.isExpanded = true;
    _this.timeLeftTimeout = 0;
    _this.timeLeft = 0;
    return _this;
  }

  _createClass(DefaultPoll, [{
    key: "pendingPollResultsText",
    value: function pendingPollResultsText() {
      switch (this.poll.options.resultVisibility) {
        case PollResultVisibility.ON_DEMAND:
          return this.$t("polls.answerReceived") + " " + this.$t("polls.adminPublish");

        case PollResultVisibility.ON_POLL_END:
          return this.$t("polls.answerReceived") + " " + this.$t("polls.publish");

        default:
          return this.$t("polls.answerReceived").toString();
      }
    }
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.allUserVotes[this.poll.id]) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.getUsersVotes(this.poll.id);

              case 3:
                this.calcTimeLeft();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "destroyed",
    value: function destroyed() {
      clearTimeout(this.timeLeftTimeout);
    }
  }, {
    key: "answerState",
    get: function get() {
      if (this.answered) {
        return this.$t("polls.answered").toString();
      } else if (!this.isActive) {
        return this.$t("polls.missed").toString();
      } else {
        return this.$t("polls.open").toString();
      }
    }
  }, {
    key: "pollVotes",
    get: function get() {
      return this.allUserVotes[this.poll.id] || [];
    }
  }, {
    key: "answered",
    get: function get() {
      return this.pollVotes.length >= this.poll.options.votesPerPerson;
    }
  }, {
    key: "answers",
    get: function get() {
      return this.poll.answers;
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.voteInProgress || !this.userInfoIsValid;
    }
  }, {
    key: "timeLeftState",
    get: function get() {
      if (this.isActive && this.timeLeft > 0) {
        return humanize_duration_default()(this.timeLeft, {
          units: ["h", "m"],
          round: true,
          language: this.$i18n.locale
        }) + " " + this.$t("polls.left");
      }

      return this.$t("polls.ended").toString();
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var _this2 = this;

      this.isExpanded = !this.isExpanded;

      if (this.isExpanded) {
        setTimeout(function () {
          _this2.$emit("pauseScrolling");
        }, 300);
      }
    }
  }, {
    key: "calcTimeLeft",
    value: function calcTimeLeft() {
      if (this.isActive) {
        this.timeLeft = new Date(this.poll.endDate).getTime() - Date.now();

        if (this.timeLeft > 0) {
          this.timeLeftTimeout = setTimeout(this.calcTimeLeft, 60000);
          return;
        }
      }

      this.endPoll();
    }
  }, {
    key: "vote",
    value: function vote(pollAnswer) {
      // check if poll became inactive
      if (Date.now() > new Date(this.poll.endDate).getTime()) {
        this.endPoll();
      } else {
        this.$emit("vote", pollAnswer);
      }
    }
  }, {
    key: "endPoll",
    value: function endPoll() {
      this.$emit("endPoll");
      this.clearTimeLeft();
    }
  }, {
    key: "clearTimeLeft",
    value: function clearTimeLeft() {
      clearTimeout(this.timeLeftTimeout);
    }
  }]);

  return DefaultPoll;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], DefaultPollvue_type_script_lang_ts_DefaultPoll.prototype, "poll", void 0);

__decorate([Prop({
  required: true
})], DefaultPollvue_type_script_lang_ts_DefaultPoll.prototype, "isActive", void 0);

__decorate([Prop({
  required: true
})], DefaultPollvue_type_script_lang_ts_DefaultPoll.prototype, "voteInProgress", void 0);

__decorate([bindings_Action(PollAction.GET_USERS_VOTES, {
  namespace: POLL_NAMESPACE
})], DefaultPollvue_type_script_lang_ts_DefaultPoll.prototype, "getUsersVotes", void 0);

__decorate([Getter("userInfoIsValid", {
  namespace: USER_NAMESPACE
})], DefaultPollvue_type_script_lang_ts_DefaultPoll.prototype, "userInfoIsValid", void 0);

__decorate([Getter("userVotes", {
  namespace: POLL_NAMESPACE
})], DefaultPollvue_type_script_lang_ts_DefaultPoll.prototype, "allUserVotes", void 0);

__decorate([Watch("isActive")], DefaultPollvue_type_script_lang_ts_DefaultPoll.prototype, "clearTimeLeft", null);

DefaultPollvue_type_script_lang_ts_DefaultPoll = __decorate([vue_class_component_esm({
  components: {
    PollQuestion: shared_components_PollQuestion,
    PollAnswers: shared_components_PollAnswers,
    PollResults: shared_components_PollResults
  }
})], DefaultPollvue_type_script_lang_ts_DefaultPoll);
/* harmony default export */ var DefaultPollvue_type_script_lang_ts_ = (DefaultPollvue_type_script_lang_ts_DefaultPoll);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/DefaultPoll.vue?vue&type=script&lang=ts&
 /* harmony default export */ var templates_DefaultPollvue_type_script_lang_ts_ = (DefaultPollvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/Polls/components/templates/DefaultPoll.vue





/* normalize component */

var DefaultPoll_component = normalizeComponent(
  templates_DefaultPollvue_type_script_lang_ts_,
  DefaultPollvue_type_template_id_40a374d6_render,
  DefaultPollvue_type_template_id_40a374d6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var templates_DefaultPoll = (DefaultPoll_component.exports);

/* vuetify-loader */


installComponents_default()(DefaultPoll_component, {VExpandTransition: VExpandTransition})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/OpenPoll.vue?vue&type=template&id=0376673b&scoped=true&
var OpenPollvue_type_template_id_0376673b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poll-item tertiary mb-3 mx-3 rounded"},[_c('div',{staticClass:"state"},[_vm._v(_vm._s(_vm.answerState))]),_c('PollQuestion',{attrs:{"image":_vm.poll.image,"question":_vm.poll.question,"title":_vm.poll.title},on:{"toggle":_vm.toggle}}),_c('v-expand-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExpanded),expression:"isExpanded"}]},[(_vm.isActive && !_vm.answered && !_vm.poll.moderatorShowResults)?_c('div',{staticClass:"my-4"},[(_vm.predefinedAnswers.length > 0)?_c('PollAnswers',{staticClass:"mb-6",attrs:{"answers":_vm.predefinedAnswers,"disabled":_vm.disabled,"votes":_vm.pollVotes,"votesPerPerson":_vm.poll.options.votesPerPerson},on:{"vote":_vm.vote}}):_vm._e(),_c('PollUserInput',{attrs:{"disabled":_vm.disabled,"maxCharacterCount":_vm.poll.options.maxCharacterCount,"singleWordAnswers":_vm.poll.options.singleWordAnswers},on:{"vote":_vm.vote}})],1):(_vm.poll.showResults || _vm.poll.moderatorShowResults)?_c('perfect-scrollbar',{staticClass:"my-4",style:({ 'max-height': _vm.maxResultDisplayHeight })},[_c('PollResults',{attrs:{"answers":_vm.sortedAnswers,"votes":_vm.pollVotes,"showAuthorNames":_vm.poll.options.showAuthors,"wordCloud":true}})],1):_c('div',{staticClass:"pending my-4"},[_vm._v(" "+_vm._s(_vm.pendingPollResultsText())+" ")]),_c('div',{staticClass:"author"},[_vm._v(" "+_vm._s(_vm.$t("polls.createdBy"))+" "+_vm._s(_vm.poll.createdByUserInfo.displayName)+" • "+_vm._s(_vm.timeLeftState)+" "+_vm._s(_vm.answered ? " • " + _vm.$t("polls.voted") : null)+" ")])],1)])],1)}
var OpenPollvue_type_template_id_0376673b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/OpenPoll.vue?vue&type=template&id=0376673b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollUserInput.vue?vue&type=template&id=1b51beb0&scoped=true&
var PollUserInputvue_type_template_id_1b51beb0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.customVote.apply(null, arguments)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"append-icon":"mdi-send","dense":"","placeholder":_vm.$t('polls.typeAnswer'),"disabled":_vm.disabled,"rules":_vm.userInputRules},on:{"click:append":_vm.customVote},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-btn',{attrs:{"icon":"","type":"submit","disabled":!_vm.userInput.length || !_vm.valid},on:{"click":_vm.customVote}},[_c('v-icon',[_vm._v("mdi-send")])],1)]},proxy:true}]),model:{value:(_vm.userInput),callback:function ($$v) {_vm.userInput=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"userInput"}})],1)}
var PollUserInputvue_type_template_id_1b51beb0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollUserInput.vue?vue&type=template&id=1b51beb0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollUserInput.vue?vue&type=script&lang=ts&












var PollUserInputvue_type_script_lang_ts_PollUserInput = /*#__PURE__*/function (_Vue) {
  _inherits(PollUserInput, _Vue);

  var _super = _createSuper(PollUserInput);

  function PollUserInput() {
    var _this;

    _classCallCheck(this, PollUserInput);

    _this = _super.apply(this, arguments);
    _this.userInput = "";
    _this.valid = true;
    return _this;
  }

  _createClass(PollUserInput, [{
    key: "userInputRules",
    get: function get() {
      var rules = [this.maxCharacterCountFormRule];

      if (this.singleWordAnswers) {
        rules.push(this.singleWordAnswersFormRule);
      }

      return rules;
    }
  }, {
    key: "maxCharacterCountFormRule",
    value: function maxCharacterCountFormRule(v) {
      v = v.trim();
      return this.maxCharacterCount <= -1 || v.length <= this.maxCharacterCount || this.$t("polls.answerLimit", {
        chars: this.maxCharacterCount
      }).toString();
    }
  }, {
    key: "singleWordAnswersFormRule",
    value: function singleWordAnswersFormRule(v) {
      var regex = /^[\w-]+$/;
      v = v.trim();
      return !v.length || regex.test(v) || this.$t("polls.singleWordValidationMessage", {
        chars: this.maxCharacterCount
      }).toString();
    }
  }, {
    key: "customVote",
    value: function customVote() {
      var userInput = this.userInput.trim();
      if (this.disabled || !this.valid || !userInput.length) return;
      var customPollAnswer = {
        answerId: "",
        value: userInput
      };
      this.$emit("vote", customPollAnswer);
    }
  }]);

  return PollUserInput;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], PollUserInputvue_type_script_lang_ts_PollUserInput.prototype, "disabled", void 0);

__decorate([Prop({
  required: true
})], PollUserInputvue_type_script_lang_ts_PollUserInput.prototype, "maxCharacterCount", void 0);

__decorate([Prop({
  required: true
})], PollUserInputvue_type_script_lang_ts_PollUserInput.prototype, "singleWordAnswers", void 0);

PollUserInputvue_type_script_lang_ts_PollUserInput = __decorate([vue_class_component_esm({})], PollUserInputvue_type_script_lang_ts_PollUserInput);
/* harmony default export */ var PollUserInputvue_type_script_lang_ts_ = (PollUserInputvue_type_script_lang_ts_PollUserInput);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollUserInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var shared_components_PollUserInputvue_type_script_lang_ts_ = (PollUserInputvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VForm/VForm.js








// Mixins



/* @vue/component */

/* harmony default export */ var VForm = (mixins_mixins(binds_attrs, registrable_provide('form')
/* @vue/component */
).extend({
  name: 'v-form',
  provide: function provide() {
    return {
      form: this
    };
  },
  inheritAttrs: false,
  props: {
    disabled: Boolean,
    lazyValidation: Boolean,
    readonly: Boolean,
    value: Boolean
  },
  data: function data() {
    return {
      inputs: [],
      watchers: [],
      errorBag: {}
    };
  },
  watch: {
    errorBag: {
      handler: function handler(val) {
        var errors = Object.values(val).includes(true);
        this.$emit('input', !errors);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    watchInput: function watchInput(input) {
      var _this = this;

      var watcher = function watcher(input) {
        return input.$watch('hasError', function (val) {
          _this.$set(_this.errorBag, input._uid, val);
        }, {
          immediate: true
        });
      };

      var watchers = {
        _uid: input._uid,
        valid: function valid() {},
        shouldValidate: function shouldValidate() {}
      };

      if (this.lazyValidation) {
        // Only start watching inputs if we need to
        watchers.shouldValidate = input.$watch('shouldValidate', function (val) {
          if (!val) return; // Only watch if we're not already doing it

          if (_this.errorBag.hasOwnProperty(input._uid)) return;
          watchers.valid = watcher(input);
        });
      } else {
        watchers.valid = watcher(input);
      }

      return watchers;
    },

    /** @public */
    validate: function validate() {
      return this.inputs.filter(function (input) {
        return !input.validate(true);
      }).length === 0;
    },

    /** @public */
    reset: function reset() {
      this.inputs.forEach(function (input) {
        return input.reset();
      });
      this.resetErrorBag();
    },
    resetErrorBag: function resetErrorBag() {
      var _this2 = this;

      if (this.lazyValidation) {
        // Account for timeout in validatable
        setTimeout(function () {
          _this2.errorBag = {};
        }, 0);
      }
    },

    /** @public */
    resetValidation: function resetValidation() {
      this.inputs.forEach(function (input) {
        return input.resetValidation();
      });
      this.resetErrorBag();
    },
    register: function register(input) {
      this.inputs.push(input);
      this.watchers.push(this.watchInput(input));
    },
    unregister: function unregister(input) {
      var found = this.inputs.find(function (i) {
        return i._uid === input._uid;
      });
      if (!found) return;
      var unwatch = this.watchers.find(function (i) {
        return i._uid === found._uid;
      });

      if (unwatch) {
        unwatch.valid();
        unwatch.shouldValidate();
      }

      this.watchers = this.watchers.filter(function (i) {
        return i._uid !== found._uid;
      });
      this.inputs = this.inputs.filter(function (i) {
        return i._uid !== found._uid;
      });
      this.$delete(this.errorBag, found._uid);
    }
  },
  render: function render(h) {
    var _this3 = this;

    return h('form', {
      staticClass: 'v-form',
      attrs: _objectSpread2({
        novalidate: true
      }, this.attrs$),
      on: {
        submit: function submit(e) {
          return _this3.$emit('submit', e);
        }
      }
    }, this.$slots.default);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.is.js
var es_object_is = __webpack_require__("2b19");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VTextField/VTextField.sass
var VTextField = __webpack_require__("4ff9");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VCounter/VCounter.sass
var VCounter = __webpack_require__("e9b1");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VCounter/VCounter.js



// Styles
 // Mixins



/* @vue/component */

/* harmony default export */ var VCounter_VCounter = (mixins_mixins(themeable).extend({
  name: 'v-counter',
  functional: true,
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    max: [Number, String]
  },
  render: function render(h, ctx) {
    var props = ctx.props;
    var max = parseInt(props.max, 10);
    var value = parseInt(props.value, 10);
    var content = max ? "".concat(value, " / ").concat(max) : String(props.value);
    var isGreater = max && value > max;
    return h('div', {
      staticClass: 'v-counter',
      class: _objectSpread2({
        'error--text': isGreater
      }, functionalThemeClasses(ctx))
    }, content);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VCounter/index.js


/* harmony default export */ var components_VCounter = (VCounter_VCounter);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/intersectable/index.js
// Directives
 // Utilities

 // Types


function intersectable(options) {
  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: 'intersectable',
    data: function data() {
      return {
        isIntersecting: false
      };
    },
    mounted: function mounted() {
      intersect.inserted(this.$el, {
        name: 'intersect',
        value: this.onObserve
      }, this.$vnode);
    },
    destroyed: function destroyed() {
      intersect.unbind(this.$el, {
        name: 'intersect',
        value: this.onObserve
      }, this.$vnode);
    },
    methods: {
      onObserve: function onObserve(entries, observer, isIntersecting) {
        this.isIntersecting = isIntersecting;
        if (!isIntersecting) return;

        for (var i = 0, length = options.onVisible.length; i < length; i++) {
          var callback = this[options.onVisible[i]];

          if (typeof callback === 'function') {
            callback();
            continue;
          }

          consoleWarn(options.onVisible[i] + ' method is not available on the instance but referenced in intersectable mixin options');
        }
      }
    }
  });
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTextField/VTextField.js



var VTextField_excluded = ["title"];








// Styles
 // Extensions

 // Components


 // Mixins



 // Directives


 // Utilities



 // Types


var VTextField_baseMixins = mixins_mixins(components_VInput, intersectable({
  onVisible: ['onResize', 'tryAutofocus']
}), loadable);
var dirtyTypes = ['color', 'file', 'time', 'date', 'datetime-local', 'week', 'month'];
/* @vue/component */

/* harmony default export */ var VTextField_VTextField = (VTextField_baseMixins.extend().extend({
  name: 'v-text-field',
  directives: {
    resize: resize,
    ripple: ripple
  },
  inheritAttrs: false,
  props: {
    appendOuterIcon: String,
    autofocus: Boolean,
    clearable: Boolean,
    clearIcon: {
      type: String,
      default: '$clear'
    },
    counter: [Boolean, Number, String],
    counterValue: Function,
    filled: Boolean,
    flat: Boolean,
    fullWidth: Boolean,
    label: String,
    outlined: Boolean,
    placeholder: String,
    prefix: String,
    prependInnerIcon: String,
    persistentPlaceholder: Boolean,
    reverse: Boolean,
    rounded: Boolean,
    shaped: Boolean,
    singleLine: Boolean,
    solo: Boolean,
    soloInverted: Boolean,
    suffix: String,
    type: {
      type: String,
      default: 'text'
    }
  },
  data: function data() {
    return {
      badInput: false,
      labelWidth: 0,
      prefixWidth: 0,
      prependWidth: 0,
      initialValue: null,
      isBooted: false,
      isClearing: false
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, components_VInput.options.computed.classes.call(this)), {}, {
        'v-text-field': true,
        'v-text-field--full-width': this.fullWidth,
        'v-text-field--prefix': this.prefix,
        'v-text-field--single-line': this.isSingle,
        'v-text-field--solo': this.isSolo,
        'v-text-field--solo-inverted': this.soloInverted,
        'v-text-field--solo-flat': this.flat,
        'v-text-field--filled': this.filled,
        'v-text-field--is-booted': this.isBooted,
        'v-text-field--enclosed': this.isEnclosed,
        'v-text-field--reverse': this.reverse,
        'v-text-field--outlined': this.outlined,
        'v-text-field--placeholder': this.placeholder,
        'v-text-field--rounded': this.rounded,
        'v-text-field--shaped': this.shaped
      });
    },
    computedColor: function computedColor() {
      var computedColor = validatable.options.computed.computedColor.call(this);
      if (!this.soloInverted || !this.isFocused) return computedColor;
      return this.color || 'primary';
    },
    computedCounterValue: function computedCounterValue() {
      if (typeof this.counterValue === 'function') {
        return this.counterValue(this.internalValue);
      }

      return _toConsumableArray((this.internalValue || '').toString()).length;
    },
    hasCounter: function hasCounter() {
      return this.counter !== false && this.counter != null;
    },
    hasDetails: function hasDetails() {
      return components_VInput.options.computed.hasDetails.call(this) || this.hasCounter;
    },
    internalValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        this.lazyValue = val;
        this.$emit('input', this.lazyValue);
      }
    },
    isDirty: function isDirty() {
      var _this$lazyValue;

      return ((_this$lazyValue = this.lazyValue) == null ? void 0 : _this$lazyValue.toString().length) > 0 || this.badInput;
    },
    isEnclosed: function isEnclosed() {
      return this.filled || this.isSolo || this.outlined;
    },
    isLabelActive: function isLabelActive() {
      return this.isDirty || dirtyTypes.includes(this.type);
    },
    isSingle: function isSingle() {
      return this.isSolo || this.singleLine || this.fullWidth || // https://material.io/components/text-fields/#filled-text-field
      this.filled && !this.hasLabel;
    },
    isSolo: function isSolo() {
      return this.solo || this.soloInverted;
    },
    labelPosition: function labelPosition() {
      var offset = this.prefix && !this.labelValue ? this.prefixWidth : 0;
      if (this.labelValue && this.prependWidth) offset -= this.prependWidth;
      return this.$vuetify.rtl === this.reverse ? {
        left: offset,
        right: 'auto'
      } : {
        left: 'auto',
        right: offset
      };
    },
    showLabel: function showLabel() {
      return this.hasLabel && !(this.isSingle && this.labelValue);
    },
    labelValue: function labelValue() {
      return this.isFocused || this.isLabelActive || this.persistentPlaceholder;
    }
  },
  watch: {
    // labelValue: 'setLabelWidth', // moved to mounted, see #11533
    outlined: 'setLabelWidth',
    label: function label() {
      this.$nextTick(this.setLabelWidth);
    },
    prefix: function prefix() {
      this.$nextTick(this.setPrefixWidth);
    },
    isFocused: 'updateValue',
    value: function value(val) {
      this.lazyValue = val;
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('box')) {
      breaking('box', 'filled', this);
    }
    /* istanbul ignore next */


    if (this.$attrs.hasOwnProperty('browser-autocomplete')) {
      breaking('browser-autocomplete', 'autocomplete', this);
    }
    /* istanbul ignore if */


    if (this.shaped && !(this.filled || this.outlined || this.isSolo)) {
      consoleWarn('shaped should be used with either filled or outlined', this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // #11533
    this.$watch(function () {
      return _this.labelValue;
    }, this.setLabelWidth);
    this.autofocus && this.tryAutofocus();
    requestAnimationFrame(function () {
      _this.isBooted = true;
      requestAnimationFrame(function () {
        if (!_this.isIntersecting) {
          _this.onResize();
        }
      });
    });
  },
  methods: {
    /** @public */
    focus: function focus() {
      this.onFocus();
    },

    /** @public */
    blur: function blur(e) {
      var _this2 = this;

      // https://github.com/vuetifyjs/vuetify/issues/5913
      // Safari tab order gets broken if called synchronous
      window.requestAnimationFrame(function () {
        _this2.$refs.input && _this2.$refs.input.blur();
      });
    },
    clearableCallback: function clearableCallback() {
      var _this3 = this;

      this.$refs.input && this.$refs.input.focus();
      this.$nextTick(function () {
        return _this3.internalValue = null;
      });
    },
    genAppendSlot: function genAppendSlot() {
      var slot = [];

      if (this.$slots['append-outer']) {
        slot.push(this.$slots['append-outer']);
      } else if (this.appendOuterIcon) {
        slot.push(this.genIcon('appendOuter'));
      }

      return this.genSlot('append', 'outer', slot);
    },
    genPrependInnerSlot: function genPrependInnerSlot() {
      var slot = [];

      if (this.$slots['prepend-inner']) {
        slot.push(this.$slots['prepend-inner']);
      } else if (this.prependInnerIcon) {
        slot.push(this.genIcon('prependInner'));
      }

      return this.genSlot('prepend', 'inner', slot);
    },
    genIconSlot: function genIconSlot() {
      var slot = [];

      if (this.$slots.append) {
        slot.push(this.$slots.append);
      } else if (this.appendIcon) {
        slot.push(this.genIcon('append'));
      }

      return this.genSlot('append', 'inner', slot);
    },
    genInputSlot: function genInputSlot() {
      var input = components_VInput.options.methods.genInputSlot.call(this);
      var prepend = this.genPrependInnerSlot();

      if (prepend) {
        input.children = input.children || [];
        input.children.unshift(prepend);
      }

      return input;
    },
    genClearIcon: function genClearIcon() {
      if (!this.clearable) return null; // if the text field has no content then don't display the clear icon.
      // We add an empty div because other controls depend on a ref to append inner

      if (!this.isDirty) {
        return this.genSlot('append', 'inner', [this.$createElement('div')]);
      }

      return this.genSlot('append', 'inner', [this.genIcon('clear', this.clearableCallback)]);
    },
    genCounter: function genCounter() {
      var _this$$scopedSlots$co, _this$$scopedSlots$co2, _this$$scopedSlots;

      if (!this.hasCounter) return null;
      var max = this.counter === true ? this.attrs$.maxlength : this.counter;
      var props = {
        dark: this.dark,
        light: this.light,
        max: max,
        value: this.computedCounterValue
      };
      return (_this$$scopedSlots$co = (_this$$scopedSlots$co2 = (_this$$scopedSlots = this.$scopedSlots).counter) == null ? void 0 : _this$$scopedSlots$co2.call(_this$$scopedSlots, {
        props: props
      })) != null ? _this$$scopedSlots$co : this.$createElement(components_VCounter, {
        props: props
      });
    },
    genControl: function genControl() {
      return components_VInput.options.methods.genControl.call(this);
    },
    genDefaultSlot: function genDefaultSlot() {
      return [this.genFieldset(), this.genTextFieldSlot(), this.genClearIcon(), this.genIconSlot(), this.genProgress()];
    },
    genFieldset: function genFieldset() {
      if (!this.outlined) return null;
      return this.$createElement('fieldset', {
        attrs: {
          'aria-hidden': true
        }
      }, [this.genLegend()]);
    },
    genLabel: function genLabel() {
      if (!this.showLabel) return null;
      var data = {
        props: {
          absolute: true,
          color: this.validationState,
          dark: this.dark,
          disabled: this.isDisabled,
          focused: !this.isSingle && (this.isFocused || !!this.validationState),
          for: this.computedId,
          left: this.labelPosition.left,
          light: this.light,
          right: this.labelPosition.right,
          value: this.labelValue
        }
      };
      return this.$createElement(components_VLabel, data, this.$slots.label || this.label);
    },
    genLegend: function genLegend() {
      var width = !this.singleLine && (this.labelValue || this.isDirty) ? this.labelWidth : 0;
      var span = this.$createElement('span', {
        domProps: {
          innerHTML: '&#8203;'
        },
        staticClass: 'notranslate'
      });
      return this.$createElement('legend', {
        style: {
          width: !this.isSingle ? convertToUnit(width) : undefined
        }
      }, [span]);
    },
    genInput: function genInput() {
      var listeners = Object.assign({}, this.listeners$);
      delete listeners.change; // Change should not be bound externally

      var _this$attrs$ = this.attrs$,
          title = _this$attrs$.title,
          inputAttrs = _objectWithoutProperties(_this$attrs$, VTextField_excluded);

      return this.$createElement('input', {
        style: {},
        domProps: {
          value: this.type === 'number' && Object.is(this.lazyValue, -0) ? '-0' : this.lazyValue
        },
        attrs: _objectSpread2(_objectSpread2({}, inputAttrs), {}, {
          autofocus: this.autofocus,
          disabled: this.isDisabled,
          id: this.computedId,
          placeholder: this.persistentPlaceholder || this.isFocused || !this.hasLabel ? this.placeholder : undefined,
          readonly: this.isReadonly,
          type: this.type
        }),
        on: Object.assign(listeners, {
          blur: this.onBlur,
          input: this.onInput,
          focus: this.onFocus,
          keydown: this.onKeyDown
        }),
        ref: 'input',
        directives: [{
          name: 'resize',
          modifiers: {
            quiet: true
          },
          value: this.onResize
        }]
      });
    },
    genMessages: function genMessages() {
      if (!this.showDetails) return null;
      var messagesNode = components_VInput.options.methods.genMessages.call(this);
      var counterNode = this.genCounter();
      return this.$createElement('div', {
        staticClass: 'v-text-field__details'
      }, [messagesNode, counterNode]);
    },
    genTextFieldSlot: function genTextFieldSlot() {
      return this.$createElement('div', {
        staticClass: 'v-text-field__slot'
      }, [this.genLabel(), this.prefix ? this.genAffix('prefix') : null, this.genInput(), this.suffix ? this.genAffix('suffix') : null]);
    },
    genAffix: function genAffix(type) {
      return this.$createElement('div', {
        class: "v-text-field__".concat(type),
        ref: type
      }, this[type]);
    },
    onBlur: function onBlur(e) {
      var _this4 = this;

      this.isFocused = false;
      e && this.$nextTick(function () {
        return _this4.$emit('blur', e);
      });
    },
    onClick: function onClick() {
      if (this.isFocused || this.isDisabled || !this.$refs.input) return;
      this.$refs.input.focus();
    },
    onFocus: function onFocus(e) {
      if (!this.$refs.input) return;
      var root = attachedRoot(this.$el);
      if (!root) return;

      if (root.activeElement !== this.$refs.input) {
        return this.$refs.input.focus();
      }

      if (!this.isFocused) {
        this.isFocused = true;
        e && this.$emit('focus', e);
      }
    },
    onInput: function onInput(e) {
      var target = e.target;
      this.internalValue = target.value;
      this.badInput = target.validity && target.validity.badInput;
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === keyCodes.enter && this.lazyValue !== this.initialValue) {
        this.initialValue = this.lazyValue;
        this.$emit('change', this.initialValue);
      }

      this.$emit('keydown', e);
    },
    onMouseDown: function onMouseDown(e) {
      // Prevent input from being blurred
      if (e.target !== this.$refs.input) {
        e.preventDefault();
        e.stopPropagation();
      }

      components_VInput.options.methods.onMouseDown.call(this, e);
    },
    onMouseUp: function onMouseUp(e) {
      if (this.hasMouseDown) this.focus();
      components_VInput.options.methods.onMouseUp.call(this, e);
    },
    setLabelWidth: function setLabelWidth() {
      if (!this.outlined) return;
      this.labelWidth = this.$refs.label ? Math.min(this.$refs.label.scrollWidth * 0.75 + 6, this.$el.offsetWidth - 24) : 0;
    },
    setPrefixWidth: function setPrefixWidth() {
      if (!this.$refs.prefix) return;
      this.prefixWidth = this.$refs.prefix.offsetWidth;
    },
    setPrependWidth: function setPrependWidth() {
      if (!this.outlined || !this.$refs['prepend-inner']) return;
      this.prependWidth = this.$refs['prepend-inner'].offsetWidth;
    },
    tryAutofocus: function tryAutofocus() {
      if (!this.autofocus || typeof document === 'undefined' || !this.$refs.input) return false;
      var root = attachedRoot(this.$el);
      if (!root || root.activeElement === this.$refs.input) return false;
      this.$refs.input.focus();
      return true;
    },
    updateValue: function updateValue(val) {
      // Sets validationState from validatable
      this.hasColor = val;

      if (val) {
        this.initialValue = this.lazyValue;
      } else if (this.initialValue !== this.lazyValue) {
        this.$emit('change', this.lazyValue);
      }
    },
    onResize: function onResize() {
      this.setLabelWidth();
      this.setPrefixWidth();
      this.setPrependWidth();
    }
  }
}));
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollUserInput.vue





/* normalize component */

var PollUserInput_component = normalizeComponent(
  shared_components_PollUserInputvue_type_script_lang_ts_,
  PollUserInputvue_type_template_id_1b51beb0_scoped_true_render,
  PollUserInputvue_type_template_id_1b51beb0_scoped_true_staticRenderFns,
  false,
  null,
  "1b51beb0",
  null
  
)

/* harmony default export */ var shared_components_PollUserInput = (PollUserInput_component.exports);

/* vuetify-loader */





installComponents_default()(PollUserInput_component, {VBtn: VBtn_VBtn,VForm: VForm,VIcon: components_VIcon_VIcon,VTextField: VTextField_VTextField})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/OpenPoll.vue?vue&type=script&lang=ts&













var OpenPollvue_type_script_lang_ts_OpenPoll = /*#__PURE__*/function (_DefaultPoll) {
  _inherits(OpenPoll, _DefaultPoll);

  var _super = _createSuper(OpenPoll);

  function OpenPoll() {
    var _this;

    _classCallCheck(this, OpenPoll);

    _this = _super.apply(this, arguments);
    _this.maxResultDisplayHeight = "250px";
    return _this;
  }

  _createClass(OpenPoll, [{
    key: "predefinedAnswers",
    get: function get() {
      return this.poll.answers.filter(function (answer) {
        return !answer.userSubmission;
      });
    }
  }, {
    key: "sortedAnswers",
    get: function get() {
      return this.poll.answers.sort(function (a, b) {
        return b.voteCount - a.voteCount;
      });
    }
  }]);

  return OpenPoll;
}(templates_DefaultPoll);

OpenPollvue_type_script_lang_ts_OpenPoll = __decorate([vue_class_component_esm({
  components: {
    PollQuestion: shared_components_PollQuestion,
    PollUserInput: shared_components_PollUserInput
  }
})], OpenPollvue_type_script_lang_ts_OpenPoll);
/* harmony default export */ var OpenPollvue_type_script_lang_ts_ = (OpenPollvue_type_script_lang_ts_OpenPoll);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/OpenPoll.vue?vue&type=script&lang=ts&
 /* harmony default export */ var templates_OpenPollvue_type_script_lang_ts_ = (OpenPollvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/Polls/components/templates/OpenPoll.vue





/* normalize component */

var OpenPoll_component = normalizeComponent(
  templates_OpenPollvue_type_script_lang_ts_,
  OpenPollvue_type_template_id_0376673b_scoped_true_render,
  OpenPollvue_type_template_id_0376673b_scoped_true_staticRenderFns,
  false,
  null,
  "0376673b",
  null
  
)

/* harmony default export */ var templates_OpenPoll = (OpenPoll_component.exports);

/* vuetify-loader */


installComponents_default()(OpenPoll_component, {VExpandTransition: VExpandTransition})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/ImagePoll.vue?vue&type=template&id=34d9bcf8&
var ImagePollvue_type_template_id_34d9bcf8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poll-item tertiary mb-3 mx-3 rounded"},[_c('div',{staticClass:"state"},[_vm._v(_vm._s(_vm.answerState))]),_c('PollQuestion',{attrs:{"image":_vm.poll.image,"question":_vm.poll.question,"title":_vm.poll.title},on:{"toggle":_vm.toggle}}),_c('v-expand-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExpanded),expression:"isExpanded"}]},[(_vm.isActive && !_vm.answered && !_vm.poll.moderatorShowResults)?_c('PollImageAnswers',{staticClass:"my-4",attrs:{"answers":_vm.answers,"disabled":_vm.disabled,"votes":_vm.pollVotes,"votesPerPerson":_vm.poll.options.votesPerPerson},on:{"vote":_vm.vote}}):(_vm.poll.showResults || _vm.poll.moderatorShowResults)?_c('PollImageResults',{staticClass:"my-4",attrs:{"answers":_vm.answers,"votes":_vm.pollVotes}}):_c('div',{staticClass:"pending my-4"},[_vm._v(" "+_vm._s(_vm.pendingPollResultsText())+" ")]),_c('div',{staticClass:"author"},[_vm._v(" "+_vm._s(_vm.$t("polls.createdBy"))+" "+_vm._s(_vm.poll.createdByUserInfo.displayName)+" • "+_vm._s(_vm.timeLeftState)+" "+_vm._s(_vm.answered ? " • " + _vm.$t("polls.voted") : null)+" ")])],1)])],1)}
var ImagePollvue_type_template_id_34d9bcf8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/ImagePoll.vue?vue&type=template&id=34d9bcf8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollImageAnswers.vue?vue&type=template&id=1462e326&scoped=true&
var PollImageAnswersvue_type_template_id_1462e326_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"my-0 mx-n2"},[_vm._l((_vm.answers),function(answer){return [(answer.image)?_c('v-col',{key:answer.answerId,staticClass:"px-2",attrs:{"cols":"6"}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{class:'poll-answer py-2 px-1 rounded' +
            (hover ? ' hover' : '') +
            (_vm.isSelected(answer) ? ' selected' : ''),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.vote(answer)}}},[_c('div',{staticClass:"img-wrapper"},[_c('v-img',{attrs:{"lazy-src":_vm.imageUrl(answer),"src":_vm.imageUrl(answer),"aspect-ratio":"1"},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"brand"}})],1)]},proxy:true}],null,true)}),_c('div',{staticClass:"img-overlay"}),_c('v-icon',{attrs:{"size":"30"}},[_vm._v("mdi-check-circle")])],1),(answer.value)?_c('v-card-text',{staticClass:"pa-0 pt-2 text-center"},[_vm._v(" "+_vm._s(answer.value)+" ")]):_vm._e()],1)]}}],null,true)})],1):_vm._e()]}),_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[(_vm.votesPerPerson > 1)?_c('p',{staticClass:"votes-remaining"},[_vm._v(" "+_vm._s(_vm.$tc("polls.votesRemaining", _vm.votesRemaining, { votes: _vm.votesRemaining }))+" ")]):_vm._e()])],2)}
var PollImageAnswersvue_type_template_id_1462e326_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollImageAnswers.vue?vue&type=template&id=1462e326&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollImageAnswers.vue?vue&type=script&lang=ts&












var PollImageAnswersvue_type_script_lang_ts_PollImageAnswers = /*#__PURE__*/function (_Vue) {
  _inherits(PollImageAnswers, _Vue);

  var _super = _createSuper(PollImageAnswers);

  function PollImageAnswers() {
    var _this;

    _classCallCheck(this, PollImageAnswers);

    _this = _super.apply(this, arguments);
    _this.mediaUploadBaseUrl = getModule(store_ConfigModule, _this.$store).mediaUploadBaseUrl;
    return _this;
  }

  _createClass(PollImageAnswers, [{
    key: "imageUrl",
    value: function imageUrl(answer) {
      var _answer$image;

      var imagePath = (_answer$image = answer.image) === null || _answer$image === void 0 ? void 0 : _answer$image.publicPath;
      if (!imagePath) return "";
      return this.mediaUploadBaseUrl + imagePath;
    }
  }, {
    key: "vote",
    value: function vote(pollAnswer) {
      if (this.isSelected(pollAnswer)) return;
      this.$emit("vote", pollAnswer);
    }
  }, {
    key: "selectedAnswersIds",
    get: function get() {
      return this.votes.map(function (vote) {
        return vote.pollAnswer.answerId;
      });
    }
  }, {
    key: "isSelected",
    value: function isSelected(_ref) {
      var answerId = _ref.answerId;
      return this.selectedAnswersIds.includes(answerId);
    }
  }, {
    key: "votesRemaining",
    get: function get() {
      return this.votesPerPerson - this.votes.length;
    }
  }]);

  return PollImageAnswers;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], PollImageAnswersvue_type_script_lang_ts_PollImageAnswers.prototype, "answers", void 0);

__decorate([Prop({
  required: true
})], PollImageAnswersvue_type_script_lang_ts_PollImageAnswers.prototype, "disabled", void 0);

__decorate([Prop({
  required: true
})], PollImageAnswersvue_type_script_lang_ts_PollImageAnswers.prototype, "votes", void 0);

__decorate([Prop({
  required: true
})], PollImageAnswersvue_type_script_lang_ts_PollImageAnswers.prototype, "votesPerPerson", void 0);

PollImageAnswersvue_type_script_lang_ts_PollImageAnswers = __decorate([vue_class_component_esm({})], PollImageAnswersvue_type_script_lang_ts_PollImageAnswers);
/* harmony default export */ var PollImageAnswersvue_type_script_lang_ts_ = (PollImageAnswersvue_type_script_lang_ts_PollImageAnswers);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollImageAnswers.vue?vue&type=script&lang=ts&
 /* harmony default export */ var shared_components_PollImageAnswersvue_type_script_lang_ts_ = (PollImageAnswersvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Polls/components/templates/shared-components/PollImageAnswers.vue?vue&type=style&index=0&id=1462e326&lang=scss&scoped=true&
var PollImageAnswersvue_type_style_index_0_id_1462e326_lang_scss_scoped_true_ = __webpack_require__("6061");

// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollImageAnswers.vue






/* normalize component */

var PollImageAnswers_component = normalizeComponent(
  shared_components_PollImageAnswersvue_type_script_lang_ts_,
  PollImageAnswersvue_type_template_id_1462e326_scoped_true_render,
  PollImageAnswersvue_type_template_id_1462e326_scoped_true_staticRenderFns,
  false,
  null,
  "1462e326",
  null
  
)

/* harmony default export */ var shared_components_PollImageAnswers = (PollImageAnswers_component.exports);

/* vuetify-loader */









installComponents_default()(PollImageAnswers_component, {VCard: VCard_VCard,VCardText: VCardText,VCol: VCol,VHover: VHover,VIcon: components_VIcon_VIcon,VImg: VImg_VImg,VProgressCircular: VProgressCircular_VProgressCircular,VRow: VRow})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollImageResults.vue?vue&type=template&id=2a884998&scoped=true&
var PollImageResultsvue_type_template_id_2a884998_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"my-0 mx-n2"},_vm._l((_vm.answers),function(answer,index){return _c('v-col',{key:index,staticClass:"px-2 pt-0 pb-2",attrs:{"cols":_vm.cols}},[_c('v-card',{class:'poll-result py-2 px-1' + (_vm.selected(answer) ? ' selected' : '')},[_c('div',{staticClass:"img-wrapper"},[_c('v-img',{attrs:{"lazy-src":_vm.imageUrl(answer),"src":_vm.imageUrl(answer),"aspect-ratio":"1"},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"brand lighten-5"}})],1)]},proxy:true}],null,true)}),_c('div',{staticClass:"img-overlay"}),_c('v-icon',{attrs:{"size":"30"}},[_vm._v("mdi-check-circle")])],1),(answer.value)?_c('v-card-text',{staticClass:"pa-0 pt-2 text-center"},[_vm._v(" "+_vm._s(answer.value)+" ")]):_vm._e(),_c('v-card-text',{staticClass:"poll-result-percent pa-0 pt-2 text-center"},[_vm._v(" "+_vm._s(_vm.calcPercent(answer) + "%")+" ")])],1)],1)}),1)}
var PollImageResultsvue_type_template_id_2a884998_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollImageResults.vue?vue&type=template&id=2a884998&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/shared-components/PollImageResults.vue?vue&type=script&lang=ts&










var PollImageResultsvue_type_script_lang_ts_PollImageAnswers = /*#__PURE__*/function (_Vue) {
  _inherits(PollImageAnswers, _Vue);

  var _super = _createSuper(PollImageAnswers);

  function PollImageAnswers() {
    var _this;

    _classCallCheck(this, PollImageAnswers);

    _this = _super.apply(this, arguments);
    _this.mediaUploadBaseUrl = getModule(store_ConfigModule, _this.$store).mediaUploadBaseUrl;
    return _this;
  }

  _createClass(PollImageAnswers, [{
    key: "imageUrl",
    value: function imageUrl(answer) {
      var _answer$image;

      var imagePath = (_answer$image = answer.image) === null || _answer$image === void 0 ? void 0 : _answer$image.publicPath;
      if (!imagePath) return "";
      return this.mediaUploadBaseUrl + imagePath;
    }
  }, {
    key: "selected",
    value: function selected(_ref) {
      var answerId = _ref.answerId;
      return this.votes.some(function (pollVote) {
        return pollVote.pollAnswer.answerId === answerId;
      });
    }
  }, {
    key: "calcPercent",
    value: function calcPercent(answer) {
      var total = this.answers.reduce(function (a, b) {
        return a + b.voteCount;
      }, 0);

      if (total === 0) {
        return 0;
      }

      return Math.round(answer.voteCount / total * 100);
    }
  }]);

  return PollImageAnswers;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], PollImageResultsvue_type_script_lang_ts_PollImageAnswers.prototype, "answers", void 0);

__decorate([Prop({
  required: true
})], PollImageResultsvue_type_script_lang_ts_PollImageAnswers.prototype, "votes", void 0);

__decorate([Prop({
  default: 6
})], PollImageResultsvue_type_script_lang_ts_PollImageAnswers.prototype, "cols", void 0);

PollImageResultsvue_type_script_lang_ts_PollImageAnswers = __decorate([vue_class_component_esm({})], PollImageResultsvue_type_script_lang_ts_PollImageAnswers);
/* harmony default export */ var PollImageResultsvue_type_script_lang_ts_ = (PollImageResultsvue_type_script_lang_ts_PollImageAnswers);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollImageResults.vue?vue&type=script&lang=ts&
 /* harmony default export */ var shared_components_PollImageResultsvue_type_script_lang_ts_ = (PollImageResultsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Polls/components/templates/shared-components/PollImageResults.vue?vue&type=style&index=0&id=2a884998&lang=scss&scoped=true&
var PollImageResultsvue_type_style_index_0_id_2a884998_lang_scss_scoped_true_ = __webpack_require__("ba63");

// CONCATENATED MODULE: ./src/components/Polls/components/templates/shared-components/PollImageResults.vue






/* normalize component */

var PollImageResults_component = normalizeComponent(
  shared_components_PollImageResultsvue_type_script_lang_ts_,
  PollImageResultsvue_type_template_id_2a884998_scoped_true_render,
  PollImageResultsvue_type_template_id_2a884998_scoped_true_staticRenderFns,
  false,
  null,
  "2a884998",
  null
  
)

/* harmony default export */ var PollImageResults = (PollImageResults_component.exports);

/* vuetify-loader */








installComponents_default()(PollImageResults_component, {VCard: VCard_VCard,VCardText: VCardText,VCol: VCol,VIcon: components_VIcon_VIcon,VImg: VImg_VImg,VProgressCircular: VProgressCircular_VProgressCircular,VRow: VRow})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/templates/ImagePoll.vue?vue&type=script&lang=ts&











var ImagePollvue_type_script_lang_ts_ImagePoll = /*#__PURE__*/function (_DefaultPoll) {
  _inherits(ImagePoll, _DefaultPoll);

  var _super = _createSuper(ImagePoll);

  function ImagePoll() {
    _classCallCheck(this, ImagePoll);

    return _super.apply(this, arguments);
  }

  return _createClass(ImagePoll);
}(templates_DefaultPoll);

ImagePollvue_type_script_lang_ts_ImagePoll = __decorate([vue_class_component_esm({
  components: {
    PollQuestion: shared_components_PollQuestion,
    PollImageAnswers: shared_components_PollImageAnswers,
    PollImageResults: PollImageResults
  }
})], ImagePollvue_type_script_lang_ts_ImagePoll);
/* harmony default export */ var ImagePollvue_type_script_lang_ts_ = (ImagePollvue_type_script_lang_ts_ImagePoll);
// CONCATENATED MODULE: ./src/components/Polls/components/templates/ImagePoll.vue?vue&type=script&lang=ts&
 /* harmony default export */ var templates_ImagePollvue_type_script_lang_ts_ = (ImagePollvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/Polls/components/templates/ImagePoll.vue





/* normalize component */

var ImagePoll_component = normalizeComponent(
  templates_ImagePollvue_type_script_lang_ts_,
  ImagePollvue_type_template_id_34d9bcf8_render,
  ImagePollvue_type_template_id_34d9bcf8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var templates_ImagePoll = (ImagePoll_component.exports);

/* vuetify-loader */


installComponents_default()(ImagePoll_component, {VExpandTransition: VExpandTransition})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Polls/components/PollItem.vue?vue&type=script&lang=ts&















var PollItemvue_type_script_lang_ts_PollItem = /*#__PURE__*/function (_Vue) {
  _inherits(PollItem, _Vue);

  var _super = _createSuper(PollItem);

  function PollItem() {
    var _this;

    _classCallCheck(this, PollItem);

    _this = _super.apply(this, arguments);
    _this.voteInProgress = false;
    return _this;
  }

  _createClass(PollItem, [{
    key: "componentName",
    value: function componentName() {
      switch (this.poll.options.type) {
        case PollType.OPEN:
          return "OpenPoll";

        case PollType.IMAGE:
          return "ImagePoll";

        default:
          return "DefaultPoll";
      }
    }
  }, {
    key: "isActive",
    get: function get() {
      return this.poll.status === PollStatus.ACTIVE;
    } // TODO: Move this into DefaultPoll.vue so we can listen to the API response

  }, {
    key: "handleVote",
    value: function () {
      var _handleVote = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pollAnswer) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.voteInProgress = true;
                _context.next = 4;
                return this.vote({
                  pollId: this.poll.id,
                  pollVote: pollAnswer
                });

              case 4:
                _context.prev = 4;
                this.voteInProgress = false;
                return _context.finish(4);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0,, 4, 7]]);
      }));

      function handleVote(_x) {
        return _handleVote.apply(this, arguments);
      }

      return handleVote;
    }()
  }, {
    key: "triggerPollEnd",
    value: function triggerPollEnd() {
      if (this.isActive) {
        this.endPoll(this.poll); // TODO: Event no longer needs to emitted, move into DefaultPoll.vue
      }
    }
  }]);

  return PollItem;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], PollItemvue_type_script_lang_ts_PollItem.prototype, "poll", void 0);

__decorate([bindings_Action(PollAction.VOTE, {
  namespace: POLL_NAMESPACE
})], PollItemvue_type_script_lang_ts_PollItem.prototype, "vote", void 0);

__decorate([bindings_Action(PollAction.END_POLL, {
  namespace: POLL_NAMESPACE
})], PollItemvue_type_script_lang_ts_PollItem.prototype, "endPoll", void 0);

PollItemvue_type_script_lang_ts_PollItem = __decorate([vue_class_component_esm({
  components: {
    DefaultPoll: templates_DefaultPoll,
    OpenPoll: templates_OpenPoll,
    ImagePoll: templates_ImagePoll
  }
})], PollItemvue_type_script_lang_ts_PollItem);
/* harmony default export */ var PollItemvue_type_script_lang_ts_ = (PollItemvue_type_script_lang_ts_PollItem);
// CONCATENATED MODULE: ./src/components/Polls/components/PollItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_PollItemvue_type_script_lang_ts_ = (PollItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Polls/components/PollItem.vue?vue&type=style&index=0&id=60526126&lang=scss&scoped=true&
var PollItemvue_type_style_index_0_id_60526126_lang_scss_scoped_true_ = __webpack_require__("9f0d");

// CONCATENATED MODULE: ./src/components/Polls/components/PollItem.vue






/* normalize component */

var PollItem_component = normalizeComponent(
  components_PollItemvue_type_script_lang_ts_,
  PollItemvue_type_template_id_60526126_scoped_true_render,
  PollItemvue_type_template_id_60526126_scoped_true_staticRenderFns,
  false,
  null,
  "60526126",
  null
  
)

/* harmony default export */ var components_PollItem = (PollItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatPollMessage.vue?vue&type=script&lang=ts&
















var ChatPollMessagevue_type_script_lang_ts_ChatPollMessage = /*#__PURE__*/function (_Vue) {
  _inherits(ChatPollMessage, _Vue);

  var _super = _createSuper(ChatPollMessage);

  function ChatPollMessage() {
    var _this;

    _classCallCheck(this, ChatPollMessage);

    _this = _super.apply(this, arguments);
    _this.loading = true;
    return _this;
  }

  _createClass(ChatPollMessage, [{
    key: "pollId",
    get: function get() {
      var _this$message$data;

      return ((_this$message$data = this.message.data) === null || _this$message$data === void 0 ? void 0 : _this$message$data.entityId) || "";
    }
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.pollId) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!(this.polls.findIndex(function (poll) {
                  return poll.id === _this2.pollId;
                }) === -1)) {
                  _context.next = 6;
                  break;
                }

                console.log("Poll not found, getting poll...", this.pollId);
                _context.next = 6;
                return this.getPollById(this.pollId);

              case 6:
                this.loading = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "poll",
    get: function get() {
      var _this3 = this;

      return this.polls.find(function (poll) {
        return poll.id === _this3.pollId;
      });
    }
  }]);

  return ChatPollMessage;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], ChatPollMessagevue_type_script_lang_ts_ChatPollMessage.prototype, "message", void 0);

__decorate([Prop({
  default: false
})], ChatPollMessagevue_type_script_lang_ts_ChatPollMessage.prototype, "simple", void 0);

__decorate([Prop({
  default: false
})], ChatPollMessagevue_type_script_lang_ts_ChatPollMessage.prototype, "indent", void 0);

__decorate([Getter("polls", {
  namespace: POLL_NAMESPACE
})], ChatPollMessagevue_type_script_lang_ts_ChatPollMessage.prototype, "polls", void 0);

__decorate([bindings_Action(PollAction.GET_POLL, {
  namespace: POLL_NAMESPACE
})], ChatPollMessagevue_type_script_lang_ts_ChatPollMessage.prototype, "getPollById", void 0);

ChatPollMessagevue_type_script_lang_ts_ChatPollMessage = __decorate([vue_class_component_esm({
  components: {
    PollItem: components_PollItem
  }
})], ChatPollMessagevue_type_script_lang_ts_ChatPollMessage);
/* harmony default export */ var ChatPollMessagevue_type_script_lang_ts_ = (ChatPollMessagevue_type_script_lang_ts_ChatPollMessage);
// CONCATENATED MODULE: ./src/components/ChatPollMessage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ChatPollMessagevue_type_script_lang_ts_ = (ChatPollMessagevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/ChatPollMessage.vue





/* normalize component */

var ChatPollMessage_component = normalizeComponent(
  components_ChatPollMessagevue_type_script_lang_ts_,
  ChatPollMessagevue_type_template_id_6f669440_render,
  ChatPollMessagevue_type_template_id_6f669440_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_ChatPollMessage = (ChatPollMessage_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatItem.vue?vue&type=script&lang=ts&









var ChatItemvue_type_script_lang_ts_ChatItem = /*#__PURE__*/function (_Vue) {
  _inherits(ChatItem, _Vue);

  var _super = _createSuper(ChatItem);

  function ChatItem() {
    _classCallCheck(this, ChatItem);

    return _super.apply(this, arguments);
  }

  return _createClass(ChatItem);
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], ChatItemvue_type_script_lang_ts_ChatItem.prototype, "message", void 0);

__decorate([Prop({
  default: false
})], ChatItemvue_type_script_lang_ts_ChatItem.prototype, "simple", void 0);

__decorate([Prop({
  default: false
})], ChatItemvue_type_script_lang_ts_ChatItem.prototype, "indent", void 0);

ChatItemvue_type_script_lang_ts_ChatItem = __decorate([vue_class_component_esm({
  components: {
    ChatTextMessage: components_ChatTextMessage,
    ChatPollMessage: components_ChatPollMessage
  }
})], ChatItemvue_type_script_lang_ts_ChatItem);
/* harmony default export */ var ChatItemvue_type_script_lang_ts_ = (ChatItemvue_type_script_lang_ts_ChatItem);
// CONCATENATED MODULE: ./src/components/ChatItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ChatItemvue_type_script_lang_ts_ = (ChatItemvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/ChatItem.vue





/* normalize component */

var ChatItem_component = normalizeComponent(
  components_ChatItemvue_type_script_lang_ts_,
  ChatItemvue_type_template_id_ebe6302c_scoped_true_render,
  ChatItemvue_type_template_id_ebe6302c_scoped_true_staticRenderFns,
  false,
  null,
  "ebe6302c",
  null
  
)

/* harmony default export */ var components_ChatItem = (ChatItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChannelSelect.vue?vue&type=template&id=7b39d818&scoped=true&
var ChannelSelectvue_type_template_id_7b39d818_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"loading":_vm.loading,"plain":"","small":""}},on),[_c('v-icon',{attrs:{"left":"","dense":"","small":"","color":"primary"}},[_vm._v(" mdi-format-list-bulleted ")]),(_vm.channelActive)?_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(" "+_vm._s(_vm.channelActive.name)+" ")]):_vm._e()],1),_c('v-badge',{attrs:{"inline":"","offset-x":"16","offset-y":"2","color":"error","content":_vm.unreadMessages,"value":_vm.unreadMessages}}),_c('v-badge',{attrs:{"inline":"","offset-x":"16","offset-y":"2","color":"info","content":_vm.unreadMentions,"value":_vm.unreadMentions}})]}}]),model:{value:(_vm.channelMenuOpen),callback:function ($$v) {_vm.channelMenuOpen=$$v},expression:"channelMenuOpen"}},[_c('v-card',{staticStyle:{"z-index":"8"},attrs:{"color":"background"}},[_c('v-card-subtitle',[_vm._v(_vm._s(_vm.$t("s8c.Chat rooms")))]),_c('v-list',{staticStyle:{"min-width":"12rem"},attrs:{"dense":"","color":"background"}},[_c('v-lazy',[_c('v-list-item-group',{attrs:{"mandatory":""},model:{value:(_vm.channelActive),callback:function ($$v) {_vm.channelActive=$$v},expression:"channelActive"}},[_vm._l((_vm.channels),function(channel){return [_c('v-hover',{key:channel.id,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-list-item',{attrs:{"value":channel,"active-class":("brand " + (_vm.brandTextColorLight ? 'white--text' : 'black--text'))},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                  var toggle = ref.toggle;
return [_c('v-list-item-content',[_c('v-list-item-title',{class:channel.unread > 0 ? 'font-weight-bold' : '',on:{"click":toggle}},[_vm._v(" "+_vm._s(channel.name)+" "),_c('v-badge',{staticClass:"ma-0",attrs:{"inline":"","color":"error","content":channel.unread,"value":channel.unread}}),_c('v-badge',{staticClass:"ma-0",attrs:{"inline":"","color":"info","content":channel.unreadMentions,"value":channel.unreadMentions}})],1)],1),_c('v-fade-transition',[(hover)?_c('v-overlay',{attrs:{"id":"channel-overlay","absolute":"","opacity":0,"z-index":"7"}},[(_vm.channels.length > 1 && _vm.canChangeChannels)?_c('v-btn',{attrs:{"icon":"","z-index":"9"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteChannel(channel)}}},[_c('v-icon',[_vm._v("mdi-minus-circle-outline")])],1):_vm._e()],1):_vm._e()],1)]}}],null,true)})]}}],null,true)})]})],2)],1)],1),_c('v-card-actions',[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.canChangeChannels),expression:"canChangeChannels"}],ref:"inputChannel",attrs:{"placeholder":"Create new chat room","single-line":"","hide-details":"","dense":"","flat":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.handleCreate.apply(null, arguments)}},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.handleCreate}},[_c('v-icon',[_vm._v("mdi-plus")])],1)]},proxy:true}]),model:{value:(_vm.textInput),callback:function ($$v) {_vm.textInput=$$v},expression:"textInput"}})],1)],1)],1)],1)}
var ChannelSelectvue_type_template_id_7b39d818_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ChannelSelect.vue?vue&type=template&id=7b39d818&scoped=true&

// CONCATENATED MODULE: ./src/util/colors.ts
var hexToRGB = function hexToRGB(h) {
  var r = 0,
      g = 0,
      b = 0; // 3 digits

  if (h.length == 4) {
    r = parseInt(h[1] + h[1], 16);
    g = parseInt(h[2] + h[2], 16);
    b = parseInt(h[3] + h[3], 16); // 6 digits
  } else if (h.length == 7) {
    r = parseInt(h[1] + h[2], 16);
    g = parseInt(h[3] + h[4], 16);
    b = parseInt(h[5] + h[6], 16);
  }

  return {
    r: r,
    g: g,
    b: b
  };
};
var colors_isDark = function isDark(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  var y = r * 0.299 + g * 0.587 + b * 0.114;
  return y / 255 < 0.5;
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChannelSelect.vue?vue&type=script&lang=ts&

















var ChannelSelectvue_type_script_lang_ts_ChannelSelect = /*#__PURE__*/function (_Vue) {
  _inherits(ChannelSelect, _Vue);

  var _super = _createSuper(ChannelSelect);

  function ChannelSelect() {
    var _this;

    _classCallCheck(this, ChannelSelect);

    _this = _super.apply(this, arguments);
    _this.channelMenuOpen = false;
    _this.textInput = "";
    return _this;
  }

  _createClass(ChannelSelect, [{
    key: "channelActive",
    get: function get() {
      return this.getChannelActive;
    },
    set: function set(c) {
      this.setChannelActive(c);
    }
  }, {
    key: "unreadMessages",
    get: function get() {
      return this.getChannelsSubscribed.reduce(function (acc, curr) {
        return acc + curr.unread;
      }, 0);
    }
  }, {
    key: "unreadMentions",
    get: function get() {
      return this.getChannelsSubscribed.reduce(function (acc, curr) {
        return acc + curr.unreadMentions;
      }, 0);
    }
  }, {
    key: "canChangeChannels",
    get: function get() {
      var _this$user, _this$user$roles, _this$user2, _this$user2$roles;

      return ((_this$user = this.user) === null || _this$user === void 0 ? void 0 : (_this$user$roles = _this$user.roles) === null || _this$user$roles === void 0 ? void 0 : _this$user$roles.includes(Role.ROLE_ADMIN)) || ((_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : (_this$user2$roles = _this$user2.roles) === null || _this$user2$roles === void 0 ? void 0 : _this$user2$roles.includes(Role.ROLE_MODERATOR));
    }
  }, {
    key: "brandTextColorLight",
    get: function get() {
      var _this$$vuetify$theme$;

      var col = (_this$$vuetify$theme$ = this.$vuetify.theme.currentTheme.brand) === null || _this$$vuetify$theme$ === void 0 ? void 0 : _this$$vuetify$theme$.toString();
      return !col || colors_isDark(hexToRGB(col));
    } // toggling menu has no good way to focus a contained input
    // https://github.com/vuetifyjs/vuetify/issues/4454#issuecomment-503681817

  }, {
    key: "onChannelMenuToggle",
    value: function onChannelMenuToggle() {
      var _this2 = this;

      if (this.channelMenuOpen) this.fetchChannels();
      setTimeout(function () {
        _this2.$refs.inputChannel.focus();
      }, 200);
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      if (!this.textInput.trim()) return;
      this.addChannel(this.textInput.trim());
      this.textInput = "";
    }
  }, {
    key: "deleteChannel",
    value: function deleteChannel(chan) {
      this.deleteChannelAction(chan);
    }
  }]);

  return ChannelSelect;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Getter("getChannels", {
  namespace: store_CHAT_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "channels", void 0);

__decorate([Getter("getChannelActive", {
  namespace: store_CHAT_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "getChannelActive", void 0);

__decorate([Getter("getChannelSelectOpen", {
  namespace: store_CHAT_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "channelSelectOpen", void 0);

__decorate([Getter("getChannelsSubscribed", {
  namespace: store_CHAT_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "getChannelsSubscribed", void 0);

__decorate([Getter("user", {
  namespace: USER_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "user", void 0);

__decorate([Prop({
  required: true
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "loading", void 0);

__decorate([bindings_Action("fetchChannels", {
  namespace: store_CHAT_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "fetchChannels", void 0);

__decorate([bindings_Action("setChannelActive", {
  namespace: store_CHAT_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "setChannelActive", void 0);

__decorate([bindings_Action("addChannel", {
  namespace: store_CHAT_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "addChannel", void 0);

__decorate([bindings_Action("deleteChannel", {
  namespace: store_CHAT_NAMESPACE
})], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "deleteChannelAction", void 0);

__decorate([Watch("channelMenuOpen")], ChannelSelectvue_type_script_lang_ts_ChannelSelect.prototype, "onChannelMenuToggle", null);

ChannelSelectvue_type_script_lang_ts_ChannelSelect = __decorate([vue_class_component_esm], ChannelSelectvue_type_script_lang_ts_ChannelSelect);
/* harmony default export */ var ChannelSelectvue_type_script_lang_ts_ = (ChannelSelectvue_type_script_lang_ts_ChannelSelect);
// CONCATENATED MODULE: ./src/components/ChannelSelect.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ChannelSelectvue_type_script_lang_ts_ = (ChannelSelectvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/ChannelSelect.vue?vue&type=style&index=0&lang=scss&
var ChannelSelectvue_type_style_index_0_lang_scss_ = __webpack_require__("f799");

// EXTERNAL MODULE: ./src/components/ChannelSelect.vue?vue&type=style&index=1&id=7b39d818&lang=scss&scoped=true&
var ChannelSelectvue_type_style_index_1_id_7b39d818_lang_scss_scoped_true_ = __webpack_require__("3950");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VBadge/VBadge.sass
var VBadge = __webpack_require__("ff44");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/transitionable/index.js

/* harmony default export */ var transitionable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'transitionable',
  props: {
    mode: String,
    origin: String,
    transition: String
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VBadge/VBadge.js


var VBadge_excluded = ["aria-atomic", "aria-label", "aria-live", "role", "title"];

// Styles
 // Components

 // Mixins





 // Utilities



/* harmony default export */ var VBadge_VBadge = (mixins_mixins(colorable, positionable_factory(['left', 'bottom']), themeable, toggleable, transitionable).extend({
  name: 'v-badge',
  props: {
    avatar: Boolean,
    bordered: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    content: {
      required: false
    },
    dot: Boolean,
    label: {
      type: String,
      default: '$vuetify.badge'
    },
    icon: String,
    inline: Boolean,
    offsetX: [Number, String],
    offsetY: [Number, String],
    overlap: Boolean,
    tile: Boolean,
    transition: {
      type: String,
      default: 'scale-rotate-transition'
    },
    value: {
      default: true
    }
  },
  computed: {
    classes: function classes() {
      return _objectSpread2({
        'v-badge--avatar': this.avatar,
        'v-badge--bordered': this.bordered,
        'v-badge--bottom': this.bottom,
        'v-badge--dot': this.dot,
        'v-badge--icon': this.icon != null,
        'v-badge--inline': this.inline,
        'v-badge--left': this.left,
        'v-badge--overlap': this.overlap,
        'v-badge--tile': this.tile
      }, this.themeClasses);
    },
    computedBottom: function computedBottom() {
      return this.bottom ? 'auto' : this.computedYOffset;
    },
    computedLeft: function computedLeft() {
      if (this.isRtl) {
        return this.left ? this.computedXOffset : 'auto';
      }

      return this.left ? 'auto' : this.computedXOffset;
    },
    computedRight: function computedRight() {
      if (this.isRtl) {
        return this.left ? 'auto' : this.computedXOffset;
      }

      return !this.left ? 'auto' : this.computedXOffset;
    },
    computedTop: function computedTop() {
      return this.bottom ? this.computedYOffset : 'auto';
    },
    computedXOffset: function computedXOffset() {
      return this.calcPosition(this.offsetX);
    },
    computedYOffset: function computedYOffset() {
      return this.calcPosition(this.offsetY);
    },
    isRtl: function isRtl() {
      return this.$vuetify.rtl;
    },
    // Default fallback if offsetX
    // or offsetY are undefined.
    offset: function offset() {
      if (this.overlap) return this.dot ? 8 : 12;
      return this.dot ? 2 : 4;
    },
    styles: function styles() {
      if (this.inline) return {};
      return {
        bottom: this.computedBottom,
        left: this.computedLeft,
        right: this.computedRight,
        top: this.computedTop
      };
    }
  },
  methods: {
    calcPosition: function calcPosition(offset) {
      return "calc(100% - ".concat(convertToUnit(offset || this.offset), ")");
    },
    genBadge: function genBadge() {
      var lang = this.$vuetify.lang;
      var label = this.$attrs['aria-label'] || lang.t(this.label);
      var data = this.setBackgroundColor(this.color, {
        staticClass: 'v-badge__badge',
        style: this.styles,
        attrs: {
          'aria-atomic': this.$attrs['aria-atomic'] || 'true',
          'aria-label': label,
          'aria-live': this.$attrs['aria-live'] || 'polite',
          title: this.$attrs.title,
          role: this.$attrs.role || 'status'
        },
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      });
      var badge = this.$createElement('span', data, [this.genBadgeContent()]);
      if (!this.transition) return badge;
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin,
          mode: this.mode
        }
      }, [badge]);
    },
    genBadgeContent: function genBadgeContent() {
      // Dot prop shows no content
      if (this.dot) return undefined;
      var slot = getSlot(this, 'badge');
      if (slot) return slot;
      if (this.content) return String(this.content);
      if (this.icon) return this.$createElement(components_VIcon_VIcon, this.icon);
      return undefined;
    },
    genBadgeWrapper: function genBadgeWrapper() {
      return this.$createElement('span', {
        staticClass: 'v-badge__wrapper'
      }, [this.genBadge()]);
    }
  },
  render: function render(h) {
    var badge = [this.genBadgeWrapper()];
    var children = [getSlot(this)];

    var _this$$attrs = this.$attrs,
        _x = _this$$attrs['aria-atomic'],
        _y = _this$$attrs['aria-label'],
        _z = _this$$attrs['aria-live'],
        role = _this$$attrs.role,
        title = _this$$attrs.title,
        attrs = _objectWithoutProperties(_this$$attrs, VBadge_excluded);

    if (this.inline && this.left) children.unshift(badge);else children.push(badge);
    return h('span', {
      staticClass: 'v-badge',
      attrs: attrs,
      class: this.classes
    }, children);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VLazy/VLazy.js

// Mixins

 // Directives

 // Utilities



/* harmony default export */ var VLazy = (mixins_mixins(measurable, toggleable).extend({
  name: 'VLazy',
  directives: {
    intersect: intersect
  },
  props: {
    options: {
      type: Object,
      // For more information on types, navigate to:
      // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      default: function _default() {
        return {
          root: undefined,
          rootMargin: undefined,
          threshold: undefined
        };
      }
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: String,
      default: 'fade-transition'
    }
  },
  computed: {
    styles: function styles() {
      return _objectSpread2({}, this.measurableStyles);
    }
  },
  methods: {
    genContent: function genContent() {
      var children = this.isActive && getSlot(this);
      return this.transition ? this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, children) : children;
    },
    onObserve: function onObserve(entries, observer, isIntersecting) {
      if (this.isActive) return;
      this.isActive = isIntersecting;
    }
  },
  render: function render(h) {
    return h(this.tag, {
      staticClass: 'v-lazy',
      attrs: this.$attrs,
      directives: [{
        name: 'intersect',
        value: {
          handler: this.onObserve,
          options: this.options
        }
      }],
      on: this.$listeners,
      style: this.styles
    }, [this.genContent()]);
  }
}));
// CONCATENATED MODULE: ./src/components/ChannelSelect.vue







/* normalize component */

var ChannelSelect_component = normalizeComponent(
  components_ChannelSelectvue_type_script_lang_ts_,
  ChannelSelectvue_type_template_id_7b39d818_scoped_true_render,
  ChannelSelectvue_type_template_id_7b39d818_scoped_true_staticRenderFns,
  false,
  null,
  "7b39d818",
  null
  
)

/* harmony default export */ var components_ChannelSelect = (ChannelSelect_component.exports);

/* vuetify-loader */


















installComponents_default()(ChannelSelect_component, {VBadge: VBadge_VBadge,VBtn: VBtn_VBtn,VCard: VCard_VCard,VCardActions: VCardActions,VCardSubtitle: VCardSubtitle,VFadeTransition: VFadeTransition,VHover: VHover,VIcon: components_VIcon_VIcon,VLazy: VLazy,VList: VList_VList,VListItem: VList_VListItem,VListItemContent: VListItemContent,VListItemGroup: VList_VListItemGroup,VListItemTitle: VListItemTitle,VMenu: VMenu_VMenu,VOverlay: VOverlay_VOverlay,VTextField: VTextField_VTextField})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserList/UserList.vue?vue&type=template&id=3d12ab11&scoped=true&
var UserListvue_type_template_id_3d12ab11_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.channelActive && _vm.channelActive.users)?_c('v-menu',{attrs:{"offset-y":"","content-class":"bottom-menu","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-2 px-0",attrs:{"text":"","small":""}},'v-btn',attrs,false),on),[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"","color":"primary"}},[_vm._v("mdi-account-multiple")]),_vm._v(" "+_vm._s(_vm.userNumber)+" ")],1)]}}],null,false,1490763871),model:{value:(_vm.bottomMenu),callback:function ($$v) {_vm.bottomMenu=$$v},expression:"bottomMenu"}},[_c('v-card',{staticClass:"bottom-menu-inner"},[_c('v-tabs',{attrs:{"slider-color":"brand"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',[_vm._v(_vm._s(_vm.$t("s8c.Active")))]),_c('v-tab-item',{key:"Active"},[_c('users-online',{on:{"user-clicked":function (hm) { return _vm.$emit('user-clicked', hm); }}})],1),_c('v-tab',[_vm._v(_vm._s(_vm.$t("s8c.Muted")))]),_c('v-tab-item',{key:"Muted"},[_c('users-muted')],1)],1)],1)],1):_vm._e()}
var UserListvue_type_template_id_3d12ab11_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UserList/UserList.vue?vue&type=template&id=3d12ab11&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserList/UsersMuted.vue?vue&type=template&id=31ef7722&scoped=true&
var UsersMutedvue_type_template_id_31ef7722_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"px-0"},[(_vm.selectedUser)?_c('v-dialog',{attrs:{"persistent":"","max-width":"460"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("s8c.Unmute"))+" "+_vm._s(_vm.selectedUser.displayName)+"? ")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary darken-1","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v(" "+_vm._s(_vm.$t("s8c.Disagree"))+" ")]),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":_vm.handleUnignore}},[_vm._v(" "+_vm._s(_vm.$t("s8c.Agree"))+" ")])],1)],1)],1):_vm._e(),_c('v-list',{staticClass:"overflow-y-auto",attrs:{"dense":""}},[_vm._l((_vm.ignored),function(user){return [_c('v-hover',{key:user.id,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-list-item',{attrs:{"value":user},on:{"click":function($event){return _vm.$emit('user-clicked', user ? user.id : '')}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(user ? user.displayName : "no-name")+" ")])],1),_c('v-fade-transition',[(hover)?_c('v-list-item-action',{staticStyle:{"margin-top":"0","margin-bottom":"0"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.handleUnignoreMenu(user)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("mdi-minus-circle-outline")])],1)],1):_vm._e()],1)],1)]}}],null,true)})]})],2)],1)}
var UsersMutedvue_type_template_id_31ef7722_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UserList/UsersMuted.vue?vue&type=template&id=31ef7722&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserList/UsersMuted.vue?vue&type=script&lang=ts&










var UsersMutedvue_type_script_lang_ts_UsersMuted = /*#__PURE__*/function (_Vue) {
  _inherits(UsersMuted, _Vue);

  var _super = _createSuper(UsersMuted);

  function UsersMuted() {
    var _this;

    _classCallCheck(this, UsersMuted);

    _this = _super.apply(this, arguments);
    _this.dialog = false;
    _this.menu = false;
    _this.menuX = 0;
    _this.menuY = 0;
    _this.remSize = 16;
    _this.loading = false;
    _this.textInput = "";
    _this.selectedUsers = [];
    _this.selectedUser = null;
    return _this;
  }

  _createClass(UsersMuted, [{
    key: "created",
    value: function created() {
      this.remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    } // handleMenu(e: PointerEvent) {
    //   if (!this.menu) {
    //     this.menuX = e.clientX;
    //     // this.menuY = e.clientY;
    //     this.menuY = window.innerHeight - 16 * this.remSize;
    //     this.menu = true;
    //     console.log(`x: ${e.clientX}`);
    //   }
    // }

  }, {
    key: "handleUnignoreMenu",
    value: function handleUnignoreMenu(u) {
      this.selectedUser = u;
      this.dialog = true;
    }
  }, {
    key: "handleUnignore",
    value: function handleUnignore() {
      this.dialog = false;
      if (this.selectedUser) this.unignoreUser(this.selectedUser);
    }
  }]);

  return UsersMuted;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([bindings_Action("unignoreUser", {
  namespace: USER_NAMESPACE
})], UsersMutedvue_type_script_lang_ts_UsersMuted.prototype, "unignoreUser", void 0);

__decorate([Getter("getChannelActive", {
  namespace: store_CHAT_NAMESPACE
})], UsersMutedvue_type_script_lang_ts_UsersMuted.prototype, "channelActive", void 0);

__decorate([Getter("ignored", {
  namespace: USER_NAMESPACE
})], UsersMutedvue_type_script_lang_ts_UsersMuted.prototype, "ignored", void 0);

UsersMutedvue_type_script_lang_ts_UsersMuted = __decorate([vue_class_component_esm], UsersMutedvue_type_script_lang_ts_UsersMuted);
/* harmony default export */ var UsersMutedvue_type_script_lang_ts_ = (UsersMutedvue_type_script_lang_ts_UsersMuted);
// CONCATENATED MODULE: ./src/components/UserList/UsersMuted.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UserList_UsersMutedvue_type_script_lang_ts_ = (UsersMutedvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UserList/UsersMuted.vue?vue&type=style&index=0&id=31ef7722&scoped=true&lang=css&
var UsersMutedvue_type_style_index_0_id_31ef7722_scoped_true_lang_css_ = __webpack_require__("e128");

// CONCATENATED MODULE: ./src/components/UserList/UsersMuted.vue






/* normalize component */

var UsersMuted_component = normalizeComponent(
  UserList_UsersMutedvue_type_script_lang_ts_,
  UsersMutedvue_type_template_id_31ef7722_scoped_true_render,
  UsersMutedvue_type_template_id_31ef7722_scoped_true_staticRenderFns,
  false,
  null,
  "31ef7722",
  null
  
)

/* harmony default export */ var UserList_UsersMuted = (UsersMuted_component.exports);

/* vuetify-loader */
















installComponents_default()(UsersMuted_component, {VBtn: VBtn_VBtn,VCard: VCard_VCard,VCardActions: VCardActions,VCardText: VCardText,VCardTitle: VCardTitle,VDialog: VDialog_VDialog,VFadeTransition: VFadeTransition,VHover: VHover,VIcon: components_VIcon_VIcon,VList: VList_VList,VListItem: VList_VListItem,VListItemAction: VListItemAction,VListItemContent: VListItemContent,VListItemTitle: VListItemTitle,VSpacer: VSpacer})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserList/UsersOnline.vue?vue&type=template&id=4fabab9c&scoped=true&
var UsersOnlinevue_type_template_id_4fabab9c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"px-0"},[_c('v-list',{staticClass:"overflow-y-auto",attrs:{"dense":""}},[_vm._l((_vm.usersFiltered),function(user){return [_c('v-list-item',{key:user.id,attrs:{"value":user},on:{"click":function($event){return _vm.$emit('user-clicked', user.displayName ? user.displayName : '')}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(user.displayName ? user.displayName : "no-name")+" ")])],1)],1)]})],2)],1)}
var UsersOnlinevue_type_template_id_4fabab9c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UserList/UsersOnline.vue?vue&type=template&id=4fabab9c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserList/UsersOnline.vue?vue&type=script&lang=ts&











var UsersOnlinevue_type_script_lang_ts_UsersOnline = /*#__PURE__*/function (_Vue) {
  _inherits(UsersOnline, _Vue);

  var _super = _createSuper(UsersOnline);

  function UsersOnline() {
    var _this;

    _classCallCheck(this, UsersOnline);

    _this = _super.apply(this, arguments);
    _this.menu = false;
    _this.menuX = 0;
    _this.menuY = 0;
    _this.remSize = 16;
    _this.loading = false;
    _this.textInput = "";
    _this.selectedUsers = [];
    return _this;
  }

  _createClass(UsersOnline, [{
    key: "created",
    value: function created() {
      this.remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    }
  }, {
    key: "usersFiltered",
    get: function get() {
      var _this2 = this;

      return this.channelActive.users.filter(function (u) {
        var _u$displayName;

        return ((_u$displayName = u.displayName) === null || _u$displayName === void 0 ? void 0 : _u$displayName.indexOf(_this2.textInput)) !== -1;
      });
    }
  }, {
    key: "handleMenu",
    value: function handleMenu(e) {
      if (!this.menu) {
        this.menuX = e.clientX; // this.menuY = e.clientY;

        this.menuY = window.innerHeight - 16 * this.remSize;
        this.menu = true; // console.log(`x: ${e.clientX}`);
      }
    }
  }]);

  return UsersOnline;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Getter("getChannelActive", {
  namespace: store_CHAT_NAMESPACE
})], UsersOnlinevue_type_script_lang_ts_UsersOnline.prototype, "channelActive", void 0);

UsersOnlinevue_type_script_lang_ts_UsersOnline = __decorate([vue_class_component_esm], UsersOnlinevue_type_script_lang_ts_UsersOnline);
/* harmony default export */ var UsersOnlinevue_type_script_lang_ts_ = (UsersOnlinevue_type_script_lang_ts_UsersOnline);
// CONCATENATED MODULE: ./src/components/UserList/UsersOnline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UserList_UsersOnlinevue_type_script_lang_ts_ = (UsersOnlinevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UserList/UsersOnline.vue?vue&type=style&index=0&id=4fabab9c&scoped=true&lang=css&
var UsersOnlinevue_type_style_index_0_id_4fabab9c_scoped_true_lang_css_ = __webpack_require__("29d7");

// CONCATENATED MODULE: ./src/components/UserList/UsersOnline.vue






/* normalize component */

var UsersOnline_component = normalizeComponent(
  UserList_UsersOnlinevue_type_script_lang_ts_,
  UsersOnlinevue_type_template_id_4fabab9c_scoped_true_render,
  UsersOnlinevue_type_template_id_4fabab9c_scoped_true_staticRenderFns,
  false,
  null,
  "4fabab9c",
  null
  
)

/* harmony default export */ var UserList_UsersOnline = (UsersOnline_component.exports);

/* vuetify-loader */






installComponents_default()(UsersOnline_component, {VCardText: VCardText,VList: VList_VList,VListItem: VList_VListItem,VListItemContent: VListItemContent,VListItemTitle: VListItemTitle})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserList/UserList.vue?vue&type=script&lang=ts&











var UserListvue_type_script_lang_ts_UserList = /*#__PURE__*/function (_Vue) {
  _inherits(UserList, _Vue);

  var _super = _createSuper(UserList);

  function UserList() {
    var _this;

    _classCallCheck(this, UserList);

    _this = _super.apply(this, arguments); // isAdmin = true;

    _this.menu = false;
    _this.menuX = 0;
    _this.menuY = 0;
    _this.remSize = 16;
    _this.loading = false;
    _this.textInput = "";
    _this.selectedUsers = [];
    _this.bottomMenu = false;
    _this.userNumber = 0;
    _this.userNumberUpdateTimer = 0; // fetch users at most every 20s

    _this.fetchCooldown = 20000;
    _this.fetchLast = 0;
    _this.tab = "Active";
    return _this;
  }

  _createClass(UserList, [{
    key: "onMenuChanged",
    value: function onMenuChanged(menu) {
      var ready = Date.now() - this.fetchLast > this.fetchCooldown;

      if (menu && this.channelActive && ready) {
        this.fetchLast = Date.now();
        this.fetchChannelUsers(this.channelActive);
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      clearTimeout(this.userNumberUpdateTimer);
      this.updateUserNumber();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      clearTimeout(this.userNumberUpdateTimer);
    }
  }, {
    key: "updateUserNumber",
    value: function updateUserNumber() {
      try {
        var _this$channelActive;

        this.userNumber = (_this$channelActive = this.channelActive) === null || _this$channelActive === void 0 ? void 0 : _this$channelActive.users.length;
      } finally {
        this.userNumberUpdateTimer = setTimeout(this.updateUserNumber, 20000);
      }
    }
  }]);

  return UserList;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Getter("getChannelActive", {
  namespace: store_CHAT_NAMESPACE
})], UserListvue_type_script_lang_ts_UserList.prototype, "channelActive", void 0);

__decorate([bindings_Action("fetchChannelUsers", {
  namespace: store_CHAT_NAMESPACE
})], UserListvue_type_script_lang_ts_UserList.prototype, "fetchChannelUsers", void 0);

__decorate([Watch("bottomMenu")], UserListvue_type_script_lang_ts_UserList.prototype, "onMenuChanged", null);

UserListvue_type_script_lang_ts_UserList = __decorate([vue_class_component_esm({
  components: {
    UsersMuted: UserList_UsersMuted,
    UsersOnline: UserList_UsersOnline
  }
})], UserListvue_type_script_lang_ts_UserList);
/* harmony default export */ var UserListvue_type_script_lang_ts_ = (UserListvue_type_script_lang_ts_UserList);
// CONCATENATED MODULE: ./src/components/UserList/UserList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UserList_UserListvue_type_script_lang_ts_ = (UserListvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UserList/UserList.vue?vue&type=style&index=0&id=3d12ab11&scoped=true&lang=scss&
var UserListvue_type_style_index_0_id_3d12ab11_scoped_true_lang_scss_ = __webpack_require__("6ac9");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTabs/VTab.js



// Mixins


 // Utilities



var VTab_baseMixins = mixins_mixins(routable, // Must be after routable
// to overwrite activeClass
groupable_factory('tabsBar'), themeable);
/* harmony default export */ var VTab = (VTab_baseMixins.extend().extend().extend({
  name: 'v-tab',
  props: {
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  data: function data() {
    return {
      proxyClass: 'v-tab--active'
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({
        'v-tab': true
      }, routable.options.computed.classes.call(this)), {}, {
        'v-tab--disabled': this.disabled
      }, this.groupClasses);
    },
    value: function value() {
      var to = this.to || this.href;
      if (to == null) return to;

      if (this.$router && this.to === Object(this.to)) {
        var resolve = this.$router.resolve(this.to, this.$route, this.append);
        to = resolve.href;
      }

      return to.replace('#', '');
    }
  },
  methods: {
    click: function click(e) {
      // Prevent keyboard actions
      // from children elements
      // within disabled tabs
      if (this.disabled) {
        e.preventDefault();
        return;
      } // If user provides an
      // actual link, do not
      // prevent default


      if (this.href && this.href.indexOf('#') > -1) e.preventDefault();
      if (e.detail) this.$el.blur();
      this.$emit('click', e);
      this.to || this.toggle();
    },
    toggle: function toggle() {
      // VItemGroup treats a change event as a click
      if (!this.isActive || !this.tabsBar.mandatory && !this.to) {
        this.$emit('change');
      }
    }
  },
  render: function render(h) {
    var _this = this;

    var _this$generateRouteLi = this.generateRouteLink(),
        tag = _this$generateRouteLi.tag,
        data = _this$generateRouteLi.data;

    data.attrs = _objectSpread2(_objectSpread2({}, data.attrs), {}, {
      'aria-selected': String(this.isActive),
      role: 'tab',
      tabindex: 0
    });
    data.on = _objectSpread2(_objectSpread2({}, data.on), {}, {
      keydown: function keydown(e) {
        if (e.keyCode === keyCodes.enter) _this.click(e);

        _this.$emit('keydown', e);
      }
    });
    return h(tag, data, this.$slots.default);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/directives/touch/index.js





var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;
  var dirRatio = 0.5;
  var minDistance = 16;
  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
    wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
    wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
  }

  if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
    wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
    wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
  }
};

function _touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;
  wrapper.start && wrapper.start(Object.assign(event, wrapper));
}

function _touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;
  wrapper.end && wrapper.end(Object.assign(event, wrapper));
  handleGesture(wrapper);
}

function _touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;
  wrapper.move && wrapper.move(Object.assign(event, wrapper));
}

function createHandlers(value) {
  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };
  return {
    touchstart: function touchstart(e) {
      return _touchstart(e, wrapper);
    },
    touchend: function touchend(e) {
      return _touchend(e, wrapper);
    },
    touchmove: function touchmove(e) {
      return _touchmove(e, wrapper);
    }
  };
}

function touch_inserted(el, binding, vnode) {
  var value = binding.value;
  var target = value.parent ? el.parentElement : el;
  var options = value.options || {
    passive: true
  }; // Needed to pass unit tests

  if (!target) return;
  var handlers = createHandlers(binding.value);
  target._touchHandlers = Object(target._touchHandlers);
  target._touchHandlers[vnode.context._uid] = handlers;
  keys(handlers).forEach(function (eventName) {
    target.addEventListener(eventName, handlers[eventName], options);
  });
}

function touch_unbind(el, binding, vnode) {
  var target = binding.value.parent ? el.parentElement : el;
  if (!target || !target._touchHandlers) return;
  var handlers = target._touchHandlers[vnode.context._uid];
  keys(handlers).forEach(function (eventName) {
    target.removeEventListener(eventName, handlers[eventName]);
  });
  delete target._touchHandlers[vnode.context._uid];
}

var Touch = {
  inserted: touch_inserted,
  unbind: touch_unbind
};
/* harmony default export */ var directives_touch = (Touch);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VWindow/VWindowItem.js
// Mixins

 // Directives

 // Utilities



var VWindowItem_baseMixins = mixins_mixins(bootable, groupable_factory('windowGroup', 'v-window-item', 'v-window'));
/* harmony default export */ var VWindowItem = (VWindowItem_baseMixins.extend().extend().extend({
  name: 'v-window-item',
  directives: {
    Touch: directives_touch
  },
  props: {
    disabled: Boolean,
    reverseTransition: {
      type: [Boolean, String],
      default: undefined
    },
    transition: {
      type: [Boolean, String],
      default: undefined
    },
    value: {
      required: false
    }
  },
  data: function data() {
    return {
      isActive: false,
      inTransition: false
    };
  },
  computed: {
    classes: function classes() {
      return this.groupClasses;
    },
    computedTransition: function computedTransition() {
      if (!this.windowGroup.internalReverse) {
        return typeof this.transition !== 'undefined' ? this.transition || '' : this.windowGroup.computedTransition;
      }

      return typeof this.reverseTransition !== 'undefined' ? this.reverseTransition || '' : this.windowGroup.computedTransition;
    }
  },
  methods: {
    genDefaultSlot: function genDefaultSlot() {
      return this.$slots.default;
    },
    genWindowItem: function genWindowItem() {
      return this.$createElement('div', {
        staticClass: 'v-window-item',
        class: this.classes,
        directives: [{
          name: 'show',
          value: this.isActive
        }],
        on: this.$listeners
      }, this.genDefaultSlot());
    },
    onAfterTransition: function onAfterTransition() {
      if (!this.inTransition) {
        return;
      } // Finalize transition state.


      this.inTransition = false;

      if (this.windowGroup.transitionCount > 0) {
        this.windowGroup.transitionCount--; // Remove container height if we are out of transition.

        if (this.windowGroup.transitionCount === 0) {
          this.windowGroup.transitionHeight = undefined;
        }
      }
    },
    onBeforeTransition: function onBeforeTransition() {
      if (this.inTransition) {
        return;
      } // Initialize transition state here.


      this.inTransition = true;

      if (this.windowGroup.transitionCount === 0) {
        // Set initial height for height transition.
        this.windowGroup.transitionHeight = convertToUnit(this.windowGroup.$el.clientHeight);
      }

      this.windowGroup.transitionCount++;
    },
    onTransitionCancelled: function onTransitionCancelled() {
      this.onAfterTransition(); // This should have the same path as normal transition end.
    },
    onEnter: function onEnter(el) {
      var _this = this;

      if (!this.inTransition) {
        return;
      }

      this.$nextTick(function () {
        // Do not set height if no transition or cancelled.
        if (!_this.computedTransition || !_this.inTransition) {
          return;
        } // Set transition target height.


        _this.windowGroup.transitionHeight = convertToUnit(el.clientHeight);
      });
    }
  },
  render: function render(h) {
    var _this2 = this;

    return h('transition', {
      props: {
        name: this.computedTransition
      },
      on: {
        // Handlers for enter windows.
        beforeEnter: this.onBeforeTransition,
        afterEnter: this.onAfterTransition,
        enterCancelled: this.onTransitionCancelled,
        // Handlers for leave windows.
        beforeLeave: this.onBeforeTransition,
        afterLeave: this.onAfterTransition,
        leaveCancelled: this.onTransitionCancelled,
        // Enter handler for height transition.
        enter: this.onEnter
      }
    }, this.showLazyContent(function () {
      return [_this2.genWindowItem()];
    }));
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTabs/VTabItem.js
// Extensions

/* @vue/component */

/* harmony default export */ var VTabItem = (VWindowItem.extend({
  name: 'v-tab-item',
  props: {
    id: String
  },
  methods: {
    genWindowItem: function genWindowItem() {
      var item = VWindowItem.options.methods.genWindowItem.call(this);
      item.data.domProps = item.data.domProps || {};
      item.data.domProps.id = this.id || this.value;
      return item;
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VTabs/VTabs.sass
var VTabs = __webpack_require__("1bfb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.sign.js
var es_math_sign = __webpack_require__("2af1");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSlideGroup/VSlideGroup.sass
var VSlideGroup = __webpack_require__("608c");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/mobile/index.js





/* @vue/component */

/* harmony default export */ var mobile = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'mobile',
  props: {
    mobileBreakpoint: {
      type: [Number, String],
      default: function _default() {
        // Avoid destroying unit
        // tests for users
        return this.$vuetify ? this.$vuetify.breakpoint.mobileBreakpoint : undefined;
      },
      validator: function validator(v) {
        return !isNaN(Number(v)) || ['xs', 'sm', 'md', 'lg', 'xl'].includes(String(v));
      }
    }
  },
  computed: {
    isMobile: function isMobile() {
      var _this$$vuetify$breakp = this.$vuetify.breakpoint,
          mobile = _this$$vuetify$breakp.mobile,
          width = _this$$vuetify$breakp.width,
          name = _this$$vuetify$breakp.name,
          mobileBreakpoint = _this$$vuetify$breakp.mobileBreakpoint; // Check if local mobileBreakpoint matches
      // the application's mobileBreakpoint

      if (mobileBreakpoint === this.mobileBreakpoint) return mobile;
      var mobileWidth = parseInt(this.mobileBreakpoint, 10);
      var isNumber = !isNaN(mobileWidth);
      return isNumber ? width < mobileWidth : name === this.mobileBreakpoint;
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('mobile-break-point')) {
      deprecate('mobile-break-point', 'mobile-breakpoint', this);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSlideGroup/VSlideGroup.js






// Styles
 // Components


 // Extensions

 // Mixins

 // Directives


 // Utilities




function bias(val) {
  var c = 0.501;
  var x = Math.abs(val);
  return Math.sign(val) * (x / ((1 / c - 2) * (1 - x) + 1));
}

function calculateUpdatedOffset(selectedElement, widths, rtl, currentScrollOffset) {
  var clientWidth = selectedElement.clientWidth;
  var offsetLeft = rtl ? widths.content - selectedElement.offsetLeft - clientWidth : selectedElement.offsetLeft;

  if (rtl) {
    currentScrollOffset = -currentScrollOffset;
  }

  var totalWidth = widths.wrapper + currentScrollOffset;
  var itemOffset = clientWidth + offsetLeft;
  var additionalOffset = clientWidth * 0.4;

  if (offsetLeft <= currentScrollOffset) {
    currentScrollOffset = Math.max(offsetLeft - additionalOffset, 0);
  } else if (totalWidth <= itemOffset) {
    currentScrollOffset = Math.min(currentScrollOffset - (totalWidth - itemOffset - additionalOffset), widths.content - widths.wrapper);
  }

  return rtl ? -currentScrollOffset : currentScrollOffset;
}
function calculateCenteredOffset(selectedElement, widths, rtl) {
  var offsetLeft = selectedElement.offsetLeft,
      clientWidth = selectedElement.clientWidth;

  if (rtl) {
    var offsetCentered = widths.content - offsetLeft - clientWidth / 2 - widths.wrapper / 2;
    return -Math.min(widths.content - widths.wrapper, Math.max(0, offsetCentered));
  } else {
    var _offsetCentered = offsetLeft + clientWidth / 2 - widths.wrapper / 2;

    return Math.min(widths.content - widths.wrapper, Math.max(0, _offsetCentered));
  }
}
var BaseSlideGroup = mixins_mixins(BaseItemGroup, mobile).extend({
  name: 'base-slide-group',
  directives: {
    Resize: resize,
    Touch: directives_touch
  },
  props: {
    activeClass: {
      type: String,
      default: 'v-slide-item--active'
    },
    centerActive: Boolean,
    nextIcon: {
      type: String,
      default: '$next'
    },
    prevIcon: {
      type: String,
      default: '$prev'
    },
    showArrows: {
      type: [Boolean, String],
      validator: function validator(v) {
        return typeof v === 'boolean' || ['always', 'desktop', 'mobile'].includes(v);
      }
    }
  },
  data: function data() {
    return {
      internalItemsLength: 0,
      isOverflowing: false,
      resizeTimeout: 0,
      startX: 0,
      isSwipingHorizontal: false,
      isSwiping: false,
      scrollOffset: 0,
      widths: {
        content: 0,
        wrapper: 0
      }
    };
  },
  computed: {
    canTouch: function canTouch() {
      return typeof window !== 'undefined';
    },
    __cachedNext: function __cachedNext() {
      return this.genTransition('next');
    },
    __cachedPrev: function __cachedPrev() {
      return this.genTransition('prev');
    },
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, BaseItemGroup.options.computed.classes.call(this)), {}, {
        'v-slide-group': true,
        'v-slide-group--has-affixes': this.hasAffixes,
        'v-slide-group--is-overflowing': this.isOverflowing
      });
    },
    hasAffixes: function hasAffixes() {
      switch (this.showArrows) {
        // Always show arrows on desktop & mobile
        case 'always':
          return true;
        // Always show arrows on desktop

        case 'desktop':
          return !this.isMobile;
        // Show arrows on mobile when overflowing.
        // This matches the default 2.2 behavior

        case true:
          return this.isOverflowing || Math.abs(this.scrollOffset) > 0;
        // Always show on mobile

        case 'mobile':
          return this.isMobile || this.isOverflowing || Math.abs(this.scrollOffset) > 0;
        // https://material.io/components/tabs#scrollable-tabs
        // Always show arrows when
        // overflowed on desktop

        default:
          return !this.isMobile && (this.isOverflowing || Math.abs(this.scrollOffset) > 0);
      }
    },
    hasNext: function hasNext() {
      if (!this.hasAffixes) return false;
      var _this$widths = this.widths,
          content = _this$widths.content,
          wrapper = _this$widths.wrapper; // Check one scroll ahead to know the width of right-most item

      return content > Math.abs(this.scrollOffset) + wrapper;
    },
    hasPrev: function hasPrev() {
      return this.hasAffixes && this.scrollOffset !== 0;
    }
  },
  watch: {
    internalValue: 'setWidths',
    // When overflow changes, the arrows alter
    // the widths of the content and wrapper
    // and need to be recalculated
    isOverflowing: 'setWidths',
    scrollOffset: function scrollOffset(val) {
      if (this.$vuetify.rtl) val = -val;
      var scroll = val <= 0 ? bias(-val) : val > this.widths.content - this.widths.wrapper ? -(this.widths.content - this.widths.wrapper) + bias(this.widths.content - this.widths.wrapper - val) : -val;
      if (this.$vuetify.rtl) scroll = -scroll;
      this.$refs.content.style.transform = "translateX(".concat(scroll, "px)");
    }
  },
  beforeUpdate: function beforeUpdate() {
    this.internalItemsLength = (this.$children || []).length;
  },
  updated: function updated() {
    if (this.internalItemsLength === (this.$children || []).length) return;
    this.setWidths();
  },
  methods: {
    onScroll: function onScroll() {
      this.$refs.wrapper.scrollLeft = 0;
    },
    onFocusin: function onFocusin(e) {
      if (!this.isOverflowing) return; // Focused element is likely to be the root of an item, so a
      // breadth-first search will probably find it in the first iteration

      var _iterator = _createForOfIteratorHelper(composedPath(e)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;

          var _iterator2 = _createForOfIteratorHelper(this.items),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var vm = _step2.value;

              if (vm.$el === el) {
                this.scrollOffset = calculateUpdatedOffset(vm.$el, this.widths, this.$vuetify.rtl, this.scrollOffset);
                return;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    // Always generate next for scrollable hint
    genNext: function genNext() {
      var _this = this;

      var slot = this.$scopedSlots.next ? this.$scopedSlots.next({}) : this.$slots.next || this.__cachedNext;
      return this.$createElement('div', {
        staticClass: 'v-slide-group__next',
        class: {
          'v-slide-group__next--disabled': !this.hasNext
        },
        on: {
          click: function click() {
            return _this.onAffixClick('next');
          }
        },
        key: 'next'
      }, [slot]);
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-slide-group__content',
        ref: 'content',
        on: {
          focusin: this.onFocusin
        }
      }, this.$slots.default);
    },
    genData: function genData() {
      return {
        class: this.classes,
        directives: [{
          name: 'resize',
          value: this.onResize
        }]
      };
    },
    genIcon: function genIcon(location) {
      var icon = location;

      if (this.$vuetify.rtl && location === 'prev') {
        icon = 'next';
      } else if (this.$vuetify.rtl && location === 'next') {
        icon = 'prev';
      }

      var upperLocation = "".concat(location[0].toUpperCase()).concat(location.slice(1));
      var hasAffix = this["has".concat(upperLocation)];
      if (!this.showArrows && !hasAffix) return null;
      return this.$createElement(components_VIcon, {
        props: {
          disabled: !hasAffix
        }
      }, this["".concat(icon, "Icon")]);
    },
    // Always generate prev for scrollable hint
    genPrev: function genPrev() {
      var _this2 = this;

      var slot = this.$scopedSlots.prev ? this.$scopedSlots.prev({}) : this.$slots.prev || this.__cachedPrev;
      return this.$createElement('div', {
        staticClass: 'v-slide-group__prev',
        class: {
          'v-slide-group__prev--disabled': !this.hasPrev
        },
        on: {
          click: function click() {
            return _this2.onAffixClick('prev');
          }
        },
        key: 'prev'
      }, [slot]);
    },
    genTransition: function genTransition(location) {
      return this.$createElement(VFadeTransition, [this.genIcon(location)]);
    },
    genWrapper: function genWrapper() {
      var _this3 = this;

      return this.$createElement('div', {
        staticClass: 'v-slide-group__wrapper',
        directives: [{
          name: 'touch',
          value: {
            start: function start(e) {
              return _this3.overflowCheck(e, _this3.onTouchStart);
            },
            move: function move(e) {
              return _this3.overflowCheck(e, _this3.onTouchMove);
            },
            end: function end(e) {
              return _this3.overflowCheck(e, _this3.onTouchEnd);
            }
          }
        }],
        ref: 'wrapper',
        on: {
          scroll: this.onScroll
        }
      }, [this.genContent()]);
    },
    calculateNewOffset: function calculateNewOffset(direction, widths, rtl, currentScrollOffset) {
      var sign = rtl ? -1 : 1;
      var newAbosluteOffset = sign * currentScrollOffset + (direction === 'prev' ? -1 : 1) * widths.wrapper;
      return sign * Math.max(Math.min(newAbosluteOffset, widths.content - widths.wrapper), 0);
    },
    onAffixClick: function onAffixClick(location) {
      this.$emit("click:".concat(location));
      this.scrollTo(location);
    },
    onResize: function onResize() {
      /* istanbul ignore next */
      if (this._isDestroyed) return;
      this.setWidths();
    },
    onTouchStart: function onTouchStart(e) {
      var content = this.$refs.content;
      this.startX = this.scrollOffset + e.touchstartX;
      content.style.setProperty('transition', 'none');
      content.style.setProperty('willChange', 'transform');
    },
    onTouchMove: function onTouchMove(e) {
      if (!this.canTouch) return;

      if (!this.isSwiping) {
        // only calculate disableSwipeHorizontal during the first onTouchMove invoke
        // in order to ensure disableSwipeHorizontal value is consistent between onTouchStart and onTouchEnd
        var diffX = e.touchmoveX - e.touchstartX;
        var diffY = e.touchmoveY - e.touchstartY;
        this.isSwipingHorizontal = Math.abs(diffX) > Math.abs(diffY);
        this.isSwiping = true;
      }

      if (this.isSwipingHorizontal) {
        // sliding horizontally
        this.scrollOffset = this.startX - e.touchmoveX; // temporarily disable window vertical scrolling

        document.documentElement.style.overflowY = 'hidden';
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (!this.canTouch) return;
      var _this$$refs = this.$refs,
          content = _this$$refs.content,
          wrapper = _this$$refs.wrapper;
      var maxScrollOffset = content.clientWidth - wrapper.clientWidth;
      content.style.setProperty('transition', null);
      content.style.setProperty('willChange', null);

      if (this.$vuetify.rtl) {
        /* istanbul ignore else */
        if (this.scrollOffset > 0 || !this.isOverflowing) {
          this.scrollOffset = 0;
        } else if (this.scrollOffset <= -maxScrollOffset) {
          this.scrollOffset = -maxScrollOffset;
        }
      } else {
        /* istanbul ignore else */
        if (this.scrollOffset < 0 || !this.isOverflowing) {
          this.scrollOffset = 0;
        } else if (this.scrollOffset >= maxScrollOffset) {
          this.scrollOffset = maxScrollOffset;
        }
      }

      this.isSwiping = false; // rollback whole page scrolling to default

      document.documentElement.style.removeProperty('overflow-y');
    },
    overflowCheck: function overflowCheck(e, fn) {
      e.stopPropagation();
      this.isOverflowing && fn(e);
    },
    scrollIntoView
    /* istanbul ignore next */
    : function scrollIntoView() {
      if (!this.selectedItem && this.items.length) {
        var lastItemPosition = this.items[this.items.length - 1].$el.getBoundingClientRect();
        var wrapperPosition = this.$refs.wrapper.getBoundingClientRect();

        if (this.$vuetify.rtl && wrapperPosition.right < lastItemPosition.right || !this.$vuetify.rtl && wrapperPosition.left > lastItemPosition.left) {
          this.scrollTo('prev');
        }
      }

      if (!this.selectedItem) {
        return;
      }

      if (this.selectedIndex === 0 || !this.centerActive && !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.centerActive) {
        this.scrollOffset = calculateCenteredOffset(this.selectedItem.$el, this.widths, this.$vuetify.rtl);
      } else if (this.isOverflowing) {
        this.scrollOffset = calculateUpdatedOffset(this.selectedItem.$el, this.widths, this.$vuetify.rtl, this.scrollOffset);
      }
    },
    scrollTo
    /* istanbul ignore next */
    : function scrollTo(location) {
      this.scrollOffset = this.calculateNewOffset(location, {
        // Force reflow
        content: this.$refs.content ? this.$refs.content.clientWidth : 0,
        wrapper: this.$refs.wrapper ? this.$refs.wrapper.clientWidth : 0
      }, this.$vuetify.rtl, this.scrollOffset);
    },
    setWidths: function setWidths() {
      var _this4 = this;

      window.requestAnimationFrame(function () {
        if (_this4._isDestroyed) return;
        var _this4$$refs = _this4.$refs,
            content = _this4$$refs.content,
            wrapper = _this4$$refs.wrapper;
        _this4.widths = {
          content: content ? content.clientWidth : 0,
          wrapper: wrapper ? wrapper.clientWidth : 0
        }; // https://github.com/vuetifyjs/vuetify/issues/13212
        // We add +1 to the wrappers width to prevent an issue where the `clientWidth`
        // gets calculated wrongly by the browser if using a different zoom-level.

        _this4.isOverflowing = _this4.widths.wrapper + 1 < _this4.widths.content;

        _this4.scrollIntoView();
      });
    }
  },
  render: function render(h) {
    return h('div', this.genData(), [this.genPrev(), this.genWrapper(), this.genNext()]);
  }
});
/* harmony default export */ var VSlideGroup_VSlideGroup = (BaseSlideGroup.extend({
  name: 'v-slide-group',
  provide: function provide() {
    return {
      slideGroup: this
    };
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/ssr-bootable/index.js

/**
 * SSRBootable
 *
 * @mixin
 *
 * Used in layout components (drawer, toolbar, content)
 * to avoid an entry animation when using SSR
 */

/* harmony default export */ var ssr_bootable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'ssr-bootable',
  data: function data() {
    return {
      isBooted: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    // Use setAttribute instead of dataset
    // because dataset does not work well
    // with unit tests
    window.requestAnimationFrame(function () {
      _this.$el.setAttribute('data-booted', 'true');

      _this.isBooted = true;
    });
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTabs/VTabsBar.js


// Extensions
 // Mixins


 // Utilities


/* harmony default export */ var VTabsBar = (mixins_mixins(BaseSlideGroup, ssr_bootable, themeable
/* @vue/component */
).extend({
  name: 'v-tabs-bar',
  provide: function provide() {
    return {
      tabsBar: this
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, BaseSlideGroup.options.computed.classes.call(this)), {}, {
        'v-tabs-bar': true,
        'v-tabs-bar--is-mobile': this.isMobile,
        // TODO: Remove this and move to v-slide-group
        'v-tabs-bar--show-arrows': this.showArrows
      }, this.themeClasses);
    }
  },
  watch: {
    items: 'callSlider',
    internalValue: 'callSlider',
    $route: 'onRouteChange'
  },
  methods: {
    callSlider: function callSlider() {
      if (!this.isBooted) return;
      this.$emit('call:slider');
    },
    genContent: function genContent() {
      var render = BaseSlideGroup.options.methods.genContent.call(this);
      render.data = render.data || {};
      render.data.staticClass += ' v-tabs-bar__content';
      return render;
    },
    onRouteChange: function onRouteChange(val, oldVal) {
      /* istanbul ignore next */
      if (this.mandatory) return;
      var items = this.items;
      var newPath = val.path;
      var oldPath = oldVal.path;
      var hasNew = false;
      var hasOld = false;

      var _iterator = _createForOfIteratorHelper(items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.to === oldPath) hasOld = true;else if (item.to === newPath) hasNew = true;
          if (hasNew && hasOld) break;
        } // If we have an old item and not a new one
        // it's assumed that the user navigated to
        // a path that is not present in the items

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!hasNew && hasOld) this.internalValue = undefined;
    }
  },
  render: function render(h) {
    var render = BaseSlideGroup.options.render.call(this, h);
    render.data.attrs = {
      role: 'tablist'
    };
    return render;
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VWindow/VWindow.sass
var VWindow = __webpack_require__("13b3");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VBtn/index.js


/* harmony default export */ var components_VBtn = (VBtn_VBtn);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VWindow/VWindow.js





// Styles
 // Directives

 // Components




/* @vue/component */

/* harmony default export */ var VWindow_VWindow = (BaseItemGroup.extend({
  name: 'v-window',
  directives: {
    Touch: directives_touch
  },
  provide: function provide() {
    return {
      windowGroup: this
    };
  },
  props: {
    activeClass: {
      type: String,
      default: 'v-window-item--active'
    },
    continuous: Boolean,
    mandatory: {
      type: Boolean,
      default: true
    },
    nextIcon: {
      type: [Boolean, String],
      default: '$next'
    },
    prevIcon: {
      type: [Boolean, String],
      default: '$prev'
    },
    reverse: Boolean,
    showArrows: Boolean,
    showArrowsOnHover: Boolean,
    touch: Object,
    touchless: Boolean,
    value: {
      required: false
    },
    vertical: Boolean
  },
  data: function data() {
    return {
      changedByDelimiters: false,
      internalHeight: undefined,
      transitionHeight: undefined,
      transitionCount: 0,
      isBooted: false,
      isReverse: false
    };
  },
  computed: {
    isActive: function isActive() {
      return this.transitionCount > 0;
    },
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, BaseItemGroup.options.computed.classes.call(this)), {}, {
        'v-window--show-arrows-on-hover': this.showArrowsOnHover
      });
    },
    computedTransition: function computedTransition() {
      if (!this.isBooted) return '';
      var axis = this.vertical ? 'y' : 'x';
      var reverse = this.internalReverse ? !this.isReverse : this.isReverse;
      var direction = reverse ? '-reverse' : '';
      return "v-window-".concat(axis).concat(direction, "-transition");
    },
    hasActiveItems: function hasActiveItems() {
      return Boolean(this.items.find(function (item) {
        return !item.disabled;
      }));
    },
    hasNext: function hasNext() {
      return this.continuous || this.internalIndex < this.items.length - 1;
    },
    hasPrev: function hasPrev() {
      return this.continuous || this.internalIndex > 0;
    },
    internalIndex: function internalIndex() {
      var _this = this;

      return this.items.findIndex(function (item, i) {
        return _this.internalValue === _this.getValue(item, i);
      });
    },
    internalReverse: function internalReverse() {
      return this.$vuetify.rtl ? !this.reverse : this.reverse;
    }
  },
  watch: {
    internalIndex: function internalIndex(val, oldVal) {
      this.isReverse = this.updateReverse(val, oldVal);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    window.requestAnimationFrame(function () {
      return _this2.isBooted = true;
    });
  },
  methods: {
    genDefaultSlot: function genDefaultSlot() {
      return this.$slots.default;
    },
    genContainer: function genContainer() {
      var children = [this.genDefaultSlot()];

      if (this.showArrows) {
        children.push(this.genControlIcons());
      }

      return this.$createElement('div', {
        staticClass: 'v-window__container',
        class: {
          'v-window__container--is-active': this.isActive
        },
        style: {
          height: this.internalHeight || this.transitionHeight
        }
      }, children);
    },
    genIcon: function genIcon(direction, icon, _click) {
      var _this3 = this;

      var _this$$scopedSlots$di, _this$$scopedSlots$di2, _this$$scopedSlots;

      var on = {
        click: function click(e) {
          e.stopPropagation();
          _this3.changedByDelimiters = true;

          _click();
        }
      };
      var attrs = {
        'aria-label': this.$vuetify.lang.t("$vuetify.carousel.".concat(direction))
      };
      var children = (_this$$scopedSlots$di = (_this$$scopedSlots$di2 = (_this$$scopedSlots = this.$scopedSlots)[direction]) == null ? void 0 : _this$$scopedSlots$di2.call(_this$$scopedSlots, {
        on: on,
        attrs: attrs
      })) != null ? _this$$scopedSlots$di : [this.$createElement(components_VBtn, {
        props: {
          icon: true
        },
        attrs: attrs,
        on: on
      }, [this.$createElement(components_VIcon, {
        props: {
          large: true
        }
      }, icon)])];
      return this.$createElement('div', {
        staticClass: "v-window__".concat(direction)
      }, children);
    },
    genControlIcons: function genControlIcons() {
      var icons = [];
      var prevIcon = this.$vuetify.rtl ? this.nextIcon : this.prevIcon;
      /* istanbul ignore else */

      if (this.hasPrev && prevIcon && typeof prevIcon === 'string') {
        var icon = this.genIcon('prev', prevIcon, this.prev);
        icon && icons.push(icon);
      }

      var nextIcon = this.$vuetify.rtl ? this.prevIcon : this.nextIcon;
      /* istanbul ignore else */

      if (this.hasNext && nextIcon && typeof nextIcon === 'string') {
        var _icon = this.genIcon('next', nextIcon, this.next);

        _icon && icons.push(_icon);
      }

      return icons;
    },
    getNextIndex: function getNextIndex(index) {
      var nextIndex = (index + 1) % this.items.length;
      var item = this.items[nextIndex];
      if (item.disabled) return this.getNextIndex(nextIndex);
      return nextIndex;
    },
    getPrevIndex: function getPrevIndex(index) {
      var prevIndex = (index + this.items.length - 1) % this.items.length;
      var item = this.items[prevIndex];
      if (item.disabled) return this.getPrevIndex(prevIndex);
      return prevIndex;
    },
    next: function next() {
      /* istanbul ignore if */
      if (!this.hasActiveItems || !this.hasNext) return;
      var nextIndex = this.getNextIndex(this.internalIndex);
      var item = this.items[nextIndex];
      this.internalValue = this.getValue(item, nextIndex);
    },
    prev: function prev() {
      /* istanbul ignore if */
      if (!this.hasActiveItems || !this.hasPrev) return;
      var lastIndex = this.getPrevIndex(this.internalIndex);
      var item = this.items[lastIndex];
      this.internalValue = this.getValue(item, lastIndex);
    },
    updateReverse: function updateReverse(val, oldVal) {
      var itemsLength = this.items.length;
      var lastIndex = itemsLength - 1;
      if (itemsLength <= 2) return val < oldVal;

      if (val === lastIndex && oldVal === 0) {
        return true;
      } else if (val === 0 && oldVal === lastIndex) {
        return false;
      } else {
        return val < oldVal;
      }
    }
  },
  render: function render(h) {
    var _this4 = this;

    var data = {
      staticClass: 'v-window',
      class: this.classes,
      directives: []
    };

    if (!this.touchless) {
      var value = this.touch || {
        left: function left() {
          _this4.$vuetify.rtl ? _this4.prev() : _this4.next();
        },
        right: function right() {
          _this4.$vuetify.rtl ? _this4.next() : _this4.prev();
        },
        end: function end(e) {
          e.stopPropagation();
        },
        start: function start(e) {
          e.stopPropagation();
        }
      };
      data.directives.push({
        name: 'touch',
        value: value
      });
    }

    return h('div', data, [this.genContainer()]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTabs/VTabsItems.js

// Extensions
 // Types & Components


/* @vue/component */

/* harmony default export */ var VTabsItems = (VWindow_VWindow.extend({
  name: 'v-tabs-items',
  props: {
    mandatory: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, VWindow_VWindow.options.computed.classes.call(this)), {}, {
        'v-tabs-items': true
      });
    },
    isDark: function isDark() {
      return this.rootIsDark;
    }
  },
  methods: {
    getValue: function getValue(item, i) {
      return item.id || BaseItemGroup.options.methods.getValue.call(this, item, i);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTabs/VTabsSlider.js
// Mixins
 // Utilities


/* @vue/component */

/* harmony default export */ var VTabsSlider = (mixins_mixins(colorable).extend({
  name: 'v-tabs-slider',
  render: function render(h) {
    return h('div', this.setBackgroundColor(this.color, {
      staticClass: 'v-tabs-slider'
    }));
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTabs/VTabs.js



// Styles
 // Components



 // Mixins



 // Directives

 // Utilities



var VTabs_baseMixins = mixins_mixins(colorable, proxyable, themeable);
/* harmony default export */ var VTabs_VTabs = (VTabs_baseMixins.extend().extend({
  name: 'v-tabs',
  directives: {
    Resize: resize
  },
  props: {
    activeClass: {
      type: String,
      default: ''
    },
    alignWithTitle: Boolean,
    backgroundColor: String,
    centerActive: Boolean,
    centered: Boolean,
    fixedTabs: Boolean,
    grow: Boolean,
    height: {
      type: [Number, String],
      default: undefined
    },
    hideSlider: Boolean,
    iconsAndText: Boolean,
    mobileBreakpoint: [String, Number],
    nextIcon: {
      type: String,
      default: '$next'
    },
    optional: Boolean,
    prevIcon: {
      type: String,
      default: '$prev'
    },
    right: Boolean,
    showArrows: [Boolean, String],
    sliderColor: String,
    sliderSize: {
      type: [Number, String],
      default: 2
    },
    vertical: Boolean
  },
  data: function data() {
    return {
      resizeTimeout: 0,
      slider: {
        height: null,
        left: null,
        right: null,
        top: null,
        width: null
      },
      transitionTime: 300
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2({
        'v-tabs--align-with-title': this.alignWithTitle,
        'v-tabs--centered': this.centered,
        'v-tabs--fixed-tabs': this.fixedTabs,
        'v-tabs--grow': this.grow,
        'v-tabs--icons-and-text': this.iconsAndText,
        'v-tabs--right': this.right,
        'v-tabs--vertical': this.vertical
      }, this.themeClasses);
    },
    isReversed: function isReversed() {
      return this.$vuetify.rtl && this.vertical;
    },
    sliderStyles: function sliderStyles() {
      return {
        height: convertToUnit(this.slider.height),
        left: this.isReversed ? undefined : convertToUnit(this.slider.left),
        right: this.isReversed ? convertToUnit(this.slider.right) : undefined,
        top: this.vertical ? convertToUnit(this.slider.top) : undefined,
        transition: this.slider.left != null ? null : 'none',
        width: convertToUnit(this.slider.width)
      };
    },
    computedColor: function computedColor() {
      if (this.color) return this.color;else if (this.isDark && !this.appIsDark) return 'white';else return 'primary';
    }
  },
  watch: {
    alignWithTitle: 'callSlider',
    centered: 'callSlider',
    centerActive: 'callSlider',
    fixedTabs: 'callSlider',
    grow: 'callSlider',
    iconsAndText: 'callSlider',
    right: 'callSlider',
    showArrows: 'callSlider',
    vertical: 'callSlider',
    '$vuetify.application.left': 'onResize',
    '$vuetify.application.right': 'onResize',
    '$vuetify.rtl': 'onResize'
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.setTimeout(_this.callSlider, 30);
    });
  },
  methods: {
    callSlider: function callSlider() {
      var _this2 = this;

      if (this.hideSlider || !this.$refs.items || !this.$refs.items.selectedItems.length) {
        this.slider.width = 0;
        return false;
      }

      this.$nextTick(function () {
        // Give screen time to paint
        var activeTab = _this2.$refs.items.selectedItems[0];
        /* istanbul ignore if */

        if (!activeTab || !activeTab.$el) {
          _this2.slider.width = 0;
          _this2.slider.left = 0;
          return;
        }

        var el = activeTab.$el;
        _this2.slider = {
          height: !_this2.vertical ? Number(_this2.sliderSize) : el.scrollHeight,
          left: _this2.vertical ? 0 : el.offsetLeft,
          right: _this2.vertical ? 0 : el.offsetLeft + el.offsetWidth,
          top: el.offsetTop,
          width: _this2.vertical ? Number(_this2.sliderSize) : el.scrollWidth
        };
      });
      return true;
    },
    genBar: function genBar(items, slider) {
      var _this3 = this;

      var data = {
        style: {
          height: convertToUnit(this.height)
        },
        props: {
          activeClass: this.activeClass,
          centerActive: this.centerActive,
          dark: this.dark,
          light: this.light,
          mandatory: !this.optional,
          mobileBreakpoint: this.mobileBreakpoint,
          nextIcon: this.nextIcon,
          prevIcon: this.prevIcon,
          showArrows: this.showArrows,
          value: this.internalValue
        },
        on: {
          'call:slider': this.callSlider,
          change: function change(val) {
            _this3.internalValue = val;
          }
        },
        ref: 'items'
      };
      this.setTextColor(this.computedColor, data);
      this.setBackgroundColor(this.backgroundColor, data);
      return this.$createElement(VTabsBar, data, [this.genSlider(slider), items]);
    },
    genItems: function genItems(items, item) {
      var _this4 = this;

      // If user provides items
      // opt to use theirs
      if (items) return items; // If no tabs are provided
      // render nothing

      if (!item.length) return null;
      return this.$createElement(VTabsItems, {
        props: {
          value: this.internalValue
        },
        on: {
          change: function change(val) {
            _this4.internalValue = val;
          }
        }
      }, item);
    },
    genSlider: function genSlider(slider) {
      if (this.hideSlider) return null;

      if (!slider) {
        slider = this.$createElement(VTabsSlider, {
          props: {
            color: this.sliderColor
          }
        });
      }

      return this.$createElement('div', {
        staticClass: 'v-tabs-slider-wrapper',
        style: this.sliderStyles
      }, [slider]);
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = window.setTimeout(this.callSlider, 0);
    },
    parseNodes: function parseNodes() {
      var items = null;
      var slider = null;
      var item = [];
      var tab = [];
      var slot = this.$slots.default || [];
      var length = slot.length;

      for (var i = 0; i < length; i++) {
        var vnode = slot[i];

        if (vnode.componentOptions) {
          switch (vnode.componentOptions.Ctor.options.name) {
            case 'v-tabs-slider':
              slider = vnode;
              break;

            case 'v-tabs-items':
              items = vnode;
              break;

            case 'v-tab-item':
              item.push(vnode);
              break;
            // case 'v-tab' - intentionally omitted

            default:
              tab.push(vnode);
          }
        } else {
          tab.push(vnode);
        }
      }
      /**
       * tab: array of `v-tab`
       * slider: single `v-tabs-slider`
       * items: single `v-tabs-items`
       * item: array of `v-tab-item`
       */


      return {
        tab: tab,
        slider: slider,
        items: items,
        item: item
      };
    }
  },
  render: function render(h) {
    var _this$parseNodes = this.parseNodes(),
        tab = _this$parseNodes.tab,
        slider = _this$parseNodes.slider,
        items = _this$parseNodes.items,
        item = _this$parseNodes.item;

    return h('div', {
      staticClass: 'v-tabs',
      class: this.classes,
      directives: [{
        name: 'resize',
        modifiers: {
          quiet: true
        },
        value: this.onResize
      }]
    }, [this.genBar(tab, slider), this.genItems(items, item)]);
  }
}));
// CONCATENATED MODULE: ./src/components/UserList/UserList.vue






/* normalize component */

var UserList_component = normalizeComponent(
  UserList_UserListvue_type_script_lang_ts_,
  UserListvue_type_template_id_3d12ab11_scoped_true_render,
  UserListvue_type_template_id_3d12ab11_scoped_true_staticRenderFns,
  false,
  null,
  "3d12ab11",
  null
  
)

/* harmony default export */ var UserList_UserList = (UserList_component.exports);

/* vuetify-loader */








installComponents_default()(UserList_component, {VBtn: VBtn_VBtn,VCard: VCard_VCard,VIcon: components_VIcon_VIcon,VMenu: VMenu_VMenu,VTab: VTab,VTabItem: VTabItem,VTabs: VTabs_VTabs})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LoyaltyPoints.vue?vue&type=template&id=5abbabc6&scoped=true&
var LoyaltyPointsvue_type_template_id_5abbabc6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","content-class":"bottom-menu","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-1 px-0",attrs:{"text":"","small":""}},'v-btn',attrs,false),on),[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"","color":"brand"}},[_vm._v("mdi-tag-heart")]),_vm._v(" 22 ")],1)]}}])},[(_vm.spendLoyaltyItemTitle === '')?_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"400","min-width":"350"}},[_c('v-toolbar',{attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("s8c.Loyalty")))])],1),_c('v-list',_vm._l((_vm.spendLoyalty),function(item){return _c('v-list-item',{key:item.title,staticClass:"spendLoyalty",style:({ background: item.color }),on:{"click":function($event){return _vm.openSpendLoyaltyItem(item)}}},[_c('v-icon',{attrs:{"left":"","color":"white"}},[_vm._v(_vm._s(item.action))]),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(item.title)))])],1),_c('v-list-item-action',[_c('v-list-item-action-text',{domProps:{"textContent":_vm._s(item.value)}})],1)],1)}),1)],1):_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"400","min-width":"350"}},[_c('v-toolbar',{attrs:{"dark":""}},[_c('v-icon',{attrs:{"left":"","color":"white"},on:{"click":function($event){return _vm.goOnFirstMenu()}}},[_vm._v(" mdi-arrow-left ")]),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t(this.spendLoyaltyItemTitle)))])],1),_c('div',[_c('div',{staticStyle:{"justifycontent":"center","display":"flex"}},[_c('v-img',{attrs:{"center":"","contain":"","height":"150px","width":"60px","src":this.spendLoyaltyItemImage}})],1),(this.spendLoyaltyItemTitle == 'How to earn points')?_c('div',_vm._l((_vm.items),function(item){return _c('v-list',{key:item.title},_vm._l((item.items),function(child){return _c('v-list-item',{key:child.title},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(child.title)))])],1),_c('v-list-item-action',[_c('v-list-item-action-text',{domProps:{"textContent":_vm._s(child.value)}})],1)],1)}),1)}),1):(this.spendLoyaltyItemDescription !== '')?_c('div',[_c('p',{staticClass:"desc-for-loyalty-item"},[_vm._v(" "+_vm._s(this.spendLoyaltyItemDescription)+" ")])]):_vm._e()]),(
        this.spendLoyaltyItemTitle !== 'How to earn points' &&
        this.spendLoyaltyItemTitle !== 'Inventory'
      )?_c('v-list',[_c('v-list-item',{staticClass:"spendLoyalty",style:({ background: this.spendLoyaltyItemColor })},[_c('v-icon',{style:({ boxShadow: _vm.spendLoyaltyItemColor }),attrs:{"left":"","color":_vm.$vuetify.theme.dark ? 'white' : 'black'}},[_vm._v(_vm._s(this.spendLoyaltyItemIcon))]),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.$t(this.spendLoyaltyItemTitle))+" ")])],1),_c('v-list-item-action',[_c('v-list-item-action-text',{domProps:{"textContent":_vm._s(this.spendLoyaltyItemValue)}})],1)],1)],1):_vm._e()],1)],1)}
var LoyaltyPointsvue_type_template_id_5abbabc6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LoyaltyPoints.vue?vue&type=template&id=5abbabc6&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LoyaltyPoints.vue?vue&type=script&lang=ts&









var LoyaltyPointsvue_type_script_lang_ts_LoyaltyPoints = /*#__PURE__*/function (_Vue) {
  _inherits(LoyaltyPoints, _Vue);

  var _super = _createSuper(LoyaltyPoints);

  function LoyaltyPoints() {
    var _this;

    _classCallCheck(this, LoyaltyPoints);

    _this = _super.apply(this, arguments); // user mocks
    // isAdmin = true;

    _this.menu = false;
    _this.dialog = false;
    _this.spendLoyaltyItem = "";
    _this.spendLoyaltyItemTitle = "";
    _this.spendLoyaltyItemIcon = "";
    _this.spendLoyaltyItemImage = "";
    _this.spendLoyaltyItemColor = "";
    _this.spendLoyaltyItemValue = "";
    _this.spendLoyaltyItemDescription = "";
    _this.menuX = 0;
    _this.menuY = 0;
    _this.remSize = 16;
    _this.loading = false;
    _this.textInput = "";
    _this.selectedUsers = [];
    _this.spendLoyalty = [{
      action: "",
      color: "#",
      value: "",
      items: [{
        title: "s8c.Watch the stream for 5min",
        value: "+ 33 LP"
      }, {
        title: "s8c.Answer a poll",
        value: "+ 33 LP"
      }, {
        title: "s8c.Buy something in shop",
        value: "+ 33 LP"
      }, {
        title: "s8c.Breakfast & brunch",
        value: "+ 33 LP"
      }, {
        title: "s8c.New American",
        value: "+ 33 LP"
      }, {
        title: "s8c.Sushi",
        value: "+ 33 LP"
      }],
      title: "s8c.How to earn points"
    }, {
      action: "",
      color: "#",
      value: "",
      items: [],
      title: "s8c.Inventory"
    }, {
      action: "mdi-tag-heart",
      color: "#ff5400",
      value: "300 LP",
      items: [],
      title: "s8c.Start a new poll"
    }, {
      action: "mdi-pin",
      color: "#ff5400",
      value: "500 LP",
      items: [],
      title: "s8c.Pin a message"
    }, {
      action: "mdi-grease-pencil",
      color: "#ff5400",
      value: "500 LP",
      items: [],
      title: "s8c.Highlight a message"
    }, {
      action: "mdi-palette",
      color: "#1a9a1a",
      value: "500 LP",
      items: [],
      title: "s8c.Unlock a name color"
    }];
    _this.items = [{
      action: "",
      color: "",
      items: [{
        title: "s8c.Watch the stream for 5min",
        value: "+ 33 LP"
      }, {
        title: "s8c.Answer a poll",
        value: "+ 33 LP"
      }, {
        title: "s8c.Buy something in shop",
        value: "+ 33 LP"
      }, {
        title: "s8c.Breakfast & brunch",
        value: "+ 33 LP"
      }, {
        title: "s8c.New American",
        value: "+ 33 LP"
      }, {
        title: "s8c.Sushi",
        value: "+ 33 LP"
      }],
      title: "s8c.How to earn points"
    }, {
      action: "",
      color: "brand",
      items: [{
        title: ""
      }],
      title: "s8c.Inventory"
    }];
    return _this;
  }

  _createClass(LoyaltyPoints, [{
    key: "goOnFirstMenu",
    value: function goOnFirstMenu() {
      this.spendLoyaltyItemTitle = "";
      this.spendLoyaltyItemIcon = "";
      this.spendLoyaltyItemDescription = "";
    }
  }, {
    key: "openSpendLoyaltyItem",
    value: function openSpendLoyaltyItem(item) {
      this.spendLoyaltyItemTitle = item.title;
      this.spendLoyaltyItemIcon = item.action;
      this.spendLoyaltyItemColor = item.color;
      this.spendLoyaltyItemValue = item.value;

      if (this.spendLoyaltyItemTitle === "s8c.Start a new poll") {
        this.spendLoyaltyItemDescription = this.$t("s8c.loyaltyStartPollDesc");
        this.spendLoyaltyItemImage = __webpack_require__("ed99");
      } else if (this.spendLoyaltyItemTitle === "s8c.Pin a message") {
        this.spendLoyaltyItemDescription = this.$t("s8c.loyaltyPinMessageDesc");
        this.spendLoyaltyItemImage = __webpack_require__("f543");
      } else if (this.spendLoyaltyItemTitle === "s8c.Highlight a message") {
        this.spendLoyaltyItemDescription = this.$t("s8c.loyaltyHighlightMessageDesc");
        this.spendLoyaltyItemImage = __webpack_require__("4e3d");
      } else if (this.spendLoyaltyItemTitle === "s8c.Unlock a name color") {
        this.spendLoyaltyItemDescription = this.$t("s8c.loyaltyUnlockNameColorDesc");
        this.spendLoyaltyItemImage = __webpack_require__("aba9");
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(user) {
      this.deleteUser(user);
      this.textInput = "";
    }
  }, {
    key: "handleAddUser",
    value: function handleAddUser(user) {
      this.addUser(user);
      this.textInput = "";
    }
  }, {
    key: "handleMenu",
    value: function handleMenu(e) {
      if (!this.menu) {
        this.menuX = e.clientX; // this.menuY = e.clientY;

        this.menuY = window.innerHeight - 16 * this.remSize;
        this.menu = true;
      }
    }
  }]);

  return LoyaltyPoints;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([bindings_Mutation("addUser", {
  namespace: store_CHAT_NAMESPACE
})], LoyaltyPointsvue_type_script_lang_ts_LoyaltyPoints.prototype, "addUser", void 0);

__decorate([bindings_Mutation("deleteUser", {
  namespace: store_CHAT_NAMESPACE
})], LoyaltyPointsvue_type_script_lang_ts_LoyaltyPoints.prototype, "deleteUser", void 0);

__decorate([Getter("getChannelActive", {
  namespace: store_CHAT_NAMESPACE
})], LoyaltyPointsvue_type_script_lang_ts_LoyaltyPoints.prototype, "channelActive", void 0);

LoyaltyPointsvue_type_script_lang_ts_LoyaltyPoints = __decorate([vue_class_component_esm], LoyaltyPointsvue_type_script_lang_ts_LoyaltyPoints);
/* harmony default export */ var LoyaltyPointsvue_type_script_lang_ts_ = (LoyaltyPointsvue_type_script_lang_ts_LoyaltyPoints);
// CONCATENATED MODULE: ./src/components/LoyaltyPoints.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_LoyaltyPointsvue_type_script_lang_ts_ = (LoyaltyPointsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/LoyaltyPoints.vue?vue&type=style&index=0&id=5abbabc6&scoped=true&lang=scss&
var LoyaltyPointsvue_type_style_index_0_id_5abbabc6_scoped_true_lang_scss_ = __webpack_require__("040e");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VToolbar/VToolbar.sass
var VToolbar = __webpack_require__("5e23");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VToolbar/VToolbar.js






// Styles
 // Extensions

 // Components

 // Utilities



/* @vue/component */

/* harmony default export */ var VToolbar_VToolbar = (VSheet_VSheet.extend({
  name: 'v-toolbar',
  props: {
    absolute: Boolean,
    bottom: Boolean,
    collapse: Boolean,
    dense: Boolean,
    extended: Boolean,
    extensionHeight: {
      default: 48,
      type: [Number, String]
    },
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    short: Boolean,
    src: {
      type: [String, Object],
      default: ''
    },
    tag: {
      type: String,
      default: 'header'
    }
  },
  data: function data() {
    return {
      isExtended: false
    };
  },
  computed: {
    computedHeight: function computedHeight() {
      var height = this.computedContentHeight;
      if (!this.isExtended) return height;
      var extensionHeight = parseInt(this.extensionHeight);
      return this.isCollapsed ? height : height + (!isNaN(extensionHeight) ? extensionHeight : 0);
    },
    computedContentHeight: function computedContentHeight() {
      if (this.height) return parseInt(this.height);
      if (this.isProminent && this.dense) return 96;
      if (this.isProminent && this.short) return 112;
      if (this.isProminent) return 128;
      if (this.dense) return 48;
      if (this.short || this.$vuetify.breakpoint.smAndDown) return 56;
      return 64;
    },
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, VSheet_VSheet.options.computed.classes.call(this)), {}, {
        'v-toolbar': true,
        'v-toolbar--absolute': this.absolute,
        'v-toolbar--bottom': this.bottom,
        'v-toolbar--collapse': this.collapse,
        'v-toolbar--collapsed': this.isCollapsed,
        'v-toolbar--dense': this.dense,
        'v-toolbar--extended': this.isExtended,
        'v-toolbar--flat': this.flat,
        'v-toolbar--floating': this.floating,
        'v-toolbar--prominent': this.isProminent
      });
    },
    isCollapsed: function isCollapsed() {
      return this.collapse;
    },
    isProminent: function isProminent() {
      return this.prominent;
    },
    styles: function styles() {
      return _objectSpread2(_objectSpread2({}, this.measurableStyles), {}, {
        height: convertToUnit(this.computedHeight)
      });
    }
  },
  created: function created() {
    var _this = this;

    var breakingProps = [['app', '<v-app-bar app>'], ['manual-scroll', '<v-app-bar :value="false">'], ['clipped-left', '<v-app-bar clipped-left>'], ['clipped-right', '<v-app-bar clipped-right>'], ['inverted-scroll', '<v-app-bar inverted-scroll>'], ['scroll-off-screen', '<v-app-bar scroll-off-screen>'], ['scroll-target', '<v-app-bar scroll-target>'], ['scroll-threshold', '<v-app-bar scroll-threshold>'], ['card', '<v-app-bar flat>']];
    /* istanbul ignore next */

    breakingProps.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          original = _ref2[0],
          replacement = _ref2[1];

      if (_this.$attrs.hasOwnProperty(original)) breaking(original, replacement, _this);
    });
  },
  methods: {
    genBackground: function genBackground() {
      var props = {
        height: convertToUnit(this.computedHeight),
        src: this.src
      };
      var image = this.$scopedSlots.img ? this.$scopedSlots.img({
        props: props
      }) : this.$createElement(VImg_VImg, {
        props: props
      });
      return this.$createElement('div', {
        staticClass: 'v-toolbar__image'
      }, [image]);
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-toolbar__content',
        style: {
          height: convertToUnit(this.computedContentHeight)
        }
      }, getSlot(this));
    },
    genExtension: function genExtension() {
      return this.$createElement('div', {
        staticClass: 'v-toolbar__extension',
        style: {
          height: convertToUnit(this.extensionHeight)
        }
      }, getSlot(this, 'extension'));
    }
  },
  render: function render(h) {
    this.isExtended = this.extended || !!this.$scopedSlots.extension;
    var children = [this.genContent()];
    var data = this.setBackgroundColor(this.color, {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    });
    if (this.isExtended) children.push(this.genExtension());
    if (this.src || this.$scopedSlots.img) children.unshift(this.genBackground());
    return h(this.tag, data, children);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VToolbar/index.js
// Components
 // Utilities


var VToolbarTitle = createSimpleFunctional('v-toolbar__title');
var VToolbarItems = createSimpleFunctional('v-toolbar__items');

/* harmony default export */ var components_VToolbar = ({
  $_vuetify_subcomponents: {
    VToolbar: VToolbar_VToolbar,
    VToolbarItems: VToolbarItems,
    VToolbarTitle: VToolbarTitle
  }
});
// CONCATENATED MODULE: ./src/components/LoyaltyPoints.vue






/* normalize component */

var LoyaltyPoints_component = normalizeComponent(
  components_LoyaltyPointsvue_type_script_lang_ts_,
  LoyaltyPointsvue_type_template_id_5abbabc6_scoped_true_render,
  LoyaltyPointsvue_type_template_id_5abbabc6_scoped_true_staticRenderFns,
  false,
  null,
  "5abbabc6",
  null
  
)

/* harmony default export */ var components_LoyaltyPoints = (LoyaltyPoints_component.exports);

/* vuetify-loader */














installComponents_default()(LoyaltyPoints_component, {VBtn: VBtn_VBtn,VCard: VCard_VCard,VIcon: components_VIcon_VIcon,VImg: VImg_VImg,VList: VList_VList,VListItem: VList_VListItem,VListItemAction: VListItemAction,VListItemActionText: VListItemActionText,VListItemContent: VListItemContent,VListItemTitle: VListItemTitle,VMenu: VMenu_VMenu,VToolbar: VToolbar_VToolbar,VToolbarTitle: VToolbarTitle})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SettingsMenu.vue?vue&type=template&id=c838e56a&scoped=true&
var SettingsMenuvue_type_template_id_c838e56a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","content-class":"bottom-menu","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mx-2 px-0",attrs:{"icon":"","small":""}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v("mdi-cog")])],1)]}}])},[_c('v-card',{staticClass:"mx-auto",staticStyle:{"box-shadow":"none !important"},attrs:{"max-width":"400","min-width":"300"}},[_c('v-toolbar',{attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("s8c.Settings menu")))])],1),_c('v-list',_vm._l((_vm.settingMenuOptions),function(item){return _c('v-list-item',{key:item.title,staticClass:"px-0"},[_c('v-menu',{staticStyle:{"padding-top":"64px"},attrs:{"offset-y":"","content-class":"bottom-menu","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-list-item',_vm._g(_vm._b({on:{"click":function($event){_vm.openSettingsMenu(item.title.toString())}}},'v-list-item',attrs,false),on),[_c('v-icon',{attrs:{"small":"","left":"","color":"brand"}},[_vm._v(_vm._s(item.action))]),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t(item.title)))])],1)]}}],null,true)},[(_vm.changeLanguageMenu)?_c('v-card',{staticClass:"settings-sub_menu",attrs:{"tile":""}},[_c('v-list',_vm._l((_vm.languages),function(lang){return _c('v-list-item',{key:lang,staticStyle:{"cursor":"pointer"},attrs:{"close-on-content-click":true},on:{"click":function($event){return _vm.changeLang(lang)}}},[_vm._v(" "+_vm._s(lang.toUpperCase())+" ")])}),1)],1):_vm._e(),(_vm.changeColorMenu)?_c('v-card',{staticClass:"settings-sub_menu",attrs:{"tile":""}},[_c('v-list',[_c('div',{style:(_vm.colorClass)},[[_c('v-menu',{ref:"changeColorMenu",refInFor:true,staticClass:"pa-1 background",staticStyle:{"cursor":"pointer"},attrs:{"close-on-content-click":true,"transition":"scale-transition","max-width":"300px","absolute":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-card',{on:{"click":function($event){return _vm.changeColorNamespace()}}},[_c('v-color-picker',{staticClass:"my-auto background",attrs:{"swatches":_vm.swatches,"hide-canvas":"","hide-inputs":"","hide-mode-switch":"","hide-sliders":"","show-swatches":"","swatches-max-height":"80"},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)],1)]}}],null,true),model:{value:(_vm.changeColorMenu),callback:function ($$v) {_vm.changeColorMenu=$$v},expression:"changeColorMenu"}})]],2)])],1):_vm._e()],1)],1)}),1)],1)],1)}
var SettingsMenuvue_type_template_id_c838e56a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/SettingsMenu.vue?vue&type=template&id=c838e56a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SettingsMenu.vue?vue&type=script&lang=ts&









var SettingsMenuvue_type_script_lang_ts_SettingsMenu = /*#__PURE__*/function (_Vue) {
  _inherits(SettingsMenu, _Vue);

  var _super = _createSuper(SettingsMenu);

  function SettingsMenu() {
    var _this;

    _classCallCheck(this, SettingsMenu);

    _this = _super.apply(this, arguments);
    _this.settingMenu = false;
    _this.openedMenu = "";
    _this.changeLanguageMenu = false;
    _this.color = "#FFFFFF";
    _this.changeColorMenu = false;
    _this.colorMenu = false;
    _this.languages = ["en", "de"];
    _this.settingMenuOptions = [{
      title: "s8c.changeLanguage",
      action: "mdi-google-translate"
    }];
    _this.swatches = [["#FFFFFF"], ["#FF5DD4"], ["#B675FF"], ["#6D9DFC"], ["#00FFF6"], ["#00FF90"], ["#09E101"], ["#D9F513"], ["#FF8A23"]];
    return _this;
  }

  _createClass(SettingsMenu, [{
    key: "colorClass",
    get: function get() {
      if (this.color === "#FFFFFF") return "input-white";
      if (this.color === "#FF5DD4") return "input-pink";
      if (this.color === "#B675FF") return "input-purple";
      if (this.color === "#6D9DFC") return "input-blue";
      if (this.color === "#00FFF6") return "input-cyan";
      if (this.color === "#00FF90") return "input-light-green";
      if (this.color === "#09E101") return "input-green";
      if (this.color === "#D9F513") return "input-yellow";
      if (this.color === "#FF8A23") return "input-orange";else return "input-white";
    }
  }, {
    key: "openSettingsMenu",
    value: function openSettingsMenu(item) {
      if (item === "s8c.changeLanguage") {
        this.changeLanguageMenu = true;
        this.changeColorMenu = false;
      } else if (item === "Change color") {
        this.changeColorMenu = true;
        this.changeLanguageMenu = false;
      }

      this.openedMenu = item;
    }
  }, {
    key: "changeLang",
    value: function changeLang(lang) {
      this.changeLanguageAction({
        preferredLanguage: lang
      });
      this.$i18n.locale = lang;
    }
  }, {
    key: "changeColorNamespace",
    value: function changeColorNamespace() {
      this.changeColorAction({
        color: this.color
      });
    }
  }]);

  return SettingsMenu;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([bindings_Action("changeColor", {
  namespace: store_CHAT_NAMESPACE
})], SettingsMenuvue_type_script_lang_ts_SettingsMenu.prototype, "changeColorAction", void 0);

__decorate([bindings_Action("changeLanguage", {
  namespace: store_CHAT_NAMESPACE
})], SettingsMenuvue_type_script_lang_ts_SettingsMenu.prototype, "changeLanguageAction", void 0);

SettingsMenuvue_type_script_lang_ts_SettingsMenu = __decorate([vue_class_component_esm], SettingsMenuvue_type_script_lang_ts_SettingsMenu);
/* harmony default export */ var SettingsMenuvue_type_script_lang_ts_ = (SettingsMenuvue_type_script_lang_ts_SettingsMenu);
// CONCATENATED MODULE: ./src/components/SettingsMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_SettingsMenuvue_type_script_lang_ts_ = (SettingsMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/SettingsMenu.vue?vue&type=style&index=0&id=c838e56a&scoped=true&lang=scss&
var SettingsMenuvue_type_style_index_0_id_c838e56a_scoped_true_lang_scss_ = __webpack_require__("74d4");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPicker.sass
var VColorPicker = __webpack_require__("bb18");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPickerPreview.sass
var VColorPickerPreview = __webpack_require__("7863");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSlider/VSlider.sass
var VSlider = __webpack_require__("9e29");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSlider/VSlider.js











 // Components


 // Mixins


 // Directives

 // Helpers



/* harmony default export */ var VSlider_VSlider = (mixins_mixins(components_VInput, loadable
/* @vue/component */
).extend({
  name: 'v-slider',
  directives: {
    ClickOutside: click_outside
  },
  mixins: [loadable],
  props: {
    disabled: Boolean,
    inverseLabel: Boolean,
    max: {
      type: [Number, String],
      default: 100
    },
    min: {
      type: [Number, String],
      default: 0
    },
    step: {
      type: [Number, String],
      default: 1
    },
    thumbColor: String,
    thumbLabel: {
      type: [Boolean, String],
      default: undefined,
      validator: function validator(v) {
        return typeof v === 'boolean' || v === 'always';
      }
    },
    thumbSize: {
      type: [Number, String],
      default: 32
    },
    tickLabels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ticks: {
      type: [Boolean, String],
      default: false,
      validator: function validator(v) {
        return typeof v === 'boolean' || v === 'always';
      }
    },
    tickSize: {
      type: [Number, String],
      default: 2
    },
    trackColor: String,
    trackFillColor: String,
    value: [Number, String],
    vertical: Boolean
  },
  data: function data() {
    return {
      app: null,
      oldValue: null,
      thumbPressed: false,
      mouseTimeout: -1,
      isFocused: false,
      isActive: false,
      noClick: false,
      startOffset: 0
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, components_VInput.options.computed.classes.call(this)), {}, {
        'v-input__slider': true,
        'v-input__slider--vertical': this.vertical,
        'v-input__slider--inverse-label': this.inverseLabel
      });
    },
    internalValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        val = isNaN(val) ? this.minValue : val; // Round value to ensure the
        // entire slider range can
        // be selected with step

        var value = this.roundValue(Math.min(Math.max(val, this.minValue), this.maxValue));
        if (value === this.lazyValue) return;
        this.lazyValue = value;
        this.$emit('input', value);
      }
    },
    trackTransition: function trackTransition() {
      return this.thumbPressed ? this.showTicks || this.stepNumeric ? '0.1s cubic-bezier(0.25, 0.8, 0.5, 1)' : 'none' : '';
    },
    minValue: function minValue() {
      return parseFloat(this.min);
    },
    maxValue: function maxValue() {
      return parseFloat(this.max);
    },
    stepNumeric: function stepNumeric() {
      return this.step > 0 ? parseFloat(this.step) : 0;
    },
    inputWidth: function inputWidth() {
      var inputWidth = (this.roundValue(this.internalValue) - this.minValue) / (this.maxValue - this.minValue) * 100;
      return isNaN(inputWidth) ? 0 : inputWidth;
    },
    trackFillStyles: function trackFillStyles() {
      var _ref;

      var startDir = this.vertical ? 'bottom' : 'left';
      var endDir = this.vertical ? 'top' : 'right';
      var valueDir = this.vertical ? 'height' : 'width';
      var start = this.$vuetify.rtl ? 'auto' : '0';
      var end = this.$vuetify.rtl ? '0' : 'auto';
      var value = this.isDisabled ? "calc(".concat(this.inputWidth, "% - 10px)") : "".concat(this.inputWidth, "%");
      return _ref = {
        transition: this.trackTransition
      }, _defineProperty(_ref, startDir, start), _defineProperty(_ref, endDir, end), _defineProperty(_ref, valueDir, value), _ref;
    },
    trackStyles: function trackStyles() {
      var _ref2;

      var startDir = this.vertical ? this.$vuetify.rtl ? 'bottom' : 'top' : this.$vuetify.rtl ? 'left' : 'right';
      var endDir = this.vertical ? 'height' : 'width';
      var start = '0px';
      var end = this.isDisabled ? "calc(".concat(100 - this.inputWidth, "% - 10px)") : "calc(".concat(100 - this.inputWidth, "%)");
      return _ref2 = {
        transition: this.trackTransition
      }, _defineProperty(_ref2, startDir, start), _defineProperty(_ref2, endDir, end), _ref2;
    },
    showTicks: function showTicks() {
      return this.tickLabels.length > 0 || !!(!this.isDisabled && this.stepNumeric && this.ticks);
    },
    numTicks: function numTicks() {
      return Math.ceil((this.maxValue - this.minValue) / this.stepNumeric);
    },
    showThumbLabel: function showThumbLabel() {
      return !this.isDisabled && !!(this.thumbLabel || this.$scopedSlots['thumb-label']);
    },
    computedTrackColor: function computedTrackColor() {
      if (this.isDisabled) return undefined;
      if (this.trackColor) return this.trackColor;
      if (this.isDark) return this.validationState;
      return this.validationState || 'primary lighten-3';
    },
    computedTrackFillColor: function computedTrackFillColor() {
      if (this.isDisabled) return undefined;
      if (this.trackFillColor) return this.trackFillColor;
      return this.validationState || this.computedColor;
    },
    computedThumbColor: function computedThumbColor() {
      if (this.thumbColor) return this.thumbColor;
      return this.validationState || this.computedColor;
    }
  },
  watch: {
    min: function min(val) {
      var parsed = parseFloat(val);
      parsed > this.internalValue && this.$emit('input', parsed);
    },
    max: function max(val) {
      var parsed = parseFloat(val);
      parsed < this.internalValue && this.$emit('input', parsed);
    },
    value: {
      handler: function handler(v) {
        this.internalValue = v;
      }
    }
  },
  // If done in as immediate in
  // value watcher, causes issues
  // with vue-test-utils
  beforeMount: function beforeMount() {
    this.internalValue = this.value;
  },
  mounted: function mounted() {
    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || consoleWarn('Missing v-app or a non-body wrapping element with the [data-app] attribute', this);
  },
  methods: {
    genDefaultSlot: function genDefaultSlot() {
      var children = [this.genLabel()];
      var slider = this.genSlider();
      this.inverseLabel ? children.unshift(slider) : children.push(slider);
      children.push(this.genProgress());
      return children;
    },
    genSlider: function genSlider() {
      return this.$createElement('div', {
        class: _objectSpread2({
          'v-slider': true,
          'v-slider--horizontal': !this.vertical,
          'v-slider--vertical': this.vertical,
          'v-slider--focused': this.isFocused,
          'v-slider--active': this.isActive,
          'v-slider--disabled': this.isDisabled,
          'v-slider--readonly': this.isReadonly
        }, this.themeClasses),
        directives: [{
          name: 'click-outside',
          value: this.onBlur
        }],
        on: {
          click: this.onSliderClick,
          mousedown: this.onSliderMouseDown,
          touchstart: this.onSliderMouseDown
        }
      }, this.genChildren());
    },
    genChildren: function genChildren() {
      return [this.genInput(), this.genTrackContainer(), this.genSteps(), this.genThumbContainer(this.internalValue, this.inputWidth, this.isActive, this.isFocused, this.onFocus, this.onBlur)];
    },
    genInput: function genInput() {
      return this.$createElement('input', {
        attrs: _objectSpread2({
          value: this.internalValue,
          id: this.computedId,
          disabled: true,
          readonly: true,
          tabindex: -1
        }, this.$attrs)
      });
    },
    genTrackContainer: function genTrackContainer() {
      var children = [this.$createElement('div', this.setBackgroundColor(this.computedTrackColor, {
        staticClass: 'v-slider__track-background',
        style: this.trackStyles
      })), this.$createElement('div', this.setBackgroundColor(this.computedTrackFillColor, {
        staticClass: 'v-slider__track-fill',
        style: this.trackFillStyles
      }))];
      return this.$createElement('div', {
        staticClass: 'v-slider__track-container',
        ref: 'track'
      }, children);
    },
    genSteps: function genSteps() {
      var _this = this;

      if (!this.step || !this.showTicks) return null;
      var tickSize = parseFloat(this.tickSize);
      var range = createRange(this.numTicks + 1);
      var direction = this.vertical ? 'bottom' : this.$vuetify.rtl ? 'right' : 'left';
      var offsetDirection = this.vertical ? this.$vuetify.rtl ? 'left' : 'right' : 'top';
      if (this.vertical) range.reverse();
      var ticks = range.map(function (index) {
        var _style;

        var children = [];

        if (_this.tickLabels[index]) {
          children.push(_this.$createElement('div', {
            staticClass: 'v-slider__tick-label'
          }, _this.tickLabels[index]));
        }

        var width = index * (100 / _this.numTicks);
        var filled = _this.$vuetify.rtl ? 100 - _this.inputWidth < width : width < _this.inputWidth;
        return _this.$createElement('span', {
          key: index,
          staticClass: 'v-slider__tick',
          class: {
            'v-slider__tick--filled': filled
          },
          style: (_style = {
            width: "".concat(tickSize, "px"),
            height: "".concat(tickSize, "px")
          }, _defineProperty(_style, direction, "calc(".concat(width, "% - ").concat(tickSize / 2, "px)")), _defineProperty(_style, offsetDirection, "calc(50% - ".concat(tickSize / 2, "px)")), _style)
        }, children);
      });
      return this.$createElement('div', {
        staticClass: 'v-slider__ticks-container',
        class: {
          'v-slider__ticks-container--always-show': this.ticks === 'always' || this.tickLabels.length > 0
        }
      }, ticks);
    },
    genThumbContainer: function genThumbContainer(value, valueWidth, isActive, isFocused, onFocus, onBlur) {
      var ref = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'thumb';
      var children = [this.genThumb()];
      var thumbLabelContent = this.genThumbLabelContent(value);
      this.showThumbLabel && children.push(this.genThumbLabel(thumbLabelContent));
      return this.$createElement('div', this.setTextColor(this.computedThumbColor, {
        ref: ref,
        key: ref,
        staticClass: 'v-slider__thumb-container',
        class: {
          'v-slider__thumb-container--active': isActive,
          'v-slider__thumb-container--focused': isFocused,
          'v-slider__thumb-container--show-label': this.showThumbLabel
        },
        style: this.getThumbContainerStyles(valueWidth),
        attrs: {
          role: 'slider',
          tabindex: this.isDisabled ? -1 : this.$attrs.tabindex ? this.$attrs.tabindex : 0,
          'aria-label': this.$attrs['aria-label'] || this.label,
          'aria-valuemin': this.min,
          'aria-valuemax': this.max,
          'aria-valuenow': this.internalValue,
          'aria-readonly': String(this.isReadonly),
          'aria-orientation': this.vertical ? 'vertical' : 'horizontal'
        },
        on: {
          focus: onFocus,
          blur: onBlur,
          keydown: this.onKeyDown
        }
      }), children);
    },
    genThumbLabelContent: function genThumbLabelContent(value) {
      return this.$scopedSlots['thumb-label'] ? this.$scopedSlots['thumb-label']({
        value: value
      }) : [this.$createElement('span', [String(value)])];
    },
    genThumbLabel: function genThumbLabel(content) {
      var size = convertToUnit(this.thumbSize);
      var transform = this.vertical ? "translateY(20%) translateY(".concat(Number(this.thumbSize) / 3 - 1, "px) translateX(55%) rotate(135deg)") : "translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg)";
      return this.$createElement(VScaleTransition, {
        props: {
          origin: 'bottom center'
        }
      }, [this.$createElement('div', {
        staticClass: 'v-slider__thumb-label-container',
        directives: [{
          name: 'show',
          value: this.isFocused || this.isActive || this.thumbLabel === 'always'
        }]
      }, [this.$createElement('div', this.setBackgroundColor(this.computedThumbColor, {
        staticClass: 'v-slider__thumb-label',
        style: {
          height: size,
          width: size,
          transform: transform
        }
      }), [this.$createElement('div', content)])])]);
    },
    genThumb: function genThumb() {
      return this.$createElement('div', this.setBackgroundColor(this.computedThumbColor, {
        staticClass: 'v-slider__thumb'
      }));
    },
    getThumbContainerStyles: function getThumbContainerStyles(width) {
      var direction = this.vertical ? 'top' : 'left';
      var value = this.$vuetify.rtl ? 100 - width : width;
      value = this.vertical ? 100 - value : value;
      return _defineProperty({
        transition: this.trackTransition
      }, direction, "".concat(value, "%"));
    },
    onSliderMouseDown: function onSliderMouseDown(e) {
      var _this2 = this;

      var _e$target;

      e.preventDefault();
      this.oldValue = this.internalValue;
      this.isActive = true;

      if ((_e$target = e.target) != null && _e$target.matches('.v-slider__thumb-container, .v-slider__thumb-container *')) {
        this.thumbPressed = true;
        var domRect = e.target.getBoundingClientRect();
        var touch = 'touches' in e ? e.touches[0] : e;
        this.startOffset = this.vertical ? touch.clientY - (domRect.top + domRect.height / 2) : touch.clientX - (domRect.left + domRect.width / 2);
      } else {
        this.startOffset = 0;
        window.clearTimeout(this.mouseTimeout);
        this.mouseTimeout = window.setTimeout(function () {
          _this2.thumbPressed = true;
        }, 300);
      }

      var mouseUpOptions = passiveSupported ? {
        passive: true,
        capture: true
      } : true;
      var mouseMoveOptions = passiveSupported ? {
        passive: true
      } : false;
      var isTouchEvent = ('touches' in e);
      this.onMouseMove(e);
      this.app.addEventListener(isTouchEvent ? 'touchmove' : 'mousemove', this.onMouseMove, mouseMoveOptions);
      addOnceEventListener(this.app, isTouchEvent ? 'touchend' : 'mouseup', this.onSliderMouseUp, mouseUpOptions);
      this.$emit('start', this.internalValue);
    },
    onSliderMouseUp: function onSliderMouseUp(e) {
      e.stopPropagation();
      window.clearTimeout(this.mouseTimeout);
      this.thumbPressed = false;
      var mouseMoveOptions = passiveSupported ? {
        passive: true
      } : false;
      this.app.removeEventListener('touchmove', this.onMouseMove, mouseMoveOptions);
      this.app.removeEventListener('mousemove', this.onMouseMove, mouseMoveOptions);
      this.$emit('mouseup', e);
      this.$emit('end', this.internalValue);

      if (!deepEqual(this.oldValue, this.internalValue)) {
        this.$emit('change', this.internalValue);
        this.noClick = true;
      }

      this.isActive = false;
    },
    onMouseMove: function onMouseMove(e) {
      if (e.type === 'mousemove') {
        this.thumbPressed = true;
      }

      this.internalValue = this.parseMouseMove(e);
    },
    onKeyDown: function onKeyDown(e) {
      if (!this.isInteractive) return;
      var value = this.parseKeyDown(e, this.internalValue);
      if (value == null || value < this.minValue || value > this.maxValue) return;
      this.internalValue = value;
      this.$emit('change', value);
    },
    onSliderClick: function onSliderClick(e) {
      if (this.noClick) {
        this.noClick = false;
        return;
      }

      var thumb = this.$refs.thumb;
      thumb.focus();
      this.onMouseMove(e);
      this.$emit('change', this.internalValue);
    },
    onBlur: function onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    onFocus: function onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    parseMouseMove: function parseMouseMove(e) {
      var start = this.vertical ? 'top' : 'left';
      var length = this.vertical ? 'height' : 'width';
      var click = this.vertical ? 'clientY' : 'clientX';

      var _this$$refs$track$get = this.$refs.track.getBoundingClientRect(),
          trackStart = _this$$refs$track$get[start],
          trackLength = _this$$refs$track$get[length];

      var clickOffset = 'touches' in e ? e.touches[0][click] : e[click]; // It is possible for left to be NaN, force to number

      var clickPos = Math.min(Math.max((clickOffset - trackStart - this.startOffset) / trackLength, 0), 1) || 0;
      if (this.vertical) clickPos = 1 - clickPos;
      if (this.$vuetify.rtl) clickPos = 1 - clickPos;
      return parseFloat(this.min) + clickPos * (this.maxValue - this.minValue);
    },
    parseKeyDown: function parseKeyDown(e, value) {
      if (!this.isInteractive) return;
      var pageup = keyCodes.pageup,
          pagedown = keyCodes.pagedown,
          end = keyCodes.end,
          home = keyCodes.home,
          left = keyCodes.left,
          right = keyCodes.right,
          down = keyCodes.down,
          up = keyCodes.up;
      if (![pageup, pagedown, end, home, left, right, down, up].includes(e.keyCode)) return;
      e.preventDefault();
      var step = this.stepNumeric || 1;
      var steps = (this.maxValue - this.minValue) / step;

      if ([left, right, down, up].includes(e.keyCode)) {
        var increase = this.$vuetify.rtl ? [left, up] : [right, up];
        var direction = increase.includes(e.keyCode) ? 1 : -1;
        var multiplier = e.shiftKey ? 3 : e.ctrlKey ? 2 : 1;
        value = value + direction * step * multiplier;
      } else if (e.keyCode === home) {
        value = this.minValue;
      } else if (e.keyCode === end) {
        value = this.maxValue;
      } else {
        var _direction = e.keyCode === pagedown ? 1 : -1;

        value = value - _direction * step * (steps > 100 ? steps / 10 : 10);
      }

      return value;
    },
    roundValue: function roundValue(value) {
      if (!this.stepNumeric) return value; // Format input value using the same number
      // of decimals places as in the step prop

      var trimmedStep = this.step.toString().trim();
      var decimals = trimmedStep.indexOf('.') > -1 ? trimmedStep.length - trimmedStep.indexOf('.') - 1 : 0;
      var offset = this.minValue % this.stepNumeric;
      var newValue = Math.round((value - offset) / this.stepNumeric) * this.stepNumeric + offset;
      return parseFloat(Math.min(newValue, this.maxValue).toFixed(decimals));
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/util/index.js



var util_excluded = ["a"];

// Utilities

function fromHSVA(hsva) {
  hsva = _objectSpread2({}, hsva);
  var hexa = HSVAtoHex(hsva);
  var hsla = HSVAtoHSLA(hsva);
  var rgba = HSVAtoRGBA(hsva);
  return {
    alpha: hsva.a,
    hex: hexa.substr(0, 7),
    hexa: hexa,
    hsla: hsla,
    hsva: hsva,
    hue: hsva.h,
    rgba: rgba
  };
}
function fromHSLA(hsla) {
  var hsva = HSLAtoHSVA(hsla);
  var hexa = HSVAtoHex(hsva);
  var rgba = HSVAtoRGBA(hsva);
  return {
    alpha: hsva.a,
    hex: hexa.substr(0, 7),
    hexa: hexa,
    hsla: hsla,
    hsva: hsva,
    hue: hsva.h,
    rgba: rgba
  };
}
function fromRGBA(rgba) {
  var hsva = RGBAtoHSVA(rgba);
  var hexa = RGBAtoHex(rgba);
  var hsla = HSVAtoHSLA(hsva);
  return {
    alpha: hsva.a,
    hex: hexa.substr(0, 7),
    hexa: hexa,
    hsla: hsla,
    hsva: hsva,
    hue: hsva.h,
    rgba: rgba
  };
}
function fromHexa(hexa) {
  var hsva = HexToHSVA(hexa);
  var hsla = HSVAtoHSLA(hsva);
  var rgba = HSVAtoRGBA(hsva);
  return {
    alpha: hsva.a,
    hex: hexa.substr(0, 7),
    hexa: hexa,
    hsla: hsla,
    hsva: hsva,
    hue: hsva.h,
    rgba: rgba
  };
}
function fromHex(hex) {
  return fromHexa(parseHex(hex));
}

function has(obj, key) {
  return key.every(function (k) {
    return obj.hasOwnProperty(k);
  });
}

function parseColor(color, oldColor) {
  if (!color) return fromRGBA({
    r: 255,
    g: 0,
    b: 0,
    a: 1
  });

  if (typeof color === 'string') {
    if (color === 'transparent') return fromHexa('#00000000');
    var hex = parseHex(color);
    if (oldColor && hex === oldColor.hexa) return oldColor;else return fromHexa(hex);
  }

  if (_typeof(color) === 'object') {
    if (color.hasOwnProperty('alpha')) return color;
    var a = color.hasOwnProperty('a') ? parseFloat(color.a) : 1;

    if (has(color, ['r', 'g', 'b'])) {
      if (oldColor && color === oldColor.rgba) return oldColor;else return fromRGBA(_objectSpread2(_objectSpread2({}, color), {}, {
        a: a
      }));
    } else if (has(color, ['h', 's', 'l'])) {
      if (oldColor && color === oldColor.hsla) return oldColor;else return fromHSLA(_objectSpread2(_objectSpread2({}, color), {}, {
        a: a
      }));
    } else if (has(color, ['h', 's', 'v'])) {
      if (oldColor && color === oldColor.hsva) return oldColor;else return fromHSVA(_objectSpread2(_objectSpread2({}, color), {}, {
        a: a
      }));
    }
  }

  return fromRGBA({
    r: 255,
    g: 0,
    b: 0,
    a: 1
  });
}

function util_stripAlpha(color, stripAlpha) {
  if (stripAlpha) {
    var a = color.a,
        rest = _objectWithoutProperties(color, util_excluded);

    return rest;
  }

  return color;
}

function extractColor(color, input) {
  if (input == null) return color;

  if (typeof input === 'string') {
    return input.length === 7 ? color.hex : color.hexa;
  }

  if (_typeof(input) === 'object') {
    var shouldStrip = typeof input.a === 'number' && input.a === 0 ? !!input.a : !input.a;
    if (has(input, ['r', 'g', 'b'])) return util_stripAlpha(color.rgba, shouldStrip);else if (has(input, ['h', 's', 'l'])) return util_stripAlpha(color.hsla, shouldStrip);else if (has(input, ['h', 's', 'v'])) return util_stripAlpha(color.hsva, shouldStrip);
  }

  return color;
}
function hasAlpha(color) {
  if (!color) return false;

  if (typeof color === 'string') {
    return color.length > 7;
  }

  if (_typeof(color) === 'object') {
    return has(color, ['a']) || has(color, ['alpha']);
  }

  return false;
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPickerPreview.js


// Styles
 // Components

 // Utilities

 // Types



/* harmony default export */ var VColorPicker_VColorPickerPreview = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-color-picker-preview',
  props: {
    color: Object,
    disabled: Boolean,
    hideAlpha: Boolean
  },
  methods: {
    genAlpha: function genAlpha() {
      var _this = this;

      return this.genTrack({
        staticClass: 'v-color-picker__alpha',
        props: {
          thumbColor: 'grey lighten-2',
          hideDetails: true,
          value: this.color.alpha,
          step: 0,
          min: 0,
          max: 1
        },
        style: {
          backgroundImage: this.disabled ? undefined : "linear-gradient(to ".concat(this.$vuetify.rtl ? 'left' : 'right', ", transparent, ").concat(RGBtoCSS(this.color.rgba), ")")
        },
        on: {
          input: function input(val) {
            return _this.color.alpha !== val && _this.$emit('update:color', fromHSVA(_objectSpread2(_objectSpread2({}, _this.color.hsva), {}, {
              a: val
            })));
          }
        }
      });
    },
    genSliders: function genSliders() {
      return this.$createElement('div', {
        staticClass: 'v-color-picker__sliders'
      }, [this.genHue(), !this.hideAlpha && this.genAlpha()]);
    },
    genDot: function genDot() {
      return this.$createElement('div', {
        staticClass: 'v-color-picker__dot'
      }, [this.$createElement('div', {
        style: {
          background: RGBAtoCSS(this.color.rgba)
        }
      })]);
    },
    genHue: function genHue() {
      var _this2 = this;

      return this.genTrack({
        staticClass: 'v-color-picker__hue',
        props: {
          thumbColor: 'grey lighten-2',
          hideDetails: true,
          value: this.color.hue,
          step: 0,
          min: 0,
          max: 360
        },
        on: {
          input: function input(val) {
            return _this2.color.hue !== val && _this2.$emit('update:color', fromHSVA(_objectSpread2(_objectSpread2({}, _this2.color.hsva), {}, {
              h: val
            })));
          }
        }
      });
    },
    genTrack: function genTrack(options) {
      return this.$createElement(VSlider_VSlider, _objectSpread2(_objectSpread2({
        class: 'v-color-picker__track'
      }, options), {}, {
        props: _objectSpread2({
          disabled: this.disabled
        }, options.props)
      }));
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-color-picker__preview',
      class: {
        'v-color-picker__preview--hide-alpha': this.hideAlpha
      }
    }, [this.genDot(), this.genSliders()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPickerCanvas.sass
var VColorPickerCanvas = __webpack_require__("d59f");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPickerCanvas.js


// Styles
 // Helpers


 // Types


/* harmony default export */ var VColorPicker_VColorPickerCanvas = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-color-picker-canvas',
  props: {
    color: {
      type: Object,
      default: function _default() {
        return fromRGBA({
          r: 255,
          g: 0,
          b: 0,
          a: 1
        });
      }
    },
    disabled: Boolean,
    dotSize: {
      type: [Number, String],
      default: 10
    },
    height: {
      type: [Number, String],
      default: 150
    },
    width: {
      type: [Number, String],
      default: 300
    }
  },
  data: function data() {
    return {
      boundingRect: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }
    };
  },
  computed: {
    dot: function dot() {
      if (!this.color) return {
        x: 0,
        y: 0
      };
      return {
        x: this.color.hsva.s * parseInt(this.width, 10),
        y: (1 - this.color.hsva.v) * parseInt(this.height, 10)
      };
    }
  },
  watch: {
    'color.hue': 'updateCanvas'
  },
  mounted: function mounted() {
    this.updateCanvas();
  },
  methods: {
    emitColor: function emitColor(x, y) {
      var _this$boundingRect = this.boundingRect,
          left = _this$boundingRect.left,
          top = _this$boundingRect.top,
          width = _this$boundingRect.width,
          height = _this$boundingRect.height;
      this.$emit('update:color', fromHSVA({
        h: this.color.hue,
        s: clamp(x - left, 0, width) / width,
        v: 1 - clamp(y - top, 0, height) / height,
        a: this.color.alpha
      }));
    },
    updateCanvas: function updateCanvas() {
      if (!this.color) return;
      var canvas = this.$refs.canvas;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var saturationGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      saturationGradient.addColorStop(0, 'hsla(0, 0%, 100%, 1)'); // white

      saturationGradient.addColorStop(1, "hsla(".concat(this.color.hue, ", 100%, 50%, 1)"));
      ctx.fillStyle = saturationGradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      var valueGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      valueGradient.addColorStop(0, 'hsla(0, 0%, 100%, 0)'); // transparent

      valueGradient.addColorStop(1, 'hsla(0, 0%, 0%, 1)'); // black

      ctx.fillStyle = valueGradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    },
    handleClick: function handleClick(e) {
      if (this.disabled) return;
      this.boundingRect = this.$el.getBoundingClientRect();
      this.emitColor(e.clientX, e.clientY);
    },
    handleMouseDown: function handleMouseDown(e) {
      // To prevent selection while moving cursor
      e.preventDefault();
      if (this.disabled) return;
      this.boundingRect = this.$el.getBoundingClientRect();
      window.addEventListener('mousemove', this.handleMouseMove);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseMove: function handleMouseMove(e) {
      if (this.disabled) return;
      this.emitColor(e.clientX, e.clientY);
    },
    handleMouseUp: function handleMouseUp() {
      window.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('mouseup', this.handleMouseUp);
    },
    genCanvas: function genCanvas() {
      return this.$createElement('canvas', {
        ref: 'canvas',
        attrs: {
          width: this.width,
          height: this.height
        }
      });
    },
    genDot: function genDot() {
      var radius = parseInt(this.dotSize, 10) / 2;
      var x = convertToUnit(this.dot.x - radius);
      var y = convertToUnit(this.dot.y - radius);
      return this.$createElement('div', {
        staticClass: 'v-color-picker__canvas-dot',
        class: {
          'v-color-picker__canvas-dot--disabled': this.disabled
        },
        style: {
          width: convertToUnit(this.dotSize),
          height: convertToUnit(this.dotSize),
          transform: "translate(".concat(x, ", ").concat(y, ")")
        }
      });
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-color-picker__canvas',
      style: {
        width: convertToUnit(this.width),
        height: convertToUnit(this.height)
      },
      on: {
        click: this.handleClick,
        mousedown: this.handleMouseDown
      }
    }, [this.genCanvas(), this.genDot()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPickerEdit.sass
var VColorPickerEdit = __webpack_require__("9f7f1");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPickerEdit.js









// Styles
 // Components


 // Helpers

 // Types



var modes = {
  rgba: {
    inputs: [['r', 255, 'int'], ['g', 255, 'int'], ['b', 255, 'int'], ['a', 1, 'float']],
    from: fromRGBA
  },
  hsla: {
    inputs: [['h', 360, 'int'], ['s', 1, 'float'], ['l', 1, 'float'], ['a', 1, 'float']],
    from: fromHSLA
  },
  hexa: {
    from: fromHexa
  }
};
/* harmony default export */ var VColorPicker_VColorPickerEdit = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-color-picker-edit',
  props: {
    color: Object,
    disabled: Boolean,
    hideAlpha: Boolean,
    hideModeSwitch: Boolean,
    mode: {
      type: String,
      default: 'rgba',
      validator: function validator(v) {
        return Object.keys(modes).includes(v);
      }
    }
  },
  data: function data() {
    return {
      modes: modes,
      internalMode: this.mode
    };
  },
  computed: {
    currentMode: function currentMode() {
      return this.modes[this.internalMode];
    }
  },
  watch: {
    mode: function mode(_mode) {
      this.internalMode = _mode;
    }
  },
  created: function created() {
    this.internalMode = this.mode;
  },
  methods: {
    getValue: function getValue(v, type) {
      if (type === 'float') return Math.round(v * 100) / 100;else if (type === 'int') return Math.round(v);else return 0;
    },
    parseValue: function parseValue(v, type) {
      if (type === 'float') return parseFloat(v);else if (type === 'int') return parseInt(v, 10) || 0;else return 0;
    },
    changeMode: function changeMode() {
      var modes = Object.keys(this.modes);
      var index = modes.indexOf(this.internalMode);
      var newMode = modes[(index + 1) % modes.length];
      this.internalMode = newMode;
      this.$emit('update:mode', newMode);
    },
    genInput: function genInput(target, attrs, value, on) {
      return this.$createElement('div', {
        staticClass: 'v-color-picker__input'
      }, [this.$createElement('input', {
        key: target,
        attrs: attrs,
        domProps: {
          value: value
        },
        on: on
      }), this.$createElement('span', target.toUpperCase())]);
    },
    genInputs: function genInputs() {
      var _this = this;

      if (this.internalMode === 'hexa') {
        var hex = this.color.hexa;
        var value = this.hideAlpha && hex.endsWith('FF') ? hex.substr(0, 7) : hex;
        return this.genInput('hex', {
          maxlength: this.hideAlpha ? 7 : 9,
          disabled: this.disabled
        }, value, {
          change: function change(e) {
            var el = e.target;

            _this.$emit('update:color', _this.currentMode.from(parseHex(el.value)));
          }
        });
      } else {
        var inputs = this.hideAlpha ? this.currentMode.inputs.slice(0, -1) : this.currentMode.inputs;
        return inputs.map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              target = _ref2[0],
              max = _ref2[1],
              type = _ref2[2];

          var value = _this.color[_this.internalMode];
          return _this.genInput(target, {
            type: 'number',
            min: 0,
            max: max,
            step: type === 'float' ? '0.01' : type === 'int' ? '1' : undefined,
            disabled: _this.disabled
          }, _this.getValue(value[target], type), {
            input: function input(e) {
              var el = e.target;

              var newVal = _this.parseValue(el.value || '0', type);

              _this.$emit('update:color', _this.currentMode.from(Object.assign({}, value, _defineProperty({}, target, newVal)), _this.color.alpha));
            }
          });
        });
      }
    },
    genSwitch: function genSwitch() {
      return this.$createElement(components_VBtn, {
        props: {
          small: true,
          icon: true,
          disabled: this.disabled
        },
        on: {
          click: this.changeMode
        }
      }, [this.$createElement(components_VIcon, '$unfold')]);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-color-picker__edit'
    }, [this.genInputs(), !this.hideModeSwitch && this.genSwitch()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPickerSwatches.sass
var VColorPickerSwatches = __webpack_require__("31ce");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/colors.js

var red = Object.freeze({
  base: '#f44336',
  lighten5: '#ffebee',
  lighten4: '#ffcdd2',
  lighten3: '#ef9a9a',
  lighten2: '#e57373',
  lighten1: '#ef5350',
  darken1: '#e53935',
  darken2: '#d32f2f',
  darken3: '#c62828',
  darken4: '#b71c1c',
  accent1: '#ff8a80',
  accent2: '#ff5252',
  accent3: '#ff1744',
  accent4: '#d50000'
});
var pink = Object.freeze({
  base: '#e91e63',
  lighten5: '#fce4ec',
  lighten4: '#f8bbd0',
  lighten3: '#f48fb1',
  lighten2: '#f06292',
  lighten1: '#ec407a',
  darken1: '#d81b60',
  darken2: '#c2185b',
  darken3: '#ad1457',
  darken4: '#880e4f',
  accent1: '#ff80ab',
  accent2: '#ff4081',
  accent3: '#f50057',
  accent4: '#c51162'
});
var purple = Object.freeze({
  base: '#9c27b0',
  lighten5: '#f3e5f5',
  lighten4: '#e1bee7',
  lighten3: '#ce93d8',
  lighten2: '#ba68c8',
  lighten1: '#ab47bc',
  darken1: '#8e24aa',
  darken2: '#7b1fa2',
  darken3: '#6a1b9a',
  darken4: '#4a148c',
  accent1: '#ea80fc',
  accent2: '#e040fb',
  accent3: '#d500f9',
  accent4: '#aa00ff'
});
var deepPurple = Object.freeze({
  base: '#673ab7',
  lighten5: '#ede7f6',
  lighten4: '#d1c4e9',
  lighten3: '#b39ddb',
  lighten2: '#9575cd',
  lighten1: '#7e57c2',
  darken1: '#5e35b1',
  darken2: '#512da8',
  darken3: '#4527a0',
  darken4: '#311b92',
  accent1: '#b388ff',
  accent2: '#7c4dff',
  accent3: '#651fff',
  accent4: '#6200ea'
});
var indigo = Object.freeze({
  base: '#3f51b5',
  lighten5: '#e8eaf6',
  lighten4: '#c5cae9',
  lighten3: '#9fa8da',
  lighten2: '#7986cb',
  lighten1: '#5c6bc0',
  darken1: '#3949ab',
  darken2: '#303f9f',
  darken3: '#283593',
  darken4: '#1a237e',
  accent1: '#8c9eff',
  accent2: '#536dfe',
  accent3: '#3d5afe',
  accent4: '#304ffe'
});
var blue = Object.freeze({
  base: '#2196f3',
  lighten5: '#e3f2fd',
  lighten4: '#bbdefb',
  lighten3: '#90caf9',
  lighten2: '#64b5f6',
  lighten1: '#42a5f5',
  darken1: '#1e88e5',
  darken2: '#1976d2',
  darken3: '#1565c0',
  darken4: '#0d47a1',
  accent1: '#82b1ff',
  accent2: '#448aff',
  accent3: '#2979ff',
  accent4: '#2962ff'
});
var lightBlue = Object.freeze({
  base: '#03a9f4',
  lighten5: '#e1f5fe',
  lighten4: '#b3e5fc',
  lighten3: '#81d4fa',
  lighten2: '#4fc3f7',
  lighten1: '#29b6f6',
  darken1: '#039be5',
  darken2: '#0288d1',
  darken3: '#0277bd',
  darken4: '#01579b',
  accent1: '#80d8ff',
  accent2: '#40c4ff',
  accent3: '#00b0ff',
  accent4: '#0091ea'
});
var cyan = Object.freeze({
  base: '#00bcd4',
  lighten5: '#e0f7fa',
  lighten4: '#b2ebf2',
  lighten3: '#80deea',
  lighten2: '#4dd0e1',
  lighten1: '#26c6da',
  darken1: '#00acc1',
  darken2: '#0097a7',
  darken3: '#00838f',
  darken4: '#006064',
  accent1: '#84ffff',
  accent2: '#18ffff',
  accent3: '#00e5ff',
  accent4: '#00b8d4'
});
var teal = Object.freeze({
  base: '#009688',
  lighten5: '#e0f2f1',
  lighten4: '#b2dfdb',
  lighten3: '#80cbc4',
  lighten2: '#4db6ac',
  lighten1: '#26a69a',
  darken1: '#00897b',
  darken2: '#00796b',
  darken3: '#00695c',
  darken4: '#004d40',
  accent1: '#a7ffeb',
  accent2: '#64ffda',
  accent3: '#1de9b6',
  accent4: '#00bfa5'
});
var green = Object.freeze({
  base: '#4caf50',
  lighten5: '#e8f5e9',
  lighten4: '#c8e6c9',
  lighten3: '#a5d6a7',
  lighten2: '#81c784',
  lighten1: '#66bb6a',
  darken1: '#43a047',
  darken2: '#388e3c',
  darken3: '#2e7d32',
  darken4: '#1b5e20',
  accent1: '#b9f6ca',
  accent2: '#69f0ae',
  accent3: '#00e676',
  accent4: '#00c853'
});
var lightGreen = Object.freeze({
  base: '#8bc34a',
  lighten5: '#f1f8e9',
  lighten4: '#dcedc8',
  lighten3: '#c5e1a5',
  lighten2: '#aed581',
  lighten1: '#9ccc65',
  darken1: '#7cb342',
  darken2: '#689f38',
  darken3: '#558b2f',
  darken4: '#33691e',
  accent1: '#ccff90',
  accent2: '#b2ff59',
  accent3: '#76ff03',
  accent4: '#64dd17'
});
var lime = Object.freeze({
  base: '#cddc39',
  lighten5: '#f9fbe7',
  lighten4: '#f0f4c3',
  lighten3: '#e6ee9c',
  lighten2: '#dce775',
  lighten1: '#d4e157',
  darken1: '#c0ca33',
  darken2: '#afb42b',
  darken3: '#9e9d24',
  darken4: '#827717',
  accent1: '#f4ff81',
  accent2: '#eeff41',
  accent3: '#c6ff00',
  accent4: '#aeea00'
});
var yellow = Object.freeze({
  base: '#ffeb3b',
  lighten5: '#fffde7',
  lighten4: '#fff9c4',
  lighten3: '#fff59d',
  lighten2: '#fff176',
  lighten1: '#ffee58',
  darken1: '#fdd835',
  darken2: '#fbc02d',
  darken3: '#f9a825',
  darken4: '#f57f17',
  accent1: '#ffff8d',
  accent2: '#ffff00',
  accent3: '#ffea00',
  accent4: '#ffd600'
});
var amber = Object.freeze({
  base: '#ffc107',
  lighten5: '#fff8e1',
  lighten4: '#ffecb3',
  lighten3: '#ffe082',
  lighten2: '#ffd54f',
  lighten1: '#ffca28',
  darken1: '#ffb300',
  darken2: '#ffa000',
  darken3: '#ff8f00',
  darken4: '#ff6f00',
  accent1: '#ffe57f',
  accent2: '#ffd740',
  accent3: '#ffc400',
  accent4: '#ffab00'
});
var orange = Object.freeze({
  base: '#ff9800',
  lighten5: '#fff3e0',
  lighten4: '#ffe0b2',
  lighten3: '#ffcc80',
  lighten2: '#ffb74d',
  lighten1: '#ffa726',
  darken1: '#fb8c00',
  darken2: '#f57c00',
  darken3: '#ef6c00',
  darken4: '#e65100',
  accent1: '#ffd180',
  accent2: '#ffab40',
  accent3: '#ff9100',
  accent4: '#ff6d00'
});
var deepOrange = Object.freeze({
  base: '#ff5722',
  lighten5: '#fbe9e7',
  lighten4: '#ffccbc',
  lighten3: '#ffab91',
  lighten2: '#ff8a65',
  lighten1: '#ff7043',
  darken1: '#f4511e',
  darken2: '#e64a19',
  darken3: '#d84315',
  darken4: '#bf360c',
  accent1: '#ff9e80',
  accent2: '#ff6e40',
  accent3: '#ff3d00',
  accent4: '#dd2c00'
});
var brown = Object.freeze({
  base: '#795548',
  lighten5: '#efebe9',
  lighten4: '#d7ccc8',
  lighten3: '#bcaaa4',
  lighten2: '#a1887f',
  lighten1: '#8d6e63',
  darken1: '#6d4c41',
  darken2: '#5d4037',
  darken3: '#4e342e',
  darken4: '#3e2723'
});
var blueGrey = Object.freeze({
  base: '#607d8b',
  lighten5: '#eceff1',
  lighten4: '#cfd8dc',
  lighten3: '#b0bec5',
  lighten2: '#90a4ae',
  lighten1: '#78909c',
  darken1: '#546e7a',
  darken2: '#455a64',
  darken3: '#37474f',
  darken4: '#263238'
});
var grey = Object.freeze({
  base: '#9e9e9e',
  lighten5: '#fafafa',
  lighten4: '#f5f5f5',
  lighten3: '#eeeeee',
  lighten2: '#e0e0e0',
  lighten1: '#bdbdbd',
  darken1: '#757575',
  darken2: '#616161',
  darken3: '#424242',
  darken4: '#212121'
});
var shades = Object.freeze({
  black: '#000000',
  white: '#ffffff',
  transparent: 'transparent'
});
/* harmony default export */ var util_colors = (Object.freeze({
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  blueGrey: blueGrey,
  grey: grey,
  shades: shades
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPickerSwatches.js



// Styles
 // Components

 // Helpers








function parseDefaultColors(colors) {
  return Object.keys(colors).map(function (key) {
    var color = colors[key];
    return color.base ? [color.base, color.darken4, color.darken3, color.darken2, color.darken1, color.lighten1, color.lighten2, color.lighten3, color.lighten4, color.lighten5] : [color.black, color.white, color.transparent];
  });
}

var white = fromHex('#FFFFFF').rgba;
var black = fromHex('#000000').rgba;
/* harmony default export */ var VColorPicker_VColorPickerSwatches = (mixins_mixins(themeable).extend({
  name: 'v-color-picker-swatches',
  props: {
    swatches: {
      type: Array,
      default: function _default() {
        return parseDefaultColors(util_colors);
      }
    },
    disabled: Boolean,
    color: Object,
    maxWidth: [Number, String],
    maxHeight: [Number, String]
  },
  methods: {
    genColor: function genColor(color) {
      var _this = this;

      var content = this.$createElement('div', {
        style: {
          background: color
        }
      }, [deepEqual(this.color, parseColor(color, null)) && this.$createElement(components_VIcon, {
        props: {
          small: true,
          dark: contrastRatio(this.color.rgba, white) > 2 && this.color.alpha > 0.5,
          light: contrastRatio(this.color.rgba, black) > 2 && this.color.alpha > 0.5
        }
      }, '$success')]);
      return this.$createElement('div', {
        staticClass: 'v-color-picker__color',
        on: {
          // TODO: Less hacky way of catching transparent
          click: function click() {
            return _this.disabled || _this.$emit('update:color', fromHex(color === 'transparent' ? '#00000000' : color));
          }
        }
      }, [content]);
    },
    genSwatches: function genSwatches() {
      var _this2 = this;

      return this.swatches.map(function (swatch) {
        var colors = swatch.map(_this2.genColor);
        return _this2.$createElement('div', {
          staticClass: 'v-color-picker__swatch'
        }, colors);
      });
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-color-picker__swatches',
      style: {
        maxWidth: convertToUnit(this.maxWidth),
        maxHeight: convertToUnit(this.maxHeight)
      }
    }, [this.$createElement('div', this.genSwatches())]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPicker.js







// Styles
 // Components





 // Helpers



 // Mixins



/* harmony default export */ var VColorPicker_VColorPicker = (mixins_mixins(elevatable, themeable).extend({
  name: 'v-color-picker',
  props: {
    canvasHeight: {
      type: [String, Number],
      default: 150
    },
    disabled: Boolean,
    dotSize: {
      type: [Number, String],
      default: 10
    },
    flat: Boolean,
    hideCanvas: Boolean,
    hideSliders: Boolean,
    hideInputs: Boolean,
    hideModeSwitch: Boolean,
    mode: {
      type: String,
      default: 'rgba',
      validator: function validator(v) {
        return Object.keys(modes).includes(v);
      }
    },
    showSwatches: Boolean,
    swatches: Array,
    swatchesMaxHeight: {
      type: [Number, String],
      default: 150
    },
    value: {
      type: [Object, String]
    },
    width: {
      type: [Number, String],
      default: 300
    }
  },
  data: function data() {
    return {
      internalValue: fromRGBA({
        r: 255,
        g: 0,
        b: 0,
        a: 1
      })
    };
  },
  computed: {
    hideAlpha: function hideAlpha() {
      if (!this.value) return false;
      return !hasAlpha(this.value);
    }
  },
  watch: {
    value: {
      handler: function handler(color) {
        this.updateColor(parseColor(color, this.internalValue));
      },
      immediate: true
    }
  },
  methods: {
    updateColor: function updateColor(color) {
      this.internalValue = color;
      var value = extractColor(this.internalValue, this.value);

      if (!deepEqual(value, this.value)) {
        this.$emit('input', value);
        this.$emit('update:color', this.internalValue);
      }
    },
    genCanvas: function genCanvas() {
      return this.$createElement(VColorPicker_VColorPickerCanvas, {
        props: {
          color: this.internalValue,
          disabled: this.disabled,
          dotSize: this.dotSize,
          width: this.width,
          height: this.canvasHeight
        },
        on: {
          'update:color': this.updateColor
        }
      });
    },
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'v-color-picker__controls'
      }, [!this.hideSliders && this.genPreview(), !this.hideInputs && this.genEdit()]);
    },
    genEdit: function genEdit() {
      var _this = this;

      return this.$createElement(VColorPicker_VColorPickerEdit, {
        props: {
          color: this.internalValue,
          disabled: this.disabled,
          hideAlpha: this.hideAlpha,
          hideModeSwitch: this.hideModeSwitch,
          mode: this.mode
        },
        on: {
          'update:color': this.updateColor,
          'update:mode': function updateMode(v) {
            return _this.$emit('update:mode', v);
          }
        }
      });
    },
    genPreview: function genPreview() {
      return this.$createElement(VColorPicker_VColorPickerPreview, {
        props: {
          color: this.internalValue,
          disabled: this.disabled,
          hideAlpha: this.hideAlpha
        },
        on: {
          'update:color': this.updateColor
        }
      });
    },
    genSwatches: function genSwatches() {
      return this.$createElement(VColorPicker_VColorPickerSwatches, {
        props: {
          dark: this.dark,
          light: this.light,
          disabled: this.disabled,
          swatches: this.swatches,
          color: this.internalValue,
          maxHeight: this.swatchesMaxHeight
        },
        on: {
          'update:color': this.updateColor
        }
      });
    }
  },
  render: function render(h) {
    return h(VSheet_VSheet, {
      staticClass: 'v-color-picker',
      class: _objectSpread2(_objectSpread2({
        'v-color-picker--flat': this.flat
      }, this.themeClasses), this.elevationClasses),
      props: {
        maxWidth: this.width
      }
    }, [!this.hideCanvas && this.genCanvas(), (!this.hideSliders || !this.hideInputs) && this.genControls(), this.showSwatches && this.genSwatches()]);
  }
}));
// CONCATENATED MODULE: ./src/components/SettingsMenu.vue






/* normalize component */

var SettingsMenu_component = normalizeComponent(
  components_SettingsMenuvue_type_script_lang_ts_,
  SettingsMenuvue_type_template_id_c838e56a_scoped_true_render,
  SettingsMenuvue_type_template_id_c838e56a_scoped_true_staticRenderFns,
  false,
  null,
  "c838e56a",
  null
  
)

/* harmony default export */ var components_SettingsMenu = (SettingsMenu_component.exports);

/* vuetify-loader */











installComponents_default()(SettingsMenu_component, {VBtn: VBtn_VBtn,VCard: VCard_VCard,VColorPicker: VColorPicker_VColorPicker,VIcon: components_VIcon_VIcon,VList: VList_VList,VListItem: VList_VListItem,VListItemContent: VListItemContent,VMenu: VMenu_VMenu,VToolbar: VToolbar_VToolbar,VToolbarTitle: VToolbarTitle})

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce90acc8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pin/PinnedMessage.vue?vue&type=template&id=04c4f152&scoped=true&
var PinnedMessagevue_type_template_id_04c4f152_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pinned-message mx-1 mt-1 pb-3",attrs:{"color":"brand","dark":_vm.brandTextColorLight}},[_c('v-list-item',{staticClass:"content pt-0 pl-6 pr-7 align-stretch flex-column",class:_vm.getPinnedMessages.length > 1 ? ' paginated' : '',staticStyle:{"position":"relative"}},[_c('v-row',{staticClass:"pinned-message-header brand flex-grow-0 flex-nowrap",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"d-flex flex-row align-center py-2"},[(!_vm.enabledFeatures.COMPACT_MESSAGES)?_c('v-list-item-avatar',{attrs:{"color":"grey darken-3 avatar"}},[_c('v-img',{staticClass:"elevation-6",attrs:{"alt":"","src":_vm.userAvatar}})],1):_vm._e(),(_vm.pinnedMessage)?_c('ChatModBadge',{attrs:{"userInfo":_vm.pinnedMessage.createdBy}}):_vm._e(),_c('p',{staticClass:"mb-0",staticStyle:{"word-break":"break-all"}},[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),_c('div',{staticClass:"d-flex align-center"},[_c('p',{staticClass:"time mb-0"},[_vm._v(_vm._s(_vm.timeRemaining))]),(_vm.canDelete)?_c('div',{staticClass:"delete-icon ml-1"},[_c('v-icon',{staticClass:"ma-0 pa-0",attrs:{"size":"20"},on:{"click":_vm.deleteMessage}},[_vm._v(" mdi-delete ")])],1):_vm._e()])],1),_c('v-col',{staticClass:"d-flex flex-grow-0 align-center"},[_c('span',{staticClass:"close-btn ml-3",on:{"click":function($event){return _vm.setIsPinnedMessage(false)}}},[_c('v-icon',[_vm._v("mdi-close-circle")])],1)])],1),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-0 mr-2",attrs:{"cols":"12"}},[_c('v-list-item-content',{staticClass:"pa-0"},[_c('v-card-text',{staticClass:"font-weight-normal message",domProps:{"innerHTML":_vm._s(_vm.formattedContent)}})],1)],1)],1)],1),(_vm.getPinnedMessages.length > 1)?_c('div',{staticClass:"pt-1 d-flex justify-center mb-n2"},[_c('v-icon',{staticClass:"pagination-btn",on:{"click":_vm.previousPin}},[_vm._v(" mdi-chevron-left ")]),_c('span',[_vm._v(_vm._s(_vm.index + 1)+" / "+_vm._s(_vm.getPinnedMessages.length)+" ")]),_c('v-icon',{staticClass:"pagination-btn",on:{"click":_vm.nextPin}},[_vm._v(" mdi-chevron-right ")])],1):_vm._e()],1)}
var PinnedMessagevue_type_template_id_04c4f152_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Pin/PinnedMessage.vue?vue&type=template&id=04c4f152&scoped=true&

// CONCATENATED MODULE: ./src/shared/utils/timeConsts.ts
var MINUTE_IN_MS = 1000 * 60;
var HOUR_IN_MS = MINUTE_IN_MS * 60;
var DAY_IN_MS = HOUR_IN_MS * 24;
var HOUR_IN_MINUTES = 60;
var DAY_IN_MINUTES = HOUR_IN_MINUTES * 24;
var WEEK_IN_MINUTES = DAY_IN_MINUTES * 7;
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pin/PinnedMessage.vue?vue&type=script&lang=ts&
































var PinnedMessagevue_type_script_lang_ts_PinnedMessage = /*#__PURE__*/function (_Vue) {
  _inherits(PinnedMessage, _Vue);

  var _super = _createSuper(PinnedMessage);

  function PinnedMessage() {
    var _this;

    _classCallCheck(this, PinnedMessage);

    _this = _super.apply(this, arguments);
    _this.isOpenMore = false;
    _this.pinnedMsg = "pinned-msg";
    _this.isExpandedList = false;
    _this.urlRegEx = /<link\|([^|]+)\|([^|]+)>/;
    _this.index = 0;
    _this.currentPinId = "";
    _this.timeRemaining = "";
    _this.timeRemainingTimeout = undefined;
    _this.enabledFeatures = getModule(store_ConfigModule, _this.$store).enabledFeatures;
    return _this;
  }

  _createClass(PinnedMessage, [{
    key: "created",
    value: function created() {
      this.startPinSync();
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      clearInterval(this.timeRemainingTimeout);
    }
  }, {
    key: "expandList",
    value: function expandList() {
      this.isExpandedList = !this.isExpandedList;
    }
  }, {
    key: "startPinSync",
    value: function startPinSync() {
      if (this.pinnedMessage) {
        this.setTimeRemaining();
        if (this.timeRemainingTimeout !== undefined) return;
        this.timeRemainingTimeout = setInterval(this.syncPinData, MINUTE_IN_MS);
      } else {
        clearInterval(this.timeRemainingTimeout);
      }
    }
  }, {
    key: "syncPinData",
    value: function syncPinData() {
      this.removeOldPins();
      this.setTimeRemaining();
    }
  }, {
    key: "removeOldPins",
    value: function removeOldPins() {
      var _this2 = this;

      var removablePins = this.getPinnedMessages.filter(function (_ref) {
        var dateCreated = _ref.dateCreated,
            validUntil = _ref.validUntil;
        return (// Pin expiry has passed and not Indefinite
          validUntil <= Date.now() && validUntil !== dateCreated
        );
      });

      if (removablePins.length) {
        var _this$pinnedMessage$i, _this$pinnedMessage;

        this.currentPinId = (_this$pinnedMessage$i = (_this$pinnedMessage = this.pinnedMessage) === null || _this$pinnedMessage === void 0 ? void 0 : _this$pinnedMessage.id) !== null && _this$pinnedMessage$i !== void 0 ? _this$pinnedMessage$i : "";

        var _iterator = _createForOfIteratorHelper(removablePins),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pin = _step.value;
            if (pin.id) this.removePinnedMessage(pin.id);

            if (this.currentPinId) {
              this.index = Math.max(this.getPinnedMessages.findIndex(function (pin) {
                return pin.id === _this2.currentPinId;
              }), 0);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "setTimeRemaining",
    value: function setTimeRemaining() {
      if (!this.pinnedMessage) this.timeRemaining = "";else {
        // Indefinite
        if (this.pinnedMessage.validUntil === this.pinnedMessage.dateCreated) {
          this.timeRemaining = this.canDelete ? this.$t("s8c.time.indefinite").toString() : "";
          return;
        }

        var timeRemainingMinutes = (this.pinnedMessage.validUntil - Date.now()) / MINUTE_IN_MS;

        if (timeRemainingMinutes <= 1) {
          this.timeRemaining = this.$tc("s8c.time.minutes", 1, {
            value: 1
          });
          return;
        }

        var durationBreakdown = {
          weeks: Math.floor(timeRemainingMinutes / WEEK_IN_MINUTES),
          days: Math.floor(timeRemainingMinutes % WEEK_IN_MINUTES / DAY_IN_MINUTES),
          hours: Math.floor(timeRemainingMinutes % WEEK_IN_MINUTES % DAY_IN_MINUTES / HOUR_IN_MINUTES),
          minutes: Math.floor(timeRemainingMinutes % WEEK_IN_MINUTES % DAY_IN_MINUTES % HOUR_IN_MINUTES)
        };
        var durationPieces = [];

        for (var _i = 0, _Object$entries = Object.entries(durationBreakdown); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              timeUnit = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          if (value > 0) {
            durationPieces.push(this.$tc("s8c.time.".concat(timeUnit), value, {
              value: value
            }));
            if (durationPieces.length >= 2) break;
          }
        }

        this.timeRemaining = durationPieces.join(" ");
      }
    }
  }, {
    key: "pinnedMessage",
    get: function get() {
      return this.getPinnedMessages[this.index];
    }
  }, {
    key: "message",
    get: function get() {
      var _this$pinnedMessage2;

      return ((_this$pinnedMessage2 = this.pinnedMessage) === null || _this$pinnedMessage2 === void 0 ? void 0 : _this$pinnedMessage2.pinnedMessage) || "";
    }
  }, {
    key: "disabledList",
    get: function get() {
      if (this.getPinnedMessages.length > 1) return false;else return true;
    }
  }, {
    key: "canDelete",
    get: function get() {
      var _this$user, _this$user$roles, _this$user2, _this$user2$roles;

      return ((_this$user = this.user) === null || _this$user === void 0 ? void 0 : (_this$user$roles = _this$user.roles) === null || _this$user$roles === void 0 ? void 0 : _this$user$roles.includes(Role.ROLE_ADMIN)) || ((_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : (_this$user2$roles = _this$user2.roles) === null || _this$user2$roles === void 0 ? void 0 : _this$user2$roles.includes(Role.ROLE_MODERATOR));
    }
  }, {
    key: "brandTextColorLight",
    get: function get() {
      var _this$$vuetify$theme$;

      var col = (_this$$vuetify$theme$ = this.$vuetify.theme.currentTheme.brand) === null || _this$$vuetify$theme$ === void 0 ? void 0 : _this$$vuetify$theme$.toString();
      return !col || colors_isDark(hexToRGB(col));
    }
  }, {
    key: "userAvatar",
    get: function get() {
      var _this$pinnedMessage3, _this$pinnedMessage3$, _this$pinnedMessage3$2;

      if ((_this$pinnedMessage3 = this.pinnedMessage) !== null && _this$pinnedMessage3 !== void 0 && (_this$pinnedMessage3$ = _this$pinnedMessage3.createdBy) !== null && _this$pinnedMessage3$ !== void 0 && (_this$pinnedMessage3$2 = _this$pinnedMessage3$.avatar) !== null && _this$pinnedMessage3$2 !== void 0 && _this$pinnedMessage3$2.src) {
        return this.pinnedMessage.createdBy.avatar.src;
      }

      return "https://cdn.spect8.io/chat/avatars/baseline_account_circle_white_48dp_2x.png";
    }
  }, {
    key: "deleteMessage",
    value: function deleteMessage(item) {
      var _this$pinnedMessage4;

      var messageId = (item === null || item === void 0 ? void 0 : item.id) || ((_this$pinnedMessage4 = this.pinnedMessage) === null || _this$pinnedMessage4 === void 0 ? void 0 : _this$pinnedMessage4.id);

      if (this.canDelete && messageId) {
        this.deletePinnedMessage({
          messageId: messageId
        });
        if (this.index > 0) this.index--;
      } else {
        console.log("No role.");
      }
    }
  }, {
    key: "formattedContent",
    get: function get() {
      var _this$pinnedMessage5,
          _this3 = this;

      return ((_this$pinnedMessage5 = this.pinnedMessage) === null || _this$pinnedMessage5 === void 0 ? void 0 : _this$pinnedMessage5.pinnedMessage.split(/[\s]+/).map(function (word) {
        if (word.match(_this3.urlRegEx)) return _this3.transformLinkAlt(word);
        return word;
      }).join(" ")) || "";
    }
  }, {
    key: "transformLinkAlt",
    value: function transformLinkAlt(s) {
      var _this4 = this;

      var re = /<link\|([^|]+)\|([^|]+)>/;
      return s.replace(re, function (_, p1, p2) {
        var _this4$user$tenant;

        return "<a style=\"color: inherit !important;\" href=\"".concat(p1, "?tid=").concat((_this4$user$tenant = _this4.user.tenant) === null || _this4$user$tenant === void 0 ? void 0 : _this4$user$tenant.tenantId, "&uid=").concat(_this4.hash(_this4.user.id), "\" target=\"_blank\">").concat(p2, "</a>");
      });
    }
  }, {
    key: "hash",
    value: function hash(s) {
      var hash = 0;
      var chr = 0;
      if (s.length === 0) return hash;

      for (var i = 0; i < s.length; i++) {
        chr = s.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }

      return hash;
    }
  }, {
    key: "displayName",
    get: function get() {
      var _this$pinnedMessage6, _this$pinnedMessage6$;

      return ((_this$pinnedMessage6 = this.pinnedMessage) === null || _this$pinnedMessage6 === void 0 ? void 0 : (_this$pinnedMessage6$ = _this$pinnedMessage6.createdBy) === null || _this$pinnedMessage6$ === void 0 ? void 0 : _this$pinnedMessage6$.displayName) || "";
    }
  }, {
    key: "nextPin",
    value: function nextPin() {
      if (this.index + 1 === this.getPinnedMessages.length) this.index = 0;else this.index++;
    }
  }, {
    key: "previousPin",
    value: function previousPin() {
      if (this.index === 0) this.index = this.getPinnedMessages.length - 1;else this.index--;
    }
  }]);

  return PinnedMessage;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Getter("getIsPinnedMessage", {
  namespace: store_CHAT_NAMESPACE
})], PinnedMessagevue_type_script_lang_ts_PinnedMessage.prototype, "isPinnedMessage", void 0);

__decorate([Getter("getPinnedMessages", {
  namespace: store_CHAT_NAMESPACE
})], PinnedMessagevue_type_script_lang_ts_PinnedMessage.prototype, "getPinnedMessages", void 0);

__decorate([Getter("user", {
  namespace: USER_NAMESPACE
})], PinnedMessagevue_type_script_lang_ts_PinnedMessage.prototype, "user", void 0);

__decorate([bindings_Mutation("setIsPinnedMessage", {
  namespace: store_CHAT_NAMESPACE
})], PinnedMessagevue_type_script_lang_ts_PinnedMessage.prototype, "setIsPinnedMessage", void 0);

__decorate([bindings_Mutation("setDismissPinnedMessage", {
  namespace: store_CHAT_NAMESPACE
})], PinnedMessagevue_type_script_lang_ts_PinnedMessage.prototype, "setDismissPinnedMessage", void 0);

__decorate([bindings_Action("deletePinnedMessage", {
  namespace: store_CHAT_NAMESPACE
})], PinnedMessagevue_type_script_lang_ts_PinnedMessage.prototype, "deletePinnedMessage", void 0);

__decorate([bindings_Action("removePinnedMessage", {
  namespace: store_CHAT_NAMESPACE
})], PinnedMessagevue_type_script_lang_ts_PinnedMessage.prototype, "removePinnedMessage", void 0);

__decorate([Watch("getPinnedMessages"), Watch("pinnedMessage")], PinnedMessagevue_type_script_lang_ts_PinnedMessage.prototype, "startPinSync", null);

PinnedMessagevue_type_script_lang_ts_PinnedMessage = __decorate([vue_class_component_esm({
  components: {
    ChatModBadge: components_ChatModBadge
  }
})], PinnedMessagevue_type_script_lang_ts_PinnedMessage);
/* harmony default export */ var PinnedMessagevue_type_script_lang_ts_ = (PinnedMessagevue_type_script_lang_ts_PinnedMessage);
// CONCATENATED MODULE: ./src/components/Pin/PinnedMessage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Pin_PinnedMessagevue_type_script_lang_ts_ = (PinnedMessagevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Pin/PinnedMessage.vue?vue&type=style&index=0&id=04c4f152&lang=scss&scoped=true&
var PinnedMessagevue_type_style_index_0_id_04c4f152_lang_scss_scoped_true_ = __webpack_require__("8afd");

// CONCATENATED MODULE: ./src/components/Pin/PinnedMessage.vue






/* normalize component */

var PinnedMessage_component = normalizeComponent(
  Pin_PinnedMessagevue_type_script_lang_ts_,
  PinnedMessagevue_type_template_id_04c4f152_scoped_true_render,
  PinnedMessagevue_type_template_id_04c4f152_scoped_true_staticRenderFns,
  false,
  null,
  "04c4f152",
  null
  
)

/* harmony default export */ var Pin_PinnedMessage = (PinnedMessage_component.exports);

/* vuetify-loader */










installComponents_default()(PinnedMessage_component, {VCard: VCard_VCard,VCardText: VCardText,VCol: VCol,VIcon: components_VIcon_VIcon,VImg: VImg_VImg,VListItem: VList_VListItem,VListItemAvatar: VListItemAvatar,VListItemContent: VListItemContent,VRow: VRow})

// EXTERNAL MODULE: ./node_modules/vue-at/dist/vue-at-textarea.js
var vue_at_textarea = __webpack_require__("53ff");
var vue_at_textarea_default = /*#__PURE__*/__webpack_require__.n(vue_at_textarea);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Chat.vue?vue&type=script&lang=ts&




































var Chatvue_type_script_lang_ts_Chat = /*#__PURE__*/function (_Vue) {
  _inherits(Chat, _Vue);

  var _super = _createSuper(Chat);

  function Chat() {
    var _this;

    _classCallCheck(this, Chat);

    _this = _super.apply(this, arguments);
    _this.config = getModule(store_ConfigModule, _this.$store);
    _this.fetchSettings = _this.config.fetchSettings;
    _this.textInput = "";
    _this.threadOpen = false;
    _this.loadingChannels = false;
    _this.loginAlert = false;
    _this.scrollingPaused = false;
    _this.scrolled = 0;
    _this.scrolledMax = 0;
    _this.keepAliveInterval = 0;
    _this.observer2 = null;
    _this.emojiPicker = false;
    return _this;
  }

  _createClass(Chat, [{
    key: "styleConfig",
    get: function get() {
      return this.config.styleConfig;
    }
  }, {
    key: "generalSettings",
    get: function get() {
      return this.config.generalSettings;
    }
  }, {
    key: "enabledFeatures",
    get: function get() {
      return this.config.enabledFeatures;
    }
  }, {
    key: "onAuthenticatedChanged",
    value: function onAuthenticatedChanged(authenticated) {
      var _this2 = this;

      console.log("Authenticated: " + authenticated);

      if (authenticated) {
        this.setupTenant();
        Promise.all([this.fetchBroadcast(), this.fetchUser(), this.fetchSettings()]).then(function () {
          _this2.loadingChannels = true;
          return _this2.fetchChannels();
        }).then(function () {
          _this2.loadingChannels = false;

          _this2.fetchBans();

          if (_this2.enabledFeatures.HISTORY) _this2.fetchHistory();
        });
        clearTimeout(this.keepAliveInterval);
        this.setKeepAliveInterval();
      }
    }
  }, {
    key: "setKeepAliveInterval",
    value: function () {
      var _setKeepAliveInterval = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.keepAlive();

              case 3:
                _context.prev = 3;
                // Send keep-alive every 24s (server cuts off at 30)
                // Perhaps this should be a config setting?
                this.keepAliveInterval = setTimeout(this.setKeepAliveInterval, 24000);
                return _context.finish(3);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0,, 3, 6]]);
      }));

      function setKeepAliveInterval() {
        return _setKeepAliveInterval.apply(this, arguments);
      }

      return setKeepAliveInterval;
    }()
  }, {
    key: "onScrollingPaused",
    value: function onScrollingPaused() {
      if (!this.scrollingPaused) this.scrollToBottom();
    }
  }, {
    key: "onChannelChange",
    value: function onChannelChange() {
      var _this3 = this;

      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick().then(function () {
        _this3.threadOpen = false;
        _this3.textInput = "";
        _this3.emojiPicker = false;

        _this3.scrollToBottom(true);
      });
    }
  }, {
    key: "onThreadOpenChanged",
    value: function onThreadOpenChanged(threadOpen) {
      var _this4 = this;

      if (threadOpen) {
        external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick().then(function () {
          if (!_this4.hasNoVoice) {
            var _this4$observer;

            var el = _this4.$refs.scrollThread.$el;
            (_this4$observer = _this4.observer2) === null || _this4$observer === void 0 ? void 0 : _this4$observer.disconnect();
            _this4.observer2 = new MutationObserver(function () {
              el.scrollTo({
                top: el.scrollHeight
              });
            });

            _this4.observer2.observe(el, {
              childList: true
            });
          }
        });
      }
    }
  }, {
    key: "onThreadChange",
    value: function onThreadChange(threadActive) {
      var _this5 = this;

      if (threadActive) this.threadOpen = true;
      this.textInput = "";
      this.emojiPicker = false;
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick().then(function () {
        _this5.$refs.input.focus();
      });
    }
  }, {
    key: "onMessagesFilteredChange",
    value: function onMessagesFilteredChange() {
      var _this6 = this;

      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick().then(function () {
        _this6.scrollToBottom();

        if (_this6.$refs.scrollMain && _this6.$refs.scrollMain.$el.clientHeight >= _this6.$refs.scrollMain.$el.scrollHeight) {
          _this6.scrollingPaused = false;
        }
      });
    }
  }, {
    key: "activated",
    value: function activated() {
      this.scrollToBottom(true);
    }
  }, {
    key: "i18nEmojiPicker",
    get: function get() {
      return this.$i18n.messages[this.$i18n.locale]["emojiPicker"];
    }
  }, {
    key: "messagesFiltered",
    get: function get() {
      var _this7 = this;

      var excludedMessageTypes = [MessageType.POLL];
      return this.enabledFeatures.IGNORE ? this.messagesOrphans.filter(function (m) {
        if (excludedMessageTypes.includes(m.type)) return true;
        return !_this7.user.blockedUsers.some(function (blocked) {
          return m.fromUser.id === blocked.id;
        });
      }) : this.messagesOrphans;
    }
  }, {
    key: "hasNoVoice",
    get: function get() {
      return !this.authenticated || !!this.userBanned;
    }
  }, {
    key: "brandTextColorLight",
    get: function get() {
      var _this$$vuetify$theme$;

      var col = (_this$$vuetify$theme$ = this.$vuetify.theme.currentTheme.brand) === null || _this$$vuetify$theme$ === void 0 ? void 0 : _this$$vuetify$theme$.toString();
      return !col || colors_isDark(hexToRGB(col));
    }
  }, {
    key: "messageErrorVisible",
    get: function get() {
      return this.getMessageErrorVisible;
    },
    set: function set(visible) {
      this.setMessageErrorVisible(visible);
    }
  }, {
    key: "textInputCounterVisible",
    get: function get() {
      if (this.isAdmin || this.isModerator) return false;
      return this.generalSettings ? this.generalSettings.allowedCharactersCount - this.textInput.length <= 3 : false;
    }
  }, {
    key: "activeUsers",
    get: function get() {
      var _this$channelActive$u, _this$channelActive;

      return (_this$channelActive$u = (_this$channelActive = this.channelActive) === null || _this$channelActive === void 0 ? void 0 : _this$channelActive.users) !== null && _this$channelActive$u !== void 0 ? _this$channelActive$u : [];
    }
  }, {
    key: "inputStyle",
    get: function get() {
      return {
        paddingLeft: this.styleConfig.padding.textInput.left + "px",
        paddingRight: this.styleConfig.padding.textInput.right + "px",
        borderRadius: this.styleConfig.borderRadius.textInput + "px"
      };
    }
  }, {
    key: "buttonStyle",
    get: function get() {
      return {
        borderRadius: this.styleConfig.borderRadius.buttons + "px"
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      console.log("Destroying chat...");
      clearTimeout(this.keepAliveInterval);
      this.stopListening();
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e) {
      var scrollOffset = this.$refs.scrollMain.$el.clientHeight - this.$refs.scrollMain.$el.scrollHeight;
      if (scrollOffset >= 0) return;
      var st = e.target.scrollTop;
      this.scrolledMax = Math.max(Math.abs(scrollOffset), 0);
      this.scroll(st);
    }
  }, {
    key: "scroll",
    value: function scroll(st) {
      this.scrolled = st;
      var distance = this.scrollingPaused ? 40 : 120;
      this.scrollingPaused = this.scrolledMax - this.scrolled > distance;
    }
  }, {
    key: "sendMessage",
    value: function sendMessage() {
      var _this8 = this;

      if (!this.userInfoIsValid) {
        this.$emit("control-message", "openProfileEdit");
        return;
      }

      if (this.textInput.trim() === "" || !this.channelActive) return;
      if (!this.isAdmin && !this.isModerator && this.generalSettings && this.textInput.length > this.generalSettings.allowedCharactersCount) return;
      this.sendMessageAction({
        content: this.textInput,
        type: MessageType.TEXT,
        parent: this.threadOpen ? this.threadActive : undefined,
        channel: this.channelActive
      }).catch(function (err) {
        var _err$response;

        // custom rejections with 'allowed values'
        if (err.response && (err.response.status === 400 || ((_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 403)) {
          var pl = err.response.data.payload;

          if (pl !== null && pl !== void 0 && pl.reason) {
            _this8.setMessageError(pl);
          } else {
            _this8.setMessageError({
              reason: "genericError"
            });
          } // this.messageErrorVisible = true;

        }
      });
      if (!this.threadOpen) this.scrollToBottom(true);
      this.textInput = "";
    }
  }, {
    key: "getErrorText",
    get: function get() {
      return this.getMessageError !== "" ? this.getMessageError : this.$t("s8c.oops");
    }
  }, {
    key: "selectEmoji",
    value: function selectEmoji(emoji) {
      var _emoji$native;

      this.textInput += (_emoji$native = emoji.native) !== null && _emoji$native !== void 0 ? _emoji$native : emoji.colons;
    }
  }, {
    key: "include",
    value: function include() {
      var ele = document.querySelectorAll(".reply-button,.mdi-reply,#EmojiPicker");
      var res = [this.$refs.input.$el];
      if (ele) res.push.apply(res, _toConsumableArray(ele));
      return res;
    }
  }, {
    key: "closeThread",
    value: function closeThread() {
      if (!this.emojiPicker) this.threadOpen = false;
    }
  }, {
    key: "handleReply",
    value: function handleReply(message) {
      var _this9 = this;

      if (this.threadActive === message) this.threadOpen = !this.threadOpen;else {
        this.setThreadActive(message);
        this.threadOpen = true;
      }
      this.textInput = "";
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick().then(function () {
        _this9.$refs.input.focus();
      });
    }
  }, {
    key: "closeAlert",
    value: function closeAlert() {
      this.loginAlert = false;
    }
  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.$refs.scrollMain || !force && this.scrollingPaused) return;
      var el = this.$refs.scrollMain.$el;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: smooth ? "smooth" : "auto"
      });
      this.scrollingPaused = false;
      this.scrolledMax = 0;
      this.scrolled = 0;
    }
  }, {
    key: "handleUserListClick",
    value: function handleUserListClick(displayName) {
      this.textInput += "@".concat(displayName, " ");
    }
  }, {
    key: "textMessageRules",
    get: function get() {
      var _this10 = this;

      return {
        maxLength: function maxLength(value) {
          var _this10$generalSettin, _this10$generalSettin2;

          var excluded = _this10.isAdmin || _this10.isModerator;
          if (_this10.generalSettings && !excluded) return value.length <= ((_this10$generalSettin = _this10.generalSettings) === null || _this10$generalSettin === void 0 ? void 0 : _this10$generalSettin.allowedCharactersCount) || _this10.$t("s8c.charLimit", [(_this10$generalSettin2 = _this10.generalSettings) === null || _this10$generalSettin2 === void 0 ? void 0 : _this10$generalSettin2.allowedCharactersCount]).toString();
          return true;
        }
      };
    }
  }, {
    key: "handleHeightChange",
    value: function handleHeightChange() {
      var _this11 = this;

      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick().then(function () {
        _this11.scrollToBottom();
      });
    }
  }]);

  return Chat;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Getter("getMessagesOrphans", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "messagesOrphans", void 0);

__decorate([Getter("getThreadActive", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "threadActive", void 0);

__decorate([Getter("getChannelActive", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "channelActive", void 0);

__decorate([Getter("getIsPinnedMessage", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "isPinnedMessage", void 0);

__decorate([Getter("authenticated", {
  namespace: AUTH_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "authenticated", void 0);

__decorate([Getter("user", {
  namespace: USER_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "user", void 0);

__decorate([Getter("user", {
  namespace: USER_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "isAdmin", void 0);

__decorate([Getter("isModerator", {
  namespace: USER_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "isModerator", void 0);

__decorate([Getter("isFetched", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "isFetched", void 0);

__decorate([Getter("dismissedPinnedMessage", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "dismissed", void 0);

__decorate([Getter("userInfoIsValid", {
  namespace: AUTH_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "userInfoIsValid", void 0);

__decorate([Getter("getBroadcast", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "broadcast", void 0);

__decorate([Getter("messageError", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "getMessageError", void 0);

__decorate([Getter("messageErrorVisible", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "getMessageErrorVisible", void 0);

__decorate([bindings_Action("fetchChannels", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "fetchChannels", void 0);

__decorate([bindings_Action("fetchBroadcast", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "fetchBroadcast", void 0);

__decorate([bindings_Action("fetchHistory", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "fetchHistory", void 0);

__decorate([bindings_Action("fetchBans", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "fetchBans", void 0);

__decorate([bindings_Action("fetch", {
  namespace: USER_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "fetchUser", void 0);

__decorate([bindings_Action("setupTenant", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "setupTenant", void 0);

__decorate([bindings_Action("sendMessage", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "sendMessageAction", void 0);

__decorate([bindings_Action("startListening", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "startListening", void 0);

__decorate([bindings_Action("stopListening", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "stopListening", void 0);

__decorate([bindings_Action("keepAlive", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "keepAlive", void 0);

__decorate([bindings_Action("setMessageError", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "setMessageError", void 0);

__decorate([bindings_Action("setMessageErrorVisible", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "setMessageErrorVisible", void 0);

__decorate([bindings_Mutation("setThreadActive", {
  namespace: store_CHAT_NAMESPACE
})], Chatvue_type_script_lang_ts_Chat.prototype, "setThreadActive", void 0);

__decorate([Watch("authenticated", {
  immediate: true
})], Chatvue_type_script_lang_ts_Chat.prototype, "onAuthenticatedChanged", null);

__decorate([Watch("scrollingPaused")], Chatvue_type_script_lang_ts_Chat.prototype, "onScrollingPaused", null);

__decorate([Watch("channelActive", {
  immediate: true
})], Chatvue_type_script_lang_ts_Chat.prototype, "onChannelChange", null);

__decorate([Watch("threadOpen")], Chatvue_type_script_lang_ts_Chat.prototype, "onThreadOpenChanged", null);

__decorate([Watch("threadActive")], Chatvue_type_script_lang_ts_Chat.prototype, "onThreadChange", null);

__decorate([Watch("messagesFiltered", {
  immediate: true
})], Chatvue_type_script_lang_ts_Chat.prototype, "onMessagesFilteredChange", null);

__decorate([Getter("".concat(store_CHAT_NAMESPACE, "/userBanned"))], Chatvue_type_script_lang_ts_Chat.prototype, "userBanned", void 0);

Chatvue_type_script_lang_ts_Chat = __decorate([vue_class_component_esm({
  components: {
    ChatItem: components_ChatItem,
    ChannelSelect: components_ChannelSelect,
    UserList: UserList_UserList,
    LoyaltyPoints: components_LoyaltyPoints,
    PinnedMessage: Pin_PinnedMessage,
    SettingsMenu: components_SettingsMenu,
    AtTa: vue_at_textarea_default.a,
    ChatEmojiPicker: components_ChatEmojiPicker
  }
})], Chatvue_type_script_lang_ts_Chat);
/* harmony default export */ var Chatvue_type_script_lang_ts_ = (Chatvue_type_script_lang_ts_Chat);
// CONCATENATED MODULE: ./src/components/Chat.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_Chatvue_type_script_lang_ts_ = (Chatvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Chat.vue?vue&type=style&index=0&id=8edea27c&scoped=true&lang=scss&
var Chatvue_type_style_index_0_id_8edea27c_scoped_true_lang_scss_ = __webpack_require__("3150");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VGrid/grid.js







// Types

function grid_VGrid(name) {
  /* @vue/component */
  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: "v-".concat(name),
    functional: true,
    props: {
      id: String,
      tag: {
        type: String,
        default: 'div'
      }
    },
    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;
      data.staticClass = "".concat(name, " ").concat(data.staticClass || '').trim();
      var attrs = data.attrs;

      if (attrs) {
        // reset attrs to extract utility clases like pa-3
        data.attrs = {};
        var classes = Object.keys(attrs).filter(function (key) {
          // TODO: Remove once resolved
          // https://github.com/vuejs/vue/issues/7841
          if (key === 'slot') return false;
          var value = attrs[key]; // add back data attributes like data-test="foo" but do not
          // add them as classes

          if (key.startsWith('data-')) {
            data.attrs[key] = value;
            return false;
          }

          return value || typeof value === 'string';
        });
        if (classes.length) data.staticClass += " ".concat(classes.join(' '));
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h(props.tag, data, children);
    }
  });
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VGrid/VContainer.js









/* @vue/component */

/* harmony default export */ var VContainer = (grid_VGrid('container').extend({
  name: 'v-container',
  functional: true,
  props: {
    id: String,
    tag: {
      type: String,
      default: 'div'
    },
    fluid: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var classes;
    var attrs = data.attrs;

    if (attrs) {
      // reset attrs to extract utility clases like pa-3
      data.attrs = {};
      classes = Object.keys(attrs).filter(function (key) {
        // TODO: Remove once resolved
        // https://github.com/vuejs/vue/issues/7841
        if (key === 'slot') return false;
        var value = attrs[key]; // add back data attributes like data-test="foo" but do not
        // add them as classes

        if (key.startsWith('data-')) {
          data.attrs[key] = value;
          return false;
        }

        return value || typeof value === 'string';
      });
    }

    if (props.id) {
      data.domProps = data.domProps || {};
      data.domProps.id = props.id;
    }

    return h(props.tag, mergeData(data, {
      staticClass: 'container',
      class: Array({
        'container--fluid': props.fluid
      }).concat(classes || [])
    }), children);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VFooter/VFooter.sass
var VFooter = __webpack_require__("b5b6");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/applicationable/index.js
 // Util


function applicationable(value) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  /* @vue/component */
  return mixins_mixins(positionable_factory(['absolute', 'fixed'])).extend({
    name: 'applicationable',
    props: {
      app: Boolean
    },
    computed: {
      applicationProperty: function applicationProperty() {
        return value;
      }
    },
    watch: {
      // If previous value was app
      // reset the provided prop
      app: function app(x, prev) {
        prev ? this.removeApplication(true) : this.callUpdate();
      },
      applicationProperty: function applicationProperty(newVal, oldVal) {
        this.$vuetify.application.unregister(this._uid, oldVal);
      }
    },
    activated: function activated() {
      this.callUpdate();
    },
    created: function created() {
      for (var i = 0, length = events.length; i < length; i++) {
        this.$watch(events[i], this.callUpdate);
      }

      this.callUpdate();
    },
    mounted: function mounted() {
      this.callUpdate();
    },
    deactivated: function deactivated() {
      this.removeApplication();
    },
    destroyed: function destroyed() {
      this.removeApplication();
    },
    methods: {
      callUpdate: function callUpdate() {
        if (!this.app) return;
        this.$vuetify.application.register(this._uid, this.applicationProperty, this.updateApplication());
      },
      removeApplication: function removeApplication() {
        var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!force && !this.app) return;
        this.$vuetify.application.unregister(this._uid, this.applicationProperty);
      },
      updateApplication: function updateApplication() {
        return 0;
      }
    }
  });
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VFooter/VFooter.js



// Styles
 // Components

 // Mixins


 // Utilities



/* @vue/component */

/* harmony default export */ var VFooter_VFooter = (mixins_mixins(VSheet_VSheet, applicationable('footer', ['height', 'inset']), ssr_bootable).extend({
  name: 'v-footer',
  props: {
    height: {
      default: 'auto',
      type: [Number, String]
    },
    inset: Boolean,
    padless: Boolean,
    tag: {
      type: String,
      default: 'footer'
    }
  },
  computed: {
    applicationProperty: function applicationProperty() {
      return this.inset ? 'insetFooter' : 'footer';
    },
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, VSheet_VSheet.options.computed.classes.call(this)), {}, {
        'v-footer--absolute': this.absolute,
        'v-footer--fixed': !this.absolute && (this.app || this.fixed),
        'v-footer--padless': this.padless,
        'v-footer--inset': this.inset
      });
    },
    computedBottom: function computedBottom() {
      if (!this.isPositioned) return undefined;
      return this.app ? this.$vuetify.application.bottom : 0;
    },
    computedLeft: function computedLeft() {
      if (!this.isPositioned) return undefined;
      return this.app && this.inset ? this.$vuetify.application.left : 0;
    },
    computedRight: function computedRight() {
      if (!this.isPositioned) return undefined;
      return this.app && this.inset ? this.$vuetify.application.right : 0;
    },
    isPositioned: function isPositioned() {
      return Boolean(this.absolute || this.fixed || this.app);
    },
    styles: function styles() {
      var height = parseInt(this.height);
      return _objectSpread2(_objectSpread2({}, VSheet_VSheet.options.computed.styles.call(this)), {}, {
        height: isNaN(height) ? height : convertToUnit(height),
        left: convertToUnit(this.computedLeft),
        right: convertToUnit(this.computedRight),
        bottom: convertToUnit(this.computedBottom)
      });
    }
  },
  methods: {
    updateApplication: function updateApplication() {
      var height = parseInt(this.height);
      return isNaN(height) ? this.$el ? this.$el.clientHeight : 0 : height;
    }
  },
  render: function render(h) {
    var data = this.setBackgroundColor(this.color, {
      staticClass: 'v-footer',
      class: this.classes,
      style: this.styles
    });
    return h(this.tag, data, this.$slots.default);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSubheader/VSubheader.sass
var VSubheader = __webpack_require__("0bc6");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSubheader/VSubheader.js

// Styles
 // Mixins



/* harmony default export */ var VSubheader_VSubheader = (mixins_mixins(themeable
/* @vue/component */
).extend({
  name: 'v-subheader',
  props: {
    inset: Boolean
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-subheader',
      class: _objectSpread2({
        'v-subheader--inset': this.inset
      }, this.themeClasses),
      attrs: this.$attrs,
      on: this.$listeners
    }, this.$slots.default);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VTextarea/VTextarea.sass
var VTextarea = __webpack_require__("1681");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTextarea/VTextarea.js


// Styles
 // Extensions

 // Utilities


var VTextarea_baseMixins = mixins_mixins(VTextField_VTextField);
/* @vue/component */

/* harmony default export */ var VTextarea_VTextarea = (VTextarea_baseMixins.extend({
  name: 'v-textarea',
  props: {
    autoGrow: Boolean,
    noResize: Boolean,
    rowHeight: {
      type: [Number, String],
      default: 24,
      validator: function validator(v) {
        return !isNaN(parseFloat(v));
      }
    },
    rows: {
      type: [Number, String],
      default: 5,
      validator: function validator(v) {
        return !isNaN(parseInt(v, 10));
      }
    }
  },
  computed: {
    classes: function classes() {
      return _objectSpread2({
        'v-textarea': true,
        'v-textarea--auto-grow': this.autoGrow,
        'v-textarea--no-resize': this.noResizeHandle
      }, VTextField_VTextField.options.computed.classes.call(this));
    },
    noResizeHandle: function noResizeHandle() {
      return this.noResize || this.autoGrow;
    }
  },
  watch: {
    autoGrow: function autoGrow(val) {
      var _this = this;

      this.$nextTick(function () {
        var _this$$refs$input;

        val ? _this.calculateInputHeight() : (_this$$refs$input = _this.$refs.input) == null ? void 0 : _this$$refs$input.style.removeProperty('height');
      });
    },
    lazyValue: function lazyValue() {
      this.autoGrow && this.$nextTick(this.calculateInputHeight);
    },
    rowHeight: function rowHeight() {
      this.autoGrow && this.$nextTick(this.calculateInputHeight);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.autoGrow && _this2.calculateInputHeight();
    }, 0);
  },
  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var input = this.$refs.input;
      if (!input) return;
      input.style.height = '0';
      var height = input.scrollHeight;
      var minHeight = parseInt(this.rows, 10) * parseFloat(this.rowHeight); // This has to be done ASAP, waiting for Vue
      // to update the DOM causes ugly layout jumping

      input.style.height = Math.max(minHeight, height) + 'px';
    },
    genInput: function genInput() {
      var input = VTextField_VTextField.options.methods.genInput.call(this);
      input.tag = 'textarea';
      delete input.data.attrs.type;
      input.data.attrs.rows = this.rows;
      return input;
    },
    onInput: function onInput(e) {
      VTextField_VTextField.options.methods.onInput.call(this, e);
      this.autoGrow && this.calculateInputHeight();
    },
    onKeyDown: function onKeyDown(e) {
      // Prevents closing of a
      // dialog when pressing
      // enter
      if (this.isFocused && e.keyCode === 13) {
        e.stopPropagation();
      }

      this.$emit('keydown', e);
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installDirectives.js
var installDirectives = __webpack_require__("269a");
var installDirectives_default = /*#__PURE__*/__webpack_require__.n(installDirectives);

// CONCATENATED MODULE: ./node_modules/vuetify/lib/directives/scroll/index.js


function scroll_inserted(el, binding, vnode) {
  var _ref = binding.modifiers || {},
      _ref$self = _ref.self,
      self = _ref$self === void 0 ? false : _ref$self;

  var value = binding.value;
  var options = _typeof(value) === 'object' && value.options || {
    passive: true
  };
  var handler = typeof value === 'function' || 'handleEvent' in value ? value : value.handler;
  var target = self ? el : binding.arg ? document.querySelector(binding.arg) : window;
  if (!target) return;
  target.addEventListener('scroll', handler, options);
  el._onScroll = Object(el._onScroll);
  el._onScroll[vnode.context._uid] = {
    handler: handler,
    options: options,
    // Don't reference self
    target: self ? undefined : target
  };
}

function scroll_unbind(el, binding, vnode) {
  var _el$_onScroll;

  if (!((_el$_onScroll = el._onScroll) != null && _el$_onScroll[vnode.context._uid])) return;
  var _el$_onScroll$vnode$c = el._onScroll[vnode.context._uid],
      handler = _el$_onScroll$vnode$c.handler,
      options = _el$_onScroll$vnode$c.options,
      _el$_onScroll$vnode$c2 = _el$_onScroll$vnode$c.target,
      target = _el$_onScroll$vnode$c2 === void 0 ? el : _el$_onScroll$vnode$c2;
  target.removeEventListener('scroll', handler, options);
  delete el._onScroll[vnode.context._uid];
}

var Scroll = {
  inserted: scroll_inserted,
  unbind: scroll_unbind
};
/* harmony default export */ var directives_scroll = (Scroll);
// CONCATENATED MODULE: ./src/components/Chat.vue






/* normalize component */

var Chat_component = normalizeComponent(
  components_Chatvue_type_script_lang_ts_,
  Chatvue_type_template_id_8edea27c_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "8edea27c",
  null
  
)

/* harmony default export */ var components_Chat = (Chat_component.exports);

/* vuetify-loader */
















installComponents_default()(Chat_component, {VBtn: VBtn_VBtn,VCard: VCard_VCard,VCol: VCol,VContainer: VContainer,VFooter: VFooter_VFooter,VIcon: components_VIcon_VIcon,VList: VList_VList,VMenu: VMenu_VMenu,VRow: VRow,VScaleTransition: VScaleTransition,VSheet: VSheet_VSheet,VSnackbar: VSnackbar_VSnackbar,VSpacer: VSpacer,VSubheader: VSubheader_VSubheader,VTextarea: VTextarea_VTextarea})


/* vuetify-loader */



installDirectives_default()(Chat_component, {ClickOutside: click_outside,Scroll: directives_scroll})

// CONCATENATED MODULE: ./src/components/index.ts

// CONCATENATED MODULE: ./src/lib.ts














var handlePollEvents = false;

var lib_Spect8ChatUiPlugin = /*#__PURE__*/function () {
  function Spect8ChatUiPlugin() {
    _classCallCheck(this, Spect8ChatUiPlugin);
  }

  _createClass(Spect8ChatUiPlugin, [{
    key: "install",
    value: function install(Vue, options) {
      if (!options || !options.store) {
        throw new Error("Please initialise plugin with a Vuex store.");
      }

      options.store.registerModule(CONFIG_NAMESPACE, store_ConfigModule);
      options.store.registerModule(AUTH_NAMESPACE, store_auth);
      options.store.registerModule(store_CHAT_NAMESPACE, chat);
      options.store.registerModule(USER_NAMESPACE, store_user);

      if (!options.store.hasModule(POLL_NAMESPACE)) {
        handlePollEvents = true;
        initPollsService(options.store);
        options.store.registerModule(POLL_NAMESPACE, store_poll);
      }

      if (!options || !options.apiService) {
        throw new Error("Please initialise plugin with an ApiService.");
      }

      setApiService(options.apiService);
      vue_i18n_plugin_initI18n(options.i18n);
      Vue.prototype.$spect8ChatUi = this.initSpect8ChatUiInstance(options);
      Vue.component("Spect8Chat", components_Chat);
    }
  }, {
    key: "initSpect8ChatUiInstance",
    value: function initSpect8ChatUiInstance(options) {
      var s8chat = {
        setAuth: function setAuth(auth) {
          options.store.commit(AUTH_NAMESPACE + "/setAuthentication", auth);
        },
        setConfig: function setConfig(config) {
          getModule(store_ConfigModule, options.store).setConfig(config); // configModule.setConfig(config);
        }
      };
      return s8chat;
    }
  }]);

  return Spect8ChatUiPlugin;
}();

/* harmony default export */ var lib = (new lib_Spect8ChatUiPlugin());

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (lib);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var un$Slice = __webpack_require__("f36a");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fce3":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "fd7e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
            '_'
        ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "ff22":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ff44":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ffff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
            '_'
        ),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
            '_'
        ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ })

/******/ });
});
//# sourceMappingURL=spect8-chat-ui.umd.js.map